(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"), require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM", "jQuery"], factory);
	else if(typeof exports === 'object')
		exports["antd"] = factory(require("React"), require("ReactDOM"), require("jQuery"));
	else
		root["antd"] = factory(root["React"], root["ReactDOM"], root["jQuery"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_811__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpantd"];
/******/ 	window["webpackJsonpantd"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		9: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = (window[__webpack_require__.v] || "") + __webpack_require__.p + "antd/" + ({}[chunkId]||chunkId) + ".chunk.js?v=" + {"0":"691e1188","1":"2659b9aa","2":"c40f5c5b","3":"f8577f5b","4":"6a781910","5":"03fe171f","6":"989b0972","7":"116af158","8":"0955b3c9"}[chunkId] + "";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/cloudstore/resource/pc/com/v1/";
/******/
/******/ 	// __webpack_content_path__
/******/ 	__webpack_require__.v = "ecologyContentPath";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 281);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(115);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(23);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(363);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(175);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(23);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(359), __esModule: true };

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(177);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(177);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _assign=__webpack_require__(115);var _assign2=_interopRequireDefault(_assign);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _promise=__webpack_require__(48);var _promise2=_interopRequireDefault(_promise);var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);var _typeof2=__webpack_require__(23);var _typeof3=_interopRequireDefault(_typeof2);var _class2,_temp2;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var React=__webpack_require__(0);var PropTypes=__webpack_require__(15);var ALL_INITIALIZERS=[];var READY_INITIALIZERS=[];function isWebpackReady(getModuleIds){if(( false?"undefined":(0,_typeof3.default)(__webpack_require__.m))!=="object"){return false;}return getModuleIds().every(function(moduleId){return typeof moduleId!=="undefined"&&typeof __webpack_require__.m[moduleId]!=="undefined";});}function load(loader){var promise=loader();var state={loading:true,loaded:null,error:null};state.promise=promise.then(function(loaded){state.loading=false;state.loaded=loaded;return loaded;}).catch(function(err){state.loading=false;state.error=err;throw err;});return state;}function loadMap(obj){var state={loading:false,loaded:{},error:null};var promises=[];try{(0,_keys2.default)(obj).forEach(function(key){var result=load(obj[key]);if(!result.loading){state.loaded[key]=result.loaded;state.error=result.error;}else{state.loading=true;}promises.push(result.promise);result.promise.then(function(res){state.loaded[key]=res;}).catch(function(err){state.error=err;});});}catch(err){state.error=err;}state.promise=_promise2.default.all(promises).then(function(res){state.loading=false;return res;}).catch(function(err){state.loading=false;throw err;});return state;}function resolve(obj){return obj&&obj.__esModule?obj.default:obj;}function render(loaded,props,ref){return React.createElement(resolve(loaded),(0,_extends3.default)({},props,{ref:ref}));}function createLoadableComponent(loadFn,options){var _class,_temp;if(!options.loading){throw new Error("react-loadable requires a `loading` component");}var opts=(0,_assign2.default)({loader:null,loading:null,delay:200,timeout:null,render:render,webpack:null,modules:null},options);var res=null;function init(){if(!res){res=loadFn(opts.loader);}return res.promise;}ALL_INITIALIZERS.push(init);if(typeof opts.webpack==="function"){READY_INITIALIZERS.push(function(){if(isWebpackReady(opts.webpack)){return init();}});}var LoadableComponent=(_temp=_class=function(_React$Component){(0,_inherits3.default)(LoadableComponent,_React$Component);function LoadableComponent(props){(0,_classCallCheck3.default)(this,LoadableComponent);var _this=(0,_possibleConstructorReturn3.default)(this,(LoadableComponent.__proto__||(0,_getPrototypeOf2.default)(LoadableComponent)).call(this,props));_this.retry=function(){_this.setState({error:null,loading:true,timedOut:false});res=loadFn(opts.loader);_this._loadModule();};init();_this.state={error:res.error,pastDelay:false,timedOut:false,loading:res.loading,loaded:res.loaded};return _this;}(0,_createClass3.default)(LoadableComponent,[{key:"componentWillMount",value:function componentWillMount(){this._mounted=true;this._loadModule();}},{key:"_loadModule",value:function _loadModule(){var _this2=this;if(this.context.loadable&&Array.isArray(opts.modules)){opts.modules.forEach(function(moduleName){_this2.context.loadable.report(moduleName);});}if(!res.loading){return;}if(typeof opts.delay==="number"){if(opts.delay===0){this.setState({pastDelay:true});}else{this._delay=setTimeout(function(){_this2.setState({pastDelay:true});},opts.delay);}}if(typeof opts.timeout==="number"){this._timeout=setTimeout(function(){_this2.setState({timedOut:true});},opts.timeout);}var update=function update(){if(!_this2._mounted){return;}_this2.setState({error:res.error,loaded:res.loaded,loading:res.loading});_this2._clearTimeouts();};res.promise.then(function(){update();}).catch(function(err){update();});}},{key:"componentWillUnmount",value:function componentWillUnmount(){this._mounted=false;this._clearTimeouts();}},{key:"_clearTimeouts",value:function _clearTimeouts(){clearTimeout(this._delay);clearTimeout(this._timeout);}},{key:"render",value:function render(){var forwardRef=this.props.forwardRef;if(this.state.loading||this.state.error){return React.createElement(opts.loading,{isLoading:this.state.loading,pastDelay:this.state.pastDelay,timedOut:this.state.timedOut,error:this.state.error,retry:this.retry,ref:forwardRef,props:this.props});}else if(this.state.loaded){return opts.render(this.state.loaded,this.props,forwardRef);}else{return null;}}}],[{key:"preload",value:function preload(){return init();}}]);return LoadableComponent;}(React.Component),_class.contextTypes={loadable:PropTypes.shape({report:PropTypes.func.isRequired})},_temp);return React.forwardRef(function(props,ref){return React.createElement(LoadableComponent,(0,_extends3.default)({},props,{forwardRef:ref}));});}function Loadable(opts){return createLoadableComponent(load,opts);}function LoadableMap(opts){if(typeof opts.render!=="function"){throw new Error("LoadableMap requires a `render(loaded, props)` function");}return createLoadableComponent(loadMap,opts);}Loadable.Map=LoadableMap;var Capture=(_temp2=_class2=function(_React$Component2){(0,_inherits3.default)(Capture,_React$Component2);function Capture(){(0,_classCallCheck3.default)(this,Capture);return(0,_possibleConstructorReturn3.default)(this,(Capture.__proto__||(0,_getPrototypeOf2.default)(Capture)).apply(this,arguments));}(0,_createClass3.default)(Capture,[{key:"getChildContext",value:function getChildContext(){return{loadable:{report:this.props.report}};}},{key:"render",value:function render(){return React.Children.only(this.props.children);}}]);return Capture;}(React.Component),_class2.propTypes={report:PropTypes.func.isRequired},_class2.childContextTypes={loadable:PropTypes.shape({report:PropTypes.func.isRequired}).isRequired},_temp2);Loadable.Capture=Capture;function flushInitializers(initializers){var promises=[];while(initializers.length){var init=initializers.pop();promises.push(init());}return _promise2.default.all(promises).then(function(){if(initializers.length){return flushInitializers(initializers);}});}Loadable.preloadAll=function(){return new _promise2.default(function(resolve,reject){flushInitializers(ALL_INITIALIZERS).then(resolve,reject);});};Loadable.preloadReady=function(){return new _promise2.default(function(resolve,reject){// We always will resolve, errors should be handled within loading UIs.
flushInitializers(READY_INITIALIZERS).then(resolve,resolve);});};module.exports=Loadable;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.convertFieldsError = convertFieldsError;
exports.format = format;
exports.isEmptyValue = isEmptyValue;
exports.isEmptyObject = isEmptyObject;
exports.asyncMap = asyncMap;
exports.complementError = complementError;
exports.deepMerge = deepMerge;
/* eslint no-console:0 */

var formatRegExp = /%[sdj%]/g;

var warning = exports.warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  exports.warning = warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject({ errors: results, fields: convertFieldsError(results) }) : resolve();
      }
    };
    objArrKeys.forEach(function (key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending['catch'](function (e) {
    return e;
  });
  return pending;
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: typeof oe === 'function' ? oe() : oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && _typeof(target[s]) === 'object') {
          target[s] = _extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(376)();
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(props){var type=props.type,_props$className=props.className,className=_props$className===undefined?"":_props$className,other=(0,_objectWithoutProperties3.default)(props,["type","className"]);className+=" anticon anticon-"+type;return _react2.default.createElement("i",(0,_extends3.default)({className:className.trim()},other,{ecId:other.ecId+"_i@0hqgzv"}));};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(179);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _required = __webpack_require__(214);

var _required2 = _interopRequireDefault(_required);

var _whitespace = __webpack_require__(581);

var _whitespace2 = _interopRequireDefault(_whitespace);

var _type = __webpack_require__(582);

var _type2 = _interopRequireDefault(_type);

var _range = __webpack_require__(583);

var _range2 = _interopRequireDefault(_range);

var _enum = __webpack_require__(584);

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__(585);

var _pattern2 = _interopRequireDefault(_pattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  required: _required2['default'],
  whitespace: _whitespace2['default'],
  type: _type2['default'],
  range: _range2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default']
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(334), __esModule: true };

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(308);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(310);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(108)('wks');
var uid = __webpack_require__(74);
var Symbol = __webpack_require__(20).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var core = __webpack_require__(14);
var ctx = __webpack_require__(49);
var hide = __webpack_require__(40);
var has = __webpack_require__(41);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);exports.default=middleware;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function isObject(obj){return Object.prototype.toString.call(obj)==="[object Object]";}function isFunction(fn){return typeof fn==="function";}function getModule(obj){return obj&&obj.__esModule?obj.default||obj:obj;}function isReactComponent(com,name,saName){if(com&&com.prototype&&(com.prototype instanceof _react2.default.Component||com.prototype.isReactComponent)&&// isFunction(com.prototype.render) &&
// name !== "Radio" &&
// saName !== "Radio.Button" &&
// saName !== "Tree.TreeNode" &&
// saName !== "Menu.ItemGroup" &&
saName!=="Select.Option"&&saName!=="Select.OptGroup"&&saName!=="SelectNew.Option"&&saName!=="SelectNew.OptGroup"&&// .type === class强比较，搞事情的代码暂时先不加
name!=="WeaDebugRouteMenu"// route 会判定多个子节点...
){return true;}else if(name==="Col"||name==="Icon"||name==="Card"){// no isReactComponent Col Icon Card
return true;}return false;}function middleware(obj,name,saName){var com=getModule(obj);var result=com;if(isObject(window.pcComponentsConfig)){var overwrite=window.pcComponentsConfig[name];if(isObject(overwrite)){if(isReactComponent(com,name)){result=_react2.default.forwardRef(function(props,ref){if(props._noOverwrite){return _react2.default.createElement(com,(0,_extends3.default)({},props,{ref:ref}));}var newProps=(0,_extends3.default)({},props);var overwriteInRender=window.pcComponentsConfig[name];if(isObject(overwriteInRender)){// overwrite render lev 1
var renderFn=overwriteInRender.overwriteRenderFn;if(isFunction(renderFn)){var overwriteRender=renderFn(newProps,saName||name);if(overwriteRender!==false){return overwriteRender;}}// overwrite props lev 2
var propsJson=overwriteInRender.overwritePropsJson;if(isObject(propsJson)){newProps=(0,_extends3.default)({},newProps,propsJson);}var propsFn=overwriteInRender.overwritePropsFn;if(isFunction(propsFn)){var overwriteProps=propsFn(newProps,saName||name);if(isObject(overwriteProps)){newProps=(0,_extends3.default)({},newProps,overwriteProps);}}// overwrite class lev 3
var classFn=overwriteInRender.overwriteClassFn;if(isFunction(classFn)){var overwriteClass=classFn(com,newProps,saName||name);if(overwriteClass.com&&isObject(overwriteClass.props)){return _react2.default.createElement(overwriteClass.com,(0,_extends3.default)({},overwriteClass.props,{ref:ref}));}}}return _react2.default.createElement(com,(0,_extends3.default)({},newProps,{ref:ref}));});}(0,_keys2.default)(com).forEach(function(key){var staticAttribute=getModule(com[key]);var staticAttributeName=name+"."+key;if(isReactComponent(staticAttribute,key,staticAttributeName)){result[key]=middleware(staticAttribute,key,staticAttributeName);}else{result[key]=staticAttribute;}});}}return result;}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(172);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(34);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(30);
var IE8_DOM_DEFINE = __webpack_require__(155);
var toPrimitive = __webpack_require__(104);
var dP = Object.defineProperty;

exports.f = __webpack_require__(32) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(50)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WindowFunc=function(){function WindowFunc(){(0,_classCallCheck3.default)(this,WindowFunc);}(0,_createClass3.default)(WindowFunc,[{key:"getTop",value:function getTop(){var current=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;try{var topWindow=window.top;topWindow.canSet="canSet";if(!topWindow.ecCom){return self;}return topWindow;}catch(error){if(current===null){current=self;}if(current.setTopWindow){return current.setTopWindow;}else{try{var parentWindow=current.parent;parentWindow.canSet="canSet";return this.getTop(parentWindow);}catch(error){current.setTopWindow=current;return current;}}}}},{key:"getParent",value:function getParent(){try{var parent=window.parent;if(!parent.ecCom){return self;}return parent;}catch(error){return self;}}}]);return WindowFunc;}();exports.default=new WindowFunc();

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.createPath=exports.parsePath=exports.getQueryStringValueFromPath=exports.stripQueryStringValueFromPath=exports.addQueryStringValueToPath=undefined;var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var addQueryStringValueToPath=exports.addQueryStringValueToPath=function addQueryStringValueToPath(path,key,value){var _parsePath=parsePath(path),pathname=_parsePath.pathname,search=_parsePath.search,hash=_parsePath.hash;return createPath({pathname:pathname,search:search+(search.indexOf('?')===-1?'?':'&')+key+'='+value,hash:hash});};var stripQueryStringValueFromPath=exports.stripQueryStringValueFromPath=function stripQueryStringValueFromPath(path,key){var _parsePath2=parsePath(path),pathname=_parsePath2.pathname,search=_parsePath2.search,hash=_parsePath2.hash;return createPath({pathname:pathname,search:search.replace(new RegExp('([?&])'+key+'=[a-zA-Z0-9]+(&?)'),function(match,prefix,suffix){return prefix==='?'?prefix:suffix;}),hash:hash});};var getQueryStringValueFromPath=exports.getQueryStringValueFromPath=function getQueryStringValueFromPath(path,key){var _parsePath3=parsePath(path),search=_parsePath3.search;var match=search.match(new RegExp('[?&]'+key+'=([a-zA-Z0-9]+)'));return match&&match[1];};var extractPath=function extractPath(string){var match=string.match(/^(https?:)?\/\/[^\/]*/);return match==null?string:string.substring(match[0].length);};var parsePath=exports.parsePath=function parsePath(path){var pathname=extractPath(path);var search='';var hash='';(0,_warning2.default)(path===pathname,'A path must be pathname + search + hash only, not a full URL like "%s"',path);var hashIndex=pathname.indexOf('#');if(hashIndex!==-1){hash=pathname.substring(hashIndex);pathname=pathname.substring(0,hashIndex);}var searchIndex=pathname.indexOf('?');if(searchIndex!==-1){search=pathname.substring(searchIndex);pathname=pathname.substring(0,searchIndex);}if(pathname==='')pathname='/';return{pathname:pathname,search:search,hash:hash};};var createPath=exports.createPath=function createPath(location){if(location==null||typeof location==='string')return location;var basename=location.basename,pathname=location.pathname,search=location.search,hash=location.hash;var path=(basename||'')+pathname;if(search&&search!=='?')path+=search;if(hash)path+=hash;return path;};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(511);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = {
  shouldComponentUpdate: function(nextProps, nextState) {
    return (
      !shallowEqual(this.props, nextProps) ||
      !shallowEqual(this.state, nextState)
    );
  }
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.formatDate=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);exports.getTodayTime=getTodayTime;exports.getTitleString=getTitleString;exports.getTodayTimeStr=getTodayTimeStr;exports.getFormatter=getFormatter;exports.syncTime=syncTime;exports.getTimeConfig=getTimeConfig;exports.isTimeValidByConfig=isTimeValidByConfig;exports.isTimeValid=isTimeValid;exports.isAllowedDate=isAllowedDate;exports.formatOfZero=formatOfZero;var _gregorianCalendarFormat=__webpack_require__(141);var _gregorianCalendarFormat2=_interopRequireDefault(_gregorianCalendarFormat);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var defaultDisabledTime={disabledHours:function disabledHours(){return[];},disabledMinutes:function disabledMinutes(){return[];},disabledSeconds:function disabledSeconds(){return[];}};function getTodayTime(value){var today=value.clone();today.setTime(Date.now());return today;}function getTitleString(value){return value.getYear()+"-"+(value.getMonth()+1)+"-"+value.getDayOfMonth();}function getTodayTimeStr(value){var today=getTodayTime(value);return getTitleString(today);}function getFormatter(format,locale){if(typeof format==="string"){return new _gregorianCalendarFormat2.default(format,locale.format);}return format;}function syncTime(from,to){to.setHourOfDay(from.getHourOfDay());to.setMinutes(from.getMinutes());to.setSeconds(from.getSeconds());}function getTimeConfig(value,disabledTime){var disabledTimeConfig=disabledTime?disabledTime(value):{};disabledTimeConfig=(0,_extends3.default)({},defaultDisabledTime,disabledTimeConfig);return disabledTimeConfig;}function isTimeValidByConfig(value,disabledTimeConfig){var invalidTime=false;if(value){var hour=value.getHourOfDay();var minutes=value.getMinutes();var seconds=value.getSeconds();var disabledHours=disabledTimeConfig.disabledHours();if(disabledHours.indexOf(hour)===-1){var disabledMinutes=disabledTimeConfig.disabledMinutes(hour);if(disabledMinutes.indexOf(minutes)===-1){var disabledSeconds=disabledTimeConfig.disabledSeconds(hour,minutes);invalidTime=disabledSeconds.indexOf(seconds)!==-1;}else{invalidTime=true;}}else{invalidTime=true;}}return!invalidTime;}function isTimeValid(value,disabledTime){var disabledTimeConfig=getTimeConfig(value,disabledTime);return isTimeValidByConfig(value,disabledTimeConfig);}function isAllowedDate(value,disabledDate,disabledTime){if(disabledDate){if(disabledDate(value)){return false;}}if(disabledTime){if(!isTimeValid(value,disabledTime)){return false;}}return true;}function formatOfZero(value){var formatWithZero=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;if(!formatWithZero&&value&&typeof value==="string"&&value.indexOf("-")>-1){// feat: 增是否显示数字前0处理
// 去掉日期前的0
var arr=value.split("-");var newArr=[];if(arr&&arr.length>0){arr.map(function(i){newArr.push(i.replace(/^0/,""));});}var str=newArr.join("-");return str;}return value;}//日期格式转化
var formatDate=exports.formatDate=function formatDate(date,fmt){var formatWithZero=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;fmt=fmt||"yyyy-MM-dd HH:mm:ss";var hour=date.getHours();var noonStr="AM";if(hour>12){hour-=12;noonStr="PM";}var obj={Y:date.getFullYear(),// 年份，注意必须用getFullYear
y:date.getFullYear(),// 年份，注意必须用getFullYear
M:date.getMonth()+1,// 月份，注意是从0-11
d:date.getDate(),// 日期
q:Math.floor((date.getMonth()+3)/3),// 季度
w:date.getDay(),// 星期，注意是0-6
H:date.getHours(),// 24小时制
h:hour,// 12小时制
m:date.getMinutes(),// 分钟
s:date.getSeconds(),// 秒
S:date.getMilliseconds(),// 毫秒
a:noonStr};var week=["天","一","二","三","四","五","六"];for(var i in obj){fmt=fmt.replace(new RegExp(i+"+","g"),function(m){var val=obj[i]+"";if(i=="a")return val;if(i=="w")return(m.length>2?"星期":"周")+week[val];for(var j=0,len=val.length;j<m.length-len;j++){// val = "0" + val;
// 增加format是否带0的处理，默认带0 (年 月 日)
if(!((i=="Y"||i=="y"||i=="M"||i=="d")&&!formatWithZero)){val="0"+val;}}return m.length==1?val:val.substring(val.length-m.length);});}return fmt;};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(31);
var createDesc = __webpack_require__(59);
module.exports = __webpack_require__(32) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(78),
    getRawTag = __webpack_require__(321),
    objectToString = __webpack_require__(322);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.locationsAreEqual=exports.statesAreEqual=exports.createLocation=exports.createQuery=undefined;var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);var _typeof2=__webpack_require__(23);var _typeof3=_interopRequireDefault(_typeof2);var _create=__webpack_require__(175);var _create2=_interopRequireDefault(_create);var _assign=__webpack_require__(115);var _assign2=_interopRequireDefault(_assign);var _invariant=__webpack_require__(62);var _invariant2=_interopRequireDefault(_invariant);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);var _PathUtils=__webpack_require__(36);var _Actions=__webpack_require__(80);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var createQuery=exports.createQuery=function createQuery(props){return(0,_assign2.default)((0,_create2.default)(null),props);};var createLocation=exports.createLocation=function createLocation(){var input=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'/';var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:_Actions.POP;var key=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var object=typeof input==='string'?(0,_PathUtils.parsePath)(input):input.pathname&&input.pathname.indexOf('=')>0?(0,_PathUtils.parsePath)(input.pathname):input;(0,_warning2.default)(!object.path,'Location descriptor objects should have a `pathname`, not a `path`.');var pathname=object.pathname||'/';var search=object.search||'';var hash=object.hash||'';var state=object.state;return{pathname:pathname,search:search,hash:hash,state:state,action:action,key:key};};var isDate=function isDate(object){return Object.prototype.toString.call(object)==='[object Date]';};var statesAreEqual=exports.statesAreEqual=function statesAreEqual(a,b){if(a===b)return true;var typeofA=typeof a==='undefined'?'undefined':(0,_typeof3.default)(a);var typeofB=typeof b==='undefined'?'undefined':(0,_typeof3.default)(b);if(typeofA!==typeofB)return false;(0,_invariant2.default)(typeofA!=='function','You must not store functions in location state');// Not the same object, but same type.
if(typeofA==='object'){(0,_invariant2.default)(!(isDate(a)&&isDate(b)),'You must not store Date objects in location state');if(!Array.isArray(a)){var keysofA=(0,_keys2.default)(a);var keysofB=(0,_keys2.default)(b);return keysofA.length===keysofB.length&&keysofA.every(function(key){return statesAreEqual(a[key],b[key]);});}return Array.isArray(b)&&a.length===b.length&&a.every(function(item,index){return statesAreEqual(item,b[index]);});}// All other serializable types (string, number, boolean)
// should be strict equal.
return false;};var locationsAreEqual=exports.locationsAreEqual=function locationsAreEqual(a,b){return a.key===b.key&&// a.action === b.action && // Different action !== location change.
a.pathname===b.pathname&&a.search===b.search&&a.hash===b.hash&&statesAreEqual(a.state,b.state);};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * object.omit <https://github.com/jonschlinkert/object.omit>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */



var isObject = __webpack_require__(385);
var forOwn = __webpack_require__(386);

module.exports = function omit(obj, keys) {
  if (!isObject(obj)) return {};

  keys = [].concat.apply([], [].slice.call(arguments, 1));
  var last = keys[keys.length - 1];
  var res = {}, fn;

  if (typeof last === 'function') {
    fn = keys.pop();
  }

  var isFunction = typeof fn === 'function';
  if (!keys.length && !isFunction) {
    return obj;
  }

  forOwn(obj, function(value, key) {
    if (keys.indexOf(key) === -1) {

      if (!isFunction) {
        res[key] = value;
      } else if (fn(value, key, obj)) {
        res[key] = value;
      }
    }
  });
  return res;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(417),
    getValue = __webpack_require__(420);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(149);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33, // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35, // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36, // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40, // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45, // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46, // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63, // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91, // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186, // needs localization
  /**
   * DASH
   */
  DASH: 189, // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187, // needs localization
  /**
   * COMMA
   */
  COMMA: 188, // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190, // needs localization
  /**
   * SLASH
   */
  SLASH: 191, // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192, // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222, // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219, // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220, // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221, // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229
};

/*
 whether text and modified key is entered at the same time.
 */
KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
  var keyCode = e.keyCode;
  if (e.altKey && !e.ctrlKey || e.metaKey ||
  // Function keys don't generate text
  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
    return false;
  }

  // The following keys are quite harmless, even in combination with
  // CTRL, ALT or SHIFT.
  switch (keyCode) {
    case KeyCode.ALT:
    case KeyCode.CAPS_LOCK:
    case KeyCode.CONTEXT_MENU:
    case KeyCode.CTRL:
    case KeyCode.DOWN:
    case KeyCode.END:
    case KeyCode.ESC:
    case KeyCode.HOME:
    case KeyCode.INSERT:
    case KeyCode.LEFT:
    case KeyCode.MAC_FF_META:
    case KeyCode.META:
    case KeyCode.NUMLOCK:
    case KeyCode.NUM_CENTER:
    case KeyCode.PAGE_DOWN:
    case KeyCode.PAGE_UP:
    case KeyCode.PAUSE:
    case KeyCode.PRINT_SCREEN:
    case KeyCode.RIGHT:
    case KeyCode.SHIFT:
    case KeyCode.UP:
    case KeyCode.WIN_KEY:
    case KeyCode.WIN_KEY_RIGHT:
      return false;
    default:
      return true;
  }
};

/*
 whether character is entered.
 */
KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
    return true;
  }

  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
    return true;
  }

  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
    return true;
  }

  // Safari sends zero key code for non-latin characters.
  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
    return true;
  }

  switch (keyCode) {
    case KeyCode.SPACE:
    case KeyCode.QUESTION_MARK:
    case KeyCode.NUM_PLUS:
    case KeyCode.NUM_MINUS:
    case KeyCode.NUM_PERIOD:
    case KeyCode.NUM_DIVISION:
    case KeyCode.SEMICOLON:
    case KeyCode.DASH:
    case KeyCode.EQUALS:
    case KeyCode.COMMA:
    case KeyCode.PERIOD:
    case KeyCode.SLASH:
    case KeyCode.APOSTROPHE:
    case KeyCode.SINGLE_QUOTE:
    case KeyCode.OPEN_SQUARE_BRACKET:
    case KeyCode.BACKSLASH:
    case KeyCode.CLOSE_SQUARE_BRACKET:
      return true;
    default:
      return false;
  }
};

module.exports = KeyCode;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(283), __esModule: true };

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(73);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(158);
var defined = __webpack_require__(102);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(102);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(548);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(79);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _button=__webpack_require__(398);var _button2=_interopRequireDefault(_button);var _buttonGroup=__webpack_require__(399);var _buttonGroup2=_interopRequireDefault(_buttonGroup);var _middleware=__webpack_require__(27);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_button2.default.Group=_buttonGroup2.default;var Com=(0,_middleware2.default)(_button2.default,"Button");exports.default=Com;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(157);
var enumBugKeys = __webpack_require__(109);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var addEventListener=exports.addEventListener=function addEventListener(node,event,listener){return node.addEventListener?node.addEventListener(event,listener,false):node.attachEvent('on'+event,listener);};var removeEventListener=exports.removeEventListener=function removeEventListener(node,event,listener){return node.removeEventListener?node.removeEventListener(event,listener,false):node.detachEvent('on'+event,listener);};/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */var supportsHistory=exports.supportsHistory=function supportsHistory(){var ua=window.navigator.userAgent;if((ua.indexOf('Android 2.')!==-1||ua.indexOf('Android 4.0')!==-1)&&ua.indexOf('Mobile Safari')!==-1&&ua.indexOf('Chrome')===-1&&ua.indexOf('Windows Phone')===-1)return false;return window.history&&'pushState'in window.history;};/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */var supportsGoWithoutReloadUsingHash=exports.supportsGoWithoutReloadUsingHash=function supportsGoWithoutReloadUsingHash(){return window.navigator.userAgent.indexOf('Firefox')===-1;};/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */var supportsPopstateOnHashchange=exports.supportsPopstateOnHashchange=function supportsPopstateOnHashchange(){return window.navigator.userAgent.indexOf('Trident')===-1;};/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */var isExtraneousPopstateEvent=exports.isExtraneousPopstateEvent=function isExtraneousPopstateEvent(event){return event.state===undefined&&navigator.userAgent.indexOf('CriOS')===-1;};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(400);

/***/ }),
/* 65 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(124),
    isLength = __webpack_require__(127);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _stringify=__webpack_require__(71);var _stringify2=_interopRequireDefault(_stringify);var _promise=__webpack_require__(48);var _promise2=_interopRequireDefault(_promise);var _toConsumableArray2=__webpack_require__(46);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _class,_temp2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _isString=__webpack_require__(98);var _isString2=_interopRequireDefault(_isString);var _loadjs=__webpack_require__(76);var _loadjs2=_interopRequireDefault(_loadjs);var _util=__webpack_require__(197);var _callApi=__webpack_require__(72);var caUtil=_interopRequireWildcard(_callApi);var _checkSSO=__webpack_require__(495);var _watermark=__webpack_require__(499);var _watermark2=_interopRequireDefault(_watermark);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var callApi=caUtil.callApi;var localeKey="e9_locale";var constant={langRegP:/(~`~`(([\d ]{1,2}[^`]{0,2000}?`~`)+[\d ]{1,2}[^`]{0,2000}?)`~`~).{0,2000}?/i,blank:/&nbsp;/g,LANG_CONTENT_PREFIX:"~`~`",LANG_CONTENT_SPLITTER1:"`~`",LANG_CONTENT_SUFFIX:"`~`~",LANG_INPUT_PREFIX:"__multilangpre_"};var getLocale=function getLocale(){return window[localeKey];};var getUserLanguage=function getUserLanguage(){// 多语言静态资源调整了。目前是直接从localStorage.languageidweaver中取的当前的语言
if(localStorage.languageidweaver){return localStorage.languageidweaver;}if(localStorage.login){try{var login=JSON.parse(localStorage.login);if(login.langId){return login.langId;}if(window[localeKey]){return window[localeKey].userLanguage||7;}}catch(error){console&&console.error("多语言获取失败 :(",error);}}};// const overTime =(msg, timeout) => new Promise((rs, rj) => {
//   setTimeout(() => rs(msg), timeout);
// });
var isInMain=function isInMain(){return window.location.href.indexOf("/wui/index")>0;};var transModeleCode=function transModeleCode(moduleCode){var mod=[];if(Array.isArray(moduleCode)){mod=[].concat((0,_toConsumableArray3.default)(moduleCode));}else if(typeof moduleCode==="string"&&moduleCode.indexOf(",")>0){mod=moduleCode.split(",");}else{mod=[moduleCode];}return mod;};var checkModuleCode=function checkModuleCode(moduleCode){var noNeedTransMod=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;// noNeedTransMod: 是否需要通过transModeleCode转一次moduleCode
if(!moduleCode||!(""+moduleCode))return false;// let mod = noNeedTransMod ? moduleCode : transModeleCode(moduleCode);
var mod=transModeleCode(moduleCode);if(window[localeKey]){// fix: 过滤mod 取window[localeKey].loadedModules没有的,有的直接拿lable，没有走接口
mod=mod.filter(function(m){return!window[localeKey].loadedModules.some(function(_m){return _m===m;});});if(mod.length>0){// fix: 过滤后的mod,拼接到window[localeKey].loadedModules中
window[localeKey].loadedModules=window[localeKey].loadedModules.concat(mod);}}if(mod.length===0)return false;return mod;};// 通过语言类型获取多语言标签
var getLocaleLabelByLang=function getLocaleLabelByLang(moduleCode){var languageId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";// moduleCode: 模块名 languageId:当前语音标识
var language=typeof language==="string"&&languageId!==""?Number(languageId):languageId;return new _promise2.default(function(rs,rj){var noNeedTransMod=!window[localeKey]||window[localeKey].userLanguage!=language;// 如果当前缓存中没有window[localeKey] 或者 当前的语言类型发生改变,重置数据
if(noNeedTransMod){window[localeKey]={userLanguage:language,loadedModules:[],reloadedModules:[]};}else{// 语言类型赋值
window[localeKey].userLanguage=language;}var mod=checkModuleCode(moduleCode,noNeedTransMod);var modUrl=[];mod.length>0&&mod.forEach(function(element){element+="";element=element.toLowerCase();modUrl.push("/mobile/languagelocal/"+languageId+"/"+element+".js");return element;});var loadedConut=0;var callback=function callback(resolve,url){var mod=url.slice(url.lastIndexOf("/")+1,url.lastIndexOf("."));var localjsonTemp="";if(!window["localjson"+mod+languageId]){localjsonTemp=window["localjson"+mod];window["localjson"+mod+languageId]=window["localjson"+mod];}else{localjsonTemp=window["localjson"+mod+languageId];}if(Array.isArray(localjsonTemp)){localjsonTemp.forEach(function(item){if(!window[localeKey][item.type]){window[localeKey][item.type]={};}window[localeKey][item.type][item.id]=item.label;});window.localStorage[localeKey]=(0,_stringify2.default)(window[localeKey]);}// checkMode方法已处理，不需要再处理一次
// window[localeKey].loadedModules = window[localeKey].loadedModules.concat(
//   mod
// );
loadedConut+=1;if(loadedConut==modUrl.length){resolve();}};callback.bind(undefined);!mod?rs():modUrl.forEach(function(url){_loadjs2.default.isDefined(url+"?v="+localStorage["languageVersion"])?_loadjs2.default.ready(url+"?v="+localStorage["languageVersion"],function(){return callback(rs,url);}):(0,_loadjs2.default)([url+"?v="+localStorage["languageVersion"]],url+"?v="+localStorage["languageVersion"],{success:function success(){callback(rs,url);},error:function error(){console&&console.warn("load "+url+" fail");callback(rs,url);}});});//  callApi("/api/ec/dev/locale/getLabelByModule", "GET", {
//     moduleCode: `${mod}`,
//     languageId: language
//   }).then(result => {
//     const { datas } = result;
//     if (Array.isArray(datas)) {
//       datas.forEach(item => {
//         if (!window[localeKey][item.type]) {
//           window[localeKey][item.type] = {};
//         }
//         window[localeKey][item.type][item.id] = item.label;
//       });
//       window.localStorage[localeKey] = JSON.stringify(window[localeKey]);
//     }
//     window[localeKey].loadedModules = window[
//       localeKey
//     ].loadedModules.concat(mod);
//     rs();
//   });
});};// 通过模块名获取多语言标签
var getLocaleLabelByCode=function getLocaleLabelByCode(moduleCode){var isform=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var noNeedTransMod=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return new _promise2.default(function(rs,rj){// if (isform) {
//   if (window[localeKey]) {
//     rs();
//     return;
//   } else {
//     if (window.localStorage[localeKey]) {
//       window[localeKey] = JSON.parse(window.localStorage[localeKey]);
//     }
//   }
// }
if(!window[localeKey]){window[localeKey]={loadedModules:[],reloadedModules:[]};}var mod=checkModuleCode(moduleCode,noNeedTransMod);var modUrl=[];mod.length>0&&mod.forEach(function(element){element+="";element=element.toLowerCase();modUrl.push("/mobile/languagelocal/"+(window.localStorage["languageidweaver"]||7)+"/"+element+".js");return element;});var loadedConut=0;var callback=function callback(resolve,url){var mod=url.slice(url.lastIndexOf("/")+1,url.lastIndexOf("."));var localjsonTemp="";if(!window["localjson"+mod+window.localStorage["languageidweaver"]]){localjsonTemp=window["localjson"+mod];window["localjson"+mod+window.localStorage["languageidweaver"]]=window["localjson"+mod];}else{localjsonTemp=window["localjson"+mod+window.localStorage["languageidweaver"]];}if(Array.isArray(localjsonTemp)){localjsonTemp.forEach(function(item){if(!window[localeKey][item.type]){window[localeKey][item.type]={};}window[localeKey][item.type][item.id]=item.label;});window.localStorage[localeKey]=(0,_stringify2.default)(window[localeKey]);}// checkMode方法已处理，不需要再处理一次
// window[localeKey].loadedModules = window[localeKey].loadedModules.concat(
//   mod
// );
loadedConut+=1;if(loadedConut==modUrl.length){resolve();}};callback.bind(undefined);if(window.localStorage.ennableTrans!="1"){!mod?rs():modUrl.forEach(function(url){_loadjs2.default.isDefined(url+"?v="+localStorage["languageVersion"])?_loadjs2.default.ready(url+"?v="+localStorage["languageVersion"],function(){return callback(rs,url);}):(0,_loadjs2.default)([url+"?v="+localStorage["languageVersion"]],url+"?v="+localStorage["languageVersion"],{success:function success(){callback(rs,url);},error:function error(){console&&console.warn("load "+url+" fail");callback(rs,url);}});});}else{!mod?rs():callApi("/api/ec/dev/locale/getLabelByModule","GET",{moduleCode:""+mod}).then(function(result){var datas=result.datas,language=result.language;window[localeKey].userLanguage=language;if(Array.isArray(datas)){datas.forEach(function(item){if(!window[localeKey][item.type]){window[localeKey][item.type]={};}window[localeKey][item.type][item.id]=item.label;});}window[localeKey].loadedModules=window[localeKey].loadedModules.concat(mod);window.localStorage[localeKey]=(0,_stringify2.default)(window[localeKey]);rs();});}});};// 用于写在 React-Router 的 onEnter 中
var getLocaleLabel=function getLocaleLabel(moduleCode,nextState,replace,callback){var callbackFunction=typeof callback==="function";if(!callbackFunction){console&&void 0;}// check sso
if(!window.ssoChecked){(0,_checkSSO.checkSSO)().then(function(){if(!/.*appid=.*&service=.*/.test(window.location.href)&&!window.loadCas){// window.loadCas = true;
callApi("/api/integration/common1/checkCasIsDeployed","POST",{}).then(function(res){function getQueryVariable(variable){var query=window.location.search.substring(1);var vars=query.split("&");for(var i=0;i<vars.length;i++){var pair=vars[i].split("=");if(pair[0]==variable){return pair[1];}}return false;}var servicePath=window.location.pathname+window.location.search+window.location.hash;if(/\/wui\/index\.html\#\/\?/.test(servicePath)){servicePath=(window.ecologyContentPath||"")+"/wui/index.html#/main";}if(!res.hasSession&&res.isDeployed&&res.weaver_login_type!=="OALogin"&&!/preview=true/.test(window.location.href)){if(/\/spa\/portal\/public\/index\.html#\/licensesubmit\?display=page/.test(window.location.href)){getLocaleLabelInner(moduleCode,nextState,replace,callback);}else{var service=window.location.protocol+"//"+window.location.host+(window.ecologyContentPath||"")+"/wui/cas-entrance.jsp?path="+encodeURIComponent(servicePath)+("&ssoType="+res.ssoType);if(getQueryVariable("languid")){service=window.location.protocol+"//"+window.location.host+(window.ecologyContentPath||"")+"/wui/cas-entrance.jsp?languid="+getQueryVariable("languid")+"&path="+encodeURIComponent(servicePath);}window.localStorage["casPath"]=service;window.location.href=service;}}else{if(!res.isDeployed){window.localStorage.removeItem("casPath");}else{var _service=window.location.protocol+"//"+window.location.host+(window.ecologyContentPath||"")+"/wui/cas-entrance.jsp?path="+encodeURIComponent(servicePath)+("&ssoType="+res.ssoType);if(getQueryVariable("languid")){_service=window.location.protocol+"//"+window.location.host+(window.ecologyContentPath||"")+"/wui/cas-entrance.jsp?languid="+getQueryVariable("languid")+"&path="+encodeURIComponent(servicePath);}window.localStorage["casPath"]=_service;}getLocaleLabelInner(moduleCode,nextState,replace,callback);}});}else{getLocaleLabelInner(moduleCode,nextState,replace,callback);}});}else{getLocaleLabelInner(moduleCode,nextState,replace,callback);}};var getLocaleLabelInner=function getLocaleLabelInner(moduleCode,nextState,replace,callback){var callbackFunction=typeof callback==="function";if(!callbackFunction){console&&void 0;}var mod=transModeleCode(moduleCode);var userLanguage=getUserLanguage();// 如果当前缓存中没有window[localeKey] 或者 当前的语言类型发生改变,重置数据
var noNeedTransMod=!window[localeKey]||userLanguage!=window[localeKey].userLanguage;if(noNeedTransMod){window[localeKey]={userLanguage:userLanguage,loadedModules:[],reloadedModules:[]};window.localStorage[localeKey]=(0,_stringify2.default)(window[localeKey]);// 默认拼接上common库
mod=mod.concat("common");}else{if(!window[localeKey].loadedModules||!window[localeKey].loadedModules["common"]){mod=mod.concat("common");}}getLocaleLabelByCode(mod,false,noNeedTransMod).then(function(){return callbackFunction&&callback();});// 加载字体大小
if(!isInMain()){if(localStorage["theme-themeInfo"]&&JSON.parse(localStorage["theme-themeInfo"])){var fontSize=JSON.parse(localStorage["theme-themeInfo"]).themeFontSize;if(fontSize)fontSize=Number(fontSize);if(!_loadjs2.default.isDefined("fontSize_"+fontSize)){(0,_loadjs2.default)("/cloudstore/resource/pc/com/font-size/"+fontSize+"px.css","fontSize_"+fontSize);}}}try{// 加载组件库时，设置系统水印
_watermark2.default.getSystemSetting();}catch(error){console.error(error);}};var transLang=function transLang(str,lang){//如果没有设过相应语言的翻译，返回中翻译作为默认值
var isExsit=false,defaultValue="",oriLang=lang;if(lang.length<2)lang+=" ";str=str.replace(constant.blank," ");var from=str.indexOf(constant.LANG_CONTENT_PREFIX),to=str.lastIndexOf(constant.LANG_CONTENT_SUFFIX);if(from!=-1&&to!=-1&&from+4<to){var ls=str.substring(from+4,to).split(constant.LANG_CONTENT_SPLITTER1);for(var i=0;i<ls.length;i++){var lg=ls[i];if(lg.indexOf("7 ")===0){defaultValue=lg.substring(lang.length);}if(lg.indexOf(lang)===0){isExsit=true;return lg.substring(lang.length);}else if(lg.startsWith(oriLang)){isExsit=true;return lg.substring(oriLang.length);}}}if(!isExsit){return defaultValue;}return str;};// 解析多语言对应的显示
var formatMultiLang=function formatMultiLang(str){if(!str||!(0,_isString2.default)(str)||str.indexOf(constant.LANG_CONTENT_PREFIX)<0){return str;}var lang=new String(getUserLanguage());var arr=null;while(arr=str.match(constant.langRegP)){var formatValue=arr[1];var value=transLang(formatValue,lang);str=str.replace(formatValue,value);}return str;};var WeaLocaleProvider=(_temp2=_class=function(_React$Component){(0,_inherits3.default)(WeaLocaleProvider,_React$Component);function WeaLocaleProvider(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,WeaLocaleProvider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=WeaLocaleProvider.__proto__||(0,_getPrototypeOf2.default)(WeaLocaleProvider)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){return _this.props.children;},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}return WeaLocaleProvider;}(_react2.default.Component),_class.getLabel=_util.getLabel,_class.getLocale=getLocale,_class.getUserLanguage=getUserLanguage,_class.getLocaleLabel=getLocaleLabel,_class.getLocaleLabelByCode=getLocaleLabelByCode,_class.formatMultiLang=formatMultiLang,_class.transLang=transLang,_class.getLocaleLabelByLang=getLocaleLabelByLang,_temp2);exports.default=WeaLocaleProvider;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _format=__webpack_require__(253);var format=_interopRequireWildcard(_format);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}var tools={tryCatch:function tryCatch(React,ErrorHandler,handlerOptions){if(!React||!React.Component){throw new Error("arguments[0] for react-try-catch-render does not look like React.");}if(typeof ErrorHandler!=="function"){throw new Error("arguments[1] for react-try-catch-render does not look like a function.");}/**
     * Implementation of the try/catch wrapper
     * @param  {[React.Component]} component The ES6 React.Component
     */return function wrapWithTryCatch(Component){var originalRender=Component.prototype.render;Component.prototype.render=function tryRender(){try{return originalRender.apply(this,arguments);}catch(err){// Log an error
window.console&&console.error("errorLog:",err);if(ErrorHandler&&ErrorHandler.prototype&&ErrorHandler.prototype.render){return React.createElement(ErrorHandler,handlerOptions);}// ErrorHandler is at least a valid function
return ErrorHandler(err);}};return Component;};},formatDate:format.formatToDate,formatTime:format.formatToTime,getTextWidth:function getTextWidth(str){var width=0;if(str){for(var i=0;i<str.length;i++){//如果是汉字
if(str.charCodeAt(i)>255){width+=14;}else{width+=7;}}}return width;},isWeekendDay:function isWeekendDay(str){var bool=false;if(str){var dt=new Date(str);// 修复大于 +8时区的周末显示异常
// let time = dt.getTime();
// dt = new Date(time + new Date(time).getTimezoneOffset() * 60 * 1000 + 8 * 60 * 60 * 1000)
if(dt.getDay()==0||dt.getDay()==6){bool=true;}}return bool;},isBelowIE9:function isBelowIE9(){return navigator.appName=="Microsoft Internet Explorer"&&parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g,"").replace("MSIE",""))<=9;},camelCase:function camelCase(name){return name.charAt(0).toUpperCase()+name.slice(1).replace(/-(\w)/g,function(m,n){return n.toUpperCase();});}};exports.default=tools;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addEventListenerWrap;

var _addDomEventListener = __webpack_require__(119);

var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function addEventListenerWrap(target, eventType, cb) {
  /* eslint camelcase: 2 */
  var callback = _reactDom2["default"].unstable_batchedUpdates ? function run(e) {
    _reactDom2["default"].unstable_batchedUpdates(cb, e);
  } : cb;
  return (0, _addDomEventListener2["default"])(target, eventType, callback);
}
module.exports = exports['default'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(342), __esModule: true };

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.callApi=exports.getPageCheckCode=exports.getFd=undefined;var _promise=__webpack_require__(48);var _promise2=_interopRequireDefault(_promise);var _toConsumableArray2=__webpack_require__(46);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _stringify=__webpack_require__(71);var _stringify2=_interopRequireDefault(_stringify);var _typeof2=__webpack_require__(23);var _typeof3=_interopRequireDefault(_typeof2);var _jsBase=__webpack_require__(490);var _isEmpty=__webpack_require__(100);var _isEmpty2=_interopRequireDefault(_isEmpty);var _window=__webpack_require__(33);var _window2=_interopRequireDefault(_window);var _util=__webpack_require__(197);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}window.E9Encrypt=false;// import { message, Modal } from "antd";
// fetch 部分处理
var server=window.server||"";var getFd=exports.getFd=function getFd(values,deep){var fd="";for(var p in values){var target=values[p];if(typeof target==="function"){continue;}if(deep&&(typeof target==="undefined"?"undefined":(0,_typeof3.default)(target))==="object"){fd+=getFd(target,deep);}else if(p=="jsonstr"&&(typeof target==="undefined"?"undefined":(0,_typeof3.default)(target))==="object"){var item=(0,_stringify2.default)(target);fd+=p+"="+item.replace(/\\/g,"")+"&";}else{// 处理undefined null数据to 空串
target=target==undefined?"":target;var _item=encodeURIComponent(target);fd+=p+"="+_item+"&";}}return fd;};// 获取页面CRSF code
var getPageCheckCode=exports.getPageCheckCode=function getPageCheckCode(_ref){var key=_ref.key,code=_ref.code;window.pageCheckKey=key;window.pageCheckCode=code;};var getFetchParams=function getFetchParams(method,params,deep,noInclude){var obj={method:method,headers:{"Content-Type":"application/x-www-form-urlencoded; charset=utf-8","X-Requested-With":"XMLHttpRequest"}};if(server==""&&!noInclude){obj.credentials="include";}if(!(0,_isEmpty2.default)(params)&&method.toUpperCase()!=="GET"){obj.body=getFd(params,deep);}return obj;};var handleRedirect=function handleRedirect(msg){window.antd&&antd.message.error(msg);setTimeout(function(){try{if(_window2.default.getTop().opener&&_window2.default.getTop().opener.ecCom){_window2.default.getTop().opener.location.href=""+(window.ecologyContentPath||"")+"/wui/index.html?v="+new Date().getTime();}}catch(error){}window.localStorage["gopage"]=encodeURIComponent(location.href);_window2.default.getTop().location.href=""+(window.ecologyContentPath||"")+"/wui/index.html?v="+new Date().getTime();},1000);};var handleRejct=function handleRejct(msg){if(window.frameElement){var url=window.frameElement.src;if(/.*index-emobile\.html.*/.test(url)){if(em&&em.checkJsApi("pageReload")){em.pageReload({});}return true;}if(/.*index-message\.html.*/.test(url)){if(em&&em.checkJsApi("pageReload")){em.pageReload({});}return true;}if(/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(url)){if(em&&em.checkJsApi("pageReload")){em.pageReload({});}return true;}}if(/.*\/main\/document\/outDetail/.test(_window2.default.getTop().location.href)||/.*\/main\/document\/more/.test(_window2.default.getTop().location.href)||/.*\/cloudstore\/e9DevModules\/portal\/element\/rss\/index\.html#\/more/.test(_window2.default.getTop().location.href)||/.*\/login\/OALogin\.jsp.*/.test(_window2.default.getTop().location.href)||/.*\/wui\/index\.html.*#\/\?.*/.test(_window2.default.getTop().location.href)||/.*\/wui\/index\.html$/.test(_window2.default.getTop().location.href)){return true;}if(!/.*index-emobile\.html.*/.test(_window2.default.getTop().location.href)&&!/.*index-message\.html.*/.test(_window2.default.getTop().location.href)&&!/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(_window2.default.getTop().location.href)){if(window.emClient){emClient.logout();}if(window.localStorage["casPath"]){window.location.href=window.localStorage["casPath"];}else{if(window.e9TimeOutSwitch){handleRedirect(msg);return true;}window.eventRegister.register("f_portal",{lib:["/spa/portal/public/index.css?v=1561346408146","/spa/portal/public/index.js?v=1561346408146","/spa/portal/index.css?v=1561346598585","/spa/portal/index.js?v=1561346598585"],libName:"f_portal",fn:function fn(){return"success";}});window.eventRegister.start("f_portal",function(){if(window.doLoginPop){window.doLoginPop();}else{handleRedirect(msg);}},function(){handleRedirect(msg);});}}else{if(window.em){window.em.getEmAuthCode({sysId:window.localStorage.emobile_ec_id,// 集成系统ID
success:function success(emres){// 如：{"em_auth_code":"abc123","errMsg":"getEmAuthCode:ok"}
if(emres.em_auth_code){callApi("/api/ec/dev/app/test","GET",{em_auth_code:emres.em_auth_code}).then(function(res){if(res.status===true||res.status==="1"){window.location.reload();}else{console&&console.error("认证失败，"+res.errmsg);}},function(){console&&console.error("认证失败，code："+emres.em_auth_code);});}else{console&&console.error("获取em_auth_code失败");}}});}else{console&&console.error("em对象不存在");}}return true;};var checkReject=function checkReject(obj){if(obj.columns&&window.localStorage.getItem("hackResponse")){obj.errorCode="005";}var isFalse=false;if(obj.errorCode&&obj.errorCode==="001"){// session异常，如果有路由就强制跳转
isFalse=handleRejct((0,_util.getLabel)("516531","session过期，请重新登录！"));}else if(obj.errorCode&&obj.errorCode==="002"){// session异常，如果有路由就强制跳转
isFalse=handleRejct((0,_util.getLabel)("516532","登录超时，请重新登录！"));}else if(obj.errorCode&&obj.errorCode==="003"){// session异常，如果有路由就强制跳转
isFalse=handleRejct((0,_util.getLabel)("81908","您已被管理员强制下线！"));}else if(obj.errorCode&&obj.errorCode==="004"){// session异常，如果有路由就强制跳转
isFalse=handleRejct((0,_util.getLabel)("23274","您已经从另一个窗口登入，当前工作窗口失效！"));}else if(obj.errorCode&&obj.errorCode==="005"){window.antd&&antd.message.error(obj.error||obj.msg);// setTimeout(() => window.location.reload(), 1000);
isFalse=true;}else if(typeof obj.status!=="undefined"&&(!obj.status||obj.status==="false")){// window.antd && antd.message.error('接口业务逻辑错误：' + obj.error, 5);
if(obj.error||obj.msg){!/.*index-emobile\.html.*/.test(_window2.default.getTop().location.href)&&!/.*index-message\.html.*/.test(_window2.default.getTop().location.href)&&!/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(_window2.default.getTop().location.href)&&window.antd&&antd.message.error(obj.error||obj.msg);}isFalse=true;}return isFalse;};var checkCSRF=function checkCSRF(url,method,_params,type,deep){var check=arguments.length>5&&arguments[5]!==undefined?arguments[5]:true;if(!check){return callApi(url,method,params,type,deep,false);}var params=Object.prototype.toString.call(_params)==="[object Object]"?(0,_extends3.default)({},_params):{};if(Object.prototype.toString.call(_params)==="[object Array]"){params=[].concat((0,_toConsumableArray3.default)(_params));}if(window.pageCheckKey&&window.pageCheckCode){// 单独处理表单一个页面唯一code
params[window.pageCheckKey]=window.pageCheckCode;params["__randCodeKey__"]=window.pageCheckKey;return callApi(url,method,params,type,deep,false);}return callApi("/api/security/getRandomCode","get",{},"json",false,false).then(function(res){params[res.key]=res.code;params["__randCodeKey__"]=res.key;return callApi(url,method,params,type,deep,false);}).catch(function(err){window.checkCSRF=false;return callApi(url,method,params,type,deep,false);});};var callApi=exports.callApi=function callApi(url){var method=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"GET";var _params=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var type=arguments.length>3&&arguments[3]!==undefined?arguments[3]:"json";var deep=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var checkCode=arguments.length>5&&arguments[5]!==undefined?arguments[5]:true;var params=Object.prototype.toString.call(_params)==="[object Object]"?(0,_extends3.default)({},_params):{};if(Object.prototype.toString.call(_params)==="[object Array]"){params=[].concat((0,_toConsumableArray3.default)(_params));}if(typeof localStorage.access_token==="string"&&localStorage.access_token!==""){params.access_token=localStorage.access_token;}if(window.checkCSRF===true&&checkCode&&window.sessionStorage["em_check_csrf"]=="true"&&// method.toUpperCase() === "POST" &&
/^\/api/.test(url)){return checkCSRF(url,method,_params,type,deep);}url=""+server+url;if(window.ecCallApiLogServer&&url=="/api/securtity/addListUrlLog"){url=""+window.ecCallApiLogServer+url;}var reg=new RegExp("^"+window.ecologyContentPath+"");if(!/^http/.test(url)&&!reg.test(url)){url=(window.ecologyContentPath||"")+url;}if(method.toUpperCase()==="GET"&&!(0,_isEmpty2.default)(params)){var c="?";if(/\?/.test(url))c="&";url=""+url+c+getFd(params);}if(method.toUpperCase()==="GET"&&!/__random__=/.test(url)){var _c="?";if(/\?/.test(url))_c="&";url+=_c+"__random__="+new Date().getTime();}// 处理连续&
url=url.replace(/\&\&/g,"&");function evil(fn){var Fn=window.Function;//一个变量指向Function，防止有些前端编译工具报错
return new Fn("return "+fn)();}return new _promise2.default(function(resolve,reject){var lastReq=function lastReq(){var isConfirm=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var validateParams=(0,_stringify2.default)(_params);if(validateParams.indexOf("base64_")>-1){console&&console.warn("原不能提交数据：",_params);// regex
var regexBase=/base64_(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?/g;if(regexBase.test(validateParams)){params=validateParams.replace(regexBase,function(oldStr){return _jsBase.Base64.decode(oldStr.substr(7));});console&&console.warn("后转换成功的数据",JSON.parse(params));}if(params.indexOf("base64_")>-1){reject((0,_util.getLabel)("516533","base64 不能提交:"));}else{params=JSON.parse(params);}}if(isConfirm){params.sensitiveWordconfirm=1;}if(method.toUpperCase()==="GET"&&isConfirm){var _c2="?";if(/\?/.test(url))_c2="&";url+=_c2+"sensitiveWordconfirm=1";}var _url=url;var _fetchParams=getFetchParams(method,params,deep,window.ecCallApiLog?true:false);if(window.e9ssoPCConfig&&window.e9ssoPCConfig.inUse&&window.e9ssoPCConfig.callapi_params_handler&&!isConfirm){var res=window.e9ssoPCConfig.callapi_params_handler(_url,method,params,type,_fetchParams);_url=res.url;method=res.method;params=res.params;type=res.type;_fetchParams=res.fetchParams||getFetchParams(method,params,deep,window.ecCallApiLog?true:false);}if(window.ecCallApiLog){var logParams={};logParams._url=_url;logParams.method=method;logParams.params=params;logParams.type=type;logParams._fetchParams=_fetchParams;logParams.themeAccount=localStorage["theme-account"];logParams.href=window.location.href;logParams.calldatetime=new Date();}fetch(_url,_fetchParams).then(function(response){if(window.ecCallApiLog){logParams.response=response.clone();logParams.endtime=new Date();window.ecCallApiLog(logParams);}if(!response.ok){if(window.ecCallApiHandler){if(typeof window.ecCallApiHandler=="function"){window.ecCallApiHandler(_url,params,response.status,response.statusText);}}return _promise2.default.reject({status:response.status,statusText:response.statusText});}return response.text().then(function(data){if(window.e9ssoPCConfig&&window.e9ssoPCConfig.inUse&&window.e9ssoPCConfig.callapi_response_handler){return window.e9ssoPCConfig.callapi_response_handler(data,reject,response,type);}if(response.redirected&&/\/login\/Login.jsp/.test(response.url)){if(/.*\/wui\/index\.html#\/?.*/.test(_window2.default.getTop().location.href)||/.*\/wui\/index\.html$/.test(_window2.default.getTop().location.href)){return{status:true};}if(/.*index-emobile\.html.*/.test(_window2.default.getTop().location.href)||/.*index-message\.html.*/.test(_window2.default.getTop().location.href)||/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(_window2.default.getTop().location.href)){if(window.em){em.setPageReload({setvalue:1,// 1表示每次都需要重新加载页面（默认） 2表示保持页面无需重新加载，
success:function success(res){// 如：{"errMsg":"setHoldPage:ok"}
//alert(res.errMsg);
}});}return{status:false,errorCode:"002"};}if(window.frameElement){var _url2=window.frameElement.src;if(/.*index-emobile\.html.*/.test(_url2)||/.*index-message\.html.*/.test(_url2)||/.*\/spa\/portal\/static4em\/index.html\#\/main.*/.test(_url2)){if(window.em){em.setPageReload({setvalue:1,// 1表示每次都需要重新加载页面（默认） 2表示保持页面无需重新加载，
success:function success(res){// 如：{"errMsg":"setHoldPage:ok"}
//alert(res.errMsg);
}});}return{status:false,errorCode:"002"};}}window.antd&&antd.message.error((0,_util.getLabel)("516532","登录超时，请重新登录！"));console&&console.error(url+" fetch \u767B\u5F55\u8D85\u65F6");setTimeout(function(){window.localStorage["gopage"]=encodeURIComponent(location.href);_window2.default.getTop().location.href=""+(window.ecologyContentPath||"")+"/wui/index.html?v="+new Date().getTime();},1000);}if(type==="json"){try{var dataTemp=JSON.parse(data);if(dataTemp.needResponse){dataTemp.response=response;}return dataTemp;}catch(error){data=data||"{}";return evil("("+data+")");// JSON.parse 解析反斜杠报错处理
}}else{return data;}});}).then(function(data){if(window.rewriteApiData){data=window.rewriteApiData(_url,params,data);}//weaHistory
if(type==="json"&&data&&(data.status==="false"||!data.status)&&data.showType==="url"&&data.url){setTimeout(function(){return _window2.default.getTop().location.href=data.url;},1000);resolve(data);}else if(type==="json"&&data&&(data.status==="false"||!data.status)&&data.showType==="auth"){if(window.weaHistory){var pathname="/main/com/auth";if(_window2.default.getTop().location.href.indexOf("/wui/engine.html")>-1){pathname="/com/auth";}window.weaHistory.push({pathname:pathname});}resolve(data);}else if(type==="json"&&data&&(data.status==="false"||!data.status)&&(data.showMsg||data.showType==="msg")){data.error&&window.antd&&antd.message.warn(data.error);resolve(data);}else if(type==="json"&&data&&(data.status==="false"||!data.status)&&data.showType==="none"){resolve(data);}else if(type==="json"&&data&&(data.status==="false"||!data.status)&&(data.showModal||data.showType==="modal")){data.error&&window.antd&&antd.Modal.warning({title:data.title||(0,_util.getLabel)("19085","消息提醒"),content:data.error});resolve(data);}else if(type==="json"&&data&&(data.status==="false"||!data.status)&&data.errorCode==="009"){// 敏感词预检
var _params2={title:(0,_util.getLabel)("131329","信息确认"),content:data.msg,showClose:false,okCancel:false,okText:(0,_util.getLabel)("532049","确定"),zIndex:9999999,onOk:function onOk(){window.onWeaDialogClose&&window.onWeaDialogClose();lastReq(true);}};if(data.remindType=="2"){_params2=(0,_extends3.default)({},_params2,{showClose:true,okCancel:true,onCancel:function onCancel(){window.onWeaDialogClose&&window.onWeaDialogClose();resolve((0,_extends3.default)({},data,{msg:""}));}});}window.onWeaDialogOpen&&window.onWeaDialogOpen();window.antd&&antd.Modal.confirm(_params2);}else if(type==="json"&&checkReject(data)){console&&console.error(url+" fetch \u8BF7\u6C42\u5F02\u5E38: "+(data.error||"error"));if(/\/api\/ecode\/sync/.test(url)){resolve({status:true});}reject(url+" fetch \u8BF7\u6C42\u5F02\u5E38: "+(data.error||"error"));}else{resolve(data);}}).catch(function(ex){if(window.ecCallApiHandler){if(typeof window.ecCallApiHandler=="function"){window.ecCallApiHandler(_url,params,ex.status,ex.statusText);}}console&&console.error(url+" fetch \u6570\u636E\u5904\u7406\u5F02\u5E38: "+ex+", params:",params);reject({msg:url+" fetch \u6570\u636E\u5904\u7406\u5F02\u5E38: "+ex,responseCode:ex.status,statusText:ex.statusText});});};lastReq();});};if(window.sessionStorage["em_check_csrf"]===undefined){callApi("/api/security/isEnableRandomCode").then(function(res){if(res.randomCodeStatus==true){window.checkCSRF=true;window.sessionStorage["em_check_csrf"]="true";}}).catch(function(error){console&&void 0;window.sessionStorage["em_check_csrf"]="false";});}else{if(window.sessionStorage["em_check_csrf"]=="true"){window.checkCSRF=true;}}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(31).f;
var has = __webpack_require__(41);
var TAG = __webpack_require__(24)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _promise=__webpack_require__(48);var _promise2=_interopRequireDefault(_promise);var _typeof2=__webpack_require__(23);var _typeof3=_interopRequireDefault(_typeof2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}(function(root,factory){if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else if((typeof exports==="undefined"?"undefined":(0,_typeof3.default)(exports))==="object"){module.exports=factory();}else{root.loadjs=factory();}})(undefined,function(){/**
   * Global dependencies.
   * @global {Object} document - DOM
   */var devnull=function devnull(){},bundleIdCache={},bundleResultCache={},bundleCallbackQueue={};/**
   * Subscribe to bundle load event.
   * @param {string[]} bundleIds - Bundle ids
   * @param {Function} callbackFn - The callback function
   */function subscribe(bundleIds,callbackFn){// listify
bundleIds=bundleIds.push?bundleIds:[bundleIds];var depsNotFound=[],i=bundleIds.length,numWaiting=i,fn,bundleId,r,q;// define callback function
fn=function fn(bundleId,pathsNotFound){if(pathsNotFound.length)depsNotFound.push(bundleId);numWaiting--;if(!numWaiting)callbackFn(depsNotFound);};// register callback
while(i--){bundleId=bundleIds[i];// execute callback if in result cache
r=bundleResultCache[bundleId];if(r){fn(bundleId,r);continue;}// add to callback queue
q=bundleCallbackQueue[bundleId]=bundleCallbackQueue[bundleId]||[];q.push(fn);}}/**
   * Publish bundle load event.
   * @param {string} bundleId - Bundle id
   * @param {string[]} pathsNotFound - List of files not found
   */function publish(bundleId,pathsNotFound){// exit if id isn't defined
if(!bundleId)return;var q=bundleCallbackQueue[bundleId];// cache result
bundleResultCache[bundleId]=pathsNotFound;// exit if queue is empty
if(!q)return;// empty callback queue
while(q.length){q[0](bundleId,pathsNotFound);q.splice(0,1);}}/**
   * Execute callbacks.
   * @param {Object or Function} args - The callback args
   * @param {string[]} depsNotFound - List of dependencies not found
   */function executeCallbacks(args,depsNotFound){// accept function as argument
if(args.call)args={success:args};// success and error callbacks
if(depsNotFound.length)(args.error||devnull)(depsNotFound);else(args.success||devnull)(args);}/**
   * Load individual file.
   * @param {string} path - The file path
   * @param {Function} callbackFn - The callback function
   */function loadFile(path,callbackFn,args,numTries){var doc=document,async=args.async,maxTries=(args.numRetries||0)+1,beforeCallbackFn=args.before||devnull,pathStripped=path.replace(/^(css|img)!/,""),isLegacyIECss,e;numTries=numTries||0;if(/(^css!|\.css$)/.test(path)){// css
e=doc.createElement("link");e.rel="stylesheet";if(!/^http/.test(pathStripped)){var reg=new RegExp("^"+window.ecologyContentPath+"");e.href=reg.test(pathStripped)?pathStripped:(window.ecologyContentPath||"")+pathStripped;}else{e.href=pathStripped;}// tag IE9+
isLegacyIECss="hideFocus"in e;// use preload in IE Edge (to detect load errors)
if(isLegacyIECss&&e.relList){isLegacyIECss=0;e.rel="preload";e.as="style";}}else if(/(^img!|\.(png|gif|jpg|svg)$)/.test(path)){// image
e=doc.createElement("img");if(!/^http/.test(pathStripped)){var reg=new RegExp("^"+window.ecologyContentPath+"");e.src=reg.test(pathStripped)?pathStripped:(window.ecologyContentPath||"")+pathStripped;}else{e.src=pathStripped;}}else{// javascript
e=doc.createElement("script");if(!/^http/.test(path)){var reg=new RegExp("^"+window.ecologyContentPath+"");e.src=reg.test(path)?path:(window.ecologyContentPath||"")+path;}else{e.src=pathStripped;}e.async=async===undefined?true:async;}e.onload=e.onerror=e.onbeforeload=function(ev){var result=ev.type[0];// treat empty stylesheets as failures to get around lack of onerror
// support in IE9-11
if(isLegacyIECss){try{if(!e.sheet.cssText.length)result="e";}catch(x){// sheets objects created from load errors don't allow access to
// `cssText` (unless error is Code:18 SecurityError)
if(x.code!=18)result="e";}}// handle retries in case of load failure
if(result=="e"){// increment counter
numTries+=1;// exit function and try again
if(numTries<maxTries){return loadFile(path,callbackFn,args,numTries);}}else if(e.rel=="preload"&&e.as=="style"){// activate preloaded stylesheets
return e.rel="stylesheet";// jshint ignore:line
}// execute callback
callbackFn(path,result,ev.defaultPrevented);};// add to document (unless callback returns `false`)
if(beforeCallbackFn(path,e)!==false)doc.head.appendChild(e);}/**
   * Load multiple files.
   * @param {string[]} paths - The file paths
   * @param {Function} callbackFn - The callback function
   */function loadFiles(paths,callbackFn,args){// listify paths
paths=paths.push?paths:[paths];var numWaiting=paths.length,x=numWaiting,pathsNotFound=[],fn,i;// define callback function
fn=function fn(path,result,defaultPrevented){// handle error
if(result=="e")pathsNotFound.push(path);// handle beforeload event. If defaultPrevented then that means the load
// will be blocked (ex. Ghostery/ABP on Safari)
if(result=="b"){if(defaultPrevented)pathsNotFound.push(path);else return;}numWaiting--;if(!numWaiting)callbackFn(pathsNotFound);};// load scripts
for(i=0;i<x;i++){loadFile(paths[i],fn,args);}}/**
   * Initiate script load and register bundle.
   * @param {(string|string[])} paths - The file paths
   * @param {(string|Function|Object)} [arg1] - The (1) bundleId or (2) success
   *   callback or (3) object literal with success/error arguments, numRetries,
   *   etc.
   * @param {(Function|Object)} [arg2] - The (1) success callback or (2) object
   *   literal with success/error arguments, numRetries, etc.
   */function loadjs(paths,arg1,arg2){var bundleId,args;// bundleId (if string)
if(arg1&&arg1.trim)bundleId=arg1;// args (default is {})
args=(bundleId?arg2:arg1)||{};// throw error if bundle is already defined
if(bundleId){if(bundleId in bundleIdCache){throw"LoadJS";}else{bundleIdCache[bundleId]=true;}}function loadFn(resolve,reject){loadFiles(paths,function(pathsNotFound){// execute callbacks
executeCallbacks(args,pathsNotFound);// resolve Promise
if(resolve){executeCallbacks({success:resolve,error:reject},pathsNotFound);}// publish bundle load event
publish(bundleId,pathsNotFound);},args);}if(args.returnPromise)return new _promise2.default(loadFn);else loadFn();}/**
   * Execute callbacks when dependencies have been satisfied.
   * @param {(string|string[])} deps - List of bundle ids
   * @param {Object} args - success/error arguments
   */loadjs.ready=function ready(deps,args){// subscribe to bundle load event
subscribe(deps,function(depsNotFound){// execute callbacks
executeCallbacks(args,depsNotFound);});return loadjs;};/**
   * Manually satisfy bundle dependencies.
   * @param {string} bundleId - The bundle id
   */loadjs.done=function done(bundleId){publish(bundleId,[]);};/**
   * Reset loadjs dependencies statuses
   */loadjs.reset=function reset(){bundleIdCache={};bundleResultCache={};bundleCallbackQueue={};};/**
   * Determine if bundle has already been defined
   * @param String} bundleId - The bundle id
   */loadjs.isDefined=function isDefined(bundleId){return bundleId in bundleIdCache;};// export
return loadjs;});

/***/ }),
/* 77 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(28);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(42),
    isObjectLike = __webpack_require__(35);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});/**
 * Indicates that navigation was caused by a call to history.push.
 */var PUSH=exports.PUSH='PUSH';/**
 * Indicates that navigation was caused by a call to history.replace.
 */var REPLACE=exports.REPLACE='REPLACE';/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */var POP=exports.POP='POP';

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var canUseDOM=exports.canUseDOM=!!(typeof window!=='undefined'&&window.document&&window.document.createElement);

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(407),
    listCacheDelete = __webpack_require__(408),
    listCacheGet = __webpack_require__(409),
    listCacheHas = __webpack_require__(410),
    listCacheSet = __webpack_require__(411);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(65);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(429);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(446),
    isObjectLike = __webpack_require__(35);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(28),
    stubFalse = __webpack_require__(447);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(126)(module)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(448),
    baseUnary = __webpack_require__(449),
    nodeUtil = __webpack_require__(450);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.noop=noop;exports.getKeyFromChildrenIndex=getKeyFromChildrenIndex;exports.loopMenuItem=loopMenuItem;exports.loopMenuItemRecusively=loopMenuItemRecusively;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var now=Date.now();function noop(){}function getKeyFromChildrenIndex(child,menuEventKey,index){var prefix=menuEventKey||'';return child.key||prefix+'item_'+now+'_'+index;}function loopMenuItem(children,cb){var index=-1;_react2.default.Children.forEach(children,function(c){index++;if(c&&c.type.isMenuItemGroup){_react2.default.Children.forEach(c.props.children,function(c2){index++;cb(c2,index);});}else{cb(c,index);}});}function loopMenuItemRecusively(children,keys,ret){if(!children||ret.find){return;}_react2.default.Children.forEach(children,function(c){if(ret.find){return;}if(c){var construt=c.type;if(!construt||!(construt.isSubMenu||construt.isMenuItem||construt.isMenuItemGroup)){return;}if(keys.indexOf(c.key)!==-1){ret.find=true;}else if(c.props.children){loopMenuItemRecusively(c.props.children,keys,ret);}}});}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(465);var _index2=_interopRequireDefault(_index);var _placements=__webpack_require__(128);var _placements2=_interopRequireDefault(_placements);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Tooltip=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Tooltip,_React$Component);function Tooltip(props){(0,_classCallCheck3.default)(this,Tooltip);var _this=(0,_possibleConstructorReturn3.default)(this,(Tooltip.__proto__||(0,_getPrototypeOf2.default)(Tooltip)).call(this,props));_this.onVisibleChange=function(visible){_this.setState({visible:visible});_this.props.onVisibleChange(visible);};_this.onPopupAlign=function(domNode,align){var placements=_this.getPlacements();// 当前返回的位置
var placement=(0,_keys2.default)(placements).filter(function(key){return placements[key].points[0]===align.points[0]&&placements[key].points[1]===align.points[1];})[0];if(!placement){return;}// 根据当前坐标设置动画点
var rect=domNode.getBoundingClientRect();var transformOrigin={top:"50%",left:"50%"};if(placement.indexOf("top")>=0||placement.indexOf("Bottom")>=0){transformOrigin.top=rect.height-align.offset[1]+"px";}else if(placement.indexOf("Top")>=0||placement.indexOf("bottom")>=0){transformOrigin.top=-align.offset[1]+"px";}if(placement.indexOf("left")>=0||placement.indexOf("Right")>=0){transformOrigin.left=rect.width-align.offset[0]+"px";}else if(placement.indexOf("right")>=0||placement.indexOf("Left")>=0){transformOrigin.left=-align.offset[0]+"px";}domNode.style.transformOrigin=transformOrigin.left+" "+transformOrigin.top;};_this.state={visible:false};return _this;}(0,_createClass3.default)(Tooltip,[{key:"getPopupDomNode",value:function getPopupDomNode(){return this.refs.tooltip.getPopupDomNode();}},{key:"getPlacements",value:function getPlacements(){var _props=this.props,builtinPlacements=_props.builtinPlacements,arrowPointAtCenter=_props.arrowPointAtCenter;return builtinPlacements||(0,_placements2.default)({arrowPointAtCenter:arrowPointAtCenter,verticalArrowShift:8});}// 动态设置动画点
},{key:"render",value:function render(){var _props2=this.props,prefixCls=_props2.prefixCls,title=_props2.title,overlay=_props2.overlay,children=_props2.children;// Hide tooltip when there is no title
var visible=this.state.visible;if(!title&&!overlay){visible=false;}if("visible"in this.props){visible=this.props.visible;}var openClassName=this.props.openClassName||prefixCls+"-open";var childrenCls=children&&children.props&&children.props.className?children.props.className+" "+openClassName:openClassName;return _react2.default.createElement(_index2.default,(0,_extends3.default)({overlay:title,visible:visible,onPopupAlign:this.onPopupAlign,ref:"tooltip"},this.props,{builtinPlacements:this.getPlacements(),onVisibleChange:this.onVisibleChange}),visible?(0,_react.cloneElement)(children,{className:childrenCls}):children);}}]);return Tooltip;}(_react2.default.Component),_class.defaultProps={prefixCls:"ant-tooltip",placement:"top",transitionName:"zoom-big",mouseEnterDelay:0.1,mouseLeaveDelay:0.1,onVisibleChange:function onVisibleChange(){},arrowPointAtCenter:false},_temp);exports.default=Tooltip;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(510);__webpack_require__(37);

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(26),
    isKey = __webpack_require__(134),
    stringToPath = __webpack_require__(600),
    toString = __webpack_require__(114);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _src=__webpack_require__(467);var _src2=_interopRequireDefault(_src);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_src2.default;// export this package's api

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * GregorianCalendar class
 * @ignore
 * @author yiminghe@gmail.com
 */


var toInt = parseInt;
var Utils = __webpack_require__(505);
var defaultLocale = __webpack_require__(261);
var Const = __webpack_require__(199);

/*
 * GregorianCalendar class.
 *
 * - no arguments:
 *   Constructs a default GregorianCalendar using the current time
 *   in the default time zone with the default locale.
 * - one argument locale:
 *   Constructs a GregorianCalendar
 *   based on the current time in the default time zone with the given locale.
 *
 * @class Date.Gregorian
 */
function GregorianCalendar(loc) {
  var locale = loc || defaultLocale;

  this.locale = locale;

  this.fields = [];

  /*
   * The currently set time for this date.
   * @protected
   * @type Number|undefined
   */
  this.time = undefined;
  /*
   * The timezoneOffset in minutes used by this date.
   * @type Number
   * @protected
   */

  this.timezoneOffset = locale.timezoneOffset;

  /*
   * The first day of the week
   * @type Number
   * @protected
   */
  this.firstDayOfWeek = locale.firstDayOfWeek;

  /*
   * The number of days required for the first week in a month or year,
   * with possible values from 1 to 7.
   * @@protected
   * @type Number
   */
  this.minimalDaysInFirstWeek = locale.minimalDaysInFirstWeek;

  this.fieldsComputed = false;
}

Utils.mix(GregorianCalendar, Const);

Utils.mix(GregorianCalendar, {
  Utils: Utils,

  defaultLocale: defaultLocale,

  /*
   * Determines if the given year is a leap year.
   * Returns true if the given year is a leap year. To specify BC year numbers,
   * 1 - year number must be given. For example, year BC 4 is specified as -3.
   * @param {Number} year the given year.
   * @returns {Boolean} true if the given year is a leap year; false otherwise.
   * @static
   * @method
   */
  isLeapYear: Utils.isLeapYear,

  /*
   * Enum indicating year field of date
   * @type Number
   */
  YEAR: 1,
  /*
   * Enum indicating month field of date
   * @type Number
   */
  MONTH: 2,
  /*
   * Enum indicating the day of the month
   * @type Number
   */
  DAY_OF_MONTH: 3,
  /*
   * Enum indicating the hour (24).
   * @type Number
   */
  HOUR_OF_DAY: 4,
  /*
   * Enum indicating the minute of the day
   * @type Number
   */
  MINUTES: 5,
  /*
   * Enum indicating the second of the day
   * @type Number
   */
  SECONDS: 6,
  /*
   * Enum indicating the millisecond of the day
   * @type Number
   */
  MILLISECONDS: 7,
  /*
   * Enum indicating the week number within the current year
   * @type Number
   */
  WEEK_OF_YEAR: 8,
  /*
   * Enum indicating the week number within the current month
   * @type Number
   */
  WEEK_OF_MONTH: 9,

  /*
   * Enum indicating the day of the day number within the current year
   * @type Number
   */
  DAY_OF_YEAR: 10,
  /*
   * Enum indicating the day of the week
   * @type Number
   */
  DAY_OF_WEEK: 11,
  /*
   * Enum indicating the day of the ordinal number of the day of the week
   * @type Number
   */
  DAY_OF_WEEK_IN_MONTH: 12,

  /*
   * Enum indicating am
   * @type Number
   */
  AM: 0,
  /*
   * Enum indicating pm
   * @type Number
   */
  PM: 1
});

var FIELDS = ['', 'Year', 'Month', 'DayOfMonth', 'HourOfDay', 'Minutes', 'Seconds', 'Milliseconds', 'WeekOfYear', 'WeekOfMonth', 'DayOfYear', 'DayOfWeek', 'DayOfWeekInMonth'];

var YEAR = GregorianCalendar.YEAR;
var MONTH = GregorianCalendar.MONTH;
var DAY_OF_MONTH = GregorianCalendar.DAY_OF_MONTH;
var HOUR_OF_DAY = GregorianCalendar.HOUR_OF_DAY;
var MINUTE = GregorianCalendar.MINUTES;
var SECONDS = GregorianCalendar.SECONDS;

var MILLISECONDS = GregorianCalendar.MILLISECONDS;
var DAY_OF_WEEK_IN_MONTH = GregorianCalendar.DAY_OF_WEEK_IN_MONTH;
var DAY_OF_YEAR = GregorianCalendar.DAY_OF_YEAR;
var DAY_OF_WEEK = GregorianCalendar.DAY_OF_WEEK;

var WEEK_OF_MONTH = GregorianCalendar.WEEK_OF_MONTH;
var WEEK_OF_YEAR = GregorianCalendar.WEEK_OF_YEAR;

var MONTH_LENGTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 0-based
var LEAP_MONTH_LENGTH = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 0-based

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_WEEK = ONE_DAY * 7;

var EPOCH_OFFSET = 719163; // Fixed date of January 1, 1970 (Gregorian)

var mod = Utils.mod;
var _isLeapYear = Utils.isLeapYear;
var floorDivide = Math.floor;

var MIN_VALUES = [undefined, 1, // YEAR
GregorianCalendar.JANUARY, // MONTH
1, // DAY_OF_MONTH
0, // HOUR_OF_DAY
0, // MINUTE
0, // SECONDS
0, // MILLISECONDS

1, // WEEK_OF_YEAR
undefined, // WEEK_OF_MONTH

1, // DAY_OF_YEAR
GregorianCalendar.SUNDAY, // DAY_OF_WEEK
1];

// DAY_OF_WEEK_IN_MONTH
var MAX_VALUES = [undefined, 292278994, // YEAR
GregorianCalendar.DECEMBER, // MONTH
undefined, // DAY_OF_MONTH
23, // HOUR_OF_DAY
59, // MINUTE
59, // SECONDS
999, // MILLISECONDS
undefined, // WEEK_OF_YEAR
undefined, // WEEK_OF_MONTH
undefined, // DAY_OF_YEAR
GregorianCalendar.SATURDAY, // DAY_OF_WEEK
undefined];

// ------------------- private start

// DAY_OF_WEEK_IN_MONTH
function getMonthLength(year, month) {
  return _isLeapYear(year) ? LEAP_MONTH_LENGTH[month] : MONTH_LENGTH[month];
}

function getYearLength(year) {
  return _isLeapYear(year) ? 366 : 365;
}

function adjustDayOfMonth(self) {
  var fields = self.fields;
  var year = fields[YEAR];
  var month = fields[MONTH];
  var monthLen = getMonthLength(year, month);
  var dayOfMonth = fields[DAY_OF_MONTH];
  if (dayOfMonth > monthLen) {
    self.set(DAY_OF_MONTH, monthLen);
  }
}

function getDayOfWeekDateOnOrBefore(fixedDate, dayOfWeek) {
  // 1.1.1 is monday
  // one week has 7 days
  return fixedDate - mod(fixedDate - dayOfWeek, 7);
}

function getWeekNumber(self, fixedDay1, fixedDate) {
  var fixedDay1st = getDayOfWeekDateOnOrBefore(fixedDay1 + 6, self.firstDayOfWeek);
  var nDays = fixedDay1st - fixedDay1;
  if (nDays >= self.minimalDaysInFirstWeek) {
    fixedDay1st -= 7;
  }
  var normalizedDayOfPeriod = fixedDate - fixedDay1st;
  return floorDivide(normalizedDayOfPeriod / 7) + 1;
}

// ------------------- private end

GregorianCalendar.prototype = {
  constructor: GregorianCalendar,

  isGregorianCalendar: 1,

  /*
   * Determines if current year is a leap year.
   * Returns true if the given year is a leap year. To specify BC year numbers,
   * 1 - year number must be given. For example, year BC 4 is specified as -3.
   * @returns {Boolean} true if the given year is a leap year; false otherwise.
   * @method
   * @member Date.Gregorian
   */
  isLeapYear: function isLeapYear() {
    return _isLeapYear(this.getYear());
  },

  /*
   * Return local info for current date instance
   * @returns {Object}
   */
  getLocale: function getLocale() {
    return this.locale;
  },

  /*
   * Returns the minimum value for
   * the given calendar field of this GregorianCalendar instance.
   * The minimum value is defined as the smallest value
   * returned by the get method for any possible time value,
   * taking into consideration the current values of the getFirstDayOfWeek,
   * getMinimalDaysInFirstWeek.
   * @param field the calendar field.
   * @returns {Number} the minimum value for the given calendar field.
   */
  getActualMinimum: function getActualMinimum(field) {
    if (MIN_VALUES[field] !== undefined) {
      return MIN_VALUES[field];
    }
    if (field === WEEK_OF_MONTH) {
      var cal = this.clone();
      cal.clear();
      cal.set(this.fields[YEAR], this.fields[MONTH], 1);
      return cal.get(WEEK_OF_MONTH);
    }

    throw new Error('minimum value not defined!');
  },

  /*
   * Returns the maximum value for the given calendar field
   * of this GregorianCalendar instance.
   * The maximum value is defined as the largest value returned
   * by the get method for any possible time value, taking into consideration
   * the current values of the getFirstDayOfWeek, getMinimalDaysInFirstWeek methods.
   * @param field the calendar field.
   * @returns {Number} the maximum value for the given calendar field.
   */
  getActualMaximum: function getActualMaximum(field) {
    if (MAX_VALUES[field] !== undefined) {
      return MAX_VALUES[field];
    }
    var value = undefined;
    var fields = this.fields;
    switch (field) {
      case DAY_OF_MONTH:
        value = getMonthLength(fields[YEAR], fields[MONTH]);
        break;

      case WEEK_OF_YEAR:
        var endOfYear = this.clone();
        endOfYear.clear();
        endOfYear.set(fields[YEAR], GregorianCalendar.DECEMBER, 31);
        value = endOfYear.get(WEEK_OF_YEAR);
        if (value === 1) {
          value = 52;
        }
        break;

      case WEEK_OF_MONTH:
        var endOfMonth = this.clone();
        endOfMonth.clear();
        endOfMonth.set(fields[YEAR], fields[MONTH], getMonthLength(fields[YEAR], fields[MONTH]));
        value = endOfMonth.get(WEEK_OF_MONTH);
        break;

      case DAY_OF_YEAR:
        value = getYearLength(fields[YEAR]);
        break;

      case DAY_OF_WEEK_IN_MONTH:
        value = toInt((getMonthLength(fields[YEAR], fields[MONTH]) - 1) / 7) + 1;
        break;
      default:
        break;
    }
    if (value === undefined) {
      throw new Error('maximum value not defined!');
    }
    return value;
  },

  /*
   * Determines if the given calendar field has a value set,
   * including cases that the value has been set by internal fields calculations
   * triggered by a get method call.
   * @param field the calendar field to be cleared.
   * @returns {boolean} true if the given calendar field has a value set; false otherwise.
   */
  isSet: function isSet(field) {
    return this.fields[field] !== undefined;
  },

  /*
   * Converts the time value (millisecond offset from the Epoch)
   * to calendar field values.
   * @protected
   */
  computeFields: function computeFields() {
    var time = this.time;
    var timezoneOffset = this.timezoneOffset * ONE_MINUTE;
    var fixedDate = toInt(timezoneOffset / ONE_DAY);
    var timeOfDay = timezoneOffset % ONE_DAY;
    fixedDate += toInt(time / ONE_DAY);
    timeOfDay += time % ONE_DAY;
    if (timeOfDay >= ONE_DAY) {
      timeOfDay -= ONE_DAY;
      fixedDate++;
    } else {
      while (timeOfDay < 0) {
        timeOfDay += ONE_DAY;
        fixedDate--;
      }
    }

    fixedDate += EPOCH_OFFSET;

    var date = Utils.getGregorianDateFromFixedDate(fixedDate);

    var year = date.year;

    var fields = this.fields;
    fields[YEAR] = year;
    fields[MONTH] = date.month;
    fields[DAY_OF_MONTH] = date.dayOfMonth;
    fields[DAY_OF_WEEK] = date.dayOfWeek;

    if (timeOfDay !== 0) {
      fields[HOUR_OF_DAY] = toInt(timeOfDay / ONE_HOUR);
      var r = timeOfDay % ONE_HOUR;
      fields[MINUTE] = toInt(r / ONE_MINUTE);
      r %= ONE_MINUTE;
      fields[SECONDS] = toInt(r / ONE_SECOND);
      fields[MILLISECONDS] = r % ONE_SECOND;
    } else {
      fields[HOUR_OF_DAY] = fields[MINUTE] = fields[SECONDS] = fields[MILLISECONDS] = 0;
    }

    var fixedDateJan1 = Utils.getFixedDate(year, GregorianCalendar.JANUARY, 1);
    var dayOfYear = fixedDate - fixedDateJan1 + 1;
    var fixDateMonth1 = fixedDate - date.dayOfMonth + 1;

    fields[DAY_OF_YEAR] = dayOfYear;
    fields[DAY_OF_WEEK_IN_MONTH] = toInt((date.dayOfMonth - 1) / 7) + 1;

    var weekOfYear = getWeekNumber(this, fixedDateJan1, fixedDate);

    // 本周没有足够的时间在当前年
    if (weekOfYear === 0) {
      // If the date belongs to the last week of the
      // previous year, use the week number of "12/31" of
      // the "previous" year.
      var fixedDec31 = fixedDateJan1 - 1;
      var prevJan1 = fixedDateJan1 - getYearLength(year - 1);
      weekOfYear = getWeekNumber(this, prevJan1, fixedDec31);
    } else
      // 本周是年末最后一周，可能有足够的时间在新的一年
      if (weekOfYear >= 52) {
        var nextJan1 = fixedDateJan1 + getYearLength(year);
        var nextJan1st = getDayOfWeekDateOnOrBefore(nextJan1 + 6, this.firstDayOfWeek);
        var nDays = nextJan1st - nextJan1;
        // 本周有足够天数在新的一年
        if (nDays >= this.minimalDaysInFirstWeek &&
        // 当天确实在本周，weekOfYear === 53 时是不需要这个判断
        fixedDate >= nextJan1st - 7) {
          weekOfYear = 1;
        }
      }

    fields[WEEK_OF_YEAR] = weekOfYear;
    fields[WEEK_OF_MONTH] = getWeekNumber(this, fixDateMonth1, fixedDate);

    this.fieldsComputed = true;
  },

  /*
   * Converts calendar field values to the time value
   * (millisecond offset from the Epoch).
   * @protected
   */
  computeTime: function computeTime() {
    var year = undefined;
    var fields = this.fields;
    if (this.isSet(YEAR)) {
      year = fields[YEAR];
    } else {
      year = new Date().getFullYear();
    }
    var timeOfDay = 0;
    if (this.isSet(HOUR_OF_DAY)) {
      timeOfDay += fields[HOUR_OF_DAY];
    }
    timeOfDay *= 60;
    timeOfDay += fields[MINUTE] || 0;
    timeOfDay *= 60;
    timeOfDay += fields[SECONDS] || 0;
    timeOfDay *= 1000;
    timeOfDay += fields[MILLISECONDS] || 0;
    var fixedDate = 0;
    fields[YEAR] = year;
    fixedDate = fixedDate + this.getFixedDate();
    // millis represents local wall-clock time in milliseconds.
    var millis = (fixedDate - EPOCH_OFFSET) * ONE_DAY + timeOfDay;
    millis -= this.timezoneOffset * ONE_MINUTE;
    this.time = millis;
    this.computeFields();
  },

  /*
   * Fills in any unset fields in the calendar fields. First,
   * the computeTime() method is called if the time value (millisecond offset from the Epoch)
   * has not been calculated from calendar field values.
   * Then, the computeFields() method is called to calculate all calendar field values.
   * @protected
   */
  complete: function complete() {
    if (this.time === undefined) {
      this.computeTime();
    }
    if (!this.fieldsComputed) {
      this.computeFields();
    }
  },

  getFixedDate: function getFixedDate() {
    var self = this;

    var fields = self.fields;

    var firstDayOfWeekCfg = self.firstDayOfWeek;

    var year = fields[YEAR];

    var month = GregorianCalendar.JANUARY;

    if (self.isSet(MONTH)) {
      month = fields[MONTH];
      if (month > GregorianCalendar.DECEMBER) {
        year += toInt(month / 12);
        month %= 12;
      } else if (month < GregorianCalendar.JANUARY) {
        year += floorDivide(month / 12);
        month = mod(month, 12);
      }
    }

    // Get the fixed date since Jan 1, 1 (Gregorian). We are on
    // the first day of either `month' or January in 'year'.
    var fixedDate = Utils.getFixedDate(year, month, 1);
    var firstDayOfWeek = undefined;
    var dayOfWeek = self.firstDayOfWeek;

    if (self.isSet(DAY_OF_WEEK)) {
      dayOfWeek = fields[DAY_OF_WEEK];
    }

    if (self.isSet(MONTH)) {
      if (self.isSet(DAY_OF_MONTH)) {
        fixedDate += fields[DAY_OF_MONTH] - 1;
      } else {
        if (self.isSet(WEEK_OF_MONTH)) {
          firstDayOfWeek = getDayOfWeekDateOnOrBefore(fixedDate + 6, firstDayOfWeekCfg);

          // If we have enough days in the first week, then
          // move to the previous week.
          if (firstDayOfWeek - fixedDate >= self.minimalDaysInFirstWeek) {
            firstDayOfWeek -= 7;
          }

          if (dayOfWeek !== firstDayOfWeekCfg) {
            firstDayOfWeek = getDayOfWeekDateOnOrBefore(firstDayOfWeek + 6, dayOfWeek);
          }

          fixedDate = firstDayOfWeek + 7 * (fields[WEEK_OF_MONTH] - 1);
        } else {
          var dowim = undefined;
          if (self.isSet(DAY_OF_WEEK_IN_MONTH)) {
            dowim = fields[DAY_OF_WEEK_IN_MONTH];
          } else {
            dowim = 1;
          }
          var lastDate = 7 * dowim;
          if (dowim < 0) {
            lastDate = getMonthLength(year, month) + 7 * (dowim + 1);
          }
          fixedDate = getDayOfWeekDateOnOrBefore(fixedDate + lastDate - 1, dayOfWeek);
        }
      }
    } else {
      // We are on the first day of the year.
      if (self.isSet(DAY_OF_YEAR)) {
        fixedDate += fields[DAY_OF_YEAR] - 1;
      } else if (self.isSet(WEEK_OF_YEAR)) {
        firstDayOfWeek = getDayOfWeekDateOnOrBefore(fixedDate + 6, firstDayOfWeekCfg);
        // If we have enough days in the first week, then move
        // to the previous week.
        if (firstDayOfWeek - fixedDate >= self.minimalDaysInFirstWeek) {
          firstDayOfWeek -= 7;
        }
        if (dayOfWeek !== firstDayOfWeekCfg) {
          firstDayOfWeek = getDayOfWeekDateOnOrBefore(firstDayOfWeek + 6, dayOfWeek);
        }
        fixedDate = firstDayOfWeek + 7 * (fields[WEEK_OF_YEAR] - 1);
      }
    }

    return fixedDate;
  },

  /*
   * Returns this Calendar's time value in milliseconds
   * @member Date.Gregorian
   * @returns {Number} the current time as UTC milliseconds from the epoch.
   */
  getTime: function getTime() {
    if (this.time === undefined) {
      this.computeTime();
    }
    return this.time;
  },

  /*
   * Sets this Calendar's current time from the given long value.
   * @param time the new time in UTC milliseconds from the epoch.
   */
  setTime: function setTime(time) {
    this.time = time;
    this.fieldsComputed = false;
    this.complete();
  },

  /*
   * Returns the value of the given calendar field.
   * @param field the given calendar field.
   * @returns {Number} the value for the given calendar field.
   */
  get: function get(field) {
    this.complete();
    return this.fields[field];
  },

  /*
   * Returns the year of the given calendar field.
   * @method getYear
   * @returns {Number} the year for the given calendar field.
   */

  /*
   * Returns the month of the given calendar field.
   * @method getMonth
   * @returns {Number} the month for the given calendar field.
   */

  /*
   * Returns the day of month of the given calendar field.
   * @method getDayOfMonth
   * @returns {Number} the day of month for the given calendar field.
   */

  /*
   * Returns the hour of day of the given calendar field.
   * @method getHourOfDay
   * @returns {Number} the hour of day for the given calendar field.
   */

  /*
   * Returns the minute of the given calendar field.
   * @method getMinute
   * @returns {Number} the minute for the given calendar field.
   */

  /*
   * Returns the second of the given calendar field.
   * @method getSecond
   * @returns {Number} the second for the given calendar field.
   */

  /*
   * Returns the millisecond of the given calendar field.
   * @method getMilliSecond
   * @returns {Number} the millisecond for the given calendar field.
   */

  /*
   * Returns the week of year of the given calendar field.
   * @method getWeekOfYear
   * @returns {Number} the week of year for the given calendar field.
   */

  /*
   * Returns the week of month of the given calendar field.
   * @method getWeekOfMonth
   * @returns {Number} the week of month for the given calendar field.
   */

  /*
   * Returns the day of year of the given calendar field.
   * @method getDayOfYear
   * @returns {Number} the day of year for the given calendar field.
   */

  /*
   * Returns the day of week of the given calendar field.
   * @method getDayOfWeek
   * @returns {Number} the day of week for the given calendar field.
   */

  /*
   * Returns the day of week in month of the given calendar field.
   * @method getDayOfWeekInMonth
   * @returns {Number} the day of week in month for the given calendar field.
   */

  /*
   * Sets the given calendar field to the given value.
   * @param field the given calendar field.
   * @param v the value to be set for the given calendar field.
   */
  set: function set(field, v) {
    var len = arguments.length;
    if (len === 2) {
      this.fields[field] = v;
    } else if (len < MILLISECONDS + 1) {
      for (var i = 0; i < len; i++) {
        this.fields[YEAR + i] = arguments[i];
      }
    } else {
      throw new Error('illegal arguments for GregorianCalendar set');
    }
    this.time = undefined;
  },

  /*
   * Set the year of the given calendar field.
   * @method setYear
   */

  /*
   * Set the month of the given calendar field.
   * @method setMonth
   */

  /*
   * Set the day of month of the given calendar field.
   * @method setDayOfMonth
   */

  /*
   * Set the hour of day of the given calendar field.
   * @method setHourOfDay
   */

  /*
   * Set the minute of the given calendar field.
   * @method setMinute
   */

  /*
   * Set the second of the given calendar field.
   * @method setSecond
   */

  /*
   * Set the millisecond of the given calendar field.
   * @method setMilliSecond
   */

  /*
   * Set the week of year of the given calendar field.
   * @method setWeekOfYear
   */

  /*
   * Set the week of month of the given calendar field.
   * @method setWeekOfMonth
   */

  /*
   * Set the day of year of the given calendar field.
   * @method setDayOfYear
   */

  /*
   * Set the day of week of the given calendar field.
   * @method setDayOfWeek
   */

  /*
   * Set the day of week in month of the given calendar field.
   * @method setDayOfWeekInMonth
   */

  /*
   * add for specified field based on two rules:
   *
   *  - Add rule 1. The value of field after the call minus the value of field before the
   *  call is amount, modulo any overflow that has occurred in field
   *  Overflow occurs when a field value exceeds its range and,
   *  as a result, the next larger field is incremented or
   *  decremented and the field value is adjusted back into its range.
   *
   *  - Add rule 2. If a smaller field is expected to be invariant,
   *  but it is impossible for it to be equal to its
   *  prior value because of changes in its minimum or maximum after
   *  field is changed, then its value is adjusted to be as close
   *  as possible to its expected value. A smaller field represents a
   *  smaller unit of time. HOUR_OF_DAY is a smaller field than
   *  DAY_OF_MONTH. No adjustment is made to smaller fields
   *  that are not expected to be invariant. The calendar system
   *  determines what fields are expected to be invariant.
   *
   *
   *      @example
   *      use('date/gregorian',function(S, GregorianCalendar){
   *          const d = new GregorianCalendar();
   *          d.set(2012, GregorianCalendar.JANUARY, 31);
   *          d.add(Gregorian.MONTH,1);
   *          // 2012-2-29
   *          document.writeln('<p>'+d.getYear()+'-'+d.getMonth()+'-'+d.getDayOfWeek())
   *          d.add(Gregorian.MONTH,12);
   *          // 2013-2-28
   *          document.writeln('<p>'+d.getYear()+'-'+d.getMonth()+'-'+d.getDayOfWeek())
   *      });
   *
   * @param field the calendar field.
   * @param {Number} amount he amount of date or time to be added to the field.
   */
  add: function add(field, a) {
    if (!a) {
      return;
    }
    var amount = a;
    var self = this;
    var fields = self.fields;
    // computer and retrieve original value
    var value = self.get(field);
    if (field === YEAR) {
      value += amount;
      self.set(YEAR, value);
      adjustDayOfMonth(self);
    } else if (field === MONTH) {
      value += amount;
      var yearAmount = floorDivide(value / 12);
      value = mod(value, 12);
      if (yearAmount) {
        self.set(YEAR, fields[YEAR] + yearAmount);
      }
      self.set(MONTH, value);
      adjustDayOfMonth(self);
    } else {
      switch (field) {
        case HOUR_OF_DAY:
          amount *= ONE_HOUR;
          break;
        case MINUTE:
          amount *= ONE_MINUTE;
          break;
        case SECONDS:
          amount *= ONE_SECOND;
          break;
        case MILLISECONDS:
          break;
        case WEEK_OF_MONTH:
        case WEEK_OF_YEAR:
        case DAY_OF_WEEK_IN_MONTH:
          amount *= ONE_WEEK;
          break;
        case DAY_OF_WEEK:
        case DAY_OF_YEAR:
        case DAY_OF_MONTH:
          amount *= ONE_DAY;
          break;
        default:
          throw new Error('illegal field for add');
      }
      self.setTime(self.time + amount);
    }
  },

  /*
   * add the year of the given calendar field.
   * @method addYear
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * add the month of the given calendar field.
   * @method addMonth
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * add the day of month of the given calendar field.
   * @method addDayOfMonth
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * add the hour of day of the given calendar field.
   * @method addHourOfDay
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * add the minute of the given calendar field.
   * @method addMinute
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * add the second of the given calendar field.
   * @method addSecond
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * add the millisecond of the given calendar field.
   * @method addMilliSecond
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * add the week of year of the given calendar field.
   * @method addWeekOfYear
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * add the week of month of the given calendar field.
   * @method addWeekOfMonth
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * add the day of year of the given calendar field.
   * @method addDayOfYear
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * add the day of week of the given calendar field.
   * @method addDayOfWeek
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * add the day of week in month of the given calendar field.
   * @method addDayOfWeekInMonth
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * Get rolled value for the field
   * @protected
   */
  getRolledValue: function getRolledValue(value, a, min, max) {
    var amount = a;
    var diff = value - min;
    var range = max - min + 1;
    amount %= range;
    return min + (diff + amount + range) % range;
  },

  /*
   * Adds a signed amount to the specified calendar field without changing larger fields.
   * A negative roll amount means to subtract from field without changing
   * larger fields. If the specified amount is 0, this method performs nothing.
   *
   *
   *
   *      @example
   *      const d = new GregorianCalendar();
   *      d.set(1999, GregorianCalendar.AUGUST, 31);
   *      // 1999-4-30
   *      // Tuesday June 1, 1999
   *      d.set(1999, GregorianCalendar.JUNE, 1);
   *      d.add(Gregorian.WEEK_OF_MONTH,-1); // === d.add(Gregorian.WEEK_OF_MONTH,
   *      d.get(Gregorian.WEEK_OF_MONTH));
   *      // 1999-06-29
   *
   *
   * @param field the calendar field.
   * @param {Number} amount the signed amount to add to field.
   */
  roll: function roll(field, amount) {
    if (!amount) {
      return;
    }
    var self = this;
    // computer and retrieve original value
    var value = self.get(field);
    var min = self.getActualMinimum(field);
    var max = self.getActualMaximum(field);
    value = self.getRolledValue(value, amount, min, max);

    self.set(field, value);

    // consider compute time priority
    switch (field) {
      case MONTH:
        adjustDayOfMonth(self);
        break;
      default:
        // other fields are set already when get
        self.updateFieldsBySet(field);
        break;
    }
  },

  /*
   * keep field stable.
   *
   * 2015-09-29 setMonth 2 vs rollSetMonth 2
   *
   */
  rollSet: function rollSet(field, v) {
    this.set(field, v);
    switch (field) {
      case MONTH:
        adjustDayOfMonth(this);
        break;
      default:
        // other fields are set already when get
        this.updateFieldsBySet(field);
        break;
    }
  },

  /*
   * roll the year of the given calendar field.
   * @method rollYear
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * roll the month of the given calendar field.
   * @param {Number} amount the signed amount to add to field.
   * @method rollMonth
   */

  /*
   * roll the day of month of the given calendar field.
   * @method rollDayOfMonth
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * roll the hour of day of the given calendar field.
   * @method rollHourOfDay
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * roll the minute of the given calendar field.
   * @method rollMinute
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * roll the second of the given calendar field.
   * @method rollSecond
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * roll the millisecond of the given calendar field.
   * @method rollMilliSecond
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * roll the week of year of the given calendar field.
   * @method rollWeekOfYear
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * roll the week of month of the given calendar field.
   * @method rollWeekOfMonth
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * roll the day of year of the given calendar field.
   * @method rollDayOfYear
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * roll the day of week of the given calendar field.
   * @method rollDayOfWeek
   * @param {Number} amount the signed amount to add to field.
   */

  /*
   * remove other priority fields when call getFixedDate
   * precondition: other fields are all set or computed
   * @protected
   */
  updateFieldsBySet: function updateFieldsBySet(field) {
    var fields = this.fields;
    switch (field) {
      case WEEK_OF_MONTH:
        fields[DAY_OF_MONTH] = undefined;
        break;
      case DAY_OF_YEAR:
        fields[MONTH] = undefined;
        break;
      case DAY_OF_WEEK:
        fields[DAY_OF_MONTH] = undefined;
        break;
      case WEEK_OF_YEAR:
        fields[DAY_OF_YEAR] = undefined;
        fields[MONTH] = undefined;
        break;
      default:
        break;
    }
  },

  /*
   * get current date instance's timezone offset
   * @returns {Number}
   */
  getTimezoneOffset: function getTimezoneOffset() {
    return this.timezoneOffset;
  },

  /*
   * set current date instance's timezone offset
   */
  setTimezoneOffset: function setTimezoneOffset(timezoneOffset) {
    if (this.timezoneOffset !== timezoneOffset) {
      this.fieldsComputed = undefined;
      this.timezoneOffset = timezoneOffset;
    }
  },

  /*
   * set first day of week for current date instance
   */
  setFirstDayOfWeek: function setFirstDayOfWeek(firstDayOfWeek) {
    if (this.firstDayOfWeek !== firstDayOfWeek) {
      this.firstDayOfWeek = firstDayOfWeek;
      this.fieldsComputed = false;
    }
  },

  /*
   * Gets what the first day of the week is; e.g., SUNDAY in the U.S., MONDAY in France.
   * @returns {Number} the first day of the week.
   */
  getFirstDayOfWeek: function getFirstDayOfWeek() {
    return this.firstDayOfWeek;
  },

  /*
   * Sets what the minimal days required in the first week of the year are; For example,
   * if the first week is defined as one that contains the first day of the first month of a year,
   * call this method with value 1.
   * If it must be a full week, use value 7.
   * @param minimalDaysInFirstWeek the given minimal days required in the first week of the year.
   */
  setMinimalDaysInFirstWeek: function setMinimalDaysInFirstWeek(minimalDaysInFirstWeek) {
    if (this.minimalDaysInFirstWeek !== minimalDaysInFirstWeek) {
      this.minimalDaysInFirstWeek = minimalDaysInFirstWeek;
      this.fieldsComputed = false;
    }
  },

  /*
   * Gets what the minimal days required in the first week of the year are; e.g.,
   * if the first week is defined as one that contains the first day of the first month of a year,
   * this method returns 1.
   * If the minimal days required must be a full week, this method returns 7.
   * @returns {Number} the minimal days required in the first week of the year.
   */
  getMinimalDaysInFirstWeek: function getMinimalDaysInFirstWeek() {
    return this.minimalDaysInFirstWeek;
  },

  /*
   * Returns the number of weeks in the week year
   * represented by this GregorianCalendar.
   *
   * For example, if this GregorianCalendar's date is
   * December 31, 2008 with the ISO
   * 8601 compatible setting, this method will return 53 for the
   * period: December 29, 2008 to January 3, 2010
   * while getActualMaximum(WEEK_OF_YEAR) will return
   * 52 for the period: December 31, 2007 to December 28, 2008.
   *
   * @return {Number} the number of weeks in the week year.
   */
  getWeeksInWeekYear: function getWeeksInWeekYear() {
    var weekYear = this.getWeekYear();
    if (weekYear === this.get(YEAR)) {
      return this.getActualMaximum(WEEK_OF_YEAR);
    }
    // Use the 2nd week for calculating the max of WEEK_OF_YEAR
    var gc = this.clone();
    gc.clear();
    gc.setWeekDate(weekYear, 2, this.get(DAY_OF_WEEK));
    return gc.getActualMaximum(WEEK_OF_YEAR);
  },

  /*
   * Returns the week year represented by this GregorianCalendar.
   * The dates in the weeks between 1 and the
   * maximum week number of the week year have the same week year value
   * that may be one year before or after the calendar year value.
   *
   * @return {Number} the week year represented by this GregorianCalendar.
   */
  getWeekYear: function getWeekYear() {
    var year = this.get(YEAR); // implicitly  complete
    var weekOfYear = this.get(WEEK_OF_YEAR);
    var month = this.get(MONTH);
    if (month === GregorianCalendar.JANUARY) {
      if (weekOfYear >= 52) {
        --year;
      }
    } else if (month === GregorianCalendar.DECEMBER) {
      if (weekOfYear === 1) {
        ++year;
      }
    }
    return year;
  },
  /*
   * Sets this GregorianCalendar to the date given by the date specifiers - weekYear,
   * weekOfYear, and dayOfWeek. weekOfYear follows the WEEK_OF_YEAR numbering.
   * The dayOfWeek value must be one of the DAY_OF_WEEK values: SUNDAY to SATURDAY.
   *
   * @param weekYear    the week year
   * @param weekOfYear  the week number based on weekYear
   * @param dayOfWeek   the day of week value
   */
  setWeekDate: function setWeekDate(weekYear, weekOfYear, dayOfWeek) {
    if (dayOfWeek < GregorianCalendar.SUNDAY || dayOfWeek > GregorianCalendar.SATURDAY) {
      throw new Error('invalid dayOfWeek: ' + dayOfWeek);
    }
    var fields = this.fields;
    // To avoid changing the time of day fields by date
    // calculations, use a clone with the GMT time zone.
    var gc = this.clone();
    gc.clear();
    gc.setTimezoneOffset(0);
    gc.set(YEAR, weekYear);
    gc.set(WEEK_OF_YEAR, 1);
    gc.set(DAY_OF_WEEK, this.getFirstDayOfWeek());
    var days = dayOfWeek - this.getFirstDayOfWeek();
    if (days < 0) {
      days += 7;
    }
    days += 7 * (weekOfYear - 1);
    if (days !== 0) {
      gc.add(DAY_OF_YEAR, days);
    } else {
      gc.complete();
    }
    fields[YEAR] = gc.get(YEAR);
    fields[MONTH] = gc.get(MONTH);
    fields[DAY_OF_MONTH] = gc.get(DAY_OF_MONTH);
    this.complete();
  },
  /*
   * Creates and returns a copy of this object.
   * @returns {Date.Gregorian}
   */
  clone: function clone() {
    if (this.time === undefined) {
      this.computeTime();
    }
    var cal = new GregorianCalendar(this.locale);
    cal.setTimezoneOffset(cal.getTimezoneOffset());
    cal.setFirstDayOfWeek(cal.getFirstDayOfWeek());
    cal.setMinimalDaysInFirstWeek(cal.getMinimalDaysInFirstWeek());
    cal.setTime(this.time);
    return cal;
  },

  /*
   * Compares this GregorianCalendar to the specified Object.
   * The result is true if and only if the argument is a GregorianCalendar object
   * that represents the same time value (millisecond offset from the Epoch)
   * under the same Calendar parameters and Gregorian change date as this object.
   * @param {Date.Gregorian} obj the object to compare with.
   * @returns {boolean} true if this object is equal to obj; false otherwise.
   */
  equals: function equals(obj) {
    return this.getTime() === obj.getTime() && this.firstDayOfWeek === obj.firstDayOfWeek && this.timezoneOffset === obj.timezoneOffset && this.minimalDaysInFirstWeek === obj.minimalDaysInFirstWeek;
  },

  compareToDay: function compareToDay(d2) {
    var d1Year = this.getYear();
    var d2Year = d2.getYear();
    var d1Month = this.getMonth();
    var d2Month = d2.getMonth();
    var d1Day = this.getDayOfMonth();
    var d2Day = d2.getDayOfMonth();
    if (d1Year !== d2Year) {
      return d1Year - d2Year;
    }
    if (d1Month !== d2Month) {
      return d1Month - d2Month;
    }
    return d1Day - d2Day;
  },

  /*
   * Sets all the calendar field values or specified field and the time value
   * (millisecond offset from the Epoch) of this Calendar undefined.
   * This means that isSet() will return false for all the calendar fields,
   * and the date and time calculations will treat the fields as if they had never been set.
   * @param [field] the calendar field to be cleared.
   */
  clear: function clear(field) {
    if (field === undefined) {
      this.field = [];
    } else {
      this.fields[field] = undefined;
    }
    this.time = undefined;
    this.fieldsComputed = false;
  },

  toString: function toString() {
    // for debug
    var v = this;
    return '[GregorianCalendar]: ' + v.getYear() + '/' + v.getMonth() + '/' + v.getDayOfMonth() + ' ' + v.getHourOfDay() + ':' + v.getMinutes() + ':' + v.getSeconds();
  }
};

var GregorianCalendarProto = GregorianCalendar.prototype;

Utils.each(FIELDS, function (f, index) {
  if (f) {
    GregorianCalendarProto['get' + f] = function get() {
      return this.get(index);
    };

    GregorianCalendarProto['isSet' + f] = function isSet() {
      return this.isSet(index);
    };

    GregorianCalendarProto['set' + f] = function set(v) {
      return this.set(index, v);
    };

    GregorianCalendarProto['add' + f] = function add(v) {
      return this.add(index, v);
    };

    GregorianCalendarProto['roll' + f] = function roll(v) {
      return this.roll(index, v);
    };

    GregorianCalendarProto['rollSet' + f] = function rollSet(v) {
      return this.rollSet(index, v);
    };
  }
});

module.exports = GregorianCalendar;
/*
 http://docs.oracle.com/javase/7/docs/api/java/util/GregorianCalendar.html

 TODO
 - day saving time
 - i18n
 - julian calendar
 */

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(284)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(154)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(325),
    baseIsNaN = __webpack_require__(326),
    strictIndexOf = __webpack_require__(327);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(42),
    isArray = __webpack_require__(26),
    isObjectLike = __webpack_require__(35);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = arguments;
  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

module.exports = createChainedFunction;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(189),
    getTag = __webpack_require__(191),
    isArguments = __webpack_require__(86),
    isArray = __webpack_require__(26),
    isArrayLike = __webpack_require__(67),
    isBuffer = __webpack_require__(87),
    isPrototype = __webpack_require__(89),
    isTypedArray = __webpack_require__(88);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(34);
var document = __webpack_require__(20).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(34);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(30);
var dPs = __webpack_require__(286);
var enumBugKeys = __webpack_require__(109);
var IE_PROTO = __webpack_require__(107)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(103)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(159).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(101);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(108)('keys');
var uid = __webpack_require__(74);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(14);
var global = __webpack_require__(20);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(58) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(73);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(24);


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var core = __webpack_require__(14);
var LIBRARY = __webpack_require__(58);
var wksExt = __webpack_require__(111);
var defineProperty = __webpack_require__(31).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(171);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(338), __esModule: true };

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.go=exports.replaceLocation=exports.pushLocation=exports.startListener=exports.getUserConfirmation=exports.getCurrentLocation=undefined;var _LocationUtils=__webpack_require__(43);var _DOMUtils=__webpack_require__(63);var _DOMStateStorage=__webpack_require__(176);var _PathUtils=__webpack_require__(36);var _ExecutionEnvironment=__webpack_require__(81);var PopStateEvent='popstate';var HashChangeEvent='hashchange';var needsHashchangeListener=_ExecutionEnvironment.canUseDOM&&!(0,_DOMUtils.supportsPopstateOnHashchange)();var _createLocation=function _createLocation(historyState){var key=historyState&&historyState.key;return(0,_LocationUtils.createLocation)({pathname:window.location.pathname,search:window.location.search,hash:window.location.hash,state:key?(0,_DOMStateStorage.readState)(key):undefined},undefined,key);};var getCurrentLocation=exports.getCurrentLocation=function getCurrentLocation(){var historyState=void 0;try{historyState=window.history.state||{};}catch(error){// IE 11 sometimes throws when accessing window.history.state
// See https://github.com/ReactTraining/history/pull/289
historyState={};}return _createLocation(historyState);};var getUserConfirmation=exports.getUserConfirmation=function getUserConfirmation(message,callback){return callback(window.confirm(message));};// eslint-disable-line no-alert
var startListener=exports.startListener=function startListener(listener){var handlePopState=function handlePopState(event){if((0,_DOMUtils.isExtraneousPopstateEvent)(event))// Ignore extraneous popstate events in WebKit
return;listener(_createLocation(event.state));};(0,_DOMUtils.addEventListener)(window,PopStateEvent,handlePopState);var handleUnpoppedHashChange=function handleUnpoppedHashChange(){return listener(getCurrentLocation());};if(needsHashchangeListener){(0,_DOMUtils.addEventListener)(window,HashChangeEvent,handleUnpoppedHashChange);}return function(){(0,_DOMUtils.removeEventListener)(window,PopStateEvent,handlePopState);if(needsHashchangeListener){(0,_DOMUtils.removeEventListener)(window,HashChangeEvent,handleUnpoppedHashChange);}};};var updateLocation=function updateLocation(location,updateState){var state=location.state,key=location.key;if(state!==undefined)(0,_DOMStateStorage.saveState)(key,state);updateState({key:key},(0,_PathUtils.createPath)(location));};var pushLocation=exports.pushLocation=function pushLocation(location){return updateLocation(location,function(state,path){return window.history.pushState(state,null,path);});};var replaceLocation=exports.replaceLocation=function replaceLocation(location){return updateLocation(location,function(state,path){return window.history.replaceState(state,null,path);});};var go=exports.go=function go(n){if(n)window.history.go(n);};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toConsumableArray2=__webpack_require__(46);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _AsyncUtils=__webpack_require__(347);var _PathUtils=__webpack_require__(36);var _runTransitionHook=__webpack_require__(118);var _runTransitionHook2=_interopRequireDefault(_runTransitionHook);var _Actions=__webpack_require__(80);var _LocationUtils=__webpack_require__(43);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var createHistory=function createHistory(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var getCurrentLocation=options.getCurrentLocation,getUserConfirmation=options.getUserConfirmation,pushLocation=options.pushLocation,replaceLocation=options.replaceLocation,go=options.go,keyLength=options.keyLength;var currentLocation=void 0;var pendingLocation=void 0;var beforeListeners=[];var listeners=[];var allKeys=[];var getCurrentIndex=function getCurrentIndex(){if(pendingLocation&&pendingLocation.action===_Actions.POP)return allKeys.indexOf(pendingLocation.key);if(currentLocation)return allKeys.indexOf(currentLocation.key);return-1;};var updateLocation=function updateLocation(nextLocation){var currentIndex=getCurrentIndex();currentLocation=nextLocation;if(currentLocation.action===_Actions.PUSH){allKeys=[].concat((0,_toConsumableArray3.default)(allKeys.slice(0,currentIndex+1)),[currentLocation.key]);}else if(currentLocation.action===_Actions.REPLACE){allKeys[currentIndex]=currentLocation.key;}listeners.forEach(function(listener){return listener(currentLocation);});};var listenBefore=function listenBefore(listener){beforeListeners.push(listener);return function(){return beforeListeners=beforeListeners.filter(function(item){return item!==listener;});};};var listen=function listen(listener){listeners.push(listener);return function(){return listeners=listeners.filter(function(item){return item!==listener;});};};var confirmTransitionTo=function confirmTransitionTo(location,callback){(0,_AsyncUtils.loopAsync)(beforeListeners.length,function(index,next,done){(0,_runTransitionHook2.default)(beforeListeners[index],location,function(result){return result!=null?done(result):next();});},function(message){if(getUserConfirmation&&typeof message==='string'){getUserConfirmation(message,function(ok){return callback(ok!==false);});}else{callback(message!==false);}});};var transitionTo=function transitionTo(nextLocation){if(currentLocation&&(0,_LocationUtils.locationsAreEqual)(currentLocation,nextLocation)||pendingLocation&&(0,_LocationUtils.locationsAreEqual)(pendingLocation,nextLocation))return;// Nothing to do
pendingLocation=nextLocation;confirmTransitionTo(nextLocation,function(ok){if(pendingLocation!==nextLocation)return;// Transition was interrupted during confirmation
pendingLocation=null;if(ok){// Treat PUSH to same path like REPLACE to be consistent with browsers
if(nextLocation.action===_Actions.PUSH){var prevPath=(0,_PathUtils.createPath)(currentLocation);var nextPath=(0,_PathUtils.createPath)(nextLocation);if(nextPath===prevPath&&(0,_LocationUtils.statesAreEqual)(currentLocation.state,nextLocation.state))nextLocation.action=_Actions.REPLACE;}if(nextLocation.action===_Actions.POP){updateLocation(nextLocation);}else if(nextLocation.action===_Actions.PUSH){if(pushLocation(nextLocation)!==false)updateLocation(nextLocation);}else if(nextLocation.action===_Actions.REPLACE){if(replaceLocation(nextLocation)!==false)updateLocation(nextLocation);}}else if(currentLocation&&nextLocation.action===_Actions.POP){var prevIndex=allKeys.indexOf(currentLocation.key);var nextIndex=allKeys.indexOf(nextLocation.key);if(prevIndex!==-1&&nextIndex!==-1)go(prevIndex-nextIndex);// Restore the URL
}});};var push=function push(input){return transitionTo(createLocation(input,_Actions.PUSH));};var replace=function replace(input){return transitionTo(createLocation(input,_Actions.REPLACE));};var goBack=function goBack(){return go(-1);};var goForward=function goForward(){return go(1);};var createKey=function createKey(){return Math.random().toString(36).substr(2,keyLength||6);};var createHref=function createHref(location){return(0,_PathUtils.createPath)(location);};var createLocation=function createLocation(location,action){var key=arguments.length>2&&arguments[2]!==undefined?arguments[2]:createKey();return(0,_LocationUtils.createLocation)(location,action,key);};return{getCurrentLocation:getCurrentLocation,listenBefore:listenBefore,listen:listen,transitionTo:transitionTo,push:push,replace:replace,go:go,goBack:goBack,goForward:goForward,createKey:createKey,createPath:_PathUtils.createPath,createHref:createHref,createLocation:createLocation};};exports.default=createHistory;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var runTransitionHook=function runTransitionHook(hook,location,callback){var result=hook(location,callback);if(hook.length<2){// Assume the hook runs synchronously and automatically
// call the callback with the return value.
callback(result);}else{(0,_warning2.default)(result===undefined,'You should not "return" in a transition hook with a callback argument; '+'call the callback instead');}};exports.default=runTransitionHook;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(367);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCssAnimationSupported", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["default"] = (cssAnimation);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(406),
    isObjectLike = __webpack_require__(35);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(82),
    stackClear = __webpack_require__(412),
    stackDelete = __webpack_require__(413),
    stackGet = __webpack_require__(414),
    stackHas = __webpack_require__(415),
    stackSet = __webpack_require__(416);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(42),
    isObject = __webpack_require__(29);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(421),
    mapCacheDelete = __webpack_require__(428),
    mapCacheGet = __webpack_require__(430),
    mapCacheHas = __webpack_require__(431),
    mapCacheSet = __webpack_require__(432);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=getPlacements;var _placements=__webpack_require__(195);var autoAdjustOverflow={adjustX:1,adjustY:1};var targetOffset=[0,0];function getPlacements(){var config=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(!config.arrowPointAtCenter){return _placements.placements;}var _config$arrowWidth=config.arrowWidth,arrowWidth=_config$arrowWidth===undefined?5:_config$arrowWidth,_config$horizontalArr=config.horizontalArrowShift,horizontalArrowShift=_config$horizontalArr===undefined?16:_config$horizontalArr,_config$verticalArrow=config.verticalArrowShift,verticalArrowShift=_config$verticalArrow===undefined?12:_config$verticalArrow;return{left:{points:['cr','cl'],overflow:autoAdjustOverflow,offset:[-4,0],targetOffset:targetOffset},right:{points:['cl','cr'],overflow:autoAdjustOverflow,offset:[4,0],targetOffset:targetOffset},top:{points:['bc','tc'],overflow:autoAdjustOverflow,offset:[0,-4],targetOffset:targetOffset},bottom:{points:['tc','bc'],overflow:autoAdjustOverflow,offset:[0,4],targetOffset:targetOffset},topLeft:{points:['bl','tc'],overflow:autoAdjustOverflow,offset:[-(horizontalArrowShift+arrowWidth),-4],targetOffset:targetOffset},leftTop:{points:['tr','cl'],overflow:autoAdjustOverflow,offset:[-4,-(verticalArrowShift+arrowWidth)],targetOffset:targetOffset},topRight:{points:['br','tc'],overflow:autoAdjustOverflow,offset:[horizontalArrowShift+arrowWidth,-4],targetOffset:targetOffset},rightTop:{points:['tl','cr'],overflow:autoAdjustOverflow,offset:[4,-(verticalArrowShift+arrowWidth)],targetOffset:targetOffset},bottomRight:{points:['tr','bc'],overflow:autoAdjustOverflow,offset:[horizontalArrowShift+arrowWidth,4],targetOffset:targetOffset},rightBottom:{points:['bl','cr'],overflow:autoAdjustOverflow,offset:[4,verticalArrowShift+arrowWidth],targetOffset:targetOffset},bottomLeft:{points:['tl','bc'],overflow:autoAdjustOverflow,offset:[-(horizontalArrowShift+arrowWidth),4],targetOffset:targetOffset},leftBottom:{points:['br','cl'],overflow:autoAdjustOverflow,offset:[-4,verticalArrowShift+arrowWidth],targetOffset:targetOffset}};}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _rcRadio=__webpack_require__(483);var _rcRadio2=_interopRequireDefault(_rcRadio);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _reactAddonsPureRenderMixin=__webpack_require__(38);var _reactAddonsPureRenderMixin2=_interopRequireDefault(_reactAddonsPureRenderMixin);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Radio=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Radio,_React$Component);function Radio(){(0,_classCallCheck3.default)(this,Radio);return(0,_possibleConstructorReturn3.default)(this,(Radio.__proto__||(0,_getPrototypeOf2.default)(Radio)).apply(this,arguments));}(0,_createClass3.default)(Radio,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.apply(this,args);}},{key:"render",value:function render(){var _classNames,_classNames2;var _props=this.props,prefixCls=_props.prefixCls,children=_props.children,checked=_props.checked,disabled=_props.disabled,className=_props.className,ecId=_props.ecId,style=_props.style;var wrapperClassString=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls+"-wrapper",true),(0,_defineProperty3.default)(_classNames,prefixCls+"-wrapper-checked",checked),(0,_defineProperty3.default)(_classNames,prefixCls+"-wrapper-disabled",disabled),(0,_defineProperty3.default)(_classNames,className,!!className),_classNames));var classString=(0,_classnames2.default)((_classNames2={},(0,_defineProperty3.default)(_classNames2,""+prefixCls,true),(0,_defineProperty3.default)(_classNames2,prefixCls+"-checked",checked),(0,_defineProperty3.default)(_classNames2,prefixCls+"-disabled",disabled),_classNames2));return _react2.default.createElement("label",{className:wrapperClassString,style:style,ecId:ecId+"_label@xzp9st"},_react2.default.createElement(_rcRadio2.default,(0,_extends3.default)({},this.props,{className:classString,style:null,children:null})),children?_react2.default.createElement("span",null,children):null);}}]);return Radio;}(_react2.default.Component),_class.displayName="Radio",_class.defaultProps={prefixCls:"ant-radio"},_temp);exports.default=Radio;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(512);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Col=exports.Row=undefined;var _row=__webpack_require__(549);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(550);var _col2=_interopRequireDefault(_col);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.Row=_row2.default;exports.Col=_col2.default;

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(93),
    toKey = __webpack_require__(54);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(26),
    isSymbol = __webpack_require__(79);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(218);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _cssAnimation=__webpack_require__(120);var _cssAnimation2=_interopRequireDefault(_cssAnimation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function animate(node,show,done){var height=void 0;return(0,_cssAnimation2.default)(node,'ant-motion-collapse',{start:function start(){if(!show){node.style.height=node.offsetHeight+'px';}else{height=node.offsetHeight;node.style.height=0;}},active:function active(){node.style.height=(show?height:0)+'px';},end:function end(){node.style.height='';done();}});}var animation={enter:function enter(node,done){return animate(node,true,done);},leave:function leave(node,done){return animate(node,false,done);},appear:function appear(node,done){return animate(node,true,done);}};exports.default=animation;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

module.exports = function toArray(children) {
  var ret = [];
  React.Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * GregorianCalendar class
 * @ignore
 * @author yiminghe@gmail.com
 */var toInt=parseInt;var Utils=__webpack_require__(402);var defaultLocale=__webpack_require__(403);var Const=__webpack_require__(182);/*
 * GregorianCalendar class.
 *
 * - no arguments:
 *   Constructs a default GregorianCalendar using the current time
 *   in the default time zone with the default locale.
 * - one argument locale:
 *   Constructs a GregorianCalendar
 *   based on the current time in the default time zone with the given locale.
 *
 * @class Date.Gregorian
 */function GregorianCalendar(loc){var locale=loc||defaultLocale;this.locale=locale;this.fields=[];/*
   * The currently set time for this date.
   * @protected
   * @type Number|undefined
   */this.time=undefined;/*
   * The timezoneOffset in minutes used by this date.
   * @type Number
   * @protected
   */this.timezoneOffset=locale.timezoneOffset;/*
   * The first day of the week
   * @type Number
   * @protected
   */this.firstDayOfWeek=locale.firstDayOfWeek;/*
   * The number of days required for the first week in a month or year,
   * with possible values from 1 to 7.
   * @@protected
   * @type Number
   */this.minimalDaysInFirstWeek=locale.minimalDaysInFirstWeek;this.fieldsComputed=false;}Utils.mix(GregorianCalendar,Const);Utils.mix(GregorianCalendar,{Utils:Utils,defaultLocale:defaultLocale,/*
   * Determines if the given year is a leap year.
   * Returns true if the given year is a leap year. To specify BC year numbers,
   * 1 - year number must be given. For example, year BC 4 is specified as -3.
   * @param {Number} year the given year.
   * @returns {Boolean} true if the given year is a leap year; false otherwise.
   * @static
   * @method
   */isLeapYear:Utils.isLeapYear,/*
   * Enum indicating year field of date
   * @type Number
   */YEAR:1,/*
   * Enum indicating month field of date
   * @type Number
   */MONTH:2,/*
   * Enum indicating the day of the month
   * @type Number
   */DAY_OF_MONTH:3,/*
   * Enum indicating the hour (24).
   * @type Number
   */HOUR_OF_DAY:4,/*
   * Enum indicating the minute of the day
   * @type Number
   */MINUTES:5,/*
   * Enum indicating the second of the day
   * @type Number
   */SECONDS:6,/*
   * Enum indicating the millisecond of the day
   * @type Number
   */MILLISECONDS:7,/*
   * Enum indicating the week number within the current year
   * @type Number
   */WEEK_OF_YEAR:8,/*
   * Enum indicating the week number within the current month
   * @type Number
   */WEEK_OF_MONTH:9,/*
   * Enum indicating the day of the day number within the current year
   * @type Number
   */DAY_OF_YEAR:10,/*
   * Enum indicating the day of the week
   * @type Number
   */DAY_OF_WEEK:11,/*
   * Enum indicating the day of the ordinal number of the day of the week
   * @type Number
   */DAY_OF_WEEK_IN_MONTH:12,/*
   * Enum indicating am
   * @type Number
   */AM:0,/*
   * Enum indicating pm
   * @type Number
   */PM:1});var FIELDS=['','Year','Month','DayOfMonth','HourOfDay','Minutes','Seconds','Milliseconds','WeekOfYear','WeekOfMonth','DayOfYear','DayOfWeek','DayOfWeekInMonth'];var YEAR=GregorianCalendar.YEAR;var MONTH=GregorianCalendar.MONTH;var DAY_OF_MONTH=GregorianCalendar.DAY_OF_MONTH;var HOUR_OF_DAY=GregorianCalendar.HOUR_OF_DAY;var MINUTE=GregorianCalendar.MINUTES;var SECONDS=GregorianCalendar.SECONDS;var MILLISECONDS=GregorianCalendar.MILLISECONDS;var DAY_OF_WEEK_IN_MONTH=GregorianCalendar.DAY_OF_WEEK_IN_MONTH;var DAY_OF_YEAR=GregorianCalendar.DAY_OF_YEAR;var DAY_OF_WEEK=GregorianCalendar.DAY_OF_WEEK;var WEEK_OF_MONTH=GregorianCalendar.WEEK_OF_MONTH;var WEEK_OF_YEAR=GregorianCalendar.WEEK_OF_YEAR;var MONTH_LENGTH=[31,28,31,30,31,30,31,31,30,31,30,31];// 0-based
var LEAP_MONTH_LENGTH=[31,29,31,30,31,30,31,31,30,31,30,31];// 0-based
var ONE_SECOND=1000;var ONE_MINUTE=60*ONE_SECOND;var ONE_HOUR=60*ONE_MINUTE;var ONE_DAY=24*ONE_HOUR;var ONE_WEEK=ONE_DAY*7;var EPOCH_OFFSET=719163;// Fixed date of January 1, 1970 (Gregorian)
var mod=Utils.mod;var _isLeapYear=Utils.isLeapYear;var floorDivide=Math.floor;var MIN_VALUES=[undefined,1,// YEAR
GregorianCalendar.JANUARY,// MONTH
1,// DAY_OF_MONTH
0,// HOUR_OF_DAY
0,// MINUTE
0,// SECONDS
0,// MILLISECONDS
1,// WEEK_OF_YEAR
undefined,// WEEK_OF_MONTH
1,// DAY_OF_YEAR
GregorianCalendar.SUNDAY,// DAY_OF_WEEK
1];// DAY_OF_WEEK_IN_MONTH
var MAX_VALUES=[undefined,292278994,// YEAR
GregorianCalendar.DECEMBER,// MONTH
undefined,// DAY_OF_MONTH
23,// HOUR_OF_DAY
59,// MINUTE
59,// SECONDS
999,// MILLISECONDS
undefined,// WEEK_OF_YEAR
undefined,// WEEK_OF_MONTH
undefined,// DAY_OF_YEAR
GregorianCalendar.SATURDAY,// DAY_OF_WEEK
undefined];// ------------------- private start
// DAY_OF_WEEK_IN_MONTH
function getMonthLength(year,month){return _isLeapYear(year)?LEAP_MONTH_LENGTH[month]:MONTH_LENGTH[month];}function getYearLength(year){return _isLeapYear(year)?366:365;}function adjustDayOfMonth(self){var fields=self.fields;var year=fields[YEAR];var month=fields[MONTH];var monthLen=getMonthLength(year,month);var dayOfMonth=fields[DAY_OF_MONTH];if(dayOfMonth>monthLen){self.set(DAY_OF_MONTH,monthLen);}}function getDayOfWeekDateOnOrBefore(fixedDate,dayOfWeek){// 1.1.1 is monday
// one week has 7 days
return fixedDate-mod(fixedDate-dayOfWeek,7);}function getWeekNumber(self,fixedDay1,fixedDate){var fixedDay1st=getDayOfWeekDateOnOrBefore(fixedDay1+6,self.firstDayOfWeek);var nDays=fixedDay1st-fixedDay1;if(nDays>=self.minimalDaysInFirstWeek){fixedDay1st-=7;}var normalizedDayOfPeriod=fixedDate-fixedDay1st;return floorDivide(normalizedDayOfPeriod/7)+1;}// ------------------- private end
GregorianCalendar.prototype={constructor:GregorianCalendar,isGregorianCalendar:1,/*
   * Determines if current year is a leap year.
   * Returns true if the given year is a leap year. To specify BC year numbers,
   * 1 - year number must be given. For example, year BC 4 is specified as -3.
   * @returns {Boolean} true if the given year is a leap year; false otherwise.
   * @method
   * @member Date.Gregorian
   */isLeapYear:function isLeapYear(){return _isLeapYear(this.getYear());},/*
   * Return local info for current date instance
   * @returns {Object}
   */getLocale:function getLocale(){return this.locale;},/*
   * Returns the minimum value for
   * the given calendar field of this GregorianCalendar instance.
   * The minimum value is defined as the smallest value
   * returned by the get method for any possible time value,
   * taking into consideration the current values of the getFirstDayOfWeek,
   * getMinimalDaysInFirstWeek.
   * @param field the calendar field.
   * @returns {Number} the minimum value for the given calendar field.
   */getActualMinimum:function getActualMinimum(field){if(MIN_VALUES[field]!==undefined){return MIN_VALUES[field];}if(field===WEEK_OF_MONTH){var cal=this.clone();cal.clear();cal.set(this.fields[YEAR],this.fields[MONTH],1);return cal.get(WEEK_OF_MONTH);}throw new Error('minimum value not defined!');},/*
   * Returns the maximum value for the given calendar field
   * of this GregorianCalendar instance.
   * The maximum value is defined as the largest value returned
   * by the get method for any possible time value, taking into consideration
   * the current values of the getFirstDayOfWeek, getMinimalDaysInFirstWeek methods.
   * @param field the calendar field.
   * @returns {Number} the maximum value for the given calendar field.
   */getActualMaximum:function getActualMaximum(field){if(MAX_VALUES[field]!==undefined){return MAX_VALUES[field];}var value=undefined;var fields=this.fields;switch(field){case DAY_OF_MONTH:value=getMonthLength(fields[YEAR],fields[MONTH]);break;case WEEK_OF_YEAR:var endOfYear=this.clone();endOfYear.clear();endOfYear.set(fields[YEAR],GregorianCalendar.DECEMBER,31);value=endOfYear.get(WEEK_OF_YEAR);if(value===1){value=52;}break;case WEEK_OF_MONTH:var endOfMonth=this.clone();endOfMonth.clear();endOfMonth.set(fields[YEAR],fields[MONTH],getMonthLength(fields[YEAR],fields[MONTH]));value=endOfMonth.get(WEEK_OF_MONTH);break;case DAY_OF_YEAR:value=getYearLength(fields[YEAR]);break;case DAY_OF_WEEK_IN_MONTH:value=toInt((getMonthLength(fields[YEAR],fields[MONTH])-1)/7)+1;break;default:break;}if(value===undefined){throw new Error('maximum value not defined!');}return value;},/*
   * Determines if the given calendar field has a value set,
   * including cases that the value has been set by internal fields calculations
   * triggered by a get method call.
   * @param field the calendar field to be cleared.
   * @returns {boolean} true if the given calendar field has a value set; false otherwise.
   */isSet:function isSet(field){return this.fields[field]!==undefined;},/*
   * Converts the time value (millisecond offset from the Epoch)
   * to calendar field values.
   * @protected
   */computeFields:function computeFields(){var time=this.time;var timezoneOffset=this.timezoneOffset*ONE_MINUTE;var fixedDate=toInt(timezoneOffset/ONE_DAY);var timeOfDay=timezoneOffset%ONE_DAY;fixedDate+=toInt(time/ONE_DAY);timeOfDay+=time%ONE_DAY;if(timeOfDay>=ONE_DAY){timeOfDay-=ONE_DAY;fixedDate++;}else{while(timeOfDay<0){timeOfDay+=ONE_DAY;fixedDate--;}}fixedDate+=EPOCH_OFFSET;var date=Utils.getGregorianDateFromFixedDate(fixedDate);var year=date.year;var fields=this.fields;fields[YEAR]=year;fields[MONTH]=date.month;fields[DAY_OF_MONTH]=date.dayOfMonth;fields[DAY_OF_WEEK]=date.dayOfWeek;if(timeOfDay!==0){fields[HOUR_OF_DAY]=toInt(timeOfDay/ONE_HOUR);var r=timeOfDay%ONE_HOUR;fields[MINUTE]=toInt(r/ONE_MINUTE);r%=ONE_MINUTE;fields[SECONDS]=toInt(r/ONE_SECOND);fields[MILLISECONDS]=r%ONE_SECOND;}else{fields[HOUR_OF_DAY]=fields[MINUTE]=fields[SECONDS]=fields[MILLISECONDS]=0;}var fixedDateJan1=Utils.getFixedDate(year,GregorianCalendar.JANUARY,1);var dayOfYear=fixedDate-fixedDateJan1+1;var fixDateMonth1=fixedDate-date.dayOfMonth+1;fields[DAY_OF_YEAR]=dayOfYear;fields[DAY_OF_WEEK_IN_MONTH]=toInt((date.dayOfMonth-1)/7)+1;var weekOfYear=getWeekNumber(this,fixedDateJan1,fixedDate);// 本周没有足够的时间在当前年
if(weekOfYear===0){// If the date belongs to the last week of the
// previous year, use the week number of "12/31" of
// the "previous" year.
var fixedDec31=fixedDateJan1-1;var prevJan1=fixedDateJan1-getYearLength(year-1);weekOfYear=getWeekNumber(this,prevJan1,fixedDec31);}else// 本周是年末最后一周，可能有足够的时间在新的一年
if(weekOfYear>=52){var nextJan1=fixedDateJan1+getYearLength(year);var nextJan1st=getDayOfWeekDateOnOrBefore(nextJan1+6,this.firstDayOfWeek);var nDays=nextJan1st-nextJan1;// 本周有足够天数在新的一年
if(nDays>=this.minimalDaysInFirstWeek&&// 当天确实在本周，weekOfYear === 53 时是不需要这个判断
fixedDate>=nextJan1st-7){weekOfYear=1;}}fields[WEEK_OF_YEAR]=weekOfYear;fields[WEEK_OF_MONTH]=getWeekNumber(this,fixDateMonth1,fixedDate);this.fieldsComputed=true;},/*
   * Converts calendar field values to the time value
   * (millisecond offset from the Epoch).
   * @protected
   */computeTime:function computeTime(){var year=undefined;var fields=this.fields;if(this.isSet(YEAR)){year=fields[YEAR];}else{year=new Date().getFullYear();}var timeOfDay=0;if(this.isSet(HOUR_OF_DAY)){timeOfDay+=fields[HOUR_OF_DAY];}timeOfDay*=60;timeOfDay+=fields[MINUTE]||0;timeOfDay*=60;timeOfDay+=fields[SECONDS]||0;timeOfDay*=1000;timeOfDay+=fields[MILLISECONDS]||0;var fixedDate=0;fields[YEAR]=year;fixedDate=fixedDate+this.getFixedDate();// millis represents local wall-clock time in milliseconds.
var millis=(fixedDate-EPOCH_OFFSET)*ONE_DAY+timeOfDay;millis-=this.timezoneOffset*ONE_MINUTE;this.time=millis;this.computeFields();},/*
   * Fills in any unset fields in the calendar fields. First,
   * the computeTime() method is called if the time value (millisecond offset from the Epoch)
   * has not been calculated from calendar field values.
   * Then, the computeFields() method is called to calculate all calendar field values.
   * @protected
   */complete:function complete(){if(this.time===undefined){this.computeTime();}if(!this.fieldsComputed){this.computeFields();}},getFixedDate:function getFixedDate(){var self=this;var fields=self.fields;var firstDayOfWeekCfg=self.firstDayOfWeek;var year=fields[YEAR];var month=GregorianCalendar.JANUARY;if(self.isSet(MONTH)){month=fields[MONTH];if(month>GregorianCalendar.DECEMBER){year+=toInt(month/12);month%=12;}else if(month<GregorianCalendar.JANUARY){year+=floorDivide(month/12);month=mod(month,12);}}// Get the fixed date since Jan 1, 1 (Gregorian). We are on
// the first day of either `month' or January in 'year'.
var fixedDate=Utils.getFixedDate(year,month,1);var firstDayOfWeek=undefined;var dayOfWeek=self.firstDayOfWeek;if(self.isSet(DAY_OF_WEEK)){dayOfWeek=fields[DAY_OF_WEEK];}if(self.isSet(MONTH)){if(self.isSet(DAY_OF_MONTH)){fixedDate+=fields[DAY_OF_MONTH]-1;}else{if(self.isSet(WEEK_OF_MONTH)){firstDayOfWeek=getDayOfWeekDateOnOrBefore(fixedDate+6,firstDayOfWeekCfg);// If we have enough days in the first week, then
// move to the previous week.
if(firstDayOfWeek-fixedDate>=self.minimalDaysInFirstWeek){firstDayOfWeek-=7;}if(dayOfWeek!==firstDayOfWeekCfg){firstDayOfWeek=getDayOfWeekDateOnOrBefore(firstDayOfWeek+6,dayOfWeek);}fixedDate=firstDayOfWeek+7*(fields[WEEK_OF_MONTH]-1);}else{var dowim=undefined;if(self.isSet(DAY_OF_WEEK_IN_MONTH)){dowim=fields[DAY_OF_WEEK_IN_MONTH];}else{dowim=1;}var lastDate=7*dowim;if(dowim<0){lastDate=getMonthLength(year,month)+7*(dowim+1);}fixedDate=getDayOfWeekDateOnOrBefore(fixedDate+lastDate-1,dayOfWeek);}}}else{// We are on the first day of the year.
if(self.isSet(DAY_OF_YEAR)){fixedDate+=fields[DAY_OF_YEAR]-1;}else if(self.isSet(WEEK_OF_YEAR)){firstDayOfWeek=getDayOfWeekDateOnOrBefore(fixedDate+6,firstDayOfWeekCfg);// If we have enough days in the first week, then move
// to the previous week.
if(firstDayOfWeek-fixedDate>=self.minimalDaysInFirstWeek){firstDayOfWeek-=7;}if(dayOfWeek!==firstDayOfWeekCfg){firstDayOfWeek=getDayOfWeekDateOnOrBefore(firstDayOfWeek+6,dayOfWeek);}fixedDate=firstDayOfWeek+7*(fields[WEEK_OF_YEAR]-1);}}return fixedDate;},/*
   * Returns this Calendar's time value in milliseconds
   * @member Date.Gregorian
   * @returns {Number} the current time as UTC milliseconds from the epoch.
   */getTime:function getTime(){if(this.time===undefined){this.computeTime();}return this.time;},/*
   * Sets this Calendar's current time from the given long value.
   * @param time the new time in UTC milliseconds from the epoch.
   */setTime:function setTime(time){this.time=time;this.fieldsComputed=false;this.complete();},/*
   * Returns the value of the given calendar field.
   * @param field the given calendar field.
   * @returns {Number} the value for the given calendar field.
   */get:function get(field){this.complete();return this.fields[field];},/*
   * Returns the year of the given calendar field.
   * @method getYear
   * @returns {Number} the year for the given calendar field.
   *//*
   * Returns the month of the given calendar field.
   * @method getMonth
   * @returns {Number} the month for the given calendar field.
   *//*
   * Returns the day of month of the given calendar field.
   * @method getDayOfMonth
   * @returns {Number} the day of month for the given calendar field.
   *//*
   * Returns the hour of day of the given calendar field.
   * @method getHourOfDay
   * @returns {Number} the hour of day for the given calendar field.
   *//*
   * Returns the minute of the given calendar field.
   * @method getMinute
   * @returns {Number} the minute for the given calendar field.
   *//*
   * Returns the second of the given calendar field.
   * @method getSecond
   * @returns {Number} the second for the given calendar field.
   *//*
   * Returns the millisecond of the given calendar field.
   * @method getMilliSecond
   * @returns {Number} the millisecond for the given calendar field.
   *//*
   * Returns the week of year of the given calendar field.
   * @method getWeekOfYear
   * @returns {Number} the week of year for the given calendar field.
   *//*
   * Returns the week of month of the given calendar field.
   * @method getWeekOfMonth
   * @returns {Number} the week of month for the given calendar field.
   *//*
   * Returns the day of year of the given calendar field.
   * @method getDayOfYear
   * @returns {Number} the day of year for the given calendar field.
   *//*
   * Returns the day of week of the given calendar field.
   * @method getDayOfWeek
   * @returns {Number} the day of week for the given calendar field.
   *//*
   * Returns the day of week in month of the given calendar field.
   * @method getDayOfWeekInMonth
   * @returns {Number} the day of week in month for the given calendar field.
   *//*
   * Sets the given calendar field to the given value.
   * @param field the given calendar field.
   * @param v the value to be set for the given calendar field.
   */set:function set(field,v){var len=arguments.length;if(len===2){this.fields[field]=v;}else if(len<MILLISECONDS+1){for(var i=0;i<len;i++){this.fields[YEAR+i]=arguments[i];}}else{throw new Error('illegal arguments for GregorianCalendar set');}this.time=undefined;},/*
   * Set the year of the given calendar field.
   * @method setYear
   *//*
   * Set the month of the given calendar field.
   * @method setMonth
   *//*
   * Set the day of month of the given calendar field.
   * @method setDayOfMonth
   *//*
   * Set the hour of day of the given calendar field.
   * @method setHourOfDay
   *//*
   * Set the minute of the given calendar field.
   * @method setMinute
   *//*
   * Set the second of the given calendar field.
   * @method setSecond
   *//*
   * Set the millisecond of the given calendar field.
   * @method setMilliSecond
   *//*
   * Set the week of year of the given calendar field.
   * @method setWeekOfYear
   *//*
   * Set the week of month of the given calendar field.
   * @method setWeekOfMonth
   *//*
   * Set the day of year of the given calendar field.
   * @method setDayOfYear
   *//*
   * Set the day of week of the given calendar field.
   * @method setDayOfWeek
   *//*
   * Set the day of week in month of the given calendar field.
   * @method setDayOfWeekInMonth
   *//*
   * add for specified field based on two rules:
   *
   *  - Add rule 1. The value of field after the call minus the value of field before the
   *  call is amount, modulo any overflow that has occurred in field
   *  Overflow occurs when a field value exceeds its range and,
   *  as a result, the next larger field is incremented or
   *  decremented and the field value is adjusted back into its range.
   *
   *  - Add rule 2. If a smaller field is expected to be invariant,
   *  but it is impossible for it to be equal to its
   *  prior value because of changes in its minimum or maximum after
   *  field is changed, then its value is adjusted to be as close
   *  as possible to its expected value. A smaller field represents a
   *  smaller unit of time. HOUR_OF_DAY is a smaller field than
   *  DAY_OF_MONTH. No adjustment is made to smaller fields
   *  that are not expected to be invariant. The calendar system
   *  determines what fields are expected to be invariant.
   *
   *
   *      @example
   *      use('date/gregorian',function(S, GregorianCalendar){
   *          const d = new GregorianCalendar();
   *          d.set(2012, GregorianCalendar.JANUARY, 31);
   *          d.add(Gregorian.MONTH,1);
   *          // 2012-2-29
   *          document.writeln('<p>'+d.getYear()+'-'+d.getMonth()+'-'+d.getDayOfWeek())
   *          d.add(Gregorian.MONTH,12);
   *          // 2013-2-28
   *          document.writeln('<p>'+d.getYear()+'-'+d.getMonth()+'-'+d.getDayOfWeek())
   *      });
   *
   * @param field the calendar field.
   * @param {Number} amount he amount of date or time to be added to the field.
   */add:function add(field,a){if(!a){return;}var amount=a;var self=this;var fields=self.fields;// computer and retrieve original value
var value=self.get(field);if(field===YEAR){value+=amount;self.set(YEAR,value);adjustDayOfMonth(self);}else if(field===MONTH){value+=amount;var yearAmount=floorDivide(value/12);value=mod(value,12);if(yearAmount){self.set(YEAR,fields[YEAR]+yearAmount);}self.set(MONTH,value);adjustDayOfMonth(self);}else{switch(field){case HOUR_OF_DAY:amount*=ONE_HOUR;break;case MINUTE:amount*=ONE_MINUTE;break;case SECONDS:amount*=ONE_SECOND;break;case MILLISECONDS:break;case WEEK_OF_MONTH:case WEEK_OF_YEAR:case DAY_OF_WEEK_IN_MONTH:amount*=ONE_WEEK;break;case DAY_OF_WEEK:case DAY_OF_YEAR:case DAY_OF_MONTH:amount*=ONE_DAY;break;default:throw new Error('illegal field for add');}self.setTime(self.time+amount);}},/*
   * add the year of the given calendar field.
   * @method addYear
   * @param {Number} amount the signed amount to add to field.
   *//*
   * add the month of the given calendar field.
   * @method addMonth
   * @param {Number} amount the signed amount to add to field.
   *//*
   * add the day of month of the given calendar field.
   * @method addDayOfMonth
   * @param {Number} amount the signed amount to add to field.
   *//*
   * add the hour of day of the given calendar field.
   * @method addHourOfDay
   * @param {Number} amount the signed amount to add to field.
   *//*
   * add the minute of the given calendar field.
   * @method addMinute
   * @param {Number} amount the signed amount to add to field.
   *//*
   * add the second of the given calendar field.
   * @method addSecond
   * @param {Number} amount the signed amount to add to field.
   *//*
   * add the millisecond of the given calendar field.
   * @method addMilliSecond
   * @param {Number} amount the signed amount to add to field.
   *//*
   * add the week of year of the given calendar field.
   * @method addWeekOfYear
   * @param {Number} amount the signed amount to add to field.
   *//*
   * add the week of month of the given calendar field.
   * @method addWeekOfMonth
   * @param {Number} amount the signed amount to add to field.
   *//*
   * add the day of year of the given calendar field.
   * @method addDayOfYear
   * @param {Number} amount the signed amount to add to field.
   *//*
   * add the day of week of the given calendar field.
   * @method addDayOfWeek
   * @param {Number} amount the signed amount to add to field.
   *//*
   * add the day of week in month of the given calendar field.
   * @method addDayOfWeekInMonth
   * @param {Number} amount the signed amount to add to field.
   *//*
   * Get rolled value for the field
   * @protected
   */getRolledValue:function getRolledValue(value,a,min,max){var amount=a;var diff=value-min;var range=max-min+1;amount%=range;return min+(diff+amount+range)%range;},/*
   * Adds a signed amount to the specified calendar field without changing larger fields.
   * A negative roll amount means to subtract from field without changing
   * larger fields. If the specified amount is 0, this method performs nothing.
   *
   *
   *
   *      @example
   *      const d = new GregorianCalendar();
   *      d.set(1999, GregorianCalendar.AUGUST, 31);
   *      // 1999-4-30
   *      // Tuesday June 1, 1999
   *      d.set(1999, GregorianCalendar.JUNE, 1);
   *      d.add(Gregorian.WEEK_OF_MONTH,-1); // === d.add(Gregorian.WEEK_OF_MONTH,
   *      d.get(Gregorian.WEEK_OF_MONTH));
   *      // 1999-06-29
   *
   *
   * @param field the calendar field.
   * @param {Number} amount the signed amount to add to field.
   */roll:function roll(field,amount){if(!amount){return;}var self=this;// computer and retrieve original value
var value=self.get(field);var min=self.getActualMinimum(field);var max=self.getActualMaximum(field);value=self.getRolledValue(value,amount,min,max);self.set(field,value);// consider compute time priority
switch(field){case MONTH:adjustDayOfMonth(self);break;default:// other fields are set already when get
self.updateFieldsBySet(field);break;}},/*
   * keep field stable.
   *
   * 2015-09-29 setMonth 2 vs rollSetMonth 2
   *
   */rollSet:function rollSet(field,v){this.set(field,v);switch(field){case MONTH:adjustDayOfMonth(this);break;default:// other fields are set already when get
this.updateFieldsBySet(field);break;}},/*
   * roll the year of the given calendar field.
   * @method rollYear
   * @param {Number} amount the signed amount to add to field.
   *//*
   * roll the month of the given calendar field.
   * @param {Number} amount the signed amount to add to field.
   * @method rollMonth
   *//*
   * roll the day of month of the given calendar field.
   * @method rollDayOfMonth
   * @param {Number} amount the signed amount to add to field.
   *//*
   * roll the hour of day of the given calendar field.
   * @method rollHourOfDay
   * @param {Number} amount the signed amount to add to field.
   *//*
   * roll the minute of the given calendar field.
   * @method rollMinute
   * @param {Number} amount the signed amount to add to field.
   *//*
   * roll the second of the given calendar field.
   * @method rollSecond
   * @param {Number} amount the signed amount to add to field.
   *//*
   * roll the millisecond of the given calendar field.
   * @method rollMilliSecond
   * @param {Number} amount the signed amount to add to field.
   *//*
   * roll the week of year of the given calendar field.
   * @method rollWeekOfYear
   * @param {Number} amount the signed amount to add to field.
   *//*
   * roll the week of month of the given calendar field.
   * @method rollWeekOfMonth
   * @param {Number} amount the signed amount to add to field.
   *//*
   * roll the day of year of the given calendar field.
   * @method rollDayOfYear
   * @param {Number} amount the signed amount to add to field.
   *//*
   * roll the day of week of the given calendar field.
   * @method rollDayOfWeek
   * @param {Number} amount the signed amount to add to field.
   *//*
   * remove other priority fields when call getFixedDate
   * precondition: other fields are all set or computed
   * @protected
   */updateFieldsBySet:function updateFieldsBySet(field){var fields=this.fields;switch(field){case WEEK_OF_MONTH:fields[DAY_OF_MONTH]=undefined;break;case DAY_OF_YEAR:fields[MONTH]=undefined;break;case DAY_OF_WEEK:fields[DAY_OF_MONTH]=undefined;break;case WEEK_OF_YEAR:fields[DAY_OF_YEAR]=undefined;fields[MONTH]=undefined;break;default:break;}},/*
   * get current date instance's timezone offset
   * @returns {Number}
   */getTimezoneOffset:function getTimezoneOffset(){return this.timezoneOffset;},/*
   * set current date instance's timezone offset
   */setTimezoneOffset:function setTimezoneOffset(timezoneOffset){if(this.timezoneOffset!==timezoneOffset){this.fieldsComputed=undefined;this.timezoneOffset=timezoneOffset;}},/*
   * set first day of week for current date instance
   */setFirstDayOfWeek:function setFirstDayOfWeek(firstDayOfWeek){if(this.firstDayOfWeek!==firstDayOfWeek){this.firstDayOfWeek=firstDayOfWeek;this.fieldsComputed=false;}},/*
   * Gets what the first day of the week is; e.g., SUNDAY in the U.S., MONDAY in France.
   * @returns {Number} the first day of the week.
   */getFirstDayOfWeek:function getFirstDayOfWeek(){return this.firstDayOfWeek;},/*
   * Sets what the minimal days required in the first week of the year are; For example,
   * if the first week is defined as one that contains the first day of the first month of a year,
   * call this method with value 1.
   * If it must be a full week, use value 7.
   * @param minimalDaysInFirstWeek the given minimal days required in the first week of the year.
   */setMinimalDaysInFirstWeek:function setMinimalDaysInFirstWeek(minimalDaysInFirstWeek){if(this.minimalDaysInFirstWeek!==minimalDaysInFirstWeek){this.minimalDaysInFirstWeek=minimalDaysInFirstWeek;this.fieldsComputed=false;}},/*
   * Gets what the minimal days required in the first week of the year are; e.g.,
   * if the first week is defined as one that contains the first day of the first month of a year,
   * this method returns 1.
   * If the minimal days required must be a full week, this method returns 7.
   * @returns {Number} the minimal days required in the first week of the year.
   */getMinimalDaysInFirstWeek:function getMinimalDaysInFirstWeek(){return this.minimalDaysInFirstWeek;},/*
   * Returns the number of weeks in the week year
   * represented by this GregorianCalendar.
   *
   * For example, if this GregorianCalendar's date is
   * December 31, 2008 with the ISO
   * 8601 compatible setting, this method will return 53 for the
   * period: December 29, 2008 to January 3, 2010
   * while getActualMaximum(WEEK_OF_YEAR) will return
   * 52 for the period: December 31, 2007 to December 28, 2008.
   *
   * @return {Number} the number of weeks in the week year.
   */getWeeksInWeekYear:function getWeeksInWeekYear(){var weekYear=this.getWeekYear();if(weekYear===this.get(YEAR)){return this.getActualMaximum(WEEK_OF_YEAR);}// Use the 2nd week for calculating the max of WEEK_OF_YEAR
var gc=this.clone();gc.clear();gc.setWeekDate(weekYear,2,this.get(DAY_OF_WEEK));return gc.getActualMaximum(WEEK_OF_YEAR);},/*
   * Returns the week year represented by this GregorianCalendar.
   * The dates in the weeks between 1 and the
   * maximum week number of the week year have the same week year value
   * that may be one year before or after the calendar year value.
   *
   * @return {Number} the week year represented by this GregorianCalendar.
   */getWeekYear:function getWeekYear(){var year=this.get(YEAR);// implicitly  complete
var weekOfYear=this.get(WEEK_OF_YEAR);var month=this.get(MONTH);if(month===GregorianCalendar.JANUARY){if(weekOfYear>=52){--year;}}else if(month===GregorianCalendar.DECEMBER){if(weekOfYear===1){++year;}}return year;},/*
   * Sets this GregorianCalendar to the date given by the date specifiers - weekYear,
   * weekOfYear, and dayOfWeek. weekOfYear follows the WEEK_OF_YEAR numbering.
   * The dayOfWeek value must be one of the DAY_OF_WEEK values: SUNDAY to SATURDAY.
   *
   * @param weekYear    the week year
   * @param weekOfYear  the week number based on weekYear
   * @param dayOfWeek   the day of week value
   */setWeekDate:function setWeekDate(weekYear,weekOfYear,dayOfWeek){if(dayOfWeek<GregorianCalendar.SUNDAY||dayOfWeek>GregorianCalendar.SATURDAY){throw new Error('invalid dayOfWeek: '+dayOfWeek);}var fields=this.fields;// To avoid changing the time of day fields by date
// calculations, use a clone with the GMT time zone.
var gc=this.clone();gc.clear();gc.setTimezoneOffset(0);gc.set(YEAR,weekYear);gc.set(WEEK_OF_YEAR,1);gc.set(DAY_OF_WEEK,this.getFirstDayOfWeek());var days=dayOfWeek-this.getFirstDayOfWeek();if(days<0){days+=7;}days+=7*(weekOfYear-1);if(days!==0){gc.add(DAY_OF_YEAR,days);}else{gc.complete();}fields[YEAR]=gc.get(YEAR);fields[MONTH]=gc.get(MONTH);fields[DAY_OF_MONTH]=gc.get(DAY_OF_MONTH);this.complete();},/*
   * Creates and returns a copy of this object.
   * @returns {Date.Gregorian}
   */clone:function clone(){if(this.time===undefined){this.computeTime();}var cal=new GregorianCalendar(this.locale);cal.setTimezoneOffset(cal.getTimezoneOffset());cal.setFirstDayOfWeek(cal.getFirstDayOfWeek());cal.setMinimalDaysInFirstWeek(cal.getMinimalDaysInFirstWeek());cal.setTime(this.time);return cal;},/*
   * Compares this GregorianCalendar to the specified Object.
   * The result is true if and only if the argument is a GregorianCalendar object
   * that represents the same time value (millisecond offset from the Epoch)
   * under the same Calendar parameters and Gregorian change date as this object.
   * @param {Date.Gregorian} obj the object to compare with.
   * @returns {boolean} true if this object is equal to obj; false otherwise.
   */equals:function equals(obj){return this.getTime()===obj.getTime()&&this.firstDayOfWeek===obj.firstDayOfWeek&&this.timezoneOffset===obj.timezoneOffset&&this.minimalDaysInFirstWeek===obj.minimalDaysInFirstWeek;},compareToDay:function compareToDay(d2){var d1Year=this.getYear();var d2Year=d2.getYear();var d1Month=this.getMonth();var d2Month=d2.getMonth();var d1Day=this.getDayOfMonth();var d2Day=d2.getDayOfMonth();if(d1Year!==d2Year){return d1Year-d2Year;}if(d1Month!==d2Month){return d1Month-d2Month;}return d1Day-d2Day;},/*
   * Sets all the calendar field values or specified field and the time value
   * (millisecond offset from the Epoch) of this Calendar undefined.
   * This means that isSet() will return false for all the calendar fields,
   * and the date and time calculations will treat the fields as if they had never been set.
   * @param [field] the calendar field to be cleared.
   */clear:function clear(field){if(field===undefined){this.field=[];}else{this.fields[field]=undefined;}this.time=undefined;this.fieldsComputed=false;},toString:function toString(){// for debug
var v=this;return'[GregorianCalendar]: '+v.getYear()+'/'+v.getMonth()+'/'+v.getDayOfMonth()+' '+v.getHourOfDay()+':'+v.getMinutes()+':'+v.getSeconds();}};var GregorianCalendarProto=GregorianCalendar.prototype;Utils.each(FIELDS,function(f,index){if(f){GregorianCalendarProto['get'+f]=function get(){return this.get(index);};GregorianCalendarProto['isSet'+f]=function isSet(){return this.isSet(index);};GregorianCalendarProto['set'+f]=function set(v){return this.set(index,v);};GregorianCalendarProto['add'+f]=function add(v){return this.add(index,v);};GregorianCalendarProto['roll'+f]=function roll(v){return this.roll(index,v);};GregorianCalendarProto['rollSet'+f]=function rollSet(v){return this.rollSet(index,v);};}});module.exports=GregorianCalendar;/*
 http://docs.oracle.com/javase/7/docs/api/java/util/GregorianCalendar.html

 TODO
 - day saving time
 - i18n
 - julian calendar
 */

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _radio=__webpack_require__(129);var _radio2=_interopRequireDefault(_radio);var _group=__webpack_require__(489);var _group2=_interopRequireDefault(_group);var _radioButton=__webpack_require__(196);var _radioButton2=_interopRequireDefault(_radioButton);var _middleware=__webpack_require__(27);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_radio2.default.Button=(0,_middleware2.default)(_radioButton2.default,"Radio.Button");_radio2.default.Group=(0,_middleware2.default)(_group2.default,"Radio.Group");exports.default=_radio2.default;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * DateTimeFormat for
 * Inspired by DateTimeFormat from JDK.
 * @author yiminghe@gmail.com
 */



var GregorianCalendar = __webpack_require__(95);
var enUsLocale = __webpack_require__(146);
var MAX_VALUE = Number.MAX_VALUE;
var warning = __webpack_require__(506);

/**
 * date or time style enum
 * @enum {Number} Date.Formatter.Style
 */
var DateTimeStyle = {
  /**
   * full style
   */
  FULL: 0,
  /**
   * long style
   */
  LONG: 1,
  /**
   * medium style
   */
  MEDIUM: 2,
  /**
   * short style
   */
  SHORT: 3
};

/*
 Letter    Date or Time Component    Presentation    Examples
 G    Era designator    Text    AD
 y    Year    Year    1996; 96
 Y    WeekYear    WeekYear    1996; 96
 M    Month in year    Month    July; Jul; 07
 w    Week in year    Number    27
 W    Week in month    Number    2
 D    Day in year    Number    189
 d    Day in month    Number    10
 F    Day of week in month    Number    2
 E    Day in week    Text    Tuesday; Tue
 a    Am/pm marker    Text    PM
 H    Hour in day (0-23)    Number    0
 k    Hour in day (1-24)    Number    24
 K    Hour in am/pm (0-11)    Number    0
 h    Hour in am/pm (1-12)    Number    12
 m    Minute in hour    Number    30
 s    Second in minute    Number    55
 S    Millisecond    Number    978
 x z    Time zone    General time zone    Pacific Standard Time; PST; GMT-08:00
 Z    Time zone    RFC 822 time zone    -0800
 */

var patternChars = new Array(GregorianCalendar.DAY_OF_WEEK_IN_MONTH + 2).join('1');
var ERA = 0;
var calendarIndexMap = {};

patternChars = patternChars.split('');
patternChars[ERA] = 'G';
patternChars[GregorianCalendar.YEAR] = 'y';
patternChars[GregorianCalendar.MONTH] = 'M';
patternChars[GregorianCalendar.DAY_OF_MONTH] = 'd';
patternChars[GregorianCalendar.HOUR_OF_DAY] = 'H';
patternChars[GregorianCalendar.MINUTES] = 'm';
patternChars[GregorianCalendar.SECONDS] = 's';
patternChars[GregorianCalendar.MILLISECONDS] = 'S';
patternChars[GregorianCalendar.WEEK_OF_YEAR] = 'w';
patternChars[GregorianCalendar.WEEK_OF_MONTH] = 'W';
patternChars[GregorianCalendar.DAY_OF_YEAR] = 'D';
patternChars[GregorianCalendar.DAY_OF_WEEK_IN_MONTH] = 'F';
patternChars.push('Y');

patternChars.forEach(function (v, key) {
  var k = key;
  if (v === 'Y') {
    k = GregorianCalendar.YEAR;
  }
  if (v) {
    calendarIndexMap[v] = k;
  }
});

function mix(t, s) {
  for (var p in s) {
    if (s.hasOwnProperty(p)) {
      t[p] = s[p];
    }
  }
}

var SUBSTITUTE_REG = /\\?\{([^{}]+)\}/g;
var EMPTY = '';

function substitute(str, o, regexp) {
  if (typeof str !== 'string' || !o) {
    return str;
  }

  return str.replace(regexp || SUBSTITUTE_REG, function (match, name) {
    if (match.charAt(0) === '\\') {
      return match.slice(1);
    }
    return o[name] === undefined ? EMPTY : o[name];
  });
}

patternChars = patternChars.join('') + 'ahkKZE';

function encode(lastField, count, compiledPattern) {
  compiledPattern.push({
    field: lastField,
    count: count
  });
}

function compile(pattern) {
  var length = pattern.length;
  var inQuote = false;
  var compiledPattern = [];
  var tmpBuffer = null;
  var count = 0;
  var lastField = -1;

  for (var i = 0; i < length; i++) {
    var c = pattern.charAt(i);

    if (c === '\'') {
      // '' is treated as a single quote regardless of being
      // in a quoted section.
      if (i + 1 < length) {
        c = pattern.charAt(i + 1);
        if (c === '\'') {
          i++;
          if (count !== 0) {
            encode(lastField, count, compiledPattern);
            lastField = -1;
            count = 0;
          }
          if (inQuote) {
            tmpBuffer += c;
          }
          continue;
        }
      }
      if (!inQuote) {
        if (count !== 0) {
          encode(lastField, count, compiledPattern);
          lastField = -1;
          count = 0;
        }
        tmpBuffer = '';
        inQuote = true;
      } else {
        compiledPattern.push({
          text: tmpBuffer
        });
        inQuote = false;
      }
      continue;
    }
    if (inQuote) {
      tmpBuffer += c;
      continue;
    }
    if (!(c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z')) {
      if (count !== 0) {
        encode(lastField, count, compiledPattern);
        lastField = -1;
        count = 0;
      }
      compiledPattern.push({
        text: c
      });
      continue;
    }

    if (patternChars.indexOf(c) === -1) {
      throw new Error('Illegal pattern character "' + c + '"');
    }

    if (lastField === -1 || lastField === c) {
      lastField = c;
      count++;
      continue;
    }
    encode(lastField, count, compiledPattern);
    lastField = c;
    count = 1;
  }

  if (inQuote) {
    throw new Error('Unterminated quote');
  }

  if (count !== 0) {
    encode(lastField, count, compiledPattern);
  }

  return compiledPattern;
}

var zeroDigit = '0';

// TODO zeroDigit localization??
function zeroPaddingNumber(_x, _x2, _x3, _x4) {
  var _again = true;

  _function: while (_again) {
    var value = _x,
        minDigits = _x2,
        maxDigits_ = _x3,
        b = _x4;
    _again = false;

    // Optimization for 1, 2 and 4 digit numbers. This should
    // cover most cases of formatting date/time related items.
    // Note: This optimization code assumes that maxDigits is
    // either 2 or Integer.MAX_VALUE (maxIntCount in format()).
    var buffer = b || [];
    var maxDigits = maxDigits_ || MAX_VALUE;
    if (value >= 0) {
      if (value < 100 && minDigits >= 1 && minDigits <= 2) {
        if (value < 10 && minDigits === 2) {
          buffer.push(zeroDigit);
        }
        buffer.push(value);
        return buffer.join('');
      } else if (value >= 1000 && value < 10000) {
        if (minDigits === 4) {
          buffer.push(value);
          return buffer.join('');
        }
        if (minDigits === 2 && maxDigits === 2) {
          _x = value % 100;
          _x2 = 2;
          _x3 = 2;
          _x4 = buffer;
          _again = true;
          buffer = maxDigits = undefined;
          continue _function;
        }
      }
    }
    buffer.push(value + '');
    return buffer.join('');
  }
}

/**
 *
 * date time formatter for GregorianCalendar
 *
 *      @example
 *
 *          const calendar = new GregorianCalendar(2013,9,24);
 *          // ' to escape
 *          const formatter = new GregorianCalendarFormat("'today is' ''yyyy/MM/dd a''");
 *          document.write(formatter.format(calendar));
 *
 * @class GregorianCalendarFormat
 * @param {String} pattern patter string of date formatter
 *
 * <table border="1">
 * <thead valign="bottom">
 * <tr><th class="head">Letter</th>
 * <th class="head">Date or Time Component</th>
 * <th class="head">Presentation</th>
 * <th class="head">Examples</th>
 * </tr>
 * </thead>
 * <tbody valign="top">
 * <tr><td>G</td>
 * <td>Era designator</td>
 * <td>Text</td>
 * <td>AD</td>
 * </tr>
 * <tr><td>y</td>
 * <td>Year</td>
 * <td>Year</td>
 * <td>1996; 96</td>
 * </tr>
 * <tr><td>M</td>
 * <td>Month in year</td>
 * <td>Month</td>
 * <td>July; Jul; 07</td>
 * </tr>
 * <tr><td>w</td>
 * <td>Week in year</td>
 * <td>Number</td>
 * <td>27</td>
 * </tr>
 * <tr><td>W</td>
 * <td>Week in month</td>
 * <td>Number</td>
 * <td>2</td>
 * </tr>
 * <tr><td>D</td>
 * <td>Day in year</td>
 * <td>Number</td>
 * <td>189</td>
 * </tr>
 * <tr><td>d</td>
 * <td>Day in month</td>
 * <td>Number</td>
 * <td>10</td>
 * </tr>
 * <tr><td>F</td>
 * <td>Day of week in month</td>
 * <td>Number</td>
 * <td>2</td>
 * </tr>
 * <tr><td>E</td>
 * <td>Day in week</td>
 * <td>Text</td>
 * <td>Tuesday; Tue</td>
 * </tr>
 * <tr><td>a</td>
 * <td>Am/pm marker</td>
 * <td>Text</td>
 * <td>PM</td>
 * </tr>
 * <tr><td>H</td>
 *       <td>Hour in day (0-23)</td>
 * <td>Number</td>
 * <td>0</td>
 * </tr>
 * <tr><td>k</td>
 *       <td>Hour in day (1-24)</td>
 * <td>Number</td>
 * <td>24</td>
 * </tr>
 * <tr><td>K</td>
 * <td>Hour in am/pm (0-11)</td>
 * <td>Number</td>
 * <td>0</td>
 * </tr>
 * <tr><td>h</td>
 * <td>Hour in am/pm (1-12)</td>
 * <td>Number</td>
 * <td>12</td>
 * </tr>
 * <tr><td>m</td>
 * <td>Minute in hour</td>
 * <td>Number</td>
 * <td>30</td>
 * </tr>
 * <tr><td>s</td>
 * <td>Second in minute</td>
 * <td>Number</td>
 * <td>55</td>
 * </tr>
 * <tr><td>S</td>
 * <td>Millisecond</td>
 * <td>Number</td>
 * <td>978</td>
 * </tr>
 * <tr><td>x/z</td>
 * <td>Time zone</td>
 * <td>General time zone</td>
 * <td>Pacific Standard Time; PST; GMT-08:00</td>
 * </tr>
 * <tr><td>Z</td>
 * <td>Time zone</td>
 * <td>RFC 822 time zone</td>
 * <td>-0800</td>
 * </tr>
 * </tbody>
 * </table>

 * @param {Object} locale format locale
 */
function DateTimeFormat(pattern, locale) {
  this.locale = locale || enUsLocale;
  this.originalPattern = pattern;
  this.pattern = compile(pattern);
}

function formatField(field, count, locale, calendar) {
  var current = undefined;
  var value = undefined;
  switch (field) {
    case 'G':
      value = calendar.getYear() > 0 ? 1 : 0;
      current = locale.eras[value];
      break;
    case 'Y':
      value = calendar.getWeekYear();
      if (value <= 0) {
        value = 1 - value;
      }
      current = zeroPaddingNumber(value, 2, count !== 2 ? MAX_VALUE : 2);
      break;
    case 'y':
      value = calendar.getYear();
      if (value <= 0) {
        value = 1 - value;
      }
      current = zeroPaddingNumber(value, 2, count !== 2 ? MAX_VALUE : 2);
      break;
    case 'M':
      value = calendar.getMonth();
      if (count >= 4) {
        current = locale.months[value];
      } else if (count === 3) {
        current = locale.shortMonths[value];
      } else {
        current = zeroPaddingNumber(value + 1, count);
      }
      break;
    case 'k':
      current = zeroPaddingNumber(calendar.getHourOfDay() || 24, count);
      break;
    case 'E':
      value = calendar.getDayOfWeek();
      current = count >= 4 ? locale.weekdays[value] : locale.shortWeekdays[value];
      break;
    case 'a':
      current = locale.ampms[calendar.getHourOfDay() >= 12 ? 1 : 0];
      break;
    case 'h':
      current = zeroPaddingNumber(calendar.getHourOfDay() % 12 || 12, count);
      break;
    case 'K':
      current = zeroPaddingNumber(calendar.getHourOfDay() % 12, count);
      break;
    case 'Z':
      var offset = calendar.getTimezoneOffset();
      var parts = [offset < 0 ? '-' : '+'];
      offset = Math.abs(offset);
      parts.push(zeroPaddingNumber(Math.floor(offset / 60) % 100, 2), zeroPaddingNumber(offset % 60, 2));
      current = parts.join('');
      break;
    default:
      // case 'd':
      // case 'H':
      // case 'm':
      // case 's':
      // case 'S':
      // case 'D':
      // case 'F':
      // case 'w':
      // case 'W':
      var index = calendarIndexMap[field];
      value = calendar.get(index);
      current = zeroPaddingNumber(value, count);
  }
  return current;
}

function matchPartString(dateStr, startIndex, match, mLen) {
  for (var i = 0; i < mLen; i++) {
    if (dateStr.charAt(startIndex + i) !== match.charAt(i)) {
      return false;
    }
  }
  return true;
}

function matchField(dateStr, startIndex, matches) {
  var matchedLen = -1;
  var index = -1;
  var i = undefined;
  var len = matches.length;
  for (i = 0; i < len; i++) {
    var m = matches[i];
    var mLen = m.length;
    if (mLen > matchedLen && matchPartString(dateStr, startIndex, m, mLen)) {
      matchedLen = mLen;
      index = i;
    }
  }
  return index >= 0 ? {
    value: index,
    startIndex: startIndex + matchedLen
  } : null;
}

function getLeadingNumberLen(str) {
  var i = undefined;
  var c = undefined;
  var len = str.length;
  for (i = 0; i < len; i++) {
    c = str.charAt(i);
    if (c < '0' || c > '9') {
      break;
    }
  }
  return i;
}

function matchNumber(dateStr, startIndex, count, obeyCount) {
  var str = dateStr;
  var n = undefined;
  if (obeyCount) {
    if (dateStr.length < startIndex + count) {
      return null;
    }
    str = dateStr.slice(startIndex, startIndex + count);
    if (!str.match(/^\d+$/)) {
      throw new Error('GregorianCalendarFormat parse error, dateStr: ' + dateStr + ', patter: ' + this.originalPattern);
    }
  } else {
    str = str.slice(startIndex);
  }
  n = parseInt(str, 10);
  if (isNaN(n)) {
    throw new Error('GregorianCalendarFormat parse error, dateStr: ' + dateStr + ', patter: ' + this.originalPattern);
  }
  return {
    value: n,
    startIndex: startIndex + getLeadingNumberLen(str)
  };
}

function parseField(calendar, dateStr, startIndex_, field, count, obeyCount, tmp) {
  var match = undefined;
  var year = undefined;
  var hour = undefined;
  var startIndex = startIndex_;
  if (dateStr.length <= startIndex) {
    return startIndex;
  }
  var locale = this.locale;
  switch (field) {
    case 'G':
      match = matchField(dateStr, startIndex, locale.eras);
      if (match) {
        if (calendar.isSetYear()) {
          if (match.value === 0) {
            year = calendar.getYear();
            calendar.setYear(1 - year);
          }
        } else {
          tmp.era = match.value;
        }
      }
      break;
    case 'y':
      match = matchNumber.call(this, dateStr, startIndex, count, obeyCount);
      if (match) {
        year = match.value;
        if ('era' in tmp) {
          if (tmp.era === 0) {
            year = 1 - year;
          }
        }
        calendar.setYear(year);
      }
      break;
    case 'M':
      var month = undefined;
      if (count >= 3) {
        match = matchField(dateStr, startIndex, locale[count === 3 ? 'shortMonths' : 'months']);
        if (match) {
          month = match.value;
        }
      } else {
        match = matchNumber.call(this, dateStr, startIndex, count, obeyCount);
        if (match) {
          month = match.value - 1;
        }
      }
      if (match) {
        calendar.setMonth(month);
      }
      break;
    case 'k':
      match = matchNumber.call(this, dateStr, startIndex, count, obeyCount);
      if (match) {
        calendar.setHourOfDay(match.value % 24);
      }
      break;
    case 'E':
      match = matchField(dateStr, startIndex, locale[count > 3 ? 'weekdays' : 'shortWeekdays']);
      if (match) {
        calendar.setDayOfWeek(match.value);
      }
      break;
    case 'a':
      match = matchField(dateStr, startIndex, locale.ampms);
      if (match) {
        if (calendar.isSetHourOfDay()) {
          if (match.value) {
            hour = calendar.getHourOfDay();
            if (hour < 12) {
              calendar.setHourOfDay((hour + 12) % 24);
            }
          }
        } else {
          tmp.ampm = match.value;
        }
      }
      break;
    case 'h':
      match = matchNumber.call(this, dateStr, startIndex, count, obeyCount);
      if (match) {
        hour = match.value %= 12;
        if (tmp.ampm) {
          hour += 12;
        }
        calendar.setHourOfDay(hour);
      }
      break;
    case 'K':
      match = matchNumber.call(this, dateStr, startIndex, count, obeyCount);
      if (match) {
        hour = match.value;
        if (tmp.ampm) {
          hour += 12;
        }
        calendar.setHourOfDay(hour);
      }
      break;
    case 'Z':
      // let sign = 1;
      var zoneChar = dateStr.charAt(startIndex);
      if (zoneChar === '-') {
        // sign = -1;
        startIndex++;
      } else if (zoneChar === '+') {
        startIndex++;
      } else {
        break;
      }
      match = matchNumber.call(this, dateStr, startIndex, 2, true);
      if (match) {
        var zoneOffset = match.value * 60;
        startIndex = match.startIndex;
        match = matchNumber.call(this, dateStr, startIndex, 2, true);
        if (match) {
          zoneOffset += match.value;
        }
        calendar.setTimezoneOffset(zoneOffset);
      }
      break;
    default:
      // case 'd':
      // case 'H':
      // case 'm':
      // case 's':
      // case 'S':
      // case 'D':
      // case 'F':
      // case 'w':
      // case 'W'
      match = matchNumber.call(this, dateStr, startIndex, count, obeyCount);
      if (match) {
        var index = calendarIndexMap[field];
        calendar.set(index, match.value);
      }
  }
  if (match) {
    startIndex = match.startIndex;
  }
  return startIndex;
}

mix(DateTimeFormat.prototype, {
  /*
   * format a GregorianDate instance according to specified pattern
   * @param {GregorianCalendar} calendar GregorianDate instance
   * @returns {string} formatted string of GregorianDate instance
   */
  format: function format(calendar) {
    if (!calendar.isGregorianCalendar) {
      throw new Error('calendar must be type of GregorianCalendar');
    }
    var i = undefined;
    var ret = [];
    var pattern = this.pattern;
    var len = pattern.length;
    for (i = 0; i < len; i++) {
      var comp = pattern[i];
      if (comp.text) {
        ret.push(comp.text);
      } else if ('field' in comp) {
        ret.push(formatField(comp.field, comp.count, this.locale, calendar));
      }
    }
    return ret.join('');
  },

  /*
   * parse a formatted string of GregorianDate instance according to specified pattern
   * @param {String} dateStr formatted string of GregorianDate
   * @returns {GregorianCalendar}
   */
  parse: function parse(dateStr, option_) {
    var option = option_ || {};
    var calendarLocale = option.locale;
    var calendar = new GregorianCalendar(calendarLocale);
    var i = undefined;
    var j = undefined;
    var tmp = {};
    var obeyCount = option.obeyCount || false;
    var dateStrLen = dateStr.length;
    var errorIndex = -1;
    var startIndex = 0;
    var oldStartIndex = 0;
    var pattern = this.pattern;
    var len = pattern.length;
    /* eslint no-labels: 0 no-empty-label:0 */
    loopPattern: {
      for (i = 0; errorIndex < 0 && i < len; i++) {
        var comp = pattern[i];
        var text = undefined;
        var textLen = undefined;
        oldStartIndex = startIndex;
        text = comp.text;
        if (text) {
          textLen = text.length;
          if (textLen + startIndex > dateStrLen) {
            errorIndex = startIndex;
          } else {
            for (j = 0; j < textLen; j++) {
              if (text.charAt(j) !== dateStr.charAt(j + startIndex)) {
                errorIndex = startIndex;
                break loopPattern;
              }
            }
            startIndex += textLen;
          }
        } else if ('field' in comp) {
          if (!option.obeyCount) {
            var nextComp = pattern[i + 1];
            obeyCount = false;
            if (nextComp) {
              if ('field' in nextComp) {
                obeyCount = true;
              } else {
                var c = nextComp.text.charAt(0);
                if (c >= '0' && c <= '9') {
                  obeyCount = true;
                }
              }
            }
          }
          startIndex = parseField.call(this, calendar, dateStr, startIndex, comp.field, comp.count, obeyCount, tmp);
          if (startIndex === oldStartIndex) {
            errorIndex = startIndex;
          }
        }
      }
    }

    if (errorIndex >= 0) {
      warning(false, 'error when parsing date: ' + dateStr + ', position: ' + dateStr.slice(0, errorIndex) + '^');
      return undefined;
    }
    return calendar;
  }
});

mix(DateTimeFormat, {
  Style: DateTimeStyle,

  /*
   * get a formatter instance of short style pattern.
   * en-us: M/d/yy h:mm a
   * zh-cn: yy-M-d ah:mm
   * @param {Object} locale locale object
   * @returns {GregorianCalendar}
   * @static
   */
  getInstance: function getInstance(locale) {
    return this.getDateTimeInstance(DateTimeStyle.SHORT, DateTimeStyle.SHORT, locale);
  },

  /*
   * get a formatter instance of specified date style.
   * @param {Date.Formatter.Style} dateStyle date format style
   * @param {Object} locale
   * @returns {GregorianCalendar}
   * @static
   */
  getDateInstance: function getDateInstance(dateStyle, locale) {
    return this.getDateTimeInstance(dateStyle, undefined, locale);
  },

  /*
   * get a formatter instance of specified date style and time style.
   * @param {Date.Formatter.Style} dateStyle date format style
   * @param {Date.Formatter.Style} timeStyle time format style
   * @param {Object} locale
   * @returns {GregorianCalendar}
   * @static
   */
  getDateTimeInstance: function getDateTimeInstance(dateStyle, timeStyle, locale_) {
    var locale = locale_ || enUsLocale;
    var datePattern = '';
    if (dateStyle !== undefined) {
      datePattern = locale.datePatterns[dateStyle];
    }
    var timePattern = '';
    if (timeStyle !== undefined) {
      timePattern = locale.timePatterns[timeStyle];
    }
    var pattern = datePattern;
    if (timePattern) {
      if (datePattern) {
        pattern = substitute(locale.dateTimePattern, {
          date: datePattern,
          time: timePattern
        });
      } else {
        pattern = timePattern;
      }
    }
    return new DateTimeFormat(pattern, locale);
  },

  /*
   * get a formatter instance of specified time style.
   * @param {Date.Formatter.Style} timeStyle time format style
   * @param {Object} locale
   * @returns {GregorianCalendar}
   * @static
   */
  getTimeInstance: function getTimeInstance(timeStyle, locale) {
    return this.getDateTimeInstance(undefined, timeStyle, locale);
  }
});

module.exports = DateTimeFormat;

DateTimeFormat.version = '@VERSION@';

// gc_format@163.com

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(289);
var global = __webpack_require__(20);
var hide = __webpack_require__(40);
var Iterators = __webpack_require__(56);
var TO_STRING_TAG = __webpack_require__(24)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.loadCss=undefined;var _window=__webpack_require__(33);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loadCss=exports.loadCss=function loadCss(){if(self!=_window2.default.getTop()){if(window.notThrowCss!==true){var topCss=[],currentCss=[],_loadCss=[];$("link").each(function(){if($(this).attr("href")&&$(this).attr("href").indexOf("?")>-1){currentCss.push($(this).attr("href").slice(0,$(this).attr("href").indexOf("?")));}else{currentCss.push($(this).attr("href"));}});$(_window2.default.getTop().document).find("link").each(function(){if($(this).attr("href")&&$(this).attr("href").indexOf("?")>-1){topCss.push($(this).attr("href").slice(0,$(this).attr("href").indexOf("?")));}else{topCss.push($(this).attr("href"));}});currentCss.forEach(function(item){if(topCss.indexOf(item)<0){_loadCss.push(item);}});_loadCss.forEach(function(item){_window2.default.getTop().document.head.appendChild($("<link rel=\"stylesheet\" type=\"text/css\" href=\""+item+"\">")[0]);});}}};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(121);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(456);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  eras: ['BC', 'AD'],
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  shortWeekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  veryShortWeekdays: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  ampms: ['AM', 'PM'],
  datePatterns: ['EEEE, MMMM d, yyyy', 'MMMM d, yyyy', 'MMM d, yyyy', 'M/d/yy'],
  timePatterns: ['h:mm:ss a \'GMT\'Z', 'h:mm:ss a', 'h:mm:ss a', 'h:mm a'],
  dateTimePattern: '{date} {time}'
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(61);
var TAG = __webpack_require__(24)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(147);
var ITERATOR = __webpack_require__(24)('iterator');
var Iterators = __webpack_require__(56);
module.exports = __webpack_require__(14).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(344), __esModule: true };

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):t.dayjs=n()}(this,function(){"use strict";var t="millisecond",n="second",e="minute",r="hour",i="day",s="week",u="month",o="quarter",a="year",h=/^(\d{4})-?(\d{1,2})-?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?.?(\d{1,3})?$/,f=/\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,c=function(t,n,e){var r=String(t);return!r||r.length>=n?t:""+Array(n+1-r.length).join(e)+t},d={s:c,z:function(t){var n=-t.utcOffset(),e=Math.abs(n),r=Math.floor(e/60),i=e%60;return(n<=0?"+":"-")+c(r,2,"0")+":"+c(i,2,"0")},m:function(t,n){var e=12*(n.year()-t.year())+(n.month()-t.month()),r=t.clone().add(e,u),i=n-r<0,s=t.clone().add(e+(i?-1:1),u);return Number(-(e+(n-r)/(i?r-s:s-r))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(h){return{M:u,y:a,w:s,d:i,h:r,m:e,s:n,ms:t,Q:o}[h]||String(h||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},$={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},l="en",m={};m[l]=$;var y=function(t){return t instanceof v},M=function(t,n,e){var r;if(!t)return l;if("string"==typeof t)m[t]&&(r=t),n&&(m[t]=n,r=t);else{var i=t.name;m[i]=t,r=i}return e||(l=r),r},g=function(t,n,e){if(y(t))return t.clone();var r=n?"string"==typeof n?{format:n,pl:e}:n:{};return r.date=t,new v(r)},D=d;D.l=M,D.i=y,D.w=function(t,n){return g(t,{locale:n.$L,utc:n.$u,$offset:n.$offset})};var v=function(){function c(t){this.$L=this.$L||M(t.locale,null,!0),this.parse(t)}var d=c.prototype;return d.parse=function(t){this.$d=function(t){var n=t.date,e=t.utc;if(null===n)return new Date(NaN);if(D.u(n))return new Date;if(n instanceof Date)return new Date(n);if("string"==typeof n&&!/Z$/i.test(n)){var r=n.match(h);if(r)return e?new Date(Date.UTC(r[1],r[2]-1,r[3]||1,r[4]||0,r[5]||0,r[6]||0,r[7]||0)):new Date(r[1],r[2]-1,r[3]||1,r[4]||0,r[5]||0,r[6]||0,r[7]||0)}return new Date(n)}(t),this.init()},d.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},d.$utils=function(){return D},d.isValid=function(){return!("Invalid Date"===this.$d.toString())},d.isSame=function(t,n){var e=g(t);return this.startOf(n)<=e&&e<=this.endOf(n)},d.isAfter=function(t,n){return g(t)<this.startOf(n)},d.isBefore=function(t,n){return this.endOf(n)<g(t)},d.$g=function(t,n,e){return D.u(t)?this[n]:this.set(e,t)},d.year=function(t){return this.$g(t,"$y",a)},d.month=function(t){return this.$g(t,"$M",u)},d.day=function(t){return this.$g(t,"$W",i)},d.date=function(t){return this.$g(t,"$D","date")},d.hour=function(t){return this.$g(t,"$H",r)},d.minute=function(t){return this.$g(t,"$m",e)},d.second=function(t){return this.$g(t,"$s",n)},d.millisecond=function(n){return this.$g(n,"$ms",t)},d.unix=function(){return Math.floor(this.valueOf()/1e3)},d.valueOf=function(){return this.$d.getTime()},d.startOf=function(t,o){var h=this,f=!!D.u(o)||o,c=D.p(t),d=function(t,n){var e=D.w(h.$u?Date.UTC(h.$y,n,t):new Date(h.$y,n,t),h);return f?e:e.endOf(i)},$=function(t,n){return D.w(h.toDate()[t].apply(h.toDate(),(f?[0,0,0,0]:[23,59,59,999]).slice(n)),h)},l=this.$W,m=this.$M,y=this.$D,M="set"+(this.$u?"UTC":"");switch(c){case a:return f?d(1,0):d(31,11);case u:return f?d(1,m):d(0,m+1);case s:var g=this.$locale().weekStart||0,v=(l<g?l+7:l)-g;return d(f?y-v:y+(6-v),m);case i:case"date":return $(M+"Hours",0);case r:return $(M+"Minutes",1);case e:return $(M+"Seconds",2);case n:return $(M+"Milliseconds",3);default:return this.clone()}},d.endOf=function(t){return this.startOf(t,!1)},d.$set=function(s,o){var h,f=D.p(s),c="set"+(this.$u?"UTC":""),d=(h={},h[i]=c+"Date",h.date=c+"Date",h[u]=c+"Month",h[a]=c+"FullYear",h[r]=c+"Hours",h[e]=c+"Minutes",h[n]=c+"Seconds",h[t]=c+"Milliseconds",h)[f],$=f===i?this.$D+(o-this.$W):o;if(f===u||f===a){var l=this.clone().set("date",1);l.$d[d]($),l.init(),this.$d=l.set("date",Math.min(this.$D,l.daysInMonth())).toDate()}else d&&this.$d[d]($);return this.init(),this},d.set=function(t,n){return this.clone().$set(t,n)},d.get=function(t){return this[D.p(t)]()},d.add=function(t,o){var h,f=this;t=Number(t);var c=D.p(o),d=function(n){var e=g(f);return D.w(e.date(e.date()+Math.round(n*t)),f)};if(c===u)return this.set(u,this.$M+t);if(c===a)return this.set(a,this.$y+t);if(c===i)return d(1);if(c===s)return d(7);var $=(h={},h[e]=6e4,h[r]=36e5,h[n]=1e3,h)[c]||1,l=this.$d.getTime()+t*$;return D.w(l,this)},d.subtract=function(t,n){return this.add(-1*t,n)},d.format=function(t){var n=this;if(!this.isValid())return"Invalid Date";var e=t||"YYYY-MM-DDTHH:mm:ssZ",r=D.z(this),i=this.$locale(),s=this.$H,u=this.$m,o=this.$M,a=i.weekdays,h=i.months,c=function(t,r,i,s){return t&&(t[r]||t(n,e))||i[r].substr(0,s)},d=function(t){return D.s(s%12||12,t,"0")},$=i.meridiem||function(t,n,e){var r=t<12?"AM":"PM";return e?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:o+1,MM:D.s(o+1,2,"0"),MMM:c(i.monthsShort,o,h,3),MMMM:h[o]||h(this,e),D:this.$D,DD:D.s(this.$D,2,"0"),d:String(this.$W),dd:c(i.weekdaysMin,this.$W,a,2),ddd:c(i.weekdaysShort,this.$W,a,3),dddd:a[this.$W],H:String(s),HH:D.s(s,2,"0"),h:d(1),hh:d(2),a:$(s,u,!0),A:$(s,u,!1),m:String(u),mm:D.s(u,2,"0"),s:String(this.$s),ss:D.s(this.$s,2,"0"),SSS:D.s(this.$ms,3,"0"),Z:r};return e.replace(f,function(t,n){return n||l[t]||r.replace(":","")})},d.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},d.diff=function(t,h,f){var c,d=D.p(h),$=g(t),l=6e4*($.utcOffset()-this.utcOffset()),m=this-$,y=D.m(this,$);return y=(c={},c[a]=y/12,c[u]=y,c[o]=y/3,c[s]=(m-l)/6048e5,c[i]=(m-l)/864e5,c[r]=m/36e5,c[e]=m/6e4,c[n]=m/1e3,c)[d]||m,f?y:D.a(y)},d.daysInMonth=function(){return this.endOf(u).$D},d.$locale=function(){return m[this.$L]},d.locale=function(t,n){if(!t)return this.$L;var e=this.clone(),r=M(t,n,!0);return r&&(e.$L=r),e},d.clone=function(){return D.w(this.$d,this)},d.toDate=function(){return new Date(this.valueOf())},d.toJSON=function(){return this.isValid()?this.toISOString():null},d.toISOString=function(){return this.$d.toISOString()},d.toString=function(){return this.$d.toUTCString()},c}();return g.prototype=v.prototype,g.extend=function(t,n){return t(n,v,g),g},g.locale=M,g.isDayjs=y,g.unix=function(t){return g(1e3*t)},g.en=m[l],g.Ls=m,g});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _DecadePanel=__webpack_require__(563);var _DecadePanel2=_interopRequireDefault(_DecadePanel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ROW=4;var COL=3;function goYear(direction){var value=this.state.value.clone();value.addYear(direction);this.setState({value:value});}function chooseYear(year){var value=this.state.value.clone();value.setYear(year);value.rollSetMonth(this.state.value.getMonth());this.props.onSelect(value);}var YearPanel=function(_React$Component){(0,_inherits3.default)(YearPanel,_React$Component);function YearPanel(props){(0,_classCallCheck3.default)(this,YearPanel);var _this=(0,_possibleConstructorReturn3.default)(this,(YearPanel.__proto__||(0,_getPrototypeOf2.default)(YearPanel)).call(this,props));_this.prefixCls=props.rootPrefixCls+"-year-panel";_this.state={value:props.value||props.defaultValue};_this.nextDecade=goYear.bind(_this,10);_this.previousDecade=goYear.bind(_this,-10);["showDecadePanel","onDecadePanelSelect"].forEach(function(method){_this[method]=_this[method].bind(_this);});return _this;}(0,_createClass3.default)(YearPanel,[{key:"onDecadePanelSelect",value:function onDecadePanelSelect(current){this.setState({value:current,showDecadePanel:0});}},{key:"getYears",value:function getYears(){var value=this.state.value;var currentYear=value.getYear();var startYear=parseInt(currentYear/10,10)*10;var previousYear=startYear-1;var endYear=startYear+9;var years=[];var index=0;for(var rowIndex=0;rowIndex<ROW;rowIndex++){years[rowIndex]=[];for(var colIndex=0;colIndex<COL;colIndex++){var year=previousYear+index;var content=void 0;if(year<startYear){content="";}else if(year>endYear){content="";}else{content=String(year);}years[rowIndex][colIndex]={content:content,year:year,title:content};index++;}}return years;}},{key:"showDecadePanel",value:function showDecadePanel(){this.setState({showDecadePanel:1});}},{key:"render",value:function render(){var _this2=this;var props=this.props;var value=this.state.value;var locale=props.locale;var years=this.getYears();var currentYear=value.getYear();var startYear=parseInt(currentYear/10,10)*10;var endYear=startYear+9;var prefixCls=this.prefixCls;var yeasEls=years.map(function(row,index){var tds=row.map(function(yearData){var _classNameMap;var classNameMap=(_classNameMap={},(0,_defineProperty3.default)(_classNameMap,prefixCls+"-cell",1),(0,_defineProperty3.default)(_classNameMap,prefixCls+"-selected-cell",yearData.year===currentYear),(0,_defineProperty3.default)(_classNameMap,prefixCls+"-last-decade-cell",yearData.year<startYear),(0,_defineProperty3.default)(_classNameMap,prefixCls+"-next-decade-cell",yearData.year>endYear),_classNameMap);var clickHandler=void 0;if(yearData.year<startYear){clickHandler=_this2.previousDecade;}else if(yearData.year>endYear){clickHandler=_this2.nextDecade;}else{clickHandler=chooseYear.bind(_this2,yearData.year);}return _react2.default.createElement("td",{ecId:props.ecId+"_td@znb1yp@"+yearData.content,role:"gridcell",title:yearData.title,key:yearData.content,onClick:clickHandler,className:(0,_classnames2.default)(classNameMap)},_react2.default.createElement("a",{className:prefixCls+"-year"},yearData.content));});return _react2.default.createElement("tr",{key:index,role:"row"},tds);});var decadePanel=void 0;if(this.state.showDecadePanel){decadePanel=_react2.default.createElement(_DecadePanel2.default,{ecId:props.ecId+"_DecadePanel@y4cukv",locale:locale,value:value,rootPrefixCls:props.rootPrefixCls,onSelect:this.onDecadePanelSelect});}return _react2.default.createElement("div",{className:this.prefixCls},_react2.default.createElement("div",null,_react2.default.createElement("div",{className:prefixCls+"-header"},_react2.default.createElement("a",{ecId:props.ecId+"_a@2xsnod",role:"button",className:prefixCls+"-prev-decade-btn",onClick:this.previousDecade,title:locale.previousDecade},"\xAB"),_react2.default.createElement("a",{ecId:props.ecId+"_a@jyny7n",role:"button",className:prefixCls+"-decade-select",onClick:this.showDecadePanel,title:locale.decadeSelect},_react2.default.createElement("span",{className:prefixCls+"-decade-select-content"},startYear,"-",endYear),_react2.default.createElement("span",{className:prefixCls+"-decade-select-arrow"},"x")),_react2.default.createElement("a",{ecId:props.ecId+"_a@6ggkfb",role:"button",className:prefixCls+"-next-decade-btn",onClick:this.nextDecade,title:locale.nextDecade},"\xBB")),_react2.default.createElement("div",{className:prefixCls+"-body"},_react2.default.createElement("table",{className:prefixCls+"-table",cellSpacing:"0",role:"grid"},_react2.default.createElement("tbody",{className:prefixCls+"-tbody"},yeasEls)))),decadePanel);}}]);return YearPanel;}(_react2.default.Component);exports.default=YearPanel;YearPanel.propTypes={rootPrefixCls:_react.PropTypes.string,value:_react.PropTypes.object,defaultValue:_react.PropTypes.object};YearPanel.defaultProps={onSelect:function onSelect(){}};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

function mirror(o) {
  return o;
}

module.exports = function mapSelf(children) {
  // return ReactFragment
  return React.Children.map(children, mirror);
};

/***/ }),
/* 153 */
/***/ (function(module, exports) {



/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(58);
var $export = __webpack_require__(25);
var redefine = __webpack_require__(156);
var hide = __webpack_require__(40);
var Iterators = __webpack_require__(56);
var $iterCreate = __webpack_require__(285);
var setToStringTag = __webpack_require__(75);
var getPrototypeOf = __webpack_require__(160);
var ITERATOR = __webpack_require__(24)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(32) && !__webpack_require__(50)(function () {
  return Object.defineProperty(__webpack_require__(103)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(40);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(41);
var toIObject = __webpack_require__(51);
var arrayIndexOf = __webpack_require__(287)(false);
var IE_PROTO = __webpack_require__(107)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(61);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(20).document;
module.exports = document && document.documentElement;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(41);
var toObject = __webpack_require__(52);
var IE_PROTO = __webpack_require__(107)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(30);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(56);
var ITERATOR = __webpack_require__(24)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(30);
var aFunction = __webpack_require__(73);
var SPECIES = __webpack_require__(24)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(49);
var invoke = __webpack_require__(295);
var html = __webpack_require__(159);
var cel = __webpack_require__(103);
var global = __webpack_require__(20);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(61)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(30);
var isObject = __webpack_require__(34);
var newPromiseCapability = __webpack_require__(110);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(24)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(303);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(157);
var hiddenKeys = __webpack_require__(109).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(77);
var createDesc = __webpack_require__(59);
var toIObject = __webpack_require__(51);
var toPrimitive = __webpack_require__(104);
var has = __webpack_require__(41);
var IE8_DOM_DEFINE = __webpack_require__(155);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(32) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(78),
    arrayMap = __webpack_require__(320),
    isArray = __webpack_require__(26),
    isSymbol = __webpack_require__(79);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 173 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(25);
var core = __webpack_require__(14);
var fails = __webpack_require__(50);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(336), __esModule: true };

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.readState=exports.saveState=undefined;var _stringify=__webpack_require__(71);var _stringify2=_interopRequireDefault(_stringify);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var QuotaExceededErrors={QuotaExceededError:true,QUOTA_EXCEEDED_ERR:true};var SecurityErrors={SecurityError:true};var KeyPrefix='@@History/';var createKey=function createKey(key){return KeyPrefix+key;};var saveState=exports.saveState=function saveState(key,state){if(!window.sessionStorage){// Session storage is not available or hidden.
// sessionStorage is undefined in Internet Explorer when served via file protocol.
(0,_warning2.default)(false,'[history] Unable to save state; sessionStorage is not available');return;}try{if(state==null){window.sessionStorage.removeItem(createKey(key));}else{window.sessionStorage.setItem(createKey(key),(0,_stringify2.default)(state));}}catch(error){if(SecurityErrors[error.name]){// Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
// attempt to access window.sessionStorage.
(0,_warning2.default)(false,'[history] Unable to save state; sessionStorage is not available due to security settings');return;}if(QuotaExceededErrors[error.name]&&window.sessionStorage.length===0){// Safari "private mode" throws QuotaExceededError.
(0,_warning2.default)(false,'[history] Unable to save state; sessionStorage is not available in Safari private mode');return;}throw error;}};var readState=exports.readState=function readState(key){var json=void 0;try{json=window.sessionStorage.getItem(createKey(key));}catch(error){if(SecurityErrors[error.name]){// Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
// attempt to access window.sessionStorage.
(0,_warning2.default)(false,'[history] Unable to read state; sessionStorage is not available due to security settings');return undefined;}}if(json){try{return JSON.parse(json);}catch(error){// Ignore invalid JSON.
}}return undefined;};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(361), __esModule: true };

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var animation=void 0;function isCssAnimationSupported(){if(animation!==undefined){return animation;}var domPrefixes='Webkit Moz O ms Khtml'.split(' ');var elm=document.createElement('div');if(elm.style.animationName!==undefined){animation=true;}if(animation!==undefined){for(var i=0;i<domPrefixes.length;i++){if(elm.style[domPrefixes[i]+'AnimationName']!==undefined){animation=true;break;}}}animation=animation||false;return animation;}exports.default=isCssAnimationSupported;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var BreadcrumbItem=(_temp=_class=function(_React$Component){(0,_inherits3.default)(BreadcrumbItem,_React$Component);function BreadcrumbItem(){(0,_classCallCheck3.default)(this,BreadcrumbItem);return(0,_possibleConstructorReturn3.default)(this,(BreadcrumbItem.__proto__||(0,_getPrototypeOf2.default)(BreadcrumbItem)).apply(this,arguments));}(0,_createClass3.default)(BreadcrumbItem,[{key:'render',value:function render(){var _props=this.props,prefixCls=_props.prefixCls,separator=_props.separator,children=_props.children,restProps=(0,_objectWithoutProperties3.default)(_props,['prefixCls','separator','children']);var link=void 0;if('href'in this.props){link=_react2.default.createElement('a',(0,_extends3.default)({className:prefixCls+'-link'},restProps),children);}else{link=_react2.default.createElement('span',(0,_extends3.default)({className:prefixCls+'-link'},restProps),children);}return _react2.default.createElement('span',null,link,_react2.default.createElement('span',{className:prefixCls+'-separator'},separator));}}]);return BreadcrumbItem;}(_react2.default.Component),_class.defaultProps={prefixCls:'ant-breadcrumb',separator:'/'},_class.propTypes={prefixCls:_react2.default.PropTypes.string,separator:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string,_react2.default.PropTypes.element]),href:_react2.default.PropTypes.string},_temp);exports.default=BreadcrumbItem;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * @ignore
 * const for gregorian date
 * @author yiminghe@gmail.com
 */module.exports={/*
   * Enum indicating sunday
   * @type Number
   * @member Date.Gregorian
   */SUNDAY:0,/*
   * Enum indicating monday
   * @type Number
   * @member Date.Gregorian
   */MONDAY:1,/*
   * Enum indicating tuesday
   * @type Number
   * @member Date.Gregorian
   */TUESDAY:2,/*
   * Enum indicating wednesday
   * @type Number
   * @member Date.Gregorian
   */WEDNESDAY:3,/*
   * Enum indicating thursday
   * @type Number
   * @member Date.Gregorian
   */THURSDAY:4,/*
   * Enum indicating friday
   * @type Number
   * @member Date.Gregorian
   */FRIDAY:5,/*
   * Enum indicating saturday
   * @type Number
   * @member Date.Gregorian
   */SATURDAY:6,/*
   * Enum indicating january
   * @type Number
   * @member Date.Gregorian
   */JANUARY:0,/*
   * Enum indicating february
   * @type Number
   * @member Date.Gregorian
   */FEBRUARY:1,/*
   * Enum indicating march
   * @type Number
   * @member Date.Gregorian
   */MARCH:2,/*
   * Enum indicating april
   * @type Number
   * @member Date.Gregorian
   */APRIL:3,/*
   * Enum indicating may
   * @type Number
   * @member Date.Gregorian
   */MAY:4,/*
   * Enum indicating june
   * @type Number
   * @member Date.Gregorian
   */JUNE:5,/*
   * Enum indicating july
   * @type Number
   * @member Date.Gregorian
   */JULY:6,/*
   * Enum indicating august
   * @type Number
   * @member Date.Gregorian
   */AUGUST:7,/*
   * Enum indicating september
   * @type Number
   * @member Date.Gregorian
   */SEPTEMBER:8,/*
   * Enum indicating october
   * @type Number
   * @member Date.Gregorian
   */OCTOBER:9,/*
   * Enum indicating november
   * @type Number
   * @member Date.Gregorian
   */NOVEMBER:10,/*
   * Enum indicating december
   * @type Number
   * @member Date.Gregorian
   */DECEMBER:11};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  eras: ['公元前', '公元'],
  months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
  shortMonths: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
  weekdays: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
  shortWeekdays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
  veryShortWeekdays: ['日', '一', '二', '三', '四', '五', '六'],
  ampms: ['上午', '下午'],
  datePatterns: ['yyyy\'年\'M\'月\'d\'日\' EEEE', 'yyyy\'年\'M\'月\'d\'日\'', 'yyyy-M-d', 'yy-M-d'],
  timePatterns: ['ahh\'时\'mm\'分\'ss\'秒\' \'GMT\'Z', 'ahh\'时\'mm\'分\'ss\'秒\'', 'H:mm:ss', 'ah:mm'],
  dateTimePattern: '{date} {time}'
};

/***/ }),
/* 184 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(258),
    arraySome = __webpack_require__(435),
    cacheHas = __webpack_require__(259);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(28);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(188),
    baseKeys = __webpack_require__(189),
    isArrayLike = __webpack_require__(67);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(445),
    isArguments = __webpack_require__(86),
    isArray = __webpack_require__(26),
    isBuffer = __webpack_require__(87),
    isIndex = __webpack_require__(66),
    isTypedArray = __webpack_require__(88);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(89),
    nativeKeys = __webpack_require__(451);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(452),
    Map = __webpack_require__(123),
    Promise = __webpack_require__(453),
    Set = __webpack_require__(260),
    WeakMap = __webpack_require__(454),
    baseGetTag = __webpack_require__(42),
    toSource = __webpack_require__(184);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _KeyCode=__webpack_require__(47);var _KeyCode2=_interopRequireDefault(_KeyCode);var _createChainedFunction=__webpack_require__(99);var _createChainedFunction2=_interopRequireDefault(_createChainedFunction);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _domScrollIntoView=__webpack_require__(145);var _domScrollIntoView2=_interopRequireDefault(_domScrollIntoView);var _objectAssign=__webpack_require__(19);var _objectAssign2=_interopRequireDefault(_objectAssign);var _util=__webpack_require__(90);var _DOMWrap=__webpack_require__(458);var _DOMWrap2=_interopRequireDefault(_DOMWrap);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function allDisabled(arr){if(!arr.length){return true;}return arr.every(function(c){return!!c.props.disabled;});}function getActiveKey(props,originalActiveKey){var activeKey=originalActiveKey;var children=props.children;var eventKey=props.eventKey;if(activeKey){var found=void 0;(0,_util.loopMenuItem)(children,function(c,i){if(!c.props.disabled&&activeKey===(0,_util.getKeyFromChildrenIndex)(c,eventKey,i)){found=true;}});if(found){return activeKey;}}activeKey=null;if(props.defaultActiveFirst){(0,_util.loopMenuItem)(children,function(c,i){if(!activeKey&&!c.props.disabled){activeKey=(0,_util.getKeyFromChildrenIndex)(c,eventKey,i);}});return activeKey;}return activeKey;}function saveRef(index,subIndex,c){if(c){if(subIndex!==undefined){this.instanceArray[index]=this.instanceArray[index]||[];this.instanceArray[index][subIndex]=c;}else{this.instanceArray[index]=c;}}}var MenuMixin={propTypes:{focusable:_react.PropTypes.bool,multiple:_react.PropTypes.bool,style:_react.PropTypes.object,defaultActiveFirst:_react.PropTypes.bool,visible:_react.PropTypes.bool,activeKey:_react.PropTypes.string,selectedKeys:_react.PropTypes.arrayOf(_react.PropTypes.string),defaultSelectedKeys:_react.PropTypes.arrayOf(_react.PropTypes.string),defaultOpenKeys:_react.PropTypes.arrayOf(_react.PropTypes.string),openKeys:_react.PropTypes.arrayOf(_react.PropTypes.string),children:_react.PropTypes.any},getDefaultProps:function getDefaultProps(){return{prefixCls:"rc-menu",className:"",mode:"vertical",level:1,inlineIndent:24,visible:true,focusable:true,style:{}};},getInitialState:function getInitialState(){var props=this.props;return{activeKey:getActiveKey(props,props.activeKey)};},componentWillReceiveProps:function componentWillReceiveProps(nextProps){var props=void 0;if("activeKey"in nextProps){props={activeKey:getActiveKey(nextProps,nextProps.activeKey)};}else{var originalActiveKey=this.state.activeKey;var activeKey=getActiveKey(nextProps,originalActiveKey);// fix: this.setState(), parent.render(),
if(activeKey!==originalActiveKey){props={activeKey:activeKey};}}if(props){this.setState(props);}},shouldComponentUpdate:function shouldComponentUpdate(nextProps){return this.props.visible||nextProps.visible;},componentWillMount:function componentWillMount(){this.instanceArray=[];},// all keyboard events callbacks run from here at first
onKeyDown:function onKeyDown(e){var _this=this;var keyCode=e.keyCode;var handled=void 0;this.getFlatInstanceArray().forEach(function(obj){if(obj&&obj.props.active){handled=obj.onKeyDown(e);}});if(handled){return 1;}var activeItem=null;if(keyCode===_KeyCode2.default.UP||keyCode===_KeyCode2.default.DOWN){activeItem=this.step(keyCode===_KeyCode2.default.UP?-1:1);}if(activeItem){e.preventDefault();this.setState({activeKey:activeItem.props.eventKey},function(){(0,_domScrollIntoView2.default)(_reactDom2.default.findDOMNode(activeItem),_reactDom2.default.findDOMNode(_this),{onlyScrollIfNeeded:true});});return 1;}else if(activeItem===undefined){e.preventDefault();this.setState({activeKey:null});return 1;}},onCommonItemHover:function onCommonItemHover(e){var mode=this.props.mode;var key=e.key,hover=e.hover,trigger=e.trigger;var activeKey=this.state.activeKey;if(!trigger||hover||this.props.closeSubMenuOnMouseLeave||!e.item.isSubMenu||mode==="inline"){this.setState({activeKey:hover?key:null});}else{}// keep active for sub menu for click active
// empty
// clear last open status
if(hover&&mode!=="inline"){var activeItem=this.getFlatInstanceArray().filter(function(c){return c&&c.props.eventKey===activeKey;})[0];if(activeItem&&activeItem.isSubMenu&&activeItem.props.eventKey!==key){this.onOpenChange({item:activeItem,key:activeItem.props.eventKey,open:false});}}},getFlatInstanceArray:function getFlatInstanceArray(){var instanceArray=this.instanceArray;var hasInnerArray=instanceArray.some(function(a){return Array.isArray(a);});if(hasInnerArray){instanceArray=[];this.instanceArray.forEach(function(a){if(Array.isArray(a)){instanceArray.push.apply(instanceArray,a);}else{instanceArray.push(a);}});this.instanceArray=instanceArray;}return instanceArray;},renderCommonMenuItem:function renderCommonMenuItem(child,i,subIndex,extraProps){var state=this.state;var props=this.props;var key=(0,_util.getKeyFromChildrenIndex)(child,props.eventKey,i);var childProps=child.props;var isActive=key===state.activeKey;var newChildProps=(0,_objectAssign2.default)({mode:props.mode,level:props.level,inlineIndent:props.inlineIndent,renderMenuItem:this.renderMenuItem,rootPrefixCls:props.prefixCls,index:i,parentMenu:this,ref:childProps.disabled?undefined:(0,_createChainedFunction2.default)(child.ref,saveRef.bind(this,i,subIndex)),eventKey:key,closeSubMenuOnMouseLeave:props.closeSubMenuOnMouseLeave,onItemHover:this.onItemHover,active:!childProps.disabled&&isActive,multiple:props.multiple,onClick:this.onClick,openTransitionName:this.getOpenTransitionName(),openAnimation:props.openAnimation,onOpenChange:this.onOpenChange,onDeselect:this.onDeselect,onDestroy:this.onDestroy,onSelect:this.onSelect,visible:props.visible},extraProps);if(props.mode==="inline"){newChildProps.closeSubMenuOnMouseLeave=newChildProps.openSubMenuOnMouseEnter=false;}return _react2.default.cloneElement(child,newChildProps);},renderRoot:function renderRoot(props){var _classes;this.instanceArray=[];var classes=(_classes={},(0,_defineProperty3.default)(_classes,props.prefixCls,1),(0,_defineProperty3.default)(_classes,props.prefixCls+"-"+props.mode,1),(0,_defineProperty3.default)(_classes,props.className,!!props.className),_classes);var domProps={className:(0,_classnames2.default)(classes),role:"menu","aria-activedescendant":""};if(props.id){domProps.id=props.id;}if(props.focusable){domProps.tabIndex="0";domProps.onKeyDown=this.onKeyDown;}return(// ESLint is not smart enough to know that the type of `children` was checked.
/* eslint-disable */_react2.default.createElement(_DOMWrap2.default,(0,_extends3.default)({style:props.style,tag:"ul",hiddenClassName:props.prefixCls+"-hidden",visible:props.visible},domProps,{ecId:this.props.ecId+"_DOMWrap@4tb1gu"}),_react2.default.Children.map(props.children,this.renderMenuItem))/*eslint-enable */);},step:function step(direction){var children=this.getFlatInstanceArray();var activeKey=this.state.activeKey;var len=children.length;if(!len){return null;}if(direction<0){children=children.concat().reverse();}// find current activeIndex
var activeIndex=-1;children.every(function(c,ci){if(c&&c.props.eventKey===activeKey){activeIndex=ci;return false;}return true;});if(!this.props.defaultActiveFirst&&activeIndex!==-1){if(allDisabled(children.slice(activeIndex,len-1))){return undefined;}}var start=(activeIndex+1)%len;var i=start;for(;;){var child=children[i];if(!child||child.props.disabled){i=(i+1+len)%len;// complete a loop
if(i===start){return null;}}else{return child;}}}};exports.default=MenuMixin;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(15);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LazyRenderBox=(_temp=_class=function(_Component){(0,_inherits3.default)(LazyRenderBox,_Component);function LazyRenderBox(){(0,_classCallCheck3.default)(this,LazyRenderBox);return(0,_possibleConstructorReturn3.default)(this,(LazyRenderBox.__proto__||(0,_getPrototypeOf2.default)(LazyRenderBox)).apply(this,arguments));}(0,_createClass3.default)(LazyRenderBox,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){return nextProps.hiddenClassName||nextProps.visible;}},{key:"render",value:function render(){var _props=this.props,hiddenClassName=_props.hiddenClassName,visible=_props.visible,props=(0,_objectWithoutProperties3.default)(_props,["hiddenClassName","visible"]);if(hiddenClassName||_react2.default.Children.count(props.children)>1){if(!visible&&hiddenClassName){props.className+=" "+hiddenClassName;}return _react2.default.createElement("div",(0,_extends3.default)({},props,{ecId:props.ecId+"_div@b8pl21"}));}return _react2.default.Children.only(props.children);}}]);return LazyRenderBox;}(_react.Component),_class.propTypes={children:_propTypes2.default.any,className:_propTypes2.default.string,visible:_propTypes2.default.bool,hiddenClassName:_propTypes2.default.string},_temp);exports.default=LazyRenderBox;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);exports.getAlignFromPlacement=getAlignFromPlacement;exports.getPopupClassNameFromAlign=getPopupClassNameFromAlign;exports.saveRef=saveRef;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function isPointsEq(a1,a2){return a1[0]===a2[0]&&a1[1]===a2[1];}function getAlignFromPlacement(builtinPlacements,placementStr,align){var baseAlign=builtinPlacements[placementStr]||{};return(0,_extends3.default)({},baseAlign,align);}function getPopupClassNameFromAlign(builtinPlacements,prefixCls,align){var points=align.points;for(var placement in builtinPlacements){if(builtinPlacements.hasOwnProperty(placement)){if(isPointsEq(builtinPlacements[placement].points,points)){return prefixCls+'-placement-'+placement;}}}return'';}function saveRef(name,component){this[name]=component;}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var autoAdjustOverflow={adjustX:1,adjustY:1};var targetOffset=[0,0];var placements=exports.placements={left:{points:['cr','cl'],overflow:autoAdjustOverflow,offset:[-4,0],targetOffset:targetOffset},right:{points:['cl','cr'],overflow:autoAdjustOverflow,offset:[4,0],targetOffset:targetOffset},top:{points:['bc','tc'],overflow:autoAdjustOverflow,offset:[0,-4],targetOffset:targetOffset},bottom:{points:['tc','bc'],overflow:autoAdjustOverflow,offset:[0,4],targetOffset:targetOffset},topLeft:{points:['bl','tl'],overflow:autoAdjustOverflow,offset:[0,-4],targetOffset:targetOffset},leftTop:{points:['tr','tl'],overflow:autoAdjustOverflow,offset:[-4,0],targetOffset:targetOffset},topRight:{points:['br','tr'],overflow:autoAdjustOverflow,offset:[0,-4],targetOffset:targetOffset},rightTop:{points:['tl','tr'],overflow:autoAdjustOverflow,offset:[4,0],targetOffset:targetOffset},bottomRight:{points:['tr','br'],overflow:autoAdjustOverflow,offset:[0,4],targetOffset:targetOffset},rightBottom:{points:['bl','br'],overflow:autoAdjustOverflow,offset:[4,0],targetOffset:targetOffset},bottomLeft:{points:['tl','bl'],overflow:autoAdjustOverflow,offset:[0,4],targetOffset:targetOffset},leftBottom:{points:['br','bl'],overflow:autoAdjustOverflow,offset:[-4,0],targetOffset:targetOffset}};exports.default=placements;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _radio=__webpack_require__(129);var _radio2=_interopRequireDefault(_radio);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RadioButton=(_temp=_class=function(_React$Component){(0,_inherits3.default)(RadioButton,_React$Component);function RadioButton(){(0,_classCallCheck3.default)(this,RadioButton);return(0,_possibleConstructorReturn3.default)(this,(RadioButton.__proto__||(0,_getPrototypeOf2.default)(RadioButton)).apply(this,arguments));}(0,_createClass3.default)(RadioButton,[{key:"render",value:function render(){return _react2.default.createElement(_radio2.default,this.props);}}]);return RadioButton;}(_react2.default.Component),_class.displayName="RadioButton",_class.defaultProps={prefixCls:"ant-radio-button"},_temp);exports.default=RadioButton;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getCommonLocale=exports.getLabel=undefined;var _isString=__webpack_require__(98);var _isString2=_interopRequireDefault(_isString);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var localeKey="e9_locale";var getLabel=exports.getLabel=function getLabel(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var defaultValue=arguments[1];var type=arguments[2];var loc=window[localeKey]||{};if(type){loc=loc[type];}else{loc=loc.label;}if(!loc)return defaultValue||"";var text=loc[id];if((0,_isString2.default)(id)&&id.indexOf(",")>-1){//支持逗号分割
text=id.split(",").reduce(function(t,c,i){return""+(i==1?loc[t]:t)+loc[c];});}if((0,_isString2.default)(text)&&text.indexOf("undefined")>-1&&defaultValue){text=defaultValue;// addLabelLog(id, defaultValue)
}var str=text||defaultValue;if(!text){// addLabelLog(id, defaultValue)
}return formatStr(str);};var getCommonLocale=exports.getCommonLocale=function getCommonLocale(){return{Popconfirm:{okText:getLabel(16631,"确认"),cancelText:getLabel(201,"取消"),justOkText:getLabel(383773,"知道了"),confirmTitle:getLabel(131329,"信息确认")},Pagination:{total:getLabel("83698","共"),totalUnit:getLabel("128218","条"),operates:getLabel("30585","操作"),items_per_page:getLabel("386261","条/页"),jump_to:getLabel("386262","跳至"),page:getLabel("30642","页"),first_page:getLabel("386263","第一页"),last_page:getLabel("386264","最后一页"),prev_page:getLabel("1258","上一页"),next_page:getLabel("1259","下一页"),prev_5:getLabel("386265","向前 5 页"),next_5:getLabel("386266","向后 5 页")},DatePicker:{lang:{placeholder:getLabel("27938","请选择日期"),rangePlaceholder:[getLabel("24978","开始日期"),getLabel("24980","结束日期")],today:getLabel("15537","今天"),now:getLabel("386451","此刻"),backToToday:getLabel("386452","返回今天"),ok:getLabel("826","确定"),clear:getLabel("311","清除"),month:getLabel("33452","月"),year:getLabel("26577","年"),previousMonth:getLabel("386453","上个月 (翻页上键)"),nextMonth:getLabel("386454","下个月 (翻页下键)"),monthSelect:getLabel("386455","选择月份"),yearSelect:getLabel("386456","选择年份"),decadeSelect:getLabel("386457","选择年代"),yearFormat:getLabel("386465","yyyy'年'"),monthFormat:getLabel("386466","M'月'"),dateFormat:getLabel("386467","yyyy'年'M'月'd'日'"),previousYear:getLabel("386458","上一年 (Control键加左方向键)"),nextYear:getLabel("386459","下一年 (Control键加右方向键)"),previousDecade:getLabel("386460","上一年代"),nextDecade:getLabel("386461","下一年代"),previousCentury:getLabel("386462","上一世纪"),nextCentury:getLabel("386463","下一世纪"),format:{eras:[getLabel("383357","公元前"),getLabel("383358","公元")],months:[getLabel("1492","一月"),getLabel("1493","二月"),getLabel("1494","三月"),getLabel("1495","四月"),getLabel("1496","五月"),getLabel("1497","六月"),getLabel("1498","七月"),getLabel("1499","八月"),getLabel("1800","九月"),getLabel("1801","十月"),getLabel("1802","十一月"),getLabel("1803","十二月")],shortMonths:[getLabel("25825","1月"),getLabel("25826","2月"),getLabel("25827","3月"),getLabel("25828","4月"),getLabel("25829","5月"),getLabel("25830","6月"),getLabel("25831","7月"),getLabel("25832","8月"),getLabel("25833","9月"),getLabel("25834","10月"),getLabel("25835","11月"),getLabel("25836","12月")],weekdays:[getLabel("24626","星期天"),getLabel("392","星期一"),getLabel("393","星期二"),getLabel("394","星期三"),getLabel("395","星期四"),getLabel("396","星期五"),getLabel("397","星期六")],shortWeekdays:[getLabel("16106","周日"),getLabel("16100","周一"),getLabel("16101","周二"),getLabel("16102","周三"),getLabel("16103","周四"),getLabel("16104","周五"),getLabel("16105","周六")],veryShortWeekdays:[getLabel("385820","日"),getLabel("385821","一"),getLabel("385822","二"),getLabel("385823","三"),getLabel("385824","四"),getLabel("385825","五"),getLabel("385826","六")],ampms:[getLabel("16689","上午"),getLabel("16690","下午")],datePatterns:["yyyy'年'M'月'd'日' EEEE","yyyy'年'M'月'd'日'","yyyy-M-d","yy-M-d"],timePatterns:["ahh'时'mm'分'ss'秒' 'GMT'Z","ahh'时'mm'分'ss'秒'","H:mm:ss","ah:mm"],dateTimePattern:"{date} {time}"}},timePickerLocale:{clear:getLabel("311","清除"),placeholder:getLabel("386464","请选择时间"),format:{eras:[getLabel("383357","公元前"),getLabel("383358","公元")],months:[getLabel("1492","一月"),getLabel("1493","二月"),getLabel("1494","三月"),getLabel("1495","四月"),getLabel("1496","五月"),getLabel("1497","六月"),getLabel("1498","七月"),getLabel("1499","八月"),getLabel("1800","九月"),getLabel("1801","十月"),getLabel("1802","十一月"),getLabel("1803","十二月")],shortMonths:[getLabel("25825","1月"),getLabel("25826","2月"),getLabel("25827","3月"),getLabel("25828","4月"),getLabel("25829","5月"),getLabel("25830","6月"),getLabel("25831","7月"),getLabel("25832","8月"),getLabel("25833","9月"),getLabel("25834","10月"),getLabel("25835","11月"),getLabel("25836","12月")],weekdays:[getLabel("24626","星期天"),getLabel("392","星期一"),getLabel("393","星期二"),getLabel("394","星期三"),getLabel("395","星期四"),getLabel("396","星期五"),getLabel("397","星期六")],shortWeekdays:[getLabel("16106","周日"),getLabel("16100","周一"),getLabel("16101","周二"),getLabel("16102","周三"),getLabel("16103","周四"),getLabel("16104","周五"),getLabel("16105","周六")],veryShortWeekdays:[getLabel("385820","日"),getLabel("385821","一"),getLabel("385822","二"),getLabel("385823","三"),getLabel("385824","四"),getLabel("385825","五"),getLabel("385826","六")],ampms:[getLabel("16689","上午"),getLabel("16690","下午")],datePatterns:["yyyy'年'M'月'd'日' EEEE","yyyy'年'M'月'd'日'","yyyy-M-d","yy-M-d"],timePatterns:["ahh'时'mm'分'ss'秒' 'GMT'Z","ahh'时'mm'分'ss'秒'","H:mm:ss","ah:mm"],dateTimePattern:"{date} {time}"},calendar:{timezoneOffset:8*60,firstDayOfWeek:1,minimalDaysInFirstWeek:1}}}};};var formatStr=function formatStr(str){return str.replace(/&quot;/g,'"');};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={DATE_ROW_COUNT:6,DATE_COL_COUNT:7};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * @ignore
 * const for gregorian date
 * @author yiminghe@gmail.com
 */



module.exports = {
  /*
   * Enum indicating sunday
   * @type Number
   * @member Date.Gregorian
   */
  SUNDAY: 0,
  /*
   * Enum indicating monday
   * @type Number
   * @member Date.Gregorian
   */
  MONDAY: 1,
  /*
   * Enum indicating tuesday
   * @type Number
   * @member Date.Gregorian
   */
  TUESDAY: 2,
  /*
   * Enum indicating wednesday
   * @type Number
   * @member Date.Gregorian
   */
  WEDNESDAY: 3,
  /*
   * Enum indicating thursday
   * @type Number
   * @member Date.Gregorian
   */
  THURSDAY: 4,
  /*
   * Enum indicating friday
   * @type Number
   * @member Date.Gregorian
   */
  FRIDAY: 5,
  /*
   * Enum indicating saturday
   * @type Number
   * @member Date.Gregorian
   */
  SATURDAY: 6,
  /*
   * Enum indicating january
   * @type Number
   * @member Date.Gregorian
   */
  JANUARY: 0,
  /*
   * Enum indicating february
   * @type Number
   * @member Date.Gregorian
   */
  FEBRUARY: 1,
  /*
   * Enum indicating march
   * @type Number
   * @member Date.Gregorian
   */
  MARCH: 2,
  /*
   * Enum indicating april
   * @type Number
   * @member Date.Gregorian
   */
  APRIL: 3,
  /*
   * Enum indicating may
   * @type Number
   * @member Date.Gregorian
   */
  MAY: 4,
  /*
   * Enum indicating june
   * @type Number
   * @member Date.Gregorian
   */
  JUNE: 5,
  /*
   * Enum indicating july
   * @type Number
   * @member Date.Gregorian
   */
  JULY: 6,
  /*
   * Enum indicating august
   * @type Number
   * @member Date.Gregorian
   */
  AUGUST: 7,
  /*
   * Enum indicating september
   * @type Number
   * @member Date.Gregorian
   */
  SEPTEMBER: 8,
  /*
   * Enum indicating october
   * @type Number
   * @member Date.Gregorian
   */
  OCTOBER: 9,
  /*
   * Enum indicating november
   * @type Number
   * @member Date.Gregorian
   */
  NOVEMBER: 10,
  /*
   * Enum indicating december
   * @type Number
   * @member Date.Gregorian
   */
  DECEMBER: 11
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error('Keys Missing', spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);

  var trackWidth;

  if (spec.variableWidth) {
    trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
  } else if (spec.centerMode) {
    trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
  } else {
    trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
  }

  var style = {
    opacity: 1,
    width: trackWidth,
    WebkitTransform: 'translate3d(' + spec.left + 'px, 0px, 0px)',
    transform: 'translate3d(' + spec.left + 'px, 0px, 0px)',
    transition: '',
    WebkitTransition: '',
    msTransform: 'translateX(' + spec.left + 'px)'
  };

  // Fallback for IE8
  if (!window.addEventListener && window.attachEvent) {
    style.marginLeft = spec.left + 'px';
  }

  return style;
};

var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);

  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
  return style;
};

var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {

  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth']);

  var slideOffset = 0;
  var targetLeft;
  var targetSlide;

  if (spec.fade) {
    return 0;
  }

  if (spec.infinite) {
    if (spec.slideCount > spec.slidesToShow) {
      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
    }
    if (spec.slideCount % spec.slidesToScroll !== 0) {
      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
        if (spec.slideIndex > spec.slideCount) {
          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
        } else {
          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
        }
      }
    }
  } else {

    if (spec.slideCount % spec.slidesToScroll !== 0) {
      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
        slideOffset = slidesToOffset * spec.slideWidth;
      }
    }
  }

  if (spec.centerMode) {
    if (spec.infinite) {
      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
    } else {
      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
    }
  }

  targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;

  if (spec.variableWidth === true) {
    var targetSlideIndex;
    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
    } else {
      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
    }
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (spec.centerMode === true) {
      if (spec.infinite === false) {
        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
      } else {
        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
      }

      targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
      targetLeft += (spec.listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _trackHelper = __webpack_require__(200);

var _objectAssign = __webpack_require__(19);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var helpers = {
  initialize: function initialize(props) {
    var slideCount = _react2.default.Children.count(props.children);
    var listWidth = this.getWidth(_reactDom2.default.findDOMNode(this.list));
    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
    var slideWidth = trackWidth / props.slidesToShow;

    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;

    this.setState({
      slideCount: slideCount,
      slideWidth: slideWidth,
      listWidth: listWidth,
      trackWidth: trackWidth,
      currentSlide: currentSlide
    }, function () {

      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, props, this.state));
      // getCSS function needs previously set state
      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));

      this.setState({ trackStyle: trackStyle });

      this.autoPlay(); // once we're set up, trigger the initial autoplay.
    });
  },
  update: function update(props) {
    // This method has mostly same code as initialize method.
    // Refactor it
    var slideCount = _react2.default.Children.count(props.children);
    var listWidth = this.getWidth(_reactDom2.default.findDOMNode(this.list));
    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
    var slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this)) / props.slidesToShow;

    // pause slider if autoplay is set to false
    if (!props.autoplay) this.pause();

    this.setState({
      slideCount: slideCount,
      slideWidth: slideWidth,
      listWidth: listWidth,
      trackWidth: trackWidth
    }, function () {

      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, props, this.state));
      // getCSS function needs previously set state
      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));

      this.setState({ trackStyle: trackStyle });
    });
  },
  getWidth: function getWidth(elem) {
    return elem.getBoundingClientRect().width || elem.offsetWidth;
  },
  adaptHeight: function adaptHeight() {
    if (this.props.adaptiveHeight) {
      var selector = '[data-index="' + this.state.currentSlide + '"]';
      if (this.list) {
        var slickList = _reactDom2.default.findDOMNode(this.list);
        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
      }
    }
  },
  slideHandler: function slideHandler(index) {
    var _this = this;

    // Functionality of animateSlide and postSlide is merged into this function
    // console.log('slideHandler', index);
    var targetSlide, currentSlide;
    var targetLeft, currentLeft;
    var callback;

    if (this.props.waitForAnimate && this.state.animating) {
      return;
    }

    if (this.props.fade) {
      currentSlide = this.state.currentSlide;

      // Don't change slide if it's not infite and current slide is the first or last slide.
      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
        return;
      }

      //  Shifting targetSlide back into the range
      if (index < 0) {
        targetSlide = index + this.state.slideCount;
      } else if (index >= this.state.slideCount) {
        targetSlide = index - this.state.slideCount;
      } else {
        targetSlide = index;
      }

      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
        this.setState({
          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
        });
      }

      callback = function callback() {
        _this.setState({
          animating: false
        });
        if (_this.props.afterChange) {
          _this.props.afterChange(targetSlide);
        }
        delete _this.animationEndCallback;
      };

      this.setState({
        animating: true,
        currentSlide: targetSlide
      }, function () {
        this.animationEndCallback = setTimeout(callback, this.props.speed);
      });

      if (this.props.beforeChange) {
        this.props.beforeChange(this.state.currentSlide, targetSlide);
      }

      this.autoPlay();
      return;
    }

    targetSlide = index;
    if (targetSlide < 0) {
      if (this.props.infinite === false) {
        currentSlide = 0;
      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
      } else {
        currentSlide = this.state.slideCount + targetSlide;
      }
    } else if (targetSlide >= this.state.slideCount) {
      if (this.props.infinite === false) {
        currentSlide = this.state.slideCount - this.props.slidesToShow;
      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
        currentSlide = 0;
      } else {
        currentSlide = targetSlide - this.state.slideCount;
      }
    } else {
      currentSlide = targetSlide;
    }

    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
      slideIndex: targetSlide,
      trackRef: this.track
    }, this.props, this.state));

    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
      slideIndex: currentSlide,
      trackRef: this.track
    }, this.props, this.state));

    if (this.props.infinite === false) {
      targetLeft = currentLeft;
    }

    if (this.props.beforeChange) {
      this.props.beforeChange(this.state.currentSlide, currentSlide);
    }

    if (this.props.lazyLoad) {
      var loaded = true;
      var slidesToLoad = [];
      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
        if (!loaded) {
          slidesToLoad.push(i);
        }
      }
      if (!loaded) {
        this.setState({
          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
        });
      }
    }

    // Slide Transition happens here.
    // animated transition happens to target Slide and
    // non - animated transition happens to current Slide
    // If CSS transitions are false, directly go the current slide.

    if (this.props.useCSS === false) {

      this.setState({
        currentSlide: currentSlide,
        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
      }, function () {
        if (this.props.afterChange) {
          this.props.afterChange(currentSlide);
        }
      });
    } else {

      var nextStateChanges = {
        animating: false,
        currentSlide: currentSlide,
        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
        swipeLeft: null
      };

      callback = function callback() {
        _this.setState(nextStateChanges);
        if (_this.props.afterChange) {
          _this.props.afterChange(currentSlide);
        }
        delete _this.animationEndCallback;
      };

      this.setState({
        animating: true,
        currentSlide: currentSlide,
        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
      }, function () {
        this.animationEndCallback = setTimeout(callback, this.props.speed);
      });
    }

    this.autoPlay();
  },
  swipeDirection: function swipeDirection(touchObject) {
    var xDist, yDist, r, swipeAngle;

    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);

    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
      return this.props.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return this.props.rtl === false ? 'right' : 'left';
    }

    return 'vertical';
  },
  autoPlay: function autoPlay() {
    var _this2 = this;

    if (this.state.autoPlayTimer) {
      return;
    }
    var play = function play() {
      if (_this2.state.mounted) {
        var nextIndex = _this2.props.rtl ? _this2.state.currentSlide - _this2.props.slidesToScroll : _this2.state.currentSlide + _this2.props.slidesToScroll;
        _this2.slideHandler(nextIndex);
      }
    };
    if (this.props.autoplay) {
      this.setState({
        autoPlayTimer: window.setInterval(play, this.props.autoplaySpeed)
      });
    }
  },
  pause: function pause() {
    if (this.state.autoPlayTimer) {
      window.clearInterval(this.state.autoPlayTimer);
      this.setState({
        autoPlayTimer: null
      });
    }
  }
};

exports.default = helpers;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaultProps = {
    className: '',
    accessibility: true,
    adaptiveHeight: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    centerMode: false,
    centerPadding: '50px',
    cssEase: 'ease',
    dots: false,
    dotsClass: 'slick-dots',
    draggable: true,
    easing: 'linear',
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: false,
    pauseOnHover: true,
    responsive: null,
    rtl: false,
    slide: 'div',
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    swipe: true,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true,
    afterChange: null,
    beforeChange: null,
    edgeEvent: null,
    init: null,
    swipeEvent: null,
    // nextArrow, prevArrow are react componets
    nextArrow: null,
    prevArrow: null
};

module.exports = defaultProps;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(525);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 204 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 205 */
/***/ (function(module, exports) {

function arrayTreeFilter(data, filterFn, options) {
  options = options || {};
  options.childrenKeyName = options.childrenKeyName || 'children';
  var children = data || [];
  var result = [];
  var level = 0;
  var foundItem;
  do {
    var foundItem = children.filter(function(item) {
      return filterFn(item, level);
    })[0];
    if (!foundItem) {
      break;
    }
    result.push(foundItem);
    children = foundItem[options.childrenKeyName] || [];
    level += 1;
  } while(children.length > 0);
  return result;
}

module.exports = arrayTreeFilter;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Input=__webpack_require__(538);var _Input2=_interopRequireDefault(_Input);var _Group=__webpack_require__(540);var _Group2=_interopRequireDefault(_Group);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_Input2.default.Group=_Group2.default;exports.default=_Input2.default;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _rcCheckbox=__webpack_require__(543);var _rcCheckbox2=_interopRequireDefault(_rcCheckbox);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _reactAddonsPureRenderMixin=__webpack_require__(38);var _reactAddonsPureRenderMixin2=_interopRequireDefault(_reactAddonsPureRenderMixin);var _isEmpty=__webpack_require__(100);var _isEmpty2=_interopRequireDefault(_isEmpty);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Checkbox=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Checkbox,_React$Component);function Checkbox(){(0,_classCallCheck3.default)(this,Checkbox);return(0,_possibleConstructorReturn3.default)(this,(Checkbox.__proto__||(0,_getPrototypeOf2.default)(Checkbox)).apply(this,arguments));}(0,_createClass3.default)(Checkbox,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.apply(this,args);}},{key:"render",value:function render(){var _classNames;var _props=this.props,prefixCls=_props.prefixCls,style=_props.style,children=_props.children,className=_props.className,ecId=_props.ecId,indeterminate=_props.indeterminate,restProps=(0,_objectWithoutProperties3.default)(_props,["prefixCls","style","children","className","ecId","indeterminate"]);var classString=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,className,!!className),(0,_defineProperty3.default)(_classNames,prefixCls+"-wrapper",true),(0,_defineProperty3.default)(_classNames,prefixCls+"-indeterminate",indeterminate),_classNames));return _react2.default.createElement("label",{className:classString,style:style,ecId:ecId+"_label@2g0d78"},_react2.default.createElement(_rcCheckbox2.default,(0,_extends3.default)({},restProps,{prefixCls:prefixCls,children:null})),!(0,_isEmpty2.default)(children)?_react2.default.createElement("span",null,children):null);}}]);return Checkbox;}(_react2.default.Component),_class.defaultProps={prefixCls:"ant-checkbox"},_temp);exports.default=Checkbox;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _layout=__webpack_require__(131);exports.default=_layout.Col;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(569);__webpack_require__(37);

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _src=__webpack_require__(570);var _src2=_interopRequireDefault(_src);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Dropdown=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Dropdown,_React$Component);function Dropdown(){(0,_classCallCheck3.default)(this,Dropdown);return(0,_possibleConstructorReturn3.default)(this,(Dropdown.__proto__||(0,_getPrototypeOf2.default)(Dropdown)).apply(this,arguments));}(0,_createClass3.default)(Dropdown,[{key:"render",value:function render(){return _react2.default.createElement(_src2.default,(0,_extends3.default)({ref:"rcdropdown"},this.props,{ecId:this.props.ecId+"_RcDropdown@04jjjo"}));}}]);return Dropdown;}(_react2.default.Component),_class.defaultProps={transitionName:"slide-up",prefixCls:"ant-dropdown",mouseEnterDelay:0.15,mouseLeaveDelay:0.1},_temp);exports.default=Dropdown;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(574);__webpack_require__(64);

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _toConsumableArray2=__webpack_require__(46);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _utils=__webpack_require__(213);var _asyncValidator=__webpack_require__(578);var _asyncValidator2=_interopRequireDefault(_asyncValidator);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);var _get=__webpack_require__(215);var _get2=_interopRequireDefault(_get);var _has=__webpack_require__(603);var _has2=_interopRequireDefault(_has);var _set=__webpack_require__(605);var _set2=_interopRequireDefault(_set);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DEFAULT_VALIDATE_TRIGGER="onChange";var DEFAULT_TRIGGER=DEFAULT_VALIDATE_TRIGGER;var atom={};function createBaseForm(){var option=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var mixins=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var mapPropsToFields=option.mapPropsToFields,onFieldsChange=option.onFieldsChange,onValuesChange=option.onValuesChange,fieldNameProp=option.fieldNameProp,fieldMetaProp=option.fieldMetaProp,validateMessages=option.validateMessages,_option$mapProps=option.mapProps,mapProps=_option$mapProps===undefined?_utils.mirror:_option$mapProps,_option$formPropName=option.formPropName,formPropName=_option$formPropName===undefined?"form":_option$formPropName,withRef=option.withRef;function decorate(WrappedComponent){var Form=_react2.default.createClass({displayName:"Form",mixins:mixins,getInitialState:function getInitialState(){var fields=void 0;if(mapPropsToFields){fields=mapPropsToFields(this.props);}this.fields=fields||{};this.instances={};this.fieldsMeta={};this.cachedBind={};return{submitting:false};},componentWillReceiveProps:function componentWillReceiveProps(nextProps){if(mapPropsToFields){this.fields=mapPropsToFields(nextProps);}},onCollectCommon:function onCollectCommon(name_,action,args){//console.log("name_:",name_," action:",action," args:",args);
var name=name_;var fieldMeta=this.getFieldMeta(name);if(fieldMeta[action]){fieldMeta[action].apply(fieldMeta,(0,_toConsumableArray3.default)(args));}else if(fieldMeta.originalProps&&fieldMeta.originalProps[action]){var _fieldMeta$originalPr;(_fieldMeta$originalPr=fieldMeta.originalProps)[action].apply(_fieldMeta$originalPr,(0,_toConsumableArray3.default)(args));}var value=fieldMeta.getValueFromEvent?fieldMeta.getValueFromEvent.apply(fieldMeta,(0,_toConsumableArray3.default)(args)):_utils.getValueFromEvent.apply(undefined,(0,_toConsumableArray3.default)(args));//console.log("value:",value);
if(onValuesChange){onValuesChange(this.props,(0,_set2.default)({},name,value));}var nameKeyObj=(0,_utils.getNameIfNested)(name);if(this.getFieldMeta(nameKeyObj.name).exclusive){name=nameKeyObj.name;}var field=this.getField(name);return{name:name,field:(0,_extends3.default)({},field,{value:value,touched:true,valueSpan:args[1]?args[1]:"",valueObj:args[2]?args[2]:""}),fieldMeta:fieldMeta};},onCollect:function onCollect(name_,action){for(var _len=arguments.length,args=Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){args[_key-2]=arguments[_key];}var _onCollectCommon=this.onCollectCommon(name_,action,args),name=_onCollectCommon.name,field=_onCollectCommon.field,fieldMeta=_onCollectCommon.fieldMeta;var validate=fieldMeta.validate;var fieldContent=(0,_extends3.default)({},field,{dirty:(0,_utils.hasRules)(validate)});this.setFields((0,_defineProperty3.default)({},name,fieldContent));},onCollectValidate:function onCollectValidate(name_,action){for(var _len2=arguments.length,args=Array(_len2>2?_len2-2:0),_key2=2;_key2<_len2;_key2++){args[_key2-2]=arguments[_key2];}var _onCollectCommon2=this.onCollectCommon(name_,action,args),field=_onCollectCommon2.field,fieldMeta=_onCollectCommon2.fieldMeta;var fieldContent=(0,_extends3.default)({},field,{dirty:true});this.validateFieldsInternal([fieldContent],{action:action,options:{firstFields:!!fieldMeta.validateFirst}});},getCacheBind:function getCacheBind(name,action,fn){//console.log("name:",name," action:",action," fn:",fn);
var cache=this.cachedBind[name]=this.cachedBind[name]||{};if(!cache[action]){cache[action]=fn.bind(this,name,action);}return cache[action];},getFieldMeta:function getFieldMeta(name){return this.fieldsMeta[name];},getField:function getField(name){var fields=this.fields;return(0,_extends3.default)({},fields[name],{name:name});},getFields:function getFields(){var fields=this.fields;return(0,_extends3.default)({},fields);},getFieldDecorator:function getFieldDecorator(name,fieldOption){var _this=this;var props=this.getFieldProps(name,fieldOption);return function(fieldElem){var fieldMeta=_this.getFieldMeta(name);var originalProps=fieldElem.props;if(false){var valuePropName=fieldMeta.valuePropName;(0,_warning2.default)(!(valuePropName in originalProps),"`getFieldDecorator` will override `"+valuePropName+"`, "+("so please don't set `"+valuePropName+"` directly ")+"and use `setFieldsValue` to set it.");var defaultValuePropName="default"+valuePropName[0].toUpperCase()+valuePropName.slice(1);(0,_warning2.default)(!(defaultValuePropName in originalProps),"`"+defaultValuePropName+"` is invalid "+("for `getFieldDecorator` will set `"+valuePropName+"`,")+" please use `option.initialValue` instead.");}fieldMeta.originalProps=originalProps;fieldMeta.ref=fieldElem.ref;return _react2.default.cloneElement(fieldElem,(0,_extends3.default)({},props,_this.getFieldValuePropValue(fieldMeta)));};},getFieldProps:function getFieldProps(name){var _this2=this;var usersFieldOption=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!name){throw new Error("Must call `getFieldProps` with valid name string!");}var nameIfNested=(0,_utils.getNameIfNested)(name);var leadingName=nameIfNested.name;var fieldOption=(0,_extends3.default)({valuePropName:"value",validate:[],trigger:DEFAULT_TRIGGER,validateTrigger:DEFAULT_VALIDATE_TRIGGER,leadingName:leadingName,name:name},usersFieldOption);var rules=fieldOption.rules,trigger=fieldOption.trigger,exclusive=fieldOption.exclusive,validateTrigger=fieldOption.validateTrigger,validate=fieldOption.validate;var fieldsMeta=this.fieldsMeta;//console.log("fieldsMeta:",fieldsMeta);
var fieldMeta=void 0;fieldMeta=fieldsMeta[name]=fieldsMeta[name]||{};if("initialValue"in fieldOption){fieldMeta.initialValue=fieldOption.initialValue;}var leadingFieldMeta=fieldsMeta[leadingName];if(nameIfNested.isNested){leadingFieldMeta=fieldsMeta[leadingName]=fieldsMeta[leadingName]||{};leadingFieldMeta.virtual=!exclusive;// exclusive allow getFieldProps('x', {initialValue})
// non-exclusive does not allow getFieldProps('x', {initialValue})
leadingFieldMeta.hidden=!exclusive;leadingFieldMeta.exclusive=exclusive;}var inputProps=(0,_extends3.default)({},this.getFieldValuePropValue(fieldOption),{ref:this.getCacheBind(name,name+"__ref",this.saveRef)});if(fieldNameProp){inputProps[fieldNameProp]=name;}var validateRules=(0,_utils.normalizeValidateRules)(validate,rules,validateTrigger);var validateTriggers=validateRules.filter(function(item){return!!item.rules&&item.rules.length;}).map(function(item){return item.trigger;}).reduce(function(pre,curr){return pre.concat(curr);},[]);validateTriggers.forEach(function(action){if(inputProps[action])return;inputProps[action]=_this2.getCacheBind(name,action,_this2.onCollectValidate);});// make sure that the value will be collect
if(trigger&&validateTriggers.indexOf(trigger)===-1){inputProps[trigger]=this.getCacheBind(name,trigger,this.onCollect);}var meta=(0,_extends3.default)({},fieldMeta,fieldOption,{validate:validateRules});//console.log("meta:",meta);
fieldsMeta[name]=meta;if(fieldMetaProp){inputProps[fieldMetaProp]=meta;}return inputProps;},getFieldValuePropValue:function getFieldValuePropValue(fieldMeta){var _ref;var exclusive=fieldMeta.exclusive,leadingName=fieldMeta.leadingName,name=fieldMeta.name,getValueProps=fieldMeta.getValueProps,valuePropName=fieldMeta.valuePropName;var fieldsMeta=this.fieldsMeta;var field=exclusive?this.getField(leadingName):this.getField(name);var fieldValue=atom;if(field&&"value"in field){fieldValue=field.value;}var fieldValueSpan="";if(field&&"valueSpan"in field){fieldValueSpan=field.valueSpan;}var fieldValueObj=null;if(field&&"valueObj"in field){fieldValueObj=field.valueObj;}if(fieldValue===atom){fieldValue=exclusive?fieldsMeta[leadingName].initialValue:fieldMeta.initialValue;}if(getValueProps){return getValueProps(fieldValue);}return _ref={},(0,_defineProperty3.default)(_ref,valuePropName,fieldValue),(0,_defineProperty3.default)(_ref,"valueSpan",fieldValueSpan),(0,_defineProperty3.default)(_ref,"valueObj",fieldValueObj),_ref;},getFieldMember:function getFieldMember(name,member){var field=this.getField(name);return field&&field[member];},getFieldsError:function getFieldsError(names){var _this3=this;var fields=names||(0,_utils.flatFieldNames)(this.getValidFieldsName());var allErrors={};fields.forEach(function(f){(0,_set2.default)(allErrors,f,_this3.getFieldError(f));});return allErrors;},getFieldError:function getFieldError(name){return(0,_utils.getErrorStrs)(this.getFieldMember(name,"errors"));},getValidFieldsName:function getValidFieldsName(){var fieldsMeta=this.fieldsMeta;return fieldsMeta?(0,_keys2.default)(fieldsMeta).filter(function(name){return!fieldsMeta[name].hidden;}):[];},getFieldsValue:function getFieldsValue(names){var _this4=this;var fields=names||(0,_utils.flatFieldNames)(this.getValidFieldsName());var allValues={};fields.forEach(function(f){(0,_set2.default)(allValues,f,_this4.getFieldValue(f));});return allValues;},getFieldValue:function getFieldValue(name){var fields=this.fields;return this.getValueFromFields(name,fields);},getFieldInstance:function getFieldInstance(name){return this.instances[name];},getValueFromFieldsInternal:function getValueFromFieldsInternal(name,fields){var field=fields[name];if(field&&"value"in field){return field.value;}if(field&&"valueSpan"in field&&field.valueSpan){return field.valueSpan;}var fieldMeta=this.fieldsMeta[name];return fieldMeta&&fieldMeta.initialValue;},getValueFromFields:function getValueFromFields(name,fields){var _this5=this;var fieldsMeta=this.fieldsMeta;if(fieldsMeta[name]&&fieldsMeta[name].virtual){var ret={};(0,_keys2.default)(fieldsMeta).forEach(function(fieldKey){var nameIfNested=(0,_utils.getNameIfNested)(fieldKey);if(nameIfNested.name===name&&nameIfNested.isNested){(0,_set2.default)(ret,fieldKey,_this5.getValueFromFieldsInternal(fieldKey,fields));}});return ret[name];}return this.getValueFromFieldsInternal(name,fields);},getRules:function getRules(fieldMeta,action){var actionRules=fieldMeta.validate.filter(function(item){return!action||item.trigger.indexOf(action)>=0;}).map(function(item){return item.rules;});return(0,_utils.flattenArray)(actionRules);},setFields:function setFields(fields_){var _this6=this;var fieldsMeta=this.fieldsMeta;var fields=fields_;var nowFields=(0,_extends3.default)({},this.fields,fields);var nowValues={};(0,_keys2.default)(fieldsMeta).forEach(function(f){var _getNameIfNested=(0,_utils.getNameIfNested)(f),name=_getNameIfNested.name,isNested=_getNameIfNested.isNested;if(isNested&&fieldsMeta[name].exclusive){return;}nowValues[f]=_this6.getValueFromFields(f,nowFields);});(0,_keys2.default)(nowValues).forEach(function(f){var value=nowValues[f];var fieldMeta=fieldsMeta[f];if(fieldMeta&&fieldMeta.normalize){var nowValue=fieldMeta.normalize(value,_this6.getValueFromFields(f,_this6.fields),nowValues);if(nowValue!==value){nowFields[f]=(0,_extends3.default)({},nowFields[f],{value:nowValue});}}});this.fields=nowFields;if(onFieldsChange){var changedFieldsName=(0,_keys2.default)(fields);var changedFields={};changedFieldsName.forEach(function(f){changedFields[f]=_this6.getField(f);});onFieldsChange(this.props,changedFields);}this.forceUpdate();},setFieldsValue:function setFieldsValue(fieldsValue,valueSpan,valueObj){if(onValuesChange){onValuesChange(this.props,fieldsValue);}var newFields={};var fieldsMeta=this.fieldsMeta,fields=this.fields;var virtualPaths=(0,_utils.getVirtualPaths)(fieldsMeta);(0,_keys2.default)(fieldsValue).forEach(function(name){var value=fieldsValue[name];if(fieldsMeta[name]&&fieldsMeta[name].virtual){(0,_utils.clearVirtualField)(name,fields,fieldsMeta);for(var i=0,len=virtualPaths[name].length;i<len;i++){var path=virtualPaths[name][i];if((0,_has2.default)(fieldsValue,path)){newFields[path]={name:path,value:(0,_get2.default)(fieldsValue,path),valueSpan:valueSpan,valueObj:valueObj};}}}else if(fieldsMeta[name]){newFields[name]={name:name,value:value,valueSpan:valueSpan,valueObj:valueObj};}else{//临时加的
newFields[name]={name:name,value:value,valueSpan:valueSpan,valueObj:valueObj};}});this.setFields(newFields);},setFieldsInitialValue:function setFieldsInitialValue(initialValues){var fieldsMeta=this.fieldsMeta;var virtualPaths=(0,_utils.getVirtualPaths)(fieldsMeta);(0,_keys2.default)(initialValues).forEach(function(name){if(fieldsMeta[name]&&fieldsMeta[name].virtual){for(var i=0,len=virtualPaths[name].length;i<len;i++){var path=virtualPaths[name][i];if((0,_has2.default)(initialValues,path)){fieldsMeta[path]=(0,_extends3.default)({},fieldsMeta[path],{initialValue:(0,_get2.default)(initialValues,path)});}}}else if(fieldsMeta[name]){fieldsMeta[name]=(0,_extends3.default)({},fieldsMeta[name],{initialValue:initialValues[name]});}});},saveRef:function saveRef(name,_,component){if(!component){// after destroy, delete data
delete this.fieldsMeta[name];delete this.fields[name];delete this.instances[name];delete this.cachedBind[name];return;}var fieldMeta=this.getFieldMeta(name);if(fieldMeta){var ref=fieldMeta.ref;if(ref){if(typeof ref==="string"){throw new Error("can not set ref string for "+name);}ref(component);}}this.instances[name]=component;},validateFieldsInternal:function validateFieldsInternal(fields,_ref2,callback){var _this7=this;var fieldNames=_ref2.fieldNames,action=_ref2.action,_ref2$options=_ref2.options,options=_ref2$options===undefined?{}:_ref2$options;var allRules={};var allValues={};var allFields={};var alreadyErrors={};fields.forEach(function(field){var name=field.name;if(options.force!==true&&field.dirty===false){if(field.errors){(0,_set2.default)(alreadyErrors,name,{errors:field.errors});}return;}var fieldMeta=_this7.getFieldMeta(name);var newField=(0,_extends3.default)({},field);newField.errors=undefined;newField.validating=true;newField.dirty=true;allRules[name]=_this7.getRules(fieldMeta,action);allValues[name]=newField.value;allFields[name]=newField;});this.setFields(allFields);// in case normalize
(0,_keys2.default)(allValues).forEach(function(f){allValues[f]=_this7.getFieldValue(f);});if(callback&&(0,_utils.isEmptyObject)(allFields)){callback((0,_utils.isEmptyObject)(alreadyErrors)?null:alreadyErrors,this.getFieldsValue((0,_utils.flatFieldNames)(fieldNames)));return;}var validator=new _asyncValidator2.default(allRules);if(validateMessages){validator.messages(validateMessages);}validator.validate(allValues,options,function(errors){var errorsGroup=(0,_extends3.default)({},alreadyErrors);if(errors&&errors.length){errors.forEach(function(e){var fieldName=e.field;if(!(0,_has2.default)(errorsGroup,fieldName)){(0,_set2.default)(errorsGroup,fieldName,{errors:[]});}var fieldErrors=(0,_get2.default)(errorsGroup,fieldName.concat(".errors"));fieldErrors.push(e);});}var expired=[];var nowAllFields={};(0,_keys2.default)(allRules).forEach(function(name){var fieldErrors=(0,_get2.default)(errorsGroup,name);var nowField=_this7.getField(name);// avoid concurrency problems
if(nowField.value!==allValues[name]){expired.push({name:name});}else{nowField.errors=fieldErrors&&fieldErrors.errors;nowField.value=allValues[name];nowField.validating=false;nowField.dirty=false;nowAllFields[name]=nowField;}});_this7.setFields(nowAllFields);if(callback){if(expired.length){expired.forEach(function(_ref3){var name=_ref3.name;var fieldErrors=[{message:name+" need to revalidate",field:name}];(0,_set2.default)(errorsGroup,name,{expired:true,errors:fieldErrors});});}callback((0,_utils.isEmptyObject)(errorsGroup)?null:errorsGroup,_this7.getFieldsValue((0,_utils.flatFieldNames)(fieldNames)));}});},validateFields:function validateFields(ns,opt,cb){var _this8=this;var _getParams=(0,_utils.getParams)(ns,opt,cb),names=_getParams.names,callback=_getParams.callback,options=_getParams.options;var fieldNames=names||this.getValidFieldsName();var fields=fieldNames.filter(function(name){var fieldMeta=_this8.getFieldMeta(name);return(0,_utils.hasRules)(fieldMeta.validate);}).map(function(name){var field=_this8.getField(name);field.value=_this8.getFieldValue(name);return field;});if(!fields.length){if(callback){callback(null,this.getFieldsValue((0,_utils.flatFieldNames)(fieldNames)));}return;}if(!("firstFields"in options)){options.firstFields=fieldNames.filter(function(name){var fieldMeta=_this8.getFieldMeta(name);return!!fieldMeta.validateFirst;});}this.validateFieldsInternal(fields,{fieldNames:fieldNames,options:options},callback);},isFieldValidating:function isFieldValidating(name){return this.getFieldMember(name,"validating");},isFieldsValidating:function isFieldsValidating(ns){var _this9=this;var names=ns||this.getValidFieldsName();return names.some(function(n){return _this9.isFieldValidating(n);});},isFieldTouched:function isFieldTouched(name){return this.getFieldMember(name,"touched");},isFieldsTouched:function isFieldsTouched(ns){var _this10=this;var names=ns||this.getValidFieldsName();return names.some(function(n){return _this10.isFieldTouched(n);});},isSubmitting:function isSubmitting(){return this.state.submitting;},submit:function submit(callback){var _this11=this;var fn=function fn(){_this11.setState({submitting:false});};this.setState({submitting:true});callback(fn);},resetFields:function resetFields(ns){var newFields={};var fields=this.fields;var changed=false;var names=ns||(0,_keys2.default)(fields);names.forEach(function(name){var field=fields[name];if(field&&"value"in field){changed=true;newFields[name]={};}});if(changed){this.setFields(newFields);}},render:function render(){var formProps=(0,_defineProperty3.default)({},formPropName,this.getForm());if(withRef){formProps.ref="wrappedComponent";}var props=mapProps.call(this,(0,_extends3.default)({},formProps,this.props));return _react2.default.createElement(WrappedComponent,(0,_extends3.default)({},props,{ecId:props.ecId+"_WrappedComponent@i9q2c5"}));}});return(0,_utils.argumentContainer)(Form,WrappedComponent);}return decorate;}exports.default=createBaseForm;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);exports.argumentContainer=argumentContainer;exports.getValueFromEvent=getValueFromEvent;exports.getErrorStrs=getErrorStrs;exports.isEmptyObject=isEmptyObject;exports.flattenArray=flattenArray;exports.mirror=mirror;exports.hasRules=hasRules;exports.startsWith=startsWith;exports.getParams=getParams;exports.getNameIfNested=getNameIfNested;exports.flatFieldNames=flatFieldNames;exports.clearVirtualField=clearVirtualField;exports.getVirtualPaths=getVirtualPaths;exports.normalizeValidateRules=normalizeValidateRules;var _hoistNonReactStatics=__webpack_require__(577);var _hoistNonReactStatics2=_interopRequireDefault(_hoistNonReactStatics);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function getDisplayName(WrappedComponent){return WrappedComponent.displayName||WrappedComponent.name||'WrappedComponent';}function argumentContainer(Container,WrappedComponent){/* eslint no-param-reassign:0 */Container.displayName='Form('+getDisplayName(WrappedComponent)+')';Container.WrappedComponent=WrappedComponent;return(0,_hoistNonReactStatics2.default)(Container,WrappedComponent);}function getValueFromEvent(e){// support custom element
if(!e||!e.target){return e;}var target=e.target;return target.type==='checkbox'?target.checked:target.value;}function getErrorStrs(errors){if(errors){return errors.map(function(e){if(e&&e.message){return e.message;}return e;});}return errors;}function isEmptyObject(obj){return(0,_keys2.default)(obj).length===0;}function flattenArray(arr){return Array.prototype.concat.apply([],arr);}function mirror(obj){return obj;}function hasRules(validate){if(validate){return validate.some(function(item){return!!item.rules&&item.rules.length;});}return false;}function startsWith(str,prefix){return str.lastIndexOf(prefix,0)===0;}function getParams(ns,opt,cb){var names=ns;var callback=cb;var options=opt;if(cb===undefined){if(typeof names==='function'){callback=names;options={};names=undefined;}else if(Array.isArray(ns)){if(typeof options==='function'){callback=options;options={};}else{options=options||{};}}else{callback=options;options=names||{};names=undefined;}}return{names:names,callback:callback,options:options};}var NAME_KEY_SEP='.';var NAME_INDEX_OPEN_SEP='[';function getNameIfNested(str){var keyIndex=str.indexOf(NAME_KEY_SEP);var arrayIndex=str.indexOf(NAME_INDEX_OPEN_SEP);var index=void 0;if(keyIndex===-1&&arrayIndex===-1){return{name:str};}else if(keyIndex===-1){index=arrayIndex;}else if(arrayIndex===-1){index=keyIndex;}else{index=Math.min(keyIndex,arrayIndex);}return{name:str.slice(0,index),isNested:true};}function flatFieldNames(names){var ret={};names.forEach(function(n){ret[getNameIfNested(n).name]=1;});return(0,_keys2.default)(ret);}function clearVirtualField(name,fields,fieldsMeta){if(fieldsMeta[name]&&fieldsMeta[name].virtual){/* eslint no-loop-func:0 */(0,_keys2.default)(fields).forEach(function(ok){if(getNameIfNested(ok).name===name){delete fields[ok];}});}}function getVirtualPaths(fieldsMeta){var virtualPaths={};(0,_keys2.default)(fieldsMeta).forEach(function(name){var leadingName=fieldsMeta[name].leadingName;if(leadingName&&fieldsMeta[leadingName].virtual){if(leadingName in virtualPaths){virtualPaths[leadingName].push(name);}else{virtualPaths[leadingName]=[name];}}});return virtualPaths;}function normalizeValidateRules(validate,rules,validateTrigger){var validateRules=validate.map(function(item){var newItem=(0,_extends3.default)({},item,{trigger:item.trigger||[]});if(typeof newItem.trigger==='string'){newItem.trigger=[newItem.trigger];}return newItem;});if(rules){validateRules.push({trigger:validateTrigger?[].concat(validateTrigger):[],rules:rules});}return validateRules;}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(13);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
    errors.push(util.format(options.messages.required, rule.fullField));
  }
}

exports['default'] = required;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(133);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(93),
    isArguments = __webpack_require__(86),
    isArray = __webpack_require__(26),
    isIndex = __webpack_require__(66),
    isLength = __webpack_require__(127),
    toKey = __webpack_require__(54);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(135),
    eq = __webpack_require__(65);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _layout=__webpack_require__(131);exports.default=_layout.Row;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var FIELD_META_PROP=exports.FIELD_META_PROP='data-__meta';

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(132);

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);exports.changeConfirmLocale=changeConfirmLocale;exports.getConfirmLocale=getConfirmLocale;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var defaultLocale={okText:'确定',cancelText:'取消',justOkText:'知道了'};var runtimeLocale=(0,_extends3.default)({},defaultLocale);function changeConfirmLocale(newLocale){if(newLocale){runtimeLocale=(0,_extends3.default)({},runtimeLocale,newLocale);}else{runtimeLocale=(0,_extends3.default)({},defaultLocale);}}function getConfirmLocale(){// if (this.context.antLocale && this.context.antLocale.Popconfirm) {
//   runtimeLocale = {...this.context.antLocale.Popconfirm}
// }
return runtimeLocale;}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(135),
    eq = __webpack_require__(65);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(190);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(188),
    baseKeysIn = __webpack_require__(633),
    isArrayLike = __webpack_require__(67);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp2;// import Dialog from 'rc-dialog';
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _src=__webpack_require__(655);var _src2=_interopRequireDefault(_src);var _addEventListener=__webpack_require__(70);var _addEventListener2=_interopRequireDefault(_addEventListener);var _button=__webpack_require__(55);var _button2=_interopRequireDefault(_button);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function noop(){}var mousePosition=void 0;var mousePositionEventBinded=void 0;var Modal=(_temp2=_class=function(_React$Component){(0,_inherits3.default)(Modal,_React$Component);function Modal(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Modal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Modal.__proto__||(0,_getPrototypeOf2.default)(Modal)).call.apply(_ref,[this].concat(args))),_this),_this.handleCancel=function(e){_this.props.onCancel(e);},_this.close=function(e){_this.handleCancel(e);},_this.handleOk=function(){_this.props.onOk();},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Modal,[{key:"componentDidMount",value:function componentDidMount(){if(mousePositionEventBinded){return;}// 只有点击事件支持从鼠标位置动画展开
(0,_addEventListener2.default)(document.documentElement,"click",function(e){mousePosition={x:e.pageX,y:e.pageY};// 20ms 内发生过点击事件，则从点击位置动画展示
// 否则直接 zoom 展示
// 这样可以兼容非点击方式展开
setTimeout(function(){return mousePosition=null;},20);});mousePositionEventBinded=true;}},{key:"render",value:function render(){var _props=this.props,okText=_props.okText,cancelText=_props.cancelText,confirmLoading=_props.confirmLoading,footer=_props.footer,visible=_props.visible,dialog=_props.dialog;if(this.context.antLocale&&this.context.antLocale.Modal){okText=okText||this.context.antLocale.Modal.okText;cancelText=cancelText||this.context.antLocale.Modal.cancelText;}var defaultFooter=[_react2.default.createElement(_button2.default,{ecId:this.props.ecId+"_Button@m27oza",key:"cancel",type:"ghost",size:"large",onClick:this.handleCancel},cancelText||"取消"),_react2.default.createElement(_button2.default,{ecId:this.props.ecId+"_Button@t6homx",key:"confirm",type:"primary",size:"large",loading:confirmLoading,onClick:this.handleOk},okText||"确定")];return _react2.default.createElement(_src2.default,(0,_extends3.default)({ecId:this.props.ecId+"_Dialog@pnyf1m",onClose:this.handleCancel,footer:footer||defaultFooter},this.props,{visible:visible,dialog:dialog,mousePosition:mousePosition}));}}]);return Modal;}(_react2.default.Component),_class.defaultProps={prefixCls:"ant-modal",onOk:noop,onCancel:noop,width:520,transitionName:"zoom",maskTransitionName:"fade",confirmLoading:false,visible:false,dialog:false},_class.propTypes={prefixCls:_react.PropTypes.string,onOk:_react.PropTypes.func,onCancel:_react.PropTypes.func,okText:_react.PropTypes.node,cancelText:_react.PropTypes.node,width:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.string]),confirmLoading:_react.PropTypes.bool,visible:_react.PropTypes.bool,align:_react.PropTypes.object,footer:_react.PropTypes.node,title:_react.PropTypes.node,closable:_react.PropTypes.bool},_class.contextTypes={antLocale:_react2.default.PropTypes.object},_temp2);exports.default=Modal;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(669);__webpack_require__(92);__webpack_require__(37);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(672);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _progress=__webpack_require__(674);var _progress2=_interopRequireDefault(_progress);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var AntProgress=_progress2.default;// For downward compatibility
AntProgress.Line=function(props){(0,_warning2.default)(false,'<Progress.Line /> is deprecated, use <Progress type="line" /> instead.');return _react2.default.createElement(_progress2.default,(0,_extends3.default)({},props,{ecId:props.ecId+"_Progress@yr1bn1",type:"line"}));};AntProgress.Circle=function(props){(0,_warning2.default)(false,'<Progress.Circle /> is deprecated, use <Progress type="circle" /> instead.');return _react2.default.createElement(_progress2.default,(0,_extends3.default)({},props,{ecId:props.ecId+"_Progress@p0tssm",type:"circle"}));};exports.default=AntProgress;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(677);

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(704);

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(705);

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames2=__webpack_require__(7);var _classnames3=_interopRequireDefault(_classnames2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TabPane=_react2.default.createClass({displayName:"TabPane",propTypes:{active:_react.PropTypes.bool},render:function render(){var _classnames;var props=this.props;this._isActived=this._isActived||props.active;if(!this._isActived){return null;}var prefixCls=props.rootPrefixCls+"-tabpane";var cls=(0,_classnames3.default)((_classnames={},(0,_defineProperty3.default)(_classnames,prefixCls+"-hidden",!props.active),(0,_defineProperty3.default)(_classnames,prefixCls,1),_classnames));return _react2.default.createElement("div",{ecId:this.props.ecId+"_div@764i7e",role:"tabpanel","aria-hidden":props.active?"false":"true",className:cls},props.children);}});exports.default=TabPane;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getScroll=getScroll;exports.offset=offset;exports.getTransformPropertyName=getTransformPropertyName;function getScroll(w,top){var ret=w['page'+(top?'Y':'X')+'Offset'];var method='scroll'+(top?'Top':'Left');if(typeof ret!=='number'){var d=w.document;// ie6,7,8 standard mode
ret=d.documentElement[method];if(typeof ret!=='number'){// quirks mode
ret=d.body[method];}}return ret;}function offset(elem){var box=void 0;var x=void 0;var y=void 0;var doc=elem.ownerDocument;var body=doc.body;var docElem=doc&&doc.documentElement;box=elem.getBoundingClientRect();x=box.left;y=box.top;x-=docElem.clientLeft||body.clientLeft||0;y-=docElem.clientTop||body.clientTop||0;var w=doc.defaultView||doc.parentWindow;x+=getScroll(w);y+=getScroll(w,true);return{left:x,top:y};}var transformPropertyName=void 0;function getTransformPropertyName(){if(!window.getComputedStyle){return false;}if(transformPropertyName!==undefined){return transformPropertyName;}var el=document.createElement('p');var has3d=void 0;var transforms={webkitTransform:'-webkit-transform',OTransform:'-o-transform',msTransform:'-ms-transform',MozTransform:'-moz-transform',transform:'transform'};// Add it to the body to get the computed style.
document.body.insertBefore(el,null);for(var t in transforms){if(el.style[t]!==undefined){el.style[t]='translate3d(1px,1px,1px)';has3d=window.getComputedStyle(el).getPropertyValue(transforms[t]);if(has3d!==undefined&&has3d.length>0&&has3d!=='none'){transformPropertyName=t;}}}document.body.removeChild(el);return transformPropertyName;}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TimelineItem=(_temp=_class=function(_React$Component){(0,_inherits3.default)(TimelineItem,_React$Component);function TimelineItem(){(0,_classCallCheck3.default)(this,TimelineItem);return(0,_possibleConstructorReturn3.default)(this,(TimelineItem.__proto__||(0,_getPrototypeOf2.default)(TimelineItem)).apply(this,arguments));}(0,_createClass3.default)(TimelineItem,[{key:'render',value:function render(){var _classNames,_classNames2;var _props=this.props,prefixCls=_props.prefixCls,color=_props.color,last=_props.last,children=_props.children,pending=_props.pending,className=_props.className,dot=_props.dot,restProps=(0,_objectWithoutProperties3.default)(_props,['prefixCls','color','last','children','pending','className','dot']);var itemClassName=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls+'-item',true),(0,_defineProperty3.default)(_classNames,prefixCls+'-item-last',last),(0,_defineProperty3.default)(_classNames,prefixCls+'-item-pending',pending),(0,_defineProperty3.default)(_classNames,className,className),_classNames));var dotClassName=(0,_classnames2.default)((_classNames2={},(0,_defineProperty3.default)(_classNames2,prefixCls+'-item-head',true),(0,_defineProperty3.default)(_classNames2,prefixCls+'-item-head-custom',dot),(0,_defineProperty3.default)(_classNames2,prefixCls+'-item-head-'+color,true),_classNames2));return _react2.default.createElement('li',(0,_extends3.default)({},restProps,{className:itemClassName}),_react2.default.createElement('div',{className:prefixCls+'-item-tail'}),_react2.default.createElement('div',{className:dotClassName,style:{borderColor:/blue|red|green/.test(color)?null:color}},dot),_react2.default.createElement('div',{className:prefixCls+'-item-content'},children));}}]);return TimelineItem;}(_react2.default.Component),_class.defaultProps={prefixCls:'ant-timeline',color:'blue',last:false,pending:false},_temp);exports.default=TimelineItem;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _from=__webpack_require__(149);var _from2=_interopRequireDefault(_from);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _isEqual=__webpack_require__(144);var _isEqual2=_interopRequireDefault(_isEqual);var _indexOf=__webpack_require__(767);var _indexOf2=_interopRequireDefault(_indexOf);var _window=__webpack_require__(33);var _window2=_interopRequireDefault(_window);var _loadjs=__webpack_require__(76);var _loadjs2=_interopRequireDefault(_loadjs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _const={key:{children:"childs",checked:"selected"}};function getNodes(nodes){var arr=[];if(!nodes)return arr;if(nodes instanceof Array){nodes.forEach(function(item){arr=arr.concat(getNodes(item));});}else{arr.push(nodes);var childs=nodes.subs||nodes.childs||nodes.children;if(childs){arr=arr.concat(getNodes(childs));}}return arr;}function loadZTree(callback){callback=callback||function(){};_loadjs2.default.isDefined("emZTreeV3")?_loadjs2.default.ready("emZTreeV3",callback):(0,_loadjs2.default)([(window.ecologyContentPath||"")+"/cloudstore/resource/pc/ztree_v3/js/jquery.ztree.all.js",(window.ecologyContentPath||"")+"/cloudstore/resource/pc/ztree_v3/css/zTreeStyle/zTreeStyle.css"],"emZTreeV3",function(){_window2.default.getTop().document.head.appendChild($("<link rel=\"stylesheet\" type=\"text/css\" href=\""+(window.ecologyContentPath||"")+"/cloudstore/resource/pc/ztree_v3/css/zTreeStyle/zTreeStyle.css\">")[0]);callback();});}var TreeZ=(_temp=_class=function(_React$Component){(0,_inherits3.default)(TreeZ,_React$Component);function TreeZ(props){(0,_classCallCheck3.default)(this,TreeZ);var _this=(0,_possibleConstructorReturn3.default)(this,(TreeZ.__proto__||(0,_getPrototypeOf2.default)(TreeZ)).call(this,props));_initialiseProps.call(_this);_this.zTreeOnExpand=_this.zTreeOnExpand.bind(_this);_this.zTreeOnCollapse=_this.zTreeOnCollapse.bind(_this);_this.zTreeBeforeAsync=_this.zTreeBeforeAsync.bind(_this);_this.ajaxDataFilter=_this.ajaxDataFilter.bind(_this);_this.updateNode=_this.updateNode.bind(_this);_this.addDiyDom=_this.addDiyDom.bind(_this);_this.checkedFilter=_this.checkedFilter.bind(_this);_this.expandFilter=_this.expandFilter.bind(_this);_this.checkableFilter=_this.checkableFilter.bind(_this);_this.zTreeOnClick=_this.zTreeOnClick.bind(_this);_this.zTreeOnCheck=_this.zTreeOnCheck.bind(_this);_this.zTreeAsyncSuccess=_this.zTreeAsyncSuccess.bind(_this);_this.isCheckedDisable=_this.isCheckedDisable.bind(_this);_this.updateCheckbox=_this.updateCheckbox.bind(_this);_this.getKey=_this.getKey.bind(_this);_this.ztreeId=_this.createHash();_this.setting={};_this.expandedKeys=props.expandedKeys||[];_this.checkedKeys=props.checkedKeys||[];var initData=[];_this.treeInited=false;// if (props.datas && props.datas.length > 0) {
//   initData = props.datas;
// }
if(props.treeData&&props.treeData.length>0){initData=_this.props.loadAll?props.treeData:_this.ajaxDataFilter([],[],{datas:props.treeData});}_this.state={initData:initData};return _this;}(0,_createClass3.default)(TreeZ,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this2=this;// if (this.props.checkStrictly !== nextProps.checkStrictly) {
//   var treeObj = $.fn.zTree.getZTreeObj(this.ztreeId);
//   this.props.loadAll
//   ? refresh()
//   : treeObj.reAsyncChildNodes(null, "refresh");
// }
// if (
//   nextProps.datas &&
//   nextProps.datas.length > 0 &&
//   !isEqual(nextProps.datas, this.state.initData)
// ) {
//   this.setState({ initData: nextProps.datas });
// }
if(// nextProps.treeData &&
// nextProps.treeData.length > 0 &&
!(0,_isEqual2.default)(nextProps.treeData,this.state.initData)){var initData=this.props.loadAll?nextProps.treeData||[]:this.ajaxDataFilter([],[],{datas:nextProps.treeData||[]});this.setState({initData:initData});}if(!(0,_isEqual2.default)(this.props.asyncOtherParams,nextProps.asyncOtherParams)){this.setting.async.otherParam=nextProps.asyncOtherParams;}if(this.props.checkStrictly!=nextProps.checkStrictly){this.setting.check.chkboxType=nextProps.checkStrictly?{Y:"",N:""}:{Y:"ps",N:"ps"};_loadjs2.default.ready("emZTreeV3",function(){$(document).ready(function(){$.fn.zTree.init($((0,_reactDom.findDOMNode)(this.refs.ztreeNode)),this.setting,this.ajaxDataFilter([],[],{datas:this.state.initData},nextProps));this.updateCheck();this.updateExpand();this.updateCheckStrictly(nextProps);this.treeInited=true;}.bind(_this2));});}if(!(0,_isEqual2.default)(nextProps.filterData.sort(),this.props.filterData.sort())){this.updateCheckbox(nextProps);}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){// if (!isEqual(this.props.checkStrictly, prevProps.checkStrictly)) {
//   let treeObj = $.fn.zTree.getZTreeObj(this.ztreeId);
//   // treeObj.refresh();
//   treeObj.destroy(this.ztreeId);
//   $.fn.zTree.init(
//     $(findDOMNode(this.refs.ztreeNode)),
//     this.setting,
//     this.props.treeData
//   );
// }
if(!(0,_isEqual2.default)(this.expandedKeys.sort(),this.props.expandedKeys.sort())){this.expandedKeys=this.props.expandedKeys;this.treeInited&&this.updateExpand();}if(!(0,_isEqual2.default)(this.checkedKeys.sort(),this.props.checkedKeys.sort())){this.checkedKeys=this.props.checkedKeys;this.treeInited&&this.updateCheck();}if(!(0,_isEqual2.default)(prevState.initData,this.state.initData)// && this.state.initData.length > 0
){_loadjs2.default.ready("emZTreeV3",this.init);}}},{key:"updateCheckStrictly",value:function updateCheckStrictly(props){var treeObj=$.fn.zTree.getZTreeObj(this.ztreeId);var nodes=treeObj.getNodesByFilter(this.checkStrictlyFilter);// 查找节点集合
for(var index=0;index<nodes.length;index++){var node=nodes[index];var nocheck=this.isCheckedDisable(node,props);if(nocheck!==node.nocheck){node.nocheck=nocheck;node.icon=undefined;node.iconSkin=undefined;treeObj.updateNode(node,false);}}}},{key:"updateCheckbox",value:function updateCheckbox(props){var treeObj=$.fn.zTree.getZTreeObj(this.ztreeId);var nodes=treeObj.getNodesByFilter(this.checkableFilter);// 查找节点集合
for(var index=0;index<nodes.length;index++){var node=nodes[index];node.nocheck=this.isCheckedDisable(node,props);node[_const.key.checked]=!node.nocheck&&node[_const.key.checked];node.icon=undefined;node.iconSkin=undefined;treeObj.updateNode(node,false);}}},{key:"updateCheck",value:function updateCheck(){var treeObj=$.fn.zTree.getZTreeObj(this.ztreeId);// 取消未选中的数据
var nodes=treeObj.getCheckedNodes();for(var index=0;index<nodes.length;index++){var node=nodes[index];if(!this.checkedFilter(node)){treeObj.checkNode(node,false,false,false);}}// 选中需要选中的数据
nodes=treeObj.getNodesByFilter(this.checkedFilter);// 查找节点集合
for(var _index=0;_index<nodes.length;_index++){var _node=nodes[_index];treeObj.checkNode(_node,true,false,false);}}},{key:"updateExpand",value:function updateExpand(){var treeObj=$.fn.zTree.getZTreeObj(this.ztreeId);// let node = treeObj.getNodesByFilter(filter, true); // 仅查找一个节点
// 收起未展开的节点
// let nodes = treeObj.getNodesByFilter(e => e.open);
// for (let index = 0; index < nodes.length; index++) {
//   const node = nodes[index];
//   if (!this.expandFilter(node)) {
//     treeObj.expandNode(node);
//   }
// }
// 展开需要展开的节点
var nodes=treeObj.getNodesByFilter(this.expandFilter);// 查找节点集合
// nodes = getNodes(treeObj.getNodes()).filter(this.expandFilter);
for(var index=0;index<nodes.length;index++){var node=nodes[index];treeObj.expandNode(node,true,false,false);}}},{key:"updateSelect",value:function updateSelect(){var treeObj=$.fn.zTree.getZTreeObj(this.ztreeId);// let node = treeObj.getNodesByFilter(filter, true); // 仅查找一个节点
// let nodes = treeObj.getNodesByFilter(this.expandFilter); // 查找节点集合
for(var index=0;index<nodes.length;index++){var node=nodes[index];treeObj.expandNode(node,true,false,false);}}},{key:"updateNode",value:function updateNode(node){$.fn.zTree.getZTreeObj(this.ztreeId).updateNode(node);}},{key:"checkedFilter",value:function checkedFilter(node){var _this3=this;return this.checkedKeys.some(function(e){return e==node[_this3.getKey()];});}},{key:"expandFilter",value:function expandFilter(node){var _this4=this;return this.expandedKeys.some(function(e){return e==node[_this4.getKey()];});}},{key:"checkableFilter",value:function checkableFilter(node){var isHrmTree=this.props.isHrmTree;return node.canClick||isHrmTree&&node.type!="com";}},{key:"checkStrictlyFilter",value:function checkStrictlyFilter(node){return node.isParent&&node.type!="0";}},{key:"createHash",value:function createHash(){// 默认长度 8
return(0,_from2.default)(Array(8),function(){return Math.floor(Math.random()*36).toString(36);}).join("");}},{key:"getKey",value:function getKey(){return this.props.itemMainKey?this.props.itemMainKey:"id";}},{key:"zTreeOnCollapse",value:function zTreeOnCollapse(event,treeId,treeNode){// alert(treeNode.tId + ", " + treeNode.name);
var key=this.getKey();if((0,_indexOf2.default)(this.expandedKeys,treeNode[key])>-1){this.expandedKeys.splice((0,_indexOf2.default)(this.expandedKeys,treeNode[key]),1);this.props.onExpand&&this.props.onExpand(this.expandedKeys,{node:treeNode,expanded:false});}}},{key:"zTreeOnExpand",value:function zTreeOnExpand(event,treeId,treeNode){var key=this.getKey();this.expandedKeys.push(treeNode[key]);this.props.onExpand&&this.props.onExpand(this.expandedKeys,{node:treeNode,expanded:true});}},{key:"zTreeBeforeAsync",value:function zTreeBeforeAsync(treeId,treeNode){// return (treeNode.id !== 1);
if(!treeNode)return false;if(this.props.dataUrl){var childs=treeNode.subs||treeNode.childs||treeNode.children;if(childs&&childs.length||treeNode.loadChildNodes){if(childs){var treeObj=$.fn.zTree.getZTreeObj(this.ztreeId);treeNode.loadChildNodes=true;delete treeNode.subs;delete treeNode.childs;delete treeNode.children;delete treeNode.icon;delete treeNode.iconSkin;treeObj.addNodes(treeNode,this.ajaxDataFilter([],[],{datas:childs}),true);}return false;}return true;}else{if(this.props.loadData){// this.props.loadData(treeId, treeNode);
this.props.loadData({props:treeNode});}return false;}}},{key:"isCheckedDisable",value:function isCheckedDisable(item,props){var _ref=props||this.props,multiple=_ref.multiple,filterData=_ref.filterData,inputId=_ref.inputId,inputName=_ref.inputName,checkStrictly=_ref.checkStrictly,isHrmTree=_ref.isHrmTree;if(isHrmTree){if(multiple){if(item.canClick=="false"){return true;}if(filterData&&filterData.length){return filterData.some(function(d){return item.id===d.id&&item.type===d.type;});}return false;}else{return true;}}if(multiple){if(!item.canClick&&!(!checkStrictly&&item.isParent)){return true;}if(filterData&&filterData.length){var id=inputId||"id";var name=inputName||"name";return filterData.some(function(d){return item.id===d[id]&&(item.name===d[name]||item.orgWholePathspan===d[name]);});}return false;}else{return!item.canClick||false;}}},{key:"ajaxDataFilter",value:function ajaxDataFilter(treeId,parentNode,responseData,nextProps){if(responseData){if(Array.isArray(responseData.datas)){for(var i=0;i<responseData.datas.length;i++){responseData.datas[i].nocheck=this.isCheckedDisable(responseData.datas[i],nextProps);responseData.datas[i].iconSkin="wea-ztree-icon "+responseData.datas[i].icon;}}else if(responseData.datas){responseData.datas.nocheck=this.isCheckedDisable(responseData.datas,nextProps);}}return responseData.datas;}},{key:"zTreeAsyncSuccess",value:function zTreeAsyncSuccess(){this.updateCheck();}// clickFlag	selectedMulti	(autoCancelSelected && event.ctrlKey / metaKey)	isSelected	选中操作
// 1	true	false	false	普通选中
// 1	true	false	true	普通选中
// 2	true	true	false	追加选中
// 0	true	true	true	取消选中
// 1	false	false	false	普通选中
// 1	false	false	true	普通选中
// 1	false	true	false	普通选中
// 0	false	true	true	取消选中
},{key:"zTreeOnClick",value:function zTreeOnClick(event,treeId,treeNode,clickFlag){if(clickFlag==1){var treeObj=$.fn.zTree.getZTreeObj(treeId);if(this.props.onSelect){var _nodes=treeObj.getSelectedNodes();var keys=[];var key=this.getKey();for(var index=0;index<_nodes.length;index++){var element=_nodes[index];// left tree key setting
keys.push(element[key]);}this.props.onSelect(keys,_nodes);}}}},{key:"zTreeOnCheck",value:function zTreeOnCheck(event,treeId,treeNode){// const { multiple, checkStrictly } = this.props;
var treeObj=$.fn.zTree.getZTreeObj(treeId);var key=this.getKey();var nodes=treeObj.getCheckedNodes();// if (!multiple) {
//   treeNode[_const.key.checked] = true;
//   treeNode.icon = undefined;
//   treeNode.iconSkin = undefined;
//   treeObj.updateNode(treeNode, false);
// }
treeNode[_const.key.checked]?this.checkedKeys.push(treeNode[key]):this.checkedKeys.splice((0,_indexOf2.default)(this.checkedKeys,treeNode[key]),1);if(this.props.onCheck){var keys=[];for(var index=0;index<nodes.length;index++){var element=nodes[index];// left tree key setting
keys.push(element[this.getKey()]);}this.props.onCheck(keys,nodes);}}},{key:"addHoverDom",value:function addHoverDom(treeId,treeNode){// let aObj = $("#" + treeNode.tId + "_a");
// if ($("#diyBtn_"+treeNode.id).length>0) return;
// let editStr = "<span id='diyBtn_space_" +treeNode.id+ "' > </span>"
//   + "<button type='button' class='diyBtn1' id='diyBtn_" + treeNode.id
//   + "' title='"+treeNode.name+"' onfocus='this.blur();'></button>";
// aObj.append(editStr);
// let btn = $("#diyBtn_"+treeNode.id);
// if (btn) btn.bind("click", function(){alert("diy Button for " + treeNode.name);});
}},{key:"removeHoverDom",value:function removeHoverDom(treeId,treeNode){$("#diyBtn_"+treeNode.id).unbind().remove();$("#diyBtn_space_"+treeNode.id).unbind().remove();}},{key:"addDiyDom",value:function addDiyDom(treeId,treeNode){// let aObj = $("#" + treeNode.tId + "_a");
// if ($("#diyBtn_"+treeNode.id).length>0) return;
// let editStr = "<span id='diyBtn_space_" +treeNode.id+ "' > </span>"
//   + "<button type='button' class='diyBtn1' id='diyBtn_" + treeNode.id
//   + "' title='"+treeNode.name+"' onfocus='this.blur();'></button>";
// aObj.append(editStr);
// let btn = $("#diyBtn_"+treeNode.id);
// if (btn) btn.bind("click", function(){alert("diy Button for " + treeNode.name);});
var div=document.createElement("div");div.className="ant-tree-title";// let liObj = $("#" + treeNode.tId);
// liObj.append(div);
var aObj=$("#"+treeNode.tId+"_a");aObj.html(div);ReactDOM.render(this.props.getTitle(treeNode),div);}},{key:"componentDidMount",value:function componentDidMount(){var props=this.props;var checkable=props.checkable,multiple=props.multiple,loadAll=props.loadAll,dataUrl=props.dataUrl,type=props.type,keyword=props.keyword,getTitle=props.getTitle,checkStrictly=props.checkStrictly,_props$asyncOtherPara=props.asyncOtherParams,asyncOtherParams=_props$asyncOtherPara===undefined?[]:_props$asyncOtherPara,isHrmTree=props.isHrmTree;var setting={treeId:this.ztreeId,check:{enable:checkable,chkStyle:multiple?"checkbox":"radio",radioType:"all",chkboxType:checkStrictly?{Y:"",N:""}:{Y:"ps",N:"ps"}},view:{showLine:false},data:{key:(0,_extends3.default)({},_const.key,{name:isHrmTree?"lastname":"name"})},callback:{onExpand:this.zTreeOnExpand,onCollapse:this.zTreeOnCollapse,beforeAsync:this.zTreeBeforeAsync,onAsyncSuccess:this.zTreeAsyncSuccess,onClick:this.zTreeOnClick,onCheck:this.zTreeOnCheck},weaProps:(0,_extends3.default)({},props)};if(!loadAll){setting.async={enable:true,type:"get",url:dataUrl,autoParam:["id","type","isVirtual","level"],dataFilter:this.ajaxDataFilter,otherParam:asyncOtherParams};var browserType=type;var innerParams=(0,_extends3.default)({},asyncOtherParams);if(browserType==4){innerParams.isLoadSubDepartment=1;}if(keyword){innerParams.keyword=keyword;}setting.async.otherParam=innerParams;}if(getTitle){setting.view.addDiyDom=this.addDiyDom;}this.setting=setting;loadZTree(this.init);}},{key:"render",value:function render(){// const props = this.props;
// let checkable = props.checkable;
// if (checkable) {
//   checkable = <span className={`${props.prefixCls}-checkbox-inner`}></span>;
// }
return _react2.default.createElement("div",{className:"ztree",ref:"ztreeNode",id:this.ztreeId,ecId:this.props.ecId+"_div@vext2g"});}}]);return TreeZ;}(_react2.default.Component),_class.loadZTree=loadZTree,_class.defaultProps={defaultExpandedKeys:[],defaultCheckedKeys:[],expandedKeys:[],checkedKeys:[],filterData:[]},_initialiseProps=function _initialiseProps(){var _this5=this;this.init=function(){var initData=_this5.state.initData;$(document).ready(function(){this.setting=this.setting;$.fn.zTree.init($((0,_reactDom.findDOMNode)(this.refs.ztreeNode)),this.setting,initData);this.updateExpand();this.updateCheck();this.treeInited=true;}.bind(_this5));};},_temp);exports.default=TreeZ;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=uid;var now=+new Date();var index=0;function uid(){return"rc-upload-"+now+"-"+ ++index;}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Divider=exports.ItemGroup=exports.MenuItemGroup=exports.MenuItem=exports.Item=exports.SubMenu=undefined;var _Menu=__webpack_require__(455);var _Menu2=_interopRequireDefault(_Menu);var _SubMenu=__webpack_require__(459);var _SubMenu2=_interopRequireDefault(_SubMenu);var _MenuItem=__webpack_require__(464);var _MenuItem2=_interopRequireDefault(_MenuItem);var _MenuItemGroup=__webpack_require__(481);var _MenuItemGroup2=_interopRequireDefault(_MenuItemGroup);var _Divider=__webpack_require__(482);var _Divider2=_interopRequireDefault(_Divider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.SubMenu=_SubMenu2.default;exports.Item=_MenuItem2.default;exports.MenuItem=_MenuItem2.default;exports.MenuItemGroup=_MenuItemGroup2.default;exports.ItemGroup=_MenuItemGroup2.default;exports.Divider=_Divider2.default;exports.default=_Menu2.default;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fetchKeys = __webpack_require__(369);

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if (ret !== void 0) {
        return !!ret;
    }

    if (objA === objB) {
        return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }

    var keysA = fetchKeys(objA);
    var keysB = fetchKeys(objB);

    var len = keysA.length;
    if (len !== keysB.length) {
        return false;
    }

    compareContext = compareContext || null;

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < len; i++) {
        var key = keysA[i];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];

        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (_ret === false || _ret === void 0 && valueA !== valueB) {
            return false;
        }
    }

    return true;
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _en_US=__webpack_require__(507);var _en_US2=_interopRequireDefault(_en_US);var _index=__webpack_require__(39);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function noop(){}exports.default={propTypes:{className:_react.PropTypes.string,locale:_react.PropTypes.object,style:_react.PropTypes.object,visible:_react.PropTypes.bool,onSelect:_react.PropTypes.func,prefixCls:_react.PropTypes.string,onChange:_react.PropTypes.func,onOk:_react.PropTypes.func},getDefaultProps:function getDefaultProps(){return{locale:_en_US2.default,style:{},visible:true,prefixCls:'rc-calendar',formatter:'yyyy-MM-dd',className:'',onSelect:noop,onChange:noop,onClear:noop};},shouldComponentUpdate:function shouldComponentUpdate(nextProps){return this.props.visible||nextProps.visible;},getFormatter:function getFormatter(){var formatter=this.props.formatter;var locale=this.props.locale;if(this.normalFormatter&&formatter===this.lastFormatter){return this.normalFormatter;}this.normalFormatter=(0,_index.getFormatter)(formatter,locale);this.lastFormatter=formatter;return this.normalFormatter;},focus:function focus(){if(this.refs.root){this.refs.root.focus();}}};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _checkbox=__webpack_require__(207);var _checkbox2=_interopRequireDefault(_checkbox);var _Group=__webpack_require__(547);var _Group2=_interopRequireDefault(_Group);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_checkbox2.default.Group=_Group2.default;exports.default=_checkbox2.default;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _class,_temp;// import RcSelect, { Option, OptGroup } from '../../_rc-select-6.4.8';
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _OptGroup=__webpack_require__(246);var _OptGroup2=_interopRequireDefault(_OptGroup);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RcSelect=(0,_reactLoadable2.default)({loader:function loader(){return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, 796));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var Option=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(4/* limit */).then(__webpack_require__.bind(null, 786));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});// OptGroup异步会影响组件正常使用
var Select=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Select,_React$Component);function Select(){(0,_classCallCheck3.default)(this,Select);return(0,_possibleConstructorReturn3.default)(this,(Select.__proto__||(0,_getPrototypeOf2.default)(Select)).apply(this,arguments));}(0,_createClass3.default)(Select,[{key:"render",value:function render(){var _classNames;var _props=this.props,size=_props.size,className=_props.className,combobox=_props.combobox,notFoundContent=_props.notFoundContent,prefixCls=_props.prefixCls,showSearch=_props.showSearch,optionLabelProp=_props.optionLabelProp;var cls=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls+"-lg",size==="large"),(0,_defineProperty3.default)(_classNames,prefixCls+"-sm",size==="small"),(0,_defineProperty3.default)(_classNames,className,!!className),(0,_defineProperty3.default)(_classNames,prefixCls+"-show-search",showSearch),_classNames));var antLocale=this.context.antLocale;if(antLocale&&antLocale.Select){notFoundContent=notFoundContent||antLocale.Select.notFoundContent;}if(combobox){notFoundContent=null;// children 带 dom 结构时，无法填入输入框
optionLabelProp=optionLabelProp||"value";}return _react2.default.createElement(RcSelect,(0,_extends3.default)({},this.props,{ref:"rcSelect",className:cls,optionLabelProp:optionLabelProp||"children",notFoundContent:notFoundContent}));}}]);return Select;}(_react2.default.Component),_class.Option=Option,_class.OptGroup=_OptGroup2.default,_class.defaultProps={prefixCls:"ant-select",transitionName:"slide-up",choiceTransitionName:"zoom",showSearch:false},_class.contextTypes={antLocale:_react2.default.PropTypes.object},_temp);exports.default=Select;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var OptGroup=function(_React$Component){(0,_inherits3.default)(OptGroup,_React$Component);function OptGroup(){(0,_classCallCheck3.default)(this,OptGroup);return(0,_possibleConstructorReturn3.default)(this,(OptGroup.__proto__||(0,_getPrototypeOf2.default)(OptGroup)).apply(this,arguments));}return OptGroup;}(_react2.default.Component);exports.default=OptGroup;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _gregorianCalendar=__webpack_require__(95);var _gregorianCalendar2=_interopRequireDefault(_gregorianCalendar);var _index=__webpack_require__(39);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function noop(){}function getNow(){var value=new _gregorianCalendar2.default();var ts=Date.now();ts-=ts%(60*60*1000);// 获取整点时间，去除分钟
value.setTime(ts);return value;}function getNowByCurrentStateValue(value){var ret=void 0;if(value){ret=value.clone();var ts=Date.now();ts-=ts%(60*60*1000);// 获取整点时间，去除分钟
ret.setTime(ts);}else{ret=getNow();}return ret;}var CalendarMixin={propTypes:{value:_react.PropTypes.object,defaultValue:_react.PropTypes.object,onKeyDown:_react.PropTypes.func},getDefaultProps:function getDefaultProps(){return{onKeyDown:noop};},getInitialState:function getInitialState(){var props=this.props;var value=props.value||props.defaultValue||getNow();return{value:value,selectedValue:props.selectedValue||props.defaultSelectedValue};},componentWillReceiveProps:function componentWillReceiveProps(nextProps){var value=nextProps.value;var selectedValue=nextProps.selectedValue;if("value"in nextProps){value=value||nextProps.defaultValue||getNowByCurrentStateValue(this.state.value);this.setState({value:value});}if("selectedValue"in nextProps){this.setState({selectedValue:selectedValue});}},onSelect:function onSelect(value,cause){if(value){this.setValue(value);}this.setSelectedValue(value,cause);},renderRoot:function renderRoot(newProps){var _className;var props=this.props;var prefixCls=props.prefixCls;var className=(_className={},(0,_defineProperty3.default)(_className,prefixCls,1),(0,_defineProperty3.default)(_className,prefixCls+"-hidden",!props.visible),(0,_defineProperty3.default)(_className,props.className,!!props.className),(0,_defineProperty3.default)(_className,newProps.className,!!newProps.className),_className);return _react2.default.createElement("div",{ecId:props.ecId+"_div@b0557j",ref:"root",className:""+(0,_classnames2.default)(className),style:this.props.style,tabIndex:"0",onKeyDown:this.onKeyDown},newProps.children);},setSelectedValue:function setSelectedValue(selectedValue,cause){if(this.isAllowedDate(selectedValue)){if(!("selectedValue"in this.props)){this.setState({selectedValue:selectedValue});}this.props.onSelect(selectedValue,cause);}},setValue:function setValue(value){var originalValue=this.state.value;if(!("value"in this.props)){this.setState({value:value});}if(originalValue&&value&&originalValue.getTime()!==value.getTime()||!originalValue&&value||originalValue&&!value){this.props.onChange(value);}},isAllowedDate:function isAllowedDate(value){var disabledDate=this.props.disabledDate;var disabledTime=this.props.disabledTime;return(0,_index.isAllowedDate)(value,disabledDate,disabledTime);}};exports.default=CalendarMixin;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(178);
} catch (err) {
  var index = __webpack_require__(178);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * zh-cn locale
 * @ignore
 * @author yiminghe@gmail.com
 */


module.exports = {
  // in minutes
  timezoneOffset: 8 * 60,
  firstDayOfWeek: 1,
  minimalDaysInFirstWeek: 1
};

/***/ }),
/* 250 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _DateTHead=__webpack_require__(503);var _DateTHead2=_interopRequireDefault(_DateTHead);var _DateTBody=__webpack_require__(504);var _DateTBody2=_interopRequireDefault(_DateTBody);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DateTable=function(_React$Component){(0,_inherits3.default)(DateTable,_React$Component);function DateTable(){(0,_classCallCheck3.default)(this,DateTable);return(0,_possibleConstructorReturn3.default)(this,(DateTable.__proto__||(0,_getPrototypeOf2.default)(DateTable)).apply(this,arguments));}(0,_createClass3.default)(DateTable,[{key:"render",value:function render(){var props=this.props;var prefixCls=props.prefixCls;return _react2.default.createElement("table",{className:prefixCls+"-table",cellSpacing:"0",role:"grid"},_react2.default.createElement(_DateTHead2.default,(0,_extends3.default)({},props,{ecId:props.ecId+"_DateTHead@n7u0ha"})),_react2.default.createElement(_DateTBody2.default,(0,_extends3.default)({},props,{ecId:props.ecId+"_DateTBody@zdisx6"})));}}]);return DateTable;}(_react2.default.Component);exports.default=DateTable;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof2=__webpack_require__(23);var _typeof3=_interopRequireDefault(_typeof2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(15);var _propTypes2=_interopRequireDefault(_propTypes);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _toArray=__webpack_require__(138);var _toArray2=_interopRequireDefault(_toArray);var _reactLifecyclesCompat=__webpack_require__(275);var _contextTypes=__webpack_require__(276);var _util=__webpack_require__(277);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ICON_OPEN="open";var ICON_CLOSE="close";var defaultTitle="---";var TreeNode=(_temp=_class=function(_React$Component){(0,_inherits3.default)(TreeNode,_React$Component);function TreeNode(props){(0,_classCallCheck3.default)(this,TreeNode);var _this=(0,_possibleConstructorReturn3.default)(this,(TreeNode.__proto__||(0,_getPrototypeOf2.default)(TreeNode)).call(this,props));_initialiseProps.call(_this);_this.state={dragNodeHighlight:false};return _this;}(0,_createClass3.default)(TreeNode,[{key:"getChildContext",value:function getChildContext(){return(0,_extends3.default)({},this.context,{rcTreeNode:{// onUpCheckConduct: this.onUpCheckConduct,
}});}// Isomorphic needn't load data in server side
},{key:"componentDidMount",value:function componentDidMount(){this.syncLoadData(this.props);}},{key:"componentDidUpdate",value:function componentDidUpdate(){this.syncLoadData(this.props);}// Disabled item still can be switch
// Drag usage
},{key:"isSelectable",value:function isSelectable(){var selectable=this.props.selectable;var treeSelectable=this.context.rcTree.selectable;// Ignore when selectable is undefined or null
if(typeof selectable==="boolean"){return selectable;}return treeSelectable;}// Load data to avoid default expanded tree without data
// Switcher
// Checkbox
// Icon + Title
// Children list wrapped with `Animation`
},{key:"render",value:function render(){var _classNames;var loading=this.props.loading;var _props=this.props,className=_props.className,style=_props.style,dragOver=_props.dragOver,dragOverGapTop=_props.dragOverGapTop,dragOverGapBottom=_props.dragOverGapBottom,isLeaf=_props.isLeaf,expanded=_props.expanded,selected=_props.selected,checked=_props.checked,halfChecked=_props.halfChecked,otherProps=(0,_objectWithoutProperties3.default)(_props,["className","style","dragOver","dragOverGapTop","dragOverGapBottom","isLeaf","expanded","selected","checked","halfChecked"]);var _context$rcTree=this.context.rcTree,prefixCls=_context$rcTree.prefixCls,filterTreeNode=_context$rcTree.filterTreeNode,draggable=_context$rcTree.draggable;var disabled=this.isDisabled();var dataOrAriaAttributeProps=(0,_keys2.default)(otherProps).reduce(function(prev,key){if(key.substr(0,5)==="data-"||key.substr(0,5)==="aria-"){prev[key]=otherProps[key];}return prev;},{});return _react2.default.createElement("li",(0,_extends3.default)({className:(0,_classnames2.default)(className,(_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls+"-treenode-disabled",disabled),(0,_defineProperty3.default)(_classNames,prefixCls+"-treenode-switcher-"+(expanded?"open":"close"),!isLeaf),(0,_defineProperty3.default)(_classNames,prefixCls+"-treenode-checkbox-checked",checked),(0,_defineProperty3.default)(_classNames,prefixCls+"-treenode-checkbox-indeterminate",halfChecked),(0,_defineProperty3.default)(_classNames,prefixCls+"-treenode-selected",selected),(0,_defineProperty3.default)(_classNames,prefixCls+"-treenode-loading",loading),(0,_defineProperty3.default)(_classNames,"drag-over",!disabled&&dragOver),(0,_defineProperty3.default)(_classNames,"drag-over-gap-top",!disabled&&dragOverGapTop),(0,_defineProperty3.default)(_classNames,"drag-over-gap-bottom",!disabled&&dragOverGapBottom),(0,_defineProperty3.default)(_classNames,"filter-node",filterTreeNode&&filterTreeNode(this)),_classNames)),style:style,role:"treeitem",onDragEnter:draggable?this.onDragEnter:undefined,onDragOver:draggable?this.onDragOver:undefined,onDragLeave:draggable?this.onDragLeave:undefined,onDrop:draggable?this.onDrop:undefined,onDragEnd:draggable?this.onDragEnd:undefined},dataOrAriaAttributeProps),_react2.default.createElement("span",{"class":"wea-tree-new-item-wrapper"},this.renderSwitcher(),this.renderCheckbox(),this.renderSelector()),this.renderChildren());}}]);return TreeNode;}(_react2.default.Component),_class.propTypes={eventKey:_propTypes2.default.string,// Pass by parent `cloneElement`
prefixCls:_propTypes2.default.string,className:_propTypes2.default.string,style:_propTypes2.default.object,root:_propTypes2.default.object,onSelect:_propTypes2.default.func,// By parent
expanded:_propTypes2.default.bool,selected:_propTypes2.default.bool,checked:_propTypes2.default.bool,loaded:_propTypes2.default.bool,loading:_propTypes2.default.bool,halfChecked:_propTypes2.default.bool,children:_propTypes2.default.node,title:_propTypes2.default.node,pos:_propTypes2.default.string,dragOver:_propTypes2.default.bool,dragOverGapTop:_propTypes2.default.bool,dragOverGapBottom:_propTypes2.default.bool,// By user
isLeaf:_propTypes2.default.bool,selectable:_propTypes2.default.bool,disabled:_propTypes2.default.bool,disableCheckbox:_propTypes2.default.bool,icon:_propTypes2.default.oneOfType([_propTypes2.default.node,_propTypes2.default.func]),switcherIcon:_propTypes2.default.oneOfType([_propTypes2.default.node,_propTypes2.default.func])},_class.contextTypes=_contextTypes.nodeContextTypes,_class.childContextTypes=_contextTypes.nodeContextTypes,_class.defaultProps={title:defaultTitle},_initialiseProps=function _initialiseProps(){var _this2=this;this.onSelectorClick=function(e){// Click trigger before select/check operation
var onNodeClick=_this2.context.rcTree.onNodeClick;onNodeClick(e,_this2);if(_this2.isSelectable()){_this2.onSelect(e);}else{_this2.onCheck(e);}};this.onSelectorDoubleClick=function(e){var onNodeDoubleClick=_this2.context.rcTree.onNodeDoubleClick;onNodeDoubleClick(e,_this2);};this.onSelect=function(e){if(_this2.isDisabled())return;var onNodeSelect=_this2.context.rcTree.onNodeSelect;e.preventDefault();onNodeSelect(e,_this2);};this.onCheck=function(e){if(_this2.isDisabled())return;var _props2=_this2.props,disableCheckbox=_props2.disableCheckbox,checked=_props2.checked;var _context$rcTree2=_this2.context.rcTree,checkable=_context$rcTree2.checkable,onNodeCheck=_context$rcTree2.onNodeCheck;if(!checkable||disableCheckbox)return;e.preventDefault();var targetChecked=!checked;onNodeCheck(e,_this2,targetChecked);};this.onMouseEnter=function(e){var onNodeMouseEnter=_this2.context.rcTree.onNodeMouseEnter;onNodeMouseEnter(e,_this2);};this.onMouseLeave=function(e){var onNodeMouseLeave=_this2.context.rcTree.onNodeMouseLeave;onNodeMouseLeave(e,_this2);};this.onContextMenu=function(e){var onNodeContextMenu=_this2.context.rcTree.onNodeContextMenu;onNodeContextMenu(e,_this2);};this.onDragStart=function(e){var onNodeDragStart=_this2.context.rcTree.onNodeDragStart;e.stopPropagation();_this2.setState({dragNodeHighlight:true});onNodeDragStart(e,_this2);try{// ie throw error
// firefox-need-it
e.dataTransfer.setData("text/plain","");}catch(error){// empty
}};this.onDragEnter=function(e){var onNodeDragEnter=_this2.context.rcTree.onNodeDragEnter;e.preventDefault();e.stopPropagation();onNodeDragEnter(e,_this2);};this.onDragOver=function(e){var onNodeDragOver=_this2.context.rcTree.onNodeDragOver;e.preventDefault();e.stopPropagation();onNodeDragOver(e,_this2);};this.onDragLeave=function(e){var onNodeDragLeave=_this2.context.rcTree.onNodeDragLeave;e.stopPropagation();onNodeDragLeave(e,_this2);};this.onDragEnd=function(e){var onNodeDragEnd=_this2.context.rcTree.onNodeDragEnd;e.stopPropagation();_this2.setState({dragNodeHighlight:false});onNodeDragEnd(e,_this2);};this.onDrop=function(e){var onNodeDrop=_this2.context.rcTree.onNodeDrop;e.preventDefault();e.stopPropagation();_this2.setState({dragNodeHighlight:false});onNodeDrop(e,_this2);};this.onExpand=function(e){var onNodeExpand=_this2.context.rcTree.onNodeExpand;onNodeExpand(e,_this2);};this.setSelectHandle=function(node){_this2.selectHandle=node;};this.getNodeChildren=function(){var children=_this2.props.children;var originList=(0,_toArray2.default)(children).filter(function(node){return node;});var targetList=(0,_util.getNodeChildren)(originList);if(originList.length!==targetList.length){(0,_util.warnOnlyTreeNode)();}return targetList;};this.getNodeState=function(){var expanded=_this2.props.expanded;if(_this2.isLeaf()){return null;}return expanded?ICON_OPEN:ICON_CLOSE;};this.isLeaf=function(){var _props3=_this2.props,isLeaf=_props3.isLeaf,loaded=_props3.loaded;var loadData=_this2.context.rcTree.loadData;var hasChildren=_this2.getNodeChildren().length!==0;if(isLeaf===false){return false;}return isLeaf||!loadData&&!hasChildren||loadData&&loaded&&!hasChildren;};this.isDisabled=function(){var disabled=_this2.props.disabled;var treeDisabled=_this2.context.rcTree.disabled;// Follow the logic of Selectable
if(disabled===false){return false;}return!!(treeDisabled||disabled);};this.syncLoadData=function(props){var expanded=props.expanded,loading=props.loading;var onNodeLoad=_this2.context.rcTree.onNodeLoad;if(loading)return;// read from state to avoid loadData at same time
if(expanded&&!_this2.isLeaf()){// We needn't reload data when has children in sync logic
// It's only needed in node expanded
var hasChildren=_this2.getNodeChildren().length!==0;if(!hasChildren){onNodeLoad(_this2);}}};this.renderSwitcher=function(){var _props4=_this2.props,expanded=_props4.expanded,switcherIconFromProps=_props4.switcherIcon;var _context$rcTree3=_this2.context.rcTree,prefixCls=_context$rcTree3.prefixCls,switcherIconFromCtx=_context$rcTree3.switcherIcon;var switcherIcon=switcherIconFromProps||switcherIconFromCtx;if(_this2.isLeaf()){return _react2.default.createElement("span",{className:(0,_classnames2.default)(prefixCls+"-switcher",prefixCls+"-switcher-noop")},typeof switcherIcon==="function"?_react2.default.createElement(switcherIcon,(0,_extends3.default)({},_this2.props,{isLeaf:true})):switcherIcon);}var switcherCls=(0,_classnames2.default)(prefixCls+"-switcher",prefixCls+"-switcher_"+(expanded?ICON_OPEN:ICON_CLOSE),"icon-coms-organization-"+(expanded?"down":"right"));return _react2.default.createElement("span",{onClick:_this2.onExpand,className:switcherCls},typeof switcherIcon==="function"?_react2.default.createElement(switcherIcon,(0,_extends3.default)({},_this2.props,{isLeaf:false})):switcherIcon);};this.renderCheckbox=function(){var _props5=_this2.props,checked=_props5.checked,halfChecked=_props5.halfChecked,disableCheckbox=_props5.disableCheckbox;var _context$rcTree4=_this2.context.rcTree,prefixCls=_context$rcTree4.prefixCls,checkable=_context$rcTree4.checkable;var disabled=_this2.isDisabled();if(!checkable)return null;// [Legacy] Custom element should be separate with `checkable` in future
var $custom=typeof checkable!=="boolean"?checkable:null;return _react2.default.createElement("span",{className:(0,_classnames2.default)(prefixCls+"-checkbox",checked&&prefixCls+"-checkbox-checked",!checked&&halfChecked&&prefixCls+"-checkbox-indeterminate",(disabled||disableCheckbox)&&prefixCls+"-checkbox-disabled"),onClick:_this2.onCheck},$custom);};this.renderIcon=function(){var loading=_this2.props.loading;var prefixCls=_this2.context.rcTree.prefixCls;return _react2.default.createElement("span",{className:(0,_classnames2.default)(prefixCls+"-iconEle",prefixCls+"-icon__"+(_this2.getNodeState()||"docu"),loading&&prefixCls+"-icon_loading")});};this.renderSelector=function(){var dragNodeHighlight=_this2.state.dragNodeHighlight;var _props6=_this2.props,title=_props6.title,selected=_props6.selected,icon=_props6.icon,loading=_props6.loading;var _context$rcTree5=_this2.context.rcTree,prefixCls=_context$rcTree5.prefixCls,showIcon=_context$rcTree5.showIcon,treeIcon=_context$rcTree5.icon,draggable=_context$rcTree5.draggable,loadData=_context$rcTree5.loadData;var disabled=_this2.isDisabled();var wrapClass=prefixCls+"-node-content-wrapper";// Icon - Still show loading icon when loading without showIcon
var $icon=void 0;if(showIcon){var currentIcon=icon||treeIcon;$icon=currentIcon?_react2.default.createElement("span",{className:(0,_classnames2.default)(prefixCls+"-iconEle",prefixCls+"-icon__customize")},typeof currentIcon==="function"?_react2.default.createElement(currentIcon,(0,_extends3.default)({},_this2.props)):currentIcon):_this2.renderIcon();}else if(loadData&&loading){$icon=_this2.renderIcon();}// Title
var $title=_react2.default.createElement("span",{className:prefixCls+"-title"},title);return _react2.default.createElement("span",{ref:_this2.setSelectHandle,title:typeof title==="string"?title:"",className:(0,_classnames2.default)(""+wrapClass,wrapClass+"-"+(_this2.getNodeState()||"normal"),!disabled&&(selected||dragNodeHighlight)&&prefixCls+"-node-selected",!disabled&&draggable&&"draggable"),draggable:!disabled&&draggable||undefined,"aria-grabbed":!disabled&&draggable||undefined,onMouseEnter:_this2.onMouseEnter,onMouseLeave:_this2.onMouseLeave,onContextMenu:_this2.onContextMenu,onClick:_this2.onSelectorClick,onDoubleClick:_this2.onSelectorDoubleClick,onDragStart:draggable?_this2.onDragStart:undefined},$icon,$title,_react2.default.createElement("div",{className:"wea-icon-selected-bg"}),_react2.default.createElement("i",{className:"icon-coms-Selected"}));};this.renderChildren=function(){var _props7=_this2.props,expanded=_props7.expanded,pos=_props7.pos;var _context$rcTree6=_this2.context.rcTree,prefixCls=_context$rcTree6.prefixCls,openTransitionName=_context$rcTree6.openTransitionName,openAnimation=_context$rcTree6.openAnimation,renderTreeNode=_context$rcTree6.renderTreeNode;var animProps={};if(openTransitionName){animProps.transitionName=openTransitionName;}else if((typeof openAnimation==="undefined"?"undefined":(0,_typeof3.default)(openAnimation))==="object"){animProps.animation=(0,_extends3.default)({},openAnimation);}// Children TreeNode
var nodeList=_this2.getNodeChildren();if(nodeList.length===0){return null;}var $children=void 0;if(expanded){$children=_react2.default.createElement("ul",{className:(0,_classnames2.default)(prefixCls+"-child-tree",expanded&&prefixCls+"-child-tree-open"),"data-expanded":expanded,role:"group"},(0,_util.mapChildren)(nodeList,function(node,index){return renderTreeNode(node,index,pos);}));}return _react2.default.createElement(_rcAnimate2.default,(0,_extends3.default)({},animProps,{showProp:"data-expanded",component:""}),$children);};},_temp);TreeNode.isTreeNode=1;(0,_reactLifecyclesCompat.polyfill)(TreeNode);exports.default=TreeNode;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.formatToTime=exports.formatToDate=exports.formatOfZero=undefined;var _trim=__webpack_require__(319);var _trim2=_interopRequireDefault(_trim);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var formatOfZero=exports.formatOfZero=function formatOfZero(value){var formatWithZero=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;if(!formatWithZero&&value&&typeof value==="string"&&value.indexOf("-")>-1){// feat: 增是否显示数字前0处理
// 去掉日期前的0
var arr=alue.split("-");var newArr=[];if(arr&&arr.length>0){arr.map(function(i){newArr.push(i.replace(/^0/,""));});}var str=newArr.join("-");return str;}return value;};var formatToDate=exports.formatToDate=function formatToDate(realVal,formatPattern){var formatWithZero=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var pattern=new RegExp("^\\d{2,4}-\\d{1,2}-\\d{1,2}$");if(!pattern.test(realVal)){return formatOfZero(realVal,formatWithZero);}/**
   * formatPattern
   * 1：yyyy/MM/dd
   * 2：yyyy-MM-dd
   * 3：yyyy年MM月dd日
   * 4：yyyy年MM月
   * 5：MM月dd日
   * 6：EEEE
   * 7：日期大写
   * 8：yyyy/MM/dd hh:mm a
   * 9：yyyy/MM/dd HH:mm
   */var arr=realVal.split("-");var year=arr[0];var month=arr[1];var day=arr[2];if(parseInt(month)>12||parseInt(day)>31||parseInt(year)<=0||parseInt(month)<=0||parseInt(day)<=0){return realVal;}if(year.length==2)year=formatWithZero?"00"+year:year;if(year.length==3)year=formatWithZero?"0"+year:year;if(month.length==1)month=formatWithZero?"0"+month:month;if(day.length==1)day=formatWithZero?"0"+day:day;realVal=year+"-"+month+"-"+day;if(new Date(realVal).toString().indexOf("undefined")>-1){//解决IE下类似不存在的日期2014-9-31通过new Date无法生成日期问题，chrome下默认取的下一天
return realVal;}switch(parseInt(formatPattern)){case 1:return formatDate(new Date(realVal),"yyyy/MM/dd",formatWithZero);case 2:return formatDate(new Date(realVal),"yyyy-MM-dd",formatWithZero);case 3:return formatDate(new Date(realVal),"yyyy年MM月dd日",formatWithZero);case 4:return formatDate(new Date(realVal),"yyyy年MM月",formatWithZero);case 5:return formatDate(new Date(realVal),"MM月dd日",formatWithZero);case 6:return formatDate(new Date(realVal),"wwww",formatWithZero);case 7:return dataToChinese(new Date(realVal));case 8:return formatDate(new Date(realVal),"yyyy/MM/dd 12:00 a",formatWithZero);case 9:return formatDate(new Date(realVal),"yyyy/MM/dd 00:00",formatWithZero);default:return realVal;}};//日期格式
var formatDate=function formatDate(date,fmt){var formatWithZero=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;fmt=fmt||"yyyy-MM-dd HH:mm:ss";var obj={y:date.getUTCFullYear(),// 年份，注意必须用getFullYear
M:date.getUTCMonth()+1,// 月份，注意是从0-11
d:date.getUTCDate(),// 日期
q:Math.floor((date.getUTCMonth()+3)/3),// 季度
w:date.getUTCDay(),// 星期，注意是0-6
H:12,// 24小时制
h:12,// 12小时制
m:0,// 分钟
s:0,// 秒
S:0,// 毫秒
a:"AM"};var week=["天","一","二","三","四","五","六"];for(var i in obj){fmt=fmt.replace(new RegExp(i+"+","g"),function(m){var val=obj[i]+"";if(i=="a")return val;if(i=="w")return(m.length>2?"星期":"周")+week[val];for(var j=0,len=val.length;j<m.length-len;j++){// val = "0" + val;
// 增加format是否带0的处理,默认带0 (年 月 日)
if(!((i=="Y"||i=="y"||i=="M"||i=="d")&&!formatWithZero)){val="0"+val;}}return m.length==1?val:val.substring(val.length-m.length);});}return fmt;};//日期中文
var dataToChinese=function dataToChinese(date){var arr=["〇","一","二","三","四","五","六","七","八","九"];var year=date.getFullYear();var month=date.getMonth()+1;var day=date.getDate();var tempYear=year.toString().split("").map(function(o){return arr[parseInt(o)];}).toString();return(tempYear+"年"+convertNumToChinese(month)+"月"+convertNumToChinese(day)+"日").replace(/\,/g,"");};var convertNumToChinese=function convertNumToChinese(num){var arr1=["","","二","三"];var arr2=["","一","二","三","四","五","六","七","八","九"];num=num<10?"0"+num.toString():num.toString();var first=parseInt(num.toString().split("")[0]);var second=parseInt(num.toString().split("")[1]);return arr1[first]+(first>0?"十":"")+arr2[second];};var formatToTime=exports.formatToTime=function formatToTime(realVal,formatPattern){var pattern=new RegExp("^(\\d{1,2}:\\d{1,2})(:\\d{1,2})?$");if(!pattern.test(realVal)){return realVal;}/**
   * formatPattern
   * 1：HH:MI:SS
   * 2：HH:MI:SS AM/PM
   * 3：HH:MI
   * 4：HH:MI AM/PM
   * 5：HH时MI分SS秒
   * 6：HH时MI分
   * 7：HH时MI分SS秒 AM/PM
   * 8：HH时MI分 AM/PM
   **/var realValArr=realVal.split(":");var hour=realValArr[0];var minute=realValArr[1];var seconds=realValArr[2]||"00";var separatorChar=":";var suffix=parseInt(hour)<12?" AM":" PM";switch(parseInt(formatPattern)){case 1:return hour+separatorChar+minute+separatorChar+seconds;case 2:return hour+separatorChar+minute+separatorChar+seconds+suffix;case 3:return hour+separatorChar+minute;case 4:return hour+separatorChar+minute+suffix;case 5:return hour+"时"+minute+("\u5206"+seconds+"\u79D2");case 6:return hour+"时"+minute+"分";case 7:return hour+"时"+minute+("\u5206"+seconds+"\u79D2")+suffix;case 8:return hour+"时"+minute+"分"+suffix;default:return realVal;}};

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _zh_CN=__webpack_require__(404);var _zh_CN2=_interopRequireDefault(_zh_CN);var _zh_CN3=__webpack_require__(256);var _zh_CN4=_interopRequireDefault(_zh_CN3);var _zh_CN5=__webpack_require__(257);var _zh_CN6=_interopRequireDefault(_zh_CN5);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// 统一合并为完整的 Locale
// const locale = { ...GregorianCalendarLocale };
var locale={// in minutes
timezoneOffset:8*60,firstDayOfWeek:1,minimalDaysInFirstWeek:1};locale.lang={placeholder:'请选择日期',rangePlaceholder:['开始日期','结束日期'],today:'今天',now:'此刻',backToToday:'返回今天',ok:'确定',clear:'清除',month:'月',year:'年',previousMonth:'上个月 (翻页上键)',nextMonth:'下个月 (翻页下键)',monthSelect:'选择月份',yearSelect:'选择年份',decadeSelect:'选择年代',yearFormat:'yyyy\'年\'',monthFormat:'M\'月\'',dateFormat:'yyyy\'年\'M\'月\'d\'日\'',previousYear:'上一年 (Control键加左方向键)',nextYear:'下一年 (Control键加右方向键)',previousDecade:'上一年代',nextDecade:'下一年代',previousCentury:'上一世纪',nextCentury:'下一世纪',format:{eras:['公元前','公元'],months:['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'],shortMonths:['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'],weekdays:['星期天','星期一','星期二','星期三','星期四','星期五','星期六'],shortWeekdays:['周日','周一','周二','周三','周四','周五','周六'],veryShortWeekdays:['日','一','二','三','四','五','六'],ampms:['上午','下午'],datePatterns:['yyyy\'年\'M\'月\'d\'日\' EEEE','yyyy\'年\'M\'月\'d\'日\'','yyyy-M-d','yy-M-d'],timePatterns:['ahh\'时\'mm\'分\'ss\'秒\' \'GMT\'Z','ahh\'时\'mm\'分\'ss\'秒\'','H:mm:ss','ah:mm'],dateTimePattern:'{date} {time}'}};locale.timePickerLocale=(0,_extends3.default)({},_zh_CN6.default);// should add whitespace between char in Button
locale.lang.ok='确 定';// All settings at:
// https://github.com/ant-design/ant-design/issues/424
exports.default=locale;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _zh_CN=__webpack_require__(183);var _zh_CN2=_interopRequireDefault(_zh_CN);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={today:'今天',now:'此刻',backToToday:'返回今天',ok:'确定',clear:'清除',month:'月',year:'年',previousMonth:'上个月 (翻页上键)',nextMonth:'下个月 (翻页下键)',monthSelect:'选择月份',yearSelect:'选择年份',decadeSelect:'选择年代',yearFormat:'yyyy\'年\'',monthFormat:'M\'月\'',dateFormat:'yyyy\'年\'M\'月\'d\'日\'',previousYear:'上一年 (Control键加左方向键)',nextYear:'下一年 (Control键加右方向键)',previousDecade:'上一年代',nextDecade:'下一年代',previousCentury:'上一世纪',nextCentury:'下一世纪',format:_zh_CN2.default};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _zh_CN=__webpack_require__(405);var _zh_CN2=_interopRequireDefault(_zh_CN);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var locale=(0,_extends3.default)({placeholder:'请选择时间'},_zh_CN2.default);exports.default=locale;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(125),
    setCacheAdd = __webpack_require__(433),
    setCacheHas = __webpack_require__(434);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * en-us locale
 * @ignore
 * @author yiminghe@gmail.com
 */


module.exports = {
  // in minutes
  timezoneOffset: -8 * 60,
  firstDayOfWeek: 0,
  minimalDaysInFirstWeek: 1
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _dayjs=__webpack_require__(150);var _dayjs2=_interopRequireDefault(_dayjs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ROW=4;// import moment from 'moment';
var COL=3;function chooseMonth(month){var next=this.state.value.clone();next.rollSetMonth(month);this.setAndSelectValue(next);}function noop(){}var MonthTable=function(_Component){(0,_inherits3.default)(MonthTable,_Component);function MonthTable(props){(0,_classCallCheck3.default)(this,MonthTable);var _this=(0,_possibleConstructorReturn3.default)(this,(MonthTable.__proto__||(0,_getPrototypeOf2.default)(MonthTable)).call(this,props));_this.state={value:props.value};return _this;}(0,_createClass3.default)(MonthTable,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if("value"in nextProps){this.setState({value:nextProps.value});}}},{key:"getMonths",value:function getMonths(){var props=this.props;var value=this.state.value;var current=value.clone();var locale=props.locale;var months=[];var shortMonths=locale.format.shortMonths;var index=0;for(var rowIndex=0;rowIndex<ROW;rowIndex++){months[rowIndex]=[];for(var colIndex=0;colIndex<COL;colIndex++){current.rollSetMonth(index);months[rowIndex][colIndex]={value:index,content:shortMonths[index],title:shortMonths[index]};index++;}}return months;}},{key:"setAndSelectValue",value:function setAndSelectValue(value){this.setState({value:value});this.props.onSelect(value);}},{key:"render",value:function render(){var _this2=this;var props=this.props;var value=this.state.value;var today=value.clone();today.setTime(Date.now());var months=this.getMonths();var currentMonth=value.getMonth();var prefixCls=props.prefixCls,locale=props.locale,contentRender=props.contentRender,cellRender=props.cellRender,ecId=props.ecId;var monthsEls=months.map(function(month,index){var tds=month.map(function(monthData){var _classNameMap;var disabled=false;if(props.disabledDate){var testValue=value.clone();testValue.rollSetMonth(monthData.value);disabled=props.disabledDate(testValue);}var classNameMap=(_classNameMap={},(0,_defineProperty3.default)(_classNameMap,prefixCls+"-cell",1),(0,_defineProperty3.default)(_classNameMap,prefixCls+"-cell-disabled",disabled),(0,_defineProperty3.default)(_classNameMap,prefixCls+"-selected-cell",monthData.value===currentMonth),(0,_defineProperty3.default)(_classNameMap,prefixCls+"-current-cell",today.getYear()===value.getYear()&&monthData.value===today.getMonth()),_classNameMap);var red=false;props.redDots&&props.redDots.forEach(function(redItem){var mo=(0,_dayjs2.default)(redItem).format("YYYY-MM").split("-");if(parseInt(mo[0])===props.year&&parseInt(mo[1])===monthData.value+1)red=true;});var cellEl=void 0;if(cellRender){var currentValue=value.clone();currentValue.rollSetMonth(monthData.value);cellEl=cellRender(currentValue,locale);}else{var content=void 0;if(contentRender){var _currentValue=value.clone();_currentValue.rollSetMonth(monthData.value);content=contentRender(_currentValue,locale);}else{content=monthData.content;}cellEl=_react2.default.createElement("div",{className:prefixCls+"-month"},red&&_react2.default.createElement("div",{className:"redDots"}),content);}return _react2.default.createElement("td",{ecId:ecId+"_td@75jc2o@"+monthData.value,role:"gridcell",key:monthData.value,onClick:disabled?null:chooseMonth.bind(_this2,monthData.value),title:monthData.title,className:(0,_classnames2.default)(classNameMap)},cellEl);});return _react2.default.createElement("tr",{key:index,role:"row"},tds);});return _react2.default.createElement("table",{className:prefixCls+"-table",cellSpacing:"0",role:"grid"},_react2.default.createElement("tbody",{className:prefixCls+"-tbody"},monthsEls));}}]);return MonthTable;}(_react.Component);MonthTable.defaultProps={onSelect:noop};MonthTable.propTypes={onSelect:_react.PropTypes.func,cellRender:_react.PropTypes.func,prefixCls:_react.PropTypes.string,value:_react.PropTypes.object,redDots:_react.PropTypes.array};exports.default=MonthTable;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _src=__webpack_require__(561);var _src2=_interopRequireDefault(_src);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_src2.default;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _MonthPanel=__webpack_require__(265);var _MonthPanel2=_interopRequireDefault(_MonthPanel);var _index=__webpack_require__(39);var _YearPanel=__webpack_require__(151);var _YearPanel2=_interopRequireDefault(_YearPanel);var _mapSelf=__webpack_require__(152);var _mapSelf2=_interopRequireDefault(_mapSelf);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function goMonth(direction){var next=this.props.value.clone();next.addMonth(direction);this.props.onValueChange(next);}function goYear(direction){var next=this.props.value.clone();next.addYear(direction);this.props.onValueChange(next);}var CalendarHeader=_react2.default.createClass({displayName:"CalendarHeader",propTypes:{enablePrev:_react.PropTypes.any,enableNext:_react.PropTypes.any,prefixCls:_react.PropTypes.string,locale:_react.PropTypes.object,value:_react.PropTypes.object,onValueChange:_react.PropTypes.func},getDefaultProps:function getDefaultProps(){return{enableNext:1,enablePrev:1};},getInitialState:function getInitialState(){var props=this.props;this.yearFormatter=(0,_index.getFormatter)(props.locale.yearFormat,props.locale);this.monthFormatter=(0,_index.getFormatter)(props.locale.monthFormat,props.locale);this.nextMonth=goMonth.bind(this,1);this.previousMonth=goMonth.bind(this,-1);this.nextYear=goYear.bind(this,1);this.previousYear=goYear.bind(this,-1);return{};},componentWillReceiveProps:function componentWillReceiveProps(nextProps){var locale=this.props.locale;var nextLocale=nextProps.locale;if(nextLocale!==locale){this.yearFormatter=(0,_index.getFormatter)(nextLocale.yearFormat,nextLocale);this.monthFormatter=(0,_index.getFormatter)(nextLocale.monthFormat,nextLocale);}},onSelect:function onSelect(value){this.setState({showMonthPanel:0,showYearPanel:0});this.props.onValueChange(value);},onYearSelectHandler:function onYearSelectHandler(value){this.setState({showMonthPanel:0,showYearPanel:1});},getMonthYearElement:function getMonthYearElement(){var props=this.props;var prefixCls=props.prefixCls;var locale=props.locale;var value=this.props.value;var monthBeforeYear=locale.monthBeforeYear;var selectClassName=prefixCls+"-"+(monthBeforeYear?"my-select":"ym-select");var year=_react2.default.createElement("a",{ecId:props.ecId+"_a@i28u1y",className:prefixCls+"-year-select",role:"button",onClick:this.showYearPanel,title:locale.yearSelect},this.yearFormatter.format(value));var month=_react2.default.createElement("a",{ecId:props.ecId+"_a@1zfsrt",className:prefixCls+"-month-select",role:"button",onClick:this.showMonthPanel,title:locale.monthSelect},this.monthFormatter.format(value));var my=[];if(monthBeforeYear){my=[month,year];}else{my=[year,month];}return _react2.default.createElement("span",{className:selectClassName},(0,_mapSelf2.default)(my));},showIf:function showIf(condition,el){return condition?el:null;},showMonthPanel:function showMonthPanel(){this.setState({showMonthPanel:1,showYearPanel:0});},showYearPanel:function showYearPanel(){this.setState({showMonthPanel:0,showYearPanel:1});},render:function render(){var props=this.props;var enableNext=props.enableNext,enablePrev=props.enablePrev,prefixCls=props.prefixCls,locale=props.locale,value=props.value,ecId=props.ecId;var state=this.state;var PanelClass=null;if(state.showMonthPanel){PanelClass=_MonthPanel2.default;}else if(state.showYearPanel){PanelClass=_YearPanel2.default;}var panel=void 0;if(PanelClass){panel=_react2.default.createElement(PanelClass,{ecId:ecId+"_PanelClass@kktxa2",locale:locale,defaultValue:value,rootPrefixCls:prefixCls,onSelect:this.onSelect,onYearSelectHandler:this.onYearSelectHandler.bind(this)});}return _react2.default.createElement("div",{className:prefixCls+"-header"},_react2.default.createElement("div",{style:{position:"relative"}},this.showIf(enablePrev,_react2.default.createElement("a",{ecId:ecId+"_a@am15a1",className:prefixCls+"-prev-year-btn",role:"button",onClick:this.previousYear,title:locale.previousYear},"\xAB")),this.showIf(enablePrev,_react2.default.createElement("a",{ecId:ecId+"_a@2qsjl9",className:prefixCls+"-prev-month-btn",role:"button",onClick:this.previousMonth,title:locale.previousMonth},"\u2039")),this.getMonthYearElement(),this.showIf(enableNext,_react2.default.createElement("a",{className:prefixCls+"-next-month-btn",onClick:this.nextMonth,title:locale.nextMonth},"\u203A")),this.showIf(enableNext,_react2.default.createElement("a",{ecId:ecId+"_a@ty310n",className:prefixCls+"-next-year-btn",onClick:this.nextYear,title:locale.nextYear},"\xBB"))),panel);}});exports.default=CalendarHeader;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _YearPanel=__webpack_require__(151);var _YearPanel2=_interopRequireDefault(_YearPanel);var _MonthTable=__webpack_require__(262);var _MonthTable2=_interopRequireDefault(_MonthTable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function goYear(direction){var next=this.state.value.clone();next.addYear(direction);this.setAndChangeValue(next);}function noop(){}var MonthPanel=_react2.default.createClass({displayName:"MonthPanel",propTypes:{onChange:_react.PropTypes.func,disabledDate:_react.PropTypes.func,onSelect:_react.PropTypes.func},getDefaultProps:function getDefaultProps(){return{onChange:noop,onSelect:noop};},getInitialState:function getInitialState(){var props=this.props;// bind methods
this.nextYear=goYear.bind(this,1);this.previousYear=goYear.bind(this,-1);this.prefixCls=props.rootPrefixCls+"-month-panel";return{value:props.value||props.defaultValue};},componentWillReceiveProps:function componentWillReceiveProps(nextProps){if("value"in nextProps){this.setState({value:nextProps.value});}},onYearPanelSelect:function onYearPanelSelect(current){this.setState({showYearPanel:0});this.setAndChangeValue(current);},setAndChangeValue:function setAndChangeValue(value){this.setValue(value);this.props.onChange(value);},setAndSelectValue:function setAndSelectValue(value){this.setValue(value);this.props.onSelect(value);},setValue:function setValue(value){if(!("value"in this.props)){this.setState({value:value});}},showYearPanel:function showYearPanel(){this.setState({showYearPanel:1});},render:function render(){var _this=this;var props=this.props;var value=this.state.value;var locale=props.locale;var year=value.getYear();var prefixCls=this.prefixCls;var yearPanel=void 0;if(this.state.showYearPanel){yearPanel=_react2.default.createElement(_YearPanel2.default,{locale:locale,value:value,rootPrefixCls:props.rootPrefixCls,onSelect:this.onYearPanelSelect});}return _react2.default.createElement("div",{className:prefixCls,style:props.style},_react2.default.createElement("div",null,_react2.default.createElement("div",{className:prefixCls+"-header"},_react2.default.createElement("a",{ecId:props.ecId+"_a@o8bvpb",className:prefixCls+"-prev-year-btn",role:"button",onClick:this.previousYear,title:locale.previousYear},"\xAB"),_react2.default.createElement("a",{ecId:props.ecId+"_a@9fzhow",className:prefixCls+"-year-select",role:"button",onClick:function onClick(){if(_this.props.onYearSelectHandler){_this.props.onYearSelectHandler(_this.state.value.getYear());}else{_this.showYearPanel();}},title:locale.yearSelect},_react2.default.createElement("span",{className:prefixCls+"-year-select-content"},year),_react2.default.createElement("span",{className:prefixCls+"-year-select-arrow"},"x")),_react2.default.createElement("a",{ecId:props.ecId+"_a@tui7i4",className:prefixCls+"-next-year-btn",role:"button",onClick:this.nextYear,title:locale.nextYear},"\xBB")),_react2.default.createElement("div",{className:prefixCls+"-body"},_react2.default.createElement(_MonthTable2.default,{ecId:props.ecId+"_MonthTable@uwfcx1",disabledDate:props.disabledDate,onSelect:this.setAndSelectValue,locale:locale,value:value,prefixCls:prefixCls,redDots:props.redDots,year:year}))),yearPanel);}});exports.default=MonthPanel;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=TodayButton;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _util=__webpack_require__(39);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function TodayButton(_ref){var prefixCls=_ref.prefixCls,locale=_ref.locale,value=_ref.value,timePicker=_ref.timePicker,disabledDate=_ref.disabledDate,disabledTime=_ref.disabledTime,onToday=_ref.onToday,text=_ref.text,ecId=_ref.ecId;var disabledToday=false;var localeNow=text;if(!localeNow&&timePicker){localeNow=locale.now;}localeNow=localeNow||locale.today;var disabledTodayClass="";if(disabledDate){disabledToday=!(0,_util.isAllowedDate)((0,_util.getTodayTime)(value),disabledDate,disabledTime);if(disabledToday){disabledTodayClass=prefixCls+"-today-btn-disabled";}}return _react2.default.createElement("a",{ecId:ecId+"_a@owz8gi",className:prefixCls+"-today-btn "+disabledTodayClass,role:"button",onClick:disabledToday?null:onToday,title:(0,_util.getTodayTimeStr)(value)},localeNow);}

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=OkButton;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function OkButton(_ref){var prefixCls=_ref.prefixCls,locale=_ref.locale,okDisabled=_ref.okDisabled,onOk=_ref.onOk,ecId=_ref.ecId;var className=prefixCls+"-ok-btn";if(okDisabled){className+=" "+prefixCls+"-ok-btn-disabled";}return _react2.default.createElement("a",{ecId:ecId+"_a@iqxxsu",className:className,role:"button",onClick:okDisabled?null:onOk},locale.ok);}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _index=__webpack_require__(39);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function copyTime(target,source){if(source){target.setHourOfDay(source.getHourOfDay());target.setMinutes(source.getMinutes());target.setSeconds(source.getSeconds());}return target;}var DateInput=_react2.default.createClass({displayName:"DateInput",propTypes:{prefixCls:_react.PropTypes.string,timePicker:_react.PropTypes.object,disabledTime:_react.PropTypes.any,formatter:_react.PropTypes.object,locale:_react.PropTypes.object,gregorianCalendarLocale:_react.PropTypes.object,disabledDate:_react.PropTypes.func,onChange:_react.PropTypes.func,onClear:_react.PropTypes.func,placeholder:_react.PropTypes.string,onSelect:_react.PropTypes.func,selectedValue:_react.PropTypes.object,formatWithZero:_react.PropTypes.boolean},getInitialState:function getInitialState(){var _props=this.props,_props$formatWithZero=_props.formatWithZero,formatWithZero=_props$formatWithZero===undefined?true:_props$formatWithZero,selectedValue=_props.selectedValue,formatter=_props.formatter;return{str:selectedValue&&(0,_index.formatOfZero)(formatter.format(selectedValue),formatWithZero)||"",// feat: formatOfZero 增加是否显示数字前的0的处理。这里不好改node_module的方法，统一增加formatOfZero方法处理
invalid:false};},componentWillReceiveProps:function componentWillReceiveProps(nextProps){// when popup show, click body will call this, bug!
var _nextProps$formatWith=nextProps.formatWithZero,formatWithZero=_nextProps$formatWith===undefined?true:_nextProps$formatWith,selectedValue=nextProps.selectedValue,formatter=nextProps.formatter;this.setState({str:selectedValue&&(0,_index.formatOfZero)(formatter.format(selectedValue),formatWithZero)||"",invalid:false});},onInputKeyDown:function onInputKeyDown(event){if(event.keyCode===13){// !showTime 情况下 回车选择日期功能
if(this.props.showTime)return;var str=event.target.value;var value=void 0;var _props2=this.props,disabledDate=_props2.disabledDate,formatter=_props2.formatter,gregorianCalendarLocale=_props2.gregorianCalendarLocale,onEnter=_props2.onEnter;if(str){var _enterFunc=function _enterFunc(v){return typeof onEnter==="function"&&onEnter(v);};try{value=copyTime(formatter.parse(str,{locale:gregorianCalendarLocale,obeyCount:true}),this.props.selectedValue);}catch(ex){_enterFunc(null);return;}if(value&&(!disabledDate||!disabledDate(value))){_enterFunc(value);}else{_enterFunc(null);}}else{enterFunc(null);}}},onInputChange:function onInputChange(event){var str=event.target.value;this.setState({str:str});var value=void 0;var _props3=this.props,disabledDate=_props3.disabledDate,format=_props3.format,formatter=_props3.formatter,gregorianCalendarLocale=_props3.gregorianCalendarLocale,showTime=_props3.showTime,_props3$formatWithZer=_props3.formatWithZero,formatWithZero=_props3$formatWithZer===undefined?true:_props3$formatWithZer,onChange=_props3.onChange;if(str){// 显示时间的情况 format一般为 YYYY-MM-DD HH:mm:ss(或者HH:mm) 但是这里的str只有YYYY-MM-DD
// showTime && str 匹配 YYY-MM-DD的时候,转成同format匹配的数据  fix: 下面formatter.parse转换str失败的问题
if(showTime&&/^\d{4}\-\d{2}\-\d{2}$/.test(str)){str=(0,_index.formatDate)(new Date(str),format,formatWithZero);}try{value=copyTime(formatter.parse(str,{locale:gregorianCalendarLocale,obeyCount:true}),this.props.selectedValue);}catch(ex){this.setState({invalid:true});return;}if(value&&(!disabledDate||!disabledDate(value))){var originalValue=this.props.selectedValue;if(originalValue&&value){if(originalValue.getTime()!==value.getTime()){onChange(value);}}else if(originalValue!==value){onChange(value);}}else{this.setState({invalid:true});return;}}else{onChange(null);}this.setState({invalid:false});},onClear:function onClear(){this.setState({str:""});this.props.onClear(null);},getRootDOMNode:function getRootDOMNode(){return _reactDom2.default.findDOMNode(this);},focus:function focus(){this.refs.dateInput.focus();},hasPlaceHolder:function hasPlaceHolder(){var input=document.createElement("input");return"placeholder"in input;},render:function render(){var props=this.props;var _state=this.state,invalid=_state.invalid,str=_state.str;var selectedValue=props.selectedValue,locale=props.locale,prefixCls=props.prefixCls,placeholder=props.placeholder,onChange=props.onChange,timePicker=props.timePicker,disabledTime=props.disabledTime,_props$formatWithZero2=props.formatWithZero,formatWithZero=_props$formatWithZero2===undefined?true:_props$formatWithZero2,gregorianCalendarLocale=props.gregorianCalendarLocale;var invalidClass=invalid?prefixCls+"-input-invalid":"";var disabledTimeConfig=disabledTime&&timePicker?(0,_index.getTimeConfig)(selectedValue,disabledTime):null;if(timePicker&&str){if(!formatWithZero){// 增加格式化不带0的时候。输入框截取的数字处理
str=str.slice(0,str.indexOf(" "));}else{str=str.slice(0,10);}}var hasPlaceHolder=this.hasPlaceHolder();return _react2.default.createElement("div",{className:prefixCls+"-input-wrap"},_react2.default.createElement("div",{className:prefixCls+"-time-picker-wrap"},timePicker?_react2.default.cloneElement(timePicker,(0,_extends3.default)({showClear:false,allowEmpty:false,getPopupContainer:this.getRootDOMNode,gregorianCalendarLocale:gregorianCalendarLocale,value:selectedValue,onChange:onChange},disabledTimeConfig)):null),_react2.default.createElement("div",{className:prefixCls+"-date-input-wrap"},!hasPlaceHolder&&str===""&&_react2.default.createElement("span",{className:"ant-calendar-range-picker-placeholder-ie9"},placeholder),_react2.default.createElement("input",{ecId:this.props.ecId+"_input@144am8",ref:"dateInput",className:prefixCls+"-input  "+invalidClass,value:str,placeholder:placeholder,onChange:this.onInputChange,onKeyDown:this.onInputKeyDown})),props.showClear?_react2.default.createElement("a",{ecId:this.props.ecId+"_a@bhee5d",className:prefixCls+"-clear-btn",role:"button",title:locale.clear,onClick:this.onClear}):null);}});exports.default=DateInput;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _dropdown=__webpack_require__(210);var _dropdown2=_interopRequireDefault(_dropdown);var _dropdownButton=__webpack_require__(573);var _dropdownButton2=_interopRequireDefault(_dropdownButton);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_dropdown2.default.Button=_dropdownButton2.default;exports.default=_dropdown2.default;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _rcNotification=__webpack_require__(648);var _rcNotification2=_interopRequireDefault(_rcNotification);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var defaultDuration=2;var defaultTop=void 0;var messageInstance=void 0;var key=1;var prefixCls="ant-message";function noop(){}function isObject(obj){return Object.prototype.toString.call(obj)==="[object Object]";}function isFunction(fn){return typeof fn==="function";}function getMessageInstance(callback){if(messageInstance){callback(messageInstance);return;}_rcNotification2.default.newInstance({prefixCls:prefixCls,transitionName:"move-up",style:{top:defaultTop// 覆盖原来的样式
}},function(instance){if(messageInstance){callback(messageInstance);return;}messageInstance=instance;callback(instance);});}function getEcodeConfigProps(){var newProps=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var name="message.config";if(isObject(window.pcComponentsConfig)&&window.pcComponentsConfig[name]){var overwrite=window.pcComponentsConfig[name];if(isObject(overwrite)){var propsFn=overwrite.overwritePropsFn;if(isFunction(propsFn)){var overwriteProps=propsFn(newProps,name);if(isObject(overwriteProps)){newProps=(0,_extends3.default)({},newProps,overwriteProps);}}}}return newProps;}function getEcodeProps(){var newProps=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var name="message";if(isObject(window.pcComponentsConfig)&&window.pcComponentsConfig[name]){var overwrite=window.pcComponentsConfig[name];if(isObject(overwrite)){var propsFn=overwrite.overwritePropsFn;if(isFunction(propsFn)){var overwriteProps=propsFn(newProps,name);if(isObject(overwriteProps)){newProps=(0,_extends3.default)({},newProps,overwriteProps);}}}}return newProps;}function notice(content){var duration=arguments.length>1&&arguments[1]!==undefined?arguments[1]:defaultDuration;var type=arguments[2];var onClose=arguments[3];if(!content)return;onClose=onClose||noop;var iconType={info:"info-circle",success:"check-circle",error:"cross-circle",warning:"exclamation-circle",loading:"loading"}[type];var target=key++;var props=getEcodeProps({duration:duration,content:content,onClose:onClose,type:type,iconType:iconType});getMessageInstance(function(instance){instance.notice((0,_extends3.default)({},props,{key:target,style:{},content:_react2.default.createElement("div",{className:prefixCls+"-custom-content "+prefixCls+"-"+props.type},_react2.default.createElement(_icon2.default,{type:props.iconType}),_react2.default.createElement("span",null,props.content),_react2.default.createElement("div",{className:prefixCls+"-custom-close",onClick:function onClick(){if(messageInstance){messageInstance.removeNotice(target);}}},_react2.default.createElement(_icon2.default,{type:"cross-circle"})))}));});return function(){if(messageInstance){messageInstance.removeNotice(target);}};}exports.default={info:function info(content,duration,onClose){return notice(content,duration,"info",onClose);},success:function success(content,duration,onClose){return notice(content,duration,"success",onClose);},error:function error(content,duration,onClose){return notice(content,duration,"error",onClose);},// Departed usage, please use warning()
warn:function warn(content,duration,onClose){return notice(content,duration,"warning",onClose);},warning:function warning(content,duration,onClose){return notice(content,duration,"warning",onClose);},loading:function loading(content,duration,onClose){return notice(content,duration,"loading",onClose);},config:function config(options){if("top"in options){defaultTop=options.top;}if("duration"in options){defaultDuration=options.duration;}if("prefixCls"in options){prefixCls=options.prefixCls;}var configOptions=getEcodeConfigProps(options);if("top"in configOptions){defaultTop=configOptions.top;}if("duration"in configOptions){defaultDuration=configOptions.duration;}},destroy:function destroy(){if(messageInstance){messageInstance.destroy();messageInstance=null;}}};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import Pagination from './Pagination';
var Pagination=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(3/* limit */).then(__webpack_require__.bind(null, 804));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=Pagination;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SelectPropTypes=undefined;var _propTypes=__webpack_require__(15);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function valueType(props,propName,componentName){var basicType=_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number]);var labelInValueShape=_propTypes2.default.shape({key:basicType.isRequired,label:_propTypes2.default.node});if(props.labelInValue){var validate=_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(labelInValueShape),labelInValueShape]);var error=validate.apply(undefined,arguments);if(error){return new Error('Invalid prop `'+propName+'` supplied to `'+componentName+'`, '+('when you set `labelInValue` to `true`, `'+propName+'` should in ')+'shape of `{ key: string | number, label?: ReactNode }`.');}}else if((props.mode==='multiple'||props.mode==='tags'||props.multiple||props.tags)&&props[propName]===''){return new Error('Invalid prop `'+propName+'` of type `string` supplied to `'+componentName+'`, '+'expected `array` when `multiple` or `tags` is `true`.');}else{var _validate=_propTypes2.default.oneOfType([_propTypes2.default.arrayOf(basicType),basicType]);return _validate.apply(undefined,arguments);}}var SelectPropTypes=exports.SelectPropTypes={defaultActiveFirstOption:_propTypes2.default.bool,multiple:_propTypes2.default.bool,filterOption:_propTypes2.default.any,children:_propTypes2.default.any,showSearch:_propTypes2.default.bool,disabled:_propTypes2.default.bool,allowClear:_propTypes2.default.bool,showArrow:_propTypes2.default.bool,tags:_propTypes2.default.bool,prefixCls:_propTypes2.default.string,className:_propTypes2.default.string,transitionName:_propTypes2.default.string,optionLabelProp:_propTypes2.default.string,optionFilterProp:_propTypes2.default.string,animation:_propTypes2.default.string,choiceTransitionName:_propTypes2.default.string,onChange:_propTypes2.default.func,onBlur:_propTypes2.default.func,onFocus:_propTypes2.default.func,onSelect:_propTypes2.default.func,onSearch:_propTypes2.default.func,onPopupScroll:_propTypes2.default.func,onMouseEnter:_propTypes2.default.func,onMouseLeave:_propTypes2.default.func,onInputKeyDown:_propTypes2.default.func,placeholder:_propTypes2.default.any,onDeselect:_propTypes2.default.func,labelInValue:_propTypes2.default.bool,value:valueType,defaultValue:valueType,dropdownStyle:_propTypes2.default.object,maxTagTextLength:_propTypes2.default.number,maxTagCount:_propTypes2.default.number,maxTagPlaceholder:_propTypes2.default.oneOfType([_propTypes2.default.node,_propTypes2.default.func]),tokenSeparators:_propTypes2.default.arrayOf(_propTypes2.default.string),getInputElement:_propTypes2.default.func,showAction:_propTypes2.default.arrayOf(_propTypes2.default.string)};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _isCssAnimationSupported=__webpack_require__(180);var _isCssAnimationSupported2=_interopRequireDefault(_isCssAnimationSupported);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _object=__webpack_require__(44);var _object2=_interopRequireDefault(_object);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Spin=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Spin,_React$Component);function Spin(props){(0,_classCallCheck3.default)(this,Spin);var _this=(0,_possibleConstructorReturn3.default)(this,(Spin.__proto__||(0,_getPrototypeOf2.default)(Spin)).call(this,props));var spinning=props.spinning;_this.state={spinning:spinning,notCssAnimationSupported:false};return _this;}(0,_createClass3.default)(Spin,[{key:"isNestedPattern",value:function isNestedPattern(){return!!(this.props&&this.props.children);}},{key:"componentDidMount",value:function componentDidMount(){if(!(0,_isCssAnimationSupported2.default)()){// Show text in IE9
this.setState({notCssAnimationSupported:true});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.debounceTimeout){clearTimeout(this.debounceTimeout);}if(this.delayTimeout){clearTimeout(this.delayTimeout);}}},{key:"getSpinning",value:function getSpinning(props){// Backwards support
if("spining"in props){return props.spining;}return props.spinning;}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this2=this;var currentSpinning=this.getSpinning(this.props);var spinning=this.getSpinning(nextProps);if(this.debounceTimeout){clearTimeout(this.debounceTimeout);}if(currentSpinning&&!spinning){this.debounceTimeout=setTimeout(function(){return _this2.setState({spinning:spinning});},0);}else{this.setState({spinning:spinning});}}},{key:"renderIndicator",value:function renderIndicator(){var _props=this.props,prefixCls=_props.prefixCls,indicator=_props.indicator;var dotClassName=prefixCls+"-dot";if(indicator&&React.isValidElement(indicator)){return React.cloneElement(indicator,{className:(0,_classnames2.default)(indicator.props.className,dotClassName)});}return React.createElement("span",{className:(0,_classnames2.default)(dotClassName,prefixCls+"-dot-spin")},React.createElement("i",null),React.createElement("i",null),React.createElement("i",null),React.createElement("i",null));}},{key:"render",value:function render(){var _classNames;var _props2=this.props,className=_props2.className,size=_props2.size,prefixCls=_props2.prefixCls,tip=_props2.tip,wrapperClassName=_props2.wrapperClassName,restProps=(0,_objectWithoutProperties3.default)(_props2,["className","size","prefixCls","tip","wrapperClassName"]);var _state=this.state,spinning=_state.spinning,notCssAnimationSupported=_state.notCssAnimationSupported;var spinClassName=(0,_classnames2.default)(prefixCls,(_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls+"-sm",size==="small"),(0,_defineProperty3.default)(_classNames,prefixCls+"-lg",size==="large"),(0,_defineProperty3.default)(_classNames,prefixCls+"-spinning",spinning),(0,_defineProperty3.default)(_classNames,prefixCls+"-show-text",!!tip||notCssAnimationSupported),_classNames),className);// fix https://fb.me/react-unknown-prop
var divProps=(0,_object2.default)(restProps,["spinning","delay","indicator"]);var spinElement=React.createElement("div",(0,_extends3.default)({},divProps,{className:spinClassName}),this.renderIndicator(),tip?React.createElement("div",{className:prefixCls+"-text"},tip):null);if(this.isNestedPattern()){var _classNames2;var animateClassName=prefixCls+"-nested-loading";if(wrapperClassName){animateClassName+=" "+wrapperClassName;}var containerClassName=(0,_classnames2.default)((_classNames2={},(0,_defineProperty3.default)(_classNames2,prefixCls+"-container",true),(0,_defineProperty3.default)(_classNames2,prefixCls+"-blur",spinning),_classNames2));return React.createElement(_rcAnimate2.default,(0,_extends3.default)({},divProps,{ecId:this.props.ecId+"_Animate@mbigvi",component:"div",className:animateClassName,style:null,transitionName:"fade"}),spinning&&React.createElement("div",{key:"loading"},spinElement),React.createElement("div",{className:containerClassName,key:"container"},this.props.children));}return spinElement;}}]);return Spin;}(React.Component),_class.defaultProps={prefixCls:"ant-spin",spinning:true,size:"default",wrapperClassName:""},_class.propTypes={className:React.PropTypes.string,size:React.PropTypes.oneOf(["small","default","large"])},_temp);exports.default=Spin;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(716);__webpack_require__(130);__webpack_require__(53);__webpack_require__(211);__webpack_require__(233);__webpack_require__(228);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.nodeContextTypes=exports.treeContextTypes=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _propTypes=__webpack_require__(15);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Thought we still use `cloneElement` to pass `key`,
 * other props can pass with context for future refactor.
 */var treeContextTypes=exports.treeContextTypes={rcTree:_propTypes2.default.shape({root:_propTypes2.default.object,prefixCls:_propTypes2.default.string,selectable:_propTypes2.default.bool,showIcon:_propTypes2.default.bool,icon:_propTypes2.default.oneOfType([_propTypes2.default.node,_propTypes2.default.func]),draggable:_propTypes2.default.bool,checkable:_propTypes2.default.oneOfType([_propTypes2.default.bool,_propTypes2.default.node]),checkStrictly:_propTypes2.default.bool,disabled:_propTypes2.default.bool,openTransitionName:_propTypes2.default.string,openAnimation:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.object]),loadData:_propTypes2.default.func,filterTreeNode:_propTypes2.default.func,renderTreeNode:_propTypes2.default.func,isKeyChecked:_propTypes2.default.func,onNodeClick:_propTypes2.default.func,onNodeDoubleClick:_propTypes2.default.func,onNodeExpand:_propTypes2.default.func,onNodeSelect:_propTypes2.default.func,onNodeCheck:_propTypes2.default.func,onNodeMouseEnter:_propTypes2.default.func,onNodeMouseLeave:_propTypes2.default.func,onNodeContextMenu:_propTypes2.default.func,onNodeDragStart:_propTypes2.default.func,onNodeDragEnter:_propTypes2.default.func,onNodeDragOver:_propTypes2.default.func,onNodeDragLeave:_propTypes2.default.func,onNodeDragEnd:_propTypes2.default.func,onNodeDrop:_propTypes2.default.func// TODO: Remove this
// onBatchNodeCheck: PropTypes.func,
// onCheckConductFinished: PropTypes.func,
// Tree will store the entities when the treeNode refresh.
// User can pass the func to add more info to customize the additional info.
// processTreeEntity: PropTypes.func,
})};/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */var nodeContextTypes=exports.nodeContextTypes=(0,_extends3.default)({},treeContextTypes,{rcTreeNode:_propTypes2.default.shape({onUpCheckConduct:_propTypes2.default.func})});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);var _typeof2=__webpack_require__(23);var _typeof3=_interopRequireDefault(_typeof2);exports.warnOnlyTreeNode=warnOnlyTreeNode;exports.arrDel=arrDel;exports.arrAdd=arrAdd;exports.posToArr=posToArr;exports.getPosition=getPosition;exports.isTreeNode=isTreeNode;exports.getNodeChildren=getNodeChildren;exports.isCheckDisabled=isCheckDisabled;exports.traverseTreeNodes=traverseTreeNodes;exports.mapChildren=mapChildren;exports.getDragNodesKeys=getDragNodesKeys;exports.calcDropPosition=calcDropPosition;exports.calcSelectedKeys=calcSelectedKeys;exports.convertTreeToEntities=convertTreeToEntities;exports.parseCheckedKeys=parseCheckedKeys;exports.conductCheck=conductCheck;exports.conductExpandParent=conductExpandParent;var _react=__webpack_require__(0);var _toArray=__webpack_require__(138);var _toArray2=_interopRequireDefault(_toArray);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DRAG_SIDE_RANGE=0.25;var DRAG_MIN_GAP=2;var onlyTreeNodeWarned=false;function warnOnlyTreeNode(){if(onlyTreeNodeWarned)return;onlyTreeNodeWarned=true;(0,_warning2.default)(false,'Tree only accept TreeNode as children.');}function arrDel(list,value){var clone=list.slice();var index=clone.indexOf(value);if(index>=0){clone.splice(index,1);}return clone;}function arrAdd(list,value){var clone=list.slice();if(clone.indexOf(value)===-1){clone.push(value);}return clone;}function posToArr(pos){return pos.split('-');}function getPosition(level,index){return level+'-'+index;}function isTreeNode(node){return node&&node.type&&node.type.isTreeNode;}function getNodeChildren(children){return(0,_toArray2.default)(children).filter(isTreeNode);}function isCheckDisabled(node){var _ref=node.props||{},disabled=_ref.disabled,disableCheckbox=_ref.disableCheckbox;return!!(disabled||disableCheckbox);}function traverseTreeNodes(treeNodes,callback){function processNode(node,index,parent){var children=node?node.props.children:treeNodes;var pos=node?getPosition(parent.pos,index):0;// Filter children
var childList=getNodeChildren(children);// Process node if is not root
if(node){var data={node:node,index:index,pos:pos,key:node.key||pos,parentPos:parent.node?parent.pos:null};callback(data);}// Process children node
_react.Children.forEach(childList,function(subNode,subIndex){processNode(subNode,subIndex,{node:node,pos:pos});});}processNode(null);}/**
 * Use `rc-util` `toArray` to get the children list which keeps the key.
 * And return single node if children is only one(This can avoid `key` missing check).
 */function mapChildren(children,func){var list=(0,_toArray2.default)(children).map(func);if(list.length===1){return list[0];}return list;}function getDragNodesKeys(treeNodes,node){var _node$props=node.props,eventKey=_node$props.eventKey,pos=_node$props.pos;var dragNodesKeys=[];traverseTreeNodes(treeNodes,function(_ref2){var key=_ref2.key;dragNodesKeys.push(key);});dragNodesKeys.push(eventKey||pos);return dragNodesKeys;}// Only used when drag, not affect SSR.
function calcDropPosition(event,treeNode){var clientY=event.clientY;var _treeNode$selectHandl=treeNode.selectHandle.getBoundingClientRect(),top=_treeNode$selectHandl.top,bottom=_treeNode$selectHandl.bottom,height=_treeNode$selectHandl.height;var des=Math.max(height*DRAG_SIDE_RANGE,DRAG_MIN_GAP);if(clientY<=top+des){return-1;}else if(clientY>=bottom-des){return 1;}return 0;}/**
 * Return selectedKeys according with multiple prop
 * @param selectedKeys
 * @param props
 * @returns [string]
 */function calcSelectedKeys(selectedKeys,props){if(!selectedKeys)return undefined;var multiple=props.multiple;if(multiple){return selectedKeys.slice();}if(selectedKeys.length){return[selectedKeys[0]];}return selectedKeys;}/**
 * Since React internal will convert key to string,
 * we need do this to avoid `checkStrictly` use number match
 */function keyListToString(keyList){if(!keyList)return keyList;return keyList.map(function(key){return String(key);});}// TODO: ========================= NEW LOGIC =========================
/**
 * Calculate treeNodes entities.
 * @param treeNodes
 * @param processTreeEntity  User can customize the entity
 */function convertTreeToEntities(treeNodes){var _ref3=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},initWrapper=_ref3.initWrapper,processEntity=_ref3.processEntity,onProcessFinished=_ref3.onProcessFinished;var posEntities={};var keyEntities={};var wrapper={posEntities:posEntities,keyEntities:keyEntities};if(initWrapper){wrapper=initWrapper(wrapper)||wrapper;}traverseTreeNodes(treeNodes,function(item){var node=item.node,index=item.index,pos=item.pos,key=item.key,parentPos=item.parentPos;var entity={node:node,index:index,key:key,pos:pos};posEntities[pos]=entity;keyEntities[key]=entity;// Fill children
entity.parent=posEntities[parentPos];if(entity.parent){entity.parent.children=entity.parent.children||[];entity.parent.children.push(entity);}if(processEntity){processEntity(entity,wrapper);}});if(onProcessFinished){onProcessFinished(wrapper);}return wrapper;}/**
 * Parse `checkedKeys` to { checkedKeys, halfCheckedKeys } style
 */function parseCheckedKeys(keys){if(!keys){return null;}// Convert keys to object format
var keyProps=void 0;if(Array.isArray(keys)){// [Legacy] Follow the api doc
keyProps={checkedKeys:keys,halfCheckedKeys:undefined};}else if((typeof keys==='undefined'?'undefined':(0,_typeof3.default)(keys))==='object'){keyProps={checkedKeys:keys.checked||undefined,halfCheckedKeys:keys.halfChecked||undefined};}else{(0,_warning2.default)(false,'`checkedKeys` is not an array or an object');return null;}keyProps.checkedKeys=keyListToString(keyProps.checkedKeys);keyProps.halfCheckedKeys=keyListToString(keyProps.halfCheckedKeys);return keyProps;}/**
 * Conduct check state by the keyList. It will conduct up & from the provided key.
 * If the conduct path reach the disabled or already checked / unchecked node will stop conduct.
 * @param keyList       list of keys
 * @param isCheck       is check the node or not
 * @param keyEntities   parsed by `convertTreeToEntities` function in Tree
 * @param checkStatus   Can pass current checked status for process (usually for uncheck operation)
 * @returns {{checkedKeys: [], halfCheckedKeys: []}}
 */function conductCheck(keyList,isCheck,keyEntities){var checkStatus=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var checkedKeys={};var halfCheckedKeys={};// Record the key has some child checked (include child half checked)
(checkStatus.checkedKeys||[]).forEach(function(key){checkedKeys[key]=true;});(checkStatus.halfCheckedKeys||[]).forEach(function(key){halfCheckedKeys[key]=true;});// Conduct up
function conductUp(key){if(checkedKeys[key]===isCheck)return;var entity=keyEntities[key];if(!entity)return;var children=entity.children,parent=entity.parent,node=entity.node;if(isCheckDisabled(node))return;// Check child node checked status
var everyChildChecked=true;var someChildChecked=false;// Child checked or half checked
(children||[]).filter(function(child){return!isCheckDisabled(child.node);}).forEach(function(_ref4){var childKey=_ref4.key;var childChecked=checkedKeys[childKey];var childHalfChecked=halfCheckedKeys[childKey];if(childChecked||childHalfChecked)someChildChecked=true;if(!childChecked)everyChildChecked=false;});// Update checked status
if(isCheck){checkedKeys[key]=everyChildChecked;}else{checkedKeys[key]=false;}halfCheckedKeys[key]=someChildChecked;if(parent){conductUp(parent.key);}}// Conduct down
function conductDown(key){if(checkedKeys[key]===isCheck)return;var entity=keyEntities[key];if(!entity)return;var children=entity.children,node=entity.node;if(isCheckDisabled(node))return;checkedKeys[key]=isCheck;(children||[]).forEach(function(child){conductDown(child.key);});}function conduct(key){var entity=keyEntities[key];if(!entity){(0,_warning2.default)(false,'\''+key+'\' does not exist in the tree.');return;}var children=entity.children,parent=entity.parent,node=entity.node;checkedKeys[key]=isCheck;if(isCheckDisabled(node))return;// Conduct down
(children||[]).filter(function(child){return!isCheckDisabled(child.node);}).forEach(function(child){conductDown(child.key);});// Conduct up
if(parent){conductUp(parent.key);}}(keyList||[]).forEach(function(key){conduct(key);});var checkedKeyList=[];var halfCheckedKeyList=[];// Fill checked list
(0,_keys2.default)(checkedKeys).forEach(function(key){if(checkedKeys[key]){checkedKeyList.push(key);}});// Fill half checked list
(0,_keys2.default)(halfCheckedKeys).forEach(function(key){if(!checkedKeys[key]&&halfCheckedKeys[key]){halfCheckedKeyList.push(key);}});return{checkedKeys:checkedKeyList,halfCheckedKeys:halfCheckedKeyList};}/**
 * If user use `autoExpandParent` we should get the list of parent node
 * @param keyList
 * @param keyEntities
 */function conductExpandParent(keyList,keyEntities){var expandedKeys={};function conductUp(key){if(expandedKeys[key])return;var entity=keyEntities[key];if(!entity)return;var parent=entity.parent,node=entity.node;if(isCheckDisabled(node))return;expandedKeys[key]=true;if(parent){conductUp(parent.key);}}(keyList||[]).forEach(function(key){conductUp(key);});return(0,_keys2.default)(expandedKeys);}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TreeNode=function(_React$Component){(0,_inherits3.default)(TreeNode,_React$Component);function TreeNode(){(0,_classCallCheck3.default)(this,TreeNode);return(0,_possibleConstructorReturn3.default)(this,(TreeNode.__proto__||(0,_getPrototypeOf2.default)(TreeNode)).apply(this,arguments));}return TreeNode;}(_react2.default.Component);exports.default=TreeNode;TreeNode.propTypes={value:_react2.default.PropTypes.string};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _typeof2=__webpack_require__(23);var _typeof3=_interopRequireDefault(_typeof2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;// zxt - 20171114
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _objectAssign=__webpack_require__(19);var _objectAssign2=_interopRequireDefault(_objectAssign);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _util=__webpack_require__(280);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);var _radio=__webpack_require__(140);var _radio2=_interopRequireDefault(_radio);var _reactAddonsPureRenderMixin=__webpack_require__(38);var _reactAddonsPureRenderMixin2=_interopRequireDefault(_reactAddonsPureRenderMixin);var _isEqual=__webpack_require__(144);var _isEqual2=_interopRequireDefault(_isEqual);var _middleware=__webpack_require__(27);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var browserUa=typeof window!=="undefined"?(0,_util.browser)(window.navigator):"";var ieOrEdge=/.*(IE|Edge).+/.test(browserUa);// const uaArray = browserUa.split(' ');
// const gtIE8 = uaArray.length !== 2 || uaArray[0].indexOf('IE') === -1 || Number(uaArray[1]) > 8;
var defaultTitle="---";var TreeNode=(_temp=_class=function(_React$Component){(0,_inherits3.default)(TreeNode,_React$Component);function TreeNode(props){(0,_classCallCheck3.default)(this,TreeNode);var _this=(0,_possibleConstructorReturn3.default)(this,(TreeNode.__proto__||(0,_getPrototypeOf2.default)(TreeNode)).call(this,props));_this.onClickNameClickFirst=function(e){e.preventDefault();var _this$props=_this.props,clickNodeExpandChildren=_this$props.clickNodeExpandChildren,clickNameExpandNode=_this$props.clickNameExpandNode,isLeaf=_this$props.isLeaf,hasRadio=_this$props.hasRadio,disableRadio=_this$props.disableRadio,checkable=_this$props.checkable,disableCheckbox=_this$props.disableCheckbox,root=_this$props.root,selectable=_this$props.selectable;var canRadio=hasRadio&&!disableRadio;var canCheck=checkable&&!disableCheckbox;// 展开节点
clickNodeExpandChildren&&!isLeaf&&_this.onExpand();// 选择节点
selectable&&_this.onSelect();// 展开节点
clickNameExpandNode&&!isLeaf&&!(canRadio||canCheck)&&_this.onExpand();// 选中单选节点
canRadio&&root.onRadioCheck(_this);// 选中多选节点
canCheck&&!hasRadio&&_this.onCheck();};_this.onClickNameExpandFirst=function(e){e.preventDefault();var _this$props2=_this.props,isLeaf=_this$props2.isLeaf,hasRadio=_this$props2.hasRadio,disableRadio=_this$props2.disableRadio,checkable=_this$props2.checkable,disableCheckbox=_this$props2.disableCheckbox,selectable=_this$props2.selectable,root=_this$props2.root;var canRadio=hasRadio&&!disableRadio;var canCheck=checkable&&!disableCheckbox;// 选中单选节点
isLeaf&&hasRadio&&!disableRadio&&root.onRadioCheck(_this);// 选中单选节点
isLeaf&&canRadio&&root.onRadioCheck(_this);// 选中多选节点
isLeaf&&canCheck&&!hasRadio&&_this.onCheck();// 展开节点
!isLeaf&&_this.onExpand();};["onExpand","onCheck","onContextMenu","onMouseEnter","onMouseLeave","onDragStart","onDragEnter","onDragOver","onDragLeave","onDrop","onRadioCheck"].forEach(function(m){_this[m]=_this[m].bind(_this);});_this.state={dataLoading:false,dragNodeHighlight:false};return _this;}(0,_createClass3.default)(TreeNode,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}// console.log('----', this.props, args[0]); 再说吧。。先不影响其他值，之后再想办法做优化
// if (args[0].browserTree && isEqual(args[0].data, this.props.data)
//   && this.state.dataLoading === args[1].dataLoading
//   && this.state.dragNodeHighlight === args[1].dragNodeHighlight
// ) {
//   return false;
// }
return _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.apply(this,args);}},{key:"componentDidMount",value:function componentDidMount(){if(!this.props.root._treeNodeInstances){this.props.root._treeNodeInstances=[];}this.props.root._treeNodeInstances.push(this);}// shouldComponentUpdate(nextProps) {
//   if (!nextProps.expanded) {
//     return false;
//   }
//   return true;
// }
},{key:"onCheck",value:function onCheck(){this.props.root.onCheck(this);}},{key:"onSelect",value:function onSelect(){this.props.root.onSelect(this);}},{key:"onDoubleClick",value:function onDoubleClick(e){e.preventDefault();e.stopPropagation();this.props.root.onDoubleClick(this);}},{key:"onMouseEnter",value:function onMouseEnter(e){e.preventDefault();this.props.root.onMouseEnter(e,this);}},{key:"onMouseLeave",value:function onMouseLeave(e){e.preventDefault();this.props.root.onMouseLeave(e,this);}},{key:"onContextMenu",value:function onContextMenu(e){e.preventDefault();this.props.root.onContextMenu(e,this);}},{key:"onDragStart",value:function onDragStart(e){// console.log('dragstart', this.props.eventKey, e);
// e.preventDefault();
e.stopPropagation();this.setState({dragNodeHighlight:false});this.props.root.onDragStart(e,this);try{// ie throw error
// firefox-need-it
e.dataTransfer.setData("text/plain","");}finally{// empty
}}},{key:"onDragEnter",value:function onDragEnter(e){// console.log('dragenter', this.props.eventKey, e);
e.preventDefault();e.stopPropagation();this.props.root.onDragEnter(e,this);}},{key:"onDragOver",value:function onDragOver(e){// console.log(this.props.eventKey, e);
// todo disabled
e.preventDefault();e.stopPropagation();this.props.root.onDragOver(e,this);return false;}},{key:"onDragLeave",value:function onDragLeave(e){// console.log(this.props.eventKey, e);
e.stopPropagation();this.props.root.onDragLeave(e,this);}},{key:"onDrop",value:function onDrop(e){e.preventDefault();e.stopPropagation();this.setState({dragNodeHighlight:false});this.props.root.onDrop(e,this);}},{key:"onExpand",value:function onExpand(){var _this2=this;var callbackPromise=this.props.root.onExpand(this);if(callbackPromise&&(typeof callbackPromise==="undefined"?"undefined":(0,_typeof3.default)(callbackPromise))==="object"){var setLoading=function setLoading(dataLoading){_this2.setState({dataLoading:dataLoading});};setLoading(true);callbackPromise.then(function(){setLoading(false);},function(){setLoading(false);});}}// keyboard event support
},{key:"onKeyDown",value:function onKeyDown(e){e.preventDefault();}},{key:"onRadioCheck",value:function onRadioCheck(e){e.preventDefault();this.props.root.onRadioCheck(this);}},{key:"renderSwitcher",value:function renderSwitcher(props,expandedState,expanded){var prefixCls=props.prefixCls;var switcherCls=(0,_defineProperty3.default)({},prefixCls+"-switcher",true);if(expanded){switcherCls["icon-coms-organization-down"]=true;}else{switcherCls["icon-coms-organization-right"]=true;}// if (!props.showLine) {
// } else if (props.pos === '0-0') {
//   switcherCls[`${prefixCls}-roots_${expandedState}`] = true;
// } else {
//   switcherCls[`${prefixCls}-center_${expandedState}`] = !props.last;
//   switcherCls[`${prefixCls}-bottom_${expandedState}`] = props.last;
// }
if(props.disabled){switcherCls[prefixCls+"-switcher-disabled"]=true;return _react2.default.createElement("span",{className:(0,_classnames2.default)(switcherCls),style:{color:"#A3A3A3",fontSize:16}});}return _react2.default.createElement("span",{className:(0,_classnames2.default)(switcherCls),onClick:this.onExpand,style:{color:"#A3A3A3",fontSize:16}});//span
}},{key:"renderCheckbox",value:function renderCheckbox(props){var prefixCls=props.prefixCls;var checkboxCls=(0,_defineProperty3.default)({},prefixCls+"-checkbox",true);if(props.checked){checkboxCls[prefixCls+"-checkbox-checked"]=true;}else if(props.halfChecked){checkboxCls[prefixCls+"-checkbox-indeterminate"]=true;}var customEle=null;if(typeof props.checkable!=="boolean"){customEle=props.checkable;}if(props.checkboxCls){checkboxCls[props.checkboxCls]=true;}if(props.disabled||props.disableCheckbox){checkboxCls[prefixCls+"-checkbox-disabled"]=true;return _react2.default.createElement("span",{ref:"checkbox",className:(0,_classnames2.default)(checkboxCls)},customEle);}return _react2.default.createElement("span",{ref:"checkbox",className:(0,_classnames2.default)(checkboxCls),onClick:this.onCheck},customEle);}},{key:"renderRadio",value:function renderRadio(props){var prefixCls=props.prefixCls;var radioCls=(0,_defineProperty3.default)({},prefixCls+"-radio",true);if(!props.disableRadio){return _react2.default.createElement(_radio2.default,{ref:"radio",className:(0,_classnames2.default)(radioCls),value:props.treeKey,checked:props.radioChecked,onChange:this.onRadioCheck});}}},{key:"renderChildren",value:function renderChildren(props){var renderFirst=this.renderFirst;this.renderFirst=1;var transitionAppear=true;if(!renderFirst&&props.expanded){transitionAppear=false;}var children=props.children;var newChildren=children;if(children&&(children.type&&children.type.displayName==="Tree.TreeNode"||Array.isArray(children)&&children.every(function(item){return item.type&&item.type.displayName==="Tree.TreeNode";}))){var _cls;var cls=(_cls={},(0,_defineProperty3.default)(_cls,props.prefixCls+"-child-tree",true),(0,_defineProperty3.default)(_cls,props.prefixCls+"-child-tree-open",props.expanded),_cls);if(props.showLine){cls[props.prefixCls+"-line"]=!props.last;}var animProps={};if(props.openTransitionName){animProps.transitionName=props.openTransitionName;}else if((0,_typeof3.default)(props.openAnimation)==="object"){animProps.animation=(0,_objectAssign2.default)({},props.openAnimation);if(!transitionAppear){delete animProps.animation.appear;}}newChildren=_react2.default.createElement(_rcAnimate2.default,(0,_extends3.default)({},animProps,{showProp:"data-expanded",transitionAppear:transitionAppear,component:""}),!props.expanded?null:_react2.default.createElement("ul",{className:(0,_classnames2.default)(cls),"data-expanded":props.expanded},_react2.default.Children.map(children,function(item,index){return props.root.renderTreeNode(item,index,props.pos);},props.root)));}return newChildren;}},{key:"render",value:function render(){var _iconEleCls,_this3=this;var props=this.props;// console.log("props",props)
var prefixCls=props.prefixCls;var expandedState=props.expanded?"open":"close";var iconEleCls=(_iconEleCls={},(0,_defineProperty3.default)(_iconEleCls,prefixCls+"-iconEle",true),(0,_defineProperty3.default)(_iconEleCls,prefixCls+"-icon_loading",this.state.dataLoading),(0,_defineProperty3.default)(_iconEleCls,prefixCls+"-icon__"+expandedState,true),_iconEleCls);var canRenderSwitcher=true;var content=props.title;var newChildren=this.renderChildren(props);if(props.isLeaf){// fix 展开节点的受控
canRenderSwitcher=false;}if(!newChildren||newChildren===props.children){// content = newChildren;
newChildren=null;if(!props.loadData||props.isLeaf){canRenderSwitcher=false;}}// For performance, does't render children into dom when `!props.expanded` (move to Animate)
// if (!props.expanded) {
//   newChildren = null;
// }
var selectHandle=function selectHandle(){var icon=props.showIcon||props.loadData&&_this3.state.dataLoading?_react2.default.createElement("span",{className:(0,_classnames2.default)(iconEleCls)}):null;var title=_react2.default.createElement("span",{className:prefixCls+"-title"},content);var domProps={className:prefixCls+"-node-content-wrapper"};if(!props.disabled){if(props.selected||!props._dropTrigger&&_this3.state.dragNodeHighlight){domProps.className+=" "+prefixCls+"-node-selected";}domProps.onClick=props.clickNameExpandFirst?_this3.onClickNameExpandFirst:_this3.onClickNameClickFirst;if(props.onRightClick){domProps.onContextMenu=_this3.onContextMenu;}if(props.onMouseEnter){domProps.onMouseEnter=_this3.onMouseEnter;}if(props.onMouseLeave){domProps.onMouseLeave=_this3.onMouseLeave;}if(props.draggable){domProps.className+=" draggable";if(ieOrEdge){// ie bug!
domProps.href="#";}domProps.draggable=true;domProps["aria-grabbed"]=true;domProps.onDragStart=_this3.onDragStart;}}return _react2.default.createElement("a",(0,_extends3.default)({ref:"selectHandle",title:typeof content==="string"?content:""},domProps,{onDoubleClick:_this3.onDoubleClick.bind(_this3)}),icon,title,_react2.default.createElement("div",{className:"wea-icon-selected-bg"}),_react2.default.createElement("i",{className:"icon-coms-Selected"}));};var liProps={};if(props.draggable){liProps.onDragEnter=this.onDragEnter;liProps.onDragOver=this.onDragOver;liProps.onDragLeave=this.onDragLeave;liProps.onDrop=this.onDrop;}var disabledCls="";var dragOverCls="";if(props.disabled){disabledCls=prefixCls+"-treenode-disabled";}else if(props.dragOver){dragOverCls="drag-over";}else if(props.dragOverGapTop){dragOverCls="drag-over-gap-top";}else if(props.dragOverGapBottom){dragOverCls="drag-over-gap-bottom";}var filterCls=props.filterTreeNode(this)?"filter-node":"";var noopSwitcher=function noopSwitcher(){var _cls2;var cls=(_cls2={},(0,_defineProperty3.default)(_cls2,prefixCls+"-switcher",true),(0,_defineProperty3.default)(_cls2,prefixCls+"-switcher-noop",true),_cls2);if(props.showLine){cls[prefixCls+"-center_docu"]=!props.last;cls[prefixCls+"-bottom_docu"]=props.last;}else{cls[prefixCls+"-noline_docu"]=true;}return _react2.default.createElement("span",{className:(0,_classnames2.default)(cls)});};return!!props.browserTree?_react2.default.createElement("li",(0,_extends3.default)({},liProps,{ref:"li",className:(0,_classnames2.default)(props.className,disabledCls,dragOverCls,filterCls)}),_react2.default.createElement("div",{className:"wea-tree-wrap wea-tree-wrap-"+props.selected,style:{margin:0,width:"100%",lineHeight:"26px",padding:"0 10px 0 "+(props.level*18+10)+"px"}},canRenderSwitcher?this.renderSwitcher(props,expandedState,props.expanded):noopSwitcher(),props.checkable?this.renderCheckbox(props):null,props.hasRadio?this.renderRadio(props):null,selectHandle()),newChildren):_react2.default.createElement("li",(0,_extends3.default)({},liProps,{ref:"li",className:(0,_classnames2.default)(props.className,disabledCls,dragOverCls,filterCls)}),canRenderSwitcher?this.renderSwitcher(props,expandedState,props.expanded):noopSwitcher(),props.checkable?this.renderCheckbox(props):null,props.hasRadio?this.renderRadio(props):null,selectHandle(),newChildren);}}]);return TreeNode;}(_react2.default.Component),_class.displayName="Tree.TreeNode",_temp);TreeNode.isTreeNode=1;TreeNode.propTypes={prefixCls:_react.PropTypes.string,disabled:_react.PropTypes.bool,disableCheckbox:_react.PropTypes.bool,expanded:_react.PropTypes.bool,isLeaf:_react.PropTypes.bool,root:_react.PropTypes.object,onSelect:_react.PropTypes.func};TreeNode.defaultProps={title:defaultTitle};exports.default=(0,_middleware2.default)(TreeNode,"Tree.TreeNode");

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);exports.browser=browser;exports.getOffset=getOffset;exports.loopAllChildren=loopAllChildren;exports.isInclude=isInclude;exports.filterParentPosition=filterParentPosition;exports.handleCheckState=handleCheckState;exports.getCheck=getCheck;exports.getStrictlyValue=getStrictlyValue;exports.arraysEqual=arraysEqual;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function browser(navigator){var tem=void 0;var ua=navigator.userAgent;var M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i)||[];if(/trident/i.test(M[1])){tem=/\brv[ :]+(\d+)/g.exec(ua)||[];return'IE '+(tem[1]||'');}if(M[1]==='Chrome'){tem=ua.match(/\b(OPR|Edge)\/(\d+)/);if(tem)return tem.slice(1).join(' ').replace('OPR','Opera');}M=M[2]?[M[1],M[2]]:[navigator.appName,navigator.appVersion,'-?'];tem=ua.match(/version\/(\d+)/i);if(tem){M.splice(1,1,tem[1]);}return M.join(' ');}// export function getOffset(el) {
//   const obj = el.getBoundingClientRect();
//   return {
//     left: obj.left + document.body.scrollLeft,
//     top: obj.top + document.body.scrollTop,
//     width: obj.width,
//     height: obj.height
//   };
// }
// // iscroll offset
// offset = function (el) {
//   var left = -el.offsetLeft,
//     top = -el.offsetTop;
//   // jshint -W084
//   while (el = el.offsetParent) {
//     left -= el.offsetLeft;
//     top -= el.offsetTop;
//   }
//   // jshint +W084
//   return {
//     left: left,
//     top: top
//   };
// }
/* eslint-disable *//* eslint no-loop-func: 0*/function getOffset(ele){var doc=void 0,win=void 0,docElem=void 0,rect=void 0;if(!ele.getClientRects().length){return{top:0,left:0};}rect=ele.getBoundingClientRect();if(rect.width||rect.height){doc=ele.ownerDocument;win=doc.defaultView;docElem=doc.documentElement;return{top:rect.top+win.pageYOffset-docElem.clientTop,left:rect.left+win.pageXOffset-docElem.clientLeft};}return rect;}/* eslint-enable */function getChildrenlength(children){var len=1;if(Array.isArray(children)){len=children.length;}return len;}function getSiblingPosition(index,len,siblingPosition){if(len===1){siblingPosition.first=true;siblingPosition.last=true;}else{siblingPosition.first=index===0;siblingPosition.last=index===len-1;}return siblingPosition;}function loopAllChildren(childs,callback,parent){var loop=function loop(children,level,_parent){var len=getChildrenlength(children);_react2.default.Children.forEach(children,function(item,index){var pos=level+'-'+index;if(item.props.children&&item.type&&item.type.isTreeNode){loop(item.props.children,pos,{node:item,pos:pos});}callback(item,index,pos,item.key||pos,getSiblingPosition(index,len,{}),_parent);});};loop(childs,0,parent);}function isInclude(smallArray,bigArray){return smallArray.every(function(ii,i){return ii===bigArray[i];});}// console.log(isInclude(['0', '1'], ['0', '10', '1']));
// arr.length === 628, use time: ~20ms
function filterParentPosition(arr){var levelObj={};arr.forEach(function(item){var posLen=item.split('-').length;if(!levelObj[posLen]){levelObj[posLen]=[];}levelObj[posLen].push(item);});var levelArr=(0,_keys2.default)(levelObj).sort();var _loop=function _loop(i){if(levelArr[i+1]){levelObj[levelArr[i]].forEach(function(ii){var _loop2=function _loop2(j){levelObj[levelArr[j]].forEach(function(_i,index){if(isInclude(ii.split('-'),_i.split('-'))){levelObj[levelArr[j]][index]=null;}});levelObj[levelArr[j]]=levelObj[levelArr[j]].filter(function(p){return p;});};for(var j=i+1;j<levelArr.length;j++){_loop2(j);}});}};for(var i=0;i<levelArr.length;i++){_loop(i);}var nArr=[];levelArr.forEach(function(i){nArr=nArr.concat(levelObj[i]);});return nArr;}// console.log(filterParentPosition(
//   ['0-2', '0-3-3', '0-10', '0-10-0', '0-0-1', '0-0', '0-1-1', '0-1']
// ));
function stripTail(str){var arr=str.match(/(.+)(-[^-]+)$/);var st='';if(arr&&arr.length===3){st=arr[1];}return st;}function splitPosition(pos){return pos.split('-');}function handleCheckState(obj,checkedPositionArr,checkIt){// console.log(stripTail('0-101-000'));
var objKeys=(0,_keys2.default)(obj);// let s = Date.now();
objKeys.forEach(function(i,index){var iArr=splitPosition(i);var saved=false;checkedPositionArr.forEach(function(_pos){// 设置子节点，全选或全不选
var _posArr=splitPosition(_pos);if(iArr.length>_posArr.length&&isInclude(_posArr,iArr)){obj[i].halfChecked=false;obj[i].checked=checkIt;objKeys[index]=null;}if(iArr[0]===_posArr[0]&&iArr[1]===_posArr[1]){// 如果
saved=true;}});if(!saved){objKeys[index]=null;}});// TODO: 循环 2470000 次耗时约 1400 ms。 性能瓶颈！
// console.log(Date.now()-s, checkedPositionArr.length * objKeys.length);
objKeys=objKeys.filter(function(i){return i;});// filter non null;
var _loop3=function _loop3(_pIndex){// 循环设置父节点的 选中 或 半选状态
var loop=function loop(__pos){var _posLen=splitPosition(__pos).length;if(_posLen<=2){// e.g. '0-0', '0-1'
return;}var sibling=0;var siblingChecked=0;var parentPosition=stripTail(__pos);objKeys.forEach(function(i/* , index*/){var iArr=splitPosition(i);if(iArr.length===_posLen&&isInclude(splitPosition(parentPosition),iArr)){sibling++;if(obj[i].checked){siblingChecked++;var _i=checkedPositionArr.indexOf(i);if(_i>-1){checkedPositionArr.splice(_i,1);if(_i<=_pIndex){_pIndex--;}}}else if(obj[i].halfChecked){siblingChecked+=0.5;}// objKeys[index] = null;
}});// objKeys = objKeys.filter(i => i); // filter non null;
var parent=obj[parentPosition];// sibling 不会等于0
// 全不选 - 全选 - 半选
if(siblingChecked===0){parent.checked=false;parent.halfChecked=false;}else if(siblingChecked===sibling){parent.checked=true;parent.halfChecked=false;}else{parent.halfChecked=true;parent.checked=false;}loop(parentPosition);};loop(checkedPositionArr[_pIndex],_pIndex);pIndex=_pIndex;};for(var pIndex=0;pIndex<checkedPositionArr.length;pIndex++){_loop3(pIndex);}// console.log(Date.now()-s, objKeys.length, checkIt);
}function getCheck(treeNodesStates){var halfCheckedKeys=[];var checkedKeys=[];var checkedNodes=[];var checkedNodesPositions=[];(0,_keys2.default)(treeNodesStates).forEach(function(item){var itemObj=treeNodesStates[item];if(itemObj.checked){checkedKeys.push(itemObj.key);checkedNodes.push(itemObj.node);checkedNodesPositions.push({node:itemObj.node,pos:item});}else if(itemObj.halfChecked){halfCheckedKeys.push(itemObj.key);}});return{halfCheckedKeys:halfCheckedKeys,checkedKeys:checkedKeys,checkedNodes:checkedNodes,checkedNodesPositions:checkedNodesPositions,treeNodesStates:treeNodesStates};}function getStrictlyValue(checkedKeys,halfChecked){if(halfChecked){return{checked:checkedKeys,halfChecked:halfChecked};}return checkedKeys;}function arraysEqual(a,b){if(a===b)return true;if(a===null||typeof a==='undefined'||b===null||typeof b==='undefined'){return false;}if(a.length!==b.length)return false;// If you don't care about the order of the elements inside
// the array, you should sort both arrays here.
for(var i=0;i<a.length;++i){if(a[i]!==b[i])return false;}return true;}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(282);
module.exports = __webpack_require__(306);


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _promise=__webpack_require__(48);var _promise2=_interopRequireDefault(_promise);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}if(typeof _promise2.default==='undefined'){// Rejection tracking prevents a common issue where React gets into an
// inconsistent state due to an error, but it gets swallowed by a Promise,
// and the user has no idea what causes React's erratic future behavior.
__webpack_require__(302).enable();window.Promise=__webpack_require__(304);}// fetch() polyfill for making API calls.
__webpack_require__(305);// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign=__webpack_require__(19);// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if(false){require('raf').polyfill(global);}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153);
__webpack_require__(96);
__webpack_require__(142);
__webpack_require__(292);
__webpack_require__(300);
__webpack_require__(301);
module.exports = __webpack_require__(14).Promise;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(101);
var defined = __webpack_require__(102);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(105);
var descriptor = __webpack_require__(59);
var setToStringTag = __webpack_require__(75);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(40)(IteratorPrototype, __webpack_require__(24)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(31);
var anObject = __webpack_require__(30);
var getKeys = __webpack_require__(60);

module.exports = __webpack_require__(32) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(51);
var toLength = __webpack_require__(106);
var toAbsoluteIndex = __webpack_require__(288);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(101);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(290);
var step = __webpack_require__(291);
var Iterators = __webpack_require__(56);
var toIObject = __webpack_require__(51);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(154)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(58);
var global = __webpack_require__(20);
var ctx = __webpack_require__(49);
var classof = __webpack_require__(147);
var $export = __webpack_require__(25);
var isObject = __webpack_require__(34);
var aFunction = __webpack_require__(73);
var anInstance = __webpack_require__(293);
var forOf = __webpack_require__(294);
var speciesConstructor = __webpack_require__(163);
var task = __webpack_require__(164).set;
var microtask = __webpack_require__(296)();
var newPromiseCapabilityModule = __webpack_require__(110);
var perform = __webpack_require__(165);
var userAgent = __webpack_require__(297);
var promiseResolve = __webpack_require__(166);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(24)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(298)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(75)($Promise, PROMISE);
__webpack_require__(299)(PROMISE);
Wrapper = __webpack_require__(14)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(167)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(49);
var call = __webpack_require__(161);
var isArrayIter = __webpack_require__(162);
var anObject = __webpack_require__(30);
var toLength = __webpack_require__(106);
var getIterFn = __webpack_require__(148);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var macrotask = __webpack_require__(164).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(61)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(40);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(20);
var core = __webpack_require__(14);
var dP = __webpack_require__(31);
var DESCRIPTORS = __webpack_require__(32);
var SPECIES = __webpack_require__(24)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(25);
var core = __webpack_require__(14);
var global = __webpack_require__(20);
var speciesConstructor = __webpack_require__(163);
var promiseResolve = __webpack_require__(166);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(25);
var newPromiseCapability = __webpack_require__(110);
var perform = __webpack_require__(165);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(168);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(168);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 305 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(307);var _util=__webpack_require__(69);var _util2=_interopRequireDefault(_util);var _index=__webpack_require__(333);var History=_interopRequireWildcard(_index);var _middleware=__webpack_require__(27);var _middleware2=_interopRequireDefault(_middleware);__webpack_require__(254);__webpack_require__(356);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import "babel-polyfill";
window.History=History;var req=__webpack_require__(357);req.keys().forEach(function(mod){var v=req(mod);var match=mod.match(/^\.\/([^_][\w-]+)\/index\.jsx?$/);if(match&&match[1]){var name=match[1];if(match[1]==="message"||match[1]==="notification"){}else{name=_util2.default.camelCase(name);}// v.default = util.tryCatch(React, MyErrorHandler, {error: "前端组件库异常，请联系管理员!"})(v.default);
// exports[name] = v.default;
exports[name]=(0,_middleware2.default)(v,name);}});

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _loadjs=__webpack_require__(76);var _loadjs2=_interopRequireDefault(_loadjs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}window.loadjs=_loadjs2.default;var u=window.navigator.userAgent;var isIE=u.indexOf("MSIE")>-1||u.indexOf("Trident")>-1;var IEVersion=u.replace(/^.*MSIE ([\d.]+).*$/,"$1").replace(/^.*rv:([\d.]+).*$/,"$1");if(isIE&&parseInt(IEVersion,10)===9){var version=localStorage.staticVersion||new Date().getTime();(0,_loadjs2.default)(["css!/cloudstore/resource/pc/com/v1/index.min-1.css?v="+version,"css!/cloudstore/resource/pc/com/v1/index.min-2.css?v="+version,"css!/cloudstore/resource/pc/com/v1/ecCom.min-1.css?v="+version,"css!/cloudstore/resource/pc/com/v1/ecCom.min-2.css?v="+version],"ie9CSSSpit");}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(309), __esModule: true };

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96);
__webpack_require__(142);
module.exports = __webpack_require__(111).f('iterator');


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(311), __esModule: true };

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(312);
__webpack_require__(153);
__webpack_require__(317);
__webpack_require__(318);
module.exports = __webpack_require__(14).Symbol;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(20);
var has = __webpack_require__(41);
var DESCRIPTORS = __webpack_require__(32);
var $export = __webpack_require__(25);
var redefine = __webpack_require__(156);
var META = __webpack_require__(313).KEY;
var $fails = __webpack_require__(50);
var shared = __webpack_require__(108);
var setToStringTag = __webpack_require__(75);
var uid = __webpack_require__(74);
var wks = __webpack_require__(24);
var wksExt = __webpack_require__(111);
var wksDefine = __webpack_require__(112);
var enumKeys = __webpack_require__(314);
var isArray = __webpack_require__(315);
var anObject = __webpack_require__(30);
var isObject = __webpack_require__(34);
var toObject = __webpack_require__(52);
var toIObject = __webpack_require__(51);
var toPrimitive = __webpack_require__(104);
var createDesc = __webpack_require__(59);
var _create = __webpack_require__(105);
var gOPNExt = __webpack_require__(316);
var $GOPD = __webpack_require__(170);
var $GOPS = __webpack_require__(113);
var $DP = __webpack_require__(31);
var $keys = __webpack_require__(60);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(169).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(77).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(58)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(40)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(74)('meta');
var isObject = __webpack_require__(34);
var has = __webpack_require__(41);
var setDesc = __webpack_require__(31).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(50)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(60);
var gOPS = __webpack_require__(113);
var pIE = __webpack_require__(77);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(61);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(51);
var gOPN = __webpack_require__(169).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('asyncIterator');


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('observable');


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(171),
    castSlice = __webpack_require__(323),
    charsEndIndex = __webpack_require__(324),
    charsStartIndex = __webpack_require__(328),
    stringToArray = __webpack_require__(329),
    toString = __webpack_require__(114);

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(78);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(173);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(97);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 326 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 327 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(97);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(330),
    hasUnicode = __webpack_require__(331),
    unicodeToArray = __webpack_require__(332);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 332 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.locationsAreEqual=exports.Actions=exports.useQueries=exports.useBeforeUnload=exports.useBasename=exports.createMemoryHistory=exports.createHashHistory=exports.createHistory=undefined;var _LocationUtils=__webpack_require__(43);Object.defineProperty(exports,'locationsAreEqual',{enumerable:true,get:function get(){return _LocationUtils.locationsAreEqual;}});var _createBrowserHistory=__webpack_require__(341);var _createBrowserHistory2=_interopRequireDefault(_createBrowserHistory);var _createHashHistory2=__webpack_require__(348);var _createHashHistory3=_interopRequireDefault(_createHashHistory2);var _createMemoryHistory2=__webpack_require__(350);var _createMemoryHistory3=_interopRequireDefault(_createMemoryHistory2);var _useBasename2=__webpack_require__(351);var _useBasename3=_interopRequireDefault(_useBasename2);var _useBeforeUnload2=__webpack_require__(352);var _useBeforeUnload3=_interopRequireDefault(_useBeforeUnload2);var _useQueries2=__webpack_require__(353);var _useQueries3=_interopRequireDefault(_useQueries2);var _Actions2=__webpack_require__(80);var _Actions=_interopRequireWildcard(_Actions2);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.createHistory=_createBrowserHistory2.default;exports.createHashHistory=_createHashHistory3.default;exports.createMemoryHistory=_createMemoryHistory3.default;exports.useBasename=_useBasename3.default;exports.useBeforeUnload=_useBeforeUnload3.default;exports.useQueries=_useQueries3.default;exports.Actions=_Actions;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(335);
module.exports = __webpack_require__(14).Object.keys;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(52);
var $keys = __webpack_require__(60);

__webpack_require__(174)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(337);
var $Object = __webpack_require__(14).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(25);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(105) });


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(339);
module.exports = __webpack_require__(14).Object.assign;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(25);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(340) });


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(32);
var getKeys = __webpack_require__(60);
var gOPS = __webpack_require__(113);
var pIE = __webpack_require__(77);
var toObject = __webpack_require__(52);
var IObject = __webpack_require__(158);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(50)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _invariant=__webpack_require__(62);var _invariant2=_interopRequireDefault(_invariant);var _ExecutionEnvironment=__webpack_require__(81);var _BrowserProtocol=__webpack_require__(116);var BrowserProtocol=_interopRequireWildcard(_BrowserProtocol);var _RefreshProtocol=__webpack_require__(343);var RefreshProtocol=_interopRequireWildcard(_RefreshProtocol);var _DOMUtils=__webpack_require__(63);var _createHistory=__webpack_require__(117);var _createHistory2=_interopRequireDefault(_createHistory);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */var createBrowserHistory=function createBrowserHistory(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};(0,_invariant2.default)(_ExecutionEnvironment.canUseDOM,'Browser history needs a DOM');var useRefresh=options.forceRefresh||!(0,_DOMUtils.supportsHistory)();var Protocol=useRefresh?RefreshProtocol:BrowserProtocol;var getUserConfirmation=Protocol.getUserConfirmation,getCurrentLocation=Protocol.getCurrentLocation,pushLocation=Protocol.pushLocation,replaceLocation=Protocol.replaceLocation,go=Protocol.go;var history=(0,_createHistory2.default)((0,_extends3.default)({getUserConfirmation:getUserConfirmation},options,{getCurrentLocation:getCurrentLocation,pushLocation:pushLocation,replaceLocation:replaceLocation,go:go}));var listenerCount=0,stopListener=void 0;var startListener=function startListener(listener,before){if(++listenerCount===1)stopListener=BrowserProtocol.startListener(history.transitionTo);var unlisten=before?history.listenBefore(listener):history.listen(listener);return function(){unlisten();if(--listenerCount===0)stopListener();};};var listenBefore=function listenBefore(listener){return startListener(listener,true);};var listen=function listen(listener){return startListener(listener,false);};return(0,_extends3.default)({},history,{listenBefore:listenBefore,listen:listen});};exports.default=createBrowserHistory;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(14);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.replaceLocation=exports.pushLocation=exports.getCurrentLocation=exports.go=exports.getUserConfirmation=undefined;var _BrowserProtocol=__webpack_require__(116);Object.defineProperty(exports,'getUserConfirmation',{enumerable:true,get:function get(){return _BrowserProtocol.getUserConfirmation;}});Object.defineProperty(exports,'go',{enumerable:true,get:function get(){return _BrowserProtocol.go;}});var _LocationUtils=__webpack_require__(43);var _PathUtils=__webpack_require__(36);var getCurrentLocation=exports.getCurrentLocation=function getCurrentLocation(){return(0,_LocationUtils.createLocation)(window.location);};var pushLocation=exports.pushLocation=function pushLocation(location){window.location.href=(0,_PathUtils.createPath)(location);return false;// Don't update location
};var replaceLocation=exports.replaceLocation=function replaceLocation(location){window.location.replace((0,_PathUtils.createPath)(location));return false;// Don't update location
};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96);
__webpack_require__(345);
module.exports = __webpack_require__(14).Array.from;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(49);
var $export = __webpack_require__(25);
var toObject = __webpack_require__(52);
var call = __webpack_require__(161);
var isArrayIter = __webpack_require__(162);
var toLength = __webpack_require__(106);
var createProperty = __webpack_require__(346);
var getIterFn = __webpack_require__(148);

$export($export.S + $export.F * !__webpack_require__(167)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(31);
var createDesc = __webpack_require__(59);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.loopAsync=undefined;var _toConsumableArray2=__webpack_require__(46);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loopAsync=exports.loopAsync=function loopAsync(turns,work,callback){var currentTurn=0,isDone=false;var isSync=false,hasNext=false,doneArgs=void 0;var done=function done(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}isDone=true;if(isSync){// Iterate instead of recursing if possible.
doneArgs=args;return;}callback.apply(undefined,args);};var next=function next(){if(isDone)return;hasNext=true;if(isSync)return;// Iterate instead of recursing if possible.
isSync=true;while(!isDone&&currentTurn<turns&&hasNext){hasNext=false;work(currentTurn++,next,done);}isSync=false;if(isDone){// This means the loop finished synchronously.
callback.apply(undefined,(0,_toConsumableArray3.default)(doneArgs));return;}if(currentTurn>=turns&&hasNext){isDone=true;callback();}};next();};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);var _invariant=__webpack_require__(62);var _invariant2=_interopRequireDefault(_invariant);var _ExecutionEnvironment=__webpack_require__(81);var _DOMUtils=__webpack_require__(63);var _HashProtocol=__webpack_require__(349);var HashProtocol=_interopRequireWildcard(_HashProtocol);var _createHistory=__webpack_require__(117);var _createHistory2=_interopRequireDefault(_createHistory);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DefaultQueryKey='_k';var addLeadingSlash=function addLeadingSlash(path){return path.charAt(0)==='/'?path:'/'+path;};var HashPathCoders={hashbang:{encodePath:function encodePath(path){return path.charAt(0)==='!'?path:'!'+path;},decodePath:function decodePath(path){return path.charAt(0)==='!'?path.substring(1):path;}},noslash:{encodePath:function encodePath(path){return path.charAt(0)==='/'?path.substring(1):path;},decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};var createHashHistory=function createHashHistory(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};(0,_invariant2.default)(_ExecutionEnvironment.canUseDOM,'Hash history needs a DOM');var queryKey=options.queryKey,hashType=options.hashType;(0,_warning2.default)(queryKey!==false,'Using { queryKey: false } no longer works. Instead, just don\'t '+'use location state if you don\'t want a key in your URL query string');if(typeof queryKey!=='string')queryKey=DefaultQueryKey;if(hashType==null)hashType='slash';if(!(hashType in HashPathCoders)){(0,_warning2.default)(false,'Invalid hash type: %s',hashType);hashType='slash';}var pathCoder=HashPathCoders[hashType];var getUserConfirmation=HashProtocol.getUserConfirmation;var getCurrentLocation=function getCurrentLocation(){return HashProtocol.getCurrentLocation(pathCoder,queryKey);};var pushLocation=function pushLocation(location){return HashProtocol.pushLocation(location,pathCoder,queryKey);};var replaceLocation=function replaceLocation(location){return HashProtocol.replaceLocation(location,pathCoder,queryKey);};var history=(0,_createHistory2.default)((0,_extends3.default)({getUserConfirmation:getUserConfirmation},options,{getCurrentLocation:getCurrentLocation,pushLocation:pushLocation,replaceLocation:replaceLocation,go:HashProtocol.go}));var listenerCount=0,stopListener=void 0;var startListener=function startListener(listener,before){if(++listenerCount===1)stopListener=HashProtocol.startListener(history.transitionTo,pathCoder,queryKey);var unlisten=before?history.listenBefore(listener):history.listen(listener);return function(){unlisten();if(--listenerCount===0)stopListener();};};var listenBefore=function listenBefore(listener){return startListener(listener,true);};var listen=function listen(listener){return startListener(listener,false);};var goIsSupportedWithoutReload=(0,_DOMUtils.supportsGoWithoutReloadUsingHash)();var go=function go(n){(0,_warning2.default)(goIsSupportedWithoutReload,'Hash history go(n) causes a full page reload in this browser');history.go(n);};var createHref=function createHref(path){return'#'+pathCoder.encodePath(history.createHref(path));};return(0,_extends3.default)({},history,{listenBefore:listenBefore,listen:listen,go:go,createHref:createHref});};exports.default=createHashHistory;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.replaceLocation=exports.pushLocation=exports.startListener=exports.getCurrentLocation=exports.go=exports.getUserConfirmation=undefined;var _BrowserProtocol=__webpack_require__(116);Object.defineProperty(exports,'getUserConfirmation',{enumerable:true,get:function get(){return _BrowserProtocol.getUserConfirmation;}});Object.defineProperty(exports,'go',{enumerable:true,get:function get(){return _BrowserProtocol.go;}});var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);var _LocationUtils=__webpack_require__(43);var _DOMUtils=__webpack_require__(63);var _DOMStateStorage=__webpack_require__(176);var _PathUtils=__webpack_require__(36);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var HashChangeEvent='hashchange';var getHashPath=function getHashPath(){// We can't use window.location.hash here because it's not
// consistent across browsers - Firefox will pre-decode it!
var href=window.location.href;var hashIndex=href.indexOf('#');return hashIndex===-1?'':href.substring(hashIndex+1);};var pushHashPath=function pushHashPath(path){return window.location.hash=path;};var replaceHashPath=function replaceHashPath(path,queryKey){var hashIndex=window.location.href.indexOf('#');// zxt 临时写死
if(queryKey&&path.indexOf(queryKey)<0){var key=Math.random().toString(36).substr(2,6);if(path.indexOf('?')<0){path=path+'?'+queryKey+'='+key;}else{if(path.indexOf('=')<0)path=path+queryKey+'='+key;if(path.indexOf('=')>0)path=path+'&'+queryKey+'='+key;}}window.location.replace(window.location.href.slice(0,hashIndex>=0?hashIndex:0)+'#'+path);};var getCurrentLocation=exports.getCurrentLocation=function getCurrentLocation(pathCoder,queryKey){var path=pathCoder.decodePath(getHashPath());var key=(0,_PathUtils.getQueryStringValueFromPath)(path,queryKey);var state=void 0;if(!key)key=Math.random().toString(36).substr(2,6);if(key){path=(0,_PathUtils.stripQueryStringValueFromPath)(path,queryKey);state=(0,_DOMStateStorage.readState)(key);}var init=(0,_PathUtils.parsePath)(path);init.state=state;return(0,_LocationUtils.createLocation)(init,undefined,key);};var prevLocation=void 0;var startListener=exports.startListener=function startListener(listener,pathCoder,queryKey){var handleHashChange=function handleHashChange(){var path=getHashPath();var encodedPath=pathCoder.encodePath(path);if(path!==encodedPath){// Always be sure we have a properly-encoded hash.
replaceHashPath(encodedPath,queryKey);}else{var currentLocation=getCurrentLocation(pathCoder,queryKey);if(prevLocation&&currentLocation.key&&prevLocation.key===currentLocation.key)return;// Ignore extraneous hashchange events
prevLocation=currentLocation;listener(currentLocation);}};// Ensure the hash is encoded properly.
var path=getHashPath();var encodedPath=pathCoder.encodePath(path);if(path!==encodedPath||encodedPath.indexOf(queryKey)<0)replaceHashPath(encodedPath,queryKey);(0,_DOMUtils.addEventListener)(window,HashChangeEvent,handleHashChange);return function(){return(0,_DOMUtils.removeEventListener)(window,HashChangeEvent,handleHashChange);};};var updateLocation=function updateLocation(location,pathCoder,queryKey,updateHash){var state=location.state,key=location.key;var path=pathCoder.encodePath((0,_PathUtils.createPath)(location));//if (state !== undefined) {
path=(0,_PathUtils.addQueryStringValueToPath)(path,queryKey,key);(0,_DOMStateStorage.saveState)(key,state);//}
prevLocation=location;updateHash(path);};var pushLocation=exports.pushLocation=function pushLocation(location,pathCoder,queryKey){return updateLocation(location,pathCoder,queryKey,function(path){if(getHashPath()!==path){pushHashPath(path);}else{(0,_warning2.default)(false,'You cannot PUSH the same path using hash history');}});};var replaceLocation=exports.replaceLocation=function replaceLocation(location,pathCoder,queryKey){return updateLocation(location,pathCoder,queryKey,function(path){if(getHashPath()!==path)replaceHashPath(path);});};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);var _invariant=__webpack_require__(62);var _invariant2=_interopRequireDefault(_invariant);var _LocationUtils=__webpack_require__(43);var _PathUtils=__webpack_require__(36);var _createHistory=__webpack_require__(117);var _createHistory2=_interopRequireDefault(_createHistory);var _Actions=__webpack_require__(80);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var createStateStorage=function createStateStorage(entries){return entries.filter(function(entry){return entry.state;}).reduce(function(memo,entry){memo[entry.key]=entry.state;return memo;},{});};var createMemoryHistory=function createMemoryHistory(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(Array.isArray(options)){options={entries:options};}else if(typeof options==='string'){options={entries:[options]};}var getCurrentLocation=function getCurrentLocation(){var entry=entries[current];var path=(0,_PathUtils.createPath)(entry);var key=void 0,state=void 0;if(entry.key){key=entry.key;state=readState(key);}var init=(0,_PathUtils.parsePath)(path);return(0,_LocationUtils.createLocation)((0,_extends3.default)({},init,{state:state}),undefined,key);};var canGo=function canGo(n){var index=current+n;return index>=0&&index<entries.length;};var go=function go(n){if(!n)return;if(!canGo(n)){(0,_warning2.default)(false,'Cannot go(%s) there is not enough history',n);return;}current+=n;var currentLocation=getCurrentLocation();// Change action to POP
history.transitionTo((0,_extends3.default)({},currentLocation,{action:_Actions.POP}));};var pushLocation=function pushLocation(location){current+=1;if(current<entries.length)entries.splice(current);entries.push(location);saveState(location.key,location.state);};var replaceLocation=function replaceLocation(location){entries[current]=location;saveState(location.key,location.state);};var history=(0,_createHistory2.default)((0,_extends3.default)({},options,{getCurrentLocation:getCurrentLocation,pushLocation:pushLocation,replaceLocation:replaceLocation,go:go}));var _options=options,entries=_options.entries,current=_options.current;if(typeof entries==='string'){entries=[entries];}else if(!Array.isArray(entries)){entries=['/'];}entries=entries.map(function(entry){return(0,_LocationUtils.createLocation)(entry);});if(current==null){current=entries.length-1;}else{(0,_invariant2.default)(current>=0&&current<entries.length,'Current index must be >= 0 and < %s, was %s',entries.length,current);}var storage=createStateStorage(entries);var saveState=function saveState(key,state){return storage[key]=state;};var readState=function readState(key){return storage[key];};return(0,_extends3.default)({},history,{canGo:canGo});};exports.default=createMemoryHistory;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _runTransitionHook=__webpack_require__(118);var _runTransitionHook2=_interopRequireDefault(_runTransitionHook);var _PathUtils=__webpack_require__(36);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var useBasename=function useBasename(createHistory){return function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var history=createHistory(options);var basename=options.basename;var addBasename=function addBasename(location){if(!location)return location;if(basename&&location.basename==null){if(location.pathname.toLowerCase().indexOf(basename.toLowerCase())===0){location.pathname=location.pathname.substring(basename.length);location.basename=basename;if(location.pathname==='')location.pathname='/';}else{location.basename='';}}return location;};var prependBasename=function prependBasename(location){if(!basename)return location;var object=typeof location==='string'?(0,_PathUtils.parsePath)(location):location;var pname=object.pathname;var normalizedBasename=basename.slice(-1)==='/'?basename:basename+'/';var normalizedPathname=pname.charAt(0)==='/'?pname.slice(1):pname;var pathname=normalizedBasename+normalizedPathname;return(0,_extends3.default)({},object,{pathname:pathname});};// Override all read methods with basename-aware versions.
var getCurrentLocation=function getCurrentLocation(){return addBasename(history.getCurrentLocation());};var listenBefore=function listenBefore(hook){return history.listenBefore(function(location,callback){return(0,_runTransitionHook2.default)(hook,addBasename(location),callback);});};var listen=function listen(listener){return history.listen(function(location){return listener(addBasename(location));});};// Override all write methods with basename-aware versions.
var push=function push(location){return history.push(prependBasename(location));};var replace=function replace(location){return history.replace(prependBasename(location));};var createPath=function createPath(location){return history.createPath(prependBasename(location));};var createHref=function createHref(location){return history.createHref(prependBasename(location));};var createLocation=function createLocation(location){for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}return addBasename(history.createLocation.apply(history,[prependBasename(location)].concat(args)));};return(0,_extends3.default)({},history,{getCurrentLocation:getCurrentLocation,listenBefore:listenBefore,listen:listen,push:push,replace:replace,createPath:createPath,createHref:createHref,createLocation:createLocation});};};exports.default=useBasename;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _invariant=__webpack_require__(62);var _invariant2=_interopRequireDefault(_invariant);var _DOMUtils=__webpack_require__(63);var _ExecutionEnvironment=__webpack_require__(81);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var startListener=function startListener(getPromptMessage){var handleBeforeUnload=function handleBeforeUnload(event){var message=getPromptMessage();if(typeof message==='string'){(event||window.event).returnValue=message;return message;}return undefined;};(0,_DOMUtils.addEventListener)(window,'beforeunload',handleBeforeUnload);return function(){return(0,_DOMUtils.removeEventListener)(window,'beforeunload',handleBeforeUnload);};};/**
 * Returns a new createHistory function that can be used to create
 * history objects that know how to use the beforeunload event in web
 * browsers to cancel navigation.
 */var useBeforeUnload=function useBeforeUnload(createHistory){(0,_invariant2.default)(_ExecutionEnvironment.canUseDOM,'useBeforeUnload only works in DOM environments');return function(options){var history=createHistory(options);var listeners=[];var stopListener=void 0;var getPromptMessage=function getPromptMessage(){var message=void 0;for(var i=0,len=listeners.length;message==null&&i<len;++i){message=listeners[i].call();}return message;};var listenBeforeUnload=function listenBeforeUnload(listener){if(listeners.push(listener)===1)stopListener=startListener(getPromptMessage);return function(){listeners=listeners.filter(function(item){return item!==listener;});if(listeners.length===0&&stopListener){stopListener();stopListener=null;}};};return(0,_extends3.default)({},history,{listenBeforeUnload:listenBeforeUnload});};};exports.default=useBeforeUnload;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _queryString=__webpack_require__(354);var _runTransitionHook=__webpack_require__(118);var _runTransitionHook2=_interopRequireDefault(_runTransitionHook);var _LocationUtils=__webpack_require__(43);var _PathUtils=__webpack_require__(36);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var defaultStringifyQuery=function defaultStringifyQuery(query){return(0,_queryString.stringify)(query).replace(/%20/g,'+');};var defaultParseQueryString=_queryString.parse;/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */var useQueries=function useQueries(createHistory){return function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var history=createHistory(options);var stringifyQuery=options.stringifyQuery,parseQueryString=options.parseQueryString;if(typeof stringifyQuery!=='function')stringifyQuery=defaultStringifyQuery;if(typeof parseQueryString!=='function')parseQueryString=defaultParseQueryString;var decodeQuery=function decodeQuery(location){if(!location)return location;if(location.query==null)location.query=parseQueryString(location.search.substring(1));return location;};var encodeQuery=function encodeQuery(location,query){if(query==null)return location;var object=typeof location==='string'?(0,_PathUtils.parsePath)(location):location;var queryString=stringifyQuery(query);var search=queryString?'?'+queryString:'';return(0,_extends3.default)({},object,{search:search});};// Override all read methods with query-aware versions.
var getCurrentLocation=function getCurrentLocation(){return decodeQuery(history.getCurrentLocation());};var listenBefore=function listenBefore(hook){return history.listenBefore(function(location,callback){return(0,_runTransitionHook2.default)(hook,decodeQuery(location),callback);});};var listen=function listen(listener){return history.listen(function(location){return listener(decodeQuery(location));});};// Override all write methods with query-aware versions.
var push=function push(location){return history.push(encodeQuery(location,location.query));};var replace=function replace(location){return history.replace(encodeQuery(location,location.query));};var createPath=function createPath(location){return history.createPath(encodeQuery(location,location.query));};var createHref=function createHref(location){return history.createHref(encodeQuery(location,location.query));};var createLocation=function createLocation(location){for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}var newLocation=history.createLocation.apply(history,[encodeQuery(location,location.query)].concat(args));if(location.query)newLocation.query=(0,_LocationUtils.createQuery)(location.query);return decodeQuery(newLocation);};return(0,_extends3.default)({},history,{getCurrentLocation:getCurrentLocation,listenBefore:listenBefore,listen:listen,push:push,replace:replace,createPath:createPath,createHref:createHref,createLocation:createLocation});};};exports.default=useQueries;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(355);
var objectAssign = __webpack_require__(19);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./affix/index.jsx": 358,
	"./affix/style/index.js": 373,
	"./alert/index.jsx": 375,
	"./alert/style/index.js": 382,
	"./back-top/index.jsx": 384,
	"./back-top/style/index.js": 388,
	"./badge/index.jsx": 390,
	"./badge/style/index.js": 392,
	"./breadcrumb/index.jsx": 394,
	"./breadcrumb/style/index.js": 396,
	"./button/index.jsx": 55,
	"./button/style/index.js": 64,
	"./calendar/index.jsx": 401,
	"./calendar/style/index.js": 508,
	"./card/index.jsx": 513,
	"./card/style/index.js": 514,
	"./carousel/index.jsx": 516,
	"./carousel/style/index.js": 532,
	"./cascader/index.jsx": 534,
	"./cascader/style/index.js": 541,
	"./checkbox/index.jsx": 244,
	"./checkbox/style/index.js": 53,
	"./col/index.js": 208,
	"./col/style/index.js": 551,
	"./collapse/index.jsx": 552,
	"./collapse/style/index.js": 558,
	"./date-picker/index.jsx": 560,
	"./date-picker/style/index.js": 567,
	"./dropdown/index.jsx": 269,
	"./dropdown/style/index.js": 211,
	"./form/index.jsx": 575,
	"./form/style/index.js": 611,
	"./icon/index.jsx": 16,
	"./icon/style/index.js": 613,
	"./input-number/index.jsx": 614,
	"./input-number/style/index.js": 615,
	"./input/index.jsx": 206,
	"./input/style/index.js": 37,
	"./layout/index.jsx": 131,
	"./layout/style/index.js": 221,
	"./locale-provider/index.jsx": 617,
	"./locale-provider/style/index.js": 644,
	"./menu/index.jsx": 645,
	"./menu/style/index.js": 646,
	"./message/index.jsx": 270,
	"./message/style/index.js": 652,
	"./modal/index.jsx": 654,
	"./modal/style/index.js": 661,
	"./notification/index.jsx": 663,
	"./notification/style/index.js": 667,
	"./pagination/index.jsx": 271,
	"./pagination/style/index.js": 228,
	"./popconfirm/index.jsx": 670,
	"./popconfirm/style/index.js": 671,
	"./popover/index.jsx": 673,
	"./popover/style/index.js": 229,
	"./progress/index.jsx": 230,
	"./progress/style/index.js": 231,
	"./queue-anim/index.jsx": 678,
	"./queue-anim/style/index.js": 687,
	"./radio/index.jsx": 140,
	"./radio/style/index.js": 130,
	"./rate/index.jsx": 688,
	"./rate/style/index.js": 694,
	"./row/index.js": 219,
	"./row/style/index.js": 696,
	"./select-new/index.jsx": 697,
	"./select/index.jsx": 245,
	"./select/style/index.js": 92,
	"./slider/index.jsx": 701,
	"./slider/style/index.js": 702,
	"./spin/index.jsx": 273,
	"./spin/style/index.js": 233,
	"./steps/index.jsx": 706,
	"./steps/style/index.js": 707,
	"./style/index.js": 709,
	"./switch/index.jsx": 710,
	"./switch/style/index.js": 713,
	"./table/index.jsx": 715,
	"./table/style/index.js": 274,
	"./tabs/index.jsx": 717,
	"./tabs/style/index.js": 740,
	"./tag/index.jsx": 742,
	"./tag/style/index.js": 743,
	"./time-picker/index.jsx": 745,
	"./time-picker/style/index.js": 209,
	"./timeline/index.jsx": 746,
	"./timeline/style/index.js": 748,
	"./tooltip/index.jsx": 91,
	"./tooltip/style/index.js": 232,
	"./transfer/index.jsx": 750,
	"./transfer/style/index.js": 754,
	"./transfer_browser/index.jsx": 756,
	"./transfer_browser/style/index.js": 760,
	"./tree-new/index.jsx": 762,
	"./tree-select/index.jsx": 763,
	"./tree-select/style/index.js": 765,
	"./tree-z/index.jsx": 239,
	"./tree/index.jsx": 771,
	"./tree/style/index.js": 772,
	"./upload/index.jsx": 774,
	"./upload/style/index.js": 782,
	"./validation/index.jsx": 784,
	"./validation/style/index.js": 785
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 357;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _addEventListener=__webpack_require__(70);var _addEventListener2=_interopRequireDefault(_addEventListener);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);var _shallowequal=__webpack_require__(242);var _shallowequal2=_interopRequireDefault(_shallowequal);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function getScroll(target,top){var prop=top?'pageYOffset':'pageXOffset';var method=top?'scrollTop':'scrollLeft';var isWindow=target===window;var ret=isWindow?target[prop]:target[method];// ie6,7,8 standard mode
if(isWindow&&typeof ret!=='number'){ret=window.document.documentElement[method];}return ret;}function getTargetRect(target){return target!==window?target.getBoundingClientRect():{top:0,left:0,bottom:0};}function getOffset(element,target){var elemRect=element.getBoundingClientRect();var targetRect=getTargetRect(target);var scrollTop=getScroll(target,true);var scrollLeft=getScroll(target,false);var docElem=window.document.body;var clientTop=docElem.clientTop||0;var clientLeft=docElem.clientLeft||0;return{top:elemRect.top-targetRect.top+scrollTop-clientTop,left:elemRect.left-targetRect.left+scrollLeft-clientLeft};}var Affix=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Affix,_React$Component);function Affix(props){(0,_classCallCheck3.default)(this,Affix);var _this=(0,_possibleConstructorReturn3.default)(this,(Affix.__proto__||(0,_getPrototypeOf2.default)(Affix)).call(this,props));_this.updatePosition=function(e){var _this$props=_this.props,offsetTop=_this$props.offsetTop,offsetBottom=_this$props.offsetBottom,offset=_this$props.offset,target=_this$props.target;var targetNode=target();// Backwards support
offsetTop=offsetTop||offset;var scrollTop=getScroll(targetNode,true);var elemOffset=getOffset(_reactDom2.default.findDOMNode(_this),targetNode);var elemSize={width:_this.refs.fixedNode.offsetWidth,height:_this.refs.fixedNode.offsetHeight};var offsetMode={};// Default to `offsetTop=0`.
if(typeof offsetTop!=='number'&&typeof offsetBottom!=='number'){offsetMode.top=true;offsetTop=0;}else{offsetMode.top=typeof offsetTop==='number';offsetMode.bottom=typeof offsetBottom==='number';}var targetRect=getTargetRect(targetNode);var targetInnerHeight=targetNode.innerHeight||targetNode.clientHeight;if(scrollTop>elemOffset.top-offsetTop&&offsetMode.top){// Fixed Top
_this.setAffixStyle(e,{position:'fixed',top:targetRect.top+offsetTop,left:targetRect.left+elemOffset.left,width:_reactDom2.default.findDOMNode(_this).offsetWidth});_this.setPlaceholderStyle(e,{width:_reactDom2.default.findDOMNode(_this).offsetWidth,height:_reactDom2.default.findDOMNode(_this).offsetHeight});}else if(scrollTop<elemOffset.top+elemSize.height+offsetBottom-targetInnerHeight&&offsetMode.bottom){// Fixed Bottom
var targetBottomOffet=targetNode===window?0:window.innerHeight-targetRect.bottom;_this.setAffixStyle(e,{position:'fixed',bottom:targetBottomOffet+offsetBottom,left:targetRect.left+elemOffset.left,width:_reactDom2.default.findDOMNode(_this).offsetWidth});_this.setPlaceholderStyle(e,{width:_reactDom2.default.findDOMNode(_this).offsetWidth,height:_reactDom2.default.findDOMNode(_this).offsetHeight});}else{_this.setAffixStyle(e,null);_this.setPlaceholderStyle(e,null);}};_this.state={affixStyle:null,placeholderStyle:null};return _this;}(0,_createClass3.default)(Affix,[{key:'setAffixStyle',value:function setAffixStyle(e,affixStyle){var _this2=this;var _props=this.props,onChange=_props.onChange,target=_props.target;var originalAffixStyle=this.state.affixStyle;var isWindow=target()===window;if(e.type==='scroll'&&originalAffixStyle&&affixStyle&&isWindow){return;}if((0,_shallowequal2.default)(affixStyle,originalAffixStyle)){return;}this.setState({affixStyle:affixStyle},function(){var affixed=!!_this2.state.affixStyle;if(affixStyle&&!originalAffixStyle||!affixStyle&&originalAffixStyle){onChange(affixed);}});}},{key:'setPlaceholderStyle',value:function setPlaceholderStyle(e,placeholderStyle){var originalPlaceholderStyle=this.state.placeholderStyle;if(e.type==='resize'){return;}if((0,_shallowequal2.default)(placeholderStyle,originalPlaceholderStyle)){return;}this.setState({placeholderStyle:placeholderStyle});}},{key:'componentDidMount',value:function componentDidMount(){(0,_warning2.default)(!('offset'in this.props),'`offset` prop of Affix is deprecated, use `offsetTop` instead.');var target=this.props.target;this.setTargetEventListeners(target);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.target!==nextProps.target){this.clearScrollEventListeners();this.setTargetEventListeners(nextProps.target);// Mock Event object.
this.updatePosition({});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.clearScrollEventListeners();}},{key:'setTargetEventListeners',value:function setTargetEventListeners(getTarget){var target=getTarget();this.scrollEvent=(0,_addEventListener2.default)(target,'scroll',this.updatePosition);this.resizeEvent=(0,_addEventListener2.default)(target,'resize',this.updatePosition);}},{key:'clearScrollEventListeners',value:function clearScrollEventListeners(){var _this3=this;['scrollEvent','resizeEvent'].forEach(function(name){if(_this3[name]){_this3[name].remove();}});}},{key:'render',value:function render(){var className=(0,_classnames2.default)({'ant-affix':this.state.affixStyle});var props=(0,_extends3.default)({},this.props);delete props.offsetTop;delete props.offsetBottom;delete props.target;return _react2.default.createElement('div',(0,_extends3.default)({},props,{style:this.state.placeholderStyle}),_react2.default.createElement('div',{className:className,ref:'fixedNode',style:this.state.affixStyle},this.props.children));}}]);return Affix;}(_react2.default.Component),_class.propTypes={offsetTop:_react2.default.PropTypes.number,offsetBottom:_react2.default.PropTypes.number,target:_react2.default.PropTypes.func},_class.defaultProps={target:function target(){return window;},onChange:function onChange(){}},_temp);exports.default=Affix;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(360);
module.exports = __webpack_require__(14).Object.getPrototypeOf;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(52);
var $getPrototypeOf = __webpack_require__(160);

__webpack_require__(174)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(362);
var $Object = __webpack_require__(14).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(25);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(32), 'Object', { defineProperty: __webpack_require__(31).f });


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(364), __esModule: true };

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(365);
module.exports = __webpack_require__(14).Object.setPrototypeOf;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(25);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(366).set });


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(34);
var anObject = __webpack_require__(30);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(49)(Function.call, __webpack_require__(170).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(368);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(19);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(370),
    isArguments = __webpack_require__(371),
    isArray = __webpack_require__(372);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 372 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(374);

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Alert=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Alert,_React$Component);function Alert(props){(0,_classCallCheck3.default)(this,Alert);var _this=(0,_possibleConstructorReturn3.default)(this,(Alert.__proto__||(0,_getPrototypeOf2.default)(Alert)).call(this,props));_this.handleClose=function(e){e.preventDefault();var dom=_reactDom2.default.findDOMNode(_this);dom.style.height=dom.offsetHeight+'px';// Magic code
// 重复一次后才能正确设置 height
dom.style.height=dom.offsetHeight+'px';_this.setState({closing:false});_this.props.onClose(e);};_this.animationEnd=function(){_this.setState({closed:true,closing:true});};_this.state={closing:true,closed:false};return _this;}(0,_createClass3.default)(Alert,[{key:'render',value:function render(){var _classNames;var _props=this.props,closable=_props.closable,description=_props.description,type=_props.type,prefixCls=_props.prefixCls,message=_props.message,closeText=_props.closeText,showIcon=_props.showIcon;var iconType='';switch(type){case'success':iconType='check-circle';break;case'info':iconType='info-circle';break;case'error':iconType='cross-circle';break;case'warning':iconType='exclamation-circle';break;default:iconType='default';}// use outline icon in alert with description
if(!!description){iconType+='-o';}var alertCls=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls,true),(0,_defineProperty3.default)(_classNames,prefixCls+'-'+type,true),(0,_defineProperty3.default)(_classNames,prefixCls+'-close',!this.state.closing),(0,_defineProperty3.default)(_classNames,prefixCls+'-with-description',!!description),(0,_defineProperty3.default)(_classNames,prefixCls+'-no-icon',!showIcon),_classNames));// closeable when closeText is assigned
if(closeText){closable=true;}return this.state.closed?null:_react2.default.createElement(_rcAnimate2.default,{component:'',showProp:'data-show',transitionName:prefixCls+'-slide-up',onEnd:this.animationEnd},_react2.default.createElement('div',{'data-show':this.state.closing,className:alertCls},showIcon?_react2.default.createElement(_icon2.default,{className:'ant-alert-icon',type:iconType}):null,_react2.default.createElement('span',{className:prefixCls+'-message'},message),_react2.default.createElement('span',{className:prefixCls+'-description'},description),closable?_react2.default.createElement('a',{onClick:this.handleClose,className:prefixCls+'-close-icon'},closeText||_react2.default.createElement(_icon2.default,{type:'cross'})):null));}}]);return Alert;}(_react2.default.Component),_class.defaultProps={prefixCls:'ant-alert',showIcon:false,onClose:function onClose(){},type:'info'},_temp);exports.default=Alert;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(377);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(179);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["isCssAnimationSupported"] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["default"])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(383);

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);var _addEventListener=__webpack_require__(70);var _addEventListener2=_interopRequireDefault(_addEventListener);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _object=__webpack_require__(44);var _object2=_interopRequireDefault(_object);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function getScroll(target,top){if(typeof window==='undefined'){return 0;}var prop=top?'pageYOffset':'pageXOffset';var method=top?'scrollTop':'scrollLeft';var isWindow=target===window;var ret=isWindow?target[prop]:target[method];// ie6,7,8 standard mode
if(isWindow&&typeof ret!=='number'){ret=window.document.documentElement[method];}return ret;}var BackTop=(_temp=_class=function(_React$Component){(0,_inherits3.default)(BackTop,_React$Component);function BackTop(props){(0,_classCallCheck3.default)(this,BackTop);var _this=(0,_possibleConstructorReturn3.default)(this,(BackTop.__proto__||(0,_getPrototypeOf2.default)(BackTop)).call(this,props));_initialiseProps.call(_this);var scrollTop=getScroll(props.target(),true);_this.state={visible:scrollTop>props.visibilityHeight};return _this;}(0,_createClass3.default)(BackTop,[{key:'setScrollTop',value:function setScrollTop(value){var targetNode=this.props.target();if(targetNode===window){document.body.scrollTop=value;document.documentElement.scrollTop=value;}else{targetNode.scrollTop=value;}}},{key:'componentDidMount',value:function componentDidMount(){this.scrollEvent=(0,_addEventListener2.default)(this.props.target(),'scroll',this.handleScroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.scrollEvent){this.scrollEvent.remove();}}},{key:'render',value:function render(){var _classNames;var _props=this.props,prefixCls=_props.prefixCls,className=_props.className,children=_props.children,otherProps=(0,_objectWithoutProperties3.default)(_props,['prefixCls','className','children']);var classString=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls,true),(0,_defineProperty3.default)(_classNames,className,!!className),_classNames));var defaultElement=_react2.default.createElement('div',{className:prefixCls+'-content'},_react2.default.createElement(_icon2.default,{className:prefixCls+'-icon',type:'to-top'}));// fix https://fb.me/react-unknown-prop
var divProps=(0,_object2.default)(otherProps,['visibilityHeight']);return _react2.default.createElement(_rcAnimate2.default,{component:'',transitionName:'fade'},this.state.visible?_react2.default.createElement('div',(0,_extends3.default)({},divProps,{className:classString,onClick:this.scrollToTop}),children||defaultElement):null);}}]);return BackTop;}(_react2.default.Component),_class.propTypes={visibilityHeight:_react2.default.PropTypes.number,target:_react2.default.PropTypes.func},_class.defaultProps={onClick:function onClick(){},visibilityHeight:400,target:function target(){return window;},prefixCls:'ant-back-top'},_initialiseProps=function _initialiseProps(){var _this2=this;this.scrollToTop=function(e){if(e)e.preventDefault();_this2.setScrollTop(0);_this2.props.onClick(e);};this.handleScroll=function(){var _props2=_this2.props,visibilityHeight=_props2.visibilityHeight,target=_props2.target;var scrollTop=getScroll(target(),true);_this2.setState({visible:scrollTop>visibilityHeight});};},_temp);exports.default=BackTop;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-extendable <https://github.com/jonschlinkert/is-extendable>
 *
 * Copyright (c) 2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */



module.exports = function isExtendable(val) {
  return typeof val !== 'undefined' && val !== null
    && (typeof val === 'object' || typeof val === 'function');
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * for-own <https://github.com/jonschlinkert/for-own>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var forIn = __webpack_require__(387);
var hasOwn = Object.prototype.hasOwnProperty;

module.exports = function forOwn(obj, fn, thisArg) {
  forIn(obj, function(val, key) {
    if (hasOwn.call(obj, key)) {
      return fn.call(thisArg, obj[key], key, obj);
    }
  });
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * for-in <https://github.com/jonschlinkert/for-in>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function forIn(obj, fn, thisArg) {
  for (var key in obj) {
    if (fn.call(thisArg, obj[key], key, obj) === false) {
      break;
    }
  }
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(389);

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _ScrollNumber=__webpack_require__(391);var _ScrollNumber2=_interopRequireDefault(_ScrollNumber);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Badge=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Badge,_React$Component);function Badge(){(0,_classCallCheck3.default)(this,Badge);return(0,_possibleConstructorReturn3.default)(this,(Badge.__proto__||(0,_getPrototypeOf2.default)(Badge)).apply(this,arguments));}(0,_createClass3.default)(Badge,[{key:'render',value:function render(){var _classNames;var _props=this.props,count=_props.count,prefixCls=_props.prefixCls,overflowCount=_props.overflowCount,className=_props.className,style=_props.style,children=_props.children,dot=_props.dot,restProps=(0,_objectWithoutProperties3.default)(_props,['count','prefixCls','overflowCount','className','style','children','dot']);count=count>overflowCount?overflowCount+'+':count;// dot mode don't need count
if(dot){count='';}// null undefined "" "0" 0
var hidden=(!count||count==='0')&&!dot;var scrollNumberCls=prefixCls+(dot?'-dot':'-count');var badgeCls=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,className,!!className),(0,_defineProperty3.default)(_classNames,prefixCls,true),(0,_defineProperty3.default)(_classNames,prefixCls+'-not-a-wrapper',!children),_classNames));return _react2.default.createElement('span',(0,_extends3.default)({className:badgeCls,title:count,style:null},restProps),children,_react2.default.createElement(_rcAnimate2.default,{component:'',showProp:'data-show',transitionName:prefixCls+'-zoom',transitionAppear:true},hidden?null:_react2.default.createElement(_ScrollNumber2.default,{'data-show':!hidden,className:scrollNumberCls,count:count,style:style})));}}]);return Badge;}(_react2.default.Component),_class.defaultProps={prefixCls:'ant-badge',count:null,dot:false,overflowCount:99},_class.propTypes={count:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string,_react2.default.PropTypes.number]),dot:_react2.default.PropTypes.bool,overflowCount:_react2.default.PropTypes.number},_temp);exports.default=Badge;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _isCssAnimationSupported=__webpack_require__(180);var _isCssAnimationSupported2=_interopRequireDefault(_isCssAnimationSupported);var _object=__webpack_require__(44);var _object2=_interopRequireDefault(_object);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function getNumberArray(num){return num?num.toString().split('').reverse().map(function(i){return Number(i);}):[];}var ScrollNumber=(_temp=_class=function(_React$Component){(0,_inherits3.default)(ScrollNumber,_React$Component);function ScrollNumber(props){(0,_classCallCheck3.default)(this,ScrollNumber);var _this=(0,_possibleConstructorReturn3.default)(this,(ScrollNumber.__proto__||(0,_getPrototypeOf2.default)(ScrollNumber)).call(this,props));_this.state={animateStarted:true,count:props.count};return _this;}(0,_createClass3.default)(ScrollNumber,[{key:'componentDidMount',value:function componentDidMount(){if(!(0,_isCssAnimationSupported2.default)()){(0,_reactDom.findDOMNode)(this).className+=' not-support-css-animation';}}},{key:'getPositionByNum',value:function getPositionByNum(num,i){if(this.state.animateStarted){return 10+num;}var currentDigit=getNumberArray(this.state.count)[i];var lastDigit=getNumberArray(this.lastCount)[i];// 同方向则在同一侧切换数字
if(this.state.count>this.lastCount){if(currentDigit>=lastDigit){return 10+num;}return 20+num;}if(currentDigit<=lastDigit){return 10+num;}return num;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;if('count'in nextProps){if(this.state.count===nextProps.count){return;}this.lastCount=this.state.count;// 复原数字初始位置
this.setState({animateStarted:true},function(){// 等待数字位置复原完毕
// 开始设置完整的数字
setTimeout(function(){_this2.setState({animateStarted:false,count:nextProps.count},function(){_this2.props.onAnimated();});},5);});}}},{key:'renderNumberList',value:function renderNumberList(position){var childrenToReturn=[];for(var i=0;i<30;i++){var currentClassName=position===i?'current':null;childrenToReturn.push(_react2.default.createElement('p',{key:i,className:currentClassName},i%10));}return childrenToReturn;}},{key:'renderCurrentNumber',value:function renderCurrentNumber(num,i){var position=this.getPositionByNum(num,i);var height=this.props.height;var removeTransition=this.state.animateStarted||getNumberArray(this.lastCount)[i]===undefined;return(0,_react.createElement)('span',{className:this.props.prefixCls+'-only',style:{transition:removeTransition&&'none',WebkitTransform:'translateY('+-position*height+'px)',transform:'translateY('+-position*height+'px)',height:height},key:i},this.renderNumberList(position));}},{key:'renderNumberElement',value:function renderNumberElement(){var _this3=this;var state=this.state;if(!state.count||isNaN(state.count)){return state.count;}return getNumberArray(state.count).map(function(num,i){return _this3.renderCurrentNumber(num,i);}).reverse();}},{key:'render',value:function render(){var _props=this.props,component=_props.component,prefixCls=_props.prefixCls,className=_props.className,otherProps=(0,_objectWithoutProperties3.default)(_props,['component','prefixCls','className']);// fix https://fb.me/react-unknown-prop
var restProps=(0,_object2.default)(otherProps,['count','onAnimated']);var props=(0,_extends3.default)({},restProps,{className:prefixCls+' '+className});return(0,_react.createElement)(component,props,this.renderNumberElement());}}]);return ScrollNumber;}(_react2.default.Component),_class.defaultProps={prefixCls:'ant-scroll-number',count:null,component:'sup',onAnimated:function onAnimated(){},height:18},_class.propTypes={count:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string,_react2.default.PropTypes.number]),component:_react2.default.PropTypes.string,onAnimated:_react2.default.PropTypes.func,height:_react2.default.PropTypes.number},_temp);exports.default=ScrollNumber;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(393);

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Breadcrumb=__webpack_require__(395);var _Breadcrumb2=_interopRequireDefault(_Breadcrumb);var _BreadcrumbItem=__webpack_require__(181);var _BreadcrumbItem2=_interopRequireDefault(_BreadcrumbItem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_Breadcrumb2.default.Item=_BreadcrumbItem2.default;exports.default=_Breadcrumb2.default;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _BreadcrumbItem=__webpack_require__(181);var _BreadcrumbItem2=_interopRequireDefault(_BreadcrumbItem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var defaultNameRender=function defaultNameRender(breadcrumbName,route,params){if(!breadcrumbName){return null;}var paramsKeys=(0,_keys2.default)(params).join('|');var name=breadcrumbName.replace(new RegExp(':('+paramsKeys+')','g'),function(replacement,key){return params[key]||replacement;});return _react2.default.createElement('span',null,name);};var Breadcrumb=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Breadcrumb,_React$Component);function Breadcrumb(){(0,_classCallCheck3.default)(this,Breadcrumb);return(0,_possibleConstructorReturn3.default)(this,(Breadcrumb.__proto__||(0,_getPrototypeOf2.default)(Breadcrumb)).apply(this,arguments));}(0,_createClass3.default)(Breadcrumb,[{key:'render',value:function render(){var crumbs=void 0;var _props=this.props,separator=_props.separator,prefixCls=_props.prefixCls,routes=_props.routes,params=_props.params,children=_props.children,linkRender=_props.linkRender,nameRender=_props.nameRender;if(routes&&routes.length>0){var paths=[];var lastPath=routes.length-1;crumbs=routes.map(function(route,i){route.path=route.path||'';var path=route.path.replace(/^\//,'');(0,_keys2.default)(params).forEach(function(key){path=path.replace(':'+key,params[key]);});if(path){paths.push(path);}var name=nameRender(route.breadcrumbName,route,params);if(name){var link=i===lastPath?name:linkRender('/'+paths.join('/'),name,paths);return _react2.default.createElement(_BreadcrumbItem2.default,{separator:separator,key:route.breadcrumbName||i},link);}return null;});}else{crumbs=_react2.default.Children.map(children,function(element,index){return(0,_react.cloneElement)(element,{separator:separator,key:index});});}return _react2.default.createElement('div',{className:prefixCls},crumbs);}}]);return Breadcrumb;}(_react2.default.Component),_class.defaultProps={prefixCls:'ant-breadcrumb',separator:'/',linkRender:function linkRender(href,name){return _react2.default.createElement('a',{href:'#'+href},name);},nameRender:defaultNameRender},_class.propTypes={prefixCls:_react2.default.PropTypes.string,separator:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string,_react2.default.PropTypes.element]),routes:_react2.default.PropTypes.array,params:_react2.default.PropTypes.object,linkRender:_react2.default.PropTypes.func,nameRender:_react2.default.PropTypes.func},_temp);exports.default=Breadcrumb;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(397);

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp2,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _reactDom=__webpack_require__(10);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var rxTwoCNChar=/^[\u4e00-\u9fa5]{2}$/;var isTwoCNChar=rxTwoCNChar.test.bind(rxTwoCNChar);function isString(str){return typeof str==="string";}// Insert one space between two chinese characters automatically.
function insertSpace(child){if(isString(child.type)&&isTwoCNChar(child.props.children)){return _react2.default.cloneElement(child,{},child.props.children.split("").join(" "));}if(isString(child)){if(isTwoCNChar(child)){child=child.split("").join(" ");}return _react2.default.createElement("span",null,child);}return child;}var Button=(_temp2=_class=function(_React$Component){(0,_inherits3.default)(Button,_React$Component);function Button(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Button);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Button.__proto__||(0,_getPrototypeOf2.default)(Button)).call.apply(_ref,[this].concat(args))),_this),_initialiseProps.call(_this),_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Button,[{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.clickedTimeout){clearTimeout(this.clickedTimeout);}if(this.timeout){clearTimeout(this.timeout);}}// Handle auto focus when click button in Chrome
},{key:"render",value:function render(){var _classNames;var props=this.props;var type=props.type,shape=props.shape,size=props.size,className=props.className,htmlType=props.htmlType,children=props.children,icon=props.icon,loading=props.loading,prefixCls=props.prefixCls,others=(0,_objectWithoutProperties3.default)(props,["type","shape","size","className","htmlType","children","icon","loading","prefixCls"]);// large => lg
// small => sm
var sizeCls={// large: 'lg',  只支持small default
small:"sm"}[size]||"";var classes=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls,true),(0,_defineProperty3.default)(_classNames,prefixCls+"-"+type,type),(0,_defineProperty3.default)(_classNames,prefixCls+"-"+shape,shape),(0,_defineProperty3.default)(_classNames,prefixCls+"-"+sizeCls,sizeCls),(0,_defineProperty3.default)(_classNames,prefixCls+"-icon-only",!children&&icon),(0,_defineProperty3.default)(_classNames,prefixCls+"-loading",loading),(0,_defineProperty3.default)(_classNames,className,className),_classNames));var iconType=loading?"loading":icon;var kids=_react2.default.Children.map(children,insertSpace);return _react2.default.createElement("button",(0,_extends3.default)({},others,{type:htmlType||"button",className:classes,onMouseUp:this.handleMouseUp,onClick:this.handleClick,ecId:others.ecId+"_button@xq1ea3"}),iconType?_react2.default.createElement(_icon2.default,{type:iconType,ecId:others.ecId+"_Icon@rtw99x"}):null,kids);}}]);return Button;}(_react2.default.Component),_class.defaultProps={prefixCls:"ant-btn",onClick:function onClick(){},loading:false},_class.propTypes={type:_react2.default.PropTypes.string,shape:_react2.default.PropTypes.oneOf(["circle","circle-outline"]),size:_react2.default.PropTypes.oneOf(["large","default","small"]),htmlType:_react2.default.PropTypes.oneOf(["submit","button","reset"]),onClick:_react2.default.PropTypes.func,loading:_react2.default.PropTypes.bool,className:_react2.default.PropTypes.string,icon:_react2.default.PropTypes.string},_initialiseProps=function _initialiseProps(){var _this2=this;this.clearButton=function(button){button.className=button.className.replace(" "+_this2.props.prefixCls+"-clicked","");};this.handleClick=function(){var _props;// Add click effect
var buttonNode=(0,_reactDom.findDOMNode)(_this2);_this2.clearButton(buttonNode);_this2.clickedTimeout=setTimeout(function(){return buttonNode.className+=" "+_this2.props.prefixCls+"-clicked";},10);clearTimeout(_this2.timeout);_this2.timeout=setTimeout(function(){return _this2.clearButton(buttonNode);},500);(_props=_this2.props).onClick.apply(_props,arguments);};this.handleMouseUp=function(e){(0,_reactDom.findDOMNode)(_this2).blur();if(_this2.props.onMouseUp){_this2.props.onMouseUp(e);}};},_temp2);exports.default=Button;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);exports.default=ButtonGroup;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var prefix="ant-btn-group-";function ButtonGroup(props){var _classNames;var size=props.size,className=props.className,others=(0,_objectWithoutProperties3.default)(props,["size","className"]);// large => lg
// small => sm
var sizeCls={large:"lg",small:"sm"}[size]||"";var classes=(0,_classnames2.default)((_classNames={"ant-btn-group":true},(0,_defineProperty3.default)(_classNames,prefix+sizeCls,sizeCls),(0,_defineProperty3.default)(_classNames,className,className),_classNames));return _react2.default.createElement("div",(0,_extends3.default)({},others,{ecId:others.ecId+"_div@t6si6j",className:classes}));}ButtonGroup.propTypes={size:_react2.default.PropTypes.oneOf(["large","default","small"])};

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Calendar=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 795));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=Calendar;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * utils for gregorian date
 * @ignore
 * @author yiminghe@gmail.com
 */var Const=__webpack_require__(182);var floor=Math.floor;var ACCUMULATED_DAYS_IN_MONTH//   1/1 2/1 3/1 4/1 5/1 6/1 7/1 8/1 9/1 10/1 11/1 12/1
=[0,31,59,90,120,151,181,212,243,273,304,334];var ACCUMULATED_DAYS_IN_MONTH_LEAP//   1/1 2/1   3/1   4/1   5/1   6/1   7/1   8/1   9/1
// 10/1   11/1   12/1
=[0,31,59+1,90+1,120+1,151+1,181+1,212+1,243+1,273+1,304+1,334+1];var DAYS_OF_YEAR=365;var DAYS_OF_4YEAR=365*4+1;var DAYS_OF_100YEAR=DAYS_OF_4YEAR*25-1;var DAYS_OF_400YEAR=DAYS_OF_100YEAR*4+1;var _exports={};function getDayOfYear(year,month,dayOfMonth){return dayOfMonth+(_exports.isLeapYear(year)?ACCUMULATED_DAYS_IN_MONTH_LEAP[month]:ACCUMULATED_DAYS_IN_MONTH[month]);}function getDayOfWeekFromFixedDate(fixedDate){// The fixed day 1 (January 1, 1 Gregorian) is Monday.
if(fixedDate>=0){return fixedDate%7;}return _exports.mod(fixedDate,7);}function getGregorianYearFromFixedDate(fixedDate){var d0=undefined;var d1=undefined;var d2=undefined;var d3=undefined;var n400=undefined;var n100=undefined;var n4=undefined;var n1=undefined;var year=undefined;d0=fixedDate-1;n400=floor(d0/DAYS_OF_400YEAR);d1=_exports.mod(d0,DAYS_OF_400YEAR);n100=floor(d1/DAYS_OF_100YEAR);d2=_exports.mod(d1,DAYS_OF_100YEAR);n4=floor(d2/DAYS_OF_4YEAR);d3=_exports.mod(d2,DAYS_OF_4YEAR);n1=floor(d3/DAYS_OF_YEAR);year=400*n400+100*n100+4*n4+n1;// ?
if(!(n100===4||n1===4)){++year;}return year;}_exports=module.exports={each:function each(arr,fn){for(var i=0,len=arr.length;i<len;i++){if(fn(arr[i],i,arr)===false){break;}}},mix:function mix(t,s){for(var p in s){if(s.hasOwnProperty(p)){t[p]=s[p];}}},isLeapYear:function isLeapYear(year){if((year&3)!==0){return false;}return year%100!==0||year%400===0;},mod:function mod(x,y){// 负数时不是镜像关系
return x-y*floor(x/y);},// month: 0 based
getFixedDate:function getFixedDate(year,month,dayOfMonth){var prevYear=year-1;// 考虑公元前
return DAYS_OF_YEAR*prevYear+floor(prevYear/4)-floor(prevYear/100)+floor(prevYear/400)+getDayOfYear(year,month,dayOfMonth);},getGregorianDateFromFixedDate:function getGregorianDateFromFixedDate(fixedDate){var year=getGregorianYearFromFixedDate(fixedDate);var jan1=_exports.getFixedDate(year,Const.JANUARY,1);var isLeap=_exports.isLeapYear(year);var ACCUMULATED_DAYS=isLeap?ACCUMULATED_DAYS_IN_MONTH_LEAP:ACCUMULATED_DAYS_IN_MONTH;var daysDiff=fixedDate-jan1;var month=undefined;for(var i=0;i<ACCUMULATED_DAYS.length;i++){if(ACCUMULATED_DAYS[i]<=daysDiff){month=i;}else{break;}}var dayOfMonth=fixedDate-jan1-ACCUMULATED_DAYS[month]+1;var dayOfWeek=getDayOfWeekFromFixedDate(fixedDate);return{year:year,month:month,dayOfMonth:dayOfMonth,dayOfWeek:dayOfWeek,isLeap:isLeap};}};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * en-us locale
 * @ignore
 * @author yiminghe@gmail.com
 */module.exports={// in minutes
timezoneOffset:-8*60,firstDayOfWeek:0,minimalDaysInFirstWeek:1};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * zh-cn locale
 * @ignore
 * @author yiminghe@gmail.com
 */module.exports={// in minutes
timezoneOffset:8*60,firstDayOfWeek:0,minimalDaysInFirstWeek:1};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _zh_CN=__webpack_require__(183);var _zh_CN2=_interopRequireDefault(_zh_CN);var _zh_CN3=__webpack_require__(249);var _zh_CN4=_interopRequireDefault(_zh_CN3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={clear:'清除',format:_zh_CN2.default,calendar:_zh_CN4.default};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(122),
    equalArrays = __webpack_require__(185),
    equalByTag = __webpack_require__(436),
    equalObjects = __webpack_require__(438),
    getTag = __webpack_require__(191),
    isArray = __webpack_require__(26),
    isBuffer = __webpack_require__(87),
    isTypedArray = __webpack_require__(88);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 407 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(83);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(83);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(83);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(83);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(82);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 413 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 414 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 415 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(82),
    Map = __webpack_require__(123),
    MapCache = __webpack_require__(125);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(124),
    isMasked = __webpack_require__(418),
    isObject = __webpack_require__(29),
    toSource = __webpack_require__(184);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(419);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(28);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 420 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(422),
    ListCache = __webpack_require__(82),
    Map = __webpack_require__(123);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(423),
    hashDelete = __webpack_require__(424),
    hashGet = __webpack_require__(425),
    hashHas = __webpack_require__(426),
    hashSet = __webpack_require__(427);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(84);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 424 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(84);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(84);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(84);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(85);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 429 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(85);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(85);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(85);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 433 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 434 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(78),
    Uint8Array = __webpack_require__(186),
    eq = __webpack_require__(65),
    equalArrays = __webpack_require__(185),
    mapToArray = __webpack_require__(437),
    setToArray = __webpack_require__(250);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(439);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(440),
    getSymbols = __webpack_require__(442),
    keys = __webpack_require__(187);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(441),
    isArray = __webpack_require__(26);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 441 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(443),
    stubArray = __webpack_require__(444);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 444 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 445 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(42),
    isObjectLike = __webpack_require__(35);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 447 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(42),
    isLength = __webpack_require__(127),
    isObjectLike = __webpack_require__(35);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 449 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(172);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(126)(module)))

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(190);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _MenuMixin=__webpack_require__(192);var _MenuMixin2=_interopRequireDefault(_MenuMixin);var _objectAssign=__webpack_require__(19);var _objectAssign2=_interopRequireDefault(_objectAssign);var _util=__webpack_require__(90);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Menu=_react2.default.createClass({displayName:'Menu',propTypes:{openSubMenuOnMouseEnter:_react.PropTypes.bool,closeSubMenuOnMouseLeave:_react.PropTypes.bool,selectedKeys:_react.PropTypes.arrayOf(_react.PropTypes.string),defaultSelectedKeys:_react.PropTypes.arrayOf(_react.PropTypes.string),defaultOpenKeys:_react.PropTypes.arrayOf(_react.PropTypes.string),openKeys:_react.PropTypes.arrayOf(_react.PropTypes.string),mode:_react.PropTypes.string,onClick:_react.PropTypes.func,onSelect:_react.PropTypes.func,onDeselect:_react.PropTypes.func,onDestroy:_react.PropTypes.func,openTransitionName:_react.PropTypes.string,openAnimation:_react.PropTypes.oneOfType([_react.PropTypes.string,_react.PropTypes.object]),level:_react.PropTypes.number,eventKey:_react.PropTypes.string,selectable:_react.PropTypes.bool,children:_react.PropTypes.any},mixins:[_MenuMixin2.default],getDefaultProps:function getDefaultProps(){return{openSubMenuOnMouseEnter:true,closeSubMenuOnMouseLeave:true,selectable:true,onClick:_util.noop,onSelect:_util.noop,onOpen:_util.noop,onClose:_util.noop,onDeselect:_util.noop,defaultSelectedKeys:[],defaultOpenKeys:[]};},getInitialState:function getInitialState(){var props=this.props;var selectedKeys=props.defaultSelectedKeys;var openKeys=props.defaultOpenKeys;if('selectedKeys'in props){selectedKeys=props.selectedKeys||[];}if('openKeys'in props){openKeys=props.openKeys||[];}return{selectedKeys:selectedKeys,openKeys:openKeys};},componentWillReceiveProps:function componentWillReceiveProps(nextProps){var props={};if('selectedKeys'in nextProps){props.selectedKeys=nextProps.selectedKeys;}if('openKeys'in nextProps){props.openKeys=nextProps.openKeys;}this.setState(props);},onDestroy:function onDestroy(key){var state=this.state;var props=this.props;var selectedKeys=state.selectedKeys;var openKeys=state.openKeys;var index=selectedKeys.indexOf(key);if(!('selectedKeys'in props)&&index!==-1){selectedKeys.splice(index,1);}index=openKeys.indexOf(key);if(!('openKeys'in props)&&index!==-1){openKeys.splice(index,1);}},onItemHover:function onItemHover(e){var item=e.item;// special for top sub menu
if(this.props.mode!=='inline'&&!this.props.closeSubMenuOnMouseLeave&&item.isSubMenu){var activeKey=this.state.activeKey;var activeItem=this.getFlatInstanceArray().filter(function(c){return c&&c.props.eventKey===activeKey;})[0];if(activeItem&&activeItem.props.open){this.onOpenChange({key:item.props.eventKey,item:e.item,open:true});}}this.onCommonItemHover(e);},onSelect:function onSelect(selectInfo){var props=this.props;if(props.selectable){// root menu
var selectedKeys=this.state.selectedKeys;var selectedKey=selectInfo.key;if(props.multiple){selectedKeys=selectedKeys.concat([selectedKey]);}else{selectedKeys=[selectedKey];}if(!('selectedKeys'in props)){this.setState({selectedKeys:selectedKeys});}props.onSelect((0,_objectAssign2.default)({},selectInfo,{selectedKeys:selectedKeys}));}},onClick:function onClick(e){this.props.onClick(e);},onOpenChange:function onOpenChange(e){var props=this.props;var openKeys=this.state.openKeys;var changed=true;if(e.open){changed=openKeys.indexOf(e.key)===-1;if(changed){openKeys=openKeys.concat(e.key);}}else{var index=openKeys.indexOf(e.key);changed=index!==-1;if(changed){openKeys=openKeys.concat();openKeys.splice(index,1);}}if(changed){// hack, synchronous call from onTitleMouseEnter
this.state.openKeys=openKeys;if(!('openKeys'in this.props)){// hack: batch does not update state
this.setState({openKeys:openKeys});}var info=(0,_objectAssign2.default)({openKeys:openKeys},e);if(e.open){props.onOpen(info);}else{props.onClose(info);}}},onDeselect:function onDeselect(selectInfo){var props=this.props;if(props.selectable){var selectedKeys=this.state.selectedKeys.concat();var selectedKey=selectInfo.key;var index=selectedKeys.indexOf(selectedKey);if(index!==-1){selectedKeys.splice(index,1);}if(!('selectedKeys'in props)){this.setState({selectedKeys:selectedKeys});}props.onDeselect((0,_objectAssign2.default)({},selectInfo,{selectedKeys:selectedKeys}));}},getOpenTransitionName:function getOpenTransitionName(){var props=this.props;var transitionName=props.openTransitionName;var animationName=props.openAnimation;if(!transitionName&&typeof animationName==='string'){transitionName=props.prefixCls+'-open-'+animationName;}return transitionName;},isInlineMode:function isInlineMode(){return this.props.mode==='inline';},lastOpenSubMenu:function lastOpenSubMenu(){var _this=this;var lastOpen=[];if(this.state.openKeys.length){lastOpen=this.getFlatInstanceArray().filter(function(c){return c&&_this.state.openKeys.indexOf(c.props.eventKey)!==-1;});}return lastOpen[0];},renderMenuItem:function renderMenuItem(c,i,subIndex){if(!c){return null;}var state=this.state;var extraProps={openKeys:state.openKeys,selectedKeys:state.selectedKeys,openSubMenuOnMouseEnter:this.props.openSubMenuOnMouseEnter};return this.renderCommonMenuItem(c,i,subIndex,extraProps);},render:function render(){var props=(0,_objectAssign2.default)({},this.props);props.className+=' '+props.prefixCls+'-root';return this.renderRoot(props);}});exports.default=Menu;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(457);

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;
  var offsetTop = config.offsetTop || 0;
  var offsetLeft = config.offsetLeft || 0;
  var offsetBottom = config.offsetBottom || 0;
  var offsetRight = config.offsetRight || 0;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset = undefined;
  var ch = undefined;
  var cw = undefined;
  var containerScroll = undefined;
  var diffTop = undefined;
  var diffBottom = undefined;
  var win = undefined;
  var winScroll = undefined;
  var ww = undefined;
  var wh = undefined;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left - offsetLeft,
      top: elemOffset.top - winScroll.top - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box = undefined;
  var x = undefined;
  var y = undefined;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle_) {
  var val = '';
  var d = elem.ownerDocument;
  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX = undefined;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = undefined;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = undefined;
  var j = undefined;
  var i = undefined;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = undefined;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  }
  if (borderBoxValueOrIsBorderBox) {
    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
    return val + (extra === BORDER_INDEX ? 0 : padding);
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val = undefined;
  var args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value += 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem);
  var ret = {};
  var current = undefined;
  var key = undefined;

  for (key in offset) {
    if (offset.hasOwnProperty(key)) {
      current = parseFloat(css(elem, key)) || 0;
      ret[key] = current + offset[key] - old[key];
    }
  }
  css(elem, ret);
}

module.exports = _extends({
  getWindow: function getWindow(node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function offset(el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var ret = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  scrollLeft: function scrollLeft(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      }
      window.scrollTo(v, getScrollTop(w));
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      }
      w.scrollLeft = v;
    }
  },
  scrollTop: function scrollTop(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      }
      window.scrollTo(getScrollLeft(w), v);
    } else {
      if (v === undefined) {
        return w.scrollTop;
      }
      w.scrollTop = v;
    }
  },

  viewportWidth: 0,
  viewportHeight: 0
}, domUtils);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _objectAssign=__webpack_require__(19);var _objectAssign2=_interopRequireDefault(_objectAssign);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DOMWrap=_react2.default.createClass({displayName:"DOMWrap",propTypes:{tag:_react.PropTypes.string,hiddenClassName:_react.PropTypes.string,visible:_react.PropTypes.bool},getDefaultProps:function getDefaultProps(){return{tag:"div"};},render:function render(){var props=(0,_objectAssign2.default)({},this.props);if(!props.visible){props.className=props.className||"";props.className+=" "+props.hiddenClassName;}var Tag=props.tag;delete props.tag;delete props.hiddenClassName;delete props.visible;return _react2.default.createElement(Tag,(0,_extends3.default)({},props,{ecId:this.props.ecId+"_Tag@k32wx4"}));}});exports.default=DOMWrap;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _SubPopupMenu=__webpack_require__(460);var _SubPopupMenu2=_interopRequireDefault(_SubPopupMenu);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _KeyCode=__webpack_require__(47);var _KeyCode2=_interopRequireDefault(_KeyCode);var _guid=__webpack_require__(461);var _guid2=_interopRequireDefault(_guid);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _util=__webpack_require__(90);var _middleware=__webpack_require__(27);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint react/no-is-mounted:0 *///获取元素的纵坐标
function getTop(e){var offset=e.offsetTop;//alert("getTop: "+e + " offset: " + offset);
//console.log("getTop: ",e,offset);
if(!!e.offsetParent)offset+=getTop(e.offsetParent);return offset;}//获取元素的横坐标
function getLeft(e){var offset=e.offsetLeft;if(!!e.offsetParent)offset+=getLeft(e.offsetParent);return offset;}function getScrollTop(){var scrollTop=0;if(document.documentElement&&document.documentElement.scrollTop)scrollTop=document.documentElement.scrollTop;else if(document.body)scrollTop=document.body.scrollTop;return scrollTop;}var SubMenu=_react2.default.createClass({displayName:"SubMenu",propTypes:{parentMenu:_react.PropTypes.object,title:_react.PropTypes.node,children:_react.PropTypes.any,selectedKeys:_react.PropTypes.array,openKeys:_react.PropTypes.array,onClick:_react.PropTypes.func,onOpenChange:_react.PropTypes.func,rootPrefixCls:_react.PropTypes.string,eventKey:_react.PropTypes.string,multiple:_react.PropTypes.bool,active:_react.PropTypes.bool,onSelect:_react.PropTypes.func,closeSubMenuOnMouseLeave:_react.PropTypes.bool,openSubMenuOnMouseEnter:_react.PropTypes.bool,onDeselect:_react.PropTypes.func,onDestroy:_react.PropTypes.func,onItemHover:_react.PropTypes.func,onMouseEnter:_react.PropTypes.func,onMouseLeave:_react.PropTypes.func,onTitleMouseEnter:_react.PropTypes.func,onTitleMouseLeave:_react.PropTypes.func,onTitleClick:_react.PropTypes.func},mixins:[__webpack_require__(462)],getDefaultProps:function getDefaultProps(){return{onMouseEnter:_util.noop,onMouseLeave:_util.noop,onTitleMouseEnter:_util.noop,onTitleMouseLeave:_util.noop,onTitleClick:_util.noop,title:""};},getInitialState:function getInitialState(){this.isSubMenu=1;return{defaultActiveFirst:false};},componentWillUnmount:function componentWillUnmount(){var props=this.props;if(props.onDestroy){props.onDestroy(props.eventKey);}if(props.parentMenu.subMenuInstance===this){this.clearSubMenuTimers();}//this._menuId
},componentDidUpdate:function componentDidUpdate(prevProps){if(this.props.ifFixed&&this.props.mode=="vertical"){var level=this.props.level;var obj=document.getElementById("sub"+this._menuId);var obj1=document.getElementById(this._menuId);if(obj1&&obj){// const top = (!!window.weaScrollTop['wea-scroll']?window.weaScrollTop['wea-scroll']:0)+getScrollTop();
//      const top = getScrollTop();
var top=jQuery("#menuScrollWrapper").find(".scroller").scrollTop();var fatherTop=getTop(obj);var fatherLeft=getLeft(obj);var fatherWidth=obj.offsetWidth;var fatherHeight=obj.offsetHeight;var nowLeft=fatherLeft+fatherWidth-4;var ownHeight=obj1.offsetHeight;var winHeight=document.documentElement.clientHeight;var nowTop=level==1?fatherTop-top:fatherTop;//      alert("fatherTop" + fatherTop + " fatherLeft" + fatherLeft);
//      console.log("fatherTop" + fatherTop + " fatherLeft" + fatherLeft);
//      alert('nowTop:' + nowTop+';  nowTop+ownHeight:' + (nowTop + ownHeight) +'; winHeight:'+winHeight);
//      console.log('nowTop',nowTop,'nowTop + ownHeight',nowTop + ownHeight,'winHeight',winHeight);
if(nowTop+ownHeight>winHeight)nowTop=winHeight-ownHeight;if(nowTop<0)nowTop=0;//console.log("id:",this._menuId," level:",level," fatherTop:",fatherTop," nowTop:",nowTop);
//console.log("id:",this._menuId," level:",level," fatherLeft:",fatherLeft," nowLeft:",nowLeft," fatherWidth:",fatherWidth);
obj1.style.top=nowTop+"px";obj1.style.left=nowLeft+"px";}}},onDestroy:function onDestroy(key){this.props.onDestroy(key);},onKeyDown:function onKeyDown(e){var keyCode=e.keyCode;var menu=this.menuInstance;var isOpen=this.isOpen();if(keyCode===_KeyCode2.default.ENTER){this.onTitleClick(e);this.setState({defaultActiveFirst:true});return true;}if(keyCode===_KeyCode2.default.RIGHT){if(isOpen){menu.onKeyDown(e);}else{this.triggerOpenChange(true);this.setState({defaultActiveFirst:true});}return true;}if(keyCode===_KeyCode2.default.LEFT){var handled=void 0;if(isOpen){handled=menu.onKeyDown(e);}else{return undefined;}if(!handled){this.triggerOpenChange(false);handled=true;}return handled;}if(isOpen&&(keyCode===_KeyCode2.default.UP||keyCode===_KeyCode2.default.DOWN)){return menu.onKeyDown(e);}},onOpenChange:function onOpenChange(e){this.props.onOpenChange(this.addKeyPath(e));},onMouseEnter:function onMouseEnter(e){var props=this.props;this.clearSubMenuLeaveTimer(props.parentMenu.subMenuInstance!==this);props.onMouseEnter({key:props.eventKey,domEvent:e});},onTitleMouseEnter:function onTitleMouseEnter(e){var props=this.props;var parentMenu=props.parentMenu;this.clearSubMenuTitleLeaveTimer(parentMenu.subMenuInstance!==this);if(parentMenu.menuItemInstance){parentMenu.menuItemInstance.clearMenuItemMouseLeaveTimer(true);}props.onItemHover({key:props.eventKey,item:this,hover:true,trigger:"mouseenter"});if(props.openSubMenuOnMouseEnter){this.triggerOpenChange(true);}this.setState({defaultActiveFirst:false});props.onTitleMouseEnter({key:props.eventKey,domEvent:e});},onTitleMouseLeave:function onTitleMouseLeave(e){var _this=this;var props=this.props;var parentMenu=props.parentMenu;parentMenu.subMenuInstance=this;parentMenu.subMenuTitleLeaveFn=function(){var eventKey=props.eventKey;if(_this.isMounted()){// leave whole sub tree
// still active
if(props.mode==="inline"&&props.active){props.onItemHover({key:eventKey,item:_this,hover:false,trigger:"mouseleave"});}props.onTitleMouseLeave({key:props.eventKey,domEvent:e});}};parentMenu.subMenuTitleLeaveTimer=setTimeout(parentMenu.subMenuTitleLeaveFn,100);},onMouseLeave:function onMouseLeave(e){var _this2=this;var props=this.props;var parentMenu=props.parentMenu;parentMenu.subMenuInstance=this;parentMenu.subMenuLeaveFn=function(){var eventKey=props.eventKey;if(_this2.isMounted()){// leave whole sub tree
// still active
if(props.mode!=="inline"){if(props.active){props.onItemHover({key:eventKey,item:_this2,hover:false,trigger:"mouseleave"});}if(_this2.isOpen()){if(props.closeSubMenuOnMouseLeave){_this2.triggerOpenChange(false);}}}// trigger mouseleave
props.onMouseLeave({key:eventKey,domEvent:e});}};// prevent popup menu and submenu gap
parentMenu.subMenuLeaveTimer=setTimeout(parentMenu.subMenuLeaveFn,100);},onTitleClick:function onTitleClick(e){var props=this.props;props.onTitleClick({key:props.eventKey,domEvent:e});if(props.openSubMenuOnMouseEnter){return;}this.triggerOpenChange(!this.isOpen(),"click");this.setState({defaultActiveFirst:false});},onSubMenuClick:function onSubMenuClick(info){this.props.onClick(this.addKeyPath(info));},onSelect:function onSelect(info){this.props.onSelect(info);},onDeselect:function onDeselect(info){this.props.onDeselect(info);},getPrefixCls:function getPrefixCls(){return this.props.rootPrefixCls+"-submenu";},getActiveClassName:function getActiveClassName(){return this.getPrefixCls()+"-active";},getDisabledClassName:function getDisabledClassName(){return this.getPrefixCls()+"-disabled";},getSelectedClassName:function getSelectedClassName(){return this.getPrefixCls()+"-selected";},getOpenClassName:function getOpenClassName(){return this.props.rootPrefixCls+"-submenu-open";},saveMenuInstance:function saveMenuInstance(c){this.menuInstance=c;},addKeyPath:function addKeyPath(info){return(0,_extends3.default)({},info,{keyPath:(info.keyPath||[]).concat(this.props.eventKey)});},triggerOpenChange:function triggerOpenChange(open,type){var key=this.props.eventKey;this.onOpenChange({key:key,item:this,trigger:type,open:open});},clearSubMenuTimers:function clearSubMenuTimers(callFn){this.clearSubMenuLeaveTimer(callFn);this.clearSubMenuTitleLeaveTimer(callFn);},clearSubMenuTitleLeaveTimer:function clearSubMenuTitleLeaveTimer(callFn){var parentMenu=this.props.parentMenu;if(parentMenu.subMenuTitleLeaveTimer){clearTimeout(parentMenu.subMenuTitleLeaveTimer);parentMenu.subMenuTitleLeaveTimer=null;if(callFn&&parentMenu.subMenuTitleLeaveFn){parentMenu.subMenuTitleLeaveFn();}parentMenu.subMenuTitleLeaveFn=null;}},clearSubMenuLeaveTimer:function clearSubMenuLeaveTimer(callFn){var parentMenu=this.props.parentMenu;if(parentMenu.subMenuLeaveTimer){clearTimeout(parentMenu.subMenuLeaveTimer);parentMenu.subMenuLeaveTimer=null;if(callFn&&parentMenu.subMenuLeaveFn){parentMenu.subMenuLeaveFn();}parentMenu.subMenuLeaveFn=null;}},isChildrenSelected:function isChildrenSelected(){var ret={find:false};(0,_util.loopMenuItemRecusively)(this.props.children,this.props.selectedKeys,ret);return ret.find;},isOpen:function isOpen(){return this.props.openKeys.indexOf(this.props.eventKey)!==-1;},renderChildren:function renderChildren(children){var props=this.props;//console.log("props:",props);
//console.log("props.openAnimation:",props.openAnimation," props.openTransitionName:",props.openTransitionName);
var baseProps={mode:props.mode==="horizontal"?"vertical":props.mode,visible:this.isOpen(),level:props.level+1,inlineIndent:props.inlineIndent,focusable:false,onClick:this.onSubMenuClick,onSelect:this.onSelect,onDeselect:this.onDeselect,onDestroy:this.onDestroy,selectedKeys:props.selectedKeys,eventKey:props.eventKey+"-menu-",openKeys:props.openKeys,openTransitionName:props.ifFixed?"":props.openTransitionName,openAnimation:props.ifFixed?"":props.openAnimation,onOpenChange:this.onOpenChange,closeSubMenuOnMouseLeave:props.closeSubMenuOnMouseLeave,defaultActiveFirst:this.state.defaultActiveFirst,multiple:props.multiple,prefixCls:props.rootPrefixCls,className:props.subMenuClass||"",id:this._menuId,ref:this.saveMenuInstance};//style:props.ifFixed?{"possion":"fixed"}:{} //add by dyf
//style={this.props.ifFixed?{"possion":"fixed"}:{}}
return _react2.default.createElement(_SubPopupMenu2.default,(0,_extends3.default)({},baseProps,{ecId:this.props.ecId+"_SubPopupMenu@3szk3w"}),children);},render:function render(){var _classes;var isOpen=this.isOpen();this.haveOpen=this.haveOpen||isOpen;var props=this.props;var prefixCls=this.getPrefixCls();var classes=(_classes={},(0,_defineProperty3.default)(_classes,props.className,!!props.className),(0,_defineProperty3.default)(_classes,prefixCls+"-"+props.mode,1),_classes);classes[this.getOpenClassName()]=isOpen;classes[this.getActiveClassName()]=props.active;classes[this.getDisabledClassName()]=props.disabled;classes[this.getSelectedClassName()]=this.isChildrenSelected();this._menuId=this._menuId||(0,_guid2.default)();classes[prefixCls]=true;classes[prefixCls+"-"+props.mode]=1;var titleClickEvents={};var mouseEvents={};var titleMouseEvents={};if(!props.disabled){titleClickEvents={onClick:this.onTitleClick};mouseEvents={onMouseLeave:this.onMouseLeave,onMouseEnter:this.onMouseEnter};// only works in title, not outer li
titleMouseEvents={onMouseEnter:this.onTitleMouseEnter,onMouseLeave:this.onTitleMouseLeave};}var style={};if(props.mode==="inline"){//console.log("props.inlineIndent:",props.inlineIndent," props.level:",props.level," props.inlineIndent * props.level:",props.inlineIndent * props.level);
if(this.props.ifFixed){if(props.level==1)style.paddingLeft=props.inlineIndent+(props.level-1)*10;//props.inlineIndent * props.level;
else style.paddingLeft=props.inlineIndent+25+(props.level-1)*12;//props.inlineIndent * props.level;
}else{style.paddingLeft=props.inlineIndent*props.level;}}var selectedClassName=this.props.selectedClassName;return _react2.default.createElement("li",(0,_extends3.default)({id:"sub"+this._menuId,className:(0,_classnames2.default)(classes)},mouseEvents,{ecId:this.props.ecId+"_li@5uxfvs"}),_react2.default.createElement("div",(0,_extends3.default)({style:style,className:prefixCls+"-title "+selectedClassName},titleMouseEvents,titleClickEvents,{"aria-open":isOpen,"aria-owns":this._menuId,"aria-haspopup":"true",ecId:this.props.ecId+"_div@5yfix4"}),props.title),this.renderChildren(props.children));}});SubMenu.isSubMenu=1;exports.default=(0,_middleware2.default)(SubMenu,"Menu.SubMenu");

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _typeof2=__webpack_require__(23);var _typeof3=_interopRequireDefault(_typeof2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _MenuMixin=__webpack_require__(192);var _MenuMixin2=_interopRequireDefault(_MenuMixin);var _objectAssign=__webpack_require__(19);var _objectAssign2=_interopRequireDefault(_objectAssign);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SubPopupMenu=_react2.default.createClass({displayName:"SubPopupMenu",propTypes:{onSelect:_react.PropTypes.func,onClick:_react.PropTypes.func,onDeselect:_react.PropTypes.func,onOpenChange:_react.PropTypes.func,onDestroy:_react.PropTypes.func,openTransitionName:_react.PropTypes.string,openAnimation:_react.PropTypes.oneOfType([_react.PropTypes.string,_react.PropTypes.object]),openKeys:_react.PropTypes.arrayOf(_react.PropTypes.string),closeSubMenuOnMouseLeave:_react.PropTypes.bool,visible:_react.PropTypes.bool,children:_react.PropTypes.any},mixins:[_MenuMixin2.default],onDeselect:function onDeselect(selectInfo){this.props.onDeselect(selectInfo);},onSelect:function onSelect(selectInfo){this.props.onSelect(selectInfo);},onClick:function onClick(e){this.props.onClick(e);},onOpenChange:function onOpenChange(e){this.props.onOpenChange(e);},onDestroy:function onDestroy(key){this.props.onDestroy(key);},onItemHover:function onItemHover(e){this.onCommonItemHover(e);},getOpenTransitionName:function getOpenTransitionName(){return this.props.openTransitionName;},renderMenuItem:function renderMenuItem(c,i,subIndex){var props=this.props;var extraProps={openKeys:props.openKeys,selectedKeys:props.selectedKeys,openSubMenuOnMouseEnter:true};return this.renderCommonMenuItem(c,i,subIndex,extraProps);},render:function render(){var renderFirst=this.renderFirst;this.renderFirst=1;this.haveOpened=this.haveOpened||this.props.visible;if(!this.haveOpened){return null;}var transitionAppear=true;if(!renderFirst&&this.props.visible){transitionAppear=false;}var props=(0,_objectAssign2.default)({},this.props);props.className+=" "+props.prefixCls+"-sub";var animProps={};if(props.openTransitionName){animProps.transitionName=props.openTransitionName;}else if((0,_typeof3.default)(props.openAnimation)==="object"){animProps.animation=(0,_objectAssign2.default)({},props.openAnimation);if(!transitionAppear){delete animProps.animation.appear;}}return _react2.default.createElement(_rcAnimate2.default,(0,_extends3.default)({},animProps,{ecId:this.props.ecId+"_Animate@8xgn9v",showProp:"visible",component:"",transitionAppear:transitionAppear}),this.renderRoot(props));}});exports.default=SubPopupMenu;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var seed = 0;
module.exports = function guid() {
  return Date.now() + "_" + seed++;
};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _KeyCode=__webpack_require__(47);var _KeyCode2=_interopRequireDefault(_KeyCode);var _addEventListener=__webpack_require__(70);var _addEventListener2=_interopRequireDefault(_addEventListener);var _contains=__webpack_require__(463);var _contains2=_interopRequireDefault(_contains);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={componentDidMount:function componentDidMount(){this.componentDidUpdate();},componentDidUpdate:function componentDidUpdate(){if(this.props.mode!=='inline'){if(this.props.open){this.bindRootCloseHandlers();}else{this.unbindRootCloseHandlers();}}},handleDocumentKeyUp:function handleDocumentKeyUp(e){if(e.keyCode===_KeyCode2.default.ESC){this.props.onItemHover({key:this.props.eventKey,item:this,hover:false});}},handleDocumentClick:function handleDocumentClick(e){// If the click originated from within this component
// don't do anything.
if((0,_contains2.default)(_reactDom2.default.findDOMNode(this),e.target)){return;}var props=this.props;props.onItemHover({hover:false,item:this,key:this.props.eventKey});this.triggerOpenChange(false);},bindRootCloseHandlers:function bindRootCloseHandlers(){if(!this._onDocumentClickListener){this._onDocumentClickListener=(0,_addEventListener2.default)(document,'click',this.handleDocumentClick);this._onDocumentKeyupListener=(0,_addEventListener2.default)(document,'keyup',this.handleDocumentKeyUp);}},unbindRootCloseHandlers:function unbindRootCloseHandlers(){if(this._onDocumentClickListener){this._onDocumentClickListener.remove();this._onDocumentClickListener=null;}if(this._onDocumentKeyupListener){this._onDocumentKeyupListener.remove();this._onDocumentKeyupListener=null;}},componentWillUnmount:function componentWillUnmount(){this.unbindRootCloseHandlers();}};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _KeyCode=__webpack_require__(47);var _KeyCode2=_interopRequireDefault(_KeyCode);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _util=__webpack_require__(90);var _tooltip=__webpack_require__(91);var _tooltip2=_interopRequireDefault(_tooltip);var _middleware=__webpack_require__(27);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MenuItem=_react2.default.createClass({displayName:"MenuItem",propTypes:{rootPrefixCls:_react.PropTypes.string,eventKey:_react.PropTypes.string,active:_react.PropTypes.bool,children:_react.PropTypes.any,selectedKeys:_react.PropTypes.array,disabled:_react.PropTypes.bool,title:_react.PropTypes.string,onSelect:_react.PropTypes.func,onClick:_react.PropTypes.func,onDeselect:_react.PropTypes.func,parentMenu:_react.PropTypes.object,onItemHover:_react.PropTypes.func,onDestroy:_react.PropTypes.func,onMouseEnter:_react.PropTypes.func,onMouseLeave:_react.PropTypes.func},getInitialState:function getInitialState(){return{tooltipVisable:false};},getDefaultProps:function getDefaultProps(){return{onSelect:_util.noop,onMouseEnter:_util.noop,onMouseLeave:_util.noop};},componentWillUnmount:function componentWillUnmount(){var props=this.props;if(props.onDestroy){props.onDestroy(props.eventKey);}if(props.parentMenu.menuItemInstance===this){this.clearMenuItemMouseLeaveTimer();}},onKeyDown:function onKeyDown(e){var keyCode=e.keyCode;if(keyCode===_KeyCode2.default.ENTER){this.onClick(e);return true;}},onMouseOver:function onMouseOver(e){this.setState({tooltipVisable:true});},onMouseLeave:function onMouseLeave(e){var _this=this;this.setState({tooltipVisable:false});var props=this.props;var eventKey=props.eventKey;var parentMenu=props.parentMenu;parentMenu.menuItemInstance=this;parentMenu.menuItemMouseLeaveFn=function(){if(_this.isMounted()&&props.active){props.onItemHover({key:eventKey,item:_this,hover:false,trigger:"mouseleave"});}};parentMenu.menuItemMouseLeaveTimer=setTimeout(parentMenu.menuItemMouseLeaveFn,30);props.onMouseLeave({key:eventKey,domEvent:e});},onMouseEnter:function onMouseEnter(e){var props=this.props;var parentMenu=props.parentMenu;this.clearMenuItemMouseLeaveTimer(parentMenu.menuItemInstance!==this);if(parentMenu.subMenuInstance){parentMenu.subMenuInstance.clearSubMenuTimers(true);}var eventKey=props.eventKey;props.onItemHover({key:eventKey,item:this,hover:true,trigger:"mouseenter"});props.onMouseEnter({key:eventKey,domEvent:e});},onClick:function onClick(e){var props=this.props;var selected=this.isSelected();var eventKey=props.eventKey;var info={key:eventKey,keyPath:[eventKey],item:this,domEvent:e};props.onClick(info);if(props.multiple){if(selected){props.onDeselect(info);}else{props.onSelect(info);}}else if(!selected){props.onSelect(info);}},getPrefixCls:function getPrefixCls(){return this.props.rootPrefixCls+"-item";},getActiveClassName:function getActiveClassName(){return this.getPrefixCls()+"-active";},getSelectedClassName:function getSelectedClassName(){return this.getPrefixCls()+"-selected";},getDisabledClassName:function getDisabledClassName(){return this.getPrefixCls()+"-disabled";},clearMenuItemMouseLeaveTimer:function clearMenuItemMouseLeaveTimer(callFn){var props=this.props;var parentMenu=props.parentMenu;if(parentMenu.menuItemMouseLeaveTimer){clearTimeout(parentMenu.menuItemMouseLeaveTimer);parentMenu.menuItemMouseLeaveTimer=null;if(callFn&&parentMenu.menuItemMouseLeaveFn){parentMenu.menuItemMouseLeaveFn();}parentMenu.menuItemMouseLeaveFn=null;}},isSelected:function isSelected(){return this.props.selectedKeys.indexOf(this.props.eventKey)!==-1;},getVisable:function getVisable(){var props=this.props;var tooltipVisable=this.state.tooltipVisable;var visible=false;if(props.active||tooltipVisable)visible=true;return visible;},render:function render(){var props=this.props;var selected=this.isSelected();var classes={};classes[this.getActiveClassName()]=!props.disabled&&props.active;classes[this.getSelectedClassName()]=selected;classes[this.getDisabledClassName()]=props.disabled;classes[this.getPrefixCls()]=true;classes[props.className]=!!props.className;var attrs=(0,_extends3.default)({},props.attribute,{title:props.title,className:(0,_classnames2.default)(classes)+" text-elli",role:"menuitem","aria-selected":selected,"aria-disabled":props.disabled});var mouseEvent={};if(!props.disabled){mouseEvent={onClick:this.onClick,onMouseLeave:this.onMouseLeave,onMouseEnter:this.onMouseEnter,onMouseOver:this.onMouseOver};}var style=(0,_extends3.default)({},props.style);if(props.mode==="inline"){style.paddingLeft=props.inlineIndent*props.level;}var content=_react2.default.createElement("li",(0,_extends3.default)({style:style},attrs,mouseEvent,{ecId:this.props.ecId+"_li@zyccqn"}),props.children);if(props.tooltip){content=_react2.default.createElement(_tooltip2.default,{ecId:this.props.ecId+"_Tooltip@013dds",key:props.key,title:props.tooltip,placement:"right",visible:!selected&&props.visible&&this.getVisable()},content);}return content;}});/* eslint react/no-is-mounted:0 */MenuItem.isMenuItem=1;exports.default=(0,_middleware2.default)(MenuItem,"Menu.Item");

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Tooltip=__webpack_require__(466);var _Tooltip2=_interopRequireDefault(_Tooltip);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Tooltip2.default;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(15);var _propTypes2=_interopRequireDefault(_propTypes);var _rcTrigger=__webpack_require__(94);var _rcTrigger2=_interopRequireDefault(_rcTrigger);var _placements=__webpack_require__(195);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Tooltip=(_temp2=_class=function(_Component){(0,_inherits3.default)(Tooltip,_Component);function Tooltip(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Tooltip);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Tooltip.__proto__||(0,_getPrototypeOf2.default)(Tooltip)).call.apply(_ref,[this].concat(args))),_this),_this.getPopupElement=function(){var _this$props=_this.props,arrowContent=_this$props.arrowContent,overlay=_this$props.overlay,prefixCls=_this$props.prefixCls;return[_react2.default.createElement("div",{className:prefixCls+"-arrow",key:"arrow"},arrowContent),_react2.default.createElement("div",{className:prefixCls+"-inner",key:"content"},typeof overlay==="function"?overlay():overlay)];},_this.saveTrigger=function(node){_this.trigger=node;},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Tooltip,[{key:"getPopupDomNode",value:function getPopupDomNode(){return this.trigger.getPopupDomNode();}},{key:"render",value:function render(){var _props=this.props,overlayClassName=_props.overlayClassName,trigger=_props.trigger,mouseEnterDelay=_props.mouseEnterDelay,mouseLeaveDelay=_props.mouseLeaveDelay,overlayStyle=_props.overlayStyle,prefixCls=_props.prefixCls,children=_props.children,onVisibleChange=_props.onVisibleChange,afterVisibleChange=_props.afterVisibleChange,transitionName=_props.transitionName,animation=_props.animation,placement=_props.placement,align=_props.align,destroyTooltipOnHide=_props.destroyTooltipOnHide,defaultVisible=_props.defaultVisible,getTooltipContainer=_props.getTooltipContainer,ecId=_props.ecId,restProps=(0,_objectWithoutProperties3.default)(_props,["overlayClassName","trigger","mouseEnterDelay","mouseLeaveDelay","overlayStyle","prefixCls","children","onVisibleChange","afterVisibleChange","transitionName","animation","placement","align","destroyTooltipOnHide","defaultVisible","getTooltipContainer","ecId"]);var extraProps=(0,_extends3.default)({},restProps);if("visible"in this.props){extraProps.popupVisible=this.props.visible;}return _react2.default.createElement(_rcTrigger2.default,(0,_extends3.default)({ecId:ecId+"_Trigger@2qgdni",popupClassName:overlayClassName,ref:this.saveTrigger,prefixCls:prefixCls,popup:this.getPopupElement,action:trigger,builtinPlacements:_placements.placements,popupPlacement:placement,popupAlign:align,getPopupContainer:getTooltipContainer,onPopupVisibleChange:onVisibleChange,afterPopupVisibleChange:afterVisibleChange,popupTransitionName:transitionName,popupAnimation:animation,defaultPopupVisible:defaultVisible,destroyPopupOnHide:destroyTooltipOnHide,mouseLeaveDelay:mouseLeaveDelay,popupStyle:overlayStyle,mouseEnterDelay:mouseEnterDelay},extraProps),children);}}]);return Tooltip;}(_react.Component),_class.propTypes={trigger:_propTypes2.default.any,children:_propTypes2.default.any,defaultVisible:_propTypes2.default.bool,visible:_propTypes2.default.bool,placement:_propTypes2.default.string,transitionName:_propTypes2.default.string,animation:_propTypes2.default.any,onVisibleChange:_propTypes2.default.func,afterVisibleChange:_propTypes2.default.func,overlay:_propTypes2.default.oneOfType([_propTypes2.default.node,_propTypes2.default.func]).isRequired,overlayStyle:_propTypes2.default.object,overlayClassName:_propTypes2.default.string,prefixCls:_propTypes2.default.string,mouseEnterDelay:_propTypes2.default.number,mouseLeaveDelay:_propTypes2.default.number,getTooltipContainer:_propTypes2.default.func,destroyTooltipOnHide:_propTypes2.default.bool,align:_propTypes2.default.object,arrowContent:_propTypes2.default.any},_class.defaultProps={prefixCls:"rc-tooltip",mouseEnterDelay:0,destroyTooltipOnHide:false,mouseLeaveDelay:0.1,align:{},placement:"right",trigger:["hover"],arrowContent:null},_temp2);exports.default=Tooltip;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(15);var _propTypes2=_interopRequireDefault(_propTypes);var _reactDom=__webpack_require__(10);var _createReactClass=__webpack_require__(468);var _createReactClass2=_interopRequireDefault(_createReactClass);var _contains=__webpack_require__(470);var _contains2=_interopRequireDefault(_contains);var _addEventListener=__webpack_require__(471);var _addEventListener2=_interopRequireDefault(_addEventListener);var _Popup=__webpack_require__(472);var _Popup2=_interopRequireDefault(_Popup);var _utils=__webpack_require__(194);var _getContainerRenderMixin=__webpack_require__(480);var _getContainerRenderMixin2=_interopRequireDefault(_getContainerRenderMixin);var _loadCss=__webpack_require__(143);var _window=__webpack_require__(33);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function noop(){}function returnEmptyString(){return"";}function returnDocument(){return _window2.default.getTop().document;}var ALL_HANDLERS=["onClick","onMouseDown","onTouchStart","onMouseEnter","onMouseLeave","onFocus","onBlur"];var Trigger=(0,_createReactClass2.default)({displayName:"Trigger",propTypes:{children:_propTypes2.default.any,action:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.arrayOf(_propTypes2.default.string)]),showAction:_propTypes2.default.any,hideAction:_propTypes2.default.any,getPopupClassNameFromAlign:_propTypes2.default.any,onPopupVisibleChange:_propTypes2.default.func,afterPopupVisibleChange:_propTypes2.default.func,popup:_propTypes2.default.oneOfType([_propTypes2.default.node,_propTypes2.default.func]).isRequired,popupStyle:_propTypes2.default.object,prefixCls:_propTypes2.default.string,popupClassName:_propTypes2.default.string,popupPlacement:_propTypes2.default.string,builtinPlacements:_propTypes2.default.object,popupTransitionName:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.object]),popupAnimation:_propTypes2.default.any,mouseEnterDelay:_propTypes2.default.number,mouseLeaveDelay:_propTypes2.default.number,zIndex:_propTypes2.default.number,focusDelay:_propTypes2.default.number,blurDelay:_propTypes2.default.number,getPopupContainer:_propTypes2.default.func,getDocument:_propTypes2.default.func,destroyPopupOnHide:_propTypes2.default.bool,mask:_propTypes2.default.bool,maskClosable:_propTypes2.default.bool,onPopupAlign:_propTypes2.default.func,popupAlign:_propTypes2.default.object,popupVisible:_propTypes2.default.bool,maskTransitionName:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.object]),maskAnimation:_propTypes2.default.string},mixins:[(0,_getContainerRenderMixin2.default)({autoMount:false,isVisible:function isVisible(instance){return instance.state.popupVisible;},getContainer:function getContainer(instance){var props=instance.props;var popupContainer=document.createElement("div");// Make sure default popup container will never cause scrollbar appearing
// https://github.com/react-component/trigger/issues/41
popupContainer.style.position="absolute";popupContainer.style.top="0";popupContainer.style.left="0";popupContainer.style.width="100%";var mountNode=props.getPopupContainer?props.getPopupContainer((0,_reactDom.findDOMNode)(instance)):props.getDocument().body;var isTimepicker=false;// 处理时间选择第二层弹框在dialog嵌入iframe中时定位异常的问题
if(/ant-calendar-input-wrap/.test(mountNode.className)){isTimepicker=true;}var modal=[];if($){if(_window2.default.getParent()!==window){if(_window2.default.getTop().event&&_window2.default.getTop().target){modal=$(_window2.default.getTop().event.target).closest(".ant-modal");}else{var instanceDom=(0,_reactDom.findDOMNode)(instance);if(instanceDom){modal=$(instanceDom).closest(".ant-modal");}}if(modal.length>0){// if (mountNode === window.document.body) {
mountNode=modal[0];// }
}else{mountNode=window.document.body;}}}if(window.setLayoutWindow){mountNode=window.setLayoutWindow.document.body;}if(isTimepicker){mountNode=props.getPopupContainer?props.getPopupContainer((0,_reactDom.findDOMNode)(instance)):props.getDocument().body;}mountNode.appendChild(popupContainer);(0,_loadCss.loadCss)();return popupContainer;}})],getDefaultProps:function getDefaultProps(){return{prefixCls:"rc-trigger-popup",getPopupClassNameFromAlign:returnEmptyString,getDocument:returnDocument,onPopupVisibleChange:noop,afterPopupVisibleChange:noop,onPopupAlign:noop,popupClassName:"",mouseEnterDelay:0,mouseLeaveDelay:0.1,focusDelay:0,blurDelay:0.15,popupStyle:{},destroyPopupOnHide:false,popupAlign:{},defaultPopupVisible:false,mask:false,maskClosable:true,action:[],showAction:[],hideAction:[]};},getInitialState:function getInitialState(){var props=this.props;var popupVisible=void 0;if("popupVisible"in props){popupVisible=!!props.popupVisible;}else{popupVisible=!!props.defaultPopupVisible;}return{popupVisible:popupVisible};},componentWillMount:function componentWillMount(){var _this=this;ALL_HANDLERS.forEach(function(h){_this["fire"+h]=function(e){_this.fireEvents(h,e);};});},componentDidMount:function componentDidMount(){this.componentDidUpdate({},{popupVisible:this.state.popupVisible});},componentWillReceiveProps:function componentWillReceiveProps(_ref){var popupVisible=_ref.popupVisible;if(popupVisible!==undefined){this.setState({popupVisible:popupVisible});}},componentDidUpdate:function componentDidUpdate(_,prevState){var props=this.props;var state=this.state;this.renderComponent(null,function(){if(prevState.popupVisible!==state.popupVisible){props.afterPopupVisibleChange(state.popupVisible);}});// We must listen to `mousedown` or `touchstart`, edge case:
// https://github.com/ant-design/ant-design/issues/5804
// https://github.com/react-component/calendar/issues/250
// https://github.com/react-component/trigger/issues/50
if(state.popupVisible){var currentDocument=void 0;var topDocument=void 0;if(!this.clickOutsideHandler&&this.isClickToHide()){currentDocument=props.getDocument();topDocument=document;this.clickOutsideHandler=(0,_addEventListener2.default)(currentDocument,"mousedown",this.onDocumentClick);if(topDocument&&topDocument!==currentDocument){this.clickInsideHandler=(0,_addEventListener2.default)(topDocument,"mousedown",this.onDocumentClick);}}// always hide on mobile
if(!this.touchOutsideHandler){currentDocument=currentDocument||props.getDocument();this.touchOutsideHandler=(0,_addEventListener2.default)(currentDocument,"touchstart",this.onDocumentClick);if(topDocument&&topDocument!==currentDocument){this.touchInsideHandler=(0,_addEventListener2.default)(topDocument,"touchstart",this.onDocumentClick);}}return;}this.clearOutsideHandler();},componentWillUnmount:function componentWillUnmount(){this.clearDelayTimer();this.clearOutsideHandler();},onMouseEnter:function onMouseEnter(e){this.fireEvents("onMouseEnter",e);this.delaySetPopupVisible(true,this.props.mouseEnterDelay);},onMouseLeave:function onMouseLeave(e){this.fireEvents("onMouseLeave",e);this.delaySetPopupVisible(false,this.props.mouseLeaveDelay);},onPopupMouseEnter:function onPopupMouseEnter(){this.clearDelayTimer();},onPopupMouseLeave:function onPopupMouseLeave(e){// https://github.com/react-component/trigger/pull/13
// react bug?
if(e.relatedTarget&&!e.relatedTarget.setTimeout&&this._component&&this._component.getPopupDomNode&&(0,_contains2.default)(this._component.getPopupDomNode(),e.relatedTarget)){return;}this.delaySetPopupVisible(false,this.props.mouseLeaveDelay);},onFocus:function onFocus(e){this.fireEvents("onFocus",e);// incase focusin and focusout
this.clearDelayTimer();if(this.isFocusToShow()){this.focusTime=Date.now();this.delaySetPopupVisible(true,this.props.focusDelay);}},onMouseDown:function onMouseDown(e){this.fireEvents("onMouseDown",e);this.preClickTime=Date.now();},onTouchStart:function onTouchStart(e){this.fireEvents("onTouchStart",e);this.preTouchTime=Date.now();},onBlur:function onBlur(e){this.fireEvents("onBlur",e);this.clearDelayTimer();if(this.isBlurToHide()){this.delaySetPopupVisible(false,this.props.blurDelay);}},onClick:function onClick(event){this.fireEvents("onClick",event);// focus will trigger click
if(this.focusTime){var preTime=void 0;if(this.preClickTime&&this.preTouchTime){preTime=Math.min(this.preClickTime,this.preTouchTime);}else if(this.preClickTime){preTime=this.preClickTime;}else if(this.preTouchTime){preTime=this.preTouchTime;}if(Math.abs(preTime-this.focusTime)<20){return;}this.focusTime=0;}this.preClickTime=0;this.preTouchTime=0;event.preventDefault();var nextVisible=!this.state.popupVisible;if(this.isClickToHide()&&!nextVisible||nextVisible&&this.isClickToShow()){this.setPopupVisible(!this.state.popupVisible);}},onDocumentClick:function onDocumentClick(event){if(this.props.mask&&!this.props.maskClosable){return;}var target=event.target;var root=(0,_reactDom.findDOMNode)(this);var popupNode=this.getPopupDomNode();if(!(0,_contains2.default)(root,target)&&!(0,_contains2.default)(popupNode,target)){this.close();}},getPopupDomNode:function getPopupDomNode(){// for test
if(this._component&&this._component.getPopupDomNode){return this._component.getPopupDomNode();}return null;},getRootDomNode:function getRootDomNode(){return(0,_reactDom.findDOMNode)(this);},getPopupClassNameFromAlign:function getPopupClassNameFromAlign(align){var className=[];var props=this.props;var popupPlacement=props.popupPlacement,builtinPlacements=props.builtinPlacements,prefixCls=props.prefixCls;if(popupPlacement&&builtinPlacements){className.push((0,_utils.getPopupClassNameFromAlign)(builtinPlacements,prefixCls,align));}if(props.getPopupClassNameFromAlign){className.push(props.getPopupClassNameFromAlign(align));}return className.join(" ");},getPopupAlign:function getPopupAlign(){var props=this.props;var popupPlacement=props.popupPlacement,popupAlign=props.popupAlign,builtinPlacements=props.builtinPlacements;if(popupPlacement&&builtinPlacements){return(0,_utils.getAlignFromPlacement)(builtinPlacements,popupPlacement,popupAlign);}return popupAlign;},getComponent:function getComponent(){var props=this.props,state=this.state;var mouseProps={};if(this.isMouseEnterToShow()){mouseProps.onMouseEnter=this.onPopupMouseEnter;}if(this.isMouseLeaveToHide()){mouseProps.onMouseLeave=this.onPopupMouseLeave;}return _react2.default.createElement(_Popup2.default,(0,_extends3.default)({prefixCls:props.prefixCls,destroyPopupOnHide:props.destroyPopupOnHide,visible:state.popupVisible,className:props.popupClassName,triggerMaskClassName:props.triggerMaskClassName,action:props.action,align:this.getPopupAlign(),onAlign:props.onPopupAlign,animation:props.popupAnimation,getClassNameFromAlign:this.getPopupClassNameFromAlign},mouseProps,{getRootDomNode:this.getRootDomNode,style:props.popupStyle,mask:props.mask,zIndex:props.zIndex,transitionName:props.popupTransitionName,maskAnimation:props.maskAnimation,maskTransitionName:props.maskTransitionName,ecId:props.ecId+"_Popup@eqte67"}),typeof props.popup==="function"?props.popup():props.popup);},setPopupVisible:function setPopupVisible(popupVisible){this.clearDelayTimer();if(this.state.popupVisible!==popupVisible){if(!("popupVisible"in this.props)){this.setState({popupVisible:popupVisible});}this.props.onPopupVisibleChange(popupVisible);}},delaySetPopupVisible:function delaySetPopupVisible(visible,delayS){var _this2=this;var delay=delayS*1000;this.clearDelayTimer();if(delay){this.delayTimer=setTimeout(function(){_this2.setPopupVisible(visible);_this2.clearDelayTimer();},delay);}else{this.setPopupVisible(visible);}},clearDelayTimer:function clearDelayTimer(){if(this.delayTimer){clearTimeout(this.delayTimer);this.delayTimer=null;}},clearOutsideHandler:function clearOutsideHandler(){if(this.clickOutsideHandler){this.clickOutsideHandler.remove();this.clickOutsideHandler=null;}if(this.touchOutsideHandler){this.touchOutsideHandler.remove();this.touchOutsideHandler=null;}if(this.clickInsideHandler){this.clickInsideHandler.remove();this.clickInsideHandler=null;}if(this.touchInsideHandler){this.touchInsideHandler.remove();this.touchInsideHandler=null;}},createTwoChains:function createTwoChains(event){var childPros=this.props.children.props;var props=this.props;if(childPros[event]&&props[event]){return this["fire"+event];}return childPros[event]||props[event];},isClickToShow:function isClickToShow(){var _props=this.props,action=_props.action,showAction=_props.showAction;return action.indexOf("click")!==-1||showAction.indexOf("click")!==-1;},isClickToHide:function isClickToHide(){var _props2=this.props,action=_props2.action,hideAction=_props2.hideAction;return action.indexOf("click")!==-1||hideAction.indexOf("click")!==-1;},isMouseEnterToShow:function isMouseEnterToShow(){var _props3=this.props,action=_props3.action,showAction=_props3.showAction;return action.indexOf("hover")!==-1||showAction.indexOf("mouseEnter")!==-1;},isMouseLeaveToHide:function isMouseLeaveToHide(){var _props4=this.props,action=_props4.action,hideAction=_props4.hideAction;return action.indexOf("hover")!==-1||hideAction.indexOf("mouseLeave")!==-1;},isFocusToShow:function isFocusToShow(){var _props5=this.props,action=_props5.action,showAction=_props5.showAction;return action.indexOf("focus")!==-1||showAction.indexOf("focus")!==-1;},isBlurToHide:function isBlurToHide(){var _props6=this.props,action=_props6.action,hideAction=_props6.hideAction;return action.indexOf("focus")!==-1||hideAction.indexOf("blur")!==-1;},forcePopupAlign:function forcePopupAlign(){if(this.state.popupVisible&&this._component&&this._component.alignInstance){this._component.alignInstance.forceAlign();}},fireEvents:function fireEvents(type,e){var childCallback=this.props.children.props[type];if(childCallback){childCallback(e);}var callback=this.props[type];if(callback){callback(e);}},close:function close(){this.setPopupVisible(false);},render:function render(){var props=this.props;var children=props.children;var child=_react2.default.Children.only(children);var newChildProps={};if(this.isClickToHide()||this.isClickToShow()){newChildProps.onClick=this.onClick;newChildProps.onMouseDown=this.onMouseDown;newChildProps.onTouchStart=this.onTouchStart;}else{newChildProps.onClick=this.createTwoChains("onClick");newChildProps.onMouseDown=this.createTwoChains("onMouseDown");newChildProps.onTouchStart=this.createTwoChains("onTouchStart");}if(this.isMouseEnterToShow()){newChildProps.onMouseEnter=this.onMouseEnter;}else{newChildProps.onMouseEnter=this.createTwoChains("onMouseEnter");}if(this.isMouseLeaveToHide()){newChildProps.onMouseLeave=this.onMouseLeave;}else{newChildProps.onMouseLeave=this.createTwoChains("onMouseLeave");}if(this.isFocusToShow()||this.isBlurToHide()){newChildProps.onFocus=this.onFocus;newChildProps.onBlur=this.onBlur;}else{newChildProps.onFocus=this.createTwoChains("onFocus");newChildProps.onBlur=this.createTwoChains("onBlur");}return _react2.default.cloneElement(child,newChildProps);}});exports.default=Trigger;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(469);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=contains;function contains(root,n){var node=n;while(node){if(node===root){return true;}node=node.parentNode;}return false;}

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=addEventListenerWrap;var _addDomEventListener=__webpack_require__(119);var _addDomEventListener2=_interopRequireDefault(_addDomEventListener);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function addEventListenerWrap(target,eventType,cb){/* eslint camelcase: 2 */var callback=_reactDom2.default.unstable_batchedUpdates?function run(e){_reactDom2.default.unstable_batchedUpdates(cb,e);}:cb;return(0,_addDomEventListener2.default)(target,eventType,callback);}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(15);var _propTypes2=_interopRequireDefault(_propTypes);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _rcAlign=__webpack_require__(473);var _rcAlign2=_interopRequireDefault(_rcAlign);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _PopupInner=__webpack_require__(479);var _PopupInner2=_interopRequireDefault(_PopupInner);var _LazyRenderBox=__webpack_require__(193);var _LazyRenderBox2=_interopRequireDefault(_LazyRenderBox);var _utils=__webpack_require__(194);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Popup=(_temp=_class=function(_Component){(0,_inherits3.default)(Popup,_Component);function Popup(props){(0,_classCallCheck3.default)(this,Popup);var _this=(0,_possibleConstructorReturn3.default)(this,(Popup.__proto__||(0,_getPrototypeOf2.default)(Popup)).call(this,props));_initialiseProps.call(_this);_this.savePopupRef=_utils.saveRef.bind(_this,"popupInstance");_this.saveAlignRef=_utils.saveRef.bind(_this,"alignInstance");return _this;}(0,_createClass3.default)(Popup,[{key:"componentDidMount",value:function componentDidMount(){this.rootNode=this.getPopupDomNode();}},{key:"getPopupDomNode",value:function getPopupDomNode(){return _reactDom2.default.findDOMNode(this.popupInstance);}},{key:"getMaskTransitionName",value:function getMaskTransitionName(){var props=this.props;var transitionName=props.maskTransitionName;var animation=props.maskAnimation;if(!transitionName&&animation){transitionName=props.prefixCls+"-"+animation;}return transitionName;}},{key:"getTransitionName",value:function getTransitionName(){var props=this.props;var transitionName=props.transitionName;if(!transitionName&&props.animation){transitionName=props.prefixCls+"-"+props.animation;}return transitionName;}},{key:"getClassName",value:function getClassName(currentAlignClassName){return this.props.prefixCls+" "+this.props.className+" "+currentAlignClassName;}},{key:"getPopupElement",value:function getPopupElement(){var savePopupRef=this.savePopupRef,props=this.props;var align=props.align,style=props.style,visible=props.visible,prefixCls=props.prefixCls,destroyPopupOnHide=props.destroyPopupOnHide,ecId=props.ecId;var className=this.getClassName(this.currentAlignClassName||props.getClassNameFromAlign(align));var hiddenClassName=prefixCls+"-hidden";if(!visible){this.currentAlignClassName=null;}var newStyle=(0,_extends3.default)({},style,this.getZIndexStyle());var popupInnerProps={className:className,prefixCls:prefixCls,ref:savePopupRef,onMouseEnter:props.onMouseEnter,onMouseLeave:props.onMouseLeave,style:newStyle};if(destroyPopupOnHide){return _react2.default.createElement(_rcAnimate2.default,{component:"",exclusive:true,transitionAppear:true,transitionName:this.getTransitionName(),ecId:ecId+"_Animate@93e6ql"},visible?_react2.default.createElement(_rcAlign2.default,{target:this.getTarget,key:"popup",ref:this.saveAlignRef,monitorWindowResize:true,align:align,onAlign:this.onAlign,ecId:ecId+"_Align@0k6rae"},_react2.default.createElement(_PopupInner2.default,(0,_extends3.default)({visible:true},popupInnerProps,{ecId:ecId+"_PopupInner@uh3doz"}),props.children)):null);}return _react2.default.createElement(_rcAnimate2.default,{ecId:ecId+"_Animate@2y3fw7",component:"",exclusive:true,transitionAppear:true,transitionName:this.getTransitionName(),showProp:"xVisible"},_react2.default.createElement(_rcAlign2.default,{ecId:ecId+"_Align@rbujkp",target:this.getTarget,key:"popup",ref:this.saveAlignRef,monitorWindowResize:true,xVisible:visible,childrenProps:{visible:"xVisible"},disabled:!visible,align:align,onAlign:this.onAlign},_react2.default.createElement(_PopupInner2.default,(0,_extends3.default)({hiddenClassName:hiddenClassName},popupInnerProps,{ecId:ecId+"_PopupInner@8utwji"}),props.children)));}},{key:"getZIndexStyle",value:function getZIndexStyle(){var style={};var props=this.props;if(props.zIndex!==undefined){style.zIndex=props.zIndex;}return style;}},{key:"getMaskElement",value:function getMaskElement(){var props=this.props;var maskElement=void 0;if(props.mask){var maskTransition=this.getMaskTransitionName();maskElement=_react2.default.createElement(_LazyRenderBox2.default,{ecId:props.ecId+"_LazyRenderBox@fqcq8j",style:this.getZIndexStyle(),key:"mask",className:props.prefixCls+"-mask",hiddenClassName:props.prefixCls+"-mask-hidden",visible:props.visible});if(maskTransition){maskElement=_react2.default.createElement(_rcAnimate2.default,{ecId:props.ecId+"_Animate@zo4se4",key:"mask",showProp:"visible",transitionAppear:true,component:"",transitionName:maskTransition},maskElement);}}return maskElement;}},{key:"render",value:function render(){return _react2.default.createElement("div",{className:this.props.triggerMaskClassName||""},this.getMaskElement(),this.getPopupElement());}}]);return Popup;}(_react.Component),_class.propTypes={visible:_propTypes2.default.bool,style:_propTypes2.default.object,getClassNameFromAlign:_propTypes2.default.func,onAlign:_propTypes2.default.func,getRootDomNode:_propTypes2.default.func,onMouseEnter:_propTypes2.default.func,align:_propTypes2.default.any,destroyPopupOnHide:_propTypes2.default.bool,className:_propTypes2.default.string,prefixCls:_propTypes2.default.string,onMouseLeave:_propTypes2.default.func},_initialiseProps=function _initialiseProps(){var _this2=this;this.onAlign=function(popupDomNode,align){var props=_this2.props;var currentAlignClassName=props.getClassNameFromAlign(align);// FIX: https://github.com/react-component/trigger/issues/56
// FIX: https://github.com/react-component/tooltip/issues/79
if(_this2.currentAlignClassName!==currentAlignClassName){_this2.currentAlignClassName=currentAlignClassName;popupDomNode.className=_this2.getClassName(currentAlignClassName);}props.onAlign(popupDomNode,align);};this.getTarget=function(){return _this2.props.getRootDomNode();};},_temp);exports.default=Popup;

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(474);
// export this package's api


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(477);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */


function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); parent && parent !== body; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */


function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points; // 重置对应部分的翻转逻辑

      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }

      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }

      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2({}, align, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(478);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(15);var _propTypes2=_interopRequireDefault(_propTypes);var _LazyRenderBox=__webpack_require__(193);var _LazyRenderBox2=_interopRequireDefault(_LazyRenderBox);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var PopupInner=(_temp=_class=function(_Component){(0,_inherits3.default)(PopupInner,_Component);function PopupInner(){(0,_classCallCheck3.default)(this,PopupInner);return(0,_possibleConstructorReturn3.default)(this,(PopupInner.__proto__||(0,_getPrototypeOf2.default)(PopupInner)).apply(this,arguments));}(0,_createClass3.default)(PopupInner,[{key:"render",value:function render(){var props=this.props;var className=props.className;if(!props.visible){className+=" "+props.hiddenClassName;}return _react2.default.createElement("div",{ecId:props.ecId+"_div@u4cyjq",className:className,onMouseEnter:props.onMouseEnter,onMouseLeave:props.onMouseLeave,style:props.style},_react2.default.createElement(_LazyRenderBox2.default,{ecId:props.ecId+"_LazyRenderBox@tggfbb",className:props.prefixCls+"-content",visible:props.visible},props.children));}}]);return PopupInner;}(_react.Component),_class.propTypes={hiddenClassName:_propTypes2.default.string,className:_propTypes2.default.string,prefixCls:_propTypes2.default.string,onMouseEnter:_propTypes2.default.func,onMouseLeave:_propTypes2.default.func,children:_propTypes2.default.any},_temp);exports.default=PopupInner;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);exports.default=getContainerRenderMixin;var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function defaultGetContainer(){var container=document.createElement('div');document.body.appendChild(container);return container;}function getContainerRenderMixin(config){var _config$autoMount=config.autoMount,autoMount=_config$autoMount===undefined?true:_config$autoMount,_config$autoDestroy=config.autoDestroy,autoDestroy=_config$autoDestroy===undefined?true:_config$autoDestroy,isVisible=config.isVisible,isForceRender=config.isForceRender,getComponent=config.getComponent,_config$getContainer=config.getContainer,getContainer=_config$getContainer===undefined?defaultGetContainer:_config$getContainer;var mixin=void 0;function _renderComponent(instance,componentArg,ready){if(!isVisible||instance._component||isVisible(instance)||isForceRender&&isForceRender(instance)){if(!instance._container){instance._container=getContainer(instance);}var component=void 0;if(instance.getComponent){component=instance.getComponent(componentArg);}else{component=getComponent(instance,componentArg);}_reactDom2.default.unstable_renderSubtreeIntoContainer(instance,component,instance._container,function callback(){instance._component=this;if(ready){ready.call(this);}});}}if(autoMount){mixin=(0,_extends3.default)({},mixin,{componentDidMount:function componentDidMount(){_renderComponent(this);},componentDidUpdate:function componentDidUpdate(){_renderComponent(this);}});}if(!autoMount||!autoDestroy){mixin=(0,_extends3.default)({},mixin,{renderComponent:function renderComponent(componentArg,ready){_renderComponent(this,componentArg,ready);}});}function _removeContainer(instance){if(instance._container){var container=instance._container;_reactDom2.default.unmountComponentAtNode(container);container.parentNode.removeChild(container);instance._container=null;}}if(autoDestroy){mixin=(0,_extends3.default)({},mixin,{componentWillUnmount:function componentWillUnmount(){_removeContainer(this);}});}else{mixin=(0,_extends3.default)({},mixin,{removeContainer:function removeContainer(){_removeContainer(this);}});}return mixin;}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _middleware=__webpack_require__(27);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MenuItemGroup=_react2.default.createClass({displayName:"MenuItemGroup",propTypes:{renderMenuItem:_react.PropTypes.func,index:_react.PropTypes.number},getDefaultProps:function getDefaultProps(){return{disabled:true};},renderInnerMenuItem:function renderInnerMenuItem(item,subIndex){var renderMenuItem=this.props.renderMenuItem;return renderMenuItem(item,this.props.index,subIndex);},render:function render(){var props=this.props;var className=props.className||"";var rootPrefixCls=props.rootPrefixCls;className+=" "+rootPrefixCls+"-item-group";var titleClassName=rootPrefixCls+"-item-group-title";var listClassName=rootPrefixCls+"-item-group-list";return _react2.default.createElement("li",{className:className},_react2.default.createElement("div",{className:titleClassName},props.title),_react2.default.createElement("ul",{className:listClassName},_react2.default.Children.map(props.children,this.renderInnerMenuItem)));}});MenuItemGroup.isMenuItemGroup=true;// export default MenuItemGroup;
exports.default=(0,_middleware2.default)(MenuItemGroup,"Menu.ItemGroup");

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _middleware=__webpack_require__(27);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Divider=_react2.default.createClass({displayName:"Divider",getDefaultProps:function getDefaultProps(){return{disabled:true};},render:function render(){var props=this.props;var className=props.className||"";var rootPrefixCls=props.rootPrefixCls;className+=" "+(rootPrefixCls+"-item-divider");return _react2.default.createElement("li",{className:className});}});exports.default=(0,_middleware2.default)(Divider,"Menu.Divider");// export default Divider;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Radio = __webpack_require__(484);

var _Radio2 = _interopRequireDefault(_Radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Radio2["default"];
module.exports = exports['default'];

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcCheckbox = __webpack_require__(485);

var _rcCheckbox2 = _interopRequireDefault(_rcCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Radio = function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio() {
    _classCallCheck(this, Radio);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Radio.prototype.render = function render() {
    return _react2["default"].createElement(_rcCheckbox2["default"], _extends({}, this.props, { ref: 'checkbox' }));
  };

  return Radio;
}(_react2["default"].Component);

Radio.defaultProps = {
  prefixCls: 'rc-radio',
  type: 'radio'
};
exports["default"] = Radio;
module.exports = exports['default'];

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(486);

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PureRenderMixin = __webpack_require__(487);

var _PureRenderMixin2 = _interopRequireDefault(_PureRenderMixin);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Checkbox = function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox(props) {
    _classCallCheck(this, Checkbox);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var checked = 'checked' in props ? props.checked : props.defaultChecked;

    _this.state = {
      checked: checked
    };
    return _this;
  }

  Checkbox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({
        checked: nextProps.checked
      });
    }
  };

  Checkbox.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _PureRenderMixin2["default"].shouldComponentUpdate.apply(this, args);
  };

  Checkbox.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        className = _props.className,
        style = _props.style,
        name = _props.name,
        type = _props.type,
        disabled = _props.disabled,
        readOnly = _props.readOnly,
        tabIndex = _props.tabIndex,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onBlur = _props.onBlur;
    var checked = this.state.checked;

    var classString = (0, _classnames2["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, prefixCls + '-checked', checked), _defineProperty(_classNames, prefixCls + '-disabled', disabled), _classNames));

    return _react2["default"].createElement(
      'span',
      { className: classString, style: style },
      _react2["default"].createElement('input', {
        name: name,
        type: type,
        readOnly: readOnly,
        disabled: disabled,
        tabIndex: tabIndex,
        className: prefixCls + '-input',
        checked: !!checked,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: this.handleChange
      }),
      _react2["default"].createElement('span', { className: prefixCls + '-inner' })
    );
  };

  return Checkbox;
}(_react2["default"].Component);

Checkbox.propTypes = {
  prefixCls: _react.PropTypes.string,
  className: _react.PropTypes.string,
  style: _react.PropTypes.object,
  name: _react.PropTypes.string,
  type: _react.PropTypes.string,
  defaultChecked: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
  checked: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
  disabled: _react.PropTypes.bool,
  onFocus: _react.PropTypes.func,
  onBlur: _react.PropTypes.func,
  onChange: _react.PropTypes.func,
  onClick: _react.PropTypes.func,
  tabIndex: _react.PropTypes.string,
  readOnly: _react.PropTypes.bool
};
Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  className: '',
  style: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleChange = function (e) {
    var props = _this2.props;

    if (props.disabled) {
      return;
    }
    if (!('checked' in props)) {
      _this2.setState({
        checked: e.target.checked
      });
    }
    props.onChange({
      target: _extends({}, props, {
        checked: e.target.checked
      }),
      stopPropagation: function stopPropagation() {
        e.stopPropagation();
      },
      preventDefault: function preventDefault() {
        e.preventDefault();
      }
    });
  };
};

exports["default"] = Checkbox;
module.exports = exports['default'];

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentWithPureRenderMixin
 */
var shallowEqual = __webpack_require__(488);

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}
/**
 * If your React component's render function is "pure", e.g. it will render the
 * same result given the same props and state, provide this mixin for a
 * considerable performance boost.
 *
 * Most React components have pure render functions.
 *
 * Example:
 *
 *   var ReactComponentWithPureRenderMixin =
 *     require('ReactComponentWithPureRenderMixin');
 *   React.createClass({
 *     mixins: [ReactComponentWithPureRenderMixin],
 *
 *     render: function() {
 *       return <div className={this.props.className}>foo</div>;
 *     }
 *   });
 *
 * Note: This only checks shallow equality for props and state. If these contain
 * complex data structures this mixin may have false-negatives for deeper
 * differences. Only mixin to components which have simple props and state, or
 * use `forceUpdate()` when you know deep data structures have changed.
 *
 * See https://facebook.github.io/react/docs/pure-render-mixin.html
 */


var ReactComponentWithPureRenderMixin = {
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
};
module.exports = ReactComponentWithPureRenderMixin;

/***/ }),
/* 488 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _radio=__webpack_require__(129);var _radio2=_interopRequireDefault(_radio);var _radioButton=__webpack_require__(196);var _radioButton2=_interopRequireDefault(_radioButton);var _reactAddonsPureRenderMixin=__webpack_require__(38);var _reactAddonsPureRenderMixin2=_interopRequireDefault(_reactAddonsPureRenderMixin);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function getCheckedValue(children){var value=null;var matched=false;_react2.default.Children.forEach(children,function(radio){if(radio&&radio.props&&radio.props.checked){value=radio.props.value;matched=true;}});return matched?{value:value}:undefined;}var RadioGroup=(_temp=_class=function(_React$Component){(0,_inherits3.default)(RadioGroup,_React$Component);function RadioGroup(props){(0,_classCallCheck3.default)(this,RadioGroup);var _this=(0,_possibleConstructorReturn3.default)(this,(RadioGroup.__proto__||(0,_getPrototypeOf2.default)(RadioGroup)).call(this,props));_this.onRadioChange=function(ev){if(!("value"in _this.props)){_this.setState({value:ev.target.value});}_this.props.onChange(ev);};var value=void 0;if("value"in props){value=props.value;}else if("defaultValue"in props){value=props.defaultValue;}else{var checkedValue=getCheckedValue(props.children);value=checkedValue&&checkedValue.value;}_this.state={value:value};return _this;}(0,_createClass3.default)(RadioGroup,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if("value"in nextProps){this.setState({value:nextProps.value});}else{var checkedValue=getCheckedValue(nextProps.children);if(checkedValue){this.setState({value:checkedValue.value});}}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.apply(this,args);}},{key:"render",value:function render(){var _this2=this,_classNames;var props=this.props;var children=_react2.default.Children.map(props.children,function(radio){if(radio&&radio.type&&(radio.type.displayName==="Radio"||radio.type.displayName==="RadioButton")&&radio.props){var keyProps={};if(!("key"in radio)&&typeof radio.props.value==="string"){keyProps.key=radio.props.value;}return _react2.default.cloneElement(radio,(0,_extends3.default)({},keyProps,radio.props,{onChange:_this2.onRadioChange,checked:_this2.state.value===radio.props.value,disabled:radio.props.disabled||_this2.props.disabled}));}// return radio; react16 下有bug
});var classString=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,props.prefixCls,true),(0,_defineProperty3.default)(_classNames,props.prefixCls+"-"+props.size,props.size),_classNames));return _react2.default.createElement("div",{className:classString,style:props.style,ecId:props.ecId+"_div@kf60f8"},children);}}]);return RadioGroup;}(_react2.default.Component),_class.defaultProps={prefixCls:"ant-radio-group",disabled:false,onChange:function onChange(){}},_temp);exports.default=RadioGroup;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * $Id: base64.js,v 2.15 2014/04/05 12:58:57 dankogai Exp dankogai $
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 */

(function(global) {
    'use strict';
    // existing version for noConflict()
    var _Base64 = global.Base64;
    var version = "2.2.1";
    // if node.js, we use Buffer
    var buffer;
    if (typeof module !== 'undefined' && module.exports) {
        try {
            buffer = __webpack_require__(491).Buffer;
        } catch (err) {}
    }
    // constants
    var b64chars
        = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function(bin) {
        var t = {};
        for (var i = 0, l = bin.length; i < l; i++) t[bin.charAt(i)] = i;
        return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c
                : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
                                + fromCharCode(0x80 | (cc & 0x3f)))
                : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
                   + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                   + fromCharCode(0x80 | ( cc         & 0x3f)));
        } else {
            var cc = 0x10000
                + (c.charCodeAt(0) - 0xD800) * 0x400
                + (c.charCodeAt(1) - 0xDC00);
            return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
                    + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                    + fromCharCode(0x80 | ( cc         & 0x3f)));
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function(ccc) {
        var padlen = [0, 2, 1][ccc.length % 3],
        ord = ccc.charCodeAt(0) << 16
            | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
            | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0)),
        chars = [
            b64chars.charAt( ord >>> 18),
            b64chars.charAt((ord >>> 12) & 63),
            padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
        ];
        return chars.join('');
    };
    var btoa = global.btoa ? function(b) {
        return global.btoa(b);
    } : function(b) {
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = buffer ?
        buffer.from ? function (u) {
            return (u.constructor === buffer.constructor ? u : buffer.from(u))
                .toString('base64')
        }
        :  function (u) {
            return (u.constructor === buffer.constructor ? u : new  buffer(u))
                .toString('base64')
        }
        : function (u) { return btoa(utob(u)) }
    ;
    var encode = function(u, urisafe) {
        return !urisafe
            ? _encode(String(u))
            : _encode(String(u)).replace(/[+\/]/g, function(m0) {
                return m0 == '+' ? '-' : '_';
            }).replace(/=/g, '');
    };
    var encodeURI = function(u) { return encode(u, true) };
    // decoder stuff
    var re_btou = new RegExp([
        '[\xC0-\xDF][\x80-\xBF]',
        '[\xE0-\xEF][\x80-\xBF]{2}',
        '[\xF0-\xF7][\x80-\xBF]{3}'
    ].join('|'), 'g');
    var cb_btou = function(cccc) {
        switch(cccc.length) {
        case 4:
            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                |    ((0x3f & cccc.charCodeAt(1)) << 12)
                |    ((0x3f & cccc.charCodeAt(2)) <<  6)
                |     (0x3f & cccc.charCodeAt(3)),
            offset = cp - 0x10000;
            return (fromCharCode((offset  >>> 10) + 0xD800)
                    + fromCharCode((offset & 0x3FF) + 0xDC00));
        case 3:
            return fromCharCode(
                ((0x0f & cccc.charCodeAt(0)) << 12)
                    | ((0x3f & cccc.charCodeAt(1)) << 6)
                    |  (0x3f & cccc.charCodeAt(2))
            );
        default:
            return  fromCharCode(
                ((0x1f & cccc.charCodeAt(0)) << 6)
                    |  (0x3f & cccc.charCodeAt(1))
            );
        }
    };
    var btou = function(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function(cccc) {
        var len = cccc.length,
        padlen = len % 4,
        n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0)
            | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0)
            | (len > 2 ? b64tab[cccc.charAt(2)] <<  6 : 0)
            | (len > 3 ? b64tab[cccc.charAt(3)]       : 0),
        chars = [
            fromCharCode( n >>> 16),
            fromCharCode((n >>>  8) & 0xff),
            fromCharCode( n         & 0xff)
        ];
        chars.length -= [0, 0, 2, 1][padlen];
        return chars.join('');
    };
    var atob = global.atob ? function(a) {
        return global.atob(a);
    } : function(a){
        return a.replace(/[\s\S]{1,4}/g, cb_decode);
    };
    var _decode = buffer ?
        buffer.from ? function(a) {
            return (a.constructor === buffer.constructor
                    ? a : buffer.from(a, 'base64')).toString();
        }
        : function(a) {
            return (a.constructor === buffer.constructor
                    ? a : new buffer(a, 'base64')).toString();
        }
        : function(a) { return btou(atob(a)) };
    var decode = function(a){
        return _decode(
            String(a).replace(/[-_]/g, function(m0) { return m0 == '-' ? '+' : '/' })
                .replace(/[^A-Za-z0-9\+\/]/g, '')
        );
    };
    var noConflict = function() {
        var Base64 = global.Base64;
        global.Base64 = _Base64;
        return Base64;
    };
    // export Base64
    global.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function(v){
            return {value:v,enumerable:false,writable:true,configurable:true};
        };
        global.Base64.extendString = function () {
            Object.defineProperty(
                String.prototype, 'fromBase64', noEnum(function () {
                    return decode(this)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64', noEnum(function (urisafe) {
                    return encode(this, urisafe)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64URI', noEnum(function () {
                    return encode(this, true)
                }));
        };
    }
    // that's it!
})(this);


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(492)
var ieee754 = __webpack_require__(493)
var isArray = __webpack_require__(494)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 493 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 494 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ssoLogout=exports.checkCustomSSO=exports.checkSSO=undefined;var _promise=__webpack_require__(48);var _promise2=_interopRequireDefault(_promise);var _loadjs=__webpack_require__(76);var _loadjs2=_interopRequireDefault(_loadjs);var _getUrlParams=__webpack_require__(496);var _getUrlParams2=_interopRequireDefault(_getUrlParams);var _callApi=__webpack_require__(72);var caUtil=_interopRequireWildcard(_callApi);var _window=__webpack_require__(33);var _window2=_interopRequireDefault(_window);var _getOsInfo=__webpack_require__(497);var _getOsInfo2=_interopRequireDefault(_getOsInfo);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var callApi=caUtil.callApi;var checkSSO=exports.checkSSO=function checkSSO(path){var checkCustom=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return new _promise2.default(function(rs,rj){if(!window.ssoChecked&&!window.isAdminIndex){if(/.*em_auth_code.*/.test(window.location.href)){if(window.ssoChecking){var interval=setInterval(function(){if(window.ssoChecking){return;}else{clearInterval(interval);rs();}},500);}else{var params=(0,_getUrlParams2.default)();window.ssoChecking=true;callApi("/api/ec/dev/app/test","GET",{em_auth_code:params["em_auth_code"],em_auth_userid:params["em_auth_userid"],timeZoneOffset:new Date().getTimezoneOffset()}).then(function(res){window.ssoChecked=true;window.ssoChecking=false;if(res.languageType){window.localStorage["languageidweaver"]=res.languageType;}if(!res.status){window.location.href=""+(window.ecologyContentPath||"")+"/wui/index.html";rs();}else{var initEm=function initEm(res,rs){setTimeout(function(){//init emobile config
if(window.em){em.config({corpId:res.em_corpid,//必填，企业的corpId
appId:""// 非必填，应用ID
});em.ready(function(){window.localStorage.emobile_ec_id=res.ec_id;em.setPageReload({setvalue:2,// 1表示每次都需要重新加载页面（默认） 2表示保持页面无需重新加载，
success:function success(res){// 如：{"errMsg":"setHoldPage:ok"}
//alert(res.errMsg);
}});});rs();}},100);};var timestamp=new Date().getTime();var emUrl=res.em_url_open+"/open/js/jem.js?_key="+timestamp;_loadjs2.default.isDefined("em")?_loadjs2.default.ready("em",initEm.bind(undefined,res,rs)):(0,_loadjs2.default)(emUrl,"em",initEm.bind(undefined,res,rs));}});}}else{if(checkCustom){if(!window.e9ecComConfig){if(window.e9ssoPCConfig&&window.e9ssoPCConfig.inUse&&window.e9ssoPCConfig.customInit){window.e9ssoPCConfig.customInit().then(function(){checkCustomSSO(path).then(function(){(0,_getOsInfo2.default)(function(){rs();});});});}else{checkCustomSSO(path).then(function(){(0,_getOsInfo2.default)(function(){rs();});});}}else{if(window.e9ssoPCConfig&&window.e9ssoPCConfig.inUse&&window.e9ssoPCConfig.customInit){window.e9ssoPCConfig.customInit().then(function(){checkCustomSSO(path).then(function(){(0,_getOsInfo2.default)(function(){rs();});});});}else{checkCustomSSO(path).then(function(){(0,_getOsInfo2.default)(function(){rs();});});}}}else{(0,_getOsInfo2.default)(function(){rs();});}}}else{(0,_getOsInfo2.default)(function(){rs();});}});};var checkCustomSSO=exports.checkCustomSSO=function checkCustomSSO(path){return new _promise2.default(function(rs,rj){if(!window.ssoCustomChecked&&!window.isAdminIndex){window.ssoCustomChecked=true;if(window.customSSOConfig){if(window.customSSOConfig.inUse){var params=(0,_getUrlParams2.default)();var checkSessionParams={};if(window.customSSOConfig.sessionCheckApiParams){var sessionParams=window.customSSOConfig.sessionCheckApiParams.split(",");sessionParams.forEach(function(element){checkSessionParams[element]=params[element];});}callApi(window.customSSOConfig.sessionCheckApi,window.customSSOConfig.sessionCheckApiType||"GET",checkSessionParams).then(function(res){if(res.status&&!res.hasSession){var getQueryVariable=function getQueryVariable(variable){var query=window.location.search.substring(1);var vars=query.split("&");for(var i=0;i<vars.length;i++){var pair=vars[i].split("=");if(pair[0]==variable){return pair[1];}}return false;};var servicePath=path||window.location.pathname+window.location.search+window.location.hash;if(/\/wui\/index\.html\#\/\?/.test(servicePath)){servicePath="/wui/index.html#/main";}if(/\/spa\/portal\/public\/index\.html#\/licensesubmit\?display=page/.test(window.location.href)){rs();}var service=window.location.protocol+"//"+window.location.host+(window.ecologyContentPath||"")+"/wui/cas-entrance.jsp?path="+encodeURIComponent(servicePath);if(getQueryVariable("languid")){service=window.location.protocol+"//"+window.location.host+(window.ecologyContentPath||"")+"/wui/cas-entrance.jsp?languid="+getQueryVariable("languid")+"&path="+encodeURIComponent(servicePath);}var paramsMark="?";if(window.customSSOConfig.serverLoginUrl.indexOf("?")!==-1){paramsMark="&";}window.localStorage["casPath"]=""+window.customSSOConfig.serverLoginUrl+paramsMark+"service="+encodeURIComponent(service);window.location.href=""+window.customSSOConfig.serverLoginUrl+paramsMark+"service="+encodeURIComponent(service);// window.location.href = service;
rs();}else{if(res.status&&res.hasSession){if(/.*\/login\/OALogin\.jsp.*/.test(_window2.default.getTop().location.href)||/.*\/wui\/index(-admin)?\.html.*#\/\?.*/.test(_window2.default.getTop().location.href)||/.*\/wui\/index(-admin)?\.html$/.test(_window2.default.getTop().location.href)){// 第三方集成登录的场景下 登录页如果系统session还未清除 则自动跳转
_window2.default.getTop().location.href=""+(window.ecologyContentPath||"")+"/wui/index.html#/main";}}(0,_getOsInfo2.default)(function(){rs();});}});}else{(0,_getOsInfo2.default)(function(){rs();});}}else{(0,_getOsInfo2.default)(function(){rs();});}}else{(0,_getOsInfo2.default)(function(){rs();});}});};var ssoLogout=exports.ssoLogout=function ssoLogout(logoutRes){if(window.eventRegister.list["emLogoutEvent"]){window.eventRegister.startList("emLogoutEvent",function(){// success
},function(){// fail
});}else{getLogoutUrl(logoutRes);}};var getLogoutUrl=function getLogoutUrl(logoutRes,isEngine){if(logoutRes.status==true){if(window.customSSOConfig&&window.customSSOConfig.inUse){if(window.customSSOConfig.serverLogoutUrl){if(window.customSSOConfig.serverLogoutAjax){// TODO
}else{window.location.href=window.customSSOConfig.serverLogoutUrl;}}else{if(window.weaHistory&&location.href.indexOf("engine.html")==-1){window.weaHistory.push({pathname:"/"});}else{window.location.href=""+(window.ecologyContentPath||"")+"/wui/index.html";}}}else{if(logoutRes.casLogoutUrl){var split="?";if(logoutRes.casLogoutUrl.indexOf("?")>-1){split="&";}window.location.href=logoutRes.casLogoutUrl+split+"e9timestamp="+new Date().getTime();}else{if(window.weaHistory&&location.href.indexOf("engine.html")==-1){window.weaHistory.push({pathname:"/"});}else{window.location.href=""+(window.ecologyContentPath||"")+"/wui/index.html";}}}}};window.onLogoutCallback=function(){window.localStorage["e9_locale"]=null;window.ssoChecked=false;window.e9_locale=null;if(window.emClient){emClient.logout();}};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function getFrameParams(){var url=window.location.href;var urlParams=url.slice(url.indexOf('?')+1).split('&');var params=[];urlParams.forEach(function(element){var datas=element.split('=');params[datas[0]]=datas[1];});return params;}module.exports=getFrameParams;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _callApi=__webpack_require__(72);var _storage=__webpack_require__(498);function getOs(cb){(0,_callApi.callApi)("/api/system/info/getOSinfo","GET",{}).then(function(res){if(res.status){_storage.ls.set("getOsInfo",res);var defaultLinkMode=res.defaultLinkMode,dragColumns=res.dragColumns,uploadSuffixLimit=res.uploadSuffixLimit,prohibitDownload=res.prohibitDownload,languageVersion=res.languageVersion;if(res.languageType){window.localStorage["languageidweaver"]=res.languageType;}window.localStorage.setItem("ec_open_rewrite",defaultLinkMode);window.localStorage.setItem("dragColumns_WeaTable",dragColumns);window.localStorage.setItem("uploadSuffixLimit",uploadSuffixLimit);window.localStorage.setItem("prohibitDownload",prohibitDownload);window.localStorage.setItem("languageVersion",languageVersion);}var browserConfig=res.browserConfig;if(browserConfig){var timeInterval=browserConfig.timeInterval,typeList=browserConfig.typeList,defaultPageSize=browserConfig.defaultPageSize,pageConfigList=browserConfig.pageConfigList,defaultCountry=browserConfig.defaultCountry;// 保存浏览按钮的设置
window.ecBrowserConfig=browserConfig;// 获取浏览按钮显示设置
window.ecBrowserDisplayStyle=typeList||[];// 获取系统时间间隔设置
window.ecTimePickerMinuteStep=timeInterval||1;// 获取浏览按钮默认显示条数
window.ecBrowserDisplayPageSize=defaultPageSize||10;// 获取浏览按钮显示条数配置
window.ecBrowserDisplayConfigList=pageConfigList||[];// 获取城市浏览框默认国家配置
window.ecBrowserDefaultCountry=defaultCountry;}cb();}).catch(function(err){// window.console && window.console.log('err: ', err);
});// window.localStorage.removeItem("ec_open_rewrite");
}module.exports=getOs;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ss=exports.ls=undefined;var _stringify=__webpack_require__(71);var _stringify2=_interopRequireDefault(_stringify);var _typeof2=__webpack_require__(23);var _typeof3=_interopRequireDefault(_typeof2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ls=exports.ls={set:function set(key,val){if((typeof val==='undefined'?'undefined':(0,_typeof3.default)(val))==='object'){try{window.localStorage[key]=(0,_stringify2.default)(val);}catch(e){window.localStorage[key]="";}}else{window.localStorage[key]=val;}},getStr:function getStr(key){return window.localStorage[key]||'';},getJSONObj:function getJSONObj(key){if(!window.localStorage[key])return null;try{return JSON.parse(window.localStorage[key]);}catch(e){return{};}}};var ss=exports.ss={set:function set(key,val){if((typeof val==='undefined'?'undefined':(0,_typeof3.default)(val))==='object'){try{window.sessionStorage[key]=(0,_stringify2.default)(val);}catch(e){window.sessionStorage[key]="";}}else{window.sessionStorage[key]=val;}},getStr:function getStr(key){return window.sessionStorage[key]||'';},getJSONObj:function getJSONObj(key){if(!window.sessionStorage[key])return null;try{return JSON.parse(window.sessionStorage[key]);}catch(e){return{};}}};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _class,_temp,_initialiseProps;var _callApi=__webpack_require__(72);var caUtil=_interopRequireWildcard(_callApi);var _html2image=__webpack_require__(500);var _userAgent=__webpack_require__(502);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var callApi=caUtil.callApi;var instance=null;var getHash=function getHash(){return Math.random().toString(36).substr(2,6);};var WaterMark=(_temp=_class=function WaterMark(options){(0,_classCallCheck3.default)(this,WaterMark);_initialiseProps.call(this);var win=this.getWindow(options);if(win.e9WatermarkLoaded)return;win.e9WatermarkLoaded=true;this.loaded=true;this.updateOptions(options);}// 检测options是否有修改
// 判断重新生成dom条件
,_initialiseProps=function _initialiseProps(){var _this=this;this.type="text";this.len=0;this.html="";this.timer=null;this.destoryed=false;this.wrapId="wea_watermark_wrap";this.prefixCls="wea_watermark";this.options={// text / img
text:"WATERMARK",fontStyle:"font-size:18px;color:#000;",src:"",width:200,height:150,rotate:-15,alpha:0.15,interval:2000,intervalCheck:true,clickCheck:true};this.updateOptions=function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(!_this.loaded)return;if(!_this.checkOptions(options))return;_this.destoryed=false;_this.setOptions(options);_this.canvas=new _html2image.WaterMarkCanvas(options);_this.update();};this.checkOptions=function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var flag=false;for(var key in options){if(options.hasOwnProperty(key)){if(options[key]!==_this.options[key]){flag=true;break;}}}return flag;};this.handleClick=function(){if(_this.checkChange()){_this.update();}else if(_this.checkCanvasChange()){_this.rerenderCanvas();}};this.des=function(){clearInterval(_this.timer);if(_this.observeDomInstance)_this.observeDomInstance.disconnect();if(_this.window&&_this.window.e9WatermarkLoaded){_this.destoryed=true;window.top.onresize=undefined;_this.window.e9WatermarkLoaded=false;_this.doc.removeEventListener("click",_this.handleClick);_this.removeEle(_this.wrapId);_this.removeEle(_this.canvasImgCls);}};this.removeEle=function(selectorId){var ele=_this.doc.getElementById(selectorId);if(ele){_this.doc.body.removeChild(ele);}};this.checkChange=function(){var wrap=_this.doc.getElementById(_this.wrapId);return!wrap||wrap.innerHTML!==_this.html;};this.checkCanvasChange=function(){var canvasImg=_this.doc.getElementById(_this.canvasImgCls);return _this.canvasImg&&(!canvasImg||canvasImg!==_this.canvasImg);};this.getWindow=function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var win=void 0;if(options.window&&options.window.document&&options.window.document.body){win=options.window;}win=win||window.top;return win;};this.setOptions=function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this.options=(0,_extends3.default)({},_this.options,options);var _options=_this.options,intervalCheck=_options.intervalCheck,interval=_options.interval,clickCheck=_options.clickCheck;_this.window=_this.getWindow(_this.options);_this.doc=_this.window.document;if(_this.timer){clearInterval(_this.timer);}if(intervalCheck){_this.timer=setInterval(function(){return _this.handleClick();},interval);}if(clickCheck){_this.doc.addEventListener("click",_this.handleClick);}else{_this.doc.removeEventListener("click",_this.handleClick);}window.top.onresize=function(){_this.update(_this.options);};// 给当前页面添加关闭销毁事件
window.onunload=function(){_this.des();};return true;};this.isUpdate=function(marks){var _options2=_this.options,alpha=_options2.alpha,rotate=_options2.rotate;if(!marks||marks.length===0){// 初始化
return true;}else if(marks.length!=_this.len){// 修改宽高的值
return true;}else if(marks[0].style.transform!=="rotate("+rotate+"deg)"){// 修改旋转角度
return true;}else if(marks[0].style.opacity!==alpha){// 修改透明度
return true;}return false;};this.update=function(type){var _options3=_this.options,src=_options3.src,alpha=_options3.alpha,rotate=_options3.rotate,text=_options3.text,fontStyle=_options3.fontStyle;if(_this.destoryed)return;var _options4=_this.options,width=_options4.width,height=_options4.height;width=width>0?width:200;height=height>0?height:150;var wrap=_this.doc.getElementById(_this.wrapId);if(wrap){// 每次更新时需要将原先的水印节点去掉，重新生成水印
_this.removeEle(_this.wrapId);}wrap=_this.doc.createElement("div");wrap.id=_this.wrapId;wrap.style.position="relative";wrap.style.overflow="hidden";_this.doc.body.appendChild(wrap);var bg=_this.doc.getElementById(_this.prefixCls);if(!bg){bg=_this.doc.createElement("div");bg.id=_this.prefixCls;bg.style.display="block";bg.style.pointerEvents="none";bg.style.position="absolute";// bg.style.width = "100%";
// bg.style.height = "100%";
bg.style.zIndex=99999;bg.style.top=0;bg.style.left=0;bg.style.textAlign="center";wrap.appendChild(bg);}// 检测图片是否有效
if(src&&type!=="text"){_this.type="img";var img=_this.doc.getElementById("wea_watremark_img_test");if(!img){img=_this.doc.createElement("img");img.id="wea_watremark_img_test";img.style.display="none";img.onerror=function(){_this.type="text";_this.update(_this.type);};_this.doc.body.appendChild(img);}img.src=src;}else{_this.type="text";}var w=_this.doc.documentElement.clientWidth;var h=_this.doc.documentElement.clientHeight;var x=Math.ceil(w/width);var y=Math.ceil(h/height);_this.len=x*y+2;var marks=_this.doc.querySelectorAll(".wea-watremark-mark");if(_this.isUpdate(marks)){bg.innerHTML="";for(var i=0;i<_this.len;i++){var mark=_this.doc.createElement("div");mark.className="wea-watremark-mark";mark.style.width=width+"px";mark.style.height=height+"px";mark.style.pointerEvents="none";mark.style.zIndex=-1;mark.style.float="left";mark.style.overflow="visible";mark.style.opacity=alpha;mark.style.transform="rotate("+rotate+"deg)";mark.style["-ms-transform"]="rotate("+rotate+"deg)";mark.style.position="relative";bg.appendChild(mark);}marks=_this.doc.querySelectorAll(".wea-watremark-mark");}Array.prototype.forEach.call(marks,function(m,i){if((i+1)%x===0){m.style.marginRight="-"+width+"px";}else{m.style.marginRight="0";}if(_this.type==="text"){m.innerHTML="<div style=\"width:100%;position:absolute;top:50%;transform:translateY(-50%);\"><p style=\"pointer-events:none;"+fontStyle+"\">"+text+"</p></div>";}else{m.innerHTML="<img class=\"wea_watremark_img\" alt=\"\" src=\""+src+"\" style=\"position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);pointer-events:none;max-width:100%;max-height:100%;\"></img>";}});_this.html=wrap.innerHTML;_this.updateCanvas();};this.updateCanvas=function(){_this.canvas.loadWatermarkWithCanvas(_this.prefixCls,_this.doc,_this.renderCanvasImg);};this.rerenderCanvas=function(){_this.canvas.loadWatermarkToImage(undefined,_this.doc,_this.renderCanvasImg);};this.renderCanvasImg=function(imgEle){if(!imgEle||_this.destoryed)return;if(_this.observeDomInstance)_this.observeDomInstance.disconnect();_this.removeEle(_this.canvasImgCls);_this.canvasImgCls=_this.prefixCls+"_"+getHash();imgEle.id=_this.canvasImgCls;_this.canvasImg=imgEle;_this.doc.body.appendChild(imgEle);_html2image.WaterMarkCanvas.wait(function(){return _this.doc.getElementById(_this.canvasImgCls);},function(){_this.observeDomInstance=_this.observeDom(_this.canvasImgCls,undefined,function(){_this.rerenderCanvas();});});};this.observeDom=function(selectorId,config,callback){// Firefox和Chrome早期版本中带有前缀
var MutationObserver=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver;// 选择目标节点
var target=_this.doc.getElementById(selectorId);// 创建观察者对象
var observer=new MutationObserver(callback);// 配置观察选项:
config=config||{attributes:true,childList:false,characterData:false};// 传入目标节点和观察选项
observer.observe(target,config);// 随后,你还可以停止观察
// observer.disconnect();
return observer;};},_temp);var WM=function WM(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(instance){instance.updateOptions(options);}else{instance=new WaterMark(options);}};// 清除水印
WM.destory=function(){if(instance){instance.des();instance=null;}};// 格式化文档水印文本内容
function formatContent(options){var text=options.wmcontent||"";var fontStyle="font-family:"+(options.familyname||"微软雅黑")+";font-size:"+(options.fontsize||14)+"px;color:"+(options.color||"#000")+";text-align:"+(options.align||"left");// let lines = "";
// 处理多行文本的换行
// text
//   .split("\n")
//   .forEach(line => (lines += `<p style="${fontStyle}">` + line + "</p>"));
// text = lines;
text=text.replace(/<p>/g,"<p style=\""+fontStyle+"\">");return text;}// 处理水印设置内容
var handleWMSetting=function handleWMSetting(){var wmSetting=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var rotate=-Number(wmSetting.rotate);var alpha=Number(wmSetting.opacity)/100;var options={src:wmSetting.watermarktype=="2"?(window.ecologyContentPath||"")+"/weaver/weaver.file.FileDownload?fileid="+wmSetting.imageid:"",text:wmSetting.watermarktype=="1"?params&&params.document?formatContent(wmSetting):wmSetting.wmcontent:"",width:wmSetting.wmwidth>0?wmSetting.wmwidth:200,height:wmSetting.wmheight>0?wmSetting.wmheight:150,rotate:rotate,alpha:alpha};return options;};// 处理水印黑白名单规则
var handleSettingByHash=function handleSettingByHash(wmSetting){var pathname=window.location.pathname||"";var hash=window.location.hash||"";var index=hash.indexOf("?");index=index!==-1?index:hash.length-1;var href=pathname+hash.substring(0,index);if(wmSetting){var isopen=wmSetting.isopen,whitelist=wmSetting.whitelist,blacklist=wmSetting.blacklist;var list=isopen===1||isopen==="1"?blacklist:whitelist;var match=(list||[]).findIndex(function(value){return new RegExp(value).test(href);});if(match!==-1){isopen===1||isopen==="1"?WM.destory():WM(handleWMSetting(wmSetting));}else{isopen===1||isopen==="1"?WM(handleWMSetting(wmSetting)):WM.destory();}}};// 设置系统默认全局水印
WM.getSystemSetting=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cb=arguments[1];if(_userAgent.ua.browser==="IE"&&parseInt(_userAgent.ua.version,10)<11)return;callApi("/api/doc/console/wmsystemsetting/getwmsetting?isconvert=1","GET",params).then(cb&&typeof cb==="function"?cb:function(res){var wmSetting=res.wmSetting;WM.wmSetting=wmSetting;handleSettingByHash(wmSetting);}).catch(function(){});};// 处理hash变化
var handleHashChange=function handleHashChange(){handleSettingByHash(WM.wmSetting);};// 监听哈希变化
if("onhashchange"in window){if(window.addEventListener){window.removeEventListener("hashchange",handleHashChange);window.addEventListener("hashchange",handleHashChange);}else if(window.attachEvent){window.detachEvent("onhashchange",handleHashChange);window.attachEvent("onhashchange",handleHashChange);}else{window.onhashchange=handleHashChange;}}WM.handleHashChange=handleHashChange;WM.handleWMSetting=handleWMSetting;WM.handleSettingByHash=handleSettingByHash;WM.formatContent=formatContent;WM.WaterMarkClass=WaterMark;exports.default=WM;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Canvas2Image=exports.WaterMarkCanvas=undefined;var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _class,_temp;var _html2canvas=__webpack_require__(501);var _html2canvas2=_interopRequireDefault(_html2canvas);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WaterMarkCanvas=exports.WaterMarkCanvas=(_temp=_class=function WaterMarkCanvas(options){var _this=this;(0,_classCallCheck3.default)(this,WaterMarkCanvas);this.drawCanvas=function(){//Draw canvas
var canvas=document.createElement("canvas");canvas.style.width=WaterMarkCanvas.CANVAS_WIDTH+"px";canvas.style.height=WaterMarkCanvas.CANVAS_HEIGHT+"px";canvas.width=WaterMarkCanvas.CANVAS_WIDTH;canvas.height=WaterMarkCanvas.CANVAS_HEIGHT;canvas.id=_this.wmId;canvas.style.display="block";canvas.style.pointerEvents="none";canvas.style.position="fixed";canvas.style.zIndex=99999;canvas.style.top=0;canvas.style.left=0;canvas.style.textAlign="center";return canvas;};this.drawTextWatermark=function(options){var windowWidth=window.innerWidth;var windowHeight=window.innerHeight;var canvas=_this.drawCanvas();var ctx=canvas.getContext("2d");ctx.clearRect(0,0,WaterMarkCanvas.CANVAS_WIDTH,WaterMarkCanvas.CANVAS_HEIGHT);ctx.save();ctx.scale(WaterMarkCanvas.CANVAS_WIDTH/windowWidth,WaterMarkCanvas.CANVAS_HEIGHT/windowHeight);var width=_this.options.width>0?_this.options.width:200;var height=_this.options.height>0?_this.options.height:150;var rotate=(_this.options.rotate||0)/360*Math.PI;var text=_this.options.text;var w=WaterMarkCanvas.CANVAS_WIDTH;var h=WaterMarkCanvas.CANVAS_HEIGHT;var x=Math.ceil(w/width);var y=Math.ceil(h/height);ctx.textAlign="center";// ctx.font= 'px yahei';
ctx.globalAlpha=_this.options.alpha;ctx.rotate(rotate);for(var i=0;i<x;i+=1){for(var j=0;j<y;j+=1){ctx.fillText(text,i*width,j*height,width);}}ctx.restore();document.body.appendChild(canvas);};this.loadWatermarkWithCanvas=function(watermarkContentId,layout,callback){layout=layout||document;WaterMarkCanvas.wait(function(){return layout.getElementById(watermarkContentId);},function(){var getPixelRatio=function getPixelRatio(context){// 闁兼儳鍢茶ぐ鍥╂媼閹屾У闁汇劌鍤xelRatio
var backingStore=context.backingStorePixelRatio||context.webkitBackingStorePixelRatio||context.mozBackingStorePixelRatio||context.msBackingStorePixelRatio||context.oBackingStorePixelRatio||context.backingStorePixelRatio||1;return(window.devicePixelRatio||1)/backingStore;};var shareContent=layout.getElementById(watermarkContentId);var width=shareContent.offsetWidth;var height=shareContent.offsetHeight;var canvas=document.createElement("canvas");var context=canvas.getContext("2d");// 閻忓繐鎽禷nvas闁汇劌瀚鎰板闯閵婏箑鈷栧棰濇箳ixelRatio闁稿﹤绋勭槐婵嬪礃瀹ュ懐娈洪柣銏ｎ嚙缁旈绱撻埡鍌涙澒闁挎稑鑻惃銏ゅ炊閹冨壖闁衡偓閹佷海PixelRatio闁稿﹤绋勭槐婵嬫⒓閸欏鍓鹃悗鐢靛帶閸ゎ參鎯冮崟顐ｇ闁绘娲﹁啯缂侇垽鎷�
var scale=getPixelRatio(context);context.scale(scale,scale);WaterMarkCanvas.setWAH(canvas,width*scale,height*scale);var opts={backgroundColor:null,scale:scale,canvas:canvas,width:width,height:height,useCORS:true,dpi:window.devicePixelRatio,ignoreElements:function ignoreElements(element){/* 鏉╁洦鎶ら崶鍓у娑撳娴囬幓鎺嶆閻ㄥ埇frame閿涘矂妲诲銏犳禈閻楀洭鍣告径宥勭瑓鏉炰粙妫舵０锟� */if(element.id=="downloadFrame"){return true;}/* 去除非水印的图片元素，防止验证码图片重复请求 */if(element.tagName==="IMG"&&element.className!=="wea_watremark_img"){return true;}if(element.nodeName==="IFRAME"){/* 过滤 EMobile 聊天工具 */if(element.className==="eMobile-iframe"){return true;}/* 过滤iframe的src中带接口的，一般为下载工具 */if(element.src&&/\/api\//.test(element.src)){return true;}}}};(0,_html2canvas2.default)(shareContent,opts).then(function(canvas){_this.canvas=canvas;var context=canvas.getContext("2d");// 闁稿繑濞婂Λ鎾箮濡ゅ懏鏆滃璇茬仢閼革拷
context.mozImageSmoothingEnabled=false;context.webkitImageSmoothingEnabled=false;context.msImageSmoothingEnabled=false;context.imageSmoothingEnabled=false;_this.cache.width=width;_this.cache.height=height;_this.cache.scale=scale;_this.loadWatermarkToImage(canvas,callback);});});};this.loadWatermarkToImage=function(canvas,callback){canvas=canvas||_this.canvas;// canvas閺夌儐鍓欑€靛弶绋夐崫鍕闁绘鎷�
var newImg=Canvas2Image.convertToImage(canvas);// 缂備焦鐟ュù姗€鎮ч崶顏嶅晭缂傚喚鍠栫敮顐ｆ叏鐎ｎ剚鐣遍悗閫涚矙閻濓拷
newImg.style.all="initial";WaterMarkCanvas.setWAH(newImg,_this.cache.width,_this.cache.height);WaterMarkCanvas.setStyle(newImg,{display:"block",pointerEvents:"none",textAlign:"center",position:"fixed",zIndex:99999,top:0,left:0});if(callback)callback(newImg,canvas);};this.wmId="wea_watremark_"+parseInt(Math.random()*1000);this.options=options;this.cache={};}// 缂備焦锚閸╂anvas闁哄秴鍢茬槐锟�
// 缂備焦锚閸╂寮崶銊︽嫳婵ɑ娼欏畵锟�
// 閻忓繐妫欑€垫氨鈧鐡皁m闁稿繐鍟扮粈锟�闁汇垻鍠愰崹姝漚nvas闁搞儱澧芥晶锟�
,_class.CANVAS_WIDTH=1600,_class.CANVAS_HEIGHT=900,_class.setStyle=function(ele,style){if(!ele||!ele.style)return;for(var styleKey in style){if(style.hasOwnProperty(styleKey)){ele.style[styleKey]=style[styleKey];}}},_class.setWAH=function(ele,width,height){if(!ele)return;ele.width=width;ele.height=height;ele.style.width=width+"px";ele.style.height=height+"px";},_class.wait=function(getEle,func,times,interval){if(typeof getEle!=="function")return;var _times=times||-1,//100婵炲棴鎷�
_interval=interval||20,//20婵綆鍋嗛～妤€袙韫囨棏鍋�
_self=this,_iIntervalID;//閻庤纰嶅鍌炲闯閳侯櫔
if(getEle()){//濠碘€冲€归悘澶婎啅閼碱剛鐥呴柤鎯у槻瑜板洭宕氭０浣哄晩闁挎稑鑻銊╂儎鐎涙ê澶嶉柟绗涘棭鏀介柛鎴ｅГ閺嗭拷
func&&func.call(this);}else{_iIntervalID=setInterval(function(){if(!_times){//闁哄嫸鎷�0閻忓繘浜堕埀顑藉亾闁告埊鎷�
clearInterval(_iIntervalID);}_times<=0||_times--;//濠碘€冲€归悘澶愬及椤栨侗鍔€闁轰焦婢樺锟� --
if(getEle()){// 闁告劕绉甸濂告焻婢跺顏�,闁告帇鍊栭弻鍥及椤栨碍鍎婇柛娆愮墪閸╋拷
func&&func.call(_self);clearInterval(_iIntervalID);}},_interval);}return this;},_temp);/**
 * covert canvas to image
 * and save the image file
 */var Canvas2Image=exports.Canvas2Image=function(){// check if support sth.
var $support=function(){var canvas=document.createElement("canvas"),ctx=canvas.getContext("2d");return{canvas:!!ctx,imageData:!!ctx.getImageData,dataURL:!!canvas.toDataURL,btoa:!!window.btoa};}();var downloadMime="image/octet-stream";function scaleCanvas(canvas,width,height){var w=canvas.width,h=canvas.height;if(width==undefined){width=w;}if(height==undefined){height=h;}var retCanvas=document.createElement("canvas");var retCtx=retCanvas.getContext("2d");retCanvas.width=width;retCanvas.height=height;retCtx.drawImage(canvas,0,0,w,h,0,0,width,height);return retCanvas;}function getDataURL(canvas,type,width,height){canvas=scaleCanvas(canvas,width,height);return canvas.toDataURL(type);}function saveFile(strData){document.location.href=strData;}function genImage(strData){var img=document.createElement("img");img.src=strData;return img;}function fixType(type){type=type.toLowerCase().replace(/jpg/i,"jpeg");var r=type.match(/png|jpeg|bmp|gif/)[0];return"image/"+r;}function encodeData(data){if(!window.btoa){throw"btoa undefined";}var str="";if(typeof data=="string"){str=data;}else{for(var i=0;i<data.length;i++){str+=String.fromCharCode(data[i]);}}return btoa(str);}function getImageData(canvas){var w=canvas.width,h=canvas.height;return canvas.getContext("2d").getImageData(0,0,w,h);}function makeURI(strData,type){return"data:"+type+";base64,"+strData;}/**
   * create bitmap image
   * 闂佸湱枪椤﹂亶宕ｆ惔锝嗗枂闁告洦鍋勯悘鐔兼煟閵忋垹鏋戦柛銊﹀哺瀹曞爼宕滆椤ｅ鏌涘┑鍡櫺㈢紒銊ュ级瀵板嫰寮堕幋鐐差伅闂佸憡绻傜粔瀵歌姳閸欏濯撮柨鐕傛嫹
   */var genBitmapImage=function genBitmapImage(oData){//
// BITMAPFILEHEADER: http://msdn.microsoft.com/en-us/library/windows/desktop/dd183374(v=vs.85).aspx
// BITMAPINFOHEADER: http://msdn.microsoft.com/en-us/library/dd183376.aspx
//
var biWidth=oData.width;var biHeight=oData.height;var biSizeImage=biWidth*biHeight*3;var bfSize=biSizeImage+54;// total header size = 54 bytes
//
//  typedef struct tagBITMAPFILEHEADER {
//  	WORD bfType;
//  	DWORD bfSize;
//  	WORD bfReserved1;
//  	WORD bfReserved2;
//  	DWORD bfOffBits;
//  } BITMAPFILEHEADER;
//
var BITMAPFILEHEADER=[// WORD bfType -- The file type signature; must be "BM"
0x42,0x4d,// DWORD bfSize -- The size, in bytes, of the bitmap file
bfSize&0xff,bfSize>>8&0xff,bfSize>>16&0xff,bfSize>>24&0xff,// WORD bfReserved1 -- Reserved; must be zero
0,0,// WORD bfReserved2 -- Reserved; must be zero
0,0,// DWORD bfOffBits -- The offset, in bytes, from the beginning of the BITMAPFILEHEADER structure to the bitmap bits.
54,0,0,0];//
//  typedef struct tagBITMAPINFOHEADER {
//  	DWORD biSize;
//  	LONG  biWidth;
//  	LONG  biHeight;
//  	WORD  biPlanes;
//  	WORD  biBitCount;
//  	DWORD biCompression;
//  	DWORD biSizeImage;
//  	LONG  biXPelsPerMeter;
//  	LONG  biYPelsPerMeter;
//  	DWORD biClrUsed;
//  	DWORD biClrImportant;
//  } BITMAPINFOHEADER, *PBITMAPINFOHEADER;
//
var BITMAPINFOHEADER=[// DWORD biSize -- The number of bytes required by the structure
40,0,0,0,// LONG biWidth -- The width of the bitmap, in pixels
biWidth&0xff,biWidth>>8&0xff,biWidth>>16&0xff,biWidth>>24&0xff,// LONG biHeight -- The height of the bitmap, in pixels
biHeight&0xff,biHeight>>8&0xff,biHeight>>16&0xff,biHeight>>24&0xff,// WORD biPlanes -- The number of planes for the target device. This value must be set to 1
1,0,// WORD biBitCount -- The number of bits-per-pixel, 24 bits-per-pixel -- the bitmap
// has a maximum of 2^24 colors (16777216, Truecolor)
24,0,// DWORD biCompression -- The type of compression, BI_RGB (code 0) -- uncompressed
0,0,0,0,// DWORD biSizeImage -- The size, in bytes, of the image. This may be set to zero for BI_RGB bitmaps
biSizeImage&0xff,biSizeImage>>8&0xff,biSizeImage>>16&0xff,biSizeImage>>24&0xff,// LONG biXPelsPerMeter, unused
0,0,0,0,// LONG biYPelsPerMeter, unused
0,0,0,0,// DWORD biClrUsed, the number of color indexes of palette, unused
0,0,0,0,// DWORD biClrImportant, unused
0,0,0,0];var iPadding=(4-biWidth*3%4)%4;var aImgData=oData.data;var strPixelData="";var biWidth4=biWidth<<2;var y=biHeight;var fromCharCode=String.fromCharCode;do{var iOffsetY=biWidth4*(y-1);var strPixelRow="";for(var x=0;x<biWidth;x++){var iOffsetX=x<<2;strPixelRow+=fromCharCode(aImgData[iOffsetY+iOffsetX+2])+fromCharCode(aImgData[iOffsetY+iOffsetX+1])+fromCharCode(aImgData[iOffsetY+iOffsetX]);}for(var c=0;c<iPadding;c++){strPixelRow+=String.fromCharCode(0);}strPixelData+=strPixelRow;}while(--y);var strEncoded=encodeData(BITMAPFILEHEADER.concat(BITMAPINFOHEADER))+encodeData(strPixelData);return strEncoded;};/**
   * saveAsImage
   * @param canvasElement
   * @param {String} image type
   * @param {Number} [optional] png width
   * @param {Number} [optional] png height
   */var saveAsImage=function saveAsImage(canvas,width,height,type){if($support.canvas&&$support.dataURL){if(typeof canvas=="string"){canvas=document.getElementById(canvas);}if(type==undefined){type="png";}type=fixType(type);if(/bmp/.test(type)){var data=getImageData(scaleCanvas(canvas,width,height));var strData=genBitmapImage(data);saveFile(makeURI(strData,downloadMime));}else{var strData=getDataURL(canvas,type,width,height);saveFile(strData.replace(type,downloadMime));}}};var convertToImage=function convertToImage(canvas,width,height,type){if($support.canvas&&$support.dataURL){if(typeof canvas=="string"){canvas=document.getElementById(canvas);}if(type==undefined){type="png";}type=fixType(type);if(/bmp/.test(type)){var data=getImageData(scaleCanvas(canvas,width,height));var strData=genBitmapImage(data);return genImage(makeURI(strData,"image/bmp"));}else{var strData=getDataURL(canvas,type,width,height);return genImage(strData);}}};return{saveAsImage:saveAsImage,saveAsPNG:function saveAsPNG(canvas,width,height){return saveAsImage(canvas,width,height,"png");},saveAsJPEG:function saveAsJPEG(canvas,width,height){return saveAsImage(canvas,width,height,"jpeg");},saveAsGIF:function saveAsGIF(canvas,width,height){return saveAsImage(canvas,width,height,"gif");},saveAsBMP:function saveAsBMP(canvas,width,height){return saveAsImage(canvas,width,height,"bmp");},convertToImage:convertToImage,convertToPNG:function convertToPNG(canvas,width,height){return convertToImage(canvas,width,height,"png");},convertToJPEG:function convertToJPEG(canvas,width,height){return convertToImage(canvas,width,height,"jpeg");},convertToGIF:function convertToGIF(canvas,width,height){return convertToImage(canvas,width,height,"gif");},convertToBMP:function convertToBMP(canvas,width,height){return convertToImage(canvas,width,height,"bmp");}};}();

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * html2canvas 1.0.0-rc.7 <https://html2canvas.hertzen.com>
 * Copyright (c) 2020 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = global || self, global.html2canvas = factory());
}(this, function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    var Bounds = /** @class */ (function () {
        function Bounds(x, y, w, h) {
            this.left = x;
            this.top = y;
            this.width = w;
            this.height = h;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (clientRect) {
            return new Bounds(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
        };
        return Bounds;
    }());
    var parseBounds = function (node) {
        return Bounds.fromClientRect(node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 1.1.1 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2019 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup[base64.charCodeAt(i)];
            encoded2 = lookup[base64.charCodeAt(i + 1)];
            encoded3 = lookup[base64.charCodeAt(i + 2)];
            encoded4 = lookup[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    var base64 = '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';

    /* @flow */
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR = 2; //  Cause a line break (after), except between CR and LF
    var LF = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var UnicodeTrie = createTrieFromBase64(base64);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR, LF, NL];
    var SPACE = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indicies = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indicies.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indicies.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indicies.push(indicies[index - 1]);
                    return types.push(prev);
                }
                indicies.push(index);
                return types.push(AL);
            }
            indicies.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indicies, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED;
        }
        // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.
        if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ && (next === ID || next === EB || next === EM)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.
        if (next === IN && ALPHABETICS.concat(IN, EX, NU, ID, EB, EM).indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI && next === RI) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED) { }
                if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var TokenType;
    (function (TokenType) {
        TokenType[TokenType["STRING_TOKEN"] = 0] = "STRING_TOKEN";
        TokenType[TokenType["BAD_STRING_TOKEN"] = 1] = "BAD_STRING_TOKEN";
        TokenType[TokenType["LEFT_PARENTHESIS_TOKEN"] = 2] = "LEFT_PARENTHESIS_TOKEN";
        TokenType[TokenType["RIGHT_PARENTHESIS_TOKEN"] = 3] = "RIGHT_PARENTHESIS_TOKEN";
        TokenType[TokenType["COMMA_TOKEN"] = 4] = "COMMA_TOKEN";
        TokenType[TokenType["HASH_TOKEN"] = 5] = "HASH_TOKEN";
        TokenType[TokenType["DELIM_TOKEN"] = 6] = "DELIM_TOKEN";
        TokenType[TokenType["AT_KEYWORD_TOKEN"] = 7] = "AT_KEYWORD_TOKEN";
        TokenType[TokenType["PREFIX_MATCH_TOKEN"] = 8] = "PREFIX_MATCH_TOKEN";
        TokenType[TokenType["DASH_MATCH_TOKEN"] = 9] = "DASH_MATCH_TOKEN";
        TokenType[TokenType["INCLUDE_MATCH_TOKEN"] = 10] = "INCLUDE_MATCH_TOKEN";
        TokenType[TokenType["LEFT_CURLY_BRACKET_TOKEN"] = 11] = "LEFT_CURLY_BRACKET_TOKEN";
        TokenType[TokenType["RIGHT_CURLY_BRACKET_TOKEN"] = 12] = "RIGHT_CURLY_BRACKET_TOKEN";
        TokenType[TokenType["SUFFIX_MATCH_TOKEN"] = 13] = "SUFFIX_MATCH_TOKEN";
        TokenType[TokenType["SUBSTRING_MATCH_TOKEN"] = 14] = "SUBSTRING_MATCH_TOKEN";
        TokenType[TokenType["DIMENSION_TOKEN"] = 15] = "DIMENSION_TOKEN";
        TokenType[TokenType["PERCENTAGE_TOKEN"] = 16] = "PERCENTAGE_TOKEN";
        TokenType[TokenType["NUMBER_TOKEN"] = 17] = "NUMBER_TOKEN";
        TokenType[TokenType["FUNCTION"] = 18] = "FUNCTION";
        TokenType[TokenType["FUNCTION_TOKEN"] = 19] = "FUNCTION_TOKEN";
        TokenType[TokenType["IDENT_TOKEN"] = 20] = "IDENT_TOKEN";
        TokenType[TokenType["COLUMN_TOKEN"] = 21] = "COLUMN_TOKEN";
        TokenType[TokenType["URL_TOKEN"] = 22] = "URL_TOKEN";
        TokenType[TokenType["BAD_URL_TOKEN"] = 23] = "BAD_URL_TOKEN";
        TokenType[TokenType["CDC_TOKEN"] = 24] = "CDC_TOKEN";
        TokenType[TokenType["CDO_TOKEN"] = 25] = "CDO_TOKEN";
        TokenType[TokenType["COLON_TOKEN"] = 26] = "COLON_TOKEN";
        TokenType[TokenType["SEMICOLON_TOKEN"] = 27] = "SEMICOLON_TOKEN";
        TokenType[TokenType["LEFT_SQUARE_BRACKET_TOKEN"] = 28] = "LEFT_SQUARE_BRACKET_TOKEN";
        TokenType[TokenType["RIGHT_SQUARE_BRACKET_TOKEN"] = 29] = "RIGHT_SQUARE_BRACKET_TOKEN";
        TokenType[TokenType["UNICODE_RANGE_TOKEN"] = 30] = "UNICODE_RANGE_TOKEN";
        TokenType[TokenType["WHITESPACE_TOKEN"] = 31] = "WHITESPACE_TOKEN";
        TokenType[TokenType["EOF_TOKEN"] = 32] = "EOF_TOKEN";
    })(TokenType || (TokenType = {}));
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE$1 = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE$1;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: TokenType.LEFT_PARENTHESIS_TOKEN
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: TokenType.RIGHT_PARENTHESIS_TOKEN
    };
    var COMMA_TOKEN = { type: TokenType.COMMA_TOKEN };
    var SUFFIX_MATCH_TOKEN = { type: TokenType.SUFFIX_MATCH_TOKEN };
    var PREFIX_MATCH_TOKEN = { type: TokenType.PREFIX_MATCH_TOKEN };
    var COLUMN_TOKEN = { type: TokenType.COLUMN_TOKEN };
    var DASH_MATCH_TOKEN = { type: TokenType.DASH_MATCH_TOKEN };
    var INCLUDE_MATCH_TOKEN = { type: TokenType.INCLUDE_MATCH_TOKEN };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: TokenType.LEFT_CURLY_BRACKET_TOKEN
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: TokenType.RIGHT_CURLY_BRACKET_TOKEN
    };
    var SUBSTRING_MATCH_TOKEN = { type: TokenType.SUBSTRING_MATCH_TOKEN };
    var BAD_URL_TOKEN = { type: TokenType.BAD_URL_TOKEN };
    var BAD_STRING_TOKEN = { type: TokenType.BAD_STRING_TOKEN };
    var CDO_TOKEN = { type: TokenType.CDO_TOKEN };
    var CDC_TOKEN = { type: TokenType.CDC_TOKEN };
    var COLON_TOKEN = { type: TokenType.COLON_TOKEN };
    var SEMICOLON_TOKEN = { type: TokenType.SEMICOLON_TOKEN };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: TokenType.LEFT_SQUARE_BRACKET_TOKEN
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: TokenType.RIGHT_SQUARE_BRACKET_TOKEN
    };
    var WHITESPACE_TOKEN = { type: TokenType.WHITESPACE_TOKEN };
    var EOF_TOKEN = { type: TokenType.EOF_TOKEN };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: TokenType.HASH_TOKEN, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: TokenType.AT_KEYWORD_TOKEN, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: TokenType.DELIM_TOKEN, value: fromCodePoint(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint.apply(void 0, endDigits), 16);
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start, end: end };
            }
            else {
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: TokenType.FUNCTION_TOKEN, value: value };
            }
            return { type: TokenType.IDENT_TOKEN, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: TokenType.URL_TOKEN, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === TokenType.STRING_TOKEN) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: TokenType.URL_TOKEN, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: TokenType.URL_TOKEN, value: fromCodePoint.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: TokenType.URL_TOKEN, value: fromCodePoint.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 60000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: TokenType.STRING_TOKEN, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: TokenType.DIMENSION_TOKEN, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: TokenType.PERCENTAGE_TOKEN, number: number, flags: flags };
            }
            return { type: TokenType.NUMBER_TOKEN, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === TokenType.WHITESPACE_TOKEN) {
                token = this.consumeToken();
            }
            if (token.type === TokenType.EOF_TOKEN) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === TokenType.WHITESPACE_TOKEN);
            if (token.type === TokenType.EOF_TOKEN) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === TokenType.EOF_TOKEN) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case TokenType.LEFT_CURLY_BRACKET_TOKEN:
                case TokenType.LEFT_SQUARE_BRACKET_TOKEN:
                case TokenType.LEFT_PARENTHESIS_TOKEN:
                    return this.consumeSimpleBlock(token.type);
                case TokenType.FUNCTION_TOKEN:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === TokenType.EOF_TOKEN || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: TokenType.FUNCTION
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === TokenType.EOF_TOKEN || token.type === TokenType.RIGHT_PARENTHESIS_TOKEN) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === TokenType.DIMENSION_TOKEN; };
    var isNumberToken = function (token) { return token.type === TokenType.NUMBER_TOKEN; };
    var isIdentToken = function (token) { return token.type === TokenType.IDENT_TOKEN; };
    var isStringToken = function (token) { return token.type === TokenType.STRING_TOKEN; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== TokenType.WHITESPACE_TOKEN; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== TokenType.WHITESPACE_TOKEN && token.type !== TokenType.COMMA_TOKEN;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === TokenType.COMMA_TOKEN) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== TokenType.WHITESPACE_TOKEN) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === TokenType.LEFT_CURLY_BRACKET_TOKEN && token.type === TokenType.RIGHT_CURLY_BRACKET_TOKEN) {
            return true;
        }
        if (type === TokenType.LEFT_SQUARE_BRACKET_TOKEN && token.type === TokenType.RIGHT_SQUARE_BRACKET_TOKEN) {
            return true;
        }
        return type === TokenType.LEFT_PARENTHESIS_TOKEN && token.type === TokenType.RIGHT_PARENTHESIS_TOKEN;
    };

    var isLength = function (token) {
        return token.type === TokenType.NUMBER_TOKEN || token.type === TokenType.DIMENSION_TOKEN;
    };

    var isLengthPercentage = function (token) {
        return token.type === TokenType.PERCENTAGE_TOKEN || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: TokenType.NUMBER_TOKEN,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === TokenType.PERCENTAGE_TOKEN) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (value) {
            if (value.type === TokenType.DIMENSION_TOKEN) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === TokenType.DIMENSION_TOKEN) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color = {
        name: 'color',
        parse: function (value) {
            if (value.type === TokenType.FUNCTION) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(value.values);
            }
            if (value.type === TokenType.HASH_TOKEN) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === TokenType.IDENT_TOKEN) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === TokenType.NUMBER_TOKEN) {
            return token.number;
        }
        if (token.type === TokenType.PERCENTAGE_TOKEN) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === TokenType.NUMBER_TOKEN ? deg(hue.number) : angle.parse(hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var PropertyDescriptorParsingType;
    (function (PropertyDescriptorParsingType) {
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["VALUE"] = 0] = "VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["LIST"] = 1] = "LIST";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["IDENT_VALUE"] = 2] = "IDENT_VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TYPE_VALUE"] = 3] = "TYPE_VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TOKEN_VALUE"] = 4] = "TOKEN_VALUE";
    })(PropertyDescriptorParsingType || (PropertyDescriptorParsingType = {}));

    var BACKGROUND_CLIP;
    (function (BACKGROUND_CLIP) {
        BACKGROUND_CLIP[BACKGROUND_CLIP["BORDER_BOX"] = 0] = "BORDER_BOX";
        BACKGROUND_CLIP[BACKGROUND_CLIP["PADDING_BOX"] = 1] = "PADDING_BOX";
        BACKGROUND_CLIP[BACKGROUND_CLIP["CONTENT_BOX"] = 2] = "CONTENT_BOX";
    })(BACKGROUND_CLIP || (BACKGROUND_CLIP = {}));
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return BACKGROUND_CLIP.PADDING_BOX;
                        case 'content-box':
                            return BACKGROUND_CLIP.CONTENT_BOX;
                    }
                }
                return BACKGROUND_CLIP.BORDER_BOX;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var parseColorStop = function (args) {
        var color$1 = color.parse(args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color$1, stop: stop } : { color: color$1, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [[0, 0], [0, height], [width, 0], [width, height]];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case CSSRadialExtent.CLOSEST_SIDE:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case CSSRadialExtent.CLOSEST_CORNER:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case CSSRadialExtent.FARTHEST_SIDE:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case CSSRadialExtent.FARTHEST_CORNER:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === TokenType.IDENT_TOKEN && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: CSSImageType.LINEAR_GRADIENT };
    };

    var prefixLinearGradient = function (tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === TokenType.IDENT_TOKEN &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: CSSImageType.LINEAR_GRADIENT
        };
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        }
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, [this.id, this.getTime() + "ms"].concat(args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        Logger.create = function (options) {
            Logger.instances[options.id] = new Logger(options);
        };
        Logger.destroy = function (id) {
            delete Logger.instances[id];
        };
        Logger.getInstance = function (id) {
            var instance = Logger.instances[id];
            if (typeof instance === 'undefined') {
                throw new Error("No logger instance found with id " + id);
            }
            return instance;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, [this.id, this.getTime() + "ms"].concat(args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, [this.id, this.getTime() + "ms"].concat(args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.create = function (name, options) {
            return (CacheStorage._caches[name] = new Cache(name, options));
        };
        CacheStorage.destroy = function (name) {
            delete CacheStorage._caches[name];
        };
        CacheStorage.open = function (name) {
            var cache = CacheStorage._caches[name];
            if (typeof cache !== 'undefined') {
                return cache;
            }
            throw new Error("Cache with key \"" + name + "\" not found");
        };
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage.getInstance = function () {
            var current = CacheStorage._current;
            if (current === null) {
                throw new Error("No cache instance attached");
            }
            return current;
        };
        CacheStorage.attachInstance = function (cache) {
            CacheStorage._current = cache;
        };
        CacheStorage.detachInstance = function () {
            CacheStorage._current = null;
        };
        CacheStorage._caches = {};
        CacheStorage._origin = 'about:blank';
        CacheStorage._current = null;
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(id, options) {
            this.id = id;
            this._options = options;
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                this._cache[src] = this.loadImage(src);
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !useProxy && !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            Logger.getInstance(this.id).debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                xhr.open('GET', proxy + "?url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var webkitGradient = function (tokens) {
        var angle = deg(180);
        var stops = [];
        var type = CSSImageType.LINEAR_GRADIENT;
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = CSSImageType.LINEAR_GRADIENT;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = CSSImageType.RADIAL_GRADIENT;
                    return;
                }
            }
            if (firstToken.type === TokenType.FUNCTION) {
                if (firstToken.name === 'from') {
                    var color$1 = color.parse(firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color$1 });
                }
                else if (firstToken.name === 'to') {
                    var color$1 = color.parse(firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color$1 });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color$1 = color.parse(values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: TokenType.PERCENTAGE_TOKEN, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color$1
                            });
                        }
                    }
                }
            }
        });
        return type === CSSImageType.LINEAR_GRADIENT
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (tokens) {
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = CSSRadialShape.CIRCLE;
                                return false;
                            case ELLIPSE:
                                shape = CSSRadialShape.ELLIPSE;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = CSSRadialExtent.CLOSEST_SIDE;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = CSSRadialExtent.FARTHEST_SIDE;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = CSSRadialExtent.CLOSEST_CORNER;
                                return false;
                            case FARTHEST_CORNER:
                                size = CSSRadialExtent.FARTHEST_CORNER;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: CSSImageType.RADIAL_GRADIENT };
    };

    var prefixRadialGradient = function (tokens) {
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = CSSRadialShape.CIRCLE;
                                return false;
                            case ELLIPSE:
                                shape = CSSRadialShape.ELLIPSE;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = CSSRadialExtent.CLOSEST_SIDE;
                                return false;
                            case FARTHEST_SIDE:
                                size = CSSRadialExtent.FARTHEST_SIDE;
                                return false;
                            case CLOSEST_CORNER:
                                size = CSSRadialExtent.CLOSEST_CORNER;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = CSSRadialExtent.FARTHEST_CORNER;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: CSSImageType.RADIAL_GRADIENT };
    };

    var CSSImageType;
    (function (CSSImageType) {
        CSSImageType[CSSImageType["URL"] = 0] = "URL";
        CSSImageType[CSSImageType["LINEAR_GRADIENT"] = 1] = "LINEAR_GRADIENT";
        CSSImageType[CSSImageType["RADIAL_GRADIENT"] = 2] = "RADIAL_GRADIENT";
    })(CSSImageType || (CSSImageType = {}));
    var isLinearGradient = function (background) {
        return background.type === CSSImageType.LINEAR_GRADIENT;
    };
    var isRadialGradient = function (background) {
        return background.type === CSSImageType.RADIAL_GRADIENT;
    };
    var CSSRadialShape;
    (function (CSSRadialShape) {
        CSSRadialShape[CSSRadialShape["CIRCLE"] = 0] = "CIRCLE";
        CSSRadialShape[CSSRadialShape["ELLIPSE"] = 1] = "ELLIPSE";
    })(CSSRadialShape || (CSSRadialShape = {}));
    var CSSRadialExtent;
    (function (CSSRadialExtent) {
        CSSRadialExtent[CSSRadialExtent["CLOSEST_SIDE"] = 0] = "CLOSEST_SIDE";
        CSSRadialExtent[CSSRadialExtent["FARTHEST_SIDE"] = 1] = "FARTHEST_SIDE";
        CSSRadialExtent[CSSRadialExtent["CLOSEST_CORNER"] = 2] = "CLOSEST_CORNER";
        CSSRadialExtent[CSSRadialExtent["FARTHEST_CORNER"] = 3] = "FARTHEST_CORNER";
    })(CSSRadialExtent || (CSSRadialExtent = {}));
    var image = {
        name: 'image',
        parse: function (value) {
            if (value.type === TokenType.URL_TOKEN) {
                var image_1 = { url: value.value, type: CSSImageType.URL };
                CacheStorage.getInstance().addImage(value.value);
                return image_1;
            }
            if (value.type === TokenType.FUNCTION) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(value.values);
            }
            throw new Error("Unsupported image type");
        }
    };
    function isSupportedImage(value) {
        return value.type !== TokenType.FUNCTION || SUPPORTED_IMAGE_FUNCTIONS[value.name];
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return [];
            }
            return tokens.filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); }).map(image.parse);
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var BACKGROUND_REPEAT;
    (function (BACKGROUND_REPEAT) {
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT"] = 0] = "REPEAT";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["NO_REPEAT"] = 1] = "NO_REPEAT";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_X"] = 2] = "REPEAT_X";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_Y"] = 3] = "REPEAT_Y";
    })(BACKGROUND_REPEAT || (BACKGROUND_REPEAT = {}));
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return BACKGROUND_REPEAT.NO_REPEAT;
            case 'repeat-x':
            case 'repeat no-repeat':
                return BACKGROUND_REPEAT.REPEAT_X;
            case 'repeat-y':
            case 'no-repeat repeat':
                return BACKGROUND_REPEAT.REPEAT_Y;
            case 'repeat':
            default:
                return BACKGROUND_REPEAT.REPEAT;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) { return parseLengthPercentageTuple(tokens.filter(isLengthPercentage)); }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var BORDER_STYLE;
    (function (BORDER_STYLE) {
        BORDER_STYLE[BORDER_STYLE["NONE"] = 0] = "NONE";
        BORDER_STYLE[BORDER_STYLE["SOLID"] = 1] = "SOLID";
    })(BORDER_STYLE || (BORDER_STYLE = {}));
    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (style) {
            switch (style) {
                case 'none':
                    return BORDER_STYLE.NONE;
            }
            return BORDER_STYLE.SOLID;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color$1 = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var FLOAT;
    (function (FLOAT) {
        FLOAT[FLOAT["NONE"] = 0] = "NONE";
        FLOAT[FLOAT["LEFT"] = 1] = "LEFT";
        FLOAT[FLOAT["RIGHT"] = 2] = "RIGHT";
        FLOAT[FLOAT["INLINE_START"] = 3] = "INLINE_START";
        FLOAT[FLOAT["INLINE_END"] = 4] = "INLINE_END";
    })(FLOAT || (FLOAT = {}));
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (float) {
            switch (float) {
                case 'left':
                    return FLOAT.LEFT;
                case 'right':
                    return FLOAT.RIGHT;
                case 'inline-start':
                    return FLOAT.INLINE_START;
                case 'inline-end':
                    return FLOAT.INLINE_END;
            }
            return FLOAT.NONE;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'normal') {
                return 0;
            }
            if (token.type === TokenType.NUMBER_TOKEN) {
                return token.number;
            }
            if (token.type === TokenType.DIMENSION_TOKEN) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.TOKEN_VALUE
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === TokenType.NUMBER_TOKEN) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'none') {
                return null;
            }
            return image.parse(token);
        }
    };

    var LIST_STYLE_POSITION;
    (function (LIST_STYLE_POSITION) {
        LIST_STYLE_POSITION[LIST_STYLE_POSITION["INSIDE"] = 0] = "INSIDE";
        LIST_STYLE_POSITION[LIST_STYLE_POSITION["OUTSIDE"] = 1] = "OUTSIDE";
    })(LIST_STYLE_POSITION || (LIST_STYLE_POSITION = {}));
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (position) {
            switch (position) {
                case 'inside':
                    return LIST_STYLE_POSITION.INSIDE;
                case 'outside':
                default:
                    return LIST_STYLE_POSITION.OUTSIDE;
            }
        }
    };

    var LIST_STYLE_TYPE;
    (function (LIST_STYLE_TYPE) {
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["NONE"] = -1] = "NONE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISC"] = 0] = "DISC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CIRCLE"] = 1] = "CIRCLE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SQUARE"] = 2] = "SQUARE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL"] = 3] = "DECIMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_DECIMAL"] = 4] = "CJK_DECIMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL_LEADING_ZERO"] = 5] = "DECIMAL_LEADING_ZERO";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ROMAN"] = 6] = "LOWER_ROMAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ROMAN"] = 7] = "UPPER_ROMAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_GREEK"] = 8] = "LOWER_GREEK";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ALPHA"] = 9] = "LOWER_ALPHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ALPHA"] = 10] = "UPPER_ALPHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARABIC_INDIC"] = 11] = "ARABIC_INDIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARMENIAN"] = 12] = "ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["BENGALI"] = 13] = "BENGALI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CAMBODIAN"] = 14] = "CAMBODIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_EARTHLY_BRANCH"] = 15] = "CJK_EARTHLY_BRANCH";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_HEAVENLY_STEM"] = 16] = "CJK_HEAVENLY_STEM";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_IDEOGRAPHIC"] = 17] = "CJK_IDEOGRAPHIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DEVANAGARI"] = 18] = "DEVANAGARI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ETHIOPIC_NUMERIC"] = 19] = "ETHIOPIC_NUMERIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GEORGIAN"] = 20] = "GEORGIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GUJARATI"] = 21] = "GUJARATI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GURMUKHI"] = 22] = "GURMUKHI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HEBREW"] = 22] = "HEBREW";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA"] = 23] = "HIRAGANA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA_IROHA"] = 24] = "HIRAGANA_IROHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_FORMAL"] = 25] = "JAPANESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_INFORMAL"] = 26] = "JAPANESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KANNADA"] = 27] = "KANNADA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA"] = 28] = "KATAKANA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA_IROHA"] = 29] = "KATAKANA_IROHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KHMER"] = 30] = "KHMER";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANGUL_FORMAL"] = 31] = "KOREAN_HANGUL_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_FORMAL"] = 32] = "KOREAN_HANJA_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_INFORMAL"] = 33] = "KOREAN_HANJA_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LAO"] = 34] = "LAO";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ARMENIAN"] = 35] = "LOWER_ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MALAYALAM"] = 36] = "MALAYALAM";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MONGOLIAN"] = 37] = "MONGOLIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MYANMAR"] = 38] = "MYANMAR";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ORIYA"] = 39] = "ORIYA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["PERSIAN"] = 40] = "PERSIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_FORMAL"] = 41] = "SIMP_CHINESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_INFORMAL"] = 42] = "SIMP_CHINESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TAMIL"] = 43] = "TAMIL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TELUGU"] = 44] = "TELUGU";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["THAI"] = 45] = "THAI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TIBETAN"] = 46] = "TIBETAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_FORMAL"] = 47] = "TRAD_CHINESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_INFORMAL"] = 48] = "TRAD_CHINESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ARMENIAN"] = 49] = "UPPER_ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_OPEN"] = 50] = "DISCLOSURE_OPEN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_CLOSED"] = 51] = "DISCLOSURE_CLOSED";
    })(LIST_STYLE_TYPE || (LIST_STYLE_TYPE = {}));
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (type) {
            switch (type) {
                case 'disc':
                    return LIST_STYLE_TYPE.DISC;
                case 'circle':
                    return LIST_STYLE_TYPE.CIRCLE;
                case 'square':
                    return LIST_STYLE_TYPE.SQUARE;
                case 'decimal':
                    return LIST_STYLE_TYPE.DECIMAL;
                case 'cjk-decimal':
                    return LIST_STYLE_TYPE.CJK_DECIMAL;
                case 'decimal-leading-zero':
                    return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
                case 'lower-roman':
                    return LIST_STYLE_TYPE.LOWER_ROMAN;
                case 'upper-roman':
                    return LIST_STYLE_TYPE.UPPER_ROMAN;
                case 'lower-greek':
                    return LIST_STYLE_TYPE.LOWER_GREEK;
                case 'lower-alpha':
                    return LIST_STYLE_TYPE.LOWER_ALPHA;
                case 'upper-alpha':
                    return LIST_STYLE_TYPE.UPPER_ALPHA;
                case 'arabic-indic':
                    return LIST_STYLE_TYPE.ARABIC_INDIC;
                case 'armenian':
                    return LIST_STYLE_TYPE.ARMENIAN;
                case 'bengali':
                    return LIST_STYLE_TYPE.BENGALI;
                case 'cambodian':
                    return LIST_STYLE_TYPE.CAMBODIAN;
                case 'cjk-earthly-branch':
                    return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
                case 'cjk-heavenly-stem':
                    return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
                case 'cjk-ideographic':
                    return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
                case 'devanagari':
                    return LIST_STYLE_TYPE.DEVANAGARI;
                case 'ethiopic-numeric':
                    return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
                case 'georgian':
                    return LIST_STYLE_TYPE.GEORGIAN;
                case 'gujarati':
                    return LIST_STYLE_TYPE.GUJARATI;
                case 'gurmukhi':
                    return LIST_STYLE_TYPE.GURMUKHI;
                case 'hebrew':
                    return LIST_STYLE_TYPE.HEBREW;
                case 'hiragana':
                    return LIST_STYLE_TYPE.HIRAGANA;
                case 'hiragana-iroha':
                    return LIST_STYLE_TYPE.HIRAGANA_IROHA;
                case 'japanese-formal':
                    return LIST_STYLE_TYPE.JAPANESE_FORMAL;
                case 'japanese-informal':
                    return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
                case 'kannada':
                    return LIST_STYLE_TYPE.KANNADA;
                case 'katakana':
                    return LIST_STYLE_TYPE.KATAKANA;
                case 'katakana-iroha':
                    return LIST_STYLE_TYPE.KATAKANA_IROHA;
                case 'khmer':
                    return LIST_STYLE_TYPE.KHMER;
                case 'korean-hangul-formal':
                    return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
                case 'korean-hanja-formal':
                    return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
                case 'korean-hanja-informal':
                    return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
                case 'lao':
                    return LIST_STYLE_TYPE.LAO;
                case 'lower-armenian':
                    return LIST_STYLE_TYPE.LOWER_ARMENIAN;
                case 'malayalam':
                    return LIST_STYLE_TYPE.MALAYALAM;
                case 'mongolian':
                    return LIST_STYLE_TYPE.MONGOLIAN;
                case 'myanmar':
                    return LIST_STYLE_TYPE.MYANMAR;
                case 'oriya':
                    return LIST_STYLE_TYPE.ORIYA;
                case 'persian':
                    return LIST_STYLE_TYPE.PERSIAN;
                case 'simp-chinese-formal':
                    return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
                case 'simp-chinese-informal':
                    return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
                case 'tamil':
                    return LIST_STYLE_TYPE.TAMIL;
                case 'telugu':
                    return LIST_STYLE_TYPE.TELUGU;
                case 'thai':
                    return LIST_STYLE_TYPE.THAI;
                case 'tibetan':
                    return LIST_STYLE_TYPE.TIBETAN;
                case 'trad-chinese-formal':
                    return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
                case 'trad-chinese-informal':
                    return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
                case 'upper-armenian':
                    return LIST_STYLE_TYPE.UPPER_ARMENIAN;
                case 'disclosure-open':
                    return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
                case 'disclosure-closed':
                    return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
                case 'none':
                default:
                    return LIST_STYLE_TYPE.NONE;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TOKEN_VALUE
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var OVERFLOW;
    (function (OVERFLOW) {
        OVERFLOW[OVERFLOW["VISIBLE"] = 0] = "VISIBLE";
        OVERFLOW[OVERFLOW["HIDDEN"] = 1] = "HIDDEN";
        OVERFLOW[OVERFLOW["SCROLL"] = 2] = "SCROLL";
        OVERFLOW[OVERFLOW["AUTO"] = 3] = "AUTO";
    })(OVERFLOW || (OVERFLOW = {}));
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return OVERFLOW.HIDDEN;
                    case 'scroll':
                        return OVERFLOW.SCROLL;
                    case 'auto':
                        return OVERFLOW.AUTO;
                    case 'visible':
                    default:
                        return OVERFLOW.VISIBLE;
                }
            });
        }
    };

    var OVERFLOW_WRAP;
    (function (OVERFLOW_WRAP) {
        OVERFLOW_WRAP["NORMAL"] = "normal";
        OVERFLOW_WRAP["BREAK_WORD"] = "break-word";
    })(OVERFLOW_WRAP || (OVERFLOW_WRAP = {}));
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (overflow) {
            switch (overflow) {
                case 'break-word':
                    return OVERFLOW_WRAP.BREAK_WORD;
                case 'normal':
                default:
                    return OVERFLOW_WRAP.NORMAL;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var TEXT_ALIGN;
    (function (TEXT_ALIGN) {
        TEXT_ALIGN[TEXT_ALIGN["LEFT"] = 0] = "LEFT";
        TEXT_ALIGN[TEXT_ALIGN["CENTER"] = 1] = "CENTER";
        TEXT_ALIGN[TEXT_ALIGN["RIGHT"] = 2] = "RIGHT";
    })(TEXT_ALIGN || (TEXT_ALIGN = {}));
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (textAlign) {
            switch (textAlign) {
                case 'right':
                    return TEXT_ALIGN.RIGHT;
                case 'center':
                case 'justify':
                    return TEXT_ALIGN.CENTER;
                case 'left':
                default:
                    return TEXT_ALIGN.LEFT;
            }
        }
    };

    var POSITION;
    (function (POSITION) {
        POSITION[POSITION["STATIC"] = 0] = "STATIC";
        POSITION[POSITION["RELATIVE"] = 1] = "RELATIVE";
        POSITION[POSITION["ABSOLUTE"] = 2] = "ABSOLUTE";
        POSITION[POSITION["FIXED"] = 3] = "FIXED";
        POSITION[POSITION["STICKY"] = 4] = "STICKY";
    })(POSITION || (POSITION = {}));
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (position) {
            switch (position) {
                case 'relative':
                    return POSITION.RELATIVE;
                case 'absolute':
                    return POSITION.ABSOLUTE;
                case 'fixed':
                    return POSITION.FIXED;
                case 'sticky':
                    return POSITION.STICKY;
            }
            return POSITION.STATIC;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color.parse(token);
                    }
                }
                return shadow;
            });
        }
    };

    var TEXT_TRANSFORM;
    (function (TEXT_TRANSFORM) {
        TEXT_TRANSFORM[TEXT_TRANSFORM["NONE"] = 0] = "NONE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["LOWERCASE"] = 1] = "LOWERCASE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["UPPERCASE"] = 2] = "UPPERCASE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["CAPITALIZE"] = 3] = "CAPITALIZE";
    })(TEXT_TRANSFORM || (TEXT_TRANSFORM = {}));
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return TEXT_TRANSFORM.UPPERCASE;
                case 'lowercase':
                    return TEXT_TRANSFORM.LOWERCASE;
                case 'capitalize':
                    return TEXT_TRANSFORM.CAPITALIZE;
            }
            return TEXT_TRANSFORM.NONE;
        }
    };

    var transform = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'none') {
                return null;
            }
            if (token.type === TokenType.FUNCTION) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === TokenType.NUMBER_TOKEN; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === TokenType.NUMBER_TOKEN; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1], _a = values[2], _b = values[3], a2 = values[4], b2 = values[5], _c = values[6], _d = values[7], _e = values[8], _f = values[9], _g = values[10], _h = values[11], a4 = values[12], b4 = values[13], _j = values[14], _k = values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var VISIBILITY;
    (function (VISIBILITY) {
        VISIBILITY[VISIBILITY["VISIBLE"] = 0] = "VISIBLE";
        VISIBILITY[VISIBILITY["HIDDEN"] = 1] = "HIDDEN";
        VISIBILITY[VISIBILITY["COLLAPSE"] = 2] = "COLLAPSE";
    })(VISIBILITY || (VISIBILITY = {}));
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (visibility) {
            switch (visibility) {
                case 'hidden':
                    return VISIBILITY.HIDDEN;
                case 'collapse':
                    return VISIBILITY.COLLAPSE;
                case 'visible':
                default:
                    return VISIBILITY.VISIBLE;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case TokenType.IDENT_TOKEN:
                    case TokenType.STRING_TOKEN:
                        accumulator.push(token.value);
                        break;
                    case TokenType.NUMBER_TOKEN:
                        accumulator.push(token.number.toString());
                        break;
                    case TokenType.COMMA_TOKEN:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var FONT_STYLE;
    (function (FONT_STYLE) {
        FONT_STYLE["NORMAL"] = "normal";
        FONT_STYLE["ITALIC"] = "italic";
        FONT_STYLE["OBLIQUE"] = "oblique";
    })(FONT_STYLE || (FONT_STYLE = {}));
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (overflow) {
            switch (overflow) {
                case 'oblique':
                    return FONT_STYLE.OBLIQUE;
                case 'italic':
                    return FONT_STYLE.ITALIC;
                case 'normal':
                default:
                    return FONT_STYLE.NORMAL;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === TokenType.IDENT_TOKEN) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color.parse(token);
                    }
                }
                return shadow;
            });
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(declaration) {
            this.backgroundClip = parse(backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(boxShadow, declaration.boxShadow);
            this.color = parse(color$1, declaration.color);
            this.display = parse(display, declaration.display);
            this.float = parse(float, declaration.cssFloat);
            this.fontFamily = parse(fontFamily, declaration.fontFamily);
            this.fontSize = parse(fontSize, declaration.fontSize);
            this.fontStyle = parse(fontStyle, declaration.fontStyle);
            this.fontVariant = parse(fontVariant, declaration.fontVariant);
            this.fontWeight = parse(fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(lineBreak, declaration.lineBreak);
            this.lineHeight = parse(lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(listStyleType, declaration.listStyleType);
            this.marginTop = parse(marginTop, declaration.marginTop);
            this.marginRight = parse(marginRight, declaration.marginRight);
            this.marginBottom = parse(marginBottom, declaration.marginBottom);
            this.marginLeft = parse(marginLeft, declaration.marginLeft);
            this.opacity = parse(opacity, declaration.opacity);
            var overflowTuple = parse(overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(paddingTop, declaration.paddingTop);
            this.paddingRight = parse(paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(paddingLeft, declaration.paddingLeft);
            this.position = parse(position, declaration.position);
            this.textAlign = parse(textAlign, declaration.textAlign);
            this.textDecorationColor = parse(textDecorationColor, declaration.textDecorationColor || declaration.color);
            this.textDecorationLine = parse(textDecorationLine, declaration.textDecorationLine);
            this.textShadow = parse(textShadow, declaration.textShadow);
            this.textTransform = parse(textTransform, declaration.textTransform);
            this.transform = parse(transform, declaration.transform);
            this.transformOrigin = parse(transformOrigin, declaration.transformOrigin);
            this.visibility = parse(visibility, declaration.visibility);
            this.wordBreak = parse(wordBreak, declaration.wordBreak);
            this.zIndex = parse(zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === VISIBILITY.VISIBLE;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== POSITION.STATIC;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== FLOAT.NONE;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(declaration) {
            this.content = parse(content, declaration.content);
            this.quotes = parse(quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(declaration) {
            this.counterIncrement = parse(counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case PropertyDescriptorParsingType.IDENT_VALUE:
                var token = parser.parseComponentValue();
                return descriptor.parse(isIdentToken(token) ? token.value : descriptor.initialValue);
            case PropertyDescriptorParsingType.VALUE:
                return descriptor.parse(parser.parseComponentValue());
            case PropertyDescriptorParsingType.LIST:
                return descriptor.parse(parser.parseComponentValues());
            case PropertyDescriptorParsingType.TOKEN_VALUE:
                return parser.parseComponentValue();
            case PropertyDescriptorParsingType.TYPE_VALUE:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(parser.parseComponentValue());
                    case 'color':
                        return color.parse(parser.parseComponentValue());
                    case 'image':
                        return image.parse(parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                }
        }
        throw new Error("Attempting to parse unsupported css format type " + descriptor.format);
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(element) {
            this.styles = new CSSParsedDeclaration(window.getComputedStyle(element, null));
            this.textNodes = [];
            this.elements = [];
            if (this.styles.transform !== null && isHTMLElementNode(element)) {
                // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(element);
            this.flags = 0;
        }
        return ElementContainer;
    }());

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length)));
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return new Bounds(0, 0, 0, 0);
    };
    var getRangeBounds = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return Bounds.fromClientRect(range.getBoundingClientRect());
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? toCodePoints(value).map(function (i) { return fromCodePoint(i); }) : breakWords(value, styles);
    };
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                words.push(bk.value.slice());
            }
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(node, styles) {
            this.text = transform$1(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform$1 = function (text, transform) {
        switch (transform) {
            case TEXT_TRANSFORM.LOWERCASE:
                return text.toLowerCase();
            case TEXT_TRANSFORM.CAPITALIZE:
                return text.replace(CAPITALIZE, capitalize);
            case TEXT_TRANSFORM.UPPERCASE:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(img) {
            var _this = _super.call(this, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            CacheStorage.getInstance().addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(canvas) {
            var _this = _super.call(this, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(img) {
            var _this = _super.call(this, img) || this;
            var s = new XMLSerializer();
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            CacheStorage.getInstance().addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: TokenType.DIMENSION_TOKEN,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: TokenType.PERCENTAGE_TOKEN,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(input) {
            var _this = _super.call(this, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle =
                    BORDER_STYLE.SOLID;
                _this.styles.backgroundClip = [BACKGROUND_CLIP.BORDER_BOX];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(element) {
            var _this = _super.call(this, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var parseColor = function (value) { return color.parse(Parser.create(value).parseComponentValue()); };
    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(iframe) {
            var _this = _super.call(this, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(getComputedStyle(iframe.contentWindow.document.documentElement)
                            .backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                var container = createContainer(childNode);
                if (container.styles.isVisible()) {
                    if (createsRealStackingContext(childNode, container, root)) {
                        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                    }
                    else if (createsStackingContext(container.styles)) {
                        container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                    }
                    if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                        container.flags |= 8 /* IS_LIST_OWNER */;
                    }
                    parent.elements.push(container);
                    if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) {
                        parseNodeTree(childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function (element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(element);
        }
        return new ElementContainer(element);
    };
    var parseTree = function (element) {
        var container = createContainer(element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case LIST_STYLE_TYPE.DISC:
                return '•' + spaceSuffix;
            case LIST_STYLE_TYPE.CIRCLE:
                return '◦' + spaceSuffix;
            case LIST_STYLE_TYPE.SQUARE:
                return '◾' + spaceSuffix;
            case LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case LIST_STYLE_TYPE.CJK_DECIMAL:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case LIST_STYLE_TYPE.LOWER_ROMAN:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.UPPER_ROMAN:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_GREEK:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ALPHA:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case LIST_STYLE_TYPE.UPPER_ALPHA:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case LIST_STYLE_TYPE.ARABIC_INDIC:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case LIST_STYLE_TYPE.ARMENIAN:
            case LIST_STYLE_TYPE.UPPER_ARMENIAN:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ARMENIAN:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.BENGALI:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case LIST_STYLE_TYPE.CAMBODIAN:
            case LIST_STYLE_TYPE.KHMER:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
            case LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.JAPANESE_INFORMAL:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case LIST_STYLE_TYPE.JAPANESE_FORMAL:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.DEVANAGARI:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case LIST_STYLE_TYPE.GEORGIAN:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.GUJARATI:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case LIST_STYLE_TYPE.GURMUKHI:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.HEBREW:
                return createAdditiveCounter(value, 1, 10999, HEBREW, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.HIRAGANA:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case LIST_STYLE_TYPE.HIRAGANA_IROHA:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case LIST_STYLE_TYPE.KANNADA:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case LIST_STYLE_TYPE.KATAKANA:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case LIST_STYLE_TYPE.KATAKANA_IROHA:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case LIST_STYLE_TYPE.LAO:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case LIST_STYLE_TYPE.MONGOLIAN:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case LIST_STYLE_TYPE.MYANMAR:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case LIST_STYLE_TYPE.ORIYA:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.PERSIAN:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case LIST_STYLE_TYPE.TAMIL:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case LIST_STYLE_TYPE.TELUGU:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.THAI:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case LIST_STYLE_TYPE.TIBETAN:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case LIST_STYLE_TYPE.DECIMAL:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(element, options) {
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    documentClone.documentElement.style.top = -windowSize.top + 'px';
                                    documentClone.documentElement.style.left = -windowSize.left + 'px';
                                    documentClone.documentElement.style.position = 'absolute';
                                }
                            }
                            onclone = this.options.onclone;
                            if (typeof this.clonedReferenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            /*
            if (isIFrameElement(node)) {
                return this.createIFrameClone(node);
            }
    */
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            // @ts-ignore
            if (isImageElement(clone) && clone.loading === 'lazy') {
                // @ts-ignore
                clone.loading = 'eager';
            }
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                Logger.getInstance(this.options.id).error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    Logger.getInstance(this.options.id).info("Unable to clone canvas contents, canvas is tainted");
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) { }
            return clonedCanvas;
        };
        /*
        createIFrameClone(iframe: HTMLIFrameElement) {
            const tempIframe = <HTMLIFrameElement>iframe.cloneNode(false);
            const iframeKey = generateIframeKey();
            tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);

            const {width, height} = parseBounds(iframe);

            this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(iframe, this.options)
                .then(documentElement => {
                    return this.renderer(
                        documentElement,
                        {
                            allowTaint: this.options.allowTaint,
                            backgroundColor: '#ffffff',
                            canvas: null,
                            imageTimeout: this.options.imageTimeout,
                            logging: this.options.logging,
                            proxy: this.options.proxy,
                            removeContainer: this.options.removeContainer,
                            scale: this.options.scale,
                            foreignObjectRendering: this.options.foreignObjectRendering,
                            useCORS: this.options.useCORS,
                            target: new CanvasRenderer(),
                            width,
                            height,
                            x: 0,
                            y: 0,
                            windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
                            windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
                            scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
                            scrollY: documentElement.ownerDocument.defaultView.pageYOffset
                        },
                    );
                })
                .then(
                    (canvas: HTMLCanvasElement) =>
                        new Promise((resolve, reject) => {
                            const iframeCanvas = document.createElement('img');
                            iframeCanvas.onload = () => resolve(canvas);
                            iframeCanvas.onerror = (event) => {
                                // Empty iframes may result in empty "data:," URLs, which are invalid from the <img>'s point of view
                                // and instead of `onload` cause `onerror` and unhandled rejection warnings
                                // https://github.com/niklasvh/html2canvas/issues/1502
                                iframeCanvas.src == 'data:,' ? resolve(canvas) : reject(event);
                            };
                            iframeCanvas.src = canvas.toDataURL();
                            if (tempIframe.parentNode && iframe.ownerDocument && iframe.ownerDocument.defaultView) {
                                tempIframe.parentNode.replaceChild(
                                    copyCSSStyles(
                                        iframe.ownerDocument.defaultView.getComputedStyle(iframe),
                                        iframeCanvas
                                    ),
                                    tempIframe
                                );
                            }
                        })
                );
            return tempIframe;
        }
    */
        DocumentCloner.prototype.cloneNode = function (node) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                for (var child = node.firstChild; child; child = child.nextSibling) {
                    if (!isElementNode(child) ||
                        (!isScriptElement(child) &&
                            !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                            (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                        if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                            clone.appendChild(this.cloneNode(child));
                        }
                    }
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) {
                    copyCSSStyles(style, clone);
                }
                //this.inlineAllImages(clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(style));
            var declaration = new CSSParsedPseudoDeclaration(style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === TokenType.STRING_TOKEN) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === TokenType.URL_TOKEN) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === TokenType.FUNCTION) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(counterStyle.value)
                                : LIST_STYLE_TYPE.DECIMAL;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(counterStyle.value)
                                : LIST_STYLE_TYPE.DECIMAL;
                            var separator = delim && delim.type === TokenType.STRING_TOKEN ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                }
                else if (token.type === TokenType.IDENT_TOKEN) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = documentClone.onreadystatechange = function () {
                cloneWindow.onload = iframe.onload = documentClone.onreadystatechange = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            // Safari shows pseudoelements if content is set
            if (property !== 'content') {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var PathType;
    (function (PathType) {
        PathType[PathType["VECTOR"] = 0] = "VECTOR";
        PathType[PathType["BEZIER_CURVE"] = 1] = "BEZIER_CURVE";
    })(PathType || (PathType = {}));
    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = PathType.VECTOR;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = PathType.BEZIER_CURVE;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === PathType.BEZIER_CURVE; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderLeftWidth ? 0 : trh - borderLeftWidth, trv - borderTopWidth, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth), Math.max(0, brh - borderRightWidth), brv - borderBottomWidth, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + leftHeight, Math.max(0, blh - borderLeftWidth), blv - borderBottomWidth, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.type = 0 /* TRANSFORM */;
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.type = 1 /* CLIP */;
            this.target = target;
            this.path = path;
        }
        return ClipEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(element, parentStack) {
            this.container = element;
            this.effects = parentStack.slice(0);
            this.curves = new BoundCurves(element);
            if (element.styles.transform !== null) {
                var offsetX = element.bounds.left + element.styles.transformOrigin[0].number;
                var offsetY = element.bounds.top + element.styles.transformOrigin[1].number;
                var matrix = element.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (element.styles.overflowX !== OVERFLOW.VISIBLE) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getParentEffects = function () {
            var effects = this.effects.slice(0);
            if (this.container.styles.overflowX !== OVERFLOW.VISIBLE) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (!equalPath(borderBox, paddingBox)) {
                    effects.push(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
            }
            return effects;
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent.getParentEffects());
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, []);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === BACKGROUND_CLIP.BORDER_BOX) {
            return element.bounds;
        }
        if (backgroundClip === BACKGROUND_CLIP.CONTENT_BOX) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case BACKGROUND_REPEAT.REPEAT_X:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case BACKGROUND_REPEAT.REPEAT_Y:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case BACKGROUND_REPEAT.NO_REPEAT:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function () {
        function CanvasRenderer(options) {
            this._activeEffects = [];
            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            if (!options.canvas) {
                this.canvas.width = Math.floor(options.width * options.scale);
                this.canvas.height = Math.floor(options.height * options.scale);
                this.canvas.style.width = options.width + "px";
                this.canvas.style.height = options.height + "px";
            }
            this.fontMetrics = new FontMetrics(document);
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
            this.ctx.textBaseline = 'bottom';
            this._activeEffects = [];
            Logger.getInstance(options.id).debug("Canvas renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        }
        CanvasRenderer.prototype.applyEffects = function (effects, target) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.filter(function (effect) { return contains(effect.target, target); }).forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            this.ctx.globalAlpha = styles.opacity;
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
            }
            else {
                var letters = toCodePoints(text.text).map(function (i) { return fromCodePoint(i); });
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + text.bounds.height);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = styles.fontFamily.join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize;
                var _this = this;
                return __generator(this, function (_b) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    text.textBounds.forEach(function (text) {
                        _this.ctx.fillStyle = asString(styles.color);
                        _this.renderTextWithLetterSpacing(text, styles.letterSpacing);
                        var textShadows = styles.textShadow;
                        if (textShadows.length && text.text.trim().length) {
                            textShadows
                                .slice(0)
                                .reverse()
                                .forEach(function (textShadow) {
                                _this.ctx.shadowColor = asString(textShadow.color);
                                _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                _this.ctx.shadowBlur = textShadow.blur.number;
                                _this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                            });
                            _this.ctx.shadowColor = '';
                            _this.ctx.shadowOffsetX = 0;
                            _this.ctx.shadowOffsetY = 0;
                            _this.ctx.shadowBlur = 0;
                        }
                        if (styles.textDecorationLine.length) {
                            _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                            styles.textDecorationLine.forEach(function (textDecorationLine) {
                                switch (textDecorationLine) {
                                    case 1 /* UNDERLINE */:
                                        // Draws a line at the baseline of the font
                                        // TODO As some browsers display the line as more than 1px if the font-size is big,
                                        // need to take that into account both in position and size
                                        var baseline = _this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                        _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                        break;
                                    case 2 /* OVERLINE */:
                                        _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                        break;
                                    case 3 /* LINE_THROUGH */:
                                        // TODO try and find exact position for line-through
                                        var middle = _this.fontMetrics.getMetrics(fontFamily, fontSize).middle;
                                        _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                        break;
                                }
                            });
                        }
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, e_1, image, e_2, iframeRenderer, canvas, size, bounds, x, textBounds, img, image, url, e_3, bounds;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.applyEffects(paint.effects, 4 /* CONTENT */);
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _b.label = 5;
                        case 5:
                            _b.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.options.cache.match(container.src)];
                        case 6:
                            image = _b.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            e_1 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _b.label = 9;
                        case 9:
                            _b.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.options.cache.match(container.svg)];
                        case 10:
                            image = _b.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            e_2 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer({
                                id: this.options.id,
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                scrollX: 0,
                                scrollY: 0,
                                width: container.width,
                                height: container.height,
                                cache: this.options.cache,
                                windowWidth: container.width,
                                windowHeight: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _b.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _b.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                this.ctx.font = this.createFontStyle(styles)[0];
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case TEXT_ALIGN.CENTER:
                                        x += bounds.width / 2;
                                        break;
                                    case TEXT_ALIGN.RIGHT:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === CSSImageType.URL)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _b.label = 15;
                        case 15:
                            _b.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.options.cache.match(url)];
                        case 16:
                            image = _b.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            e_3 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== LIST_STYLE_TYPE.NONE) {
                                this.ctx.font = this.createFontStyle(styles)[0];
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _b.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0: 
                        // https://www.w3.org/TR/css-position-3/#painting-order
                        // 1. the background and borders of the element forming the stacking context.
                        return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            if (image.width === width && image.height === height) {
                return image;
            }
            var canvas = this.canvas.ownerDocument.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, e_4, _a, path, x, y, width, height, pattern, _b, path, x, y, width, height, _c, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _d, path, left, top_1, width, height, position, x, y, _e, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_f) {
                                    switch (_f.label) {
                                        case 0:
                                            if (!(backgroundImage.type === CSSImageType.URL)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _f.label = 1;
                                        case 1:
                                            _f.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.options.cache.match(url)];
                                        case 2:
                                            image = _f.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_4 = _f.sent();
                                            Logger.getInstance(this_1.options.id).error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _a = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _a[0], x = _a[1], y = _a[2], width = _a[3], height = _a[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _b = calculateBackgroundRendering(container, index, [null, null, null]), path = _b[0], x = _b[1], y = _b[2], width = _b[3], height = _b[4];
                                                _c = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _c[0], x0 = _c[1], x1 = _c[2], y0 = _c[3], y1 = _c[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], left = _d[1], top_1 = _d[2], width = _d[3], height = _d[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _e = calculateRadius(backgroundImage, x, y, width, height), rx = _e[0], ry = _e[1];
                                                if (rx > 0 && rx > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _f.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.effects, 2 /* BACKGROUND_BORDERS */);
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor },
                                { style: styles.borderRightStyle, color: styles.borderRightColor },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 7];
                            border = borders_1[_i];
                            if (!(border.style !== BORDER_STYLE.NONE && !isTransparent(border.color))) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderBorder(border.color, side, paint.curves)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5:
                            side++;
                            _a.label = 6;
                        case 6:
                            _i++;
                            return [3 /*break*/, 3];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x - this.options.scrollX, this.options.y - this.options.scrollY, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([], 2 /* BACKGROUND_BORDERS */);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }());
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case BACKGROUND_CLIP.BORDER_BOX:
                return calculateBorderBoxPath(curves);
            case BACKGROUND_CLIP.CONTENT_BOX:
                return calculateContentBoxPath(curves);
            case BACKGROUND_CLIP.PADDING_BOX:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case TEXT_ALIGN.CENTER:
                return 'center';
            case TEXT_ALIGN.RIGHT:
                return 'right';
            case TEXT_ALIGN.LEFT:
            default:
                return 'left';
        }
    };

    var ForeignObjectRenderer = /** @class */ (function () {
        function ForeignObjectRenderer(options) {
            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            this.canvas.width = Math.floor(options.width * options.scale);
            this.canvas.height = Math.floor(options.height * options.scale);
            this.canvas.style.width = options.width + "px";
            this.canvas.style.height = options.height + "px";
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
            Logger.getInstance(options.id).debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(Math.max(this.options.windowWidth, this.options.width) * this.options.scale, Math.max(this.options.windowHeight, this.options.height) * this.options.scale, this.options.scrollX * this.options.scale, this.options.scrollY * this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG$1(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }());
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var _this = undefined;
    var parseColor$1 = function (value) { return color.parse(Parser.create(value).parseComponentValue()); };
    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(_this, void 0, void 0, function () {
        var ownerDocument, defaultView, instanceName, _a, width, height, left, top, defaultResourceOptions, resourceOptions, defaultOptions, options, windowBounds, documentCloner, clonedElement, container, documentBackgroundColor, bodyBackgroundColor, bgColor, defaultBackgroundColor, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    instanceName = (Math.round(Math.random() * 1000) + Date.now()).toString(16);
                    _a = isBodyElement(element) || isHTMLElement(element) ? parseDocumentSize(ownerDocument) : parseBounds(element), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    defaultResourceOptions = {
                        allowTaint: false,
                        imageTimeout: 15000,
                        proxy: undefined,
                        useCORS: false
                    };
                    resourceOptions = __assign({}, defaultResourceOptions, opts);
                    defaultOptions = {
                        backgroundColor: '#ffffff',
                        cache: opts.cache ? opts.cache : CacheStorage.create(instanceName, resourceOptions),
                        logging: true,
                        removeContainer: true,
                        foreignObjectRendering: false,
                        scale: defaultView.devicePixelRatio || 1,
                        windowWidth: defaultView.innerWidth,
                        windowHeight: defaultView.innerHeight,
                        scrollX: defaultView.pageXOffset,
                        scrollY: defaultView.pageYOffset,
                        x: left,
                        y: top,
                        width: Math.ceil(width),
                        height: Math.ceil(height),
                        id: instanceName
                    };
                    options = __assign({}, defaultOptions, resourceOptions, opts);
                    windowBounds = new Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);
                    Logger.create({ id: instanceName, enabled: options.logging });
                    Logger.getInstance(instanceName).debug("Starting document clone");
                    documentCloner = new DocumentCloner(element, {
                        id: instanceName,
                        onclone: options.onclone,
                        ignoreElements: options.ignoreElements,
                        inlineImages: options.foreignObjectRendering,
                        copyStyles: options.foreignObjectRendering
                    });
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _b.sent();
                    documentBackgroundColor = ownerDocument.documentElement
                        ? parseColor$1(getComputedStyle(ownerDocument.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    bodyBackgroundColor = ownerDocument.body
                        ? parseColor$1(getComputedStyle(ownerDocument.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    bgColor = opts.backgroundColor;
                    defaultBackgroundColor = typeof bgColor === 'string' ? parseColor$1(bgColor) : bgColor === null ? COLORS.TRANSPARENT : 0xffffffff;
                    backgroundColor = element === ownerDocument.documentElement
                        ? isTransparent(documentBackgroundColor)
                            ? isTransparent(bodyBackgroundColor)
                                ? defaultBackgroundColor
                                : bodyBackgroundColor
                            : documentBackgroundColor
                        : defaultBackgroundColor;
                    renderOptions = {
                        id: instanceName,
                        cache: options.cache,
                        canvas: options.canvas,
                        backgroundColor: backgroundColor,
                        scale: options.scale,
                        x: options.x,
                        y: options.y,
                        scrollX: options.scrollX,
                        scrollY: options.scrollY,
                        width: options.width,
                        height: options.height,
                        windowWidth: options.windowWidth,
                        windowHeight: options.windowHeight
                    };
                    if (!options.foreignObjectRendering) return [3 /*break*/, 3];
                    Logger.getInstance(instanceName).debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    Logger.getInstance(instanceName).debug("Document cloned, using computed rendering");
                    CacheStorage.attachInstance(options.cache);
                    Logger.getInstance(instanceName).debug("Starting DOM parsing");
                    root = parseTree(clonedElement);
                    CacheStorage.detachInstance();
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    Logger.getInstance(instanceName).debug("Starting renderer");
                    renderer = new CanvasRenderer(renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _b.sent();
                    _b.label = 5;
                case 5:
                    if (options.removeContainer === true) {
                        if (!DocumentCloner.destroy(container)) {
                            Logger.getInstance(instanceName).error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    Logger.getInstance(instanceName).debug("Finished rendering");
                    Logger.destroy(instanceName);
                    CacheStorage.destroy(instanceName);
                    return [2 /*return*/, canvas];
            }
        });
    }); };

    return html2canvas;

}));
//# sourceMappingURL=html2canvas.js.map


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ua=exports.UserAgent=undefined;var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _class,_temp;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UserAgent=exports.UserAgent=(_temp=_class=function(){function UserAgent(userAgent){var _this=this;(0,_classCallCheck3.default)(this,UserAgent);this.navigator=typeof window.navigator!=="undefined"?window.navigator:{};this.userAgent=window.navigator.userAgent||"";this.constants={engine:["WebKit","Trident","Gecko","Presto"],browser:["Safari","Chrome","Edge","IE","Firefox","Firefox Focus","Chromium","Opera","Vivaldi","Yandex","Arora","Lunascape","QupZilla","Coc Coc","Kindle","Iceweasel","Konqueror","Iceape","SeaMonkey","Epiphany","360","360SE","360EE","UC","QQBrowser","QQ","Baidu","Maxthon","Sogou","LBBROWSER","2345Explorer","TheWorld","XiaoMi","Quark","Qiyu","Wechat","Taobao","Alipay","Weibo","Douban","Suning","iQiYi","DingTalk","EMobile"],os:["Windows","Linux","Mac OS","Android","Ubuntu","FreeBSD","Debian","iOS","Windows Phone","BlackBerry","MeeGo","Symbian","Chrome OS","WebOS"],device:["Mobile","Tablet"]};this.device="PC";this.engine="";this.browser="";this.os="";this.init=function(){(0,_keys2.default)(_this.constants).forEach(function(key){_this.constants[key].forEach(function(constant){if(_this.match()[constant]){_this[key]=constant;}});});if(_this.browser==="Edge"){_this.engine="EdgeHTML";}else if(_this.browser==="Chrome"&&parseInt(_this.version,10)>27){_this.engine="Blink";}else if(_this.browser==="Opera"&&parseInt(_this.version,10)>12){_this.engine="Blink";}else if(_this.browser==="Yandex"){_this.engine="Blink";}};this.mime=function(option,value){var mimeTypes=_this.navigator.mimeTypes;for(var mt in mimeTypes){if(mimeTypes[mt][option]===value){return true;}}return false;};this.match=function(){var u=_this.userAgent;var m={// engine
Trident:u.indexOf("Trident")>-1||u.indexOf("NET CLR")>-1,Presto:u.indexOf("Presto")>-1,WebKit:u.indexOf("AppleWebKit")>-1,Gecko:u.indexOf("Gecko/")>-1,// browser
Safari:u.indexOf("Safari")>-1,Chrome:u.indexOf("Chrome")>-1||u.indexOf("CriOS")>-1,IE:u.indexOf("MSIE")>-1||u.indexOf("Trident")>-1,Edge:u.indexOf("Edge")>-1,Firefox:u.indexOf("Firefox")>-1||u.indexOf("FxiOS")>-1,"Firefox Focus":u.indexOf("Focus")>-1,Chromium:u.indexOf("Chromium")>-1,Opera:u.indexOf("Opera")>-1||u.indexOf("OPR")>-1,Vivaldi:u.indexOf("Vivaldi")>-1,Yandex:u.indexOf("YaBrowser")>-1,Arora:u.indexOf("Arora")>-1,Lunascape:u.indexOf("Lunascape")>-1,QupZilla:u.indexOf("QupZilla")>-1,"Coc Coc":u.indexOf("coc_coc_browser")>-1,Kindle:u.indexOf("Kindle")>-1||u.indexOf("Silk/")>-1,Iceweasel:u.indexOf("Iceweasel")>-1,Konqueror:u.indexOf("Konqueror")>-1,Iceape:u.indexOf("Iceape")>-1,SeaMonkey:u.indexOf("SeaMonkey")>-1,Epiphany:u.indexOf("Epiphany")>-1,"360":u.indexOf("QihooBrowser")>-1||u.indexOf("QHBrowser")>-1,"360EE":u.indexOf("360EE")>-1,"360SE":u.indexOf("360SE")>-1,UC:u.indexOf("UC")>-1||u.indexOf(" UBrowser")>-1,QQBrowser:u.indexOf("QQBrowser")>-1,QQ:u.indexOf("QQ/")>-1,Baidu:u.indexOf("Baidu")>-1||u.indexOf("BIDUBrowser")>-1,Maxthon:u.indexOf("Maxthon")>-1,Sogou:u.indexOf("MetaSr")>-1||u.indexOf("Sogou")>-1,LBBROWSER:u.indexOf("LBBROWSER")>-1,"2345Explorer":u.indexOf("2345Explorer")>-1,TheWorld:u.indexOf("TheWorld")>-1,XiaoMi:u.indexOf("MiuiBrowser")>-1,Quark:u.indexOf("Quark")>-1,Qiyu:u.indexOf("Qiyu")>-1,Taobao:u.indexOf("AliApp(TB")>-1,Alipay:u.indexOf("AliApp(AP")>-1,Wechat:u.indexOf("MicroMessenger")>-1,DingTalk:u.indexOf("AliApp(DingTalk")>-1,EMobile:u.indexOf("E-Mobile")>-1,Weibo:u.indexOf("Weibo")>-1,Douban:u.indexOf("com.douban.frodo")>-1,Suning:u.indexOf("SNEBUY-APP")>-1,iQiYi:u.indexOf("IqiyiApp")>-1,// os
Windows:u.indexOf("Windows")>-1,Linux:u.indexOf("Linux")>-1||u.indexOf("X11")>-1,"Mac OS":u.indexOf("Macintosh")>-1,Android:u.indexOf("Android")>-1||u.indexOf("Adr")>-1,Ubuntu:u.indexOf("Ubuntu")>-1,FreeBSD:u.indexOf("FreeBSD")>-1,Debian:u.indexOf("Debian")>-1,"Windows Phone":u.indexOf("IEMobile")>-1||u.indexOf("Windows Phone")>-1,BlackBerry:u.indexOf("BlackBerry")>-1||u.indexOf("RIM")>-1,MeeGo:u.indexOf("MeeGo")>-1,Symbian:u.indexOf("Symbian")>-1,iOS:u.indexOf("like Mac OS X")>-1,"Chrome OS":u.indexOf("CrOS")>-1,WebOS:u.indexOf("hpwOS")>-1,// device
Mobile:u.indexOf("Mobi")>-1||u.indexOf("iPh")>-1||u.indexOf("480")>-1,Tablet:u.indexOf("Tablet")>-1||u.indexOf("Pad")>-1||u.indexOf("Nexus 7")>-1};var is360=false;if(window.chrome){var chromeVision=Number(u.replace(/^.*Chrome\/([\d]+).*$/,"$1"));if(chromeVision>36&&window.showModalDialog){is360=true;}else if(chromeVision>45){is360=_this.mime("type","application/vnd.chromium.remoting-viewer");}}if(m.Mobile){m.Mobile=!(u.indexOf("iPad")>-1);}else if(is360){if(_this.mime("type","application/gameplugin")){m["360SE"]=true;}else if(_this.navigator&&_this.navigator.connection&&typeof _this.navigator.connection.saveData==="undefined"){m["360SE"]=true;}else{m["360EE"]=true;}}if(m.IE||m.Edge){var navigatorTop=window.screenTop-window.screenY;switch(navigatorTop){case 71:// 无收藏栏,贴边
case 99:// 有收藏栏,贴边
case 102:// 有收藏栏,非贴边
m["360EE"]=true;break;case 75:// 无收藏栏,贴边
case 74:// 无收藏栏,非贴边
case 105:// 有收藏栏,贴边
case 104:// 有收藏栏,非贴边
m["360SE"]=true;break;default:break;}}if(m.Baidu&&m.Opera){m.Baidu=false;}return m;};if(userAgent){this.userAgent=userAgent;}this.init();}(0,_createClass3.default)(UserAgent,[{key:"language",get:function get(){var g=this.navigator.browserLanguage||this.navigator.language;var arr=g.split("-");if(arr[1]){arr[1]=arr[1].toUpperCase();}return arr.join("_");}},{key:"version",get:function get(){var u=this.userAgent;var map={Safari:function Safari(){return u.replace(/^.*Version\/([\d.]+).*$/,"$1");},Chrome:function Chrome(){return u.replace(/^.*Chrome\/([\d.]+).*$/,"$1").replace(/^.*CriOS\/([\d.]+).*$/,"$1");},IE:function IE(){return u.replace(/^.*MSIE ([\d.]+).*$/,"$1").replace(/^.*rv:([\d.]+).*$/,"$1");},Edge:function Edge(){return u.replace(/^.*Edge\/([\d.]+).*$/,"$1");},Firefox:function Firefox(){return u.replace(/^.*Firefox\/([\d.]+).*$/,"$1").replace(/^.*FxiOS\/([\d.]+).*$/,"$1");},"Firefox Focus":function FirefoxFocus(){return u.replace(/^.*Focus\/([\d.]+).*$/,"$1");},Chromium:function Chromium(){return u.replace(/^.*Chromium\/([\d.]+).*$/,"$1");},Opera:function Opera(){return u.replace(/^.*Opera\/([\d.]+).*$/,"$1").replace(/^.*OPR\/([\d.]+).*$/,"$1");},Vivaldi:function Vivaldi(){return u.replace(/^.*Vivaldi\/([\d.]+).*$/,"$1");},Yandex:function Yandex(){return u.replace(/^.*YaBrowser\/([\d.]+).*$/,"$1");},Arora:function Arora(){return u.replace(/^.*Arora\/([\d.]+).*$/,"$1");},Lunascape:function Lunascape(){return u.replace(/^.*Lunascape[/\s]([\d.]+).*$/,"$1");},QupZilla:function QupZilla(){return u.replace(/^.*QupZilla[/\s]([\d.]+).*$/,"$1");},"Coc Coc":function CocCoc(){return u.replace(/^.*coc_coc_browser\/([\d.]+).*$/,"$1");},Kindle:function Kindle(){return u.replace(/^.*Version\/([\d.]+).*$/,"$1");},Iceweasel:function Iceweasel(){return u.replace(/^.*Iceweasel\/([\d.]+).*$/,"$1");},Konqueror:function Konqueror(){return u.replace(/^.*Konqueror\/([\d.]+).*$/,"$1");},Iceape:function Iceape(){return u.replace(/^.*Iceape\/([\d.]+).*$/,"$1");},SeaMonkey:function SeaMonkey(){return u.replace(/^.*SeaMonkey\/([\d.]+).*$/,"$1");},Epiphany:function Epiphany(){return u.replace(/^.*Epiphany\/([\d.]+).*$/,"$1");},"360":function _(){return u.replace(/^.*QihooBrowser\/([\d.]+).*$/,"$1");},"360SE":function SE(){var hash={"63":"10.0","55":"9.1","45":"8.1","42":"8.0","31":"7.0","21":"6.3"};var chromeVision=u.replace(/^.*Chrome\/([\d]+).*$/,"$1");return hash[chromeVision]||"";},"360EE":function EE(){var hash={"69":"11.0","63":"9.5","55":"9.0","50":"8.7","30":"7.5"};var chromeVision=u.replace(/^.*Chrome\/([\d]+).*$/,"$1");return hash[chromeVision]||"";},Maxthon:function Maxthon(){return u.replace(/^.*Maxthon\/([\d.]+).*$/,"$1");},QQBrowser:function QQBrowser(){return u.replace(/^.*QQBrowser\/([\d.]+).*$/,"$1");},QQ:function QQ(){return u.replace(/^.*QQ\/([\d.]+).*$/,"$1");},Baidu:function Baidu(){return u.replace(/^.*BIDUBrowser[\s/]([\d.]+).*$/,"$1");},UC:function UC(){return u.replace(/^.*UC?Browser\/([\d.]+).*$/,"$1");},Sogou:function Sogou(){return u.replace(/^.*SE ([\d.X]+).*$/,"$1").replace(/^.*SogouMobileBrowser\/([\d.]+).*$/,"$1");},LBBROWSER:function LBBROWSER(){var hash={"57":"6.5","49":"6.0","46":"5.9","42":"5.3","39":"5.2","34":"5.0","29":"4.5","21":"4.0"};var chromeVision=window.navigator.userAgent.replace(/^.*Chrome\/([\d]+).*$/,"$1");return hash[chromeVision]||"";},"2345Explorer":function Explorer(){return u.replace(/^.*2345Explorer\/([\d.]+).*$/,"$1");},TheWorld:function TheWorld(){return u.replace(/^.*TheWorld ([\d.]+).*$/,"$1");},XiaoMi:function XiaoMi(){return u.replace(/^.*MiuiBrowser\/([\d.]+).*$/,"$1");},Quark:function Quark(){return u.replace(/^.*Quark\/([\d.]+).*$/,"$1");},Qiyu:function Qiyu(){return u.replace(/^.*Qiyu\/([\d.]+).*$/,"$1");},Wechat:function Wechat(){return u.replace(/^.*MicroMessenger\/([\d.]+).*$/,"$1");},DingTalk:function DingTalk(){return u.replace(/^.*AliApp\(DingTalk\/([\d.]+).*$/,"$1");},EMobile:function EMobile(){return u.replace(/^.*E-Mobile\d+\/([\d.]+).*$/,"$1");},Taobao:function Taobao(){return u.replace(/^.*AliApp\(TB\/([\d.]+).*$/,"$1");},Alipay:function Alipay(){return u.replace(/^.*AliApp\(AP\/([\d.]+).*$/,"$1");},Weibo:function Weibo(){return u.replace(/^.*weibo__([\d.]+).*$/,"$1");},Douban:function Douban(){return u.replace(/^.*com.douban.frodo\/([\d.]+).*$/,"$1");},Suning:function Suning(){return u.replace(/^.*SNEBUY-APP([\d.]+).*$/,"$1");},iQiYi:function iQiYi(){return u.replace(/^.*IqiyiVersion\/([\d.]+).*$/,"$1");}};var fn=map[this.browser];var version="";if(typeof fn==="function"){version=fn();}return version===u?"":version;}},{key:"osVersion",get:function get(){var u=this.userAgent;var map={Windows:function Windows(){var v=u.replace(/^.*Windows NT ([\d.]+);.*$/,"$1");var hash={"6.4":"10","6.3":"8.1","6.2":"8","6.1":"7","6.0":"Vista","5.2":"XP","5.1":"XP","5.0":"2000"};return hash[v]||v;},Android:function Android(){return u.replace(/^.*Android ([\d.]+);.*$/,"$1");},iOS:function iOS(){return u.replace(/^.*OS ([\d_]+) like.*$/,"$1").replace(/_/g,".");},Debian:function Debian(){return u.replace(/^.*Debian\/([\d.]+).*$/,"$1");},"Windows Phone":function WindowsPhone(){return u.replace(/^.*Windows Phone( OS)? ([\d.]+);.*$/,"$2");},"Mac OS":function MacOS(){return u.replace(/^.*Mac OS X ([\d_]+).*$/,"$1").replace(/_/g,".");},WebOS:function WebOS(){return u.replace(/^.*hpwOS\/([\d.]+);.*$/,"$1");}};var fn=map[this.os];var osVersion="";if(typeof fn==="function"){osVersion=fn();}return osVersion===u?"":osVersion;}}]);return UserAgent;}(),_class.version="1.0.0",_temp);var uaa=new UserAgent();var ua=exports.ua={device:uaa.device,engine:uaa.engine,browser:uaa.browser,os:uaa.os,osVersion:uaa.osVersion,version:uaa.version,language:uaa.language};window.ua=ua;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _DateConstants=__webpack_require__(198);var _DateConstants2=_interopRequireDefault(_DateConstants);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DateTHead=function(_React$Component){(0,_inherits3.default)(DateTHead,_React$Component);function DateTHead(){(0,_classCallCheck3.default)(this,DateTHead);return(0,_possibleConstructorReturn3.default)(this,(DateTHead.__proto__||(0,_getPrototypeOf2.default)(DateTHead)).apply(this,arguments));}(0,_createClass3.default)(DateTHead,[{key:"render",value:function render(){var props=this.props;var value=props.value;var locale=props.locale;var prefixCls=props.prefixCls;var veryShortWeekdays=[];var weekDays=[];var firstDayOfWeek=value.getFirstDayOfWeek();var showWeekNumberEl=void 0;for(var dateColIndex=0;dateColIndex<_DateConstants2.default.DATE_COL_COUNT;dateColIndex++){var index=(firstDayOfWeek+dateColIndex)%_DateConstants2.default.DATE_COL_COUNT;veryShortWeekdays[dateColIndex]=locale.format.veryShortWeekdays[index];weekDays[dateColIndex]=locale.format.weekdays[index];}if(props.showWeekNumber){showWeekNumberEl=_react2.default.createElement("th",{role:"columnheader",className:prefixCls+"-column-header "+prefixCls+"-week-number-header"},_react2.default.createElement("span",{className:prefixCls+"-column-header-inner"},"x"));}var weekDaysEls=weekDays.map(function(day,xindex){return _react2.default.createElement("th",{ecId:props.ecId+"_th@wllado@"+xindex,key:xindex,role:"columnheader",title:day,className:prefixCls+"-column-header"},_react2.default.createElement("span",{className:prefixCls+"-column-header-inner"},veryShortWeekdays[xindex]));});return _react2.default.createElement("thead",null,_react2.default.createElement("tr",{role:"row"},showWeekNumberEl,weekDaysEls));}}]);return DateTHead;}(_react2.default.Component);exports.default=DateTHead;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _DateConstants=__webpack_require__(198);var _DateConstants2=_interopRequireDefault(_DateConstants);var _util=__webpack_require__(39);var _util2=__webpack_require__(69);var _util3=_interopRequireDefault(_util2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function isSameDay(one,two){return one&&two&&one.compareToDay(two)===0;}function getStartOfMonth(){var startOfMonth=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return startOfMonth>28?1:startOfMonth;}function getAddMonthOfToday(today,startOfMonth){var cloneToday=today.clone();return cloneToday.getDayOfMonth()<startOfMonth?-1:0;}function getYearAndMonth(value,addMonth){var year=value.getYear();var month=value.getMonth()+addMonth;if(month==-1){month=11;year-=1;}return{year:year,month:month};}function beforeCurrentMonthYear(current,today){var addMonth=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var startOfMonth=arguments[3];var colneCurrent=current.clone();var cloneToday=today.clone();var _getYearAndMonth=getYearAndMonth(cloneToday,addMonth),year=_getYearAndMonth.year,month=_getYearAndMonth.month;cloneToday.set(year,month,startOfMonth);return current.getYear()<year||current.getYear()===year&&colneCurrent.compareToDay(cloneToday)<0;// if (current.getYear() < today.getYear()) {
//   return 1;
// }
// return current.getYear() === today.getYear() &&
//   current.getMonth() < today.getMonth();
}function afterCurrentMonthYear(current,today){var addMonth=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var startOfMonth=arguments[3];var colneCurrent=current.clone();var cloneToday=today.clone();if(current.getYear()>today.getYear()){return 1;}cloneToday.set(cloneToday.getYear(),cloneToday.getMonth()+addMonth+1,startOfMonth);return current.getYear()===today.getYear()&&colneCurrent.compareToDay(cloneToday)>=0;// if (current.getYear() > today.getYear()) {
//   return 1;
// }
// return current.getYear() === today.getYear() &&
//   current.getMonth() > today.getMonth();
}function getIdFromDate(date){return"rc-calendar-"+date.getYear()+"-"+date.getMonth()+"-"+date.getDayOfMonth();}function noop(){}function handleDayClick(current){this.props.onSelect(current);}function handleCellMouseEnter(current){this.props.onDayHover(current);}var DateTBody=_react2.default.createClass({displayName:"DateTBody",propTypes:{contentRender:_react.PropTypes.func,dateRender:_react.PropTypes.func,disabledDate:_react.PropTypes.func,prefixCls:_react.PropTypes.string,selectedValue:_react.PropTypes.oneOfType([_react.PropTypes.object,_react.PropTypes.arrayOf(_react.PropTypes.object)]),value:_react.PropTypes.object,showWeekNumber:_react.PropTypes.bool},getDefaultProps:function getDefaultProps(){return{onDayHover:noop};},render:function render(){var props=this.props;var contentRender=props.contentRender,prefixCls=props.prefixCls,selectedValue=props.selectedValue,value=props.value,showWeekNumber=props.showWeekNumber,dateRender=props.dateRender,_props$fixWeekLength=props.fixWeekLength,fixWeekLength=_props$fixWeekLength===undefined?true:_props$fixWeekLength,disabledDate=props.disabledDate,ecId=props.ecId;var iIndex=void 0;var jIndex=void 0;var current=void 0;var dateTable=[];var today=value.clone();var cellClass=prefixCls+"-cell";var weekNumberCellClass=prefixCls+"-week-number-cell";var dateClass=prefixCls+"-date";var todayClass=prefixCls+"-today";var selectedClass=prefixCls+"-selected-day";var inRangeClass=prefixCls+"-in-range-cell";var lastMonthDayClass=prefixCls+"-last-month-cell";var nextMonthDayClass=prefixCls+"-next-month-btn-day";var disabledClass=prefixCls+"-disabled-cell";var firstDisableClass=prefixCls+"-disabled-cell-first-of-row";var lastDisableClass=prefixCls+"-disabled-cell-last-of-row";var weekendClass=prefixCls+"-weekend-of-row";today.setTime(Date.now());var startOfMonth=getStartOfMonth(this.props.startOfMonth);var addMonth=getAddMonthOfToday(today,startOfMonth);var month1=value.clone();var _getYearAndMonth2=getYearAndMonth(value,addMonth),year=_getYearAndMonth2.year,month=_getYearAndMonth2.month;month1.set(year,month,startOfMonth);// month1.set(value.getYear(), value.getMonth(), 1);
var day=month1.getDayOfWeek();var lastMonthDiffDay=(day+7-value.getFirstDayOfWeek())%7;// calculate last month
var lastMonth1=month1.clone();lastMonth1.addDayOfMonth(0-lastMonthDiffDay);var passed=0;var weekLength=_DateConstants2.default.DATE_ROW_COUNT;if(!fixWeekLength){weekLength-=1;/* 获取本月的有几周 */var test=lastMonth1.clone();test.addDayOfMonth(weekLength*7-1);if(test.getMonth()===month){test.addDayOfMonth(1);if(test.getMonth()===month){weekLength+=1;}}}for(iIndex=0;iIndex<weekLength;iIndex++){for(jIndex=0;jIndex<_DateConstants2.default.DATE_COL_COUNT;jIndex++){current=lastMonth1;if(passed){current=current.clone();current.addDayOfMonth(passed);}dateTable.push(current);passed++;}}var tableHtml=[];passed=0;for(iIndex=0;iIndex<weekLength;iIndex++){var weekNumberCell=void 0;var dateCells=[];if(showWeekNumber){weekNumberCell=_react2.default.createElement("td",{key:dateTable[passed].getWeekOfYear(),role:"gridcell",className:weekNumberCellClass},dateTable[passed].getWeekOfYear());}for(jIndex=0;jIndex<_DateConstants2.default.DATE_COL_COUNT;jIndex++){var next=null;var last=null;current=dateTable[passed];if(jIndex<_DateConstants2.default.DATE_COL_COUNT-1){next=dateTable[passed+1];}if(jIndex>0){last=dateTable[passed-1];}var cls=cellClass;var disabled=false;var selected=false;if(_util3.default.isWeekendDay(current.time)){cls+=" "+weekendClass;}if(isSameDay(current,today)){cls+=" "+todayClass;}var isBeforeCurrentMonthYear=beforeCurrentMonthYear(current,value,addMonth,startOfMonth);var isAfterCurrentMonthYear=afterCurrentMonthYear(current,value,addMonth,startOfMonth);if(selectedValue&&Array.isArray(selectedValue)){if(!isBeforeCurrentMonthYear&&!isAfterCurrentMonthYear){var startValue=selectedValue[0];var endValue=selectedValue[1];if(startValue){if(isSameDay(current,startValue)){selected=true;}}if(startValue&&endValue){if(isSameDay(current,endValue)&&!selectedValue.hovering){selected=true;}else if(current.compareToDay(startValue)>0&&current.compareToDay(endValue)<0){cls+=" "+inRangeClass;}}}}else if(isSameDay(current,value)){// keyboard change value, highlight works
selected=true;}if(isBeforeCurrentMonthYear){cls+=" "+lastMonthDayClass;}if(isAfterCurrentMonthYear){cls+=" "+nextMonthDayClass;}if(disabledDate){if(disabledDate(current,value)){disabled=true;if(!last||!disabledDate(last,value)){cls+=" "+firstDisableClass;}if(!next||!disabledDate(next,value)){cls+=" "+lastDisableClass;}}}if(selected){cls+=" "+selectedClass;}if(disabled){cls+=" "+disabledClass;}var dateHtml=void 0;if(dateRender){dateHtml=dateRender(current,value);}else{var content=contentRender?contentRender(current,value):current.getDayOfMonth();dateHtml=_react2.default.createElement("div",{key:getIdFromDate(current),className:dateClass,"aria-selected":selected,"aria-disabled":disabled},content);}dateCells.push(_react2.default.createElement("td",{ecId:ecId+"_td@wxsy7v@"+passed,key:passed,onClick:disabled?noop:handleDayClick.bind(this,current),onMouseEnter:disabled?noop:handleCellMouseEnter.bind(this,current),role:"gridcell",title:(0,_util.getTitleString)(current),className:cls},dateHtml));passed++;}tableHtml.push(_react2.default.createElement("tr",{key:iIndex,role:"row"},weekNumberCell,dateCells));}return _react2.default.createElement("tbody",{className:prefixCls+"tbody"},tableHtml);}});exports.default=DateTBody;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * utils for gregorian date
 * @ignore
 * @author yiminghe@gmail.com
 */



var Const = __webpack_require__(199);
var floor = Math.floor;
var ACCUMULATED_DAYS_IN_MONTH
//   1/1 2/1 3/1 4/1 5/1 6/1 7/1 8/1 9/1 10/1 11/1 12/1
= [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];

var ACCUMULATED_DAYS_IN_MONTH_LEAP
//   1/1 2/1   3/1   4/1   5/1   6/1   7/1   8/1   9/1
// 10/1   11/1   12/1
= [0, 31, 59 + 1, 90 + 1, 120 + 1, 151 + 1, 181 + 1, 212 + 1, 243 + 1, 273 + 1, 304 + 1, 334 + 1];

var DAYS_OF_YEAR = 365;
var DAYS_OF_4YEAR = 365 * 4 + 1;
var DAYS_OF_100YEAR = DAYS_OF_4YEAR * 25 - 1;
var DAYS_OF_400YEAR = DAYS_OF_100YEAR * 4 + 1;
var _exports = {};

function getDayOfYear(year, month, dayOfMonth) {
  return dayOfMonth + (_exports.isLeapYear(year) ? ACCUMULATED_DAYS_IN_MONTH_LEAP[month] : ACCUMULATED_DAYS_IN_MONTH[month]);
}

function getDayOfWeekFromFixedDate(fixedDate) {
  // The fixed day 1 (January 1, 1 Gregorian) is Monday.
  if (fixedDate >= 0) {
    return fixedDate % 7;
  }
  return _exports.mod(fixedDate, 7);
}

function getGregorianYearFromFixedDate(fixedDate) {
  var d0 = undefined;
  var d1 = undefined;
  var d2 = undefined;
  var d3 = undefined;
  var n400 = undefined;
  var n100 = undefined;
  var n4 = undefined;
  var n1 = undefined;
  var year = undefined;
  d0 = fixedDate - 1;

  n400 = floor(d0 / DAYS_OF_400YEAR);
  d1 = _exports.mod(d0, DAYS_OF_400YEAR);
  n100 = floor(d1 / DAYS_OF_100YEAR);
  d2 = _exports.mod(d1, DAYS_OF_100YEAR);
  n4 = floor(d2 / DAYS_OF_4YEAR);
  d3 = _exports.mod(d2, DAYS_OF_4YEAR);
  n1 = floor(d3 / DAYS_OF_YEAR);

  year = 400 * n400 + 100 * n100 + 4 * n4 + n1;

  // ?
  if (!(n100 === 4 || n1 === 4)) {
    ++year;
  }

  return year;
}

_exports = module.exports = {
  each: function each(arr, fn) {
    for (var i = 0, len = arr.length; i < len; i++) {
      if (fn(arr[i], i, arr) === false) {
        break;
      }
    }
  },

  mix: function mix(t, s) {
    for (var p in s) {
      if (s.hasOwnProperty(p)) {
        t[p] = s[p];
      }
    }
  },

  isLeapYear: function isLeapYear(year) {
    if ((year & 3) !== 0) {
      return false;
    }
    return year % 100 !== 0 || year % 400 === 0;
  },

  mod: function mod(x, y) {
    // 负数时不是镜像关系
    return x - y * floor(x / y);
  },

  // month: 0 based
  getFixedDate: function getFixedDate(year, month, dayOfMonth) {
    var prevYear = year - 1;
    // 考虑公元前
    return DAYS_OF_YEAR * prevYear + floor(prevYear / 4) - floor(prevYear / 100) + floor(prevYear / 400) + getDayOfYear(year, month, dayOfMonth);
  },

  getGregorianDateFromFixedDate: function getGregorianDateFromFixedDate(fixedDate) {
    var year = getGregorianYearFromFixedDate(fixedDate);
    var jan1 = _exports.getFixedDate(year, Const.JANUARY, 1);
    var isLeap = _exports.isLeapYear(year);
    var ACCUMULATED_DAYS = isLeap ? ACCUMULATED_DAYS_IN_MONTH_LEAP : ACCUMULATED_DAYS_IN_MONTH;
    var daysDiff = fixedDate - jan1;
    var month = undefined;

    for (var i = 0; i < ACCUMULATED_DAYS.length; i++) {
      if (ACCUMULATED_DAYS[i] <= daysDiff) {
        month = i;
      } else {
        break;
      }
    }

    var dayOfMonth = fixedDate - jan1 - ACCUMULATED_DAYS[month] + 1;
    var dayOfWeek = getDayOfWeekFromFixedDate(fixedDate);

    return {
      year: year,
      month: month,
      dayOfMonth: dayOfMonth,
      dayOfWeek: dayOfWeek,
      isLeap: isLeap
    };
  }
};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _en_US=__webpack_require__(146);var _en_US2=_interopRequireDefault(_en_US);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={today:'Today',now:'Now',backToToday:'Back to today',ok:'Ok',clear:'Clear',month:'Month',year:'Year',monthSelect:'Choose a month',yearSelect:'Choose a year',decadeSelect:'Choose a decade',yearFormat:'yyyy',dateFormat:'M/d/yyyy',monthFormat:'MMMM',monthBeforeYear:true,previousMonth:'Previous month (PageUp)',nextMonth:'Next month (PageDown)',previousYear:'Last year (Control + left)',nextYear:'Next year (Control + right)',previousDecade:'Last decade',nextDecade:'Next decade',previousCentury:'Last century',nextCentury:'Next century',format:_en_US2.default};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(509);__webpack_require__(92);__webpack_require__(130);

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=function(props){var _classNames;var _props$prefixCls=props.prefixCls,prefixCls=_props$prefixCls===undefined?'ant-card':_props$prefixCls,className=props.className,children=props.children,extra=props.extra,bodyStyle=props.bodyStyle,title=props.title,loading=props.loading,_props$bordered=props.bordered,bordered=_props$bordered===undefined?true:_props$bordered,other=(0,_objectWithoutProperties3.default)(props,['prefixCls','className','children','extra','bodyStyle','title','loading','bordered']);var classString=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls,true),(0,_defineProperty3.default)(_classNames,className,!!className),(0,_defineProperty3.default)(_classNames,prefixCls+'-loading',loading),(0,_defineProperty3.default)(_classNames,prefixCls+'-bordered',bordered),_classNames));if(loading){children=_react2.default.createElement('div',null,_react2.default.createElement('p',null,'\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588'),_react2.default.createElement('p',null,'\u2588\u2588\u2588\u2588\u2588\u2588\u3000\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588'),_react2.default.createElement('p',null,'\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u3000\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588'),_react2.default.createElement('p',null,'\u2588\u2588\u2588\u2588\u2588\u3000\u2588\u2588\u2588\u2588\u2588\u2588\u3000\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588'),_react2.default.createElement('p',null,'\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u3000\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u3000\u2588\u2588\u2588'));}var head=title?_react2.default.createElement('div',{className:prefixCls+'-head'},_react2.default.createElement('h3',{className:prefixCls+'-head-title'},title)):null;return _react2.default.createElement('div',(0,_extends3.default)({},other,{className:classString}),head,extra?_react2.default.createElement('div',{className:prefixCls+'-extra'},extra):null,_react2.default.createElement('div',{className:prefixCls+'-body',style:bodyStyle},children));};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(515);

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _reactSlick=__webpack_require__(517);var _reactSlick2=_interopRequireDefault(_reactSlick);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
if(typeof window!=='undefined'){var matchMediaPolyfill=function matchMediaPolyfill(){return{matches:false,addListener:function addListener(){},removeListener:function removeListener(){}};};window.matchMedia=window.matchMedia||matchMediaPolyfill;}var Carousel=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Carousel,_React$Component);function Carousel(){(0,_classCallCheck3.default)(this,Carousel);return(0,_possibleConstructorReturn3.default)(this,(Carousel.__proto__||(0,_getPrototypeOf2.default)(Carousel)).apply(this,arguments));}(0,_createClass3.default)(Carousel,[{key:'render',value:function render(){var props=(0,_extends3.default)({},this.props);if(props.effect==='fade'){props.fade=true;props.draggable=false;}var className='ant-carousel';if(props.vertical){className=className+' ant-carousel-vertical';}return _react2.default.createElement('div',{className:className},_react2.default.createElement(_reactSlick2.default,props));}}]);return Carousel;}(_react2.default.Component),_class.defaultProps={dots:true,arrows:false,pauseOnHover:true},_temp);exports.default=Carousel;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(518);

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(519);

var _objectAssign = __webpack_require__(19);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _json2mq = __webpack_require__(203);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _reactResponsiveMixin = __webpack_require__(526);

var _reactResponsiveMixin2 = _interopRequireDefault(_reactResponsiveMixin);

var _defaultProps = __webpack_require__(202);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = _react2.default.createClass({
  displayName: 'Slider',

  mixins: [_reactResponsiveMixin2.default],
  innerSlider: null,
  innerSliderRefHandler: function innerSliderRefHandler(ref) {
    this.innerSlider = ref;
  },
  getInitialState: function getInitialState() {
    return {
      breakpoint: null
    };
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        var bQuery;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
        }
        _this.media(bQuery, function () {
          _this.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      this.media(query, function () {
        _this.setState({ breakpoint: null });
      });
    }
  },

  slickPrev: function slickPrev() {
    this.innerSlider.slickPrev();
  },

  slickNext: function slickNext() {
    this.innerSlider.slickNext();
  },

  slickGoTo: function slickGoTo(slide) {
    this.innerSlider.slickGoTo(slide);
  },

  render: function render() {
    var _this2 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this2.state.breakpoint;
      });
      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
    } else {
      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
    }

    var children = this.props.children;
    if (!Array.isArray(children)) {
      children = [children];
    }

    // Children may contain false or null, so we should filter them
    children = children.filter(function (child) {
      return !!child;
    });

    if (settings === 'unslick') {
      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
      return _react2.default.createElement(
        'div',
        null,
        children
      );
    } else {
      return _react2.default.createElement(
        _innerSlider.InnerSlider,
        _extends({ ref: this.innerSliderRefHandler }, settings),
        children
      );
    }
  }
});

module.exports = Slider;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _eventHandlers = __webpack_require__(520);

var _eventHandlers2 = _interopRequireDefault(_eventHandlers);

var _helpers = __webpack_require__(201);

var _helpers2 = _interopRequireDefault(_helpers);

var _initialState = __webpack_require__(521);

var _initialState2 = _interopRequireDefault(_initialState);

var _defaultProps = __webpack_require__(202);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _track = __webpack_require__(522);

var _dots = __webpack_require__(523);

var _arrows = __webpack_require__(524);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InnerSlider = exports.InnerSlider = _react2.default.createClass({
  displayName: 'InnerSlider',

  mixins: [_helpers2.default, _eventHandlers2.default],
  list: null,
  track: null,
  listRefHandler: function listRefHandler(ref) {
    this.list = ref;
  },
  trackRefHandler: function trackRefHandler(ref) {
    this.track = ref;
  },
  getInitialState: function getInitialState() {
    return _extends({}, _initialState2.default, {
      currentSlide: this.props.initialSlide
    });
  },
  getDefaultProps: function getDefaultProps() {
    return _defaultProps2.default;
  },
  componentWillMount: function componentWillMount() {
    if (this.props.init) {
      this.props.init();
    }
    this.setState({
      mounted: true
    });
    var lazyLoadedList = [];
    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
        lazyLoadedList.push(i);
      }
    }

    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
      this.setState({
        lazyLoadedList: lazyLoadedList
      });
    }
  },
  componentDidMount: function componentDidMount() {
    // Hack for autoplay -- Inspect Later
    this.initialize(this.props);
    this.adaptHeight();
    if (window.addEventListener) {
      window.addEventListener('resize', this.onWindowResized);
    } else {
      window.attachEvent('onresize', this.onWindowResized);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this.animationEndCallback) {
      clearTimeout(this.animationEndCallback);
    }
    if (window.addEventListener) {
      window.removeEventListener('resize', this.onWindowResized);
    } else {
      window.detachEvent('onresize', this.onWindowResized);
    }
    if (this.state.autoPlayTimer) {
      window.clearInterval(this.state.autoPlayTimer);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.slickGoTo != nextProps.slickGoTo) {
      if (false) {
        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
      }
      this.changeSlide({
        message: 'index',
        index: nextProps.slickGoTo,
        currentSlide: this.state.currentSlide
      });
    } else if (this.state.currentSlide >= nextProps.children.length) {
      this.update(nextProps);
      this.changeSlide({
        message: 'index',
        index: nextProps.children.length - nextProps.slidesToShow,
        currentSlide: this.state.currentSlide
      });
    } else {
      this.update(nextProps);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    this.adaptHeight();
  },
  onWindowResized: function onWindowResized() {
    this.update(this.props);
    // animating state should be cleared while resizing, otherwise autoplay stops working
    this.setState({
      animating: false
    });
  },
  slickPrev: function slickPrev() {
    this.changeSlide({ message: 'previous' });
  },
  slickNext: function slickNext() {
    this.changeSlide({ message: 'next' });
  },
  slickGoTo: function slickGoTo(slide) {
    typeof slide === 'number' && this.changeSlide({
      message: 'index',
      index: slide,
      currentSlide: this.state.currentSlide
    });
  },
  render: function render() {
    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className);

    var trackProps = {
      fade: this.props.fade,
      cssEase: this.props.cssEase,
      speed: this.props.speed,
      infinite: this.props.infinite,
      centerMode: this.props.centerMode,
      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : new Function(),
      currentSlide: this.state.currentSlide,
      lazyLoad: this.props.lazyLoad,
      lazyLoadedList: this.state.lazyLoadedList,
      rtl: this.props.rtl,
      slideWidth: this.state.slideWidth,
      slidesToShow: this.props.slidesToShow,
      slidesToScroll: this.props.slidesToScroll,
      slideCount: this.state.slideCount,
      trackStyle: this.state.trackStyle,
      variableWidth: this.props.variableWidth
    };

    var dots;

    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
      var dotProps = {
        dotsClass: this.props.dotsClass,
        slideCount: this.state.slideCount,
        slidesToShow: this.props.slidesToShow,
        currentSlide: this.state.currentSlide,
        slidesToScroll: this.props.slidesToScroll,
        clickHandler: this.changeSlide
      };

      dots = _react2.default.createElement(_dots.Dots, dotProps);
    }

    var prevArrow, nextArrow;

    var arrowProps = {
      infinite: this.props.infinite,
      centerMode: this.props.centerMode,
      currentSlide: this.state.currentSlide,
      slideCount: this.state.slideCount,
      slidesToShow: this.props.slidesToShow,
      prevArrow: this.props.prevArrow,
      nextArrow: this.props.nextArrow,
      clickHandler: this.changeSlide
    };

    if (this.props.arrows) {
      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
    }

    var centerPaddingStyle = null;

    if (this.props.vertical === false) {
      if (this.props.centerMode === true) {
        centerPaddingStyle = {
          padding: '0px ' + this.props.centerPadding
        };
      }
    } else {
      if (this.props.centerMode === true) {
        centerPaddingStyle = {
          padding: this.props.centerPadding + ' 0px'
        };
      }
    }

    return _react2.default.createElement(
      'div',
      { className: className, onMouseEnter: this.onInnerSliderEnter, onMouseLeave: this.onInnerSliderLeave },
      prevArrow,
      _react2.default.createElement(
        'div',
        {
          ref: this.listRefHandler,
          className: 'slick-list',
          style: centerPaddingStyle,
          onMouseDown: this.swipeStart,
          onMouseMove: this.state.dragging ? this.swipeMove : null,
          onMouseUp: this.swipeEnd,
          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
          onTouchStart: this.swipeStart,
          onTouchMove: this.state.dragging ? this.swipeMove : null,
          onTouchEnd: this.swipeEnd,
          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
          onKeyDown: this.props.accessibility ? this.keyHandler : null },
        _react2.default.createElement(
          _track.Track,
          _extends({ ref: this.trackRefHandler }, trackProps),
          this.props.children
        )
      ),
      nextArrow,
      dots
    );
  }
});

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _trackHelper = __webpack_require__(200);

var _helpers = __webpack_require__(201);

var _helpers2 = _interopRequireDefault(_helpers);

var _objectAssign = __webpack_require__(19);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventHandlers = {
  // Event handler for previous and next
  changeSlide: function changeSlide(options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var _props = this.props;
    var slidesToScroll = _props.slidesToScroll;
    var slidesToShow = _props.slidesToShow;
    var _state = this.state;
    var slideCount = _state.slideCount;
    var currentSlide = _state.currentSlide;

    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

    if (options.message === 'previous') {
      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
      targetSlide = currentSlide - slideOffset;
      if (this.props.lazyLoad) {
        previousInt = currentSlide - slideOffset;
        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
      }
    } else if (options.message === 'next') {
      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
      targetSlide = currentSlide + slideOffset;
      if (this.props.lazyLoad) {
        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
      }
    } else if (options.message === 'dots' || options.message === 'children') {
      // Click on dots
      targetSlide = options.index * options.slidesToScroll;
      if (targetSlide === options.currentSlide) {
        return;
      }
    } else if (options.message === 'index') {
      targetSlide = parseInt(options.index);
      if (targetSlide === options.currentSlide) {
        return;
      }
    }

    this.slideHandler(targetSlide);
  },

  // Accessiblity handler for previous and next
  keyHandler: function keyHandler(e) {
    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (e.keyCode === 37 && this.props.accessibility === true) {
        this.changeSlide({
          message: this.props.rtl === true ? 'next' : 'previous'
        });
      } else if (e.keyCode === 39 && this.props.accessibility === true) {
        this.changeSlide({
          message: this.props.rtl === true ? 'previous' : 'next'
        });
      }
    }
  },
  // Focus on selecting a slide (click handler on track)
  selectHandler: function selectHandler(options) {
    this.changeSlide(options);
  },
  swipeStart: function swipeStart(e) {
    var touches, posX, posY;

    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
      return;
    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
      return;
    }
    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
    this.setState({
      dragging: true,
      touchObject: {
        startX: posX,
        startY: posY,
        curX: posX,
        curY: posY
      }
    });
  },
  swipeMove: function swipeMove(e) {
    if (!this.state.dragging) {
      e.preventDefault();
      return;
    }
    if (this.state.animating) {
      return;
    }
    var swipeLeft;
    var curLeft, positionOffset;
    var touchObject = this.state.touchObject;

    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
      slideIndex: this.state.currentSlide,
      trackRef: this.track
    }, this.props, this.state));
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));

    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);

    var currentSlide = this.state.currentSlide;
    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
    var swipeDirection = this.swipeDirection(this.state.touchObject);
    var touchSwipeLength = touchObject.swipeLength;

    if (this.props.infinite === false) {
      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;

        if (this.state.edgeDragged === false && this.props.edgeEvent) {
          this.props.edgeEvent(swipeDirection);
          this.setState({ edgeDragged: true });
        }
      }
    }

    if (this.state.swiped === false && this.props.swipeEvent) {
      this.props.swipeEvent(swipeDirection);
      this.setState({ swiped: true });
    }

    swipeLeft = curLeft + touchSwipeLength * positionOffset;
    this.setState({
      touchObject: touchObject,
      swipeLeft: swipeLeft,
      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
    });

    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
      return;
    }
    if (touchObject.swipeLength > 4) {
      e.preventDefault();
    }
  },
  swipeEnd: function swipeEnd(e) {
    if (!this.state.dragging) {
      e.preventDefault();
      return;
    }
    var touchObject = this.state.touchObject;
    var minSwipe = this.state.listWidth / this.props.touchThreshold;
    var swipeDirection = this.swipeDirection(touchObject);

    // reset the state of touch related state variables.
    this.setState({
      dragging: false,
      edgeDragged: false,
      swiped: false,
      swipeLeft: null,
      touchObject: {}
    });
    // Fix for #13
    if (!touchObject.swipeLength) {
      return;
    }
    if (touchObject.swipeLength > minSwipe) {
      e.preventDefault();
      if (swipeDirection === 'left') {
        this.slideHandler(this.state.currentSlide + this.props.slidesToScroll);
      } else if (swipeDirection === 'right') {
        this.slideHandler(this.state.currentSlide - this.props.slidesToScroll);
      } else {
        this.slideHandler(this.state.currentSlide);
      }
    } else {
      // Adjust the track back to it's original position.
      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
        slideIndex: this.state.currentSlide,
        trackRef: this.track
      }, this.props, this.state));

      this.setState({
        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
      });
    }
  },
  onInnerSliderEnter: function onInnerSliderEnter(e) {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.pause();
    }
  },
  onInnerSliderLeave: function onInnerSliderLeave(e) {
    if (this.props.autoplay && this.props.pauseOnHover) {
      this.autoPlay();
    }
  }
};

exports.default = EventHandlers;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var initialState = {
    animating: false,
    dragging: false,
    autoPlayTimer: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    // listWidth: null,
    // listHeight: null,
    // loadIndex: 0,
    slideCount: null,
    slideWidth: null,
    // sliding: false,
    // slideOffset: 0,
    swipeLeft: null,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },

    lazyLoadedList: [],

    // added for react
    initialized: false,
    edgeDragged: false,
    swiped: false, // used by swipeEvent. differentites between touch and swipe.
    trackStyle: {},
    trackWidth: 0

    // Removed
    // transformsEnabled: false,
    // $nextArrow: null,
    // $prevArrow: null,
    // $dots: null,
    // $list: null,
    // $slideTrack: null,
    // $slides: null,
};

module.exports = initialState;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(19);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  return (0, _classnames2.default)({
    'slick-slide': true,
    'slick-active': slickActive,
    'slick-center': slickCenter,
    'slick-cloned': slickCloned
  });
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = 'relative';
    style.left = -spec.index * spec.slideWidth;
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  // key could be a zero
  return child.key === null || child.key === undefined ? fallbackKey : child.key;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var count = _react2.default.Children.count(spec.children);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: 'children',
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
      child = elem;
    } else {
      child = _react2.default.createElement('div', null);
    }
    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
    var slickClasses = getSlideClasses((0, _objectAssign2.default)({ index: index }, spec));
    var cssClasses;

    if (child.props.className) {
      cssClasses = (0, _classnames2.default)(slickClasses, child.props.className);
    } else {
      cssClasses = slickClasses;
    }

    var onClick = function onClick(e) {
      child.props && child.props.onClick && child.props.onClick(e);
      spec.focusOnSelect(childOnClickOptions);
    };

    slides.push(_react2.default.cloneElement(child, {
      key: 'original' + getKey(child, index),
      'data-index': index,
      className: cssClasses,
      tabIndex: '-1',
      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
      onClick: onClick
    }));

    // variableWidth doesn't wrap properly.
    if (spec.infinite && spec.fade === false) {
      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;

      if (index >= count - infiniteCount) {
        key = -(count - index);
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: 'precloned' + getKey(child, key),
          'data-index': key,
          className: cssClasses,
          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
          onClick: onClick
        }));
      }

      if (index < infiniteCount) {
        key = count + index;
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: 'postcloned' + getKey(child, key),
          'data-index': key,
          className: cssClasses,
          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
          onClick: onClick
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = _react2.default.createClass({
  displayName: 'Track',

  render: function render() {
    var slides = renderSlides.call(this, this.props);
    return _react2.default.createElement(
      'div',
      { className: 'slick-track', style: this.props.trackStyle },
      slides
    );
  }
});

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDotCount = function getDotCount(spec) {
  var dots;
  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  return dots;
};

var Dots = exports.Dots = _react2.default.createClass({
  displayName: 'Dots',


  clickHandler: function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  },
  render: function render() {
    var _this = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {

      var leftBound = i * _this.props.slidesToScroll;
      var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        'slick-active': _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: 'dots',
        index: i,
        slidesToScroll: _this.props.slidesToScroll,
        currentSlide: _this.props.currentSlide
      };

      return _react2.default.createElement(
        'li',
        { key: i, className: className },
        _react2.default.createElement(
          'button',
          { onClick: _this.clickHandler.bind(_this, dotOptions) },
          i + 1
        )
      );
    });

    return _react2.default.createElement(
      'ul',
      { className: this.props.dotsClass, style: { display: 'block' } },
      dots
    );
  }
});

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrevArrow = exports.PrevArrow = _react2.default.createClass({
  displayName: 'PrevArrow',


  clickHandler: function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  },
  render: function render() {
    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses['slick-disabled'] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: '0',
      'data-role': 'none',
      className: (0, _classnames2.default)(prevClasses),
      style: { display: 'block' },
      onClick: prevHandler
    };
    var prevArrow;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, prevArrowProps);
    } else {
      prevArrow = _react2.default.createElement(
        'button',
        _extends({ key: '0', type: 'button' }, prevArrowProps),
        ' Previous'
      );
    }

    return prevArrow;
  }
});

var NextArrow = exports.NextArrow = _react2.default.createClass({
  displayName: 'NextArrow',

  clickHandler: function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  },
  render: function render() {
    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
    var nextHandler = this.clickHandler.bind(this, { message: 'next' });

    if (!this.props.infinite) {
      if (this.props.centerMode && this.props.currentSlide >= this.props.slideCount - 1) {
        nextClasses['slick-disabled'] = true;
        nextHandler = null;
      } else {
        if (this.props.currentSlide >= this.props.slideCount - this.props.slidesToShow) {
          nextClasses['slick-disabled'] = true;
          nextHandler = null;
        }
      }

      if (this.props.slideCount <= this.props.slidesToShow) {
        nextClasses['slick-disabled'] = true;
        nextHandler = null;
      }
    }

    var nextArrowProps = {
      key: '1',
      'data-role': 'none',
      className: (0, _classnames2.default)(nextClasses),
      style: { display: 'block' },
      onClick: nextHandler
    };

    var nextArrow;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, nextArrowProps);
    } else {
      nextArrow = _react2.default.createElement(
        'button',
        _extends({ key: '1', type: 'button' }, nextArrowProps),
        ' Next'
      );
    }

    return nextArrow;
  }
});

/***/ }),
/* 525 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var canUseDOM = __webpack_require__(527);
var enquire = canUseDOM && __webpack_require__(528);
var json2mq = __webpack_require__(203);

var ResponsiveMixin = {
  media: function (query, handler) {
    query = json2mq(query);
    if (typeof handler === 'function') {
      handler = {
        match: handler
      };
    }
    canUseDOM && enquire.register(query, handler);

    // Queue the handlers to unregister them at unmount  
    if (! this._responsiveMediaHandlers) {
      this._responsiveMediaHandlers = [];
    }
    this._responsiveMediaHandlers.push({query: query, handler: handler});
  },
  componentWillUnmount: function () {
    if (this._responsiveMediaHandlers) {
      this._responsiveMediaHandlers.forEach(function(obj) {
        canUseDOM && enquire.unregister(obj.query, obj.handler);
      });
    }
  }
};

module.exports = ResponsiveMixin;


/***/ }),
/* 527 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(529);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(530);
var Util = __webpack_require__(204);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(531);
var each = __webpack_require__(204).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 531 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(533);

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _rcCascader=__webpack_require__(535);var _rcCascader2=_interopRequireDefault(_rcCascader);var _input=__webpack_require__(206);var _input2=_interopRequireDefault(_input);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);var _arrayTreeFilter=__webpack_require__(205);var _arrayTreeFilter2=_interopRequireDefault(_arrayTreeFilter);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _object=__webpack_require__(44);var _object2=_interopRequireDefault(_object);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Cascader=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Cascader,_React$Component);function Cascader(props){(0,_classCallCheck3.default)(this,Cascader);var _this=(0,_possibleConstructorReturn3.default)(this,(Cascader.__proto__||(0,_getPrototypeOf2.default)(Cascader)).call(this,props));_initialiseProps.call(_this);var value=void 0;if('value'in props){value=props.value;}else if('defaultValue'in props){value=props.defaultValue;}_this.state={value:value||[],popupVisible:false};return _this;}(0,_createClass3.default)(Cascader,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if('value'in nextProps){this.setState({value:nextProps.value||[]});}}},{key:'getLabel',value:function getLabel(){var _this2=this;var _props=this.props,options=_props.options,displayRender=_props.displayRender;var selectedOptions=(0,_arrayTreeFilter2.default)(options,function(o,level){return o.value===_this2.state.value[level];});var label=selectedOptions.map(function(o){return o.label;});return displayRender(label,selectedOptions);}},{key:'render',value:function render(){var _classNames,_classNames2;var props=this.props;var prefixCls=props.prefixCls,children=props.children,placeholder=props.placeholder,size=props.size,disabled=props.disabled,className=props.className,style=props.style,allowClear=props.allowClear,otherProps=(0,_objectWithoutProperties3.default)(props,['prefixCls','children','placeholder','size','disabled','className','style','allowClear']);var sizeCls=(0,_classnames2.default)({'ant-input-lg':size==='large','ant-input-sm':size==='small'});var clearIcon=allowClear&&!disabled&&this.state.value.length>0?_react2.default.createElement(_icon2.default,{type:'cross-circle',className:prefixCls+'-picker-clear',onClick:this.clearSelection}):null;var arrowCls=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls+'-picker-arrow',true),(0,_defineProperty3.default)(_classNames,prefixCls+'-picker-arrow-expand',this.state.popupVisible),_classNames));var pickerCls=(0,_classnames2.default)((_classNames2={},(0,_defineProperty3.default)(_classNames2,className,!!className),(0,_defineProperty3.default)(_classNames2,prefixCls+'-picker',true),(0,_defineProperty3.default)(_classNames2,prefixCls+'-picker-disabled',disabled),_classNames2));// Fix bug of https://github.com/facebook/react/pull/5004
// and https://fb.me/react-unknown-prop
var inputProps=(0,_object2.default)(otherProps,['onChange','options','popupPlacement','transitionName','displayRender','onPopupVisibleChange','changeOnSelect','expandTrigger','popupVisible','getPopupContainer','loadData','popupClassName']);return _react2.default.createElement(_rcCascader2.default,(0,_extends3.default)({},props,{value:this.state.value,popupVisible:this.state.popupVisible,onPopupVisibleChange:this.handlePopupVisibleChange,onChange:this.handleChange}),children||_react2.default.createElement('span',{style:style,className:pickerCls},_react2.default.createElement(_input2.default,(0,_extends3.default)({},inputProps,{placeholder:this.state.value&&this.state.value.length>0?null:placeholder,className:prefixCls+'-input '+sizeCls,value:null,disabled:disabled,readOnly:true})),_react2.default.createElement('span',{className:prefixCls+'-picker-label'},this.getLabel()),clearIcon,_react2.default.createElement(_icon2.default,{type:'down',className:arrowCls})));}}]);return Cascader;}(_react2.default.Component),_class.defaultProps={prefixCls:'ant-cascader',placeholder:'Please select',transitionName:'slide-up',popupPlacement:'bottomLeft',onChange:function onChange(){},options:[],displayRender:function displayRender(label){return label.join(' / ');},disabled:false,allowClear:true,onPopupVisibleChange:function onPopupVisibleChange(){}},_initialiseProps=function _initialiseProps(){var _this3=this;this.handleChange=function(value,selectedOptions){_this3.setValue(value,selectedOptions);};this.handlePopupVisibleChange=function(popupVisible){_this3.setState({popupVisible:popupVisible});_this3.props.onPopupVisibleChange(popupVisible);};this.setValue=function(value){var selectedOptions=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];if(!('value'in _this3.props)){_this3.setState({value:value});}_this3.props.onChange(value,selectedOptions);};this.clearSelection=function(e){e.preventDefault();e.stopPropagation();_this3.setValue([]);_this3.setState({popupVisible:false});};},_temp);exports.default=Cascader;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cascader = __webpack_require__(536);

var _Cascader2 = _interopRequireDefault(_Cascader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Cascader2["default"]; // export this package's api

module.exports = exports['default'];

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcTrigger = __webpack_require__(94);

var _rcTrigger2 = _interopRequireDefault(_rcTrigger);

var _Menus = __webpack_require__(537);

var _Menus2 = _interopRequireDefault(_Menus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ['tr', 'br'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topRight: {
    points: ['br', 'tr'],
    offset: [0, -4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  }
};

var Cascader = function (_React$Component) {
  _inherits(Cascader, _React$Component);

  function Cascader(props) {
    _classCallCheck(this, Cascader);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.setPopupVisible = function (popupVisible) {
      if (!('popupVisible' in _this.props)) {
        _this.setState({ popupVisible: popupVisible });
      }
      // sync activeValue with value when panel open
      if (popupVisible && !_this.state.visible) {
        _this.setState({
          activeValue: _this.state.value
        });
      }
      _this.props.onPopupVisibleChange(popupVisible);
    };

    _this.handleChange = function (options, setProps) {
      _this.props.onChange(options.map(function (o) {
        return o.value;
      }), options);
      _this.setPopupVisible(setProps.visible);
    };

    _this.handlePopupVisibleChange = function (popupVisible) {
      _this.setPopupVisible(popupVisible);
    };

    _this.handleSelect = function (_ref) {
      var info = _objectWithoutProperties(_ref, []);

      if ('value' in _this.props) {
        delete info.value;
      }
      _this.setState(info);
    };

    var initialValue = [];
    if ('value' in props) {
      initialValue = props.value || [];
    } else if ('defaultValue' in props) {
      initialValue = props.defaultValue || [];
    }

    _this.state = {
      popupVisible: props.popupVisible,
      activeValue: initialValue,
      value: initialValue
    };
    return _this;
  }

  Cascader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps && this.props.value !== nextProps.value) {
      var newValues = {
        value: nextProps.value || [],
        activeValue: nextProps.value || []
      };
      // allow activeValue diff from value
      // https://github.com/ant-design/ant-design/issues/2767
      if ('loadData' in nextProps) {
        delete newValues.activeValue;
      }
      this.setState(newValues);
    }
    if ('popupVisible' in nextProps) {
      this.setState({
        popupVisible: nextProps.popupVisible
      });
    }
  };

  Cascader.prototype.getPopupDOMNode = function getPopupDOMNode() {
    return this.refs.trigger.getPopupDomNode();
  };

  Cascader.prototype.render = function render() {
    var _props = this.props,
        prefixCls = _props.prefixCls,
        transitionName = _props.transitionName,
        popupClassName = _props.popupClassName,
        options = _props.options,
        disabled = _props.disabled,
        builtinPlacements = _props.builtinPlacements,
        popupPlacement = _props.popupPlacement,
        restProps = _objectWithoutProperties(_props, ['prefixCls', 'transitionName', 'popupClassName', 'options', 'disabled', 'builtinPlacements', 'popupPlacement']);
    // Did not show popup when there is no options


    var menus = _react2["default"].createElement('div', null);
    var emptyMenuClassName = '';
    if (options && options.length > 0) {
      menus = _react2["default"].createElement(_Menus2["default"], _extends({}, this.props, {
        value: this.state.value,
        activeValue: this.state.activeValue,
        onSelect: this.handleSelect,
        onChange: this.handleChange,
        visible: this.state.popupVisible
      }));
    } else {
      emptyMenuClassName = ' ' + prefixCls + '-menus-empty';
    }
    return _react2["default"].createElement(_rcTrigger2["default"], _extends({
      ref: 'trigger'
    }, restProps, {
      options: options,
      disabled: disabled,
      popupPlacement: popupPlacement,
      builtinPlacements: builtinPlacements,
      popupTransitionName: transitionName,
      action: disabled ? [] : ['click'],
      popupVisible: disabled ? false : this.state.popupVisible,
      onPopupVisibleChange: this.handlePopupVisibleChange,
      prefixCls: prefixCls + '-menus',
      popupClassName: popupClassName + emptyMenuClassName,
      popup: menus
    }));
  };

  return Cascader;
}(_react2["default"].Component);

Cascader.defaultProps = {
  options: [],
  onChange: function onChange() {},
  onPopupVisibleChange: function onPopupVisibleChange() {},

  disabled: false,
  transitionName: '',
  prefixCls: 'rc-cascader',
  popupClassName: '',
  popupPlacement: 'bottomLeft',
  builtinPlacements: BUILT_IN_PLACEMENTS
};

Cascader.propTypes = {
  value: _react2["default"].PropTypes.array,
  defaultValue: _react2["default"].PropTypes.array,
  options: _react2["default"].PropTypes.array.isRequired,
  onChange: _react2["default"].PropTypes.func,
  onPopupVisibleChange: _react2["default"].PropTypes.func,
  popupVisible: _react2["default"].PropTypes.bool,
  disabled: _react2["default"].PropTypes.bool,
  transitionName: _react2["default"].PropTypes.string,
  popupClassName: _react2["default"].PropTypes.string,
  popupPlacement: _react2["default"].PropTypes.string,
  prefixCls: _react2["default"].PropTypes.string,
  dropdownMenuColumnStyle: _react2["default"].PropTypes.object,
  builtinPlacements: _react2["default"].PropTypes.object
};

exports["default"] = Cascader;
module.exports = exports['default'];

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _arrayTreeFilter = __webpack_require__(205);

var _arrayTreeFilter2 = _interopRequireDefault(_arrayTreeFilter);

var _reactDom = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Menus = function (_React$Component) {
  _inherits(Menus, _React$Component);

  function Menus() {
    _classCallCheck(this, Menus);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Menus.prototype.componentDidMount = function componentDidMount() {
    this.scrollActiveItemToView();
  };

  Menus.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.scrollActiveItemToView();
    }
  };

  Menus.prototype.onSelect = function onSelect(targetOption, menuIndex) {
    if (!targetOption || targetOption.disabled) {
      return;
    }
    var activeValue = this.props.activeValue;
    activeValue = activeValue.slice(0, menuIndex + 1);
    activeValue[menuIndex] = targetOption.value;
    var activeOptions = this.getActiveOptions(activeValue);
    if (targetOption.isLeaf === false && !targetOption.children && this.props.loadData) {
      if (this.props.changeOnSelect) {
        this.props.onChange(activeOptions, { visible: true });
      }
      this.props.onSelect({ activeValue: activeValue });
      this.props.loadData(activeOptions);
      return;
    }
    var onSelectArgument = {};
    if (!targetOption.children || !targetOption.children.length) {
      this.props.onChange(activeOptions, { visible: false });
      // set value to activeValue when select leaf option
      onSelectArgument.value = activeValue;
    } else if (this.props.changeOnSelect) {
      this.props.onChange(activeOptions, { visible: true });
      // set value to activeValue on every select
      onSelectArgument.value = activeValue;
    }
    onSelectArgument.activeValue = activeValue;
    this.props.onSelect(onSelectArgument);
  };

  Menus.prototype.getOption = function getOption(option, menuIndex) {
    var _props = this.props,
        prefixCls = _props.prefixCls,
        expandTrigger = _props.expandTrigger;

    var onSelect = this.onSelect.bind(this, option, menuIndex);
    var expandProps = {
      onClick: onSelect
    };
    var menuItemCls = prefixCls + '-menu-item';
    var hasChildren = option.children && option.children.length > 0;
    if (hasChildren || option.isLeaf === false) {
      menuItemCls += ' ' + prefixCls + '-menu-item-expand';
    }
    if (expandTrigger === 'hover' && hasChildren) {
      expandProps = {
        onMouseEnter: this.delayOnSelect.bind(this, onSelect),
        onMouseLeave: this.delayOnSelect.bind(this)
      };
    }
    if (this.isActiveOption(option, menuIndex)) {
      menuItemCls += ' ' + prefixCls + '-menu-item-active';
      expandProps.ref = 'activeItem' + menuIndex;
    }
    if (option.disabled) {
      menuItemCls += ' ' + prefixCls + '-menu-item-disabled';
    }
    if (option.loading) {
      menuItemCls += ' ' + prefixCls + '-menu-item-loading';
    }
    var title = '';
    if (option.title) {
      title = option.title;
    } else if (typeof option.label === 'string') {
      title = option.label;
    }
    return _react2["default"].createElement(
      'li',
      _extends({
        key: option.value,
        className: menuItemCls,
        title: title
      }, expandProps),
      option.label
    );
  };

  Menus.prototype.getActiveOptions = function getActiveOptions(values) {
    var activeValue = values || this.props.activeValue;
    var options = this.props.options;
    return (0, _arrayTreeFilter2["default"])(options, function (o, level) {
      return o.value === activeValue[level];
    });
  };

  Menus.prototype.getShowOptions = function getShowOptions() {
    var options = this.props.options;

    var result = this.getActiveOptions().map(function (activeOption) {
      return activeOption.children;
    }).filter(function (activeOption) {
      return !!activeOption;
    });
    result.unshift(options);
    return result;
  };

  Menus.prototype.delayOnSelect = function delayOnSelect(onSelect) {
    var _this2 = this;

    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
    if (typeof onSelect === 'function') {
      this.delayTimer = setTimeout(function () {
        onSelect();
        _this2.delayTimer = null;
      }, 150);
    }
  };

  Menus.prototype.scrollActiveItemToView = function scrollActiveItemToView() {
    // scroll into view
    var optionsLength = this.getShowOptions().length;
    for (var i = 0; i < optionsLength; i++) {
      var itemComponent = this.refs['activeItem' + i];
      if (itemComponent) {
        var target = (0, _reactDom.findDOMNode)(itemComponent);
        target.parentNode.scrollTop = target.offsetTop;
      }
    }
  };

  Menus.prototype.isActiveOption = function isActiveOption(option, menuIndex) {
    var _props$activeValue = this.props.activeValue,
        activeValue = _props$activeValue === undefined ? [] : _props$activeValue;

    return activeValue[menuIndex] === option.value;
  };

  Menus.prototype.render = function render() {
    var _this3 = this;

    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        dropdownMenuColumnStyle = _props2.dropdownMenuColumnStyle;

    return _react2["default"].createElement(
      'div',
      null,
      this.getShowOptions().map(function (options, menuIndex) {
        return _react2["default"].createElement(
          'ul',
          { className: prefixCls + '-menu', key: menuIndex, style: dropdownMenuColumnStyle },
          options.map(function (option) {
            return _this3.getOption(option, menuIndex);
          })
        );
      })
    );
  };

  return Menus;
}(_react2["default"].Component);

Menus.defaultProps = {
  options: [],
  value: [],
  activeValue: [],
  onChange: function onChange() {},
  onSelect: function onSelect() {},

  prefixCls: 'rc-cascader-menus',
  visible: false,
  expandTrigger: 'click',
  changeOnSelect: false
};

Menus.propTypes = {
  value: _react2["default"].PropTypes.array,
  activeValue: _react2["default"].PropTypes.array,
  options: _react2["default"].PropTypes.array.isRequired,
  prefixCls: _react2["default"].PropTypes.string,
  expandTrigger: _react2["default"].PropTypes.string,
  onChange: _react2["default"].PropTypes.func,
  onSelect: _react2["default"].PropTypes.func,
  loadData: _react2["default"].PropTypes.func,
  visible: _react2["default"].PropTypes.bool,
  changeOnSelect: _react2["default"].PropTypes.bool,
  dropdownMenuColumnStyle: _react2["default"].PropTypes.object
};

exports["default"] = Menus;
module.exports = exports['default'];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _calculateNodeHeight=__webpack_require__(539);var _calculateNodeHeight2=_interopRequireDefault(_calculateNodeHeight);var _object=__webpack_require__(44);var _object2=_interopRequireDefault(_object);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function fixControlledValue(value){if(typeof value==="undefined"||value===null){return"";}return value;}function onNextFrame(cb){if(window.requestAnimationFrame){return window.requestAnimationFrame(cb);}return window.setTimeout(cb,1);}function clearNextFrameAction(nextFrameId){if(window.cancelAnimationFrame){window.cancelAnimationFrame(nextFrameId);}else{window.clearTimeout(nextFrameId);}}var Input=(_temp=_class=function(_Component){(0,_inherits3.default)(Input,_Component);function Input(props){(0,_classCallCheck3.default)(this,Input);var _this=(0,_possibleConstructorReturn3.default)(this,(Input.__proto__||(0,_getPrototypeOf2.default)(Input)).call(this,props));_this.handleKeyDown=function(e){if(e.keyCode===13){_this.props.onPressEnter(e);}_this.props.onKeyDown(e);};_this.handleClick=function(e){var inputNode=_this.refs.input;if(inputNode.pasteValue){_this.props.onClick(e,inputNode.pasteValue);_this.props.onChange(e);inputNode.pasteValue="";}else{_this.props.onClick(e,e.target.value);}};_this.handleTextareaChange=function(e){if(!("value"in _this.props)){_this.resizeTextarea();}_this.props.onChange(e);};_this.resizeTextarea=function(){var _this$props=_this.props,type=_this$props.type,autosize=_this$props.autosize;if(type!=="textarea"||!autosize||!_this.refs.input){return;}var minRows=autosize?autosize.minRows:null;var maxRows=autosize?autosize.maxRows:null;var textareaStyles=(0,_calculateNodeHeight2.default)(_this.refs.input,false,minRows,maxRows);_this.setState({textareaStyles:textareaStyles});};_this.state={textareaStyles:null};return _this;}(0,_createClass3.default)(Input,[{key:"componentDidMount",value:function componentDidMount(){this.resizeTextarea();}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){// Re-render with the new content then recalculate the height as required.
if(this.props.value!==nextProps.value||this.props.autosize.minRows!==nextProps.autosize.minRows||this.props.autosize.maxRows!==nextProps.autosize.maxRows){if(this.nextFrameActionId){clearNextFrameAction(this.nextFrameActionId);}this.nextFrameActionId=onNextFrame(this.resizeTextarea);}}},{key:"renderLabledInput",value:function renderLabledInput(children){var _classNames;var props=this.props;var wrapperClassName=props.prefixCls+"-group";var addonClassName=wrapperClassName+"-addon";var addonBefore=props.addonBefore?_react2.default.createElement("span",{className:addonClassName},props.addonBefore):null;var addonAfter=props.addonAfter?_react2.default.createElement("span",{className:addonClassName},props.addonAfter):null;var className=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,props.prefixCls+"-wrapper",true),(0,_defineProperty3.default)(_classNames,wrapperClassName,addonBefore||addonAfter),_classNames));return _react2.default.createElement("span",{className:className},addonBefore,children,addonAfter);}},{key:"renderInput",value:function renderInput(){var _classNames2;var props=(0,_extends3.default)({},this.props);// Fix https://fb.me/react-unknown-prop
var otherProps=(0,_object2.default)(this.props,["prefixCls","onPressEnter","autosize","addonBefore","addonAfter"]);var prefixCls=props.prefixCls;if(!props.type){return props.children;}var inputClassName=(0,_classnames2.default)((_classNames2={},(0,_defineProperty3.default)(_classNames2,prefixCls,true),(0,_defineProperty3.default)(_classNames2,prefixCls+"-sm",props.size==="small"),(0,_defineProperty3.default)(_classNames2,prefixCls+"-lg",props.size==="large"),(0,_defineProperty3.default)(_classNames2,props.className,!!props.className),_classNames2));if("value"in props){otherProps.value=fixControlledValue(props.value);// Input elements must be either controlled or uncontrolled,
// specify either the value prop, or the defaultValue prop, but not both.
delete otherProps.defaultValue;}switch(props.type){case"textarea":return _react2.default.createElement("textarea",(0,_extends3.default)({},otherProps,{style:(0,_extends3.default)({},props.style,this.state.textareaStyles),onClick:this.handleClick,className:inputClassName,onKeyDown:this.handleKeyDown,onChange:this.handleTextareaChange,ref:"input",ecId:this.props.ecId+"_textarea@0kd6bb"}));default:return _react2.default.createElement("input",(0,_extends3.default)({},otherProps,{onClick:this.handleClick,className:inputClassName,onKeyDown:this.handleKeyDown,ref:"input",ecId:this.props.ecId+"_input@myym7t"}));}}},{key:"render",value:function render(){return this.renderLabledInput(this.renderInput());}}]);return Input;}(_react.Component),_class.defaultProps={defaultValue:"",disabled:false,prefixCls:"ant-input",type:"text",onPressEnter:function onPressEnter(){},onKeyDown:function onKeyDown(){},onChange:function onChange(){},onClick:function onClick(){},autosize:false},_class.propTypes={type:_react.PropTypes.string,id:_react.PropTypes.oneOfType([_react.PropTypes.string,_react.PropTypes.number]),size:_react.PropTypes.oneOf(["small","default","large"]),disabled:_react.PropTypes.bool,value:_react.PropTypes.any,defaultValue:_react.PropTypes.any,className:_react.PropTypes.string,addonBefore:_react.PropTypes.node,addonAfter:_react.PropTypes.node,prefixCls:_react.PropTypes.string,autosize:_react.PropTypes.oneOfType([_react.PropTypes.bool,_react.PropTypes.object]),onPressEnter:_react.PropTypes.func,onKeyDown:_react.PropTypes.func},_temp);exports.default=Input;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=calculateNodeHeight;// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */var HIDDEN_TEXTAREA_STYLE='\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';var SIZING_STYLE=['letter-spacing','line-height','padding-top','padding-bottom','font-family','font-weight','font-size','text-rendering','text-transform','width','text-indent','padding-left','padding-right','border-width','box-sizing'];var computedStyleCache={};var hiddenTextarea=void 0;function calculateNodeStyling(node){var useCache=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var nodeRef=node.getAttribute('id')||node.getAttribute('data-reactid')||node.getAttribute('name');if(useCache&&computedStyleCache[nodeRef]){return computedStyleCache[nodeRef];}var style=window.getComputedStyle(node);var boxSizing=style.getPropertyValue('box-sizing')||style.getPropertyValue('-moz-box-sizing')||style.getPropertyValue('-webkit-box-sizing');var paddingSize=parseFloat(style.getPropertyValue('padding-bottom'))+parseFloat(style.getPropertyValue('padding-top'));var borderSize=parseFloat(style.getPropertyValue('border-bottom-width'))+parseFloat(style.getPropertyValue('border-top-width'));var sizingStyle=SIZING_STYLE.map(function(name){return name+':'+style.getPropertyValue(name);}).join(';');var nodeInfo={sizingStyle:sizingStyle,paddingSize:paddingSize,borderSize:borderSize,boxSizing:boxSizing};if(useCache&&nodeRef){computedStyleCache[nodeRef]=nodeInfo;}return nodeInfo;}function calculateNodeHeight(uiTextNode){var useCache=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var minRows=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var maxRows=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;if(!hiddenTextarea){hiddenTextarea=document.createElement('textarea');document.body.appendChild(hiddenTextarea);}// Copy all CSS properties that have an impact on the height of the content in
// the textbox
var _calculateNodeStyling=calculateNodeStyling(uiTextNode,useCache),paddingSize=_calculateNodeStyling.paddingSize,borderSize=_calculateNodeStyling.borderSize,boxSizing=_calculateNodeStyling.boxSizing,sizingStyle=_calculateNodeStyling.sizingStyle;// Need to have the overflow attribute to hide the scrollbar otherwise
// text-lines will not calculated properly as the shadow will technically be
// narrower for content
hiddenTextarea.setAttribute('style',sizingStyle+';'+HIDDEN_TEXTAREA_STYLE);hiddenTextarea.value=uiTextNode.value||uiTextNode.placeholder||'';var minHeight=-Infinity;var maxHeight=Infinity;var height=hiddenTextarea.scrollHeight;if(boxSizing==='border-box'){// border-box: add border, since height = content + padding + border
height=height+borderSize;}else if(boxSizing==='content-box'){// remove padding, since height = content
height=height-paddingSize;}if(minRows!==null||maxRows!==null){// measure height of a textarea with a single row
hiddenTextarea.value='';var singleRowHeight=hiddenTextarea.scrollHeight-paddingSize;if(minRows!==null){minHeight=singleRowHeight*minRows;if(boxSizing==='border-box'){minHeight=minHeight+paddingSize+borderSize;}height=Math.max(minHeight,height);}if(maxRows!==null){maxHeight=singleRowHeight*maxRows;if(boxSizing==='border-box'){maxHeight=maxHeight+paddingSize+borderSize;}height=Math.min(maxHeight,height);}}return{height:height+2,minHeight:minHeight+2,maxHeight:maxHeight};}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);exports.default=Group;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function Group(props){var className=(0,_classnames2.default)((0,_defineProperty3.default)({'ant-input-group':true,'ant-input-group-lg':props.size==='large','ant-input-group-sm':props.size==='small'},props.className,!!props.className));return _react2.default.createElement('span',{className:className,style:props.style},props.children);}Group.propTypes={children:_react2.default.PropTypes.any};

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(542);__webpack_require__(37);

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(544);

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PureRenderMixin = __webpack_require__(545);

var _PureRenderMixin2 = _interopRequireDefault(_PureRenderMixin);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Checkbox = function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox(props) {
    _classCallCheck(this, Checkbox);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleFocus = function (e) {
      _this.setState({ focus: true });
      _this.props.onFocus(e);
    };

    _this.handleBlur = function (e) {
      _this.setState({ focus: false });
      _this.props.onBlur(e);
    };

    _this.handleChange = function (e) {
      if (_this.props.disabled) {
        return;
      }
      if (!('checked' in _this.props)) {
        _this.setState({
          checked: e.target.checked
        });
      }
      _this.props.onChange({
        target: _extends({}, _this.props, {
          checked: e.target.checked
        }),
        stopPropagation: function stopPropagation() {
          e.stopPropagation();
        },
        preventDefault: function preventDefault() {
          e.preventDefault();
        }
      });
    };

    var checked = false;
    if ('checked' in props) {
      checked = props.checked;
    } else {
      checked = props.defaultChecked;
    }
    _this.state = {
      checked: checked,
      focus: false
    };
    return _this;
  }

  Checkbox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({
        checked: nextProps.checked
      });
    }
  };

  Checkbox.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _PureRenderMixin2["default"].shouldComponentUpdate.apply(this, args);
  };

  Checkbox.prototype.render = function render() {
    var _classNames;

    var props = _extends({}, this.props);
    // Remove React warning.
    // Warning: Input elements must be either controlled or uncontrolled
    // (specify either the value prop, or the defaultValue prop, but not both).
    delete props.defaultChecked;

    var state = this.state;
    var prefixCls = props.prefixCls;
    var checked = state.checked;
    if (typeof checked === 'boolean') {
      checked = checked ? 1 : 0;
    }
    var className = (0, _classnames2["default"])((_classNames = {}, _defineProperty(_classNames, props.className, !!props.className), _defineProperty(_classNames, prefixCls, 1), _defineProperty(_classNames, prefixCls + '-checked', checked), _defineProperty(_classNames, prefixCls + '-checked-' + checked, !!checked), _defineProperty(_classNames, prefixCls + '-focused', state.focus), _defineProperty(_classNames, prefixCls + '-disabled', props.disabled), _classNames));
    return _react2["default"].createElement(
      'span',
      {
        className: className,
        style: props.style
      },
      _react2["default"].createElement('span', { className: prefixCls + '-inner' }),
      _react2["default"].createElement('input', {
        name: props.name,
        type: props.type,
        readOnly: props.readOnly,
        disabled: props.disabled,
        tabIndex: props.tabIndex,
        className: prefixCls + '-input',
        checked: !!checked,
        onClick: this.props.onClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: this.handleChange
      })
    );
  };

  return Checkbox;
}(_react2["default"].Component);

Checkbox.propTypes = {
  name: _react2["default"].PropTypes.string,
  prefixCls: _react2["default"].PropTypes.string,
  style: _react2["default"].PropTypes.object,
  type: _react2["default"].PropTypes.string,
  className: _react2["default"].PropTypes.string,
  defaultChecked: _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.number, _react2["default"].PropTypes.bool]),
  disabled: _react2["default"].PropTypes.bool,
  checked: _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.number, _react2["default"].PropTypes.bool]),
  onFocus: _react2["default"].PropTypes.func,
  onBlur: _react2["default"].PropTypes.func,
  onChange: _react2["default"].PropTypes.func,
  onClick: _react2["default"].PropTypes.func
};
Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  style: {},
  type: 'checkbox',
  className: '',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};
exports["default"] = Checkbox;
module.exports = exports['default'];

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentWithPureRenderMixin
 */
var shallowEqual = __webpack_require__(546);

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}
/**
 * If your React component's render function is "pure", e.g. it will render the
 * same result given the same props and state, provide this mixin for a
 * considerable performance boost.
 *
 * Most React components have pure render functions.
 *
 * Example:
 *
 *   var ReactComponentWithPureRenderMixin =
 *     require('ReactComponentWithPureRenderMixin');
 *   React.createClass({
 *     mixins: [ReactComponentWithPureRenderMixin],
 *
 *     render: function() {
 *       return <div className={this.props.className}>foo</div>;
 *     }
 *   });
 *
 * Note: This only checks shallow equality for props and state. If these contain
 * complex data structures this mixin may have false-negatives for deeper
 * differences. Only mixin to components which have simple props and state, or
 * use `forceUpdate()` when you know deep data structures have changed.
 *
 * See https://facebook.github.io/react/docs/pure-render-mixin.html
 */


var ReactComponentWithPureRenderMixin = {
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
};
module.exports = ReactComponentWithPureRenderMixin;

/***/ }),
/* 546 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _toConsumableArray2=__webpack_require__(46);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _checkbox=__webpack_require__(207);var _checkbox2=_interopRequireDefault(_checkbox);var _reactAddonsPureRenderMixin=__webpack_require__(38);var _reactAddonsPureRenderMixin2=_interopRequireDefault(_reactAddonsPureRenderMixin);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckboxGroup=(_temp=_class=function(_React$Component){(0,_inherits3.default)(CheckboxGroup,_React$Component);function CheckboxGroup(props){(0,_classCallCheck3.default)(this,CheckboxGroup);var _this=(0,_possibleConstructorReturn3.default)(this,(CheckboxGroup.__proto__||(0,_getPrototypeOf2.default)(CheckboxGroup)).call(this,props));_initialiseProps.call(_this);var value=void 0;if("value"in props){value=props.value||[];}else if("defaultValue"in props){value=props.defaultValue||[];}_this.state={value:value};return _this;}(0,_createClass3.default)(CheckboxGroup,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if("value"in nextProps){this.setState({value:nextProps.value||[]});}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.apply(this,args);}},{key:"getOptions",value:function getOptions(){var options=this.props.options;return options.map(function(option){if(typeof option==="string"){return{label:option,value:option};}return option;});}},{key:"render",value:function render(){var _this2=this;var options=this.getOptions();return _react2.default.createElement("div",{className:"ant-checkbox-group"},options.map(function(option,index){return _react2.default.createElement(_checkbox2.default,{ecId:_this2.props.ecId+"_Checkbox@uw9wnv@"+index,disabled:"disabled"in option?option.disabled:_this2.props.disabled,checked:_this2.state.value.indexOf(option.value)!==-1,onChange:function onChange(){return _this2.toggleOption(option);},style:option.style,className:"ant-checkbox-group-item",key:option.value},option.label);}));}}]);return CheckboxGroup;}(_react2.default.Component),_class.defaultProps={options:[],defaultValue:[],onChange:function onChange(){}},_class.propTypes={defaultValue:_react2.default.PropTypes.array,value:_react2.default.PropTypes.array,options:_react2.default.PropTypes.array.isRequired,onChange:_react2.default.PropTypes.func},_initialiseProps=function _initialiseProps(){var _this3=this;this.toggleOption=function(option){var optionIndex=_this3.state.value.indexOf(option.value);var value=[].concat((0,_toConsumableArray3.default)(_this3.state.value));if(optionIndex===-1){value.push(option.value);}else{value.splice(optionIndex,1);}if(!("value"in _this3.props)){_this3.setState({value:value});}_this3.props.onChange(value);};},_temp);exports.default=CheckboxGroup;

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Row=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Row,_React$Component);function Row(){(0,_classCallCheck3.default)(this,Row);return(0,_possibleConstructorReturn3.default)(this,(Row.__proto__||(0,_getPrototypeOf2.default)(Row)).apply(this,arguments));}(0,_createClass3.default)(Row,[{key:"render",value:function render(){var _classNames;var _props=this.props,type=_props.type,justify=_props.justify,align=_props.align,className=_props.className,gutter=_props.gutter,style=_props.style,children=_props.children,others=(0,_objectWithoutProperties3.default)(_props,["type","justify","align","className","gutter","style","children"]);var classes=(0,_classnames2.default)((_classNames={"ant-row":!type},(0,_defineProperty3.default)(_classNames,"ant-row-"+type,type),(0,_defineProperty3.default)(_classNames,"ant-row-"+type+"-"+justify,justify),(0,_defineProperty3.default)(_classNames,"ant-row-"+type+"-"+align,align),(0,_defineProperty3.default)(_classNames,className,className),_classNames));var rowStyle=gutter>0?(0,_extends3.default)({marginLeft:gutter/-2,marginRight:gutter/-2},style):style;var cols=_react.Children.map(children,function(col){if(!col){return null;}if(col.props){return(0,_react.cloneElement)(col,{style:gutter>0?(0,_extends3.default)({paddingLeft:gutter/2,paddingRight:gutter/2},col.props.style):col.props.style});}return col;});return _react2.default.createElement("div",(0,_extends3.default)({},others,{ecId:this.props.ecId+"_div@qu6vnd",className:classes,style:rowStyle}),cols);}}]);return Row;}(_react2.default.Component),_class.defaultProps={gutter:0},_class.propTypes={type:_react2.default.PropTypes.string,align:_react2.default.PropTypes.string,justify:_react2.default.PropTypes.string,className:_react2.default.PropTypes.string,children:_react2.default.PropTypes.node,gutter:_react2.default.PropTypes.number},_temp);exports.default=Row;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends4=__webpack_require__(1);var _extends5=_interopRequireDefault(_extends4);var _typeof2=__webpack_require__(23);var _typeof3=_interopRequireDefault(_typeof2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);exports.default=Col;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var stringOrNumber=_react.PropTypes.oneOfType([_react.PropTypes.string,_react.PropTypes.number]);var objectOrNumber=_react.PropTypes.oneOfType([_react.PropTypes.object,_react.PropTypes.number]);function Col(props){var _extends3;var span=props.span,order=props.order,offset=props.offset,push=props.push,pull=props.pull,className=props.className,children=props.children,others=(0,_objectWithoutProperties3.default)(props,["span","order","offset","push","pull","className","children"]);var sizeClassObj={};["xs","sm","md","lg"].forEach(function(size){var _extends2;var sizeProps={};if(typeof props[size]==="number"){sizeProps.span=props[size];}else if((0,_typeof3.default)(props[size])==="object"){sizeProps=props[size]||{};}delete others[size];sizeClassObj=(0,_extends5.default)({},sizeClassObj,(_extends2={},(0,_defineProperty3.default)(_extends2,"ant-col-"+size+"-"+sizeProps.span,sizeProps.span!==undefined),(0,_defineProperty3.default)(_extends2,"ant-col-"+size+"-order-"+sizeProps.order,sizeProps.order),(0,_defineProperty3.default)(_extends2,"ant-col-"+size+"-offset-"+sizeProps.offset,sizeProps.offset),(0,_defineProperty3.default)(_extends2,"ant-col-"+size+"-push-"+sizeProps.push,sizeProps.push),(0,_defineProperty3.default)(_extends2,"ant-col-"+size+"-pull-"+sizeProps.pull,sizeProps.pull),_extends2));});var classes=(0,_classnames2.default)((0,_extends5.default)((_extends3={},(0,_defineProperty3.default)(_extends3,"ant-col-"+span,span!==undefined),(0,_defineProperty3.default)(_extends3,"ant-col-order-"+order,order),(0,_defineProperty3.default)(_extends3,"ant-col-offset-"+offset,offset),(0,_defineProperty3.default)(_extends3,"ant-col-push-"+push,push),(0,_defineProperty3.default)(_extends3,"ant-col-pull-"+pull,pull),(0,_defineProperty3.default)(_extends3,className,!!className),_extends3),sizeClassObj));return _react2.default.createElement("div",(0,_extends5.default)({},others,{ecId:props.ecId+"_div@qjebvs",className:classes}),children);}Col.propTypes={span:stringOrNumber,order:stringOrNumber,offset:stringOrNumber,push:stringOrNumber,pull:stringOrNumber,className:_react.PropTypes.string,children:_react.PropTypes.node,xs:objectOrNumber,sm:objectOrNumber,md:objectOrNumber,lg:objectOrNumber};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(132);

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _rcCollapse=__webpack_require__(553);var _rcCollapse2=_interopRequireDefault(_rcCollapse);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Collapse=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Collapse,_React$Component);function Collapse(){(0,_classCallCheck3.default)(this,Collapse);return(0,_possibleConstructorReturn3.default)(this,(Collapse.__proto__||(0,_getPrototypeOf2.default)(Collapse)).apply(this,arguments));}(0,_createClass3.default)(Collapse,[{key:'render',value:function render(){return _react2.default.createElement(_rcCollapse2.default,this.props);}}]);return Collapse;}(_react2.default.Component),_class.Panel=_rcCollapse2.default.Panel,_class.defaultProps={prefixCls:'ant-collapse'},_temp);exports.default=Collapse;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Collapse = __webpack_require__(554);

var _Collapse2 = _interopRequireDefault(_Collapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Collapse2["default"];
module.exports = exports['default'];

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Panel = __webpack_require__(555);

var _Panel2 = _interopRequireDefault(_Panel);

var _openAnimationFactory = __webpack_require__(557);

var _openAnimationFactory2 = _interopRequireDefault(_openAnimationFactory);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function toArray(activeKey) {
  var currentActiveKey = activeKey;
  if (!Array.isArray(currentActiveKey)) {
    currentActiveKey = currentActiveKey ? [currentActiveKey] : [];
  }
  return currentActiveKey;
}

var Collapse = _react2["default"].createClass({
  displayName: 'Collapse',

  propTypes: {
    children: _react.PropTypes.any,
    prefixCls: _react.PropTypes.string,
    activeKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]),
    defaultActiveKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]),
    openAnimation: _react.PropTypes.object,
    onChange: _react.PropTypes.func,
    accordion: _react.PropTypes.bool,
    className: _react.PropTypes.string,
    style: _react.PropTypes.object
  },

  statics: {
    Panel: _Panel2["default"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      prefixCls: 'rc-collapse',
      onChange: function onChange() {},

      accordion: false
    };
  },
  getInitialState: function getInitialState() {
    var _props = this.props,
        activeKey = _props.activeKey,
        defaultActiveKey = _props.defaultActiveKey;

    var currentActiveKey = defaultActiveKey;
    if ('activeKey' in this.props) {
      currentActiveKey = activeKey;
    }
    return {
      openAnimation: this.props.openAnimation || (0, _openAnimationFactory2["default"])(this.props.prefixCls),
      activeKey: toArray(currentActiveKey)
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if ('activeKey' in nextProps) {
      this.setState({
        activeKey: toArray(nextProps.activeKey)
      });
    }
    if ('openAnimation' in nextProps) {
      this.setState({
        openAnimation: nextProps.openAnimation
      });
    }
  },
  onClickItem: function onClickItem(key) {
    var _this = this;

    return function () {
      var activeKey = _this.state.activeKey;
      if (_this.props.accordion) {
        activeKey = activeKey[0] === key ? [] : [key];
      } else {
        activeKey = [].concat(_toConsumableArray(activeKey));
        var index = activeKey.indexOf(key);
        var isActive = index > -1;
        if (isActive) {
          // remove active state
          activeKey.splice(index, 1);
        } else {
          activeKey.push(key);
        }
      }
      _this.setActiveKey(activeKey);
    };
  },
  getItems: function getItems() {
    var _this2 = this;

    var activeKey = this.state.activeKey;
    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        accordion = _props2.accordion;

    var newChildren = [];

    _react.Children.forEach(this.props.children, function (child, index) {
      if (!child) return;
      // If there is no key provide, use the panel order as default key
      var key = child.key || String(index);
      var header = child.props.header;
      var isActive = false;
      if (accordion) {
        isActive = activeKey[0] === key;
      } else {
        isActive = activeKey.indexOf(key) > -1;
      }

      var props = {
        key: key,
        header: header,
        isActive: isActive,
        prefixCls: prefixCls,
        openAnimation: _this2.state.openAnimation,
        children: child.props.children,
        onItemClick: _this2.onClickItem(key).bind(_this2)
      };

      newChildren.push(_react2["default"].cloneElement(child, props));
    });

    return newChildren;
  },
  setActiveKey: function setActiveKey(activeKey) {
    if (!('activeKey' in this.props)) {
      this.setState({ activeKey: activeKey });
    }
    this.props.onChange(this.props.accordion ? activeKey[0] : activeKey);
  },
  render: function render() {
    var _classNames;

    var _props3 = this.props,
        prefixCls = _props3.prefixCls,
        className = _props3.className,
        style = _props3.style;

    var collapseClassName = (0, _classnames2["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, className, !!className), _classNames));
    return _react2["default"].createElement(
      'div',
      { className: collapseClassName, style: style },
      this.getItems()
    );
  }
});

exports["default"] = Collapse;
module.exports = exports['default'];

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _PanelContent = __webpack_require__(556);

var _PanelContent2 = _interopRequireDefault(_PanelContent);

var _rcAnimate = __webpack_require__(18);

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CollapsePanel = _react2["default"].createClass({
  displayName: 'CollapsePanel',

  propTypes: {
    className: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
    children: _react.PropTypes.any,
    openAnimation: _react.PropTypes.object,
    prefixCls: _react.PropTypes.string,
    header: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.node]),
    showArrow: _react.PropTypes.bool,
    isActive: _react.PropTypes.bool,
    onItemClick: _react.PropTypes.func,
    style: _react.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      showArrow: true,
      isActive: false,
      onItemClick: function onItemClick() {}
    };
  },
  handleItemClick: function handleItemClick() {
    this.props.onItemClick();
  },
  render: function render() {
    var _classNames;

    var _props = this.props,
        className = _props.className,
        style = _props.style,
        prefixCls = _props.prefixCls,
        header = _props.header,
        children = _props.children,
        isActive = _props.isActive,
        showArrow = _props.showArrow;

    var headerCls = prefixCls + '-header';
    var itemCls = (0, _classnames2["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls + '-item', true), _defineProperty(_classNames, prefixCls + '-item-active', isActive), _classNames), className);
    return _react2["default"].createElement(
      'div',
      { className: itemCls, style: style },
      _react2["default"].createElement(
        'div',
        {
          className: headerCls,
          onClick: this.handleItemClick,
          role: 'tab',
          'aria-expanded': isActive
        },
        showArrow && _react2["default"].createElement('i', { className: 'arrow' }),
        header
      ),
      _react2["default"].createElement(
        _rcAnimate2["default"],
        {
          showProp: 'isActive',
          exclusive: true,
          component: '',
          animation: this.props.openAnimation
        },
        _react2["default"].createElement(
          _PanelContent2["default"],
          { prefixCls: prefixCls, isActive: isActive },
          children
        )
      )
    );
  }
});

exports["default"] = CollapsePanel;
module.exports = exports['default'];

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PanelContent = _react2["default"].createClass({
  displayName: 'PanelContent',

  propTypes: {
    prefixCls: _react.PropTypes.string,
    isActive: _react.PropTypes.bool,
    children: _react.PropTypes.any
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    return this.props.isActive || nextProps.isActive;
  },
  render: function render() {
    var _classnames;

    this._isActived = this._isActived || this.props.isActive;
    if (!this._isActived) {
      return null;
    }
    var _props = this.props,
        prefixCls = _props.prefixCls,
        isActive = _props.isActive,
        children = _props.children;

    var contentCls = (0, _classnames3["default"])((_classnames = {}, _defineProperty(_classnames, prefixCls + '-content', true), _defineProperty(_classnames, prefixCls + '-content-active', isActive), _defineProperty(_classnames, prefixCls + '-content-inactive', !isActive), _classnames));
    return _react2["default"].createElement(
      'div',
      {
        className: contentCls,
        role: 'tabpanel'
      },
      _react2["default"].createElement(
        'div',
        { className: prefixCls + '-content-box' },
        children
      )
    );
  }
});

exports["default"] = PanelContent;
module.exports = exports['default'];

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cssAnimation = __webpack_require__(120);

var _cssAnimation2 = _interopRequireDefault(_cssAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function animate(node, show, transitionName, done) {
  var height = void 0;
  return (0, _cssAnimation2["default"])(node, transitionName, {
    start: function start() {
      if (!show) {
        node.style.height = node.offsetHeight + 'px';
      } else {
        height = node.offsetHeight;
        node.style.height = 0;
      }
    },
    active: function active() {
      node.style.height = (show ? height : 0) + 'px';
    },
    end: function end() {
      node.style.height = '';
      done();
    }
  });
}

function animation(prefixCls) {
  return {
    enter: function enter(node, done) {
      return animate(node, true, prefixCls + '-anim', done);
    },
    leave: function leave(node, done) {
      return animate(node, false, prefixCls + '-anim', done);
    }
  };
}

exports["default"] = animation;
module.exports = exports['default'];

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(559);

/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _rcCalendar=__webpack_require__(263);var _rcCalendar2=_interopRequireDefault(_rcCalendar);var _createPicker=__webpack_require__(565);var _createPicker2=_interopRequireDefault(_createPicker);var _wrapPicker=__webpack_require__(566);var _wrapPicker2=_interopRequireDefault(_wrapPicker);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import RangePicker from "./RangePicker";
// import DateGroup from "./DateGroup";
// import Calendar from "./Calendar";
// import MonthCalendar from "../../_rc-calendar-5.6.2/src/MonthCalendar";
// import YearCalendar from "../../_rc-calendar-5.6.2/src/YearCalendar";
var MonthCalendar=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 798));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var YearCalendar=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 799));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var RangePicker=(0,_reactLoadable2.default)({loader:function loader(){return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 800));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var DateGroup=(0,_reactLoadable2.default)({loader:function loader(){return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 801));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var DatePicker=(0,_wrapPicker2.default)((0,_createPicker2.default)(_rcCalendar2.default));var MonthPicker=(0,_wrapPicker2.default)((0,_createPicker2.default)(MonthCalendar,"yyyy-MM"),"yyyy-MM");var YearPicker=(0,_wrapPicker2.default)((0,_createPicker2.default)(YearCalendar),"yyyy");DatePicker.Calendar=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 802));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});DatePicker.RangePicker=(0,_wrapPicker2.default)(RangePicker,"yyyy-MM-dd");DatePicker.DateGroup=(0,_wrapPicker2.default)(DateGroup,"yyyy-MM-dd");DatePicker.MonthPicker=MonthPicker;DatePicker.YearPicker=YearPicker;exports.default=DatePicker;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Calendar=__webpack_require__(562);var _Calendar2=_interopRequireDefault(_Calendar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import Loadable from "../../react-loadable";
// const Calendar = Loadable({
//   loader: () => import("./Calendar"),
//   loading: () => <div style={{ width: 231, height: 314 }} />,
//   render: (obj, props, ref) => {
//     if (obj) {
//       return React.createElement(obj && obj.__esModule ? obj.default : obj, {
//         ...props,
//         ref
//       });
//     }
//     return null;
//   }
// });
exports.default=_Calendar2.default;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gregorianCalendar=__webpack_require__(95);var _gregorianCalendar2=_interopRequireDefault(_gregorianCalendar);var _KeyCode=__webpack_require__(47);var _KeyCode2=_interopRequireDefault(_KeyCode);var _DateTable=__webpack_require__(251);var _DateTable2=_interopRequireDefault(_DateTable);var _CalendarHeader=__webpack_require__(264);var _CalendarHeader2=_interopRequireDefault(_CalendarHeader);var _CalendarFooter=__webpack_require__(564);var _CalendarFooter2=_interopRequireDefault(_CalendarFooter);var _CalendarMixin=__webpack_require__(247);var _CalendarMixin2=_interopRequireDefault(_CalendarMixin);var _CommonMixin=__webpack_require__(243);var _CommonMixin2=_interopRequireDefault(_CommonMixin);var _DateInput=__webpack_require__(268);var _DateInput2=_interopRequireDefault(_DateInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function noop(){}function goStartMonth(){var next=this.state.value.clone();next.setDayOfMonth(1);this.setValue(next);}function goEndMonth(){var next=this.state.value.clone();next.setDayOfMonth(next.getActualMaximum(_gregorianCalendar2.default.MONTH));this.setValue(next);}function goMonth(direction){var next=this.state.value.clone();next.addMonth(direction);this.setValue(next);}function goYear(direction){var next=this.state.value.clone();next.addYear(direction);this.setValue(next);}function goWeek(direction){var next=this.state.value.clone();next.addWeekOfYear(direction);this.setValue(next);}function goDay(direction){var next=this.state.value.clone();next.addDayOfMonth(direction);this.setValue(next);}var Calendar=_react2.default.createClass({displayName:"Calendar",propTypes:{disabledDate:_react.PropTypes.func,disabledTime:_react.PropTypes.any,value:_react.PropTypes.object,selectedValue:_react.PropTypes.object,defaultValue:_react.PropTypes.object,className:_react.PropTypes.string,locale:_react.PropTypes.object,showWeekNumber:_react.PropTypes.bool,style:_react.PropTypes.object,showToday:_react.PropTypes.bool,showDateInput:_react.PropTypes.bool,visible:_react.PropTypes.bool,onSelect:_react.PropTypes.func,onOk:_react.PropTypes.func,showOk:_react.PropTypes.bool,prefixCls:_react.PropTypes.string,onKeyDown:_react.PropTypes.func,timePicker:_react.PropTypes.element,dateInputPlaceholder:_react.PropTypes.any,onClear:_react.PropTypes.func,onChange:_react.PropTypes.func,formatWithZero:_react.PropTypes.boolean},mixins:[_CommonMixin2.default,_CalendarMixin2.default],getDefaultProps:function getDefaultProps(){return{showToday:true,showDateInput:true,timePicker:null,onOk:noop,startOfMonth:1};},onKeyDown:function onKeyDown(event){if(event.target.nodeName.toLowerCase()==="input"){return undefined;}var keyCode=event.keyCode;// mac
var ctrlKey=event.ctrlKey||event.metaKey;switch(keyCode){case _KeyCode2.default.DOWN:goWeek.call(this,1);event.preventDefault();return 1;case _KeyCode2.default.UP:goWeek.call(this,-1);event.preventDefault();return 1;case _KeyCode2.default.LEFT:if(ctrlKey){goYear.call(this,-1);}else{goDay.call(this,-1);}event.preventDefault();return 1;case _KeyCode2.default.RIGHT:if(ctrlKey){goYear.call(this,1);}else{goDay.call(this,1);}event.preventDefault();return 1;case _KeyCode2.default.HOME:goStartMonth.call(this);event.preventDefault();return 1;case _KeyCode2.default.END:goEndMonth.call(this);event.preventDefault();return 1;case _KeyCode2.default.PAGE_DOWN:goMonth.call(this,1);event.preventDefault();return 1;case _KeyCode2.default.PAGE_UP:goMonth.call(this,-1);event.preventDefault();return 1;case _KeyCode2.default.ENTER:this.onSelect(this.state.value,{source:"keyboard"});event.preventDefault();return 1;default:this.props.onKeyDown(event);return 1;}},onClear:function onClear(){this.onSelect(null);this.props.onClear();},onOk:function onOk(){var selectedValue=this.state.selectedValue;if(this.isAllowedDate(selectedValue)){this.props.onOk(selectedValue);}},onDateInputChange:function onDateInputChange(value){this.onSelect(value,{source:"dateInput"});},// 回车选择
onDateInputEnter:function onDateInputEnter(value){this.onSelect(value);},onDateTableSelect:function onDateTableSelect(value){this.onSelect(value);},chooseToday:function chooseToday(){var today=this.state.value.clone();today.setTime(Date.now());this.onSelect(today,{source:"todayButton"});},render:function render(){var props=this.props;var locale=props.locale,prefixCls=props.prefixCls,disabledDate=props.disabledDate,dateInputPlaceholder=props.dateInputPlaceholder,timePicker=props.timePicker,disabledTime=props.disabledTime,_props$showDateInput=props.showDateInput,showDateInput=_props$showDateInput===undefined?true:_props$showDateInput,showTime=props.showTime,_props$formatWithZero=props.formatWithZero,formatWithZero=_props$formatWithZero===undefined?true:_props$formatWithZero,ecId=props.ecId;var state=this.state;var value=state.value,selectedValue=state.selectedValue;var dateInputElement=showDateInput?_react2.default.createElement(_DateInput2.default,{ecId:ecId+"_DateInput@cg3ad9",ref:"dateInput",formatter:this.getFormatter(),formatWithZero:formatWithZero// 增加是否显示数字前的0的配置
,key:"date-input",timePicker:timePicker,gregorianCalendarLocale:value.locale,locale:locale,placeholder:dateInputPlaceholder,showClear:true,showTime:showTime,disabledTime:disabledTime,disabledDate:disabledDate,onClear:this.onClear,prefixCls:prefixCls,selectedValue:selectedValue,onChange:this.onDateInputChange,onEnter:this.onDateInputEnter}):null;var children=[dateInputElement,_react2.default.createElement("div",{key:"date-panel",className:prefixCls+"-date-panel"},_react2.default.createElement(_CalendarHeader2.default,{ecId:ecId+"_CalendarHeader@uc7p03",locale:locale,onValueChange:this.setValue,value:value,prefixCls:prefixCls}),_react2.default.createElement("div",{className:prefixCls+"-calendar-body"},_react2.default.createElement(_DateTable2.default,{ecId:ecId+"_DateTable@jekltf",locale:locale,value:value,selectedValue:selectedValue,prefixCls:prefixCls,dateRender:props.dateRender,onSelect:this.onDateTableSelect,disabledDate:disabledDate,showWeekNumber:props.showWeekNumber})),_react2.default.createElement(_CalendarFooter2.default,{ecId:ecId+"_CalendarFooter@3r3eeb",showOk:props.showOk,locale:locale,prefixCls:prefixCls,showToday:props.showToday,disabledTime:disabledTime,gregorianCalendarLocale:value.locale,showDateInput:props.showDateInput,timePicker:timePicker,selectedValue:selectedValue,value:value,disabledDate:disabledDate,onOk:this.onOk,onSelect:this.onSelect,onToday:this.chooseToday}))];return this.renderRoot({children:children,className:props.showWeekNumber?prefixCls+"-week-number":""});}});exports.default=Calendar;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ROW=4;var COL=3;function goYear(direction){var next=this.state.value.clone();next.addYear(direction);this.setState({value:next});}function chooseDecade(year,event){var next=this.state.value.clone();next.setYear(year);next.rollSetMonth(this.state.value.getMonth());this.props.onSelect(next);event.preventDefault();}var DecadePanel=function(_React$Component){(0,_inherits3.default)(DecadePanel,_React$Component);function DecadePanel(props){(0,_classCallCheck3.default)(this,DecadePanel);var _this=(0,_possibleConstructorReturn3.default)(this,(DecadePanel.__proto__||(0,_getPrototypeOf2.default)(DecadePanel)).call(this,props));_this.state={value:props.value||props.defaultValue};// bind methods
_this.prefixCls=props.rootPrefixCls+"-decade-panel";_this.nextCentury=goYear.bind(_this,100);_this.previousCentury=goYear.bind(_this,-100);return _this;}(0,_createClass3.default)(DecadePanel,[{key:"render",value:function render(){var _this2=this;var value=this.state.value;var locale=this.props.locale;var currentYear=value.getYear();var startYear=parseInt(currentYear/100,10)*100;var preYear=startYear-10;var endYear=startYear+99;var decades=[];var index=0;var prefixCls=this.prefixCls;for(var rowIndex=0;rowIndex<ROW;rowIndex++){decades[rowIndex]=[];for(var colIndex=0;colIndex<COL;colIndex++){var startDecade=preYear+index*10;var endDecade=preYear+index*10+9;decades[rowIndex][colIndex]={startDecade:startDecade,endDecade:endDecade};index++;}}var decadesEls=decades.map(function(row,decadeIndex){var tds=row.map(function(decadeData){var _classNameMap;var dStartDecade=decadeData.startDecade;var dEndDecade=decadeData.endDecade;var isLast=dStartDecade<startYear;var isNext=dEndDecade>endYear;var classNameMap=(_classNameMap={},(0,_defineProperty3.default)(_classNameMap,prefixCls+"-cell",1),(0,_defineProperty3.default)(_classNameMap,prefixCls+"-selected-cell",dStartDecade<=currentYear&&currentYear<=dEndDecade),(0,_defineProperty3.default)(_classNameMap,prefixCls+"-last-century-cell",isLast),(0,_defineProperty3.default)(_classNameMap,prefixCls+"-next-century-cell",isNext),_classNameMap);var content=void 0;var clickHandler=void 0;if(isLast){clickHandler=_this2.previousCentury;}else if(isNext){clickHandler=_this2.nextCentury;}else{content=dStartDecade+"-"+dEndDecade;clickHandler=chooseDecade.bind(_this2,dStartDecade);}return _react2.default.createElement("td",{ecId:_this2.props.ecId+"_td@1d6nwn@"+dStartDecade,key:dStartDecade,onClick:clickHandler,role:"gridcell",className:(0,_classnames2.default)(classNameMap)},_react2.default.createElement("a",{className:prefixCls+"-decade"},content));});return _react2.default.createElement("tr",{key:decadeIndex,role:"row"},tds);});return _react2.default.createElement("div",{className:this.prefixCls},_react2.default.createElement("div",{className:prefixCls+"-header"},_react2.default.createElement("a",{ecId:this.props.ecId+"_a@ezzatk",className:prefixCls+"-prev-century-btn",role:"button",onClick:this.previousCentury,title:locale.previousCentury},"\xAB"),_react2.default.createElement("div",{className:prefixCls+"-century"},startYear,"-",endYear),_react2.default.createElement("a",{ecId:this.props.ecId+"_a@zaafhh",className:prefixCls+"-next-century-btn",role:"button",onClick:this.nextCentury,title:locale.nextCentury},"\xBB")),_react2.default.createElement("div",{className:prefixCls+"-body"},_react2.default.createElement("table",{className:prefixCls+"-table",cellSpacing:"0",role:"grid"},_react2.default.createElement("tbody",{className:prefixCls+"-tbody"},decadesEls))));}}]);return DecadePanel;}(_react2.default.Component);exports.default=DecadePanel;DecadePanel.propTypes={locale:_react.PropTypes.object,value:_react.PropTypes.object,defaultValue:_react.PropTypes.object,rootPrefixCls:_react.PropTypes.string};DecadePanel.defaultProps={onSelect:function onSelect(){}};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _mapSelf=__webpack_require__(152);var _mapSelf2=_interopRequireDefault(_mapSelf);var _TodayButton=__webpack_require__(266);var _TodayButton2=_interopRequireDefault(_TodayButton);var _OkButton=__webpack_require__(267);var _OkButton2=_interopRequireDefault(_OkButton);var _index=__webpack_require__(39);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CalendarFooter=_react2.default.createClass({displayName:"CalendarFooter",propTypes:{prefixCls:_react.PropTypes.string,showDateInput:_react.PropTypes.bool,disabledTime:_react.PropTypes.any,gregorianCalendarLocale:_react.PropTypes.object,selectedValue:_react.PropTypes.any,showOk:_react.PropTypes.bool,onSelect:_react.PropTypes.func,value:_react.PropTypes.object,defaultValue:_react.PropTypes.object},onSelect:function onSelect(value){this.props.onSelect(value);},getRootDOMNode:function getRootDOMNode(){return _reactDom2.default.findDOMNode(this);},render:function render(){var props=this.props;var value=props.value,prefixCls=props.prefixCls,showDateInput=props.showDateInput,disabledTime=props.disabledTime,gregorianCalendarLocale=props.gregorianCalendarLocale,selectedValue=props.selectedValue,showOk=props.showOk,ecId=props.ecId;var timePicker=!showDateInput&&props.timePicker||null;var disabledTimeConfig=disabledTime&&timePicker?(0,_index.getTimeConfig)(selectedValue,disabledTime):null;var footerEl=null;if(props.showToday||timePicker){var nowEl=void 0;if(props.showToday){nowEl=_react2.default.createElement(_TodayButton2.default,(0,_extends3.default)({},props,{ecId:ecId+"_TodayButton@wjtm4j",value:value}));}var okBtn=void 0;if(showOk===true||showOk!==false&&!!props.timePicker){okBtn=_react2.default.createElement(_OkButton2.default,(0,_extends3.default)({},props,{ecId:ecId+"_OkButton@34b1c8"}));}var footerBtn=void 0;if(nowEl||okBtn){footerBtn=_react2.default.createElement("span",{className:prefixCls+"-footer-btn"},(0,_mapSelf2.default)([nowEl,okBtn]));}if(timePicker){timePicker=_react2.default.cloneElement(timePicker,(0,_extends3.default)({onChange:this.onSelect,allowEmpty:false,gregorianCalendarLocale:gregorianCalendarLocale},disabledTimeConfig,{getPopupContainer:this.getRootDOMNode,value:selectedValue}));}footerEl=_react2.default.createElement("div",{className:prefixCls+"-footer"},timePicker,footerBtn);}return footerEl;}});exports.default=CalendarFooter;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);exports.default=createPicker;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _gregorianCalendar=__webpack_require__(139);var _gregorianCalendar2=_interopRequireDefault(_gregorianCalendar);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);var _util=__webpack_require__(69);var _util2=_interopRequireDefault(_util);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import MonthCalendar from '../../_rc-calendar-5.6.2/src/MonthCalendar';
// import RcDatePicker from '../../_rc-calendar-5.6.2/src/Picker';
var RcDatePicker=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 787));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});function createPicker(TheCalendar,defaultFormat){var _class,_temp,_initialiseProps;return _temp=_class=function(_React$Component){(0,_inherits3.default)(CalenderWrapper,_React$Component);function CalenderWrapper(props){(0,_classCallCheck3.default)(this,CalenderWrapper);var _this=(0,_possibleConstructorReturn3.default)(this,(CalenderWrapper.__proto__||(0,_getPrototypeOf2.default)(CalenderWrapper)).call(this,props));_initialiseProps.call(_this);_this.state={value:_this.props.parseDateFromValue(_this.props.value||_this.props.defaultValue),minWidth:0};return _this;}(0,_createClass3.default)(CalenderWrapper,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if("value"in nextProps){this.setState({value:nextProps.parseDateFromValue(nextProps.value)});}}},{key:"componentDidMount",value:function componentDidMount(){var w=0;var formatPattern=this.props.formatPattern;if(formatPattern){var v=_util2.default.formatDate("2017-08-04",formatPattern);w=_util2.default.getTextWidth(v)+40;}this.setState({minWidth:w});}},{key:"render",value:function render(){var _this2=this;var props=this.props;var _props$formatWithZero=props.formatWithZero,formatWithZero=_props$formatWithZero===undefined?true:_props$formatWithZero;var locale=props.locale;// 以下两行代码
// 给没有初始值的日期选择框提供本地化信息
// 否则会以周日开始排
var defaultCalendarValue=new _gregorianCalendar2.default(locale);defaultCalendarValue.setTime(Date.now());var placeholder=void 0;if("placeholder"in props){placeholder=props.placeholder;}else if(props.format==="yyyy"){placeholder=locale.lang.yearPlaceholder;}else if(props.format==="yyyy-MM"){placeholder=locale.lang.monthPlaceholder;}else{placeholder=locale.lang.placeholder;}var disabledTime=props.showTime?props.disabledTime:null;var calendarClassName=(0,_classnames2.default)({"ant-calendar-time":props.showTime,// 'ant-calendar-month': MonthCalendar === TheCalendar,
"ant-calendar-month":defaultFormat==="yyyy-MM"// 修复MonthCalendar组件异步，样式判断错误问题
});// 需要选择时间时，点击 ok 时才触发 onChange
var pickerChangeHandler={onChange:this.handleChange};var calendarHandler={onOk:this.handleChange,onClear:this.handleChange,// fix https://github.com/ant-design/ant-design/issues/1902
onSelect:function onSelect(value,cause){if(cause&&cause.source==="todayButton"){_this2.handleChange(value);}}};if(props.showTime){pickerChangeHandler={};}else{calendarHandler={};}var calendar=_react2.default.createElement(TheCalendar,(0,_extends3.default)({ecId:props.ecId+"_TheCalendar@lxya8m",formatter:props.getFormatter(),formatWithZero:formatWithZero,disabledDate:props.disabledDate,showTime:props.showTime,disabledTime:disabledTime,locale:locale.lang,timePicker:props.timePicker,defaultValue:defaultCalendarValue,dateInputPlaceholder:placeholder,prefixCls:"ant-calendar",className:calendarClassName+" "+(props.className||""),onOk:props.onOk,redDots:props.redDots,bgColors:props.bgColors},calendarHandler));// default width for showTime
var pickerStyle={};if(props.showTime){pickerStyle.width=180;}var clearIcon=!props.disabled&&this.state.value?_react2.default.createElement(_icon2.default,{ecId:props.ecId+"_Icon@05u8ue",type:"cross-circle",className:"ant-calendar-picker-clear",onClick:this.clearSelection}):null;var hasPlaceHolder=this.hasPlaceHolder();return _react2.default.createElement("span",{className:props.pickerClass,style:(0,_extends3.default)({},pickerStyle,props.style)},_react2.default.createElement(RcDatePicker,(0,_extends3.default)({ecId:props.ecId+"_RcDatePicker@05u8ue",transitionName:props.transitionName,disabled:props.disabled,calendar:calendar,value:this.state.value,prefixCls:"ant-calendar-picker-container",style:props.popupStyle,align:props.align,getCalendarContainer:props.getCalendarContainer,open:props.open,onOpen:props.toggleOpen,onClose:props.toggleOpen,formatWithZero:formatWithZero},pickerChangeHandler),function(_ref){var value=_ref.value;return _react2.default.createElement("span",null,!hasPlaceHolder&&_this2.formatValue(value)===""&&!props.noInput&&_react2.default.createElement("span",{className:"ant-calendar-range-picker-placeholder-ie9",style:{padding:"7px 0 0 5px",textAlign:"left",width:"100%"}},placeholder),!!props.noInput?"":_react2.default.createElement("input",{ecId:props.ecId+"_input@05u8ue",disabled:props.disabled,readOnly:true,value:_this2.formatValue(value),placeholder:placeholder,className:props.pickerInputClass+" "+(props.textDecoration&&"text-decoration"),style:{minWidth:_this2.state.minWidth}}),_react2.default.createElement("span",{className:"picker-icon icon-coms-New-schedule cursor-pointer"}),props.noInput&&_react2.default.createElement("span",{className:"text"},_this2.formatValue(value)));}));}}]);return CalenderWrapper;}(_react2.default.Component),_initialiseProps=function _initialiseProps(){var _this3=this;this.clearSelection=function(e){e.preventDefault();e.stopPropagation();_this3.setState({value:null});_this3.handleChange(null);};this.handleChange=function(value){var props=_this3.props;if(!("value"in props)){_this3.setState({value:value});}var timeValue=value?new Date(value.getTime()):null;props.onChange(timeValue,value?props.getFormatter().format(value):"");};this.hasPlaceHolder=function(){var input=document.createElement("input");return"placeholder"in input;};this.formatValue=function(value){var _props=_this3.props,formatPattern=_props.formatPattern,format=_props.format,_props$formatWithZero2=_props.formatWithZero,formatWithZero=_props$formatWithZero2===undefined?true:_props$formatWithZero2;var v="";if(value){if(!formatPattern){v=_this3.props.getFormatter().format(value);}else{v=_this3.props.getFormatter(format||"yyyy-MM-dd").format(value);v=_util2.default.formatDate(v,formatPattern,formatWithZero);}}return v;};},_temp;}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);exports.default=wrapPicker;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _gregorianCalendarFormat=__webpack_require__(141);var _gregorianCalendarFormat2=_interopRequireDefault(_gregorianCalendarFormat);var _dayjs=__webpack_require__(150);var _dayjs2=_interopRequireDefault(_dayjs);var _gregorianCalendar=__webpack_require__(139);var _gregorianCalendar2=_interopRequireDefault(_gregorianCalendar);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _zh_CN=__webpack_require__(255);var _zh_CN2=_interopRequireDefault(_zh_CN);var _weaLocaleProvider=__webpack_require__(68);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;// import moment from "moment";
// import TimePicker from "../../_rc-time-picker-1.1.6";
var TimePicker=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 797));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});function wrapPicker(Picker,defaultFormat){var _class,_temp2;return _temp2=_class=function(_React$Component){(0,_inherits3.default)(PickerWrapper,_React$Component);function PickerWrapper(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,PickerWrapper);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=PickerWrapper.__proto__||(0,_getPrototypeOf2.default)(PickerWrapper)).call.apply(_ref,[this].concat(args))),_this),_this.getFormatter=function(fmt){var format=fmt||_this.props.format;var formatter=new _gregorianCalendarFormat2.default(format,_this.getLocale().lang.format);return formatter;},_this.parseDateFromValue=function(value,limit){if(value){if(typeof value==="string"){if((0,_dayjs2.default)(value).format()==="Invalid date"){return"";}return _this.getFormatter().parse(value,{locale:_this.getLocale()});}else if(value instanceof Date){var date=new _gregorianCalendar2.default(_this.getLocale());date.setTime(+value);date.unlimited=limit;return date;}}else if(limit){var _date=new _gregorianCalendar2.default(_this.getLocale());_date.setTime(new Date());_date.unlimited=limit;return _date;}return value;},_this.toggleOpen=function(_ref2){var open=_ref2.open;_this.props.toggleOpen({open:open});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(PickerWrapper,[{key:"getLocale",value:function getLocale(){var props=this.props;var locale=_zh_CN2.default;// const context = this.context;
// if (context.antLocale && context.antLocale.DatePicker) {
//   locale = context.antLocale.DatePicker;
// }
// 统一合并为完整的 Locale
locale={lang:{placeholder:getLabel("27938","请选择日期"),yearPlaceholder:getLabel("526306","请选择年"),monthPlaceholder:getLabel("126137","请选择年月"),rangePlaceholder:[getLabel("24978","开始日期"),getLabel("24980","结束日期")],today:getLabel("15537","今天"),now:getLabel("386451","此刻"),backToToday:getLabel("386452","返回今天"),ok:getLabel("826","确定"),clear:getLabel("311","清除"),month:getLabel("33452","月"),year:getLabel("26577","年"),previousMonth:getLabel("386453","上个月 (翻页上键)"),nextMonth:getLabel("386454","下个月 (翻页下键)"),monthSelect:getLabel("386455","选择月份"),yearSelect:getLabel("386456","选择年份"),decadeSelect:getLabel("386457","选择年代"),yearFormat:getLabel("386607","yyyy年"),monthFormat:getLabel("386608","M月"),dateFormat:getLabel("386609","yyyy年M月d日"),previousYear:getLabel("386458","上一年 (Control键加左方向键)"),nextYear:getLabel("386459","下一年 (Control键加右方向键)"),previousDecade:getLabel("386460","上一年代"),nextDecade:getLabel("386461","下一年代"),previousCentury:getLabel("386462","上一世纪"),nextCentury:getLabel("386463","下一世纪"),format:{eras:[getLabel("383357","公元前"),getLabel("383358","公元")],months:[getLabel("1492","一月"),getLabel("1493","二月"),getLabel("1494","三月"),getLabel("1495","四月"),getLabel("1496","五月"),getLabel("1497","六月"),getLabel("1498","七月"),getLabel("1499","八月"),getLabel("1800","九月"),getLabel("1801","十月"),getLabel("1802","十一月"),getLabel("1803","十二月")],shortMonths:[getLabel("25825","1月"),getLabel("25826","2月"),getLabel("25827","3月"),getLabel("25828","4月"),getLabel("25829","5月"),getLabel("25830","6月"),getLabel("25831","7月"),getLabel("25832","8月"),getLabel("25833","9月"),getLabel("25834","10月"),getLabel("25835","11月"),getLabel("25836","12月")],weekdays:[getLabel("24626","星期天"),getLabel("392","星期一"),getLabel("393","星期二"),getLabel("394","星期三"),getLabel("395","星期四"),getLabel("396","星期五"),getLabel("397","星期六")],shortWeekdays:[getLabel("16106","周日"),getLabel("16100","周一"),getLabel("16101","周二"),getLabel("16102","周三"),getLabel("16103","周四"),getLabel("16104","周五"),getLabel("16105","周六")],veryShortWeekdays:[getLabel("385820","日"),getLabel("385821","一"),getLabel("385822","二"),getLabel("385823","三"),getLabel("385824","四"),getLabel("385825","五"),getLabel("385826","六")],ampms:[getLabel("16689","上午"),getLabel("16690","下午")],datePatterns:[getLabel("386610","yyyy年M月d日 EEEE"),getLabel("386609","yyyy年M月d日"),"yyyy-M-d","yy-M-d"],timePatterns:["ahh'时'mm'分'ss'秒' 'GMT'Z","ahh'时'mm'分'ss'秒'","H:mm:ss","ah:mm"],dateTimePattern:"{date} {time}"}},timePickerLocale:{clear:getLabel("311","清除"),placeholder:getLabel("386464","请选择时间"),format:{eras:[getLabel("383357","公元前"),getLabel("383358","公元")],months:[getLabel("1492","一月"),getLabel("1493","二月"),getLabel("1494","三月"),getLabel("1495","四月"),getLabel("1496","五月"),getLabel("1497","六月"),getLabel("1498","七月"),getLabel("1499","八月"),getLabel("1800","九月"),getLabel("1801","十月"),getLabel("1802","十一月"),getLabel("1803","十二月")],shortMonths:[getLabel("25825","1月"),getLabel("25826","2月"),getLabel("25827","3月"),getLabel("25828","4月"),getLabel("25829","5月"),getLabel("25830","6月"),getLabel("25831","7月"),getLabel("25832","8月"),getLabel("25833","9月"),getLabel("25834","10月"),getLabel("25835","11月"),getLabel("25836","12月")],weekdays:[getLabel("24626","星期天"),getLabel("392","星期一"),getLabel("393","星期二"),getLabel("394","星期三"),getLabel("395","星期四"),getLabel("396","星期五"),getLabel("397","星期六")],shortWeekdays:[getLabel("16106","周日"),getLabel("16100","周一"),getLabel("16101","周二"),getLabel("16102","周三"),getLabel("16103","周四"),getLabel("16104","周五"),getLabel("16105","周六")],veryShortWeekdays:[getLabel("385820","日"),getLabel("385821","一"),getLabel("385822","二"),getLabel("385823","三"),getLabel("385824","四"),getLabel("385825","五"),getLabel("385826","六")],ampms:[getLabel("16689","上午"),getLabel("16690","下午")],datePatterns:[getLabel("386610","yyyy年M月d日 EEEE"),getLabel("386609","yyyy年M月d日"),"yyyy-M-d","yy-M-d"],timePatterns:["ahh'时'mm'分'ss'秒' 'GMT'Z","ahh'时'mm'分'ss'秒'","H:mm:ss","ah:mm"],dateTimePattern:"{date} {time}"}},timezoneOffset:-new Date().getTimezoneOffset(),firstDayOfWeek:7,minimalDaysInFirstWeek:1};var result=(0,_extends3.default)({},locale,props.locale);result.lang=(0,_extends3.default)({},locale.lang,props.locale.lang);return result;}},{key:"render",value:function render(){var props=this.props;var pickerClass=(0,_classnames2.default)({"ant-calendar-picker":true});var pickerInputClass=(0,_classnames2.default)({"ant-calendar-range-picker":true,"ant-input":true,"ant-input-lg":props.size==="large","ant-input-sm":props.size==="small"});var locale=this.getLocale();var timeFormat=props.showTime&&props.showTime.format;var rcTimePickerProps={formatter:new _gregorianCalendarFormat2.default(timeFormat||"HH:mm",locale.timePickerLocale.format),showSecond:timeFormat&&timeFormat.indexOf("ss")>=0,showHour:timeFormat&&timeFormat.indexOf("HH")>=0,needSecond:props.needSecond};var timePicker=props.showTime?_react2.default.createElement(TimePicker,(0,_extends3.default)({},rcTimePickerProps,props.showTime,{showTime:props.showTime// showTime参数作为 是否 为 日期-时间 选择器
,prefixCls:"ant-time-picker",placeholder:locale.timePickerLocale.placeholder,locale:locale.timePickerLocale,transitionName:"slide-up"})):null;return _react2.default.createElement(Picker,(0,_extends3.default)({},props,{pickerClass:pickerClass,pickerInputClass:pickerInputClass,locale:locale,timePicker:timePicker,toggleOpen:this.toggleOpen,getFormatter:this.getFormatter,parseDateFromValue:this.parseDateFromValue}));}}]);return PickerWrapper;}(_react2.default.Component),_class.defaultProps={format:defaultFormat||"yyyy-MM-dd",transitionName:"slide-up",popupStyle:{},onChange:function onChange(){},onOk:function onOk(){},toggleOpen:function toggleOpen(){},locale:{},align:{offset:[0,-9]}},_class.contextTypes={antLocale:_react.PropTypes.object},_temp2;}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(568);__webpack_require__(37);__webpack_require__(209);

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Dropdown=__webpack_require__(571);var _Dropdown2=_interopRequireDefault(_Dropdown);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Dropdown2.default;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _rcTrigger=__webpack_require__(94);var _rcTrigger2=_interopRequireDefault(_rcTrigger);var _placements=__webpack_require__(572);var _placements2=_interopRequireDefault(_placements);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*

 var MenuItem = Menu.Item;

 var menu = <Menu><MenuItem>1</MenuItem></Menu>;

 <DropDown trigger="click" animationName="" overlay={<>} onSelect={}>
 <button>open</button>
 </DropDown>
 */var Dropdown=_react2.default.createClass({displayName:'Dropdown',propTypes:{minOverlayWidthMatchTrigger:_react.PropTypes.bool,onVisibleChange:_react.PropTypes.func,prefixCls:_react.PropTypes.string,children:_react.PropTypes.any,transitionName:_react.PropTypes.string,overlayClassName:_react.PropTypes.string,animation:_react.PropTypes.any,align:_react.PropTypes.object,overlayStyle:_react.PropTypes.object,placement:_react.PropTypes.string,trigger:_react.PropTypes.array,showAction:_react.PropTypes.array,hideAction:_react.PropTypes.array,getPopupContainer:_react.PropTypes.func},getDefaultProps:function getDefaultProps(){return{minOverlayWidthMatchTrigger:true,prefixCls:'rc-dropdown',trigger:['hover'],showAction:[],hideAction:[],overlayClassName:'',overlayStyle:{},defaultVisible:false,onVisibleChange:function onVisibleChange(){},placement:'bottomLeft'};},getInitialState:function getInitialState(){var props=this.props;if('visible'in props){return{visible:props.visible};}return{visible:props.defaultVisible};},componentWillReceiveProps:function componentWillReceiveProps(props){if('visible'in props){this.setState({visible:props.visible});}},onClick:function onClick(e){var props=this.props;var overlayProps=props.overlay.props;if(!('visible'in props)){this.setState({visible:false});}if(overlayProps.onClick){overlayProps.onClick(e);}},onVisibleChange:function onVisibleChange(v){var props=this.props;if(!('visible'in props)){this.setState({visible:v});}props.onVisibleChange(v);},getMenuElement:function getMenuElement(){var props=this.props;return _react2.default.cloneElement(props.overlay,{prefixCls:props.prefixCls+'-menu',onClick:this.onClick});},getPopupDomNode:function getPopupDomNode(){return this.refs.trigger.getPopupDomNode();},afterVisibleChange:function afterVisibleChange(visible){if(visible&&this.props.minOverlayWidthMatchTrigger){var overlayNode=this.getPopupDomNode();var rootNode=_reactDom2.default.findDOMNode(this);if(rootNode.offsetWidth>overlayNode.offsetWidth){overlayNode.style.width=rootNode.offsetWidth+'px';}}},render:function render(){var _props=this.props,prefixCls=_props.prefixCls,children=_props.children,transitionName=_props.transitionName,animation=_props.animation,align=_props.align,placement=_props.placement,getPopupContainer=_props.getPopupContainer,showAction=_props.showAction,hideAction=_props.hideAction,overlayClassName=_props.overlayClassName,overlayStyle=_props.overlayStyle,trigger=_props.trigger,otherProps=(0,_objectWithoutProperties3.default)(_props,['prefixCls','children','transitionName','animation','align','placement','getPopupContainer','showAction','hideAction','overlayClassName','overlayStyle','trigger']);return _react2.default.createElement(_rcTrigger2.default,(0,_extends3.default)({},otherProps,{prefixCls:prefixCls,ref:'trigger',popupClassName:overlayClassName,popupStyle:overlayStyle,builtinPlacements:_placements2.default,action:trigger,showAction:showAction,hideAction:hideAction,popupPlacement:placement,popupAlign:align,popupTransitionName:transitionName,popupAnimation:animation,popupVisible:this.state.visible,afterPopupVisibleChange:this.afterVisibleChange,popup:this.getMenuElement(),onPopupVisibleChange:this.onVisibleChange,getPopupContainer:getPopupContainer}),children);}});exports.default=Dropdown;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var autoAdjustOverflow={adjustX:1,adjustY:1};var targetOffset=[0,0];var placements=exports.placements={topLeft:{points:['bl','tl'],overflow:autoAdjustOverflow,offset:[0,-4],targetOffset:targetOffset},bottomLeft:{points:['tl','bl'],overflow:autoAdjustOverflow,offset:[0,4],targetOffset:targetOffset}};exports.default=placements;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _button=__webpack_require__(55);var _button2=_interopRequireDefault(_button);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);var _dropdown=__webpack_require__(210);var _dropdown2=_interopRequireDefault(_dropdown);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ButtonGroup=_button2.default.Group;var DropdownButton=(_temp=_class=function(_React$Component){(0,_inherits3.default)(DropdownButton,_React$Component);function DropdownButton(){(0,_classCallCheck3.default)(this,DropdownButton);return(0,_possibleConstructorReturn3.default)(this,(DropdownButton.__proto__||(0,_getPrototypeOf2.default)(DropdownButton)).apply(this,arguments));}(0,_createClass3.default)(DropdownButton,[{key:"render",value:function render(){var _props=this.props,type=_props.type,overlay=_props.overlay,trigger=_props.trigger,align=_props.align,children=_props.children,className=_props.className,onClick=_props.onClick,restProps=(0,_objectWithoutProperties3.default)(_props,["type","overlay","trigger","align","children","className","onClick"]);var cls=(0,_classnames2.default)((0,_defineProperty3.default)({"ant-dropdown-button":true},className,!!className));return _react2.default.createElement(ButtonGroup,(0,_extends3.default)({},restProps,{className:cls,ecId:this.props.ecId+"_ButtonGroup@e056er"}),_react2.default.createElement(_button2.default,{ecId:this.props.ecId+"_Button@5yv16h",type:type,onClick:onClick},children),_react2.default.createElement(_dropdown2.default,{ecId:this.props.ecId+"_Dropdown@l7e303",align:align,overlay:overlay,trigger:trigger},_react2.default.createElement(_button2.default,{ecId:this.props.ecId+"_Button@kth8bh",type:type},_react2.default.createElement(_icon2.default,{ecId:this.props.ecId+"_Icon@j23eap",type:"down"}))));}}]);return DropdownButton;}(_react2.default.Component),_class.defaultProps={align:{points:["tr","br"],overlay:{adjustX:1,adjustY:1},offset:[0,4],targetOffset:[0,0]},type:"default"},_temp);exports.default=DropdownButton;

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _createDOMForm=__webpack_require__(576);var _createDOMForm2=_interopRequireDefault(_createDOMForm);var _Form=__webpack_require__(608);var _Form2=_interopRequireDefault(_Form);var _FormItem=__webpack_require__(609);var _FormItem2=_interopRequireDefault(_FormItem);var _ValueMixin=__webpack_require__(610);var _ValueMixin2=_interopRequireDefault(_ValueMixin);var _constants=__webpack_require__(220);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_Form2.default.create=function(){var o=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var options=(0,_extends3.default)({},o,{fieldNameProp:"id",fieldMetaProp:_constants.FIELD_META_PROP});var formWrapper=(0,_createDOMForm2.default)(options);/* eslint-disable react/prefer-es6-class */return function(Component){return formWrapper(_react2.default.createClass({propTypes:{form:_react.PropTypes.object.isRequired},childContextTypes:{form:_react.PropTypes.object.isRequired},getChildContext:function getChildContext(){return{form:this.props.form};},render:function render(){return _react2.default.createElement(Component,(0,_extends3.default)({},this.props,{ecId:this.props.ecId+"_Component@iiw91q"}));}}));};};_Form2.default.Item=_FormItem2.default;// @Deprecated
_Form2.default.ValueMixin=_ValueMixin2.default;exports.default=_Form2.default;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _createBaseForm=__webpack_require__(212);var _createBaseForm2=_interopRequireDefault(_createBaseForm);var _createForm=__webpack_require__(607);var _utils=__webpack_require__(213);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _domScrollIntoView=__webpack_require__(145);var _domScrollIntoView2=_interopRequireDefault(_domScrollIntoView);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function computedStyle(el,prop){var getComputedStyle=window.getComputedStyle;var style=// If we have getComputedStyle
getComputedStyle?// Query it
// TODO: From CSS-Query notes, we might need (node, null) for FF
getComputedStyle(el):// Otherwise, we are in IE and use currentStyle
el.currentStyle;if(style){return style[// Switch to camelCase for CSSOM
// DEV: Grabbed from jQuery
// https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
// https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
prop.replace(/-(\w)/gi,function(word,letter){return letter.toUpperCase();})];}return undefined;}function getScrollableContainer(n){var node=n;var nodeName=void 0;/* eslint no-cond-assign:0 */while((nodeName=node.nodeName.toLowerCase())!=='body'){var overflowY=computedStyle(node,'overflowY');if(overflowY==='auto'||overflowY==='scroll'){return node;}node=node.parentNode;}return nodeName==='body'?node.ownerDocument:node;}var mixin={getForm:function getForm(){return(0,_extends3.default)({},_createForm.mixin.getForm.call(this),{validateFieldsAndScroll:this.validateFieldsAndScroll});},validateFieldsAndScroll:function validateFieldsAndScroll(ns,opt,cb){var _this=this;var _getParams=(0,_utils.getParams)(ns,opt,cb),names=_getParams.names,callback=_getParams.callback,options=_getParams.options;var newCb=function newCb(error,values){if(error){var firstNode=void 0;var firstTop=void 0;for(var name in error){if(error.hasOwnProperty(name)){var instance=_this.getFieldInstance(name);if(instance){var node=_reactDom2.default.findDOMNode(instance);var top=node.getBoundingClientRect().top;if(firstTop===undefined||firstTop>top){firstTop=top;firstNode=node;}}}}if(firstNode){var c=options.container||getScrollableContainer(firstNode);(0,_domScrollIntoView2.default)(firstNode,c,(0,_extends3.default)({onlyScrollIfNeeded:true},options.scroll));}}if(typeof callback==='function'){callback(error,values);}};return this.validateFields(names,options,newCb);}};function createDOMForm(option){return(0,_createBaseForm2.default)((0,_extends3.default)({},option),[mixin]);}exports.default=createDOMForm;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(13);

var _validator = __webpack_require__(579);

var _validator2 = _interopRequireDefault(_validator);

var _messages2 = __webpack_require__(599);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = _messages2.messages;
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : _typeof(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return Promise.resolve();
    }

    function complete(results) {
      var i = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          var _errors;

          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        fields = (0, _util.convertFieldsError)(errors);
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === _messages2.messages) {
        messages = (0, _messages2.newMessages)();
      }
      (0, _util.deepMerge)(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = _extends({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    return (0, _util.asyncMap)(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (_typeof(rule.fields) === 'object' || _typeof(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;

      function addFullfield(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (!options.suppressWarning && errors.length) {
          Schema.warning('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map((0, _util.complementError)(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
            } else if (options.error) {
              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            var finalErrors = [];
            if (errors && errors.length) {
              finalErrors.push.apply(finalErrors, errors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }

      var res = void 0;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        res = rule.validator(rule, data.value, cb, data.source, options);
        if (res === true) {
          cb();
        } else if (res === false) {
          cb(rule.message || rule.field + ' fails');
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return _validator2['default'].required;
    }
    return _validator2['default'][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  _validator2['default'][type] = validator;
};

Schema.warning = _util.warning;

Schema.messages = _messages2.messages;

exports['default'] = Schema;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _string = __webpack_require__(580);

var _string2 = _interopRequireDefault(_string);

var _method = __webpack_require__(586);

var _method2 = _interopRequireDefault(_method);

var _number = __webpack_require__(587);

var _number2 = _interopRequireDefault(_number);

var _boolean = __webpack_require__(588);

var _boolean2 = _interopRequireDefault(_boolean);

var _regexp = __webpack_require__(589);

var _regexp2 = _interopRequireDefault(_regexp);

var _integer = __webpack_require__(590);

var _integer2 = _interopRequireDefault(_integer);

var _float = __webpack_require__(591);

var _float2 = _interopRequireDefault(_float);

var _array = __webpack_require__(592);

var _array2 = _interopRequireDefault(_array);

var _object = __webpack_require__(593);

var _object2 = _interopRequireDefault(_object);

var _enum = __webpack_require__(594);

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__(595);

var _pattern2 = _interopRequireDefault(_pattern);

var _date = __webpack_require__(596);

var _date2 = _interopRequireDefault(_date);

var _required = __webpack_require__(597);

var _required2 = _interopRequireDefault(_required);

var _type = __webpack_require__(598);

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  string: _string2['default'],
  method: _method2['default'],
  number: _number2['default'],
  boolean: _boolean2['default'],
  regexp: _regexp2['default'],
  integer: _integer2['default'],
  float: _float2['default'],
  array: _array2['default'],
  object: _object2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default'],
  date: _date2['default'],
  url: _type2['default'],
  hex: _type2['default'],
  email: _type2['default'],
  required: _required2['default']
};

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'string');
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
      _rule2['default'].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        _rule2['default'].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = string;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(13);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(util.format(options.messages.whitespace, rule.fullField));
  }
}

exports['default'] = whitespace;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(13);

var util = _interopRequireWildcard(_util);

var _required = __webpack_require__(214);

var _required2 = _interopRequireDefault(_required);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    (0, _required2['default'])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== rule.type) {
    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

exports['default'] = type;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(13);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

exports['default'] = range;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(13);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

exports['default'] = enumerable;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(13);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

exports['default'] = pattern;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = method;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === '') {
      value = undefined;
    }
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = number;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(13);

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = boolean;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = regexp;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = integer;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = floatFn;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'array');
    if (!(0, _util.isEmptyValue)(value, 'array')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = array;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = object;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value) {
      _rule2['default'][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = enumerable;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = pattern;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      _rule2['default'].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = date;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : _typeof(value);
  _rule2['default'].required(rule, value, source, errors, options, type);
  callback(errors);
}

exports['default'] = required;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(21);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, ruleType);
    if (!(0, _util.isEmptyValue)(value, ruleType)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = type;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newMessages = newMessages;
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = exports.messages = newMessages();

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(601);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(602);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(125);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(604),
    hasPath = __webpack_require__(216);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 604 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(606);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(217),
    castPath = __webpack_require__(93),
    isIndex = __webpack_require__(66),
    isObject = __webpack_require__(29),
    toKey = __webpack_require__(54);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mixin=undefined;var _createBaseForm=__webpack_require__(212);var _createBaseForm2=_interopRequireDefault(_createBaseForm);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var mixin=exports.mixin={getForm:function getForm(){return{getFieldsValue:this.getFieldsValue,getFieldValue:this.getFieldValue,getFieldInstance:this.getFieldInstance,setFieldsValue:this.setFieldsValue,setFields:this.setFields,setFieldsInitialValue:this.setFieldsInitialValue,getFieldDecorator:this.getFieldDecorator,getFieldProps:this.getFieldProps,getFieldsError:this.getFieldsError,getFieldError:this.getFieldError,isFieldValidating:this.isFieldValidating,isFieldsValidating:this.isFieldsValidating,isFieldsTouched:this.isFieldsTouched,isFieldTouched:this.isFieldTouched,isSubmitting:this.isSubmitting,submit:this.submit,validateFields:this.validateFields,resetFields:this.resetFields,getFields:this.getFields};}};function createForm(options){return(0,_createBaseForm2.default)(options,[mixin]);}exports.default=createForm;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _reactAddonsPureRenderMixin=__webpack_require__(38);var _reactAddonsPureRenderMixin2=_interopRequireDefault(_reactAddonsPureRenderMixin);var _object=__webpack_require__(44);var _object2=_interopRequireDefault(_object);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Form=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Form,_React$Component);function Form(props){(0,_classCallCheck3.default)(this,Form);var _this=(0,_possibleConstructorReturn3.default)(this,(Form.__proto__||(0,_getPrototypeOf2.default)(Form)).call(this,props));(0,_warning2.default)(!props.form,"It is unnecessary to pass `form` to `Form` after antd@1.7.0.");return _this;}(0,_createClass3.default)(Form,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.apply(this,args);}},{key:"render",value:function render(){var _classNames;var _props=this.props,prefixCls=_props.prefixCls,className=_props.className,inline=_props.inline,horizontal=_props.horizontal;var formClassName=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,""+prefixCls,true),(0,_defineProperty3.default)(_classNames,prefixCls+"-horizontal",horizontal),(0,_defineProperty3.default)(_classNames,prefixCls+"-inline",inline),(0,_defineProperty3.default)(_classNames,className,!!className),_classNames));var formProps=(0,_object2.default)(this.props,["prefixCls","className","inline","horizontal","form"]);return _react2.default.createElement("form",(0,_extends3.default)({},formProps,{className:formClassName,ecId:this.props.ecId+"_form@cmtung"}));}}]);return Form;}(_react2.default.Component),_class.defaultProps={prefixCls:"ant-form",onSubmit:function onSubmit(e){e.preventDefault();}},_class.propTypes={prefixCls:_react2.default.PropTypes.string,horizontal:_react2.default.PropTypes.bool,inline:_react2.default.PropTypes.bool,children:_react2.default.PropTypes.any,onSubmit:_react2.default.PropTypes.func},_temp);exports.default=Form;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _reactAddonsPureRenderMixin=__webpack_require__(38);var _reactAddonsPureRenderMixin2=_interopRequireDefault(_reactAddonsPureRenderMixin);var _row=__webpack_require__(219);var _row2=_interopRequireDefault(_row);var _col=__webpack_require__(208);var _col2=_interopRequireDefault(_col);var _constants=__webpack_require__(220);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FormItem=(_temp=_class=function(_React$Component){(0,_inherits3.default)(FormItem,_React$Component);function FormItem(){(0,_classCallCheck3.default)(this,FormItem);return(0,_possibleConstructorReturn3.default)(this,(FormItem.__proto__||(0,_getPrototypeOf2.default)(FormItem)).apply(this,arguments));}(0,_createClass3.default)(FormItem,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.apply(this,args);}},{key:"getHelpMsg",value:function getHelpMsg(){var context=this.context;var props=this.props;if(props.help===undefined&&context.form){return this.getId()?(context.form.getFieldError(this.getId())||[]).join(", "):"";}return props.help;}},{key:"getOnlyControl",value:function getOnlyControl(){var children=_react2.default.Children.toArray(this.props.children);var child=children.filter(function(c){return c.props&&_constants.FIELD_META_PROP in c.props;})[0];return child!==undefined?child:null;}},{key:"getChildProp",value:function getChildProp(prop){var child=this.getOnlyControl();return child&&child.props&&child.props[prop];}},{key:"getId",value:function getId(){return this.getChildProp("id");}},{key:"getMeta",value:function getMeta(){return this.getChildProp(_constants.FIELD_META_PROP);}},{key:"renderHelp",value:function renderHelp(){var prefixCls=this.props.prefixCls;var help=this.getHelpMsg();return help?_react2.default.createElement("div",{className:prefixCls+"-explain",key:"help"},help):null;}},{key:"renderExtra",value:function renderExtra(){var _props=this.props,prefixCls=_props.prefixCls,extra=_props.extra;return extra?_react2.default.createElement("span",{className:prefixCls+"-extra"},extra):null;}},{key:"getValidateStatus",value:function getValidateStatus(){var _context$form=this.context.form,isFieldValidating=_context$form.isFieldValidating,getFieldError=_context$form.getFieldError,getFieldValue=_context$form.getFieldValue;var field=this.getId();if(!field){return"";}if(isFieldValidating(field)){return"validating";}else if(!!getFieldError(field)){return"error";}else if(getFieldValue(field)!==undefined){return"success";}return"";}},{key:"renderValidateWrapper",value:function renderValidateWrapper(c1,c2,c3){var classes="";var form=this.context.form;var props=this.props;var validateStatus=props.validateStatus===undefined&&form?this.getValidateStatus():props.validateStatus;if(validateStatus){classes=(0,_classnames2.default)({"has-feedback":props.hasFeedback,"has-success":validateStatus==="success","has-warning":validateStatus==="warning","has-error":validateStatus==="error","is-validating":validateStatus==="validating"});}return _react2.default.createElement("div",{className:this.props.prefixCls+"-item-control "+classes},c1,c2,c3);}},{key:"renderWrapper",value:function renderWrapper(children){var wrapperCol=this.props.wrapperCol;return _react2.default.createElement(_col2.default,(0,_extends3.default)({},wrapperCol,{ecId:this.props.ecId+"_Col@qd58xo",key:"wrapper"}),children);}},{key:"isRequired",value:function isRequired(){if(this.context.form){var meta=this.getMeta()||{};var validate=meta.validate||[];return validate.filter(function(item){return!!item.rules;}).some(function(item){return item.rules.some(function(rule){return rule.required;});});}return false;}},{key:"renderLabel",value:function renderLabel(){var props=this.props;var labelCol=props.labelCol;var required=props.required===undefined?this.isRequired():props.required;var className=(0,_classnames2.default)((0,_defineProperty3.default)({},props.prefixCls+"-item-required",required));// remove user input colon
var label=props.label;if(typeof label==="string"&&label.trim()!==""){label=props.label.replace(/[：|:]\s*$/,"");}return props.label?_react2.default.createElement(_col2.default,(0,_extends3.default)({},labelCol,{ecId:this.props.ecId+"_Col@1o7pcd",key:"label",className:props.prefixCls+"-item-label text-elli"}),_react2.default.createElement("label",{htmlFor:props.id||this.getId(),className:className,title:label,ecId:this.props.ecId+"_label@bzeuug"},label)):null;}},{key:"renderChildren",value:function renderChildren(){var props=this.props;var children=_react2.default.Children.map(props.children,function(child){if(child&&typeof child.type==="function"&&!child.props.size){return _react2.default.cloneElement(child,{size:"large"});}return child;});return[this.renderLabel(),this.renderWrapper(this.renderValidateWrapper(children,this.renderHelp(),this.renderExtra()))];}},{key:"renderFormItem",value:function renderFormItem(children){var _itemClassName;var props=this.props;var prefixCls=props.prefixCls;var style=props.style;var itemClassName=(_itemClassName={},(0,_defineProperty3.default)(_itemClassName,prefixCls+"-item",true),(0,_defineProperty3.default)(_itemClassName,prefixCls+"-item-with-help",!!this.getHelpMsg()),(0,_defineProperty3.default)(_itemClassName,""+props.className,!!props.className),_itemClassName);return _react2.default.createElement(_row2.default,{ecId:this.props.ecId+"_Row@2115xs",className:(0,_classnames2.default)(itemClassName),style:style},children);}},{key:"render",value:function render(){var children=this.renderChildren();return this.renderFormItem(children);}}]);return FormItem;}(_react2.default.Component),_class.defaultProps={hasFeedback:false,prefixCls:"ant-form"},_class.propTypes={prefixCls:_react2.default.PropTypes.string,label:_react2.default.PropTypes.node,labelCol:_react2.default.PropTypes.object,help:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.node,_react2.default.PropTypes.bool]),validateStatus:_react2.default.PropTypes.oneOf(["","success","warning","error","validating"]),hasFeedback:_react2.default.PropTypes.bool,wrapperCol:_react2.default.PropTypes.object,className:_react2.default.PropTypes.string,id:_react2.default.PropTypes.string,children:_react2.default.PropTypes.node},_class.contextTypes={form:_react2.default.PropTypes.object},_temp);exports.default=FormItem;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ValueMixin={setValue:function setValue(field,e){var v=e;var target=e&&e.target;if(target){if((''+target.nodeName).toLowerCase()==='input'&&target.type==='checkbox'){v=target.checked;}else{v=e.target.value;}}var newFormData={};newFormData[field]=v;this.setState({formData:(0,_extends3.default)({},this.state.formData,newFormData)});}};exports.default=ValueMixin;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(612);__webpack_require__(221);

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _class,_temp;// import RcInputNumber from '../../_rc-input-number-4.0.1/src';
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RcInputNumber=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(1/* limit */).then(__webpack_require__.bind(null, 803));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var InputNumber=(_temp=_class=function(_React$Component){(0,_inherits3.default)(InputNumber,_React$Component);function InputNumber(){(0,_classCallCheck3.default)(this,InputNumber);return(0,_possibleConstructorReturn3.default)(this,(InputNumber.__proto__||(0,_getPrototypeOf2.default)(InputNumber)).apply(this,arguments));}(0,_createClass3.default)(InputNumber,[{key:"render",value:function render(){var _classNames;var _props=this.props,className=_props.className,size=_props.size,other=(0,_objectWithoutProperties3.default)(_props,["className","size"]);var inputNumberClass=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,this.props.prefixCls+"-lg",size==="large"),(0,_defineProperty3.default)(_classNames,this.props.prefixCls+"-sm",size==="small"),(0,_defineProperty3.default)(_classNames,className,!!className),_classNames));return _react2.default.createElement(RcInputNumber,(0,_extends3.default)({className:inputNumberClass},other,{ecId:this.props.ecId+"_RcInputNumber@eofgz1"}));}}]);return InputNumber;}(_react2.default.Component),_class.defaultProps={prefixCls:"ant-input-number",step:1},_temp);exports.default=InputNumber;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(616);

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _locale=__webpack_require__(222);var _merge=__webpack_require__(618);var _merge2=_interopRequireDefault(_merge);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LocaleProvider=(_temp=_class=function(_React$Component){(0,_inherits3.default)(LocaleProvider,_React$Component);function LocaleProvider(props){(0,_classCallCheck3.default)(this,LocaleProvider);var _this=(0,_possibleConstructorReturn3.default)(this,(LocaleProvider.__proto__||(0,_getPrototypeOf2.default)(LocaleProvider)).call(this,props));_this.state={comsLocale:{}};return _this;}(0,_createClass3.default)(LocaleProvider,[{key:'getChildContext',value:function getChildContext(){return{antLocale:(0,_merge2.default)(this.state.comsLocale,this.props.locale||{})};}},{key:'componentDidMount',value:function componentDidMount(){//	WeaTools.callApi('/api/ec/api/locale/taglist','GET',{isused:true,routername:'/coms'}).then( res => {
//	  	this.componentDidUpdate();
//		});
}},{key:'componentDidUpdate',value:function componentDidUpdate(){var locale=this.props.locale;var comsLocale=this.state.comsLocale;var newLocale=(0,_merge2.default)(comsLocale,locale||{});(0,_locale.changeConfirmLocale)(newLocale.Modal);}},{key:'componentWillUnMount',value:function componentWillUnMount(){(0,_locale.changeConfirmLocale)();}},{key:'render',value:function render(){return this.props.children;}}]);return LocaleProvider;}(_react2.default.Component),_class.propTypes={locale:_react2.default.PropTypes.object},_class.childContextTypes={antLocale:_react2.default.PropTypes.object},_temp);exports.default=LocaleProvider;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(619),
    createAssigner = __webpack_require__(635);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(122),
    assignMergeValue = __webpack_require__(223),
    baseFor = __webpack_require__(620),
    baseMergeDeep = __webpack_require__(622),
    isObject = __webpack_require__(29),
    keysIn = __webpack_require__(226),
    safeGet = __webpack_require__(225);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(621);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 621 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(223),
    cloneBuffer = __webpack_require__(623),
    cloneTypedArray = __webpack_require__(624),
    copyArray = __webpack_require__(626),
    initCloneObject = __webpack_require__(627),
    isArguments = __webpack_require__(86),
    isArray = __webpack_require__(26),
    isArrayLikeObject = __webpack_require__(629),
    isBuffer = __webpack_require__(87),
    isFunction = __webpack_require__(124),
    isObject = __webpack_require__(29),
    isPlainObject = __webpack_require__(630),
    isTypedArray = __webpack_require__(88),
    safeGet = __webpack_require__(225),
    toPlainObject = __webpack_require__(631);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(28);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(126)(module)))

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(625);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(186);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 626 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(628),
    getPrototype = __webpack_require__(224),
    isPrototype = __webpack_require__(89);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(67),
    isObjectLike = __webpack_require__(35);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(42),
    getPrototype = __webpack_require__(224),
    isObjectLike = __webpack_require__(35);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(632),
    keysIn = __webpack_require__(226);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(217),
    baseAssignValue = __webpack_require__(135);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29),
    isPrototype = __webpack_require__(89),
    nativeKeysIn = __webpack_require__(634);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 634 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(636),
    isIterateeCall = __webpack_require__(643);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(136),
    overRest = __webpack_require__(637),
    setToString = __webpack_require__(639);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(638);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 638 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(640),
    shortOut = __webpack_require__(642);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(641),
    defineProperty = __webpack_require__(218),
    identity = __webpack_require__(136);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 641 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 642 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(65),
    isArrayLike = __webpack_require__(67),
    isIndex = __webpack_require__(66),
    isObject = __webpack_require__(29);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _src=__webpack_require__(241);var _src2=_interopRequireDefault(_src);var _openAnimation=__webpack_require__(137);var _openAnimation2=_interopRequireDefault(_openAnimation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import RcMenu from '../../_rc-menu-4.13.0/src/Menu';
function noop(){}// const RcMenu = Loadable({
//   loader: () => import("../../_rc-menu-4.13.0/src"),
//   loading: () => null,
//   render: (obj, props, ref) => {
//     if (obj) {
//       return React.createElement(obj && obj.__esModule ? obj.default : obj, {
//         ...props,
//         ref
//       });
//     }
//     return null;
//   }
// });
// const Item = Loadable({
//   loader: () => import("../../_rc-menu-4.13.0/src/MenuItem"),
//   loading: () => null,
//   render: (obj, props, ref) => {
//     if (obj) {
//       return React.createElement(obj && obj.__esModule ? obj.default : obj, {
//         ...props,
//         ref
//       });
//     }
//     return null;
//   }
// });
// const Divider = Loadable({
//   loader: () => import("../../_rc-menu-4.13.0/src/Divider"),
//   loading: () => null,
//   render: (obj, props, ref) => {
//     if (obj) {
//       return React.createElement(obj && obj.__esModule ? obj.default : obj, {
//         ...props,
//         ref
//       });
//     }
//     return null;
//   }
// });
// const SubMenu = Loadable({
//   loader: () => import("../../_rc-menu-4.13.0/src/SubMenu"),
//   loading: () => null,
//   render: (obj, props, ref) => {
//     if (obj) {
//       return React.createElement(obj && obj.__esModule ? obj.default : obj, {
//         ...props,
//         ref
//       });
//     }
//     return null;
//   }
// });
// const ItemGroup = Loadable({
//   loader: () => import("../../_rc-menu-4.13.0/src/MenuItemGroup"),
//   loading: () => null,
//   render: (obj, props, ref) => {
//     if (obj) {
//       return React.createElement(obj && obj.__esModule ? obj.default : obj, {
//         ...props,
//         ref
//       });
//     }
//     return null;
//   }
// });
var Menu=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Menu,_React$Component);function Menu(props){(0,_classCallCheck3.default)(this,Menu);var _this=(0,_possibleConstructorReturn3.default)(this,(Menu.__proto__||(0,_getPrototypeOf2.default)(Menu)).call(this,props));_this.handleClick=function(e){_this.setOpenKeys([]);_this.props.onClick(e);};_this.handleOpenKeys=function(e){var openKeys=e.openKeys;_this.setOpenKeys(openKeys);_this.props.onOpen(e);};_this.handleCloseKeys=function(e){var openKeys=e.openKeys;_this.setOpenKeys(openKeys);_this.props.onClose(e);};_this.state={openKeys:[]};return _this;}(0,_createClass3.default)(Menu,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.mode==="inline"&&nextProps.mode!=="inline"){this.switchModeFromInline=true;}if("openKeys"in nextProps){this.setOpenKeys(nextProps.openKeys);}}},{key:"setOpenKeys",value:function setOpenKeys(openKeys){if(!("openKeys"in this.props)){this.setState({openKeys:openKeys});}}},{key:"render",value:function render(){var openAnimation=this.props.openAnimation||this.props.openTransitionName;if(!openAnimation){switch(this.props.mode){case"horizontal":openAnimation="slide-up";break;case"vertical":// When mode switch from inline
// submenu should hide without animation
if(this.switchModeFromInline){openAnimation="";this.switchModeFromInline=false;}else{openAnimation="zoom-big";}break;case"inline":openAnimation=_openAnimation2.default;break;default:}}var props={};var className=this.props.className+" "+this.props.prefixCls+"-"+this.props.theme;if(this.props.mode!=="inline"){// 这组属性的目的是
// 弹出型的菜单需要点击后立即关闭
// 另外，弹出型的菜单的受控模式没有使用场景
props={openKeys:this.state.openKeys,onClick:this.handleClick,onOpen:this.handleOpenKeys,onClose:this.handleCloseKeys,openTransitionName:openAnimation,className:className};}else{props={openAnimation:openAnimation,className:className};}return _react2.default.createElement(_src2.default,(0,_extends3.default)({},this.props,props,{ecId:this.props.ecId+"_RcMenu@lxya8m"}));}}]);return Menu;}(_react2.default.Component),_class.Divider=_src.Divider,_class.Item=_src.Item,_class.SubMenu=_src.SubMenu,_class.ItemGroup=_src.ItemGroup,_class.defaultProps={prefixCls:"ant-menu",onClick:noop,onOpen:noop,onClose:noop,className:"",theme:"light",// or dark
ifFixed:false},_temp);exports.default=Menu;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(647);

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports=__webpack_require__(649);

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Notification=__webpack_require__(650);var _Notification2=_interopRequireDefault(_Notification);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Notification2.default;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(15);var _propTypes2=_interopRequireDefault(_propTypes);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _createChainedFunction=__webpack_require__(99);var _createChainedFunction2=_interopRequireDefault(_createChainedFunction);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _Notice=__webpack_require__(651);var _Notice2=_interopRequireDefault(_Notice);var _loadCss=__webpack_require__(143);var _window=__webpack_require__(33);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var seed=0;var now=Date.now();function getUuid(){return"rcNotification_"+now+"_"+seed++;}var Notification=(_temp2=_class=function(_Component){(0,_inherits3.default)(Notification,_Component);function Notification(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Notification);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Notification.__proto__||(0,_getPrototypeOf2.default)(Notification)).call.apply(_ref,[this].concat(args))),_this),_this.state={notices:[]},_this.add=function(notice){var key=notice.key=notice.key||getUuid();_this.setState(function(previousState){var notices=previousState.notices;if(!notices.filter(function(v){return v.key===key;}).length){return{notices:notices.concat(notice)};}});},_this.remove=function(key){_this.setState(function(previousState){return{notices:previousState.notices.filter(function(notice){return notice.key!==key;})};});},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Notification,[{key:"getTransitionName",value:function getTransitionName(){var props=this.props;var transitionName=props.transitionName;if(!transitionName&&props.animation){transitionName=props.prefixCls+"-"+props.animation;}return transitionName;}},{key:"render",value:function render(){var _this2=this,_className;var props=this.props;var noticeNodes=this.state.notices.map(function(notice){var onClose=(0,_createChainedFunction2.default)(_this2.remove.bind(_this2,notice.key),notice.onClose);return _react2.default.createElement(_Notice2.default,(0,_extends3.default)({prefixCls:props.prefixCls},notice,{onClose:onClose}),notice.content);});var className=(_className={},(0,_defineProperty3.default)(_className,props.prefixCls,1),(0,_defineProperty3.default)(_className,props.className,!!props.className),_className);return _react2.default.createElement("div",{className:(0,_classnames2.default)(className),style:props.style},_react2.default.createElement(_rcAnimate2.default,{transitionName:this.getTransitionName()},noticeNodes));}}]);return Notification;}(_react.Component),_class.propTypes={prefixCls:_propTypes2.default.string,transitionName:_propTypes2.default.string,animation:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.object]),style:_propTypes2.default.object},_class.defaultProps={prefixCls:"rc-notification",animation:"fade",style:{top:65,left:"50%"}},_temp2);Notification.newInstance=function newNotificationInstance(properties,callback){var _ref2=properties||{},getContainer=_ref2.getContainer,props=(0,_objectWithoutProperties3.default)(_ref2,["getContainer"]);var div=void 0;if(getContainer){div=getContainer();}else{div=document.createElement("div");if(window.setLayoutWindow){window.setLayoutWindow.document.body.appendChild(div);}else{_window2.default.getTop().document.body.appendChild(div);}(0,_loadCss.loadCss)();}var called=false;function ref(notification){if(called){return;}called=true;callback({notice:function notice(noticeProps){notification.add(noticeProps);},removeNotice:function removeNotice(key){notification.remove(key);},component:notification,destroy:function destroy(){_reactDom2.default.unmountComponentAtNode(div);if(!getContainer){if(window.setLayoutWindow){window.setLayoutWindow.document.body.removeChild(div);}else{_window2.default.getTop().document.body.removeChild(div);}}}});}_reactDom2.default.render(_react2.default.createElement(Notification,(0,_extends3.default)({},props,{ref:ref})),div);};exports.default=Notification;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _propTypes=__webpack_require__(15);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Notice=(_temp2=_class=function(_Component){(0,_inherits3.default)(Notice,_Component);function Notice(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,Notice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=Notice.__proto__||(0,_getPrototypeOf2.default)(Notice)).call.apply(_ref,[this].concat(args))),_this),_this.close=function(){_this.clearCloseTimer();_this.props.onClose();},_this.startCloseTimer=function(){if(_this.props.duration){_this.closeTimer=setTimeout(function(){_this.close();},_this.props.duration*1000);}},_this.clearCloseTimer=function(){if(_this.closeTimer){clearTimeout(_this.closeTimer);_this.closeTimer=null;}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(Notice,[{key:'componentDidMount',value:function componentDidMount(){this.startCloseTimer();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.clearCloseTimer();}},{key:'render',value:function render(){var _className;var props=this.props;var componentClass=props.prefixCls+'-notice';var className=(_className={},(0,_defineProperty3.default)(_className,''+componentClass,1),(0,_defineProperty3.default)(_className,componentClass+'-closable',props.closable),(0,_defineProperty3.default)(_className,props.className,!!props.className),_className);return _react2.default.createElement('div',{className:(0,_classnames2.default)(className),style:props.style,onMouseEnter:this.clearCloseTimer,onMouseLeave:this.startCloseTimer},_react2.default.createElement('div',{className:componentClass+'-content'},props.children),props.closable?_react2.default.createElement('a',{tabIndex:'0',onClick:this.close,className:componentClass+'-close'},_react2.default.createElement('span',{className:componentClass+'-close-x'})):null);}}]);return Notice;}(_react.Component),_class.propTypes={duration:_propTypes2.default.number,onClose:_propTypes2.default.func,children:_propTypes2.default.any},_class.defaultProps={onEnd:function onEnd(){},onClose:function onClose(){},duration:1.5,style:{right:'50%'}},_temp2);exports.default=Notice;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(653);

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _Modal=__webpack_require__(227);var _Modal2=_interopRequireDefault(_Modal);var _confirm=__webpack_require__(660);var _confirm2=_interopRequireDefault(_confirm);var _middleware=__webpack_require__(27);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_Modal2.default.info=function(props){var config=(0,_extends3.default)({type:"info",iconType:"info-circle",okCancel:false,showClose:true},props);return(0,_confirm2.default)(config);};_Modal2.default.success=function(props){var config=(0,_extends3.default)({type:"success",iconType:"check-circle",okCancel:false,showClose:true},props);return(0,_confirm2.default)(config);};_Modal2.default.error=function(props){var config=(0,_extends3.default)({type:"error",iconType:"cross-circle",okCancel:false,showClose:true},props);return(0,_confirm2.default)(config);};_Modal2.default.warning=_Modal2.default.warn=function(props){var config=(0,_extends3.default)({type:"warning",iconType:"exclamation-circle",okCancel:false,showClose:true},props);return(0,_confirm2.default)(config);};_Modal2.default.confirm=function(props){var config=(0,_extends3.default)({type:"confirm",ecIconType:"icon-coms-Prompt",okCancel:true,showClose:true},props);return(0,_confirm2.default)(config);};var Com=(0,_middleware2.default)(_Modal2.default,"Modal");exports.default=Com;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports=__webpack_require__(656);

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _Dialog=__webpack_require__(657);var _Dialog2=_interopRequireDefault(_Dialog);var _window=__webpack_require__(33);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function noop(){}function copy(obj,fields){var ret={};fields.forEach(function(f){if(obj[f]!==undefined){ret[f]=obj[f];}});return ret;}var DialogWrap=function(_React$Component){(0,_inherits3.default)(DialogWrap,_React$Component);function DialogWrap(props){(0,_classCallCheck3.default)(this,DialogWrap);var _this=(0,_possibleConstructorReturn3.default)(this,(DialogWrap.__proto__||(0,_getPrototypeOf2.default)(DialogWrap)).call(this,props));_this.state={visible:props.visible};["onClose","onScale","cleanDialogContainer"].forEach(function(m){_this[m]=_this[m].bind(_this);});if(props.visible){window.onWeaDialogOpen&&window.onWeaDialogOpen();}return _this;}(0,_createClass3.default)(DialogWrap,[{key:"componentDidMount",value:function componentDidMount(){this.componentDidUpdate();}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(props){if("visible"in props){if(this.state.visible!==props.visible){if(props.visible){window.onWeaDialogOpen&&window.onWeaDialogOpen();}else{window.onWeaDialogClose&&window.onWeaDialogClose();}}this.setState({visible:props.visible});}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return!!(this.state.visible||nextState.visible);}},{key:"componentDidUpdate",value:function componentDidUpdate(){if(this.dialogRendered){this.dialogInstance=_reactDom2.default.unstable_renderSubtreeIntoContainer(this,this.getDialogElement(),this.getDialogContainer());}}},{key:"componentWillUnmount",value:function componentWillUnmount(){var dialog=this.props.dialog;if(this.props.visible){window.onWeaDialogClose&&window.onWeaDialogClose();}if(this.dialogContainer){if(!dialog&&this.state.visible){_reactDom2.default.unstable_renderSubtreeIntoContainer(this,this.getDialogElement({onAfterClose:this.cleanDialogContainer,onClose:noop,onScale:noop,visible:false}),this.dialogContainer);}else{this.cleanDialogContainer();}}}},{key:"onClose",value:function onClose(e){this.props.onClose(e);}},{key:"onScale",value:function onScale(e,state,height){this.props.onScale(e,state,height);}},{key:"getDialogContainer",value:function getDialogContainer(){var _props$layout=this.props.layout,layout=_props$layout===undefined?_window2.default.getTop().document.body:_props$layout;if(window.setLayoutWindow){layout=window.setLayoutWindow.document.body;}if(!this.dialogContainer){this.dialogContainer=document.createElement("div");layout.appendChild(this.dialogContainer);}return this.dialogContainer;}},{key:"getDialogElement",value:function getDialogElement(extra){var props=this.props;if(window.setLayoutWindow&&window.setDialogFullWindow){var height=$(window.setLayoutWindow.document.body).height();if(height<550){height=550;}props.height=height;props.width=window.setLayoutWindow.document.documentElement.clientWidth;props.draggable=false;}if(window.height<props.height){props.height=window.height-50;}var dialogProps=copy(props,["parentClassName","draggable","className","closable","maskClosable","title","footer","mask","keyboard","animation","transitionName","maskAnimation","maskTransitionName","mousePosition","prefixCls","style","width","wrapStyle","height","zIndex","bodyStyle","wrapClassName","onSpackClick","resize","disableAnimate","scalable","onAfterClose","getRenderModule"]);dialogProps=(0,_extends3.default)({},dialogProps,{onClose:this.onClose,onScale:this.onScale,visible:this.state.visible},extra);return _react2.default.createElement(_Dialog2.default,(0,_extends3.default)({},dialogProps,{ecId:this.props.ecId+"_Dialog@wo4l61",key:"dialog"}),props.children);}},{key:"getElement",value:function getElement(part){return this.dialogInstance.getElement(part);}},{key:"cleanDialogContainer",value:function cleanDialogContainer(){var _props$layout2=this.props.layout,layout=_props$layout2===undefined?_window2.default.getTop().document.body:_props$layout2;if(window.setLayoutWindow){layout=window.setLayoutWindow.document.body;}if(this.dialogContainer){_reactDom2.default.unmountComponentAtNode(this.dialogContainer);if(layout.contains(this.dialogContainer)){layout.removeChild(this.dialogContainer);}this.dialogContainer=null;}}},{key:"render",value:function render(){this.dialogRendered=this.dialogRendered||this.state.visible;return null;}}]);return DialogWrap;}(_react2.default.Component);DialogWrap.defaultProps={className:"",mask:true,keyboard:true,closable:true,scalable:false,maskClosable:true,prefixCls:"rc-dialog",onClose:noop,onScale:noop};DialogWrap.propTypes={className:_react.PropTypes.string,keyboard:_react.PropTypes.bool,wrapStyle:_react.PropTypes.object,style:_react.PropTypes.object,mask:_react.PropTypes.bool,closable:_react.PropTypes.bool,scalable:_react.PropTypes.bool,maskClosable:_react.PropTypes.bool,prefixCls:_react.PropTypes.string,visible:_react.PropTypes.bool,onClose:_react.PropTypes.func,onScale:_react.PropTypes.func,getRenderModule:_react.PropTypes.func};exports.default=DialogWrap;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);exports.getModuleRender=getModuleRender;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _KeyCode=__webpack_require__(47);var _KeyCode2=_interopRequireDefault(_KeyCode);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _LazyRenderBox=__webpack_require__(658);var _LazyRenderBox2=_interopRequireDefault(_LazyRenderBox);var _isString=__webpack_require__(98);var _isString2=_interopRequireDefault(_isString);var _util=__webpack_require__(69);var _util2=_interopRequireDefault(_util);var _reactDraggable=__webpack_require__(659);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _weaLocaleProvider=__webpack_require__(68);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function getModuleRender(){var modules=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var key=arguments[1];var content=arguments[2];var context=arguments[3];var module=modules[key];if(module){if(typeof module==="function"){content=module(context);}content=module;}return content;}var getLabel=_weaLocaleProvider2.default.getLabel;var uuid=0;var openCount=0;// Measure scrollbar width for padding body during modal show/hide
var scrollbarMeasure={position:"absolute",top:"-9999px",width:"50px",height:"50px",overflow:"scroll"};/* eslint react/no-is-mounted:0 */function noop(){}function getScroll(w,top){var ret=w["page"+(top?"Y":"X")+"Offset"];var method="scroll"+(top?"Top":"Left");if(typeof ret!=="number"){var d=w.document;ret=d.documentElement[method];if(typeof ret!=="number"){ret=d.body[method];}}return ret;}function setTransformOrigin(node,value){var style=node.style;["Webkit","Moz","Ms","ms"].forEach(function(prefix){style[prefix+"TransformOrigin"]=value;});style["transformOrigin"]=value;}function offset(el){var rect=el.getBoundingClientRect();var pos={left:rect.left,top:rect.top};var doc=el.ownerDocument;var w=doc.defaultView||doc.parentWindow;pos.left+=getScroll(w);pos.top+=getScroll(w,1);return pos;}var Dialog=_react2.default.createClass({displayName:"Dialog",propTypes:{onAfterClose:_react.PropTypes.func,onClose:_react.PropTypes.func,closable:_react.PropTypes.bool,maskClosable:_react.PropTypes.bool,visible:_react.PropTypes.bool,mousePosition:_react.PropTypes.object,wrapStyle:_react.PropTypes.object,prefixCls:_react.PropTypes.string,wrapClassName:_react.PropTypes.string,onSpackClick:_react.PropTypes.func,onOk:_react.PropTypes.func,onScale:_react.PropTypes.func,scalable:_react.PropTypes.bool},getDefaultProps:function getDefaultProps(){return{onAfterClose:noop,onClose:noop,onScale:noop};},getInitialState:function getInitialState(){this.getInitPosDialog=this.getInitPosDialog.bind(this);return{// drgX: 0,
// drgY: 0,
draggableKey:"draggable-"+new Date().getTime(),x:0,y:0,initPosDialog:null,scaleState:false,dialogTop:undefined,dialogLeft:undefined,bodyHeight:undefined};},componentWillMount:function componentWillMount(){this.titleId="rcDialogTitle"+uuid++;},componentDidMount:function componentDidMount(){this.componentDidUpdate({});this.getInitPosDialog();},componentWillReceiveProps:function componentWillReceiveProps(nextProps,nextState){if("visible"in nextProps&&this.props.visible!==nextProps.visible){if(!nextProps.visible){// this.setState({drgX: 0, drgY: 0});
this.removeScrollingEffect();this.setState({scaleState:false});}else{this.addScrollingEffect();}}},componentDidUpdate:function componentDidUpdate(prevProps){var props=this.props;var mousePosition=this.props.mousePosition;var dialogNode=_reactDom2.default.findDOMNode(this.refs.dialog);if(props.visible){// first show
if(!prevProps.visible){// this.refs.draggable.setState({x: 0, y: 0});
this.lastOutSideFocusNode=document.activeElement;this.addScrollingEffect();this.refs.wrap.focus();// if (mousePosition) {
//   const elOffset = offset(dialogNode);
//   setTransformOrigin(dialogNode,
//     `${mousePosition.x - elOffset.left}px ${mousePosition.y - elOffset.top}px`);
// } else {
//   setTransformOrigin(dialogNode, '');
// }
}}else if(prevProps.visible){dialogNode.style["transform"]="none";this.setState({draggableKey:"draggable-"+new Date().getTime()});// this.refs.draggable.setState({x: 0, y: 0});
if(props.mask&&this.lastOutSideFocusNode){try{this.lastOutSideFocusNode.focus();}catch(e){this.lastOutSideFocusNode=null;}this.lastOutSideFocusNode=null;}}},onAnimateLeave:function onAnimateLeave(){// need demo?
// https://github.com/react-component/dialog/pull/28
if(this.refs.wrap){this.refs.wrap.style.display="none";}this.removeScrollingEffect();this.props.onAfterClose();},onMaskClick:function onMaskClick(e){if(e.target===e.currentTarget&&this.props.closable&&this.props.maskClosable){this.close(e);}},onKeyDown:function onKeyDown(e){var props=this.props;if(props.closable&&props.keyboard){if(e.keyCode===_KeyCode2.default.ESC){this.close(e);}}// keep focus inside dialog
if(props.visible){if(e.keyCode===_KeyCode2.default.TAB){var activeElement=document.activeElement;var dialogRoot=this.refs.wrap;var sentinel=this.refs.sentinel;if(e.shiftKey){if(activeElement===dialogRoot){sentinel.focus();}}else if(activeElement===this.refs.sentinel){dialogRoot.focus();}}if(e.keyCode===_KeyCode2.default.SPACE){props.onSpackClick&&props.onSpackClick(e);}if(e.KeyCode===_KeyCode2.default.ENTER){props.onOk&&props.onOk(e);}}},getInitPosDialog:function getInitPosDialog(){var _this=this;// setTimeOut，添加到事件队列去执行，可以准确获取窗口初始化的位置状态
var dom=$(this.refs.wrap).find(".ant-modal")[0];if(!dom){return;}setTimeout(function(){var posDialog=dom.getBoundingClientRect();_this.setState({firstPosDialog:posDialog});},0);},onStartDrag:function onStartDrag(e,position){var dom=$(this.refs.wrap).find(".ant-modal")[0];if(!dom){return;}var originTransform=$(dom).css("transform").split(",");//  ["matrix(1", " 0", " 0", " 1", " 7", " -4)"]
var nowTransform={x:0,y:0};if(originTransform.length===6){nowTransform.x=parseInt(originTransform[4],10);nowTransform.y=parseInt(originTransform[5],10);}var posDialog=dom.getBoundingClientRect();this.setState({initPosDialog:posDialog,posOffset:nowTransform,initPos:{x:position.x,y:position.y}});},handleDrag:function handleDrag(e,position){var dom=$(this.refs.wrap).find(".ant-modal")[0];var posDialog=dom.getBoundingClientRect();// const posOffset = position;
var _state=this.state,initPosDialog=_state.initPosDialog,initPos=_state.initPos,posOffset=_state.posOffset,firstPosDialog=_state.firstPosDialog;if(!firstPosDialog){return;}var browserSize={width:window.innerWidth,height:window.innerHeight};var hideRate=0.8;var cursorOffset={x:initPos.x-initPosDialog.x,y:initPos.y-initPosDialog.y};// console.log(cursorOffset);
var newX=e.clientX-initPos.x+posOffset.x;var newY=e.clientY-initPos.y+posOffset.y;// console.log('mouse', e.clientX, e.clientY, 'mouse down', initPos.x, initPos.y, 'offset', posOffset.x, posOffset.y)
// console.log('initposdia', initPosDialog)
var limitedPoint={x:e.clientX-cursorOffset.x,y:e.clientY-cursorOffset.y};if(limitedPoint.x<-posDialog.width*hideRate){newX=-firstPosDialog.x-posDialog.width*hideRate;}if(limitedPoint.x>browserSize.width-posDialog.width*(1-hideRate)){newX=-firstPosDialog.x+browserSize.width-posDialog.width*(1-hideRate);}if(limitedPoint.y<0){newY=-firstPosDialog.y;}if(limitedPoint.y>browserSize.height-posDialog.height*(1-hideRate)){newY=-firstPosDialog.y+browserSize.height-posDialog.height*(1-hideRate);}newX=Math.floor(newX);newY=Math.floor(newY);// console.log(newX, newY);
$(dom).css("transform","translate("+newX+"px, "+newY+"px)");// this.setState({ x: newX, y: newY });
},setBodyHeight:function setBodyHeight(ref){if(!ref)return;var scalable=this.props.scalable;var scaleState=this.state.scaleState;if(scalable&&scaleState&&this.refs.dialog&&this.refs.dialog.refs.renderBox){var dHeight=this.refs.dialog.refs.renderBox.clientHeight;var hHeight=this.refs.header?this.refs.header.clientHeight:0;var fHeight=this.refs.footer?this.refs.footer.clientHeight:0;ref.style.height=dHeight-hHeight-fHeight+"px";}},getDialogHeader:function getDialogHeader(modules){var props=this.props;var prefixCls=props.prefixCls,_props$draggable=props.draggable,draggable=_props$draggable===undefined?true:_props$draggable;var nodrag=_util2.default.isBelowIE9()||!draggable;// IE9 暂时不让拖拽
var module_1_1=getModuleRender(modules,"module_1_1",props.title,this);var module_1=void 0;if(module_1_1){module_1=_react2.default.createElement("div",{className:prefixCls+"-header",ref:"header"},_react2.default.createElement("div",{className:prefixCls+"-title "+(nodrag?"":"cursor-move"),id:this.titleId},module_1_1));}module_1=getModuleRender(modules,"module_1",module_1,this);return{module_1:module_1,module_1_1:module_1_1};},getDialogContent:function getDialogContent(modules){var _state2=this.state,scaleState=_state2.scaleState,bodyHeight=_state2.bodyHeight;var props=this.props;var scalable=props.scalable,closable=props.closable,prefixCls=props.prefixCls;var scaleBodyStyle={};if(scalable){if(!scaleState){scaleBodyStyle=(0,_extends3.default)({},scaleBodyStyle,{height:bodyHeight+"px"});}}var bodyStyle=(0,_extends3.default)({},props.bodyStyle,scaleBodyStyle);var module_2=_react2.default.createElement("div",{className:prefixCls+"-body "+(scalable?prefixCls+"-body-scalable":""),style:bodyStyle,ref:"body"},props.children);module_2=getModuleRender(modules,"module_2",module_2,this);var module_3=props.footer;if(module_3){module_3=_react2.default.createElement("div",{className:prefixCls+"-footer",ref:"footer"},(0,_isString2.default)(module_3)?_react2.default.createElement("div",{dangerouslySetInnerHTML:{__html:module_3}}):module_3);}module_3=getModuleRender(modules,"module_3",module_3,this);var module_4=void 0;if(closable){module_4=_react2.default.createElement("span",{ecId:this.props.ecId+"_span@ekl553",onClick:this.close,className:prefixCls+"-close"},_react2.default.createElement("span",{className:prefixCls+"-close-x"}));}module_4=getModuleRender(modules,"module_4",module_4,this);return(0,_extends3.default)({},this.getDialogHeader(modules),{module_2:module_2,module_3:module_3,module_4:module_4});},getDialogElement:function getDialogElement(){var _state3=this.state,draggableKey=_state3.draggableKey,scaleState=_state3.scaleState,dialogTop=_state3.dialogTop,dialogLeft=_state3.dialogLeft;var props=this.props;var _props$draggable2=props.draggable,draggable=_props$draggable2===undefined?true:_props$draggable2,scalable=props.scalable,prefixCls=props.prefixCls;var nodrag=_util2.default.isBelowIE9()||!draggable;// IE9 暂时不让拖拽
var dest={};if(props.width!==undefined){dest.width=props.width;}if(props.height!==undefined){dest.height=props.height;}var scale=void 0;var scaleStyle={};if(scalable){scale=_react2.default.createElement("span",{ecId:this.props.ecId+"_span@prshhj",onClick:this.scale,className:prefixCls+"-scale"},_react2.default.createElement("icon",{className:""+(scaleState?"icon-coms-All-contraction":"icon-coms-All-unfolding"),title:scaleState?getLabel(589,"还原"):getLabel(19944,"最大化")}));if(scaleState){scaleStyle=(0,_extends3.default)({},scaleStyle,{height:"100%",width:"100%",left:0,top:0,paddingBottom:0,transform:""// 清除拖拽位移
});}else{scaleStyle=(0,_extends3.default)({},scaleStyle,{top:dialogTop,left:dialogLeft});}}var module_5=getModuleRender(modules,"module_5",scale,this);var style=(0,_extends3.default)({},props.style,dest,scaleStyle);var transitionName=this.getTransitionName();var modules=this.getDialogContent();if(typeof props.getRenderModule==="function"){modules=props.getRenderModule(this,(0,_extends3.default)({},modules,{module_5:module_5}))||{};module_5=modules.module_5||module_5;modules=this.getDialogContent(modules);}var _modules=modules,module_1=_modules.module_1,module_2=_modules.module_2,module_3=_modules.module_3,module_4=_modules.module_4;var dialogElement=nodrag?_react2.default.createElement(_LazyRenderBox2.default,{ecId:this.props.ecId+"_LazyRenderBox@3puw9j",role:"document",ref:"dialog",style:style,className:prefixCls+" "+(props.className||""),visible:props.visible,resize:props.resize},_react2.default.createElement("div",{className:prefixCls+"-content "+(scaleState?prefixCls+"-content-scaled":"")},module_5,module_4,module_1,module_2,module_3),_react2.default.createElement("div",{tabIndex:"0",ref:"sentinel",style:{width:0,height:0,overflow:"hidden"}},"sentinel")):_react2.default.createElement(_reactDraggable.DraggableCore,{ecId:this.props.ecId+"_DraggableCore@3ha0pj",handle:".ant-modal-title",ref:"draggable",key:draggableKey// position={{ x: this.state.x, y: this.state.y }}
,onDrag:scalable&&scaleState?noop:this.handleDrag.bind(this),onStart:scalable&&scaleState?noop:this.onStartDrag.bind(this)},_react2.default.createElement(_LazyRenderBox2.default,{ecId:this.props.ecId+"_LazyRenderBox@jdqr1b",role:"document",ref:"dialog",style:style,className:prefixCls+" "+(props.className||""),visible:props.visible,resize:props.resize},_react2.default.createElement("div",{className:prefixCls+"-content "+(scaleState?prefixCls+"-content-scaled":"")},module_5,module_4,module_1,module_2,module_3),_react2.default.createElement("div",{tabIndex:"0",ref:"sentinel",style:{width:0,height:0,overflow:"hidden"}},"sentinel")));return!props.disableAnimate?_react2.default.createElement(_rcAnimate2.default,{ecId:this.props.ecId+"_Animate@naejrk",key:"dialog",showProp:"visible",onLeave:this.onAnimateLeave,transitionName:transitionName,component:"",transitionAppear:true},dialogElement):dialogElement;},getZIndexStyle:function getZIndexStyle(){var style={};var props=this.props;if(props.zIndex!==undefined){style.zIndex=props.zIndex;}return style;},getWrapStyle:function getWrapStyle(){return(0,_extends3.default)({},this.getZIndexStyle(),this.props.wrapStyle);},getMaskElement:function getMaskElement(){var props=this.props;var maskElement=void 0;if(props.mask){var maskTransition=this.getMaskTransitionName();maskElement=_react2.default.createElement(_LazyRenderBox2.default,{ecId:this.props.ecId+"_LazyRenderBox@b7ryhq",style:this.getZIndexStyle(),key:"mask",className:props.prefixCls+"-mask",hiddenClassName:props.prefixCls+"-mask-hidden",visible:props.visible});if(maskTransition){maskElement=_react2.default.createElement(_rcAnimate2.default,{ecId:this.props.ecId+"_Animate@2e4ywr",key:"mask",showProp:"visible",transitionAppear:true,component:"",transitionName:maskTransition},maskElement);}}return maskElement;},getMaskTransitionName:function getMaskTransitionName(){var props=this.props;var transitionName=props.maskTransitionName;var animation=props.maskAnimation;if(!transitionName&&animation){transitionName=props.prefixCls+"-"+animation;}return transitionName;},getTransitionName:function getTransitionName(){var props=this.props;var transitionName=props.transitionName;var animation=props.animation;if(!transitionName&&animation){transitionName=props.prefixCls+"-"+animation;}return transitionName;},getElement:function getElement(part){return this.refs[part];},setScrollbar:function setScrollbar(){if(this.bodyIsOverflowing&&this.scrollbarWidth){document.body.style.paddingRight=this.scrollbarWidth+"px";}},addScrollingEffect:function addScrollingEffect(){document.body.style.overflow="hidden";openCount++;if(openCount!==1){return;}this.checkScrollbar();this.setScrollbar();// this.adjustDialog();
},removeScrollingEffect:function removeScrollingEffect(){document.body.style.overflow="";openCount--;if(openCount!==0){return;}this.resetScrollbar();// this.resetAdjustments();
},close:function close(e){// reset modal drag position
// this.setState({drgX:0, drgY:0});
// $(this.refs.dialog).css('transform', 'none');
this.removeScrollingEffect();this.setState({scaleState:false});this.props.onClose(e);typeof this.props.onAfterClose==="function"&&this.props.onAfterClose();},scale:function scale(e){var _this2=this;var _state4=this.state,scaleState=_state4.scaleState,dialogTop=_state4.dialogTop,dialogLeft=_state4.dialogLeft,bodyHeight=_state4.bodyHeight;var newState={};// 保留原始位置
if(!scaleState&&this.refs.dialog&&this.refs.dialog.refs.renderBox){var box=this.refs.dialog.refs.renderBox;var top=box.style.top;var left=box.style.left;if(top!==dialogTop||left!==dialogLeft){newState=(0,_extends3.default)({},newState,{dialogTop:top,dialogLeft:left});}box.style.transition="all .3s ease-in-out";}if(!scaleState&&this.refs.body){var body=this.refs.body;var height=body.clientHeight;if(height!==bodyHeight){newState=(0,_extends3.default)({},newState,{bodyHeight:height});}}this.setState((0,_extends3.default)({},newState,{scaleState:!scaleState}),function(){if(_this2.refs.body){if(!scaleState){_this2.setBodyHeight(_this2.refs.body);}}if(_this2.refs.dialog&&_this2.refs.dialog.refs.renderBox&&scaleState){setTimeout(function(){_this2.refs.dialog.refs.renderBox.style.transition="";},300);}_this2.props.onScale(e,!scaleState,scaleState?bodyHeight:_this2.refs.body.clientHeight);});},checkScrollbar:function checkScrollbar(){var fullWindowWidth=window.innerWidth;if(!fullWindowWidth){// workaround for missing window.innerWidth in IE8
var documentElementRect=document.documentElement.getBoundingClientRect();fullWindowWidth=documentElementRect.right-Math.abs(documentElementRect.left);}this.bodyIsOverflowing=document.body.clientWidth<fullWindowWidth;if(this.bodyIsOverflowing){this.scrollbarWidth=this.measureScrollbar();}},resetScrollbar:function resetScrollbar(){document.body.style.paddingRight="";},measureScrollbar:function measureScrollbar(){if(this.scrollbarWidth!==undefined){return this.scrollbarWidth;}var scrollDiv=document.createElement("div");for(var scrollProp in scrollbarMeasure){if(scrollbarMeasure.hasOwnProperty(scrollProp)){scrollDiv.style[scrollProp]=scrollbarMeasure[scrollProp];}}document.body.appendChild(scrollDiv);var scrollbarWidth=scrollDiv.offsetWidth-scrollDiv.clientWidth;document.body.removeChild(scrollDiv);this.scrollbarWidth=scrollbarWidth;return scrollbarWidth;},adjustDialog:function adjustDialog(){if(this.refs.wrap&&this.scrollbarWidth){var modalIsOverflowing=this.refs.wrap.scrollHeight>document.documentElement.clientHeight;this.refs.wrap.style.paddingLeft=(!this.bodyIsOverflowing&&modalIsOverflowing?this.scrollbarWidth:"")+"px";this.refs.wrap.style.paddingRight=(this.bodyIsOverflowing&&!modalIsOverflowing?this.scrollbarWidth:"")+"px";}},resetAdjustments:function resetAdjustments(){if(this.refs.wrap){this.refs.wrap.style.paddingLeft=this.refs.wrap.style.paddingLeft="";}},render:function render(){var props=this.props;var prefixCls=props.prefixCls;var style=this.getWrapStyle();// clear hide display
// and only set display after async anim, not here for hide
if(props.visible){style.display=null;}else{style.display="none";}return _react2.default.createElement("div",{className:""+props.parentClassName},this.getMaskElement(),_react2.default.createElement("div",{ecId:this.props.ecId+"_div@pk1lua",tabIndex:"-1",onKeyDown:this.onKeyDown,className:prefixCls+"-wrap "+(props.wrapClassName||""),ref:"wrap",onClick:this.onMaskClick,role:"dialog","aria-labelledby":props.title?this.titleId:null,style:style},this.getDialogElement()));}});exports.default=Dialog;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _window=__webpack_require__(33);var _window2=_interopRequireDefault(_window);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LazyRenderBox=_react2.default.createClass({displayName:"LazyRenderBox",propTypes:{className:_react.PropTypes.string,visible:_react.PropTypes.bool,hiddenClassName:_react.PropTypes.string},shouldComponentUpdate:function shouldComponentUpdate(nextProps){return nextProps.hiddenClassName||nextProps.visible;},componentWillReceiveProps:function componentWillReceiveProps(nextProps){if("visible"in nextProps&&nextProps.visible&&this.props.visible!==nextProps.visible){this.canSetPosition=true;}else{this.canSetPosition=false;}},canSetPosition:true,setPosition:function setPosition(scale){var _this=this;if(this.props.role=="document"&&(this.canSetPosition&&this.props.visible||this.props.resize||scale)){var renderBox=$(this.refs.renderBox);var modal=renderBox.find(".ant-modal-content");var modalHeight=modal.outerHeight();var modalWidth=modal.outerWidth();var interval=setInterval(function(){var topWindow=window.inIframe?window:_window2.default.getTop();if(topWindow!==undefined){_this.canSetPosition=false;clearInterval(interval);var bodyHeight=$(topWindow.document.body).height();var bodyWidth=topWindow.document.documentElement.clientWidth;var top=Math.floor((bodyHeight-modalHeight)/2);var left=Math.floor((bodyWidth-modalWidth)/2);if(window.setLayoutWindow&&window.setDialogFullWindow){var document=window.setLayoutWindow.document;var height=$(document.body).height();if(height<550){height=550;}bodyHeight=Math.floor(height);bodyWidth=Math.floor(document.documentElement.clientWidth);top=0;left=0;modal.css("height",bodyHeight+"px").css("width",bodyWidth+"px").css("border-radius","0");}renderBox.css("top",top+"px").css("left",left+"px").css("margin","0").css("visibility","visible");}},0);}},onResize:function onResize(){var _this2=this;if(this.props.className=="ant-modal-mask"){return;}var renderBox=$(this.refs.renderBox);var modal=renderBox.find(".ant-modal-content");var modalHeight=modal.outerHeight();var modalWidth=modal.outerWidth();var interval=setInterval(function(){var topWindow=window.inIframe?window:_window2.default.getTop();if(topWindow!==undefined){_this2.canSetPosition=false;clearInterval(interval);var bodyHeight=$(topWindow.document.body).height();var bodyWidth=topWindow.document.documentElement.clientWidth;var top=Math.floor((bodyHeight-modalHeight)/2);var left=Math.floor((bodyWidth-modalWidth)/2);if(window.setLayoutWindow&&window.setDialogFullWindow){var document=window.setLayoutWindow.document;var height=$(document.body).height();if(height<550){height=550;}bodyHeight=Math.floor(height);bodyWidth=Math.floor(document.documentElement.clientWidth);top=0;left=0;modal.css("height",bodyHeight+"px").css("width",bodyWidth+"px").css("border-radius","0");}renderBox.css("top",top+"px").css("left",left+"px").css("margin","0").css("visibility","visible");}},0);},componentDidMount:function componentDidMount(){this.setPosition();if(window.onresize){var oldResize=window.onresize;window.onresize=function(){oldResize();try{this.onResize();}catch(error){}}.bind(this);}else{window.onresize=function(){try{this.onResize();}catch(error){}}.bind(this);}},componentDidUpdate:function componentDidUpdate(){this.setPosition();},render:function render(){var className=this.props.className;if(this.props.hiddenClassName&&!this.props.visible){className+=" "+this.props.hiddenClassName;}var props=(0,_extends3.default)({},this.props);delete props.hiddenClassName;delete props.visible;props.className=className;var modalStyle=(0,_extends3.default)({},props.style)||{};if(window.setLayoutWindow){modalStyle.height=$(window.setLayoutWindow.document.body).height()+"px";modalStyle.bodyWidth=window.setLayoutWindow.document.documentElement.clientWidth+"px";}if(props.role=="document")modalStyle.visibility="hidden";// 解决签章等 object 在 IE 覆盖弹框层级的问题 zxt - 20200113
if(this.props.className=="ant-modal-mask"){return _react2.default.createElement("div",(0,_extends3.default)({ref:"renderBox"},props,{ecId:this.props.ecId+"_div@k546ee",style:modalStyle}),_react2.default.createElement("iframe",{style:{width:"100%",height:"100%",position:"absolute",zIndex:-1,pointerEvents:"none",border:"none"}}));}return _react2.default.createElement("div",(0,_extends3.default)({ref:"renderBox"},props,{ecId:this.props.ecId+"_div@nreky5",style:modalStyle}));}});exports.default=LazyRenderBox;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory(__webpack_require__(10), __webpack_require__(0)) :
	typeof define === 'function' && define.amd ? define(['react-dom', 'react'], factory) :
	(global.ReactDraggable = factory(global.ReactDOM,global.React));
}(this, (function (ReactDOM,React) { 'use strict';

	ReactDOM = ReactDOM && ReactDOM.hasOwnProperty('default') ? ReactDOM['default'] : ReactDOM;
	React = React && React.hasOwnProperty('default') ? React['default'] : React;

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */

	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}

	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};

	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};

	var emptyFunction_1 = emptyFunction;

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var validateFormat = function validateFormat(format) {};

	{
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}

	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}

	var invariant_1 = invariant;

	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */

	var warning = emptyFunction_1;

	{
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }

	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };

	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }

	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }

	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }

	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}

	var warning_1 = warning;

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	var ReactPropTypesSecret_1 = ReactPropTypesSecret;

	{
	  var invariant$1 = invariant_1;
	  var warning$1 = warning_1;
	  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
	  var loggedTypeFailures = {};
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
	        } catch (ex) {
	          error = ex;
	        }
	        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}

	var checkPropTypes_1 = checkPropTypes;

	var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret_1) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant_1(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if ("development" !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning_1(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.');
	      return emptyFunction_1.thatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.');
	      return emptyFunction_1.thatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning_1(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction_1.thatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
	          return null;
	        }
	      }

	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = objectAssign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};

	var propTypes = createCommonjsModule(function (module) {
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	{
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;

	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };

	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
	}
	});

	var classnames = createCommonjsModule(function (module) {
	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if ('object' !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (false) {
			// register as 'classnames', consistent with npm package name
			undefined('classnames', [], function () {
				return classNames;
			});
		} else {
			window.classNames = classNames;
		}
	}());
	});

	// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
	function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
	  for (var i = 0, length = array.length; i < length; i++) {
	    if (callback.apply(callback, [array[i], i, array])) return array[i];
	  }
	}

	function isFunction(func /*: any*/) /*: boolean*/ {
	  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
	}

	function isNum(num /*: any*/) /*: boolean*/ {
	  return typeof num === 'number' && !isNaN(num);
	}

	function int(a /*: string*/) /*: number*/ {
	  return parseInt(a, 10);
	}

	function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
	  if (props[propName]) {
	    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
	  }
	}

	var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
	function getPrefix() /*: string*/ {
	  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';

	  // Checking specifically for 'window.document' is for pseudo-browser server-side
	  // environments that define 'window' as the global context.
	  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
	  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';

	  var style = window.document.documentElement.style;

	  if (prop in style) return '';

	  for (var i = 0; i < prefixes.length; i++) {
	    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
	  }

	  return '';
	}

	function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
	  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
	}

	function kebabToTitleCase(str /*: string*/) /*: string*/ {
	  var out = '';
	  var shouldCapitalize = true;
	  for (var i = 0; i < str.length; i++) {
	    if (shouldCapitalize) {
	      out += str[i].toUpperCase();
	      shouldCapitalize = false;
	    } else if (str[i] === '-') {
	      shouldCapitalize = true;
	    } else {
	      out += str[i];
	    }
	  }
	  return out;
	}

	// Default export is the prefix itself, like 'Moz', 'Webkit', etc
	// Note that you may have to re-test for certain things; for instance, Chrome 50
	// can handle unprefixed `transform`, but not unprefixed `user-select`
	var browserPrefix = getPrefix();

	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	};

	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};

	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};

	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;

	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);

	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }

	    return _arr;
	  }

	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

	/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/


	var matchesSelectorFunc = '';
	function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
	  if (!matchesSelectorFunc) {
	    matchesSelectorFunc = findInArray(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
	      // $FlowIgnore: Doesn't think elements are indexable
	      return isFunction(el[method]);
	    });
	  }

	  // Might not be found entirely (not an Element?) - in that case, bail
	  // $FlowIgnore: Doesn't think elements are indexable
	  if (!isFunction(el[matchesSelectorFunc])) return false;

	  // $FlowIgnore: Doesn't think elements are indexable
	  return el[matchesSelectorFunc](selector);
	}

	// Works up the tree to the draggable itself attempting to match selector.
	function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
	  var node = el;
	  do {
	    if (matchesSelector(node, selector)) return true;
	    if (node === baseNode) return false;
	    node = node.parentNode;
	  } while (node);

	  return false;
	}

	function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
	  if (!el) {
	    return;
	  }
	  if (el.attachEvent) {
	    el.attachEvent('on' + event, handler);
	  } else if (el.addEventListener) {
	    el.addEventListener(event, handler, true);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = handler;
	  }
	}

	function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
	  if (!el) {
	    return;
	  }
	  if (el.detachEvent) {
	    el.detachEvent('on' + event, handler);
	  } else if (el.removeEventListener) {
	    el.removeEventListener(event, handler, true);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = null;
	  }
	}

	function outerHeight(node /*: HTMLElement*/) /*: number*/ {
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetTop which is including margin. See getBoundPosition
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height += int(computedStyle.borderTopWidth);
	  height += int(computedStyle.borderBottomWidth);
	  return height;
	}

	function outerWidth(node /*: HTMLElement*/) /*: number*/ {
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetLeft which is including margin. See getBoundPosition
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width += int(computedStyle.borderLeftWidth);
	  width += int(computedStyle.borderRightWidth);
	  return width;
	}
	function innerHeight(node /*: HTMLElement*/) /*: number*/ {
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height -= int(computedStyle.paddingTop);
	  height -= int(computedStyle.paddingBottom);
	  return height;
	}

	function innerWidth(node /*: HTMLElement*/) /*: number*/ {
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width -= int(computedStyle.paddingLeft);
	  width -= int(computedStyle.paddingRight);
	  return width;
	}

	// Get from offsetParent
	function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
	  var isBody = offsetParent === offsetParent.ownerDocument.body;
	  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();

	  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
	  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;

	  return { x: x, y: y };
	}

	function createCSSTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: Object*/ {
	  var translation = getTranslation(controlPos, positionOffset, 'px');
	  return defineProperty({}, browserPrefixToKey('transform', browserPrefix), translation);
	}

	function createSVGTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: string*/ {
	  var translation = getTranslation(controlPos, positionOffset, '');
	  return translation;
	}
	function getTranslation(_ref2, positionOffset /*: PositionOffsetControlPosition*/, unitSuffix /*: string*/) /*: string*/ {
	  var x = _ref2.x,
	      y = _ref2.y;

	  var translation = 'translate(' + x + unitSuffix + ',' + y + unitSuffix + ')';
	  if (positionOffset) {
	    var defaultX = '' + (typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
	    var defaultY = '' + (typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
	    translation = 'translate(' + defaultX + ', ' + defaultY + ')' + translation;
	  }
	  return translation;
	}

	function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
	  return e.targetTouches && findInArray(e.targetTouches, function (t) {
	    return identifier === t.identifier;
	  }) || e.changedTouches && findInArray(e.changedTouches, function (t) {
	    return identifier === t.identifier;
	  });
	}

	function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
	  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
	  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
	}

	// User-select Hacks:
	//
	// Useful for preventing blue highlights all over everything when dragging.

	// Note we're passing `document` b/c we could be iframed
	function addUserSelectStyles(doc /*: ?Document*/) {
	  if (!doc) return;
	  var styleEl = doc.getElementById('react-draggable-style-el');
	  if (!styleEl) {
	    styleEl = doc.createElement('style');
	    styleEl.type = 'text/css';
	    styleEl.id = 'react-draggable-style-el';
	    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
	    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
	    doc.getElementsByTagName('head')[0].appendChild(styleEl);
	  }
	  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
	}

	function removeUserSelectStyles(doc /*: ?Document*/) {
	  try {
	    if (doc && doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
	    // $FlowIgnore: IE
	    if (doc.selection) {
	      // $FlowIgnore: IE
	      doc.selection.empty();
	    } else {
	      window.getSelection().removeAllRanges(); // remove selection caused by scroll
	    }
	  } catch (e) {
	    // probably IE
	  }
	}

	function styleHacks() /*: Object*/ {
	  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	  // Workaround IE pointer events; see #51
	  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
	  return _extends({
	    touchAction: 'none'
	  }, childStyle);
	}

	function addClassName(el /*: HTMLElement*/, className /*: string*/) {
	  if (el.classList) {
	    el.classList.add(className);
	  } else {
	    if (!el.className.match(new RegExp('(?:^|\\s)' + className + '(?!\\S)'))) {
	      el.className += ' ' + className;
	    }
	  }
	}

	function removeClassName(el /*: HTMLElement*/, className /*: string*/) {
	  if (el.classList) {
	    el.classList.remove(className);
	  } else {
	    el.className = el.className.replace(new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'g'), '');
	  }
	}

	/*:: import type Draggable from '../Draggable';*/
	/*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/
	/*:: import type DraggableCore from '../DraggableCore';*/


	function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
	  // If no bounds, short-circuit and move on
	  if (!draggable.props.bounds) return [x, y];

	  // Clone new bounds
	  var bounds = draggable.props.bounds;

	  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
	  var node = findDOMNode(draggable);

	  if (typeof bounds === 'string') {
	    var ownerDocument = node.ownerDocument;

	    var ownerWindow = ownerDocument.defaultView;
	    var boundNode = void 0;
	    if (bounds === 'parent') {
	      boundNode = node.parentNode;
	    } else {
	      boundNode = ownerDocument.querySelector(bounds);
	    }
	    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
	      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
	    }
	    var nodeStyle = ownerWindow.getComputedStyle(node);
	    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
	    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
	    bounds = {
	      left: -node.offsetLeft + int(boundNodeStyle.paddingLeft) + int(nodeStyle.marginLeft),
	      top: -node.offsetTop + int(boundNodeStyle.paddingTop) + int(nodeStyle.marginTop),
	      right: innerWidth(boundNode) - outerWidth(node) - node.offsetLeft + int(boundNodeStyle.paddingRight) - int(nodeStyle.marginRight),
	      bottom: innerHeight(boundNode) - outerHeight(node) - node.offsetTop + int(boundNodeStyle.paddingBottom) - int(nodeStyle.marginBottom)
	    };
	  }

	  // Keep x and y below right and bottom limits...
	  if (isNum(bounds.right)) x = Math.min(x, bounds.right);
	  if (isNum(bounds.bottom)) y = Math.min(y, bounds.bottom);

	  // But above left and top limits.
	  if (isNum(bounds.left)) x = Math.max(x, bounds.left);
	  if (isNum(bounds.top)) y = Math.max(y, bounds.top);

	  return [x, y];
	}

	function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
	  var x = Math.round(pendingX / grid[0]) * grid[0];
	  var y = Math.round(pendingY / grid[1]) * grid[1];
	  return [x, y];
	}

	function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
	  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
	}

	function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
	  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
	}

	// Get {x, y} positions from event.
	function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
	  var touchObj = typeof touchIdentifier === 'number' ? getTouch(e, touchIdentifier) : null;
	  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
	  var node = findDOMNode(draggableCore);
	  // User can provide an offsetParent if desired.
	  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
	  return offsetXYFromParent(touchObj || e, offsetParent);
	}

	// Create an data object exposed by <DraggableCore>'s events
	function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
	  var state = draggable.state;
	  var isStart = !isNum(state.lastX);
	  var node = findDOMNode(draggable);

	  if (isStart) {
	    // If this is our first move, use the x and y as last coords.
	    return {
	      node: node,
	      deltaX: 0, deltaY: 0,
	      lastX: x, lastY: y,
	      x: x, y: y
	    };
	  } else {
	    // Otherwise calculate proper values.
	    return {
	      node: node,
	      deltaX: x - state.lastX, deltaY: y - state.lastY,
	      lastX: state.lastX, lastY: state.lastY,
	      x: x, y: y
	    };
	  }
	}

	// Create an data exposed by <Draggable>'s events
	function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
	  var scale = draggable.props.scale;
	  return {
	    node: coreData.node,
	    x: draggable.state.x + coreData.deltaX / scale,
	    y: draggable.state.y + coreData.deltaY / scale,
	    deltaX: coreData.deltaX / scale,
	    deltaY: coreData.deltaY / scale,
	    lastX: draggable.state.x,
	    lastY: draggable.state.y
	  };
	}

	// A lot faster than stringify/parse
	function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
	  return {
	    left: bounds.left,
	    top: bounds.top,
	    right: bounds.right,
	    bottom: bounds.bottom
	  };
	}

	function findDOMNode(draggable /*: Draggable | DraggableCore*/) /*: HTMLElement*/ {
	  var node = ReactDOM.findDOMNode(draggable);
	  if (!node) {
	    throw new Error('<DraggableCore>: Unmounted during event!');
	  }
	  // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
	  return node;
	}

	/*eslint no-console:0*/
	function log() {
	}

	/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/


	// Simple abstraction for dragging events names.
	/*:: import type {Element as ReactElement} from 'react';*/
	var eventsFor = {
	  touch: {
	    start: 'touchstart',
	    move: 'touchmove',
	    stop: 'touchend'
	  },
	  mouse: {
	    start: 'mousedown',
	    move: 'mousemove',
	    stop: 'mouseup'
	  }
	};

	// Default to mouse events.
	var dragEventFor = eventsFor.mouse;

	/*:: type DraggableCoreState = {
	  dragging: boolean,
	  lastX: number,
	  lastY: number,
	  touchIdentifier: ?number
	};*/
	/*:: export type DraggableBounds = {
	  left: number,
	  right: number,
	  top: number,
	  bottom: number,
	};*/
	/*:: export type DraggableData = {
	  node: HTMLElement,
	  x: number, y: number,
	  deltaX: number, deltaY: number,
	  lastX: number, lastY: number,
	};*/
	/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void;*/
	/*:: export type ControlPosition = {x: number, y: number};*/
	/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/


	//
	// Define <DraggableCore>.
	//
	// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
	// work well with libraries that require more control over the element.
	//

	/*:: export type DraggableCoreProps = {
	  allowAnyClick: boolean,
	  cancel: string,
	  children: ReactElement<any>,
	  disabled: boolean,
	  enableUserSelectHack: boolean,
	  offsetParent: HTMLElement,
	  grid: [number, number],
	  handle: string,
	  onStart: DraggableEventHandler,
	  onDrag: DraggableEventHandler,
	  onStop: DraggableEventHandler,
	  onMouseDown: (e: MouseEvent) => void,
	};*/

	var DraggableCore = function (_React$Component) {
	  inherits(DraggableCore, _React$Component);

	  function DraggableCore() {
	    var _ref;

	    var _temp, _this, _ret;

	    classCallCheck(this, DraggableCore);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      dragging: false,
	      // Used while dragging to determine deltas.
	      lastX: NaN, lastY: NaN,
	      touchIdentifier: null
	    }, _this.handleDragStart = function (e) {
	      // Make it possible to attach event handlers on top of this one.
	      _this.props.onMouseDown(e);

	      // Only accept left-clicks.
	      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;

	      // Get nodes. Be sure to grab relative document (could be iframed)
	      var thisNode = ReactDOM.findDOMNode(_this);
	      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
	        throw new Error('<DraggableCore> not mounted on DragStart!');
	      }
	      var ownerDocument = thisNode.ownerDocument;

	      // Short circuit if handle or cancel prop was provided and selector doesn't match.

	      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !matchesSelectorAndParentsTo(e.target, _this.props.handle, thisNode) || _this.props.cancel && matchesSelectorAndParentsTo(e.target, _this.props.cancel, thisNode)) {
	        return;
	      }

	      // Set touch identifier in component state if this is a touch event. This allows us to
	      // distinguish between individual touches on multitouch screens by identifying which
	      // touchpoint was set to this element.
	      var touchIdentifier = getTouchIdentifier(e);
	      _this.setState({ touchIdentifier: touchIdentifier });

	      // Get the current drag point from the event. This is used as the offset.
	      var position = getControlPosition(e, touchIdentifier, _this);
	      if (position == null) return; // not possible but satisfies flow
	      var x = position.x,
	          y = position.y;

	      // Create an event object with all the data parents need to make a decision here.

	      var coreEvent = createCoreData(_this, x, y);

	      // Call event handler. If it returns explicit false, cancel.
	      log('calling', _this.props.onStart);
	      var shouldUpdate = _this.props.onStart(e, coreEvent);
	      if (shouldUpdate === false) return;

	      // Add a style to the body to disable user-select. This prevents text from
	      // being selected all over the page.
	      if (_this.props.enableUserSelectHack) addUserSelectStyles(ownerDocument);

	      // Initiate dragging. Set the current x and y as offsets
	      // so we know how much we've moved during the drag. This allows us
	      // to drag elements around even if they have been moved, without issue.
	      _this.setState({
	        dragging: true,

	        lastX: x,
	        lastY: y
	      });

	      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
	      // this element. We use different events depending on whether or not we have detected that this
	      // is a touch-capable device.
	      addEvent(ownerDocument, dragEventFor.move, _this.handleDrag);
	      addEvent(ownerDocument, dragEventFor.stop, _this.handleDragStop);
	    }, _this.handleDrag = function (e) {

	      // Prevent scrolling on mobile devices, like ipad/iphone.
	      if (e.type === 'touchmove') e.preventDefault();

	      // Get the current drag point from the event. This is used as the offset.
	      var position = getControlPosition(e, _this.state.touchIdentifier, _this);
	      if (position == null) return;
	      var x = position.x,
	          y = position.y;

	      // Snap to grid if prop has been provided

	      if (Array.isArray(_this.props.grid)) {
	        var _deltaX = x - _this.state.lastX,
	            _deltaY = y - _this.state.lastY;

	        var _snapToGrid = snapToGrid(_this.props.grid, _deltaX, _deltaY);

	        var _snapToGrid2 = slicedToArray(_snapToGrid, 2);

	        _deltaX = _snapToGrid2[0];
	        _deltaY = _snapToGrid2[1];

	        if (!_deltaX && !_deltaY) return; // skip useless drag
	        x = _this.state.lastX + _deltaX, y = _this.state.lastY + _deltaY;
	      }

	      var coreEvent = createCoreData(_this, x, y);

	      // Call event handler. If it returns explicit false, trigger end.
	      var shouldUpdate = _this.props.onDrag(e, coreEvent);
	      if (shouldUpdate === false) {
	        try {
	          // $FlowIgnore
	          _this.handleDragStop(new MouseEvent('mouseup'));
	        } catch (err) {
	          // Old browsers
	          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
	          // I see why this insanity was deprecated
	          // $FlowIgnore
	          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	          _this.handleDragStop(event);
	        }
	        return;
	      }

	      _this.setState({
	        lastX: x,
	        lastY: y
	      });
	    }, _this.handleDragStop = function (e) {
	      if (!_this.state.dragging) return;

	      var position = getControlPosition(e, _this.state.touchIdentifier, _this);
	      if (position == null) return;
	      var x = position.x,
	          y = position.y;

	      var coreEvent = createCoreData(_this, x, y);

	      var thisNode = ReactDOM.findDOMNode(_this);
	      if (thisNode) {
	        // Remove user-select hack
	        if (_this.props.enableUserSelectHack) removeUserSelectStyles(thisNode.ownerDocument);
	      }

	      // Reset the el.
	      _this.setState({
	        dragging: false,
	        lastX: NaN,
	        lastY: NaN
	      });

	      // Call event handler
	      _this.props.onStop(e, coreEvent);

	      if (thisNode) {
	        removeEvent(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
	        removeEvent(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
	      }
	    }, _this.onMouseDown = function (e) {
	      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

	      return _this.handleDragStart(e);
	    }, _this.onMouseUp = function (e) {
	      dragEventFor = eventsFor.mouse;

	      return _this.handleDragStop(e);
	    }, _this.onTouchStart = function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;

	      return _this.handleDragStart(e);
	    }, _this.onTouchEnd = function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;

	      return _this.handleDragStop(e);
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }

	  createClass(DraggableCore, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
	      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
	      var thisNode = ReactDOM.findDOMNode(this);
	      if (thisNode) {
	        var ownerDocument = thisNode.ownerDocument;

	        removeEvent(ownerDocument, eventsFor.mouse.move, this.handleDrag);
	        removeEvent(ownerDocument, eventsFor.touch.move, this.handleDrag);
	        removeEvent(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
	        removeEvent(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
	        if (this.props.enableUserSelectHack) removeUserSelectStyles(ownerDocument);
	      }
	    }

	    // Same as onMouseDown (start drag), but now consider this a touch device.

	  }, {
	    key: 'render',
	    value: function render() {
	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return React.cloneElement(React.Children.only(this.props.children), {
	        style: styleHacks(this.props.children.props.style),

	        // Note: mouseMove handler is attached to document so it will still function
	        // when the user drags quickly and leaves the bounds of the element.
	        onMouseDown: this.onMouseDown,
	        onTouchStart: this.onTouchStart,
	        onMouseUp: this.onMouseUp,
	        onTouchEnd: this.onTouchEnd
	      });
	    }
	  }]);
	  return DraggableCore;
	}(React.Component);

	DraggableCore.displayName = 'DraggableCore';
	DraggableCore.propTypes = {
	  /**
	   * `allowAnyClick` allows dragging using any mouse button.
	   * By default, we only accept the left button.
	   *
	   * Defaults to `false`.
	   */
	  allowAnyClick: propTypes.bool,

	  /**
	   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
	   * with the exception of `onMouseDown`, will not fire.
	   */
	  disabled: propTypes.bool,

	  /**
	   * By default, we add 'user-select:none' attributes to the document body
	   * to prevent ugly text selection during drag. If this is causing problems
	   * for your app, set this to `false`.
	   */
	  enableUserSelectHack: propTypes.bool,

	  /**
	   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
	   * instead of using the parent node.
	   */
	  offsetParent: function offsetParent(props /*: DraggableCoreProps*/, propName /*: $Keys<DraggableCoreProps>*/) {
	    if (props[propName] && props[propName].nodeType !== 1) {
	      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
	    }
	  },

	  /**
	   * `grid` specifies the x and y that dragging should snap to.
	   */
	  grid: propTypes.arrayOf(propTypes.number),

	  /**
	   * `scale` specifies the scale of the area you are dragging inside of. It allows
	   * the drag deltas to scale correctly with how far zoomed in/out you are.
	   */
	  scale: propTypes.number,

	  /**
	   * `handle` specifies a selector to be used as the handle that initiates drag.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable handle=".handle">
	   *              <div>
	   *                  <div className="handle">Click me to drag</div>
	   *                  <div>This is some other content</div>
	   *              </div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  handle: propTypes.string,

	  /**
	   * `cancel` specifies a selector to be used to prevent drag initialization.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *           return(
	   *               <Draggable cancel=".cancel">
	   *                   <div>
	   *                     <div className="cancel">You can't drag from here</div>
	   *                     <div>Dragging here works fine</div>
	   *                   </div>
	   *               </Draggable>
	   *           );
	   *       }
	   *   });
	   * ```
	   */
	  cancel: propTypes.string,

	  /**
	   * Called when dragging starts.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onStart: propTypes.func,

	  /**
	   * Called while dragging.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onDrag: propTypes.func,

	  /**
	   * Called when dragging stops.
	   * If this function returns the boolean false, the drag will remain active.
	   */
	  onStop: propTypes.func,

	  /**
	   * A workaround option which can be passed if onMouseDown needs to be accessed,
	   * since it'll always be blocked (as there is internal use of onMouseDown)
	   */
	  onMouseDown: propTypes.func,

	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: dontSetMe,
	  style: dontSetMe,
	  transform: dontSetMe
	};
	DraggableCore.defaultProps = {
	  allowAnyClick: false, // by default only accept left click
	  cancel: null,
	  disabled: false,
	  enableUserSelectHack: true,
	  offsetParent: null,
	  handle: null,
	  grid: null,
	  transform: null,
	  onStart: function onStart() {},
	  onDrag: function onDrag() {},
	  onStop: function onStop() {},
	  onMouseDown: function onMouseDown() {}
	};

	/*:: import type {DraggableEventHandler} from './utils/types';*/
	/*:: import type {Element as ReactElement} from 'react';*/
	/*:: type DraggableState = {
	  dragging: boolean,
	  dragged: boolean,
	  x: number, y: number,
	  slackX: number, slackY: number,
	  isElementSVG: boolean
	};*/


	//
	// Define <Draggable>
	//

	/*:: export type DraggableProps = {
	  ...$Exact<DraggableCoreProps>,
	  axis: 'both' | 'x' | 'y' | 'none',
	  bounds: DraggableBounds | string | false,
	  defaultClassName: string,
	  defaultClassNameDragging: string,
	  defaultClassNameDragged: string,
	  defaultPosition: ControlPosition,
	  positionOffset: PositionOffsetControlPosition,
	  position: ControlPosition,
	  scale: number
	};*/

	var Draggable = function (_React$Component) {
	  inherits(Draggable, _React$Component);

	  function Draggable(props /*: DraggableProps*/) {
	    classCallCheck(this, Draggable);

	    var _this = possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));

	    _this.onDragStart = function (e, coreData) {

	      // Short-circuit if user's callback killed it.
	      var shouldStart = _this.props.onStart(e, createDraggableData(_this, coreData));
	      // Kills start event on core as well, so move handlers are never bound.
	      if (shouldStart === false) return false;

	      _this.setState({ dragging: true, dragged: true });
	    };

	    _this.onDrag = function (e, coreData) {
	      if (!_this.state.dragging) return false;

	      var uiData = createDraggableData(_this, coreData);

	      var newState /*: $Shape<DraggableState>*/ = {
	        x: uiData.x,
	        y: uiData.y
	      };

	      // Keep within bounds.
	      if (_this.props.bounds) {
	        // Save original x and y.
	        var _x = newState.x,
	            _y = newState.y;

	        // Add slack to the values used to calculate bound position. This will ensure that if
	        // we start removing slack, the element won't react to it right away until it's been
	        // completely removed.

	        newState.x += _this.state.slackX;
	        newState.y += _this.state.slackY;

	        // Get bound position. This will ceil/floor the x and y within the boundaries.

	        var _getBoundPosition = getBoundPosition(_this, newState.x, newState.y),
	            _getBoundPosition2 = slicedToArray(_getBoundPosition, 2),
	            newStateX = _getBoundPosition2[0],
	            newStateY = _getBoundPosition2[1];

	        newState.x = newStateX;
	        newState.y = newStateY;

	        // Recalculate slack by noting how much was shaved by the boundPosition handler.
	        newState.slackX = _this.state.slackX + (_x - newState.x);
	        newState.slackY = _this.state.slackY + (_y - newState.y);

	        // Update the event we fire to reflect what really happened after bounds took effect.
	        uiData.x = newState.x;
	        uiData.y = newState.y;
	        uiData.deltaX = newState.x - _this.state.x;
	        uiData.deltaY = newState.y - _this.state.y;
	      }

	      // Short-circuit if user's callback killed it.
	      var shouldUpdate = _this.props.onDrag(e, uiData);
	      if (shouldUpdate === false) return false;

	      _this.setState(newState);
	    };

	    _this.onDragStop = function (e, coreData) {
	      if (!_this.state.dragging) return false;

	      // Short-circuit if user's callback killed it.
	      var shouldStop = _this.props.onStop(e, createDraggableData(_this, coreData));
	      if (shouldStop === false) return false;

	      var newState /*: $Shape<DraggableState>*/ = {
	        dragging: false,
	        slackX: 0,
	        slackY: 0
	      };

	      // If this is a controlled component, the result of this operation will be to
	      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
	      var controlled = Boolean(_this.props.position);
	      if (controlled) {
	        var _this$props$position = _this.props.position,
	            _x2 = _this$props$position.x,
	            _y2 = _this$props$position.y;

	        newState.x = _x2;
	        newState.y = _y2;
	      }

	      _this.setState(newState);
	    };

	    _this.state = {
	      // Whether or not we are currently dragging.
	      dragging: false,

	      // Whether or not we have been dragged before.
	      dragged: false,

	      // Current transform x and y.
	      x: props.position ? props.position.x : props.defaultPosition.x,
	      y: props.position ? props.position.y : props.defaultPosition.y,

	      // Used for compensating for out-of-bounds drags
	      slackX: 0, slackY: 0,

	      // Can only determine if SVG after mounting
	      isElementSVG: false
	    };

	    if (props.position && !(props.onDrag || props.onStop)) {
	      // eslint-disable-next-line no-console
	      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
	    }
	    return _this;
	  }

	  createClass(Draggable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Check to see if the element passed is an instanceof SVGElement
	      if (typeof window.SVGElement !== 'undefined' && ReactDOM.findDOMNode(this) instanceof window.SVGElement) {
	        this.setState({ isElementSVG: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps /*: Object*/) {
	      // Set x/y if position has changed
	      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
	        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
	    }
	  }, {
	    key: 'render',
	    value: function render() /*: ReactElement<any>*/ {
	      var _classNames;

	      var style = {},
	          svgTransform = null;

	      // If this is controlled, we don't want to move it - unless it's dragging.
	      var controlled = Boolean(this.props.position);
	      var draggable = !controlled || this.state.dragging;

	      var position = this.props.position || this.props.defaultPosition;
	      var transformOpts = {
	        // Set left if horizontal drag is enabled
	        x: canDragX(this) && draggable ? this.state.x : position.x,

	        // Set top if vertical drag is enabled
	        y: canDragY(this) && draggable ? this.state.y : position.y
	      };

	      // If this element was SVG, we use the `transform` attribute.
	      if (this.state.isElementSVG) {
	        svgTransform = createSVGTransform(transformOpts, this.props.positionOffset);
	      } else {
	        // Add a CSS transform to move the element around. This allows us to move the element around
	        // without worrying about whether or not it is relatively or absolutely positioned.
	        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
	        // has a clean slate.
	        style = createCSSTransform(transformOpts, this.props.positionOffset);
	      }

	      var _props = this.props,
	          defaultClassName = _props.defaultClassName,
	          defaultClassNameDragging = _props.defaultClassNameDragging,
	          defaultClassNameDragged = _props.defaultClassNameDragged;


	      var children = React.Children.only(this.props.children);

	      // Mark with class while dragging
	      var className = classnames(children.props.className || '', defaultClassName, (_classNames = {}, defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));

	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return React.createElement(
	        DraggableCore,
	        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
	        React.cloneElement(children, {
	          className: className,
	          style: _extends({}, children.props.style, style),
	          transform: svgTransform
	        })
	      );
	    }
	  }]);
	  return Draggable;
	}(React.Component);

	Draggable.displayName = 'Draggable';
	Draggable.propTypes = _extends({}, DraggableCore.propTypes, {

	  /**
	   * `axis` determines which axis the draggable can move.
	   *
	   *  Note that all callbacks will still return data as normal. This only
	   *  controls flushing to the DOM.
	   *
	   * 'both' allows movement horizontally and vertically.
	   * 'x' limits movement to horizontal axis.
	   * 'y' limits movement to vertical axis.
	   * 'none' limits all movement.
	   *
	   * Defaults to 'both'.
	   */
	  axis: propTypes.oneOf(['both', 'x', 'y', 'none']),

	  /**
	   * `bounds` determines the range of movement available to the element.
	   * Available values are:
	   *
	   * 'parent' restricts movement within the Draggable's parent node.
	   *
	   * Alternatively, pass an object with the following properties, all of which are optional:
	   *
	   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
	   *
	   * All values are in px.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable bounds={{right: 300, bottom: 300}}>
	   *              <div>Content</div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  bounds: propTypes.oneOfType([propTypes.shape({
	    left: propTypes.number,
	    right: propTypes.number,
	    top: propTypes.number,
	    bottom: propTypes.number
	  }), propTypes.string, propTypes.oneOf([false])]),

	  defaultClassName: propTypes.string,
	  defaultClassNameDragging: propTypes.string,
	  defaultClassNameDragged: propTypes.string,

	  /**
	   * `defaultPosition` specifies the x and y that the dragged item should start at
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  defaultPosition: propTypes.shape({
	    x: propTypes.number,
	    y: propTypes.number
	  }),
	  positionOffset: propTypes.shape({
	    x: propTypes.oneOfType([propTypes.number, propTypes.string]),
	    y: propTypes.oneOfType([propTypes.number, propTypes.string])
	  }),

	  /**
	   * `position`, if present, defines the current position of the element.
	   *
	   *  This is similar to how form elements in React work - if no `position` is supplied, the component
	   *  is uncontrolled.
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable position={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  position: propTypes.shape({
	    x: propTypes.number,
	    y: propTypes.number
	  }),

	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: dontSetMe,
	  style: dontSetMe,
	  transform: dontSetMe
	});
	Draggable.defaultProps = _extends({}, DraggableCore.defaultProps, {
	  axis: 'both',
	  bounds: false,
	  defaultClassName: 'react-draggable',
	  defaultClassNameDragging: 'react-draggable-dragging',
	  defaultClassNameDragged: 'react-draggable-dragged',
	  defaultPosition: { x: 0, y: 0 },
	  position: null,
	  scale: 1
	});

	// Previous versions of this lib exported <Draggable> as the root export. As to not break
	// them, or TypeScript, we export *both* as the root and as 'default'.
	// See https://github.com/mzabriskie/react-draggable/pull/254
	// and https://github.com/mzabriskie/react-draggable/issues/266
	Draggable.default = Draggable;
	Draggable.DraggableCore = DraggableCore;

	return Draggable;

})));
//# sourceMappingURL=react-draggable.js.map


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);exports.default=confirm;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _Modal=__webpack_require__(227);var _Modal2=_interopRequireDefault(_Modal);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);var _button=__webpack_require__(55);var _button2=_interopRequireDefault(_button);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _locale=__webpack_require__(222);var _weaLocaleProvider=__webpack_require__(68);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel,formatMultiLang=_weaLocaleProvider2.default.formatMultiLang;function isObject(obj){return Object.prototype.toString.call(obj)==="[object Object]";}function isFunction(fn){return typeof fn==="function";}function getEcodeProps(){var newProps=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var name="Modal";if(isObject(window.pcComponentsConfig)&&window.pcComponentsConfig[name]){var overwrite=window.pcComponentsConfig[name];if(isObject(overwrite)){var propsFn=overwrite.overwritePropsFn;if(isFunction(propsFn)){var overwriteProps=propsFn(newProps,name);if(isObject(overwriteProps)){newProps=(0,_extends3.default)({},newProps,overwriteProps);}}}}return newProps;}function confirm(config){var _classNames;var props=getEcodeProps((0,_extends3.default)({},config));var div=document.createElement("div");document.body.appendChild(div);props.iconType=props.iconType;var width=props.width||380;var style=props.style||{};// 默认为 true，保持向下兼容
if(!("okCancel"in props)){props.okCancel=true;}var runtimeLocale=(0,_locale.getConfirmLocale)();props.okText=props.okText||(props.okCancel?getLabel(16631,"确认"):getLabel(383773,"知道了"));props.cancelText=props.cancelText||getLabel(201,"取消");function close(){var unmountResult=_reactDom2.default.unmountComponentAtNode(div);if(unmountResult){div.parentNode.removeChild(div);}}function onCancel(){var cancelFn=props.onCancel;if(cancelFn){var ret=void 0;if(cancelFn.length){ret=cancelFn(close);}else{ret=cancelFn();if(!ret){close();}}if(ret&&ret.then){ret.then(close);}}else{close();}}function onOk(){var okFn=props.onOk;if(okFn){var ret=void 0;if(okFn.length){ret=okFn(close);}else{ret=okFn();if(!ret){close();}}if(ret&&ret.then){ret.then(close);}}else{close();}}var t=props.content||props.title;if(typeof t==="string")t=formatMultiLang(t);var body=_react2.default.createElement("div",{className:"ant-confirm-body"},_react2.default.createElement("div",{className:"ant-confirm-header"},props.iconType&&_react2.default.createElement(_icon2.default,{type:props.iconType,className:"ant-confirm-header-icon"}),!props.iconType&&props.ecIconType&&_react2.default.createElement("i",{className:"icon-coms-Prompt ant-confirm-header-icon"}),_react2.default.createElement("span",{className:"ant-confirm-title wea-f14"},props.title&&!props.content||!props.title?getLabel(131329,"信息确认")||"信息确认":props.title),props.showClose&&_react2.default.createElement(_icon2.default,{type:"cross",onClick:onCancel})),_react2.default.createElement("div",{className:"ant-confirm-content wdb wea-f14"},t));var footer=null;if(props.okCancel){footer=_react2.default.createElement("div",{className:"ant-confirm-btns"},_react2.default.createElement(_button2.default,{ecId:props.ecId+"_Button@mrj0h4",type:"primary",size:"large",onClick:onOk},props.okText),_react2.default.createElement(_button2.default,{ecId:props.ecId+"_Button@d12iag",type:"ghost",size:"large",onClick:onCancel},props.cancelText));}else{footer=_react2.default.createElement("div",{className:"ant-confirm-btns"},_react2.default.createElement(_button2.default,{ecId:props.ecId+"_Button@slms6k",type:"primary",size:"large",onClick:onOk},props.okText));}var classString=(0,_classnames2.default)((_classNames={"ant-confirm":true},(0,_defineProperty3.default)(_classNames,"ant-confirm-"+props.type,true),(0,_defineProperty3.default)(_classNames,props.className,!!props.className),_classNames));var transitionName=props.transitionName||"zoom";_reactDom2.default.render(_react2.default.createElement(_Modal2.default,{ecId:props.ecId+"_Dialog@hsamwk",zIndex:props.zIndex,className:classString,visible:true,dialog:true,closable:false,title:"",transitionName:transitionName,footer:"",maskTransitionName:"fade",style:style,width:width,onSpackClick:onOk,onOk:onOk},_react2.default.createElement("div",{style:{zoom:1,overflow:"hidden"}},body," ",footer)),div);return{destroy:close};}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(662);__webpack_require__(64);

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _rcNotification=__webpack_require__(664);var _rcNotification2=_interopRequireDefault(_rcNotification);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var defaultTop=24;var notificationInstance=void 0;var defaultDuration=4.5;function getNotificationInstance(){if(notificationInstance){return notificationInstance;}notificationInstance=_rcNotification2.default.newInstance({prefixCls:'ant-notification',style:{top:defaultTop,right:0}});return notificationInstance;}function notice(args){var prefixCls=args.prefixCls||'ant-notification-notice';var duration=void 0;if(args.duration===undefined){duration=defaultDuration;}else{duration=args.duration;}var iconType='';switch(args.icon){case'success':iconType='check-circle-o';break;case'info':iconType='info-circle-o';break;case'error':iconType='cross-circle-o';break;case'warning':iconType='exclamation-circle-o';break;default:iconType='info-circle';}getNotificationInstance().notice({content:_react2.default.createElement('div',{className:prefixCls+'-content '+(args.icon?prefixCls+'-with-icon':'')},args.icon?_react2.default.createElement(_icon2.default,{className:prefixCls+'-icon '+prefixCls+'-icon-'+args.icon,type:iconType}):null,_react2.default.createElement('div',{className:prefixCls+'-message'},args.message),_react2.default.createElement('div',{className:prefixCls+'-description'},args.description),args.btn?_react2.default.createElement('span',{className:prefixCls+'-btn'},args.btn):null),duration:duration,closable:true,onClose:args.onClose,key:args.key,style:{}});}var api={open:function open(args){notice(args);},close:function close(key){if(notificationInstance){notificationInstance.removeNotice(key);}},config:function config(options){if('top'in options){defaultTop=options.top;}if('duration'in options){defaultDuration=options.duration;}},destroy:function destroy(){if(notificationInstance){notificationInstance.destroy();notificationInstance=null;}}};['success','info','warning','error'].forEach(function(type){api[type]=function(args){return api.open((0,_extends3.default)({},args,{icon:type}));};});api.warn=api.warning;exports.default=api;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Notification = __webpack_require__(665);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Notification2["default"];
module.exports = exports['default'];

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _rcAnimate = __webpack_require__(18);

var _rcAnimate2 = _interopRequireDefault(_rcAnimate);

var _createChainedFunction = __webpack_require__(99);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Notice = __webpack_require__(666);

var _Notice2 = _interopRequireDefault(_Notice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var seed = 0;
var now = Date.now();

function getUuid() {
  return 'rcNotification_' + now + '_' + seed++;
}

var Notification = _react2["default"].createClass({
  displayName: 'Notification',

  propTypes: {
    prefixCls: _react.PropTypes.string,
    transitionName: _react.PropTypes.string,
    animation: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
    style: _react.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      prefixCls: 'rc-notification',
      animation: 'fade',
      style: {
        top: 65,
        left: '50%'
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      notices: []
    };
  },
  getTransitionName: function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  },
  add: function add(notice) {
    var key = notice.key = notice.key || getUuid();
    this.setState(function (previousState) {
      var notices = previousState.notices;
      if (!notices.filter(function (v) {
        return v.key === key;
      }).length) {
        return {
          notices: notices.concat(notice)
        };
      }
    });
  },
  remove: function remove(key) {
    this.setState(function (previousState) {
      return {
        notices: previousState.notices.filter(function (notice) {
          return notice.key !== key;
        })
      };
    });
  },
  render: function render() {
    var _this = this,
        _className;

    var props = this.props;
    var noticeNodes = this.state.notices.map(function (notice) {
      var onClose = (0, _createChainedFunction2["default"])(_this.remove.bind(_this, notice.key), notice.onClose);
      return _react2["default"].createElement(
        _Notice2["default"],
        _extends({
          prefixCls: props.prefixCls
        }, notice, {
          onClose: onClose
        }),
        notice.content
      );
    });
    var className = (_className = {}, _defineProperty(_className, props.prefixCls, 1), _defineProperty(_className, props.className, !!props.className), _className);
    return _react2["default"].createElement(
      'div',
      { className: (0, _classnames2["default"])(className), style: props.style },
      _react2["default"].createElement(
        _rcAnimate2["default"],
        { transitionName: this.getTransitionName() },
        noticeNodes
      )
    );
  }
});

Notification.newInstance = function newNotificationInstance(properties) {
  var props = properties || {};
  var div = document.createElement('div');
  document.body.appendChild(div);
  var notification = _reactDom2["default"].render(_react2["default"].createElement(Notification, props), div);
  return {
    notice: function notice(noticeProps) {
      notification.add(noticeProps);
    },
    removeNotice: function removeNotice(key) {
      notification.remove(key);
    },

    component: notification,
    destroy: function destroy() {
      _reactDom2["default"].unmountComponentAtNode(div);
      document.body.removeChild(div);
    }
  };
};

exports["default"] = Notification;
module.exports = exports['default'];

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Notice = _react2["default"].createClass({
  displayName: 'Notice',

  propTypes: {
    duration: _react.PropTypes.number,
    onClose: _react.PropTypes.func,
    children: _react.PropTypes.any
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onEnd: function onEnd() {},
      onClose: function onClose() {},

      duration: 1.5,
      style: {
        right: '50%'
      }
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    if (this.props.duration) {
      this.closeTimer = setTimeout(function () {
        _this.close();
      }, this.props.duration * 1000);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.clearCloseTimer();
  },
  clearCloseTimer: function clearCloseTimer() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  },
  close: function close() {
    this.clearCloseTimer();
    this.props.onClose();
  },
  render: function render() {
    var _className;

    var props = this.props;
    var componentClass = props.prefixCls + '-notice';
    var className = (_className = {}, _defineProperty(_className, '' + componentClass, 1), _defineProperty(_className, componentClass + '-closable', props.closable), _defineProperty(_className, props.className, !!props.className), _className);
    return _react2["default"].createElement(
      'div',
      { className: (0, _classnames2["default"])(className), style: props.style },
      _react2["default"].createElement(
        'div',
        { className: componentClass + '-content' },
        props.children
      ),
      props.closable ? _react2["default"].createElement(
        'a',
        { tabIndex: '0', onClick: this.close, className: componentClass + '-close' },
        _react2["default"].createElement('span', { className: componentClass + '-close-x' })
      ) : null
    );
  }
});

exports["default"] = Notice;
module.exports = exports['default'];

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(668);

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _tooltip=__webpack_require__(91);var _tooltip2=_interopRequireDefault(_tooltip);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);var _button=__webpack_require__(55);var _button2=_interopRequireDefault(_button);var _placements=__webpack_require__(128);var _placements2=_interopRequireDefault(_placements);var _weaLocaleProvider=__webpack_require__(68);var _weaLocaleProvider2=_interopRequireDefault(_weaLocaleProvider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_weaLocaleProvider2.default.getLabel;var noop=function noop(){};var Popconfirm=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Popconfirm,_React$Component);function Popconfirm(props){(0,_classCallCheck3.default)(this,Popconfirm);var _this=(0,_possibleConstructorReturn3.default)(this,(Popconfirm.__proto__||(0,_getPrototypeOf2.default)(Popconfirm)).call(this,props));_this.confirm=function(){_this.setVisible(false);_this.props.onConfirm.call(_this);};_this.cancel=function(){_this.setVisible(false);_this.props.onCancel.call(_this);};_this.onVisibleChange=function(visible){_this.setVisible(visible);};_this.state={visible:false};return _this;}(0,_createClass3.default)(Popconfirm,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if("visible"in nextProps){this.setState({visible:nextProps.visible});}}},{key:"setVisible",value:function setVisible(visible){if(!("visible"in this.props)){this.setState({visible:visible});}this.props.onVisibleChange(visible);}},{key:"render",value:function render(){var _props=this.props,prefixCls=_props.prefixCls,title=_props.title,placement=_props.placement,arrowPointAtCenter=_props.arrowPointAtCenter,restProps=(0,_objectWithoutProperties3.default)(_props,["prefixCls","title","placement","arrowPointAtCenter"]);var _props2=this.props,okText=_props2.okText,cancelText=_props2.cancelText;if(this.context.antLocale&&this.context.antLocale.Popconfirm){okText=okText||this.context.antLocale.Popconfirm.okText;cancelText=cancelText||this.context.antLocale.Popconfirm.cancelText;}var overlay=_react2.default.createElement("div",null,_react2.default.createElement("div",{className:prefixCls+"-inner-content"},_react2.default.createElement("div",{className:prefixCls+"-message"},_react2.default.createElement(_icon2.default,{type:"exclamation-circle"}),_react2.default.createElement("div",{className:prefixCls+"-message-title"},title)),_react2.default.createElement("div",{className:prefixCls+"-buttons"},_react2.default.createElement(_button2.default,{onClick:this.cancel,type:"ghost",size:"small"},cancelText||getLabel(201,"取消")),_react2.default.createElement(_button2.default,{onClick:this.confirm,type:"primary",size:"small"},okText||getLabel(83446,"确定")))));return _react2.default.createElement(_tooltip2.default,(0,_extends3.default)({},restProps,{builtinPlacements:(0,_placements2.default)({arrowPointAtCenter:arrowPointAtCenter}),prefixCls:prefixCls,placement:placement,onVisibleChange:this.onVisibleChange,visible:this.state.visible,overlay:overlay}));}}]);return Popconfirm;}(_react2.default.Component),_class.defaultProps={prefixCls:"ant-popover",transitionName:"zoom-big",placement:"top",trigger:"click",onConfirm:noop,onCancel:noop,onVisibleChange:noop},_class.contextTypes={antLocale:_react2.default.PropTypes.object},_temp);exports.default=Popconfirm;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(229);

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _tooltip=__webpack_require__(91);var _tooltip2=_interopRequireDefault(_tooltip);var _placements=__webpack_require__(128);var _placements2=_interopRequireDefault(_placements);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Popover=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Popover,_React$Component);function Popover(){(0,_classCallCheck3.default)(this,Popover);return(0,_possibleConstructorReturn3.default)(this,(Popover.__proto__||(0,_getPrototypeOf2.default)(Popover)).apply(this,arguments));}(0,_createClass3.default)(Popover,[{key:"render",value:function render(){var arrowPointAtCenter=this.props.arrowPointAtCenter;return _react2.default.createElement(_tooltip2.default,(0,_extends3.default)({builtinPlacements:(0,_placements2.default)({arrowPointAtCenter:arrowPointAtCenter}),ref:"tooltip"},this.props,{overlay:this.getOverlay()}));}},{key:"getPopupDomNode",value:function getPopupDomNode(){return this.refs.tooltip.getPopupDomNode();}},{key:"componentDidMount",value:function componentDidMount(){if("overlay"in this.props){(0,_warning2.default)(false,"`overlay` prop of Popover is deprecated, use `content` instead.");}}},{key:"getOverlay",value:function getOverlay(){// use content replace overlay
// keep overlay for compatibility
var _props=this.props,title=_props.title,prefixCls=_props.prefixCls,overlay=_props.overlay,content=_props.content,overlayClass=_props.overlayClass;return _react2.default.createElement("div",{className:overlayClass},title&&_react2.default.createElement("div",{className:prefixCls+"-title"},title),_react2.default.createElement("div",{className:prefixCls+"-inner-content"},content||overlay));}}]);return Popover;}(_react2.default.Component),_class.defaultProps={prefixCls:"ant-popover",placement:"top",transitionName:"zoom-big",trigger:"hover",mouseEnterDelay:0.1,mouseLeaveDelay:0.1,arrowPointAtCenter:false},_temp);exports.default=Popover;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);var _rcProgress=__webpack_require__(675);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var statusColorMap={normal:"#0094FF",exception:"#ff6600",success:"#87d068"};var Line=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Line,_React$Component);function Line(){(0,_classCallCheck3.default)(this,Line);return(0,_possibleConstructorReturn3.default)(this,(Line.__proto__||(0,_getPrototypeOf2.default)(Line)).apply(this,arguments));}(0,_createClass3.default)(Line,[{key:"render",value:function render(){var _classNames;var _props=this.props,prefixCls=_props.prefixCls,status=_props.status,format=_props.format,percent=_props.percent,trailColor=_props.trailColor,type=_props.type,strokeWidth=_props.strokeWidth,width=_props.width,className=_props.className,showInfo=_props.showInfo,strokeColor=_props.strokeColor,restProps=(0,_objectWithoutProperties3.default)(_props,["prefixCls","status","format","percent","trailColor","type","strokeWidth","width","className","showInfo","strokeColor"]);// const progressStatus = (parseInt(percent, 10) >= 100 && !('status' in this.props))? 'success' : (status || 'normal');
var progressStatus=status||"normal";var progressInfo=void 0;var progress=void 0;var textFormatter=format||function(percentNumber){return percentNumber+"%";};if(percent<=0){strokeWidth=0;}if(showInfo){var text=void 0;var iconType=type==="circle"?"":"-circle";// if (progressStatus === 'exception') {
//   text = format ? textFormatter(percent) : <Icon type={`cross${iconType}`} />;
// } else if (progressStatus === 'success') {
//   text = format ? textFormatter(percent) : <Icon type={`check${iconType}`} />;
// } else {
if(percent>=100)percent=100;text=textFormatter(percent);// }
progressInfo=_react2.default.createElement("span",{className:prefixCls+"-text"},text);}if(type==="line"){var percentStyle={width:percent+"%",height:strokeWidth||10,backgroundColor:strokeColor||statusColorMap[progressStatus]};progress=_react2.default.createElement("div",null,_react2.default.createElement("div",{className:prefixCls+"-outer"},_react2.default.createElement("div",{className:prefixCls+"-inner"},_react2.default.createElement("div",{className:prefixCls+"-bg",style:percentStyle}))),progressInfo);}else if(type==="circle"){var circleSize=width||132;var circleStyle={width:circleSize,height:circleSize,fontSize:circleSize*0.16+6};progress=_react2.default.createElement("div",{className:prefixCls+"-inner",style:circleStyle},_react2.default.createElement(_rcProgress.Circle,{ecId:this.props.ecId+"_Circle@j1g7nx",percent:percent,strokeWidth:strokeWidth===0?0:6,strokeColor:strokeColor||statusColorMap[progressStatus],trailColor:trailColor}),progressInfo);}var classString=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,""+prefixCls,true),(0,_defineProperty3.default)(_classNames,prefixCls+"-"+type,true),(0,_defineProperty3.default)(_classNames,prefixCls+"-status-"+progressStatus,true),(0,_defineProperty3.default)(_classNames,prefixCls+"-show-info",showInfo),(0,_defineProperty3.default)(_classNames,className,!!className),_classNames));return _react2.default.createElement("div",(0,_extends3.default)({},restProps,{ecId:this.props.ecId+"_div@9ckcqv",className:classString}),progress);}}]);return Line;}(_react2.default.Component),_class.defaultProps={type:"line",percent:0,showInfo:true,trailColor:"#e2e2e2",prefixCls:"ant-progress"},_class.propTypes={status:_react.PropTypes.oneOf(["normal","exception","active","success"]),type:_react.PropTypes.oneOf(["line","circle"]),showInfo:_react.PropTypes.bool,percent:_react.PropTypes.number,width:_react.PropTypes.number,strokeWidth:_react.PropTypes.number,trailColor:_react.PropTypes.string,format:_react.PropTypes.func},_temp);exports.default=Line;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports=__webpack_require__(676);

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var assign=__webpack_require__(19);var React=__webpack_require__(0);var defaultProps={strokeWidth:1,strokeColor:'#3FC7FA',trailWidth:1,trailColor:'#D9D9D9'};var Line=React.createClass({displayName:'Line',render:function render(){var props=assign({},this.props);var pathStyle={'strokeDasharray':'100px, 100px','strokeDashoffset':100-props.percent+'px','transition':'stroke-dashoffset 0.6s ease 0s, stroke 0.6s linear'};['strokeWidth','strokeColor','trailWidth','trailColor'].forEach(function(item){if(item==='trailWidth'&&!props.trailWidth&&props.strokeWidth){props.trailWidth=props.strokeWidth;return;}if(item==='strokeWidth'&&props.strokeWidth&&(!parseFloat(props.strokeWidth)||parseFloat(props.strokeWidth)>100||parseFloat(props.strokeWidth)<0)){props[item]=defaultProps[item];return;}if(!props[item]){props[item]=defaultProps[item];}});var strokeWidth=props.strokeWidth;var center=strokeWidth/2;var right=100-strokeWidth/2;var pathString='M '+center+','+center+' L '+right+','+center;var viewBoxString='0 0 100 '+strokeWidth;return React.createElement('svg',{className:"rc-progress-line",viewBox:viewBoxString,preserveAspectRatio:"none"},React.createElement('path',{className:"rc-progress-line-trail",d:pathString,strokeLinecap:"round",stroke:props.trailColor,strokeWidth:props.trailWidth,fillOpacity:"0"}),React.createElement('path',{className:"rc-progress-line-path",d:pathString,strokeLinecap:"round",stroke:props.strokeColor,strokeWidth:props.strokeWidth,fillOpacity:"0",style:pathStyle}));}});var Circle=React.createClass({displayName:'Circle',render:function render(){var props=assign({},this.props);var strokeWidth=props.strokeWidth;var radius=50-strokeWidth/2;var pathString='M 50,50 m 0,-'+radius+'\n     a '+radius+','+radius+' 0 1 1 0,'+2*radius+'\n     a '+radius+','+radius+' 0 1 1 0,-'+2*radius;var len=Math.PI*2*radius;var pathStyle={'strokeDasharray':len+'px '+len+'px','strokeDashoffset':(100-props.percent)/100*len+'px','transition':'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease'};['strokeWidth','strokeColor','trailWidth','trailColor'].forEach(function(item){if(item==='trailWidth'&&!props.trailWidth&&props.strokeWidth){props.trailWidth=props.strokeWidth;return;}if(!props[item]){props[item]=defaultProps[item];}});return React.createElement('svg',{className:'rc-progress-circle',viewBox:'0 0 100 100'},React.createElement('path',{className:'rc-progress-circle-trail',d:pathString,stroke:props.trailColor,strokeWidth:props.trailWidth,fillOpacity:'0'}),React.createElement('path',{className:'rc-progress-circle-path',d:pathString,strokeLinecap:'round',stroke:props.strokeColor,strokeWidth:strokeWidth,fillOpacity:'0',style:pathStyle}));}});module.exports={Line:Line,Circle:Circle};

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _rcQueueAnim=__webpack_require__(679);var _rcQueueAnim2=_interopRequireDefault(_rcQueueAnim);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var QueueAnim=function(_React$Component){(0,_inherits3.default)(QueueAnim,_React$Component);function QueueAnim(){(0,_classCallCheck3.default)(this,QueueAnim);return(0,_possibleConstructorReturn3.default)(this,(QueueAnim.__proto__||(0,_getPrototypeOf2.default)(QueueAnim)).apply(this,arguments));}(0,_createClass3.default)(QueueAnim,[{key:'componentDidMount',value:function componentDidMount(){(0,_warning2.default)(false,'`QueueAnim` is deprecated, '+'you can import QueueAnim from \'rc-queue-anim\' directly.'+'The Demo will be moved to http://motion.ant.design/component/queue-anim');}},{key:'render',value:function render(){return _react2.default.createElement(_rcQueueAnim2.default,this.props);}}]);return QueueAnim;}(_react2.default.Component);exports.default=QueueAnim;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _QueueAnim = __webpack_require__(680);

var _QueueAnim2 = _interopRequireDefault(_QueueAnim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _QueueAnim2["default"]; // export this package's api

module.exports = exports['default'];

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _utils = __webpack_require__(684);

var _animTypes = __webpack_require__(685);

var _animTypes2 = _interopRequireDefault(_animTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var _ease = {
  easeInElastic: function easeInElastic(_p, o, t) {
    var p = _p;
    var _p1 = o >= 1 ? o : 1;
    var _p2 = (t || 1) / (o < 1 ? o : 1);
    var _p3 = _p2 / Math.PI * 2 * (Math.asin(1 / _p1) || 0);
    return -(_p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin((p - _p3) * _p2));
  },
  easeOutElastic: function easeOutElastic(p, o, t) {
    var _p1 = o >= 1 ? o : 1;
    var _p2 = (t || 1) / (o < 1 ? o : 1);
    var _p3 = _p2 / Math.PI * 2 * (Math.asin(1 / _p1) || 0);
    return _p1 * Math.pow(2, -10 * p) * Math.sin((p - _p3) * _p2) + 1;
  },
  easeInOutElastic: function easeInOutElastic(_p, o, t) {
    var p = _p;
    var _p1 = o >= 1 ? o : 1;
    var _p2 = (t || 1) / (o < 1 ? o : 1);
    var _p3 = _p2 / Math.PI * 2 * (Math.asin(1 / _p1) || 0);
    p *= 2;
    return p < 1 ? -0.5 * (_p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin((p - _p3) * _p2)) : _p1 * Math.pow(2, -10 * (p -= 1)) * Math.sin((p - _p3) * _p2) * 0.5 + 1;
  },
  easeInBounce: function easeInBounce(_p) {
    var p = _p;
    var __p = 1 - p;
    if (__p < 1 / 2.75) {
      return 1 - 7.5625 * p * p;
    } else if (p < 2 / 2.75) {
      return 1 - (7.5625 * (p -= 1.5 / 2.75) * p + 0.75);
    } else if (p < 2.5 / 2.75) {
      return 1 - (7.5625 * (p -= 2.25 / 2.75) * p + 0.9375);
    }
    return 1 - (7.5625 * (p -= 2.625 / 2.75) * p + 0.984375);
  },
  easeOutBounce: function easeOutBounce(_p) {
    var p = _p;
    if (p < 1 / 2.75) {
      return 7.5625 * p * p;
    } else if (p < 2 / 2.75) {
      return 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
    } else if (p < 2.5 / 2.75) {
      return 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
    }
    return 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
  },
  easeInOutBounce: function easeInOutBounce(_p) {
    var p = _p;
    var invert = p < 0.5;
    if (invert) {
      p = 1 - p * 2;
    } else {
      p = p * 2 - 1;
    }
    if (p < 1 / 2.75) {
      p = 7.5625 * p * p;
    } else if (p < 2 / 2.75) {
      p = 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
    } else if (p < 2.5 / 2.75) {
      p = 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
    } else {
      p = 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
    }
    return invert ? (1 - p) * 0.5 : p * 0.5 + 0.5;
  }
};

var velocity = void 0;
if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  // only load velocity on the client
  velocity = __webpack_require__(686);
  Object.keys(_ease).forEach(function (key) {
    if (velocity.Easings) {
      velocity.Easings[key] = _ease[key];
    }
  });
} else {
  // provide a velocity stub for the server
  velocity = function velocityServerDummy() {
    var callback = arguments[arguments.length - 1];
    // call after stack flushes
    // in case you app depends on the asyncron nature of this function
    setImmediate(function () {
      return callback();
    });
  };
}

var BackEase = {
  easeInBack: [0.6, -0.28, 0.735, 0.045],
  easeOutBack: [0.175, 0.885, 0.32, 1.275],
  easeInOutBack: [0.68, -0.55, 0.265, 1.55]
};

var placeholderKeyPrefix = 'ant-queue-anim-placeholder-';

var noop = function noop() {};

var QueueAnim = function (_React$Component) {
  _inherits(QueueAnim, _React$Component);

  function QueueAnim() {
    _classCallCheck(this, QueueAnim);

    var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));

    _this.getInitAnimType = function (node, velocityConfig) {
      /*
       * enterForcedRePlay 为 false 时:
       * 强行结束后，获取当前 dom 里是否有 data 里的 key 值，
       * 如果有，出场开始启动为 dom 里的值
       * 而不是 animTypes 里的初始值，如果是初始值将会跳动。
       */
      var data = _extends({}, (0, _utils.assignChild)(velocityConfig));
      var transformsBase = velocity && velocity.prototype.constructor && velocity.prototype.constructor.CSS.Lists.transformsBase || [];
      var setPropertyValue = velocity && velocity.prototype.constructor && velocity.prototype.constructor.CSS.setPropertyValue || noop;
      var getUnitType = velocity && velocity.prototype.constructor && velocity.prototype.constructor.CSS.Values.getUnitType || noop;
      var nodeStyle = node.style;
      Object.keys(data).forEach(function (dataKey) {
        var cssName = dataKey;
        if (transformsBase.indexOf(dataKey) >= 0) {
          cssName = 'transform';
          var transformString = nodeStyle[(0, _utils.checkStyleName)(cssName)];
          if (transformString && transformString !== 'none') {
            if (transformString.match(dataKey)) {
              var rep = new RegExp('^.*' + dataKey + '\\(([^\\)]+?)\\).*', 'i');
              var transformData = transformString.replace(rep, '$1');
              data[dataKey][1] = parseFloat(transformData);
            }
          }
        } else if (nodeStyle[dataKey] && parseFloat(nodeStyle[dataKey])) {
          data[dataKey][1] = parseFloat(nodeStyle[dataKey]);
        }
        // 先把初始值设进 style 里。免得跳动；把下面的设置放到这里。
        setPropertyValue(node, cssName, '' + data[dataKey][1] + getUnitType(dataKey));
      });
      return data;
    };

    _this.keysToEnter = [];
    _this.keysToLeave = [];
    _this.keysAnimating = [];
    _this.placeholderTimeoutIds = {};

    // 第一次进入，默认进场
    var children = (0, _utils.toArrayChildren)((0, _utils.getChildrenFromProps)(_this.props));
    children.forEach(function (child) {
      if (!child || !child.key) {
        return;
      }
      _this.keysToEnter.push(child.key);
    });

    _this.originalChildren = (0, _utils.toArrayChildren)((0, _utils.getChildrenFromProps)(_this.props));

    _this.state = {
      children: children,
      childrenShow: {}
    };

    ['performEnter', 'performLeave', 'enterBegin', 'leaveComplete'].forEach(function (method) {
      return _this[method] = _this[method].bind(_this);
    });
    return _this;
  }

  QueueAnim.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate();
  };

  QueueAnim.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var nextChildren = (0, _utils.toArrayChildren)(nextProps.children);
    var currentChildren = this.originalChildren;
    var newChildren = (0, _utils.mergeChildren)(currentChildren, nextChildren);

    var childrenShow = !newChildren.length ? {} : this.state.childrenShow;
    // 在出场没结束时，childrenShow 里的值将不会清除。再触发进场时， childrenShow 里的值是保留着的, 设置了 enterForcedRePlay 将重新播放进场。
    this.keysToLeave.forEach(function (key) {
      // 将所有在出场里的停止掉。避免间隔性出现
      // 因为进场是用的间隔性进入，这里不做 stop 处理将会在这间隔里继续出场的动画。。
      var node = (0, _reactDom.findDOMNode)(_this2.refs[key]);
      velocity(node, 'stop');
      if (nextProps.enterForcedRePlay) {
        // 清掉所有出场的。
        delete childrenShow[key];
      }
    });

    this.keysToEnter = [];
    this.keysToLeave = [];
    this.keysAnimating = [];

    // need render to avoid update
    this.setState({
      childrenShow: childrenShow,
      children: newChildren
    });

    nextChildren.forEach(function (c) {
      if (!c) {
        return;
      }
      var key = c.key;
      var hasPrev = (0, _utils.findChildInChildrenByKey)(currentChildren, key);
      if (!hasPrev && key) {
        _this2.keysToEnter.push(key);
      }
    });

    currentChildren.forEach(function (c) {
      if (!c) {
        return;
      }
      var key = c.key;
      var hasNext = (0, _utils.findChildInChildrenByKey)(nextChildren, key);
      if (!hasNext && key) {
        _this2.keysToLeave.push(key);
      }
    });
  };

  QueueAnim.prototype.componentDidUpdate = function componentDidUpdate() {
    this.originalChildren = (0, _utils.toArrayChildren)((0, _utils.getChildrenFromProps)(this.props));
    var keysToEnter = Array.prototype.slice.call(this.keysToEnter);
    var keysToLeave = Array.prototype.slice.call(this.keysToLeave);
    if (this.keysAnimating.length === 0) {
      this.keysAnimating = keysToEnter.concat(keysToLeave);
    }
    keysToEnter.forEach(this.performEnter);
    keysToLeave.forEach(this.performLeave);
  };

  QueueAnim.prototype.componentWillUnmount = function componentWillUnmount() {
    var _this3 = this;

    [].concat(this.keysToEnter, this.keysToLeave, this.keysAnimating).forEach(function (key) {
      return _this3.refs[key] && velocity((0, _reactDom.findDOMNode)(_this3.refs[key]), 'stop');
    });
    Object.keys(this.placeholderTimeoutIds).forEach(function (key) {
      clearTimeout(_this3.placeholderTimeoutIds[key]);
    });
    this.keysToEnter = [];
    this.keysToLeave = [];
    this.keysAnimating = [];
  };

  QueueAnim.prototype.getVelocityConfig = function getVelocityConfig(index) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.props.animConfig) {
      return _utils.transformArguments.apply(undefined, [this.props.animConfig].concat(args))[index];
    }
    return _animTypes2["default"][_utils.transformArguments.apply(undefined, [this.props.type].concat(args))[index]];
  };

  QueueAnim.prototype.getVelocityEnterConfig = function getVelocityEnterConfig() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.getVelocityConfig.apply(this, [0].concat(args));
  };

  QueueAnim.prototype.getVelocityLeaveConfig = function getVelocityLeaveConfig() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var config = this.getVelocityConfig.apply(this, [1].concat(args));
    var ret = {};
    Object.keys(config).forEach(function (key) {
      if (Array.isArray(config[key])) {
        ret[key] = Array.prototype.slice.call(config[key]).reverse();
      } else {
        ret[key] = config[key];
      }
    });
    return ret;
  };

  QueueAnim.prototype.getVelocityEasing = function getVelocityEasing() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _utils.transformArguments.apply(undefined, [this.props.ease].concat(args)).map(function (easeName) {
      if (typeof easeName === 'string') {
        return BackEase[easeName] || easeName;
      }
      return easeName;
    });
  };

  QueueAnim.prototype.performEnter = function performEnter(key, i) {
    var interval = (0, _utils.transformArguments)(this.props.interval, key, i)[0];
    var delay = (0, _utils.transformArguments)(this.props.delay, key, i)[0];
    this.placeholderTimeoutIds[key] = setTimeout(this.performEnterBegin.bind(this, key, i), interval * i + delay);
    if (this.keysToEnter.indexOf(key) >= 0) {
      this.keysToEnter.splice(this.keysToEnter.indexOf(key), 1);
    }
  };

  QueueAnim.prototype.performEnterBegin = function performEnterBegin(key, i) {
    var childrenShow = this.state.childrenShow;
    childrenShow[key] = true;
    this.setState({ childrenShow: childrenShow }, this.realPerformEnter.bind(this, key, i));
  };

  QueueAnim.prototype.realPerformEnter = function realPerformEnter(key, i) {
    var node = (0, _reactDom.findDOMNode)(this.refs[key]);
    if (!node) {
      return;
    }
    var duration = (0, _utils.transformArguments)(this.props.duration, key, i)[0];
    velocity(node, 'stop');
    var data = this.props.enterForcedRePlay ? this.getVelocityEnterConfig(key, i) : this.getInitAnimType(node, this.getVelocityEnterConfig(key, i));
    if (this.props.enterForcedRePlay) {
      node.style.visibility = 'hidden';
    }
    velocity(node, data, {
      duration: duration,
      easing: this.getVelocityEasing(key, i)[0],
      visibility: 'visible',
      begin: this.enterBegin.bind(this, key),
      complete: this.enterComplete.bind(this, key)
    });
  };

  QueueAnim.prototype.performLeave = function performLeave(key, i) {
    clearTimeout(this.placeholderTimeoutIds[key]);
    delete this.placeholderTimeoutIds[key];
    var node = (0, _reactDom.findDOMNode)(this.refs[key]);
    if (!node) {
      return;
    }
    var interval = (0, _utils.transformArguments)(this.props.interval, key, i)[1];
    var delay = (0, _utils.transformArguments)(this.props.delay, key, i)[1];
    var duration = (0, _utils.transformArguments)(this.props.duration, key, i)[1];
    var order = this.props.leaveReverse ? this.keysToLeave.length - i - 1 : i;
    velocity(node, 'stop');
    node.style.visibility = 'visible';
    var data = this.getInitAnimType(node, this.getVelocityLeaveConfig(key, i));
    velocity(node, data, {
      delay: interval * order + delay,
      duration: duration,
      easing: this.getVelocityEasing(key, i)[1],
      begin: this.leaveBegin.bind(this, key),
      complete: this.leaveComplete.bind(this, key)
    });
  };

  QueueAnim.prototype.enterBegin = function enterBegin(key, elements) {
    var _this4 = this;

    elements.forEach(function (elem) {
      var animatingClassName = _this4.props.animatingClassName;
      elem.className = elem.className.replace(animatingClassName[1], '');
      if (elem.className.indexOf(animatingClassName[0]) === -1) {
        elem.className += ' ' + animatingClassName[0];
      }
    });
  };

  QueueAnim.prototype.enterComplete = function enterComplete(key, elements) {
    var _this5 = this;

    if (this.keysAnimating.indexOf(key) >= 0) {
      this.keysAnimating.splice(this.keysAnimating.indexOf(key), 1);
    }
    elements.forEach(function (elem) {
      elem.className = elem.className.replace(_this5.props.animatingClassName[0], '').trim();
    });
    this.props.onEnd({ key: key, type: 'enter' });
  };

  QueueAnim.prototype.leaveBegin = function leaveBegin(key, elements) {
    var _this6 = this;

    elements.forEach(function (elem) {
      var animatingClassName = _this6.props.animatingClassName;
      elem.className = elem.className.replace(animatingClassName[0], '');
      if (elem.className.indexOf(animatingClassName[1]) === -1) {
        elem.className += ' ' + animatingClassName[1];
      }
    });
  };

  QueueAnim.prototype.leaveComplete = function leaveComplete(key, elements) {
    var _this7 = this;

    if (this.keysAnimating.indexOf(key) < 0) {
      return;
    }
    this.keysAnimating.splice(this.keysAnimating.indexOf(key), 1);
    var childrenShow = this.state.childrenShow;
    childrenShow[key] = false;
    if (this.keysToLeave.indexOf(key) >= 0) {
      this.keysToLeave.splice(this.keysToLeave.indexOf(key), 1);
    }
    var needLeave = this.keysToLeave.some(function (c) {
      return childrenShow[c];
    });
    if (!needLeave) {
      var currentChildren = (0, _utils.toArrayChildren)((0, _utils.getChildrenFromProps)(this.props));
      this.setState({
        children: currentChildren,
        childrenShow: childrenShow
      });
    }
    elements.forEach(function (elem) {
      elem.className = elem.className.replace(_this7.props.animatingClassName[1], '').trim();
    });
    this.props.onEnd({ key: key, type: 'leave' });
  };

  QueueAnim.prototype.render = function render() {
    var _this8 = this;

    var childrenToRender = (0, _utils.toArrayChildren)(this.state.children).map(function (child) {
      if (!child || !child.key) {
        return child;
      }
      return _this8.state.childrenShow[child.key] ? (0, _react.cloneElement)(child, {
        ref: child.key,
        key: child.key
      }) : (0, _react.createElement)('div', {
        ref: placeholderKeyPrefix + child.key,
        key: placeholderKeyPrefix + child.key
      });
    });

    var tagProps = _objectWithoutProperties(this.props, []);

    ['component', 'interval', 'duration', 'delay', 'type', 'animConfig', 'ease', 'leaveReverse', 'animatingClassName', 'enterForcedRePlay', 'onEnd'].forEach(function (key) {
      return delete tagProps[key];
    });
    return (0, _react.createElement)(this.props.component, _extends({}, tagProps), childrenToRender);
  };

  return QueueAnim;
}(_react2["default"].Component);

var numberOrArray = _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.number, _react2["default"].PropTypes.array]);
var stringOrArray = _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.string, _react2["default"].PropTypes.array]);
var objectOrArray = _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.object, _react2["default"].PropTypes.array]);
var funcOrString = _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.func, _react2["default"].PropTypes.string]);
var funcOrStringOrArray = _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.func, stringOrArray]);
var funcOrObjectOrArray = _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.func, objectOrArray]);
var funcOrNumberOrArray = _react2["default"].PropTypes.oneOfType([_react2["default"].PropTypes.func, numberOrArray]);

QueueAnim.propTypes = {
  component: funcOrString,
  interval: numberOrArray,
  duration: funcOrNumberOrArray,
  delay: funcOrNumberOrArray,
  type: funcOrStringOrArray,
  animConfig: funcOrObjectOrArray,
  ease: funcOrStringOrArray,
  leaveReverse: _react2["default"].PropTypes.bool,
  enterForcedRePlay: _react2["default"].PropTypes.bool,
  animatingClassName: _react2["default"].PropTypes.array,
  onEnd: _react2["default"].PropTypes.func
};

QueueAnim.defaultProps = {
  component: 'div',
  interval: 100,
  duration: 450,
  delay: 0,
  type: 'right',
  animConfig: null,
  ease: 'easeOutQuart',
  leaveReverse: false,
  enterForcedRePlay: false,
  animatingClassName: ['queue-anim-entering', 'queue-anim-leaving'],
  onEnd: noop
};

exports["default"] = QueueAnim;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(681).setImmediate))

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(682);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57), __webpack_require__(683)))

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.toArrayChildren = toArrayChildren;
exports.findChildInChildrenByKey = findChildInChildrenByKey;
exports.mergeChildren = mergeChildren;
exports.transformArguments = transformArguments;
exports.getChildrenFromProps = getChildrenFromProps;
exports.assignChild = assignChild;
exports.checkStyleName = checkStyleName;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function toArrayChildren(children) {
  var ret = [];
  _react2["default"].Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (c) {
      if (ret || !c) {
        return;
      }
      if (c.key === key) {
        ret = c;
      }
    });
  }
  return ret;
}

function mergeChildren(prev, next) {
  var ret = [];
  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  var followChildrenKey = void 0;
  prev.forEach(function (c) {
    if (!c) {
      return;
    }
    if (findChildInChildrenByKey(next, c.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[c.key] = pendingChildren;
        pendingChildren = [];
      }
      followChildrenKey = c.key;
    } else if (c.key) {
      pendingChildren.push(c);
    }
  });
  if (!followChildrenKey) {
    ret = ret.concat(pendingChildren);
  }
  next.forEach(function (c) {
    if (!c) {
      return;
    }
    if (nextChildrenPending.hasOwnProperty(c.key)) {
      ret = ret.concat(nextChildrenPending[c.key]);
    }
    ret.push(c);
    if (c.key === followChildrenKey) {
      ret = ret.concat(pendingChildren);
    }
  });

  return ret;
}

function transformArguments(arg, key, i) {
  var result = void 0;
  if (typeof arg === 'function') {
    result = arg({
      key: key,
      index: i
    });
  } else {
    result = arg;
  }
  if (Array.isArray(result) && result.length === 2) {
    return result;
  }
  return [result, result];
}

function getChildrenFromProps(props) {
  return props && props.children;
}

function assignChild(data) {
  var obj = {};
  Object.keys(data).forEach(function (key) {
    if (Array.isArray(data[key])) {
      obj[key] = [].concat(data[key]);
      return;
    } else if (_typeof(data[key]) === 'object') {
      obj[key] = _extends({}, data[key]);
      return;
    }
    obj[key] = data[key];
    return;
  });
  return obj;
}

function checkStyleName(p) {
  var a = ['O', 'Moz', 'ms', 'Ms', 'Webkit'];
  if (p !== 'filter' && p in document.body.style) {
    return p;
  }
  var _p = p.charAt(0).toUpperCase() + p.substr(1);
  return '' + (a.filter(function (key) {
    return '' + key + _p in document.body.style;
  })[0] || '') + _p;
}

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  left: {
    opacity: [1, 0],
    translateX: [0, -30]
  },
  top: {
    opacity: [1, 0],
    translateY: [0, -30]
  },
  right: {
    opacity: [1, 0],
    translateX: [0, 30]
  },
  bottom: {
    opacity: [1, 0],
    translateY: [0, 30]
  },
  alpha: {
    opacity: [1, 0]
  },
  scale: {
    opacity: [1, 0],
    scale: [1, 0]
  },
  scaleBig: {
    opacity: [1, 0],
    scale: [1, 2]
  },
  scaleX: {
    opacity: [1, 0],
    scaleX: [1, 0]
  },
  scaleY: {
    opacity: [1, 0],
    scaleY: [1, 0]
  }
};
module.exports = exports['default'];

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! VelocityJS.org (1.2.3). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */

/*************************
   Velocity jQuery Shim
*************************/

/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */

/* This file contains the jQuery functions that Velocity relies on, thereby removing Velocity's dependency on a full copy of jQuery, and allowing it to work in any environment. */
/* These shimmed functions are only used if jQuery isn't present. If both this shim and jQuery are loaded, Velocity defaults to jQuery proper. */
/* Browser support: Using this shim instead of jQuery proper removes support for IE8. */

;(function (window) {
    /***************
         Setup
    ***************/

    /* If jQuery is already loaded, there's no point in loading this shim. */
    if (window.jQuery) {
        return;
    }

    /* jQuery base. */
    var $ = function (selector, context) {
        return new $.fn.init(selector, context);
    };

    /********************
       Private Methods
    ********************/

    /* jQuery */
    $.isWindow = function (obj) {
        /* jshint eqeqeq: false */
        return obj != null && obj == obj.window;
    };

    /* jQuery */
    $.type = function (obj) {
        if (obj == null) {
            return obj + "";
        }

        return typeof obj === "object" || typeof obj === "function" ?
            class2type[toString.call(obj)] || "object" :
            typeof obj;
    };

    /* jQuery */
    $.isArray = Array.isArray || function (obj) {
        return $.type(obj) === "array";
    };

    /* jQuery */
    function isArraylike (obj) {
        var length = obj.length,
            type = $.type(obj);

        if (type === "function" || $.isWindow(obj)) {
            return false;
        }

        if (obj.nodeType === 1 && length) {
            return true;
        }

        return type === "array" || length === 0 || typeof length === "number" && length > 0 && (length - 1) in obj;
    }

    /***************
       $ Methods
    ***************/

    /* jQuery: Support removed for IE<9. */
    $.isPlainObject = function (obj) {
        var key;

        if (!obj || $.type(obj) !== "object" || obj.nodeType || $.isWindow(obj)) {
            return false;
        }

        try {
            if (obj.constructor &&
                !hasOwn.call(obj, "constructor") &&
                !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
                return false;
            }
        } catch (e) {
            return false;
        }

        for (key in obj) {}

        return key === undefined || hasOwn.call(obj, key);
    };

    /* jQuery */
    $.each = function(obj, callback, args) {
        var value,
            i = 0,
            length = obj.length,
            isArray = isArraylike(obj);

        if (args) {
            if (isArray) {
                for (; i < length; i++) {
                    value = callback.apply(obj[i], args);

                    if (value === false) {
                        break;
                    }
                }
            } else {
                for (i in obj) {
                    value = callback.apply(obj[i], args);

                    if (value === false) {
                        break;
                    }
                }
            }

        } else {
            if (isArray) {
                for (; i < length; i++) {
                    value = callback.call(obj[i], i, obj[i]);

                    if (value === false) {
                        break;
                    }
                }
            } else {
                for (i in obj) {
                    value = callback.call(obj[i], i, obj[i]);

                    if (value === false) {
                        break;
                    }
                }
            }
        }

        return obj;
    };

    /* Custom */
    $.data = function (node, key, value) {
        /* $.getData() */
        if (value === undefined) {
            var id = node[$.expando],
                store = id && cache[id];

            if (key === undefined) {
                return store;
            } else if (store) {
                if (key in store) {
                    return store[key];
                }
            }
        /* $.setData() */
        } else if (key !== undefined) {
            var id = node[$.expando] || (node[$.expando] = ++$.uuid);

            cache[id] = cache[id] || {};
            cache[id][key] = value;

            return value;
        }
    };

    /* Custom */
    $.removeData = function (node, keys) {
        var id = node[$.expando],
            store = id && cache[id];

        if (store) {
            $.each(keys, function(_, key) {
                delete store[key];
            });
        }
    };

    /* jQuery */
    $.extend = function () {
        var src, copyIsArray, copy, name, options, clone,
            target = arguments[0] || {},
            i = 1,
            length = arguments.length,
            deep = false;

        if (typeof target === "boolean") {
            deep = target;

            target = arguments[i] || {};
            i++;
        }

        if (typeof target !== "object" && $.type(target) !== "function") {
            target = {};
        }

        if (i === length) {
            target = this;
            i--;
        }

        for (; i < length; i++) {
            if ((options = arguments[i]) != null) {
                for (name in options) {
                    src = target[name];
                    copy = options[name];

                    if (target === copy) {
                        continue;
                    }

                    if (deep && copy && ($.isPlainObject(copy) || (copyIsArray = $.isArray(copy)))) {
                        if (copyIsArray) {
                            copyIsArray = false;
                            clone = src && $.isArray(src) ? src : [];

                        } else {
                            clone = src && $.isPlainObject(src) ? src : {};
                        }

                        target[name] = $.extend(deep, clone, copy);

                    } else if (copy !== undefined) {
                        target[name] = copy;
                    }
                }
            }
        }

        return target;
    };

    /* jQuery 1.4.3 */
    $.queue = function (elem, type, data) {
        function $makeArray (arr, results) {
            var ret = results || [];

            if (arr != null) {
                if (isArraylike(Object(arr))) {
                    /* $.merge */
                    (function(first, second) {
                        var len = +second.length,
                            j = 0,
                            i = first.length;

                        while (j < len) {
                            first[i++] = second[j++];
                        }

                        if (len !== len) {
                            while (second[j] !== undefined) {
                                first[i++] = second[j++];
                            }
                        }

                        first.length = i;

                        return first;
                    })(ret, typeof arr === "string" ? [arr] : arr);
                } else {
                    [].push.call(ret, arr);
                }
            }

            return ret;
        }

        if (!elem) {
            return;
        }

        type = (type || "fx") + "queue";

        var q = $.data(elem, type);

        if (!data) {
            return q || [];
        }

        if (!q || $.isArray(data)) {
            q = $.data(elem, type, $makeArray(data));
        } else {
            q.push(data);
        }

        return q;
    };

    /* jQuery 1.4.3 */
    $.dequeue = function (elems, type) {
        /* Custom: Embed element iteration. */
        $.each(elems.nodeType ? [ elems ] : elems, function(i, elem) {
            type = type || "fx";

            var queue = $.queue(elem, type),
                fn = queue.shift();

            if (fn === "inprogress") {
                fn = queue.shift();
            }

            if (fn) {
                if (type === "fx") {
                    queue.unshift("inprogress");
                }

                fn.call(elem, function() {
                    $.dequeue(elem, type);
                });
            }
        });
    };

    /******************
       $.fn Methods
    ******************/

    /* jQuery */
    $.fn = $.prototype = {
        init: function (selector) {
            /* Just return the element wrapped inside an array; don't proceed with the actual jQuery node wrapping process. */
            if (selector.nodeType) {
                this[0] = selector;

                return this;
            } else {
                throw new Error("Not a DOM node.");
            }
        },

        offset: function () {
            /* jQuery altered code: Dropped disconnected DOM node checking. */
            var box = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : { top: 0, left: 0 };

            return {
                top: box.top + (window.pageYOffset || document.scrollTop  || 0)  - (document.clientTop  || 0),
                left: box.left + (window.pageXOffset || document.scrollLeft  || 0) - (document.clientLeft || 0)
            };
        },

        position: function () {
            /* jQuery */
            function offsetParent() {
                var offsetParent = this.offsetParent || document;

                while (offsetParent && (!offsetParent.nodeType.toLowerCase === "html" && offsetParent.style.position === "static")) {
                    offsetParent = offsetParent.offsetParent;
                }

                return offsetParent || document;
            }

            /* Zepto */
            var elem = this[0],
                offsetParent = offsetParent.apply(elem),
                offset = this.offset(),
                parentOffset = /^(?:body|html)$/i.test(offsetParent.nodeName) ? { top: 0, left: 0 } : $(offsetParent).offset()

            offset.top -= parseFloat(elem.style.marginTop) || 0;
            offset.left -= parseFloat(elem.style.marginLeft) || 0;

            if (offsetParent.style) {
                parentOffset.top += parseFloat(offsetParent.style.borderTopWidth) || 0
                parentOffset.left += parseFloat(offsetParent.style.borderLeftWidth) || 0
            }

            return {
                top: offset.top - parentOffset.top,
                left: offset.left - parentOffset.left
            };
        }
    };

    /**********************
       Private Variables
    **********************/

    /* For $.data() */
    var cache = {};
    $.expando = "velocity" + (new Date().getTime());
    $.uuid = 0;

    /* For $.queue() */
    var class2type = {},
        hasOwn = class2type.hasOwnProperty,
        toString = class2type.toString;

    var types = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
    for (var i = 0; i < types.length; i++) {
        class2type["[object " + types[i] + "]"] = types[i].toLowerCase();
    }

    /* Makes $(node) possible, without having to call init. */
    $.fn.init.prototype = $.fn;

    /* Globalize Velocity onto the window, and assign its Utilities property. */
    window.Velocity = { Utilities: $ };
})(window);

/******************
    Velocity.js
******************/

;(function (factory) {
    /* CommonJS module. */
    if (typeof module === "object" && typeof module.exports === "object") {
        module.exports = factory();
    /* AMD module. */
    } else if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    /* Browser globals. */
    } else {
        factory();
    }
}(function() {
return function (global, window, document, undefined) {

    /***************
        Summary
    ***************/

    /*
    - CSS: CSS stack that works independently from the rest of Velocity.
    - animate(): Core animation method that iterates over the targeted elements and queues the incoming call onto each element individually.
      - Pre-Queueing: Prepare the element for animation by instantiating its data cache and processing the call's options.
      - Queueing: The logic that runs once the call has reached its point of execution in the element's $.queue() stack.
                  Most logic is placed here to avoid risking it becoming stale (if the element's properties have changed).
      - Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
    - tick(): The single requestAnimationFrame loop responsible for tweening all in-progress calls.
    - completeCall(): Handles the cleanup process for each Velocity call.
    */

    /*********************
       Helper Functions
    *********************/

    /* IE detection. Gist: https://gist.github.com/julianshapiro/9098609 */
    var IE = (function() {
        if (document.documentMode) {
            return document.documentMode;
        } else {
            for (var i = 7; i > 4; i--) {
                var div = document.createElement("div");

                div.innerHTML = "<!--[if IE " + i + "]><span></span><![endif]-->";

                if (div.getElementsByTagName("span").length) {
                    div = null;

                    return i;
                }
            }
        }

        return undefined;
    })();

    /* rAF shim. Gist: https://gist.github.com/julianshapiro/9497513 */
    var rAFShim = (function() {
        var timeLast = 0;

        return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
            var timeCurrent = (new Date()).getTime(),
                timeDelta;

            /* Dynamically set delay on a per-tick basis to match 60fps. */
            /* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
            timeDelta = Math.max(0, 16 - (timeCurrent - timeLast));
            timeLast = timeCurrent + timeDelta;

            return setTimeout(function() { callback(timeCurrent + timeDelta); }, timeDelta);
        };
    })();

    /* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */
    function compactSparseArray (array) {
        var index = -1,
            length = array ? array.length : 0,
            result = [];

        while (++index < length) {
            var value = array[index];

            if (value) {
                result.push(value);
            }
        }

        return result;
    }

    function sanitizeElements (elements) {
        /* Unwrap jQuery/Zepto objects. */
        if (Type.isWrapped(elements)) {
            elements = [].slice.call(elements);
        /* Wrap a single element in an array so that $.each() can iterate with the element instead of its node's children. */
        } else if (Type.isNode(elements)) {
            elements = [ elements ];
        }

        return elements;
    }

    var Type = {
        isString: function (variable) {
            return (typeof variable === "string");
        },
        isArray: Array.isArray || function (variable) {
            return Object.prototype.toString.call(variable) === "[object Array]";
        },
        isFunction: function (variable) {
            return Object.prototype.toString.call(variable) === "[object Function]";
        },
        isNode: function (variable) {
            return variable && variable.nodeType;
        },
        /* Copyright Martin Bohm. MIT License: https://gist.github.com/Tomalak/818a78a226a0738eaade */
        isNodeList: function (variable) {
            return typeof variable === "object" &&
                /^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(variable)) &&
                variable.length !== undefined &&
                (variable.length === 0 || (typeof variable[0] === "object" && variable[0].nodeType > 0));
        },
        /* Determine if variable is a wrapped jQuery or Zepto element. */
        isWrapped: function (variable) {
            return variable && (variable.jquery || (window.Zepto && window.Zepto.zepto.isZ(variable)));
        },
        isSVG: function (variable) {
            return window.SVGElement && (variable instanceof window.SVGElement);
        },
        isEmptyObject: function (variable) {
            for (var name in variable) {
                return false;
            }

            return true;
        }
    };

    /*****************
       Dependencies
    *****************/

    var $,
        isJQuery = false;

    if (global.fn && global.fn.jquery) {
        $ = global;
        isJQuery = true;
    } else {
        $ = window.Velocity.Utilities;
    }

    if (IE <= 8 && !isJQuery) {
        throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
    } else if (IE <= 7) {
        /* Revert to jQuery's $.animate(), and lose Velocity's extra features. */
        jQuery.fn.velocity = jQuery.fn.animate;

        /* Now that $.fn.velocity is aliased, abort this Velocity declaration. */
        return;
    }

    /*****************
        Constants
    *****************/

    var DURATION_DEFAULT = 400,
        EASING_DEFAULT = "swing";

    /*************
        State
    *************/

    var Velocity = {
        /* Container for page-wide Velocity state data. */
        State: {
            /* Detect mobile devices to determine if mobileHA should be turned on. */
            isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
            /* The mobileHA option's behavior changes on older Android devices (Gingerbread, versions 2.3.3-2.3.7). */
            isAndroid: /Android/i.test(navigator.userAgent),
            isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
            isChrome: window.chrome,
            isFirefox: /Firefox/i.test(navigator.userAgent),
            /* Create a cached element for re-use when checking for CSS property prefixes. */
            prefixElement: document.createElement("div"),
            /* Cache every prefix match to avoid repeating lookups. */
            prefixMatches: {},
            /* Cache the anchor used for animating window scrolling. */
            scrollAnchor: null,
            /* Cache the browser-specific property names associated with the scroll anchor. */
            scrollPropertyLeft: null,
            scrollPropertyTop: null,
            /* Keep track of whether our RAF tick is running. */
            isTicking: false,
            /* Container for every in-progress call to Velocity. */
            calls: []
        },
        /* Velocity's custom CSS stack. Made global for unit testing. */
        CSS: { /* Defined below. */ },
        /* A shim of the jQuery utility functions used by Velocity -- provided by Velocity's optional jQuery shim. */
        Utilities: $,
        /* Container for the user's custom animation redirects that are referenced by name in place of the properties map argument. */
        Redirects: { /* Manually registered by the user. */ },
        Easings: { /* Defined below. */ },
        /* Attempt to use ES6 Promises by default. Users can override this with a third-party promises library. */
        Promise: window.Promise,
        /* Velocity option defaults, which can be overriden by the user. */
        defaults: {
            queue: "",
            duration: DURATION_DEFAULT,
            easing: EASING_DEFAULT,
            begin: undefined,
            complete: undefined,
            progress: undefined,
            display: undefined,
            visibility: undefined,
            loop: false,
            delay: false,
            mobileHA: true,
            /* Advanced: Set to false to prevent property values from being cached between consecutive Velocity-initiated chain calls. */
            _cacheValues: true
        },
        /* A design goal of Velocity is to cache data wherever possible in order to avoid DOM requerying. Accordingly, each element has a data cache. */
        init: function (element) {
            $.data(element, "velocity", {
                /* Store whether this is an SVG element, since its properties are retrieved and updated differently than standard HTML elements. */
                isSVG: Type.isSVG(element),
                /* Keep track of whether the element is currently being animated by Velocity.
                   This is used to ensure that property values are not transferred between non-consecutive (stale) calls. */
                isAnimating: false,
                /* A reference to the element's live computedStyle object. Learn more here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
                computedStyle: null,
                /* Tween data is cached for each animation on the element so that data can be passed across calls --
                   in particular, end values are used as subsequent start values in consecutive Velocity calls. */
                tweensContainer: null,
                /* The full root property values of each CSS hook being animated on this element are cached so that:
                   1) Concurrently-animating hooks sharing the same root can have their root values' merged into one while tweening.
                   2) Post-hook-injection root values can be transferred over to consecutively chained Velocity calls as starting root values. */
                rootPropertyValueCache: {},
                /* A cache for transform updates, which must be manually flushed via CSS.flushTransformCache(). */
                transformCache: {}
            });
        },
        /* A parallel to jQuery's $.css(), used for getting/setting Velocity's hooked CSS properties. */
        hook: null, /* Defined below. */
        /* Velocity-wide animation time remapping for testing purposes. */
        mock: false,
        version: { major: 1, minor: 2, patch: 2 },
        /* Set to 1 or 2 (most verbose) to output debug info to console. */
        debug: false
    };

    /* Retrieve the appropriate scroll anchor and property name for the browser: https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY */
    if (window.pageYOffset !== undefined) {
        Velocity.State.scrollAnchor = window;
        Velocity.State.scrollPropertyLeft = "pageXOffset";
        Velocity.State.scrollPropertyTop = "pageYOffset";
    } else {
        Velocity.State.scrollAnchor = document.documentElement || document.body.parentNode || document.body;
        Velocity.State.scrollPropertyLeft = "scrollLeft";
        Velocity.State.scrollPropertyTop = "scrollTop";
    }

    /* Shorthand alias for jQuery's $.data() utility. */
    function Data (element) {
        /* Hardcode a reference to the plugin name. */
        var response = $.data(element, "velocity");

        /* jQuery <=1.4.2 returns null instead of undefined when no match is found. We normalize this behavior. */
        return response === null ? undefined : response;
    };

    /**************
        Easing
    **************/

    /* Step easing generator. */
    function generateStep (steps) {
        return function (p) {
            return Math.round(p * steps) * (1 / steps);
        };
    }

    /* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
    function generateBezier (mX1, mY1, mX2, mY2) {
        var NEWTON_ITERATIONS = 4,
            NEWTON_MIN_SLOPE = 0.001,
            SUBDIVISION_PRECISION = 0.0000001,
            SUBDIVISION_MAX_ITERATIONS = 10,
            kSplineTableSize = 11,
            kSampleStepSize = 1.0 / (kSplineTableSize - 1.0),
            float32ArraySupported = "Float32Array" in window;

        /* Must contain four arguments. */
        if (arguments.length !== 4) {
            return false;
        }

        /* Arguments must be numbers. */
        for (var i = 0; i < 4; ++i) {
            if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) {
                return false;
            }
        }

        /* X values must be in the [0, 1] range. */
        mX1 = Math.min(mX1, 1);
        mX2 = Math.min(mX2, 1);
        mX1 = Math.max(mX1, 0);
        mX2 = Math.max(mX2, 0);

        var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);

        function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
        function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
        function C (aA1)      { return 3.0 * aA1; }

        function calcBezier (aT, aA1, aA2) {
            return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
        }

        function getSlope (aT, aA1, aA2) {
            return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }

        function newtonRaphsonIterate (aX, aGuessT) {
            for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
                var currentSlope = getSlope(aGuessT, mX1, mX2);

                if (currentSlope === 0.0) return aGuessT;

                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
            }

            return aGuessT;
        }

        function calcSampleValues () {
            for (var i = 0; i < kSplineTableSize; ++i) {
                mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            }
        }

        function binarySubdivide (aX, aA, aB) {
            var currentX, currentT, i = 0;

            do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) {
                  aB = currentT;
                } else {
                  aA = currentT;
                }
            } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

            return currentT;
        }

        function getTForX (aX) {
            var intervalStart = 0.0,
                currentSample = 1,
                lastSample = kSplineTableSize - 1;

            for (; currentSample != lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
                intervalStart += kSampleStepSize;
            }

            --currentSample;

            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]),
                guessForT = intervalStart + dist * kSampleStepSize,
                initialSlope = getSlope(guessForT, mX1, mX2);

            if (initialSlope >= NEWTON_MIN_SLOPE) {
                return newtonRaphsonIterate(aX, guessForT);
            } else if (initialSlope == 0.0) {
                return guessForT;
            } else {
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
            }
        }

        var _precomputed = false;

        function precompute() {
            _precomputed = true;
            if (mX1 != mY1 || mX2 != mY2) calcSampleValues();
        }

        var f = function (aX) {
            if (!_precomputed) precompute();
            if (mX1 === mY1 && mX2 === mY2) return aX;
            if (aX === 0) return 0;
            if (aX === 1) return 1;

            return calcBezier(getTForX(aX), mY1, mY2);
        };

        f.getControlPoints = function() { return [{ x: mX1, y: mY1 }, { x: mX2, y: mY2 }]; };

        var str = "generateBezier(" + [mX1, mY1, mX2, mY2] + ")";
        f.toString = function () { return str; };

        return f;
    }

    /* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
    /* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
       then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
    var generateSpringRK4 = (function () {
        function springAccelerationForState (state) {
            return (-state.tension * state.x) - (state.friction * state.v);
        }

        function springEvaluateStateWithDerivative (initialState, dt, derivative) {
            var state = {
                x: initialState.x + derivative.dx * dt,
                v: initialState.v + derivative.dv * dt,
                tension: initialState.tension,
                friction: initialState.friction
            };

            return { dx: state.v, dv: springAccelerationForState(state) };
        }

        function springIntegrateState (state, dt) {
            var a = {
                    dx: state.v,
                    dv: springAccelerationForState(state)
                },
                b = springEvaluateStateWithDerivative(state, dt * 0.5, a),
                c = springEvaluateStateWithDerivative(state, dt * 0.5, b),
                d = springEvaluateStateWithDerivative(state, dt, c),
                dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx),
                dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);

            state.x = state.x + dxdt * dt;
            state.v = state.v + dvdt * dt;

            return state;
        }

        return function springRK4Factory (tension, friction, duration) {

            var initState = {
                    x: -1,
                    v: 0,
                    tension: null,
                    friction: null
                },
                path = [0],
                time_lapsed = 0,
                tolerance = 1 / 10000,
                DT = 16 / 1000,
                have_duration, dt, last_state;

            tension = parseFloat(tension) || 500;
            friction = parseFloat(friction) || 20;
            duration = duration || null;

            initState.tension = tension;
            initState.friction = friction;

            have_duration = duration !== null;

            /* Calculate the actual time it takes for this animation to complete with the provided conditions. */
            if (have_duration) {
                /* Run the simulation without a duration. */
                time_lapsed = springRK4Factory(tension, friction);
                /* Compute the adjusted time delta. */
                dt = time_lapsed / duration * DT;
            } else {
                dt = DT;
            }

            while (true) {
                /* Next/step function .*/
                last_state = springIntegrateState(last_state || initState, dt);
                /* Store the position. */
                path.push(1 + last_state.x);
                time_lapsed += 16;
                /* If the change threshold is reached, break. */
                if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) {
                    break;
                }
            }

            /* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
               computed path and returns a snapshot of the position according to a given percentComplete. */
            return !have_duration ? time_lapsed : function(percentComplete) { return path[ (percentComplete * (path.length - 1)) | 0 ]; };
        };
    }());

    /* jQuery easings. */
    Velocity.Easings = {
        linear: function(p) { return p; },
        swing: function(p) { return 0.5 - Math.cos( p * Math.PI ) / 2 },
        /* Bonus "spring" easing, which is a less exaggerated version of easeInOutElastic. */
        spring: function(p) { return 1 - (Math.cos(p * 4.5 * Math.PI) * Math.exp(-p * 6)); }
    };

    /* CSS3 and Robert Penner easings. */
    $.each(
        [
            [ "ease", [ 0.25, 0.1, 0.25, 1.0 ] ],
            [ "ease-in", [ 0.42, 0.0, 1.00, 1.0 ] ],
            [ "ease-out", [ 0.00, 0.0, 0.58, 1.0 ] ],
            [ "ease-in-out", [ 0.42, 0.0, 0.58, 1.0 ] ],
            [ "easeInSine", [ 0.47, 0, 0.745, 0.715 ] ],
            [ "easeOutSine", [ 0.39, 0.575, 0.565, 1 ] ],
            [ "easeInOutSine", [ 0.445, 0.05, 0.55, 0.95 ] ],
            [ "easeInQuad", [ 0.55, 0.085, 0.68, 0.53 ] ],
            [ "easeOutQuad", [ 0.25, 0.46, 0.45, 0.94 ] ],
            [ "easeInOutQuad", [ 0.455, 0.03, 0.515, 0.955 ] ],
            [ "easeInCubic", [ 0.55, 0.055, 0.675, 0.19 ] ],
            [ "easeOutCubic", [ 0.215, 0.61, 0.355, 1 ] ],
            [ "easeInOutCubic", [ 0.645, 0.045, 0.355, 1 ] ],
            [ "easeInQuart", [ 0.895, 0.03, 0.685, 0.22 ] ],
            [ "easeOutQuart", [ 0.165, 0.84, 0.44, 1 ] ],
            [ "easeInOutQuart", [ 0.77, 0, 0.175, 1 ] ],
            [ "easeInQuint", [ 0.755, 0.05, 0.855, 0.06 ] ],
            [ "easeOutQuint", [ 0.23, 1, 0.32, 1 ] ],
            [ "easeInOutQuint", [ 0.86, 0, 0.07, 1 ] ],
            [ "easeInExpo", [ 0.95, 0.05, 0.795, 0.035 ] ],
            [ "easeOutExpo", [ 0.19, 1, 0.22, 1 ] ],
            [ "easeInOutExpo", [ 1, 0, 0, 1 ] ],
            [ "easeInCirc", [ 0.6, 0.04, 0.98, 0.335 ] ],
            [ "easeOutCirc", [ 0.075, 0.82, 0.165, 1 ] ],
            [ "easeInOutCirc", [ 0.785, 0.135, 0.15, 0.86 ] ]
        ], function(i, easingArray) {
            Velocity.Easings[easingArray[0]] = generateBezier.apply(null, easingArray[1]);
        });

    /* Determine the appropriate easing type given an easing input. */
    function getEasing(value, duration) {
        var easing = value;

        /* The easing option can either be a string that references a pre-registered easing,
           or it can be a two-/four-item array of integers to be converted into a bezier/spring function. */
        if (Type.isString(value)) {
            /* Ensure that the easing has been assigned to jQuery's Velocity.Easings object. */
            if (!Velocity.Easings[value]) {
                easing = false;
            }
        } else if (Type.isArray(value) && value.length === 1) {
            easing = generateStep.apply(null, value);
        } else if (Type.isArray(value) && value.length === 2) {
            /* springRK4 must be passed the animation's duration. */
            /* Note: If the springRK4 array contains non-numbers, generateSpringRK4() returns an easing
               function generated with default tension and friction values. */
            easing = generateSpringRK4.apply(null, value.concat([ duration ]));
        } else if (Type.isArray(value) && value.length === 4) {
            /* Note: If the bezier array contains non-numbers, generateBezier() returns false. */
            easing = generateBezier.apply(null, value);
        } else {
            easing = false;
        }

        /* Revert to the Velocity-wide default easing type, or fall back to "swing" (which is also jQuery's default)
           if the Velocity-wide default has been incorrectly modified. */
        if (easing === false) {
            if (Velocity.Easings[Velocity.defaults.easing]) {
                easing = Velocity.defaults.easing;
            } else {
                easing = EASING_DEFAULT;
            }
        }

        return easing;
    }

    /*****************
        CSS Stack
    *****************/

    /* The CSS object is a highly condensed and performant CSS stack that fully replaces jQuery's.
       It handles the validation, getting, and setting of both standard CSS properties and CSS property hooks. */
    /* Note: A "CSS" shorthand is aliased so that our code is easier to read. */
    var CSS = Velocity.CSS = {

        /*************
            RegEx
        *************/

        RegEx: {
            isHex: /^#([A-f\d]{3}){1,2}$/i,
            /* Unwrap a property value's surrounding text, e.g. "rgba(4, 3, 2, 1)" ==> "4, 3, 2, 1" and "rect(4px 3px 2px 1px)" ==> "4px 3px 2px 1px". */
            valueUnwrap: /^[A-z]+\((.*)\)$/i,
            wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
            /* Split a multi-value property into an array of subvalues, e.g. "rgba(4, 3, 2, 1) 4px 3px 2px 1px" ==> [ "rgba(4, 3, 2, 1)", "4px", "3px", "2px", "1px" ]. */
            valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/ig
        },

        /************
            Lists
        ************/

        Lists: {
            colors: [ "fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor" ],
            transformsBase: [ "translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ" ],
            transforms3D: [ "transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY" ]
        },

        /************
            Hooks
        ************/

        /* Hooks allow a subproperty (e.g. "boxShadowBlur") of a compound-value CSS property
           (e.g. "boxShadow: X Y Blur Spread Color") to be animated as if it were a discrete property. */
        /* Note: Beyond enabling fine-grained property animation, hooking is necessary since Velocity only
           tweens properties with single numeric values; unlike CSS transitions, Velocity does not interpolate compound-values. */
        Hooks: {
            /********************
                Registration
            ********************/

            /* Templates are a concise way of indicating which subproperties must be individually registered for each compound-value CSS property. */
            /* Each template consists of the compound-value's base name, its constituent subproperty names, and those subproperties' default values. */
            templates: {
                "textShadow": [ "Color X Y Blur", "black 0px 0px 0px" ],
                "boxShadow": [ "Color X Y Blur Spread", "black 0px 0px 0px 0px" ],
                "clip": [ "Top Right Bottom Left", "0px 0px 0px 0px" ],
                "backgroundPosition": [ "X Y", "0% 0%" ],
                "transformOrigin": [ "X Y Z", "50% 50% 0px" ],
                "perspectiveOrigin": [ "X Y", "50% 50%" ]
            },

            /* A "registered" hook is one that has been converted from its template form into a live,
               tweenable property. It contains data to associate it with its root property. */
            registered: {
                /* Note: A registered hook looks like this ==> textShadowBlur: [ "textShadow", 3 ],
                   which consists of the subproperty's name, the associated root property's name,
                   and the subproperty's position in the root's value. */
            },
            /* Convert the templates into individual hooks then append them to the registered object above. */
            register: function () {
                /* Color hooks registration: Colors are defaulted to white -- as opposed to black -- since colors that are
                   currently set to "transparent" default to their respective template below when color-animated,
                   and white is typically a closer match to transparent than black is. An exception is made for text ("color"),
                   which is almost always set closer to black than white. */
                for (var i = 0; i < CSS.Lists.colors.length; i++) {
                    var rgbComponents = (CSS.Lists.colors[i] === "color") ? "0 0 0 1" : "255 255 255 1";
                    CSS.Hooks.templates[CSS.Lists.colors[i]] = [ "Red Green Blue Alpha", rgbComponents ];
                }

                var rootProperty,
                    hookTemplate,
                    hookNames;

                /* In IE, color values inside compound-value properties are positioned at the end the value instead of at the beginning.
                   Thus, we re-arrange the templates accordingly. */
                if (IE) {
                    for (rootProperty in CSS.Hooks.templates) {
                        hookTemplate = CSS.Hooks.templates[rootProperty];
                        hookNames = hookTemplate[0].split(" ");

                        var defaultValues = hookTemplate[1].match(CSS.RegEx.valueSplit);

                        if (hookNames[0] === "Color") {
                            /* Reposition both the hook's name and its default value to the end of their respective strings. */
                            hookNames.push(hookNames.shift());
                            defaultValues.push(defaultValues.shift());

                            /* Replace the existing template for the hook's root property. */
                            CSS.Hooks.templates[rootProperty] = [ hookNames.join(" "), defaultValues.join(" ") ];
                        }
                    }
                }

                /* Hook registration. */
                for (rootProperty in CSS.Hooks.templates) {
                    hookTemplate = CSS.Hooks.templates[rootProperty];
                    hookNames = hookTemplate[0].split(" ");

                    for (var i in hookNames) {
                        var fullHookName = rootProperty + hookNames[i],
                            hookPosition = i;

                        /* For each hook, register its full name (e.g. textShadowBlur) with its root property (e.g. textShadow)
                           and the hook's position in its template's default value string. */
                        CSS.Hooks.registered[fullHookName] = [ rootProperty, hookPosition ];
                    }
                }
            },

            /*****************************
               Injection and Extraction
            *****************************/

            /* Look up the root property associated with the hook (e.g. return "textShadow" for "textShadowBlur"). */
            /* Since a hook cannot be set directly (the browser won't recognize it), style updating for hooks is routed through the hook's root property. */
            getRoot: function (property) {
                var hookData = CSS.Hooks.registered[property];

                if (hookData) {
                    return hookData[0];
                } else {
                    /* If there was no hook match, return the property name untouched. */
                    return property;
                }
            },
            /* Convert any rootPropertyValue, null or otherwise, into a space-delimited list of hook values so that
               the targeted hook can be injected or extracted at its standard position. */
            cleanRootPropertyValue: function(rootProperty, rootPropertyValue) {
                /* If the rootPropertyValue is wrapped with "rgb()", "clip()", etc., remove the wrapping to normalize the value before manipulation. */
                if (CSS.RegEx.valueUnwrap.test(rootPropertyValue)) {
                    rootPropertyValue = rootPropertyValue.match(CSS.RegEx.valueUnwrap)[1];
                }

                /* If rootPropertyValue is a CSS null-value (from which there's inherently no hook value to extract),
                   default to the root's default value as defined in CSS.Hooks.templates. */
                /* Note: CSS null-values include "none", "auto", and "transparent". They must be converted into their
                   zero-values (e.g. textShadow: "none" ==> textShadow: "0px 0px 0px black") for hook manipulation to proceed. */
                if (CSS.Values.isCSSNullValue(rootPropertyValue)) {
                    rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
                }

                return rootPropertyValue;
            },
            /* Extracted the hook's value from its root property's value. This is used to get the starting value of an animating hook. */
            extractValue: function (fullHookName, rootPropertyValue) {
                var hookData = CSS.Hooks.registered[fullHookName];

                if (hookData) {
                    var hookRoot = hookData[0],
                        hookPosition = hookData[1];

                    rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);

                    /* Split rootPropertyValue into its constituent hook values then grab the desired hook at its standard position. */
                    return rootPropertyValue.toString().match(CSS.RegEx.valueSplit)[hookPosition];
                } else {
                    /* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
                    return rootPropertyValue;
                }
            },
            /* Inject the hook's value into its root property's value. This is used to piece back together the root property
               once Velocity has updated one of its individually hooked values through tweening. */
            injectValue: function (fullHookName, hookValue, rootPropertyValue) {
                var hookData = CSS.Hooks.registered[fullHookName];

                if (hookData) {
                    var hookRoot = hookData[0],
                        hookPosition = hookData[1],
                        rootPropertyValueParts,
                        rootPropertyValueUpdated;

                    rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);

                    /* Split rootPropertyValue into its individual hook values, replace the targeted value with hookValue,
                       then reconstruct the rootPropertyValue string. */
                    rootPropertyValueParts = rootPropertyValue.toString().match(CSS.RegEx.valueSplit);
                    rootPropertyValueParts[hookPosition] = hookValue;
                    rootPropertyValueUpdated = rootPropertyValueParts.join(" ");

                    return rootPropertyValueUpdated;
                } else {
                    /* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
                    return rootPropertyValue;
                }
            }
        },

        /*******************
           Normalizations
        *******************/

        /* Normalizations standardize CSS property manipulation by pollyfilling browser-specific implementations (e.g. opacity)
           and reformatting special properties (e.g. clip, rgba) to look like standard ones. */
        Normalizations: {
            /* Normalizations are passed a normalization target (either the property's name, its extracted value, or its injected value),
               the targeted element (which may need to be queried), and the targeted property value. */
            registered: {
                clip: function (type, element, propertyValue) {
                    switch (type) {
                        case "name":
                            return "clip";
                        /* Clip needs to be unwrapped and stripped of its commas during extraction. */
                        case "extract":
                            var extracted;

                            /* If Velocity also extracted this value, skip extraction. */
                            if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
                                extracted = propertyValue;
                            } else {
                                /* Remove the "rect()" wrapper. */
                                extracted = propertyValue.toString().match(CSS.RegEx.valueUnwrap);

                                /* Strip off commas. */
                                extracted = extracted ? extracted[1].replace(/,(\s+)?/g, " ") : propertyValue;
                            }

                            return extracted;
                        /* Clip needs to be re-wrapped during injection. */
                        case "inject":
                            return "rect(" + propertyValue + ")";
                    }
                },

                blur: function(type, element, propertyValue) {
                    switch (type) {
                        case "name":
                            return Velocity.State.isFirefox ? "filter" : "-webkit-filter";
                        case "extract":
                            var extracted = parseFloat(propertyValue);

                            /* If extracted is NaN, meaning the value isn't already extracted. */
                            if (!(extracted || extracted === 0)) {
                                var blurComponent = propertyValue.toString().match(/blur\(([0-9]+[A-z]+)\)/i);

                                /* If the filter string had a blur component, return just the blur value and unit type. */
                                if (blurComponent) {
                                    extracted = blurComponent[1];
                                /* If the component doesn't exist, default blur to 0. */
                                } else {
                                    extracted = 0;
                                }
                            }

                            return extracted;
                        /* Blur needs to be re-wrapped during injection. */
                        case "inject":
                            /* For the blur effect to be fully de-applied, it needs to be set to "none" instead of 0. */
                            if (!parseFloat(propertyValue)) {
                                return "none";
                            } else {
                                return "blur(" + propertyValue + ")";
                            }
                    }
                },

                /* <=IE8 do not support the standard opacity property. They use filter:alpha(opacity=INT) instead. */
                opacity: function (type, element, propertyValue) {
                    if (IE <= 8) {
                        switch (type) {
                            case "name":
                                return "filter";
                            case "extract":
                                /* <=IE8 return a "filter" value of "alpha(opacity=\d{1,3})".
                                   Extract the value and convert it to a decimal value to match the standard CSS opacity property's formatting. */
                                var extracted = propertyValue.toString().match(/alpha\(opacity=(.*)\)/i);

                                if (extracted) {
                                    /* Convert to decimal value. */
                                    propertyValue = extracted[1] / 100;
                                } else {
                                    /* When extracting opacity, default to 1 since a null value means opacity hasn't been set. */
                                    propertyValue = 1;
                                }

                                return propertyValue;
                            case "inject":
                                /* Opacified elements are required to have their zoom property set to a non-zero value. */
                                element.style.zoom = 1;

                                /* Setting the filter property on elements with certain font property combinations can result in a
                                   highly unappealing ultra-bolding effect. There's no way to remedy this throughout a tween, but dropping the
                                   value altogether (when opacity hits 1) at leasts ensures that the glitch is gone post-tweening. */
                                if (parseFloat(propertyValue) >= 1) {
                                    return "";
                                } else {
                                  /* As per the filter property's spec, convert the decimal value to a whole number and wrap the value. */
                                  return "alpha(opacity=" + parseInt(parseFloat(propertyValue) * 100, 10) + ")";
                                }
                        }
                    /* With all other browsers, normalization is not required; return the same values that were passed in. */
                    } else {
                        switch (type) {
                            case "name":
                                return "opacity";
                            case "extract":
                                return propertyValue;
                            case "inject":
                                return propertyValue;
                        }
                    }
                }
            },

            /*****************************
                Batched Registrations
            *****************************/

            /* Note: Batched normalizations extend the CSS.Normalizations.registered object. */
            register: function () {

                /*****************
                    Transforms
                *****************/

                /* Transforms are the subproperties contained by the CSS "transform" property. Transforms must undergo normalization
                   so that they can be referenced in a properties map by their individual names. */
                /* Note: When transforms are "set", they are actually assigned to a per-element transformCache. When all transform
                   setting is complete complete, CSS.flushTransformCache() must be manually called to flush the values to the DOM.
                   Transform setting is batched in this way to improve performance: the transform style only needs to be updated
                   once when multiple transform subproperties are being animated simultaneously. */
                /* Note: IE9 and Android Gingerbread have support for 2D -- but not 3D -- transforms. Since animating unsupported
                   transform properties results in the browser ignoring the *entire* transform string, we prevent these 3D values
                   from being normalized for these browsers so that tweening skips these properties altogether
                   (since it will ignore them as being unsupported by the browser.) */
                if (!(IE <= 9) && !Velocity.State.isGingerbread) {
                    /* Note: Since the standalone CSS "perspective" property and the CSS transform "perspective" subproperty
                    share the same name, the latter is given a unique token within Velocity: "transformPerspective". */
                    CSS.Lists.transformsBase = CSS.Lists.transformsBase.concat(CSS.Lists.transforms3D);
                }

                for (var i = 0; i < CSS.Lists.transformsBase.length; i++) {
                    /* Wrap the dynamically generated normalization function in a new scope so that transformName's value is
                    paired with its respective function. (Otherwise, all functions would take the final for loop's transformName.) */
                    (function() {
                        var transformName = CSS.Lists.transformsBase[i];

                        CSS.Normalizations.registered[transformName] = function (type, element, propertyValue) {
                            switch (type) {
                                /* The normalized property name is the parent "transform" property -- the property that is actually set in CSS. */
                                case "name":
                                    return "transform";
                                /* Transform values are cached onto a per-element transformCache object. */
                                case "extract":
                                    /* If this transform has yet to be assigned a value, return its null value. */
                                    if (Data(element) === undefined || Data(element).transformCache[transformName] === undefined) {
                                        /* Scale CSS.Lists.transformsBase default to 1 whereas all other transform properties default to 0. */
                                        return /^scale/i.test(transformName) ? 1 : 0;
                                    /* When transform values are set, they are wrapped in parentheses as per the CSS spec.
                                       Thus, when extracting their values (for tween calculations), we strip off the parentheses. */
                                    } else {
                                        return Data(element).transformCache[transformName].replace(/[()]/g, "");
                                    }
                                case "inject":
                                    var invalid = false;

                                    /* If an individual transform property contains an unsupported unit type, the browser ignores the *entire* transform property.
                                       Thus, protect users from themselves by skipping setting for transform values supplied with invalid unit types. */
                                    /* Switch on the base transform type; ignore the axis by removing the last letter from the transform's name. */
                                    switch (transformName.substr(0, transformName.length - 1)) {
                                        /* Whitelist unit types for each transform. */
                                        case "translate":
                                            invalid = !/(%|px|em|rem|vw|vh|\d)$/i.test(propertyValue);
                                            break;
                                        /* Since an axis-free "scale" property is supported as well, a little hack is used here to detect it by chopping off its last letter. */
                                        case "scal":
                                        case "scale":
                                            /* Chrome on Android has a bug in which scaled elements blur if their initial scale
                                               value is below 1 (which can happen with forcefeeding). Thus, we detect a yet-unset scale property
                                               and ensure that its first value is always 1. More info: http://stackoverflow.com/questions/10417890/css3-animations-with-transform-causes-blurred-elements-on-webkit/10417962#10417962 */
                                            if (Velocity.State.isAndroid && Data(element).transformCache[transformName] === undefined && propertyValue < 1) {
                                                propertyValue = 1;
                                            }

                                            invalid = !/(\d)$/i.test(propertyValue);
                                            break;
                                        case "skew":
                                            invalid = !/(deg|\d)$/i.test(propertyValue);
                                            break;
                                        case "rotate":
                                            invalid = !/(deg|\d)$/i.test(propertyValue);
                                            break;
                                    }

                                    if (!invalid) {
                                        /* As per the CSS spec, wrap the value in parentheses. */
                                        Data(element).transformCache[transformName] = "(" + propertyValue + ")";
                                    }

                                    /* Although the value is set on the transformCache object, return the newly-updated value for the calling code to process as normal. */
                                    return Data(element).transformCache[transformName];
                            }
                        };
                    })();
                }

                /*************
                    Colors
                *************/

                /* Since Velocity only animates a single numeric value per property, color animation is achieved by hooking the individual RGBA components of CSS color properties.
                   Accordingly, color values must be normalized (e.g. "#ff0000", "red", and "rgb(255, 0, 0)" ==> "255 0 0 1") so that their components can be injected/extracted by CSS.Hooks logic. */
                for (var i = 0; i < CSS.Lists.colors.length; i++) {
                    /* Wrap the dynamically generated normalization function in a new scope so that colorName's value is paired with its respective function.
                       (Otherwise, all functions would take the final for loop's colorName.) */
                    (function () {
                        var colorName = CSS.Lists.colors[i];

                        /* Note: In IE<=8, which support rgb but not rgba, color properties are reverted to rgb by stripping off the alpha component. */
                        CSS.Normalizations.registered[colorName] = function(type, element, propertyValue) {
                            switch (type) {
                                case "name":
                                    return colorName;
                                /* Convert all color values into the rgb format. (Old IE can return hex values and color names instead of rgb/rgba.) */
                                case "extract":
                                    var extracted;

                                    /* If the color is already in its hookable form (e.g. "255 255 255 1") due to having been previously extracted, skip extraction. */
                                    if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
                                        extracted = propertyValue;
                                    } else {
                                        var converted,
                                            colorNames = {
                                                black: "rgb(0, 0, 0)",
                                                blue: "rgb(0, 0, 255)",
                                                gray: "rgb(128, 128, 128)",
                                                green: "rgb(0, 128, 0)",
                                                red: "rgb(255, 0, 0)",
                                                white: "rgb(255, 255, 255)"
                                            };

                                        /* Convert color names to rgb. */
                                        if (/^[A-z]+$/i.test(propertyValue)) {
                                            if (colorNames[propertyValue] !== undefined) {
                                                converted = colorNames[propertyValue]
                                            } else {
                                                /* If an unmatched color name is provided, default to black. */
                                                converted = colorNames.black;
                                            }
                                        /* Convert hex values to rgb. */
                                        } else if (CSS.RegEx.isHex.test(propertyValue)) {
                                            converted = "rgb(" + CSS.Values.hexToRgb(propertyValue).join(" ") + ")";
                                        /* If the provided color doesn't match any of the accepted color formats, default to black. */
                                        } else if (!(/^rgba?\(/i.test(propertyValue))) {
                                            converted = colorNames.black;
                                        }

                                        /* Remove the surrounding "rgb/rgba()" string then replace commas with spaces and strip
                                           repeated spaces (in case the value included spaces to begin with). */
                                        extracted = (converted || propertyValue).toString().match(CSS.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
                                    }

                                    /* So long as this isn't <=IE8, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
                                    if (!(IE <= 8) && extracted.split(" ").length === 3) {
                                        extracted += " 1";
                                    }

                                    return extracted;
                                case "inject":
                                    /* If this is IE<=8 and an alpha component exists, strip it off. */
                                    if (IE <= 8) {
                                        if (propertyValue.split(" ").length === 4) {
                                            propertyValue = propertyValue.split(/\s+/).slice(0, 3).join(" ");
                                        }
                                    /* Otherwise, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
                                    } else if (propertyValue.split(" ").length === 3) {
                                        propertyValue += " 1";
                                    }

                                    /* Re-insert the browser-appropriate wrapper("rgb/rgba()"), insert commas, and strip off decimal units
                                       on all values but the fourth (R, G, and B only accept whole numbers). */
                                    return (IE <= 8 ? "rgb" : "rgba") + "(" + propertyValue.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")";
                            }
                        };
                    })();
                }
            }
        },

        /************************
           CSS Property Names
        ************************/

        Names: {
            /* Camelcase a property name into its JavaScript notation (e.g. "background-color" ==> "backgroundColor").
               Camelcasing is used to normalize property names between and across calls. */
            camelCase: function (property) {
                return property.replace(/-(\w)/g, function (match, subMatch) {
                    return subMatch.toUpperCase();
                });
            },

            /* For SVG elements, some properties (namely, dimensional ones) are GET/SET via the element's HTML attributes (instead of via CSS styles). */
            SVGAttribute: function (property) {
                var SVGAttributes = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";

                /* Certain browsers require an SVG transform to be applied as an attribute. (Otherwise, application via CSS is preferable due to 3D support.) */
                if (IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) {
                    SVGAttributes += "|transform";
                }

                return new RegExp("^(" + SVGAttributes + ")$", "i").test(property);
            },

            /* Determine whether a property should be set with a vendor prefix. */
            /* If a prefixed version of the property exists, return it. Otherwise, return the original property name.
               If the property is not at all supported by the browser, return a false flag. */
            prefixCheck: function (property) {
                /* If this property has already been checked, return the cached value. */
                if (Velocity.State.prefixMatches[property]) {
                    return [ Velocity.State.prefixMatches[property], true ];
                } else {
                    var vendors = [ "", "Webkit", "Moz", "ms", "O" ];

                    for (var i = 0, vendorsLength = vendors.length; i < vendorsLength; i++) {
                        var propertyPrefixed;

                        if (i === 0) {
                            propertyPrefixed = property;
                        } else {
                            /* Capitalize the first letter of the property to conform to JavaScript vendor prefix notation (e.g. webkitFilter). */
                            propertyPrefixed = vendors[i] + property.replace(/^\w/, function(match) { return match.toUpperCase(); });
                        }

                        /* Check if the browser supports this property as prefixed. */
                        if (Type.isString(Velocity.State.prefixElement.style[propertyPrefixed])) {
                            /* Cache the match. */
                            Velocity.State.prefixMatches[property] = propertyPrefixed;

                            return [ propertyPrefixed, true ];
                        }
                    }

                    /* If the browser doesn't support this property in any form, include a false flag so that the caller can decide how to proceed. */
                    return [ property, false ];
                }
            }
        },

        /************************
           CSS Property Values
        ************************/

        Values: {
            /* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
            hexToRgb: function (hex) {
                var shortformRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
                    longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
                    rgbParts;

                hex = hex.replace(shortformRegex, function (m, r, g, b) {
                    return r + r + g + g + b + b;
                });

                rgbParts = longformRegex.exec(hex);

                return rgbParts ? [ parseInt(rgbParts[1], 16), parseInt(rgbParts[2], 16), parseInt(rgbParts[3], 16) ] : [ 0, 0, 0 ];
            },

            isCSSNullValue: function (value) {
                /* The browser defaults CSS values that have not been set to either 0 or one of several possible null-value strings.
                   Thus, we check for both falsiness and these special strings. */
                /* Null-value checking is performed to default the special strings to 0 (for the sake of tweening) or their hook
                   templates as defined as CSS.Hooks (for the sake of hook injection/extraction). */
                /* Note: Chrome returns "rgba(0, 0, 0, 0)" for an undefined color whereas IE returns "transparent". */
                return (value == 0 || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(value));
            },

            /* Retrieve a property's default unit type. Used for assigning a unit type when one is not supplied by the user. */
            getUnitType: function (property) {
                if (/^(rotate|skew)/i.test(property)) {
                    return "deg";
                } else if (/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(property)) {
                    /* The above properties are unitless. */
                    return "";
                } else {
                    /* Default to px for all other properties. */
                    return "px";
                }
            },

            /* HTML elements default to an associated display type when they're not set to display:none. */
            /* Note: This function is used for correctly setting the non-"none" display value in certain Velocity redirects, such as fadeIn/Out. */
            getDisplayType: function (element) {
                var tagName = element && element.tagName.toString().toLowerCase();

                if (/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(tagName)) {
                    return "inline";
                } else if (/^(li)$/i.test(tagName)) {
                    return "list-item";
                } else if (/^(tr)$/i.test(tagName)) {
                    return "table-row";
                } else if (/^(table)$/i.test(tagName)) {
                    return "table";
                } else if (/^(tbody)$/i.test(tagName)) {
                    return "table-row-group";
                /* Default to "block" when no match is found. */
                } else {
                    return "block";
                }
            },

            /* The class add/remove functions are used to temporarily apply a "velocity-animating" class to elements while they're animating. */
            addClass: function (element, className) {
                if (element.classList) {
                    element.classList.add(className);
                } else {
                    element.className += (element.className.length ? " " : "") + className;
                }
            },

            removeClass: function (element, className) {
                if (element.classList) {
                    element.classList.remove(className);
                } else {
                    element.className = element.className.toString().replace(new RegExp("(^|\\s)" + className.split(" ").join("|") + "(\\s|$)", "gi"), " ");
                }
            }
        },

        /****************************
           Style Getting & Setting
        ****************************/

        /* The singular getPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
        getPropertyValue: function (element, property, rootPropertyValue, forceStyleLookup) {
            /* Get an element's computed property value. */
            /* Note: Retrieving the value of a CSS property cannot simply be performed by checking an element's
               style attribute (which only reflects user-defined values). Instead, the browser must be queried for a property's
               *computed* value. You can read more about getComputedStyle here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
            function computePropertyValue (element, property) {
                /* When box-sizing isn't set to border-box, height and width style values are incorrectly computed when an
                   element's scrollbars are visible (which expands the element's dimensions). Thus, we defer to the more accurate
                   offsetHeight/Width property, which includes the total dimensions for interior, border, padding, and scrollbar.
                   We subtract border and padding to get the sum of interior + scrollbar. */
                var computedValue = 0;

                /* IE<=8 doesn't support window.getComputedStyle, thus we defer to jQuery, which has an extensive array
                   of hacks to accurately retrieve IE8 property values. Re-implementing that logic here is not worth bloating the
                   codebase for a dying browser. The performance repercussions of using jQuery here are minimal since
                   Velocity is optimized to rarely (and sometimes never) query the DOM. Further, the $.css() codepath isn't that slow. */
                if (IE <= 8) {
                    computedValue = $.css(element, property); /* GET */
                /* All other browsers support getComputedStyle. The returned live object reference is cached onto its
                   associated element so that it does not need to be refetched upon every GET. */
                } else {
                    /* Browsers do not return height and width values for elements that are set to display:"none". Thus, we temporarily
                       toggle display to the element type's default value. */
                    var toggleDisplay = false;

                    if (/^(width|height)$/.test(property) && CSS.getPropertyValue(element, "display") === 0) {
                        toggleDisplay = true;
                        CSS.setPropertyValue(element, "display", CSS.Values.getDisplayType(element));
                    }

                    function revertDisplay () {
                        if (toggleDisplay) {
                            CSS.setPropertyValue(element, "display", "none");
                        }
                    }

                    if (!forceStyleLookup) {
                        if (property === "height" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
                            var contentBoxHeight = element.offsetHeight - (parseFloat(CSS.getPropertyValue(element, "borderTopWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderBottomWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingTop")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingBottom")) || 0);
                            revertDisplay();

                            return contentBoxHeight;
                        } else if (property === "width" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
                            var contentBoxWidth = element.offsetWidth - (parseFloat(CSS.getPropertyValue(element, "borderLeftWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderRightWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingLeft")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingRight")) || 0);
                            revertDisplay();

                            return contentBoxWidth;
                        }
                    }

                    var computedStyle;

                    /* For elements that Velocity hasn't been called on directly (e.g. when Velocity queries the DOM on behalf
                       of a parent of an element its animating), perform a direct getComputedStyle lookup since the object isn't cached. */
                    if (Data(element) === undefined) {
                        computedStyle = window.getComputedStyle(element, null); /* GET */
                    /* If the computedStyle object has yet to be cached, do so now. */
                    } else if (!Data(element).computedStyle) {
                        computedStyle = Data(element).computedStyle = window.getComputedStyle(element, null); /* GET */
                    /* If computedStyle is cached, use it. */
                    } else {
                        computedStyle = Data(element).computedStyle;
                    }

                    /* IE and Firefox do not return a value for the generic borderColor -- they only return individual values for each border side's color.
                       Also, in all browsers, when border colors aren't all the same, a compound value is returned that Velocity isn't setup to parse.
                       So, as a polyfill for querying individual border side colors, we just return the top border's color and animate all borders from that value. */
                    if (property === "borderColor") {
                        property = "borderTopColor";
                    }

                    /* IE9 has a bug in which the "filter" property must be accessed from computedStyle using the getPropertyValue method
                       instead of a direct property lookup. The getPropertyValue method is slower than a direct lookup, which is why we avoid it by default. */
                    if (IE === 9 && property === "filter") {
                        computedValue = computedStyle.getPropertyValue(property); /* GET */
                    } else {
                        computedValue = computedStyle[property];
                    }

                    /* Fall back to the property's style value (if defined) when computedValue returns nothing,
                       which can happen when the element hasn't been painted. */
                    if (computedValue === "" || computedValue === null) {
                        computedValue = element.style[property];
                    }

                    revertDisplay();
                }

                /* For top, right, bottom, and left (TRBL) values that are set to "auto" on elements of "fixed" or "absolute" position,
                   defer to jQuery for converting "auto" to a numeric value. (For elements with a "static" or "relative" position, "auto" has the same
                   effect as being set to 0, so no conversion is necessary.) */
                /* An example of why numeric conversion is necessary: When an element with "position:absolute" has an untouched "left"
                   property, which reverts to "auto", left's value is 0 relative to its parent element, but is often non-zero relative
                   to its *containing* (not parent) element, which is the nearest "position:relative" ancestor or the viewport (and always the viewport in the case of "position:fixed"). */
                if (computedValue === "auto" && /^(top|right|bottom|left)$/i.test(property)) {
                    var position = computePropertyValue(element, "position"); /* GET */

                    /* For absolute positioning, jQuery's $.position() only returns values for top and left;
                       right and bottom will have their "auto" value reverted to 0. */
                    /* Note: A jQuery object must be created here since jQuery doesn't have a low-level alias for $.position().
                       Not a big deal since we're currently in a GET batch anyway. */
                    if (position === "fixed" || (position === "absolute" && /top|left/i.test(property))) {
                        /* Note: jQuery strips the pixel unit from its returned values; we re-add it here to conform with computePropertyValue's behavior. */
                        computedValue = $(element).position()[property] + "px"; /* GET */
                    }
                }

                return computedValue;
            }

            var propertyValue;

            /* If this is a hooked property (e.g. "clipLeft" instead of the root property of "clip"),
               extract the hook's value from a normalized rootPropertyValue using CSS.Hooks.extractValue(). */
            if (CSS.Hooks.registered[property]) {
                var hook = property,
                    hookRoot = CSS.Hooks.getRoot(hook);

                /* If a cached rootPropertyValue wasn't passed in (which Velocity always attempts to do in order to avoid requerying the DOM),
                   query the DOM for the root property's value. */
                if (rootPropertyValue === undefined) {
                    /* Since the browser is now being directly queried, use the official post-prefixing property name for this lookup. */
                    rootPropertyValue = CSS.getPropertyValue(element, CSS.Names.prefixCheck(hookRoot)[0]); /* GET */
                }

                /* If this root has a normalization registered, peform the associated normalization extraction. */
                if (CSS.Normalizations.registered[hookRoot]) {
                    rootPropertyValue = CSS.Normalizations.registered[hookRoot]("extract", element, rootPropertyValue);
                }

                /* Extract the hook's value. */
                propertyValue = CSS.Hooks.extractValue(hook, rootPropertyValue);

            /* If this is a normalized property (e.g. "opacity" becomes "filter" in <=IE8) or "translateX" becomes "transform"),
               normalize the property's name and value, and handle the special case of transforms. */
            /* Note: Normalizing a property is mutually exclusive from hooking a property since hook-extracted values are strictly
               numerical and therefore do not require normalization extraction. */
            } else if (CSS.Normalizations.registered[property]) {
                var normalizedPropertyName,
                    normalizedPropertyValue;

                normalizedPropertyName = CSS.Normalizations.registered[property]("name", element);

                /* Transform values are calculated via normalization extraction (see below), which checks against the element's transformCache.
                   At no point do transform GETs ever actually query the DOM; initial stylesheet values are never processed.
                   This is because parsing 3D transform matrices is not always accurate and would bloat our codebase;
                   thus, normalization extraction defaults initial transform values to their zero-values (e.g. 1 for scaleX and 0 for translateX). */
                if (normalizedPropertyName !== "transform") {
                    normalizedPropertyValue = computePropertyValue(element, CSS.Names.prefixCheck(normalizedPropertyName)[0]); /* GET */

                    /* If the value is a CSS null-value and this property has a hook template, use that zero-value template so that hooks can be extracted from it. */
                    if (CSS.Values.isCSSNullValue(normalizedPropertyValue) && CSS.Hooks.templates[property]) {
                        normalizedPropertyValue = CSS.Hooks.templates[property][1];
                    }
                }

                propertyValue = CSS.Normalizations.registered[property]("extract", element, normalizedPropertyValue);
            }

            /* If a (numeric) value wasn't produced via hook extraction or normalization, query the DOM. */
            if (!/^[\d-]/.test(propertyValue)) {
                /* For SVG elements, dimensional properties (which SVGAttribute() detects) are tweened via
                   their HTML attribute values instead of their CSS style values. */
                if (Data(element) && Data(element).isSVG && CSS.Names.SVGAttribute(property)) {
                    /* Since the height/width attribute values must be set manually, they don't reflect computed values.
                       Thus, we use use getBBox() to ensure we always get values for elements with undefined height/width attributes. */
                    if (/^(height|width)$/i.test(property)) {
                        /* Firefox throws an error if .getBBox() is called on an SVG that isn't attached to the DOM. */
                        try {
                            propertyValue = element.getBBox()[property];
                        } catch (error) {
                            propertyValue = 0;
                        }
                    /* Otherwise, access the attribute value directly. */
                    } else {
                        propertyValue = element.getAttribute(property);
                    }
                } else {
                    propertyValue = computePropertyValue(element, CSS.Names.prefixCheck(property)[0]); /* GET */
                }
            }

            /* Since property lookups are for animation purposes (which entails computing the numeric delta between start and end values),
               convert CSS null-values to an integer of value 0. */
            if (CSS.Values.isCSSNullValue(propertyValue)) {
                propertyValue = 0;
            }

            if (Velocity.debug >= 2) console.log("Get " + property + ": " + propertyValue);

            return propertyValue;
        },

        /* The singular setPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
        setPropertyValue: function(element, property, propertyValue, rootPropertyValue, scrollData) {
            var propertyName = property;

            /* In order to be subjected to call options and element queueing, scroll animation is routed through Velocity as if it were a standard CSS property. */
            if (property === "scroll") {
                /* If a container option is present, scroll the container instead of the browser window. */
                if (scrollData.container) {
                    scrollData.container["scroll" + scrollData.direction] = propertyValue;
                /* Otherwise, Velocity defaults to scrolling the browser window. */
                } else {
                    if (scrollData.direction === "Left") {
                        window.scrollTo(propertyValue, scrollData.alternateValue);
                    } else {
                        window.scrollTo(scrollData.alternateValue, propertyValue);
                    }
                }
            } else {
                /* Transforms (translateX, rotateZ, etc.) are applied to a per-element transformCache object, which is manually flushed via flushTransformCache().
                   Thus, for now, we merely cache transforms being SET. */
                if (CSS.Normalizations.registered[property] && CSS.Normalizations.registered[property]("name", element) === "transform") {
                    /* Perform a normalization injection. */
                    /* Note: The normalization logic handles the transformCache updating. */
                    CSS.Normalizations.registered[property]("inject", element, propertyValue);

                    propertyName = "transform";
                    propertyValue = Data(element).transformCache[property];
                } else {
                    /* Inject hooks. */
                    if (CSS.Hooks.registered[property]) {
                        var hookName = property,
                            hookRoot = CSS.Hooks.getRoot(property);

                        /* If a cached rootPropertyValue was not provided, query the DOM for the hookRoot's current value. */
                        rootPropertyValue = rootPropertyValue || CSS.getPropertyValue(element, hookRoot); /* GET */

                        propertyValue = CSS.Hooks.injectValue(hookName, propertyValue, rootPropertyValue);
                        property = hookRoot;
                    }

                    /* Normalize names and values. */
                    if (CSS.Normalizations.registered[property]) {
                        propertyValue = CSS.Normalizations.registered[property]("inject", element, propertyValue);
                        property = CSS.Normalizations.registered[property]("name", element);
                    }

                    /* Assign the appropriate vendor prefix before performing an official style update. */
                    propertyName = CSS.Names.prefixCheck(property)[0];

                    /* A try/catch is used for IE<=8, which throws an error when "invalid" CSS values are set, e.g. a negative width.
                       Try/catch is avoided for other browsers since it incurs a performance overhead. */
                    if (IE <= 8) {
                        try {
                            element.style[propertyName] = propertyValue;
                        } catch (error) { if (Velocity.debug) console.log("Browser does not support [" + propertyValue + "] for [" + propertyName + "]"); }
                    /* SVG elements have their dimensional properties (width, height, x, y, cx, etc.) applied directly as attributes instead of as styles. */
                    /* Note: IE8 does not support SVG elements, so it's okay that we skip it for SVG animation. */
                    } else if (Data(element) && Data(element).isSVG && CSS.Names.SVGAttribute(property)) {
                        /* Note: For SVG attributes, vendor-prefixed property names are never used. */
                        /* Note: Not all CSS properties can be animated via attributes, but the browser won't throw an error for unsupported properties. */
                        element.setAttribute(property, propertyValue);
                    } else {
                        element.style[propertyName] = propertyValue;
                    }

                    if (Velocity.debug >= 2) console.log("Set " + property + " (" + propertyName + "): " + propertyValue);
                }
            }

            /* Return the normalized property name and value in case the caller wants to know how these values were modified before being applied to the DOM. */
            return [ propertyName, propertyValue ];
        },

        /* To increase performance by batching transform updates into a single SET, transforms are not directly applied to an element until flushTransformCache() is called. */
        /* Note: Velocity applies transform properties in the same order that they are chronogically introduced to the element's CSS styles. */
        flushTransformCache: function(element) {
            var transformString = "";

            /* Certain browsers require that SVG transforms be applied as an attribute. However, the SVG transform attribute takes a modified version of CSS's transform string
               (units are dropped and, except for skewX/Y, subproperties are merged into their master property -- e.g. scaleX and scaleY are merged into scale(X Y). */
            if ((IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) && Data(element).isSVG) {
                /* Since transform values are stored in their parentheses-wrapped form, we use a helper function to strip out their numeric values.
                   Further, SVG transform properties only take unitless (representing pixels) values, so it's okay that parseFloat() strips the unit suffixed to the float value. */
                function getTransformFloat (transformProperty) {
                    return parseFloat(CSS.getPropertyValue(element, transformProperty));
                }

                /* Create an object to organize all the transforms that we'll apply to the SVG element. To keep the logic simple,
                   we process *all* transform properties -- even those that may not be explicitly applied (since they default to their zero-values anyway). */
                var SVGTransforms = {
                    translate: [ getTransformFloat("translateX"), getTransformFloat("translateY") ],
                    skewX: [ getTransformFloat("skewX") ], skewY: [ getTransformFloat("skewY") ],
                    /* If the scale property is set (non-1), use that value for the scaleX and scaleY values
                       (this behavior mimics the result of animating all these properties at once on HTML elements). */
                    scale: getTransformFloat("scale") !== 1 ? [ getTransformFloat("scale"), getTransformFloat("scale") ] : [ getTransformFloat("scaleX"), getTransformFloat("scaleY") ],
                    /* Note: SVG's rotate transform takes three values: rotation degrees followed by the X and Y values
                       defining the rotation's origin point. We ignore the origin values (default them to 0). */
                    rotate: [ getTransformFloat("rotateZ"), 0, 0 ]
                };

                /* Iterate through the transform properties in the user-defined property map order.
                   (This mimics the behavior of non-SVG transform animation.) */
                $.each(Data(element).transformCache, function(transformName) {
                    /* Except for with skewX/Y, revert the axis-specific transform subproperties to their axis-free master
                       properties so that they match up with SVG's accepted transform properties. */
                    if (/^translate/i.test(transformName)) {
                        transformName = "translate";
                    } else if (/^scale/i.test(transformName)) {
                        transformName = "scale";
                    } else if (/^rotate/i.test(transformName)) {
                        transformName = "rotate";
                    }

                    /* Check that we haven't yet deleted the property from the SVGTransforms container. */
                    if (SVGTransforms[transformName]) {
                        /* Append the transform property in the SVG-supported transform format. As per the spec, surround the space-delimited values in parentheses. */
                        transformString += transformName + "(" + SVGTransforms[transformName].join(" ") + ")" + " ";

                        /* After processing an SVG transform property, delete it from the SVGTransforms container so we don't
                           re-insert the same master property if we encounter another one of its axis-specific properties. */
                        delete SVGTransforms[transformName];
                    }
                });
            } else {
                var transformValue,
                    perspective;

                /* Transform properties are stored as members of the transformCache object. Concatenate all the members into a string. */
                $.each(Data(element).transformCache, function(transformName) {
                    transformValue = Data(element).transformCache[transformName];

                    /* Transform's perspective subproperty must be set first in order to take effect. Store it temporarily. */
                    if (transformName === "transformPerspective") {
                        perspective = transformValue;
                        return true;
                    }

                    /* IE9 only supports one rotation type, rotateZ, which it refers to as "rotate". */
                    if (IE === 9 && transformName === "rotateZ") {
                        transformName = "rotate";
                    }

                    transformString += transformName + transformValue + " ";
                });

                /* If present, set the perspective subproperty first. */
                if (perspective) {
                    transformString = "perspective" + perspective + " " + transformString;
                }
            }

            CSS.setPropertyValue(element, "transform", transformString);
        }
    };

    /* Register hooks and normalizations. */
    CSS.Hooks.register();
    CSS.Normalizations.register();

    /* Allow hook setting in the same fashion as jQuery's $.css(). */
    Velocity.hook = function (elements, arg2, arg3) {
        var value = undefined;

        elements = sanitizeElements(elements);

        $.each(elements, function(i, element) {
            /* Initialize Velocity's per-element data cache if this element hasn't previously been animated. */
            if (Data(element) === undefined) {
                Velocity.init(element);
            }

            /* Get property value. If an element set was passed in, only return the value for the first element. */
            if (arg3 === undefined) {
                if (value === undefined) {
                    value = Velocity.CSS.getPropertyValue(element, arg2);
                }
            /* Set property value. */
            } else {
                /* sPV returns an array of the normalized propertyName/propertyValue pair used to update the DOM. */
                var adjustedSet = Velocity.CSS.setPropertyValue(element, arg2, arg3);

                /* Transform properties don't automatically set. They have to be flushed to the DOM. */
                if (adjustedSet[0] === "transform") {
                    Velocity.CSS.flushTransformCache(element);
                }

                value = adjustedSet;
            }
        });

        return value;
    };

    /*****************
        Animation
    *****************/

    var animate = function() {

        /******************
            Call Chain
        ******************/

        /* Logic for determining what to return to the call stack when exiting out of Velocity. */
        function getChain () {
            /* If we are using the utility function, attempt to return this call's promise. If no promise library was detected,
               default to null instead of returning the targeted elements so that utility function's return value is standardized. */
            if (isUtility) {
                return promiseData.promise || null;
            /* Otherwise, if we're using $.fn, return the jQuery-/Zepto-wrapped element set. */
            } else {
                return elementsWrapped;
            }
        }

        /*************************
           Arguments Assignment
        *************************/

        /* To allow for expressive CoffeeScript code, Velocity supports an alternative syntax in which "elements" (or "e"), "properties" (or "p"), and "options" (or "o")
           objects are defined on a container object that's passed in as Velocity's sole argument. */
        /* Note: Some browsers automatically populate arguments with a "properties" object. We detect it by checking for its default "names" property. */
        var syntacticSugar = (arguments[0] && (arguments[0].p || (($.isPlainObject(arguments[0].properties) && !arguments[0].properties.names) || Type.isString(arguments[0].properties)))),
            /* Whether Velocity was called via the utility function (as opposed to on a jQuery/Zepto object). */
            isUtility,
            /* When Velocity is called via the utility function ($.Velocity()/Velocity()), elements are explicitly
               passed in as the first parameter. Thus, argument positioning varies. We normalize them here. */
            elementsWrapped,
            argumentIndex;

        var elements,
            propertiesMap,
            options;

        /* Detect jQuery/Zepto elements being animated via the $.fn method. */
        if (Type.isWrapped(this)) {
            isUtility = false;

            argumentIndex = 0;
            elements = this;
            elementsWrapped = this;
        /* Otherwise, raw elements are being animated via the utility function. */
        } else {
            isUtility = true;

            argumentIndex = 1;
            elements = syntacticSugar ? (arguments[0].elements || arguments[0].e) : arguments[0];
        }

        elements = sanitizeElements(elements);

        if (!elements) {
            return;
        }

        if (syntacticSugar) {
            propertiesMap = arguments[0].properties || arguments[0].p;
            options = arguments[0].options || arguments[0].o;
        } else {
            propertiesMap = arguments[argumentIndex];
            options = arguments[argumentIndex + 1];
        }

        /* The length of the element set (in the form of a nodeList or an array of elements) is defaulted to 1 in case a
           single raw DOM element is passed in (which doesn't contain a length property). */
        var elementsLength = elements.length,
            elementsIndex = 0;

        /***************************
            Argument Overloading
        ***************************/

        /* Support is included for jQuery's argument overloading: $.animate(propertyMap [, duration] [, easing] [, complete]).
           Overloading is detected by checking for the absence of an object being passed into options. */
        /* Note: The stop and finish actions do not accept animation options, and are therefore excluded from this check. */
        if (!/^(stop|finish|finishAll)$/i.test(propertiesMap) && !$.isPlainObject(options)) {
            /* The utility function shifts all arguments one position to the right, so we adjust for that offset. */
            var startingArgumentPosition = argumentIndex + 1;

            options = {};

            /* Iterate through all options arguments */
            for (var i = startingArgumentPosition; i < arguments.length; i++) {
                /* Treat a number as a duration. Parse it out. */
                /* Note: The following RegEx will return true if passed an array with a number as its first item.
                   Thus, arrays are skipped from this check. */
                if (!Type.isArray(arguments[i]) && (/^(fast|normal|slow)$/i.test(arguments[i]) || /^\d/.test(arguments[i]))) {
                    options.duration = arguments[i];
                /* Treat strings and arrays as easings. */
                } else if (Type.isString(arguments[i]) || Type.isArray(arguments[i])) {
                    options.easing = arguments[i];
                /* Treat a function as a complete callback. */
                } else if (Type.isFunction(arguments[i])) {
                    options.complete = arguments[i];
                }
            }
        }

        /***************
            Promises
        ***************/

        var promiseData = {
                promise: null,
                resolver: null,
                rejecter: null
            };

        /* If this call was made via the utility function (which is the default method of invocation when jQuery/Zepto are not being used), and if
           promise support was detected, create a promise object for this call and store references to its resolver and rejecter methods. The resolve
           method is used when a call completes naturally or is prematurely stopped by the user. In both cases, completeCall() handles the associated
           call cleanup and promise resolving logic. The reject method is used when an invalid set of arguments is passed into a Velocity call. */
        /* Note: Velocity employs a call-based queueing architecture, which means that stopping an animating element actually stops the full call that
           triggered it -- not that one element exclusively. Similarly, there is one promise per call, and all elements targeted by a Velocity call are
           grouped together for the purposes of resolving and rejecting a promise. */
        if (isUtility && Velocity.Promise) {
            promiseData.promise = new Velocity.Promise(function (resolve, reject) {
                promiseData.resolver = resolve;
                promiseData.rejecter = reject;
            });
        }

        /*********************
           Action Detection
        *********************/

        /* Velocity's behavior is categorized into "actions": Elements can either be specially scrolled into view,
           or they can be started, stopped, or reversed. If a literal or referenced properties map is passed in as Velocity's
           first argument, the associated action is "start". Alternatively, "scroll", "reverse", or "stop" can be passed in instead of a properties map. */
        var action;

        switch (propertiesMap) {
            case "scroll":
                action = "scroll";
                break;

            case "reverse":
                action = "reverse";
                break;

            case "finish":
            case "finishAll":
            case "stop":
                /*******************
                    Action: Stop
                *******************/

                /* Clear the currently-active delay on each targeted element. */
                $.each(elements, function(i, element) {
                    if (Data(element) && Data(element).delayTimer) {
                        /* Stop the timer from triggering its cached next() function. */
                        clearTimeout(Data(element).delayTimer.setTimeout);

                        /* Manually call the next() function so that the subsequent queue items can progress. */
                        if (Data(element).delayTimer.next) {
                            Data(element).delayTimer.next();
                        }

                        delete Data(element).delayTimer;
                    }

                    /* If we want to finish everything in the queue, we have to iterate through it
                       and call each function. This will make them active calls below, which will
                       cause them to be applied via the duration setting. */
                    if (propertiesMap === "finishAll" && (options === true || Type.isString(options))) {
                        /* Iterate through the items in the element's queue. */
                        $.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
                            /* The queue array can contain an "inprogress" string, which we skip. */
                            if (Type.isFunction(item)) {
                                item();
                            }
                        });

                        /* Clearing the $.queue() array is achieved by resetting it to []. */
                        $.queue(element, Type.isString(options) ? options : "", []);
                    }
                });

                var callsToStop = [];

                /* When the stop action is triggered, the elements' currently active call is immediately stopped. The active call might have
                   been applied to multiple elements, in which case all of the call's elements will be stopped. When an element
                   is stopped, the next item in its animation queue is immediately triggered. */
                /* An additional argument may be passed in to clear an element's remaining queued calls. Either true (which defaults to the "fx" queue)
                   or a custom queue string can be passed in. */
                /* Note: The stop command runs prior to Velocity's Queueing phase since its behavior is intended to take effect *immediately*,
                   regardless of the element's current queue state. */

                /* Iterate through every active call. */
                $.each(Velocity.State.calls, function(i, activeCall) {
                    /* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
                    if (activeCall) {
                        /* Iterate through the active call's targeted elements. */
                        $.each(activeCall[1], function(k, activeElement) {
                            /* If true was passed in as a secondary argument, clear absolutely all calls on this element. Otherwise, only
                               clear calls associated with the relevant queue. */
                            /* Call stopping logic works as follows:
                               - options === true --> stop current default queue calls (and queue:false calls), including remaining queued ones.
                               - options === undefined --> stop current queue:"" call and all queue:false calls.
                               - options === false --> stop only queue:false calls.
                               - options === "custom" --> stop current queue:"custom" call, including remaining queued ones (there is no functionality to only clear the currently-running queue:"custom" call). */
                            var queueName = (options === undefined) ? "" : options;

                            if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
                                return true;
                            }

                            /* Iterate through the calls targeted by the stop command. */
                            $.each(elements, function(l, element) {
                                /* Check that this call was applied to the target element. */
                                if (element === activeElement) {
                                    /* Optionally clear the remaining queued calls. If we're doing "finishAll" this won't find anything,
                                       due to the queue-clearing above. */
                                    if (options === true || Type.isString(options)) {
                                        /* Iterate through the items in the element's queue. */
                                        $.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
                                            /* The queue array can contain an "inprogress" string, which we skip. */
                                            if (Type.isFunction(item)) {
                                                /* Pass the item's callback a flag indicating that we want to abort from the queue call.
                                                   (Specifically, the queue will resolve the call's associated promise then abort.)  */
                                                item(null, true);
                                            }
                                        });

                                        /* Clearing the $.queue() array is achieved by resetting it to []. */
                                        $.queue(element, Type.isString(options) ? options : "", []);
                                    }

                                    if (propertiesMap === "stop") {
                                        /* Since "reverse" uses cached start values (the previous call's endValues), these values must be
                                           changed to reflect the final value that the elements were actually tweened to. */
                                        /* Note: If only queue:false animations are currently running on an element, it won't have a tweensContainer
                                           object. Also, queue:false animations can't be reversed. */
                                        if (Data(element) && Data(element).tweensContainer && queueName !== false) {
                                            $.each(Data(element).tweensContainer, function(m, activeTween) {
                                                activeTween.endValue = activeTween.currentValue;
                                            });
                                        }

                                        callsToStop.push(i);
                                    } else if (propertiesMap === "finish" || propertiesMap === "finishAll") {
                                        /* To get active tweens to finish immediately, we forcefully shorten their durations to 1ms so that
                                        they finish upon the next rAf tick then proceed with normal call completion logic. */
                                        activeCall[2].duration = 1;
                                    }
                                }
                            });
                        });
                    }
                });

                /* Prematurely call completeCall() on each matched active call. Pass an additional flag for "stop" to indicate
                   that the complete callback and display:none setting should be skipped since we're completing prematurely. */
                if (propertiesMap === "stop") {
                    $.each(callsToStop, function(i, j) {
                        completeCall(j, true);
                    });

                    if (promiseData.promise) {
                        /* Immediately resolve the promise associated with this stop call since stop runs synchronously. */
                        promiseData.resolver(elements);
                    }
                }

                /* Since we're stopping, and not proceeding with queueing, exit out of Velocity. */
                return getChain();

            default:
                /* Treat a non-empty plain object as a literal properties map. */
                if ($.isPlainObject(propertiesMap) && !Type.isEmptyObject(propertiesMap)) {
                    action = "start";

                /****************
                    Redirects
                ****************/

                /* Check if a string matches a registered redirect (see Redirects above). */
                } else if (Type.isString(propertiesMap) && Velocity.Redirects[propertiesMap]) {
                    var opts = $.extend({}, options),
                        durationOriginal = opts.duration,
                        delayOriginal = opts.delay || 0;

                    /* If the backwards option was passed in, reverse the element set so that elements animate from the last to the first. */
                    if (opts.backwards === true) {
                        elements = $.extend(true, [], elements).reverse();
                    }

                    /* Individually trigger the redirect for each element in the set to prevent users from having to handle iteration logic in their redirect. */
                    $.each(elements, function(elementIndex, element) {
                        /* If the stagger option was passed in, successively delay each element by the stagger value (in ms). Retain the original delay value. */
                        if (parseFloat(opts.stagger)) {
                            opts.delay = delayOriginal + (parseFloat(opts.stagger) * elementIndex);
                        } else if (Type.isFunction(opts.stagger)) {
                            opts.delay = delayOriginal + opts.stagger.call(element, elementIndex, elementsLength);
                        }

                        /* If the drag option was passed in, successively increase/decrease (depending on the presense of opts.backwards)
                           the duration of each element's animation, using floors to prevent producing very short durations. */
                        if (opts.drag) {
                            /* Default the duration of UI pack effects (callouts and transitions) to 1000ms instead of the usual default duration of 400ms. */
                            opts.duration = parseFloat(durationOriginal) || (/^(callout|transition)/.test(propertiesMap) ? 1000 : DURATION_DEFAULT);

                            /* For each element, take the greater duration of: A) animation completion percentage relative to the original duration,
                               B) 75% of the original duration, or C) a 200ms fallback (in case duration is already set to a low value).
                               The end result is a baseline of 75% of the redirect's duration that increases/decreases as the end of the element set is approached. */
                            opts.duration = Math.max(opts.duration * (opts.backwards ? 1 - elementIndex/elementsLength : (elementIndex + 1) / elementsLength), opts.duration * 0.75, 200);
                        }

                        /* Pass in the call's opts object so that the redirect can optionally extend it. It defaults to an empty object instead of null to
                           reduce the opts checking logic required inside the redirect. */
                        Velocity.Redirects[propertiesMap].call(element, element, opts || {}, elementIndex, elementsLength, elements, promiseData.promise ? promiseData : undefined);
                    });

                    /* Since the animation logic resides within the redirect's own code, abort the remainder of this call.
                       (The performance overhead up to this point is virtually non-existant.) */
                    /* Note: The jQuery call chain is kept intact by returning the complete element set. */
                    return getChain();
                } else {
                    var abortError = "Velocity: First argument (" + propertiesMap + ") was not a property map, a known action, or a registered redirect. Aborting.";

                    if (promiseData.promise) {
                        promiseData.rejecter(new Error(abortError));
                    } else {
                        console.log(abortError);
                    }

                    return getChain();
                }
        }

        /**************************
            Call-Wide Variables
        **************************/

        /* A container for CSS unit conversion ratios (e.g. %, rem, and em ==> px) that is used to cache ratios across all elements
           being animated in a single Velocity call. Calculating unit ratios necessitates DOM querying and updating, and is therefore
           avoided (via caching) wherever possible. This container is call-wide instead of page-wide to avoid the risk of using stale
           conversion metrics across Velocity animations that are not immediately consecutively chained. */
        var callUnitConversionData = {
                lastParent: null,
                lastPosition: null,
                lastFontSize: null,
                lastPercentToPxWidth: null,
                lastPercentToPxHeight: null,
                lastEmToPx: null,
                remToPx: null,
                vwToPx: null,
                vhToPx: null
            };

        /* A container for all the ensuing tween data and metadata associated with this call. This container gets pushed to the page-wide
           Velocity.State.calls array that is processed during animation ticking. */
        var call = [];

        /************************
           Element Processing
        ************************/

        /* Element processing consists of three parts -- data processing that cannot go stale and data processing that *can* go stale (i.e. third-party style modifications):
           1) Pre-Queueing: Element-wide variables, including the element's data storage, are instantiated. Call options are prepared. If triggered, the Stop action is executed.
           2) Queueing: The logic that runs once this call has reached its point of execution in the element's $.queue() stack. Most logic is placed here to avoid risking it becoming stale.
           3) Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
        */

        function processElement () {

            /*************************
               Part I: Pre-Queueing
            *************************/

            /***************************
               Element-Wide Variables
            ***************************/

            var element = this,
                /* The runtime opts object is the extension of the current call's options and Velocity's page-wide option defaults. */
                opts = $.extend({}, Velocity.defaults, options),
                /* A container for the processed data associated with each property in the propertyMap.
                   (Each property in the map produces its own "tween".) */
                tweensContainer = {},
                elementUnitConversionData;

            /******************
               Element Init
            ******************/

            if (Data(element) === undefined) {
                Velocity.init(element);
            }

            /******************
               Option: Delay
            ******************/

            /* Since queue:false doesn't respect the item's existing queue, we avoid injecting its delay here (it's set later on). */
            /* Note: Velocity rolls its own delay function since jQuery doesn't have a utility alias for $.fn.delay()
               (and thus requires jQuery element creation, which we avoid since its overhead includes DOM querying). */
            if (parseFloat(opts.delay) && opts.queue !== false) {
                $.queue(element, opts.queue, function(next) {
                    /* This is a flag used to indicate to the upcoming completeCall() function that this queue entry was initiated by Velocity. See completeCall() for further details. */
                    Velocity.velocityQueueEntryFlag = true;

                    /* The ensuing queue item (which is assigned to the "next" argument that $.queue() automatically passes in) will be triggered after a setTimeout delay.
                       The setTimeout is stored so that it can be subjected to clearTimeout() if this animation is prematurely stopped via Velocity's "stop" command. */
                    Data(element).delayTimer = {
                        setTimeout: setTimeout(next, parseFloat(opts.delay)),
                        next: next
                    };
                });
            }

            /*********************
               Option: Duration
            *********************/

            /* Support for jQuery's named durations. */
            switch (opts.duration.toString().toLowerCase()) {
                case "fast":
                    opts.duration = 200;
                    break;

                case "normal":
                    opts.duration = DURATION_DEFAULT;
                    break;

                case "slow":
                    opts.duration = 600;
                    break;

                default:
                    /* Remove the potential "ms" suffix and default to 1 if the user is attempting to set a duration of 0 (in order to produce an immediate style change). */
                    opts.duration = parseFloat(opts.duration) || 1;
            }

            /************************
               Global Option: Mock
            ************************/

            if (Velocity.mock !== false) {
                /* In mock mode, all animations are forced to 1ms so that they occur immediately upon the next rAF tick.
                   Alternatively, a multiplier can be passed in to time remap all delays and durations. */
                if (Velocity.mock === true) {
                    opts.duration = opts.delay = 1;
                } else {
                    opts.duration *= parseFloat(Velocity.mock) || 1;
                    opts.delay *= parseFloat(Velocity.mock) || 1;
                }
            }

            /*******************
               Option: Easing
            *******************/

            opts.easing = getEasing(opts.easing, opts.duration);

            /**********************
               Option: Callbacks
            **********************/

            /* Callbacks must functions. Otherwise, default to null. */
            if (opts.begin && !Type.isFunction(opts.begin)) {
                opts.begin = null;
            }

            if (opts.progress && !Type.isFunction(opts.progress)) {
                opts.progress = null;
            }

            if (opts.complete && !Type.isFunction(opts.complete)) {
                opts.complete = null;
            }

            /*********************************
               Option: Display & Visibility
            *********************************/

            /* Refer to Velocity's documentation (VelocityJS.org/#displayAndVisibility) for a description of the display and visibility options' behavior. */
            /* Note: We strictly check for undefined instead of falsiness because display accepts an empty string value. */
            if (opts.display !== undefined && opts.display !== null) {
                opts.display = opts.display.toString().toLowerCase();

                /* Users can pass in a special "auto" value to instruct Velocity to set the element to its default display value. */
                if (opts.display === "auto") {
                    opts.display = Velocity.CSS.Values.getDisplayType(element);
                }
            }

            if (opts.visibility !== undefined && opts.visibility !== null) {
                opts.visibility = opts.visibility.toString().toLowerCase();
            }

            /**********************
               Option: mobileHA
            **********************/

            /* When set to true, and if this is a mobile device, mobileHA automatically enables hardware acceleration (via a null transform hack)
               on animating elements. HA is removed from the element at the completion of its animation. */
            /* Note: Android Gingerbread doesn't support HA. If a null transform hack (mobileHA) is in fact set, it will prevent other tranform subproperties from taking effect. */
            /* Note: You can read more about the use of mobileHA in Velocity's documentation: VelocityJS.org/#mobileHA. */
            opts.mobileHA = (opts.mobileHA && Velocity.State.isMobile && !Velocity.State.isGingerbread);

            /***********************
               Part II: Queueing
            ***********************/

            /* When a set of elements is targeted by a Velocity call, the set is broken up and each element has the current Velocity call individually queued onto it.
               In this way, each element's existing queue is respected; some elements may already be animating and accordingly should not have this current Velocity call triggered immediately. */
            /* In each queue, tween data is processed for each animating property then pushed onto the call-wide calls array. When the last element in the set has had its tweens processed,
               the call array is pushed to Velocity.State.calls for live processing by the requestAnimationFrame tick. */
            function buildQueue (next) {

                /*******************
                   Option: Begin
                *******************/

                /* The begin callback is fired once per call -- not once per elemenet -- and is passed the full raw DOM element set as both its context and its first argument. */
                if (opts.begin && elementsIndex === 0) {
                    /* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
                    try {
                        opts.begin.call(elements, elements);
                    } catch (error) {
                        setTimeout(function() { throw error; }, 1);
                    }
                }

                /*****************************************
                   Tween Data Construction (for Scroll)
                *****************************************/

                /* Note: In order to be subjected to chaining and animation options, scroll's tweening is routed through Velocity as if it were a standard CSS property animation. */
                if (action === "scroll") {
                    /* The scroll action uniquely takes an optional "offset" option -- specified in pixels -- that offsets the targeted scroll position. */
                    var scrollDirection = (/^x$/i.test(opts.axis) ? "Left" : "Top"),
                        scrollOffset = parseFloat(opts.offset) || 0,
                        scrollPositionCurrent,
                        scrollPositionCurrentAlternate,
                        scrollPositionEnd;

                    /* Scroll also uniquely takes an optional "container" option, which indicates the parent element that should be scrolled --
                       as opposed to the browser window itself. This is useful for scrolling toward an element that's inside an overflowing parent element. */
                    if (opts.container) {
                        /* Ensure that either a jQuery object or a raw DOM element was passed in. */
                        if (Type.isWrapped(opts.container) || Type.isNode(opts.container)) {
                            /* Extract the raw DOM element from the jQuery wrapper. */
                            opts.container = opts.container[0] || opts.container;
                            /* Note: Unlike other properties in Velocity, the browser's scroll position is never cached since it so frequently changes
                               (due to the user's natural interaction with the page). */
                            scrollPositionCurrent = opts.container["scroll" + scrollDirection]; /* GET */

                            /* $.position() values are relative to the container's currently viewable area (without taking into account the container's true dimensions
                               -- say, for example, if the container was not overflowing). Thus, the scroll end value is the sum of the child element's position *and*
                               the scroll container's current scroll position. */
                            scrollPositionEnd = (scrollPositionCurrent + $(element).position()[scrollDirection.toLowerCase()]) + scrollOffset; /* GET */
                        /* If a value other than a jQuery object or a raw DOM element was passed in, default to null so that this option is ignored. */
                        } else {
                            opts.container = null;
                        }
                    } else {
                        /* If the window itself is being scrolled -- not a containing element -- perform a live scroll position lookup using
                           the appropriate cached property names (which differ based on browser type). */
                        scrollPositionCurrent = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + scrollDirection]]; /* GET */
                        /* When scrolling the browser window, cache the alternate axis's current value since window.scrollTo() doesn't let us change only one value at a time. */
                        scrollPositionCurrentAlternate = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + (scrollDirection === "Left" ? "Top" : "Left")]]; /* GET */

                        /* Unlike $.position(), $.offset() values are relative to the browser window's true dimensions -- not merely its currently viewable area --
                           and therefore end values do not need to be compounded onto current values. */
                        scrollPositionEnd = $(element).offset()[scrollDirection.toLowerCase()] + scrollOffset; /* GET */
                    }

                    /* Since there's only one format that scroll's associated tweensContainer can take, we create it manually. */
                    tweensContainer = {
                        scroll: {
                            rootPropertyValue: false,
                            startValue: scrollPositionCurrent,
                            currentValue: scrollPositionCurrent,
                            endValue: scrollPositionEnd,
                            unitType: "",
                            easing: opts.easing,
                            scrollData: {
                                container: opts.container,
                                direction: scrollDirection,
                                alternateValue: scrollPositionCurrentAlternate
                            }
                        },
                        element: element
                    };

                    if (Velocity.debug) console.log("tweensContainer (scroll): ", tweensContainer.scroll, element);

                /******************************************
                   Tween Data Construction (for Reverse)
                ******************************************/

                /* Reverse acts like a "start" action in that a property map is animated toward. The only difference is
                   that the property map used for reverse is the inverse of the map used in the previous call. Thus, we manipulate
                   the previous call to construct our new map: use the previous map's end values as our new map's start values. Copy over all other data. */
                /* Note: Reverse can be directly called via the "reverse" parameter, or it can be indirectly triggered via the loop option. (Loops are composed of multiple reverses.) */
                /* Note: Reverse calls do not need to be consecutively chained onto a currently-animating element in order to operate on cached values;
                   there is no harm to reverse being called on a potentially stale data cache since reverse's behavior is simply defined
                   as reverting to the element's values as they were prior to the previous *Velocity* call. */
                } else if (action === "reverse") {
                    /* Abort if there is no prior animation data to reverse to. */
                    if (!Data(element).tweensContainer) {
                        /* Dequeue the element so that this queue entry releases itself immediately, allowing subsequent queue entries to run. */
                        $.dequeue(element, opts.queue);

                        return;
                    } else {
                        /*********************
                           Options Parsing
                        *********************/

                        /* If the element was hidden via the display option in the previous call,
                           revert display to "auto" prior to reversal so that the element is visible again. */
                        if (Data(element).opts.display === "none") {
                            Data(element).opts.display = "auto";
                        }

                        if (Data(element).opts.visibility === "hidden") {
                            Data(element).opts.visibility = "visible";
                        }

                        /* If the loop option was set in the previous call, disable it so that "reverse" calls aren't recursively generated.
                           Further, remove the previous call's callback options; typically, users do not want these to be refired. */
                        Data(element).opts.loop = false;
                        Data(element).opts.begin = null;
                        Data(element).opts.complete = null;

                        /* Since we're extending an opts object that has already been extended with the defaults options object,
                           we remove non-explicitly-defined properties that are auto-assigned values. */
                        if (!options.easing) {
                            delete opts.easing;
                        }

                        if (!options.duration) {
                            delete opts.duration;
                        }

                        /* The opts object used for reversal is an extension of the options object optionally passed into this
                           reverse call plus the options used in the previous Velocity call. */
                        opts = $.extend({}, Data(element).opts, opts);

                        /*************************************
                           Tweens Container Reconstruction
                        *************************************/

                        /* Create a deepy copy (indicated via the true flag) of the previous call's tweensContainer. */
                        var lastTweensContainer = $.extend(true, {}, Data(element).tweensContainer);

                        /* Manipulate the previous tweensContainer by replacing its end values and currentValues with its start values. */
                        for (var lastTween in lastTweensContainer) {
                            /* In addition to tween data, tweensContainers contain an element property that we ignore here. */
                            if (lastTween !== "element") {
                                var lastStartValue = lastTweensContainer[lastTween].startValue;

                                lastTweensContainer[lastTween].startValue = lastTweensContainer[lastTween].currentValue = lastTweensContainer[lastTween].endValue;
                                lastTweensContainer[lastTween].endValue = lastStartValue;

                                /* Easing is the only option that embeds into the individual tween data (since it can be defined on a per-property basis).
                                   Accordingly, every property's easing value must be updated when an options object is passed in with a reverse call.
                                   The side effect of this extensibility is that all per-property easing values are forcefully reset to the new value. */
                                if (!Type.isEmptyObject(options)) {
                                    lastTweensContainer[lastTween].easing = opts.easing;
                                }

                                if (Velocity.debug) console.log("reverse tweensContainer (" + lastTween + "): " + JSON.stringify(lastTweensContainer[lastTween]), element);
                            }
                        }

                        tweensContainer = lastTweensContainer;
                    }

                /*****************************************
                   Tween Data Construction (for Start)
                *****************************************/

                } else if (action === "start") {

                    /*************************
                        Value Transferring
                    *************************/

                    /* If this queue entry follows a previous Velocity-initiated queue entry *and* if this entry was created
                       while the element was in the process of being animated by Velocity, then this current call is safe to use
                       the end values from the prior call as its start values. Velocity attempts to perform this value transfer
                       process whenever possible in order to avoid requerying the DOM. */
                    /* If values aren't transferred from a prior call and start values were not forcefed by the user (more on this below),
                       then the DOM is queried for the element's current values as a last resort. */
                    /* Note: Conversely, animation reversal (and looping) *always* perform inter-call value transfers; they never requery the DOM. */
                    var lastTweensContainer;

                    /* The per-element isAnimating flag is used to indicate whether it's safe (i.e. the data isn't stale)
                       to transfer over end values to use as start values. If it's set to true and there is a previous
                       Velocity call to pull values from, do so. */
                    if (Data(element).tweensContainer && Data(element).isAnimating === true) {
                        lastTweensContainer = Data(element).tweensContainer;
                    }

                    /***************************
                       Tween Data Calculation
                    ***************************/

                    /* This function parses property data and defaults endValue, easing, and startValue as appropriate. */
                    /* Property map values can either take the form of 1) a single value representing the end value,
                       or 2) an array in the form of [ endValue, [, easing] [, startValue] ].
                       The optional third parameter is a forcefed startValue to be used instead of querying the DOM for
                       the element's current value. Read Velocity's docmentation to learn more about forcefeeding: VelocityJS.org/#forcefeeding */
                    function parsePropertyValue (valueData, skipResolvingEasing) {
                        var endValue = undefined,
                            easing = undefined,
                            startValue = undefined;

                        /* Handle the array format, which can be structured as one of three potential overloads:
                           A) [ endValue, easing, startValue ], B) [ endValue, easing ], or C) [ endValue, startValue ] */
                        if (Type.isArray(valueData)) {
                            /* endValue is always the first item in the array. Don't bother validating endValue's value now
                               since the ensuing property cycling logic does that. */
                            endValue = valueData[0];

                            /* Two-item array format: If the second item is a number, function, or hex string, treat it as a
                               start value since easings can only be non-hex strings or arrays. */
                            if ((!Type.isArray(valueData[1]) && /^[\d-]/.test(valueData[1])) || Type.isFunction(valueData[1]) || CSS.RegEx.isHex.test(valueData[1])) {
                                startValue = valueData[1];
                            /* Two or three-item array: If the second item is a non-hex string or an array, treat it as an easing. */
                            } else if ((Type.isString(valueData[1]) && !CSS.RegEx.isHex.test(valueData[1])) || Type.isArray(valueData[1])) {
                                easing = skipResolvingEasing ? valueData[1] : getEasing(valueData[1], opts.duration);

                                /* Don't bother validating startValue's value now since the ensuing property cycling logic inherently does that. */
                                if (valueData[2] !== undefined) {
                                    startValue = valueData[2];
                                }
                            }
                        /* Handle the single-value format. */
                        } else {
                            endValue = valueData;
                        }

                        /* Default to the call's easing if a per-property easing type was not defined. */
                        if (!skipResolvingEasing) {
                            easing = easing || opts.easing;
                        }

                        /* If functions were passed in as values, pass the function the current element as its context,
                           plus the element's index and the element set's size as arguments. Then, assign the returned value. */
                        if (Type.isFunction(endValue)) {
                            endValue = endValue.call(element, elementsIndex, elementsLength);
                        }

                        if (Type.isFunction(startValue)) {
                            startValue = startValue.call(element, elementsIndex, elementsLength);
                        }

                        /* Allow startValue to be left as undefined to indicate to the ensuing code that its value was not forcefed. */
                        return [ endValue || 0, easing, startValue ];
                    }

                    /* Cycle through each property in the map, looking for shorthand color properties (e.g. "color" as opposed to "colorRed"). Inject the corresponding
                       colorRed, colorGreen, and colorBlue RGB component tweens into the propertiesMap (which Velocity understands) and remove the shorthand property. */
                    $.each(propertiesMap, function(property, value) {
                        /* Find shorthand color properties that have been passed a hex string. */
                        if (RegExp("^" + CSS.Lists.colors.join("$|^") + "$").test(property)) {
                            /* Parse the value data for each shorthand. */
                            var valueData = parsePropertyValue(value, true),
                                endValue = valueData[0],
                                easing = valueData[1],
                                startValue = valueData[2];

                            if (CSS.RegEx.isHex.test(endValue)) {
                                /* Convert the hex strings into their RGB component arrays. */
                                var colorComponents = [ "Red", "Green", "Blue" ],
                                    endValueRGB = CSS.Values.hexToRgb(endValue),
                                    startValueRGB = startValue ? CSS.Values.hexToRgb(startValue) : undefined;

                                /* Inject the RGB component tweens into propertiesMap. */
                                for (var i = 0; i < colorComponents.length; i++) {
                                    var dataArray = [ endValueRGB[i] ];

                                    if (easing) {
                                        dataArray.push(easing);
                                    }

                                    if (startValueRGB !== undefined) {
                                        dataArray.push(startValueRGB[i]);
                                    }

                                    propertiesMap[property + colorComponents[i]] = dataArray;
                                }

                                /* Remove the intermediary shorthand property entry now that we've processed it. */
                                delete propertiesMap[property];
                            }
                        }
                    });

                    /* Create a tween out of each property, and append its associated data to tweensContainer. */
                    for (var property in propertiesMap) {

                        /**************************
                           Start Value Sourcing
                        **************************/

                        /* Parse out endValue, easing, and startValue from the property's data. */
                        var valueData = parsePropertyValue(propertiesMap[property]),
                            endValue = valueData[0],
                            easing = valueData[1],
                            startValue = valueData[2];

                        /* Now that the original property name's format has been used for the parsePropertyValue() lookup above,
                           we force the property to its camelCase styling to normalize it for manipulation. */
                        property = CSS.Names.camelCase(property);

                        /* In case this property is a hook, there are circumstances where we will intend to work on the hook's root property and not the hooked subproperty. */
                        var rootProperty = CSS.Hooks.getRoot(property),
                            rootPropertyValue = false;

                        /* Other than for the dummy tween property, properties that are not supported by the browser (and do not have an associated normalization) will
                           inherently produce no style changes when set, so they are skipped in order to decrease animation tick overhead.
                           Property support is determined via prefixCheck(), which returns a false flag when no supported is detected. */
                        /* Note: Since SVG elements have some of their properties directly applied as HTML attributes,
                           there is no way to check for their explicit browser support, and so we skip skip this check for them. */
                        if (!Data(element).isSVG && rootProperty !== "tween" && CSS.Names.prefixCheck(rootProperty)[1] === false && CSS.Normalizations.registered[rootProperty] === undefined) {
                            if (Velocity.debug) console.log("Skipping [" + rootProperty + "] due to a lack of browser support.");

                            continue;
                        }

                        /* If the display option is being set to a non-"none" (e.g. "block") and opacity (filter on IE<=8) is being
                           animated to an endValue of non-zero, the user's intention is to fade in from invisible, thus we forcefeed opacity
                           a startValue of 0 if its startValue hasn't already been sourced by value transferring or prior forcefeeding. */
                        if (((opts.display !== undefined && opts.display !== null && opts.display !== "none") || (opts.visibility !== undefined && opts.visibility !== "hidden")) && /opacity|filter/.test(property) && !startValue && endValue !== 0) {
                            startValue = 0;
                        }

                        /* If values have been transferred from the previous Velocity call, extract the endValue and rootPropertyValue
                           for all of the current call's properties that were *also* animated in the previous call. */
                        /* Note: Value transferring can optionally be disabled by the user via the _cacheValues option. */
                        if (opts._cacheValues && lastTweensContainer && lastTweensContainer[property]) {
                            if (startValue === undefined) {
                                startValue = lastTweensContainer[property].endValue + lastTweensContainer[property].unitType;
                            }

                            /* The previous call's rootPropertyValue is extracted from the element's data cache since that's the
                               instance of rootPropertyValue that gets freshly updated by the tweening process, whereas the rootPropertyValue
                               attached to the incoming lastTweensContainer is equal to the root property's value prior to any tweening. */
                            rootPropertyValue = Data(element).rootPropertyValueCache[rootProperty];
                        /* If values were not transferred from a previous Velocity call, query the DOM as needed. */
                        } else {
                            /* Handle hooked properties. */
                            if (CSS.Hooks.registered[property]) {
                               if (startValue === undefined) {
                                    rootPropertyValue = CSS.getPropertyValue(element, rootProperty); /* GET */
                                    /* Note: The following getPropertyValue() call does not actually trigger a DOM query;
                                       getPropertyValue() will extract the hook from rootPropertyValue. */
                                    startValue = CSS.getPropertyValue(element, property, rootPropertyValue);
                                /* If startValue is already defined via forcefeeding, do not query the DOM for the root property's value;
                                   just grab rootProperty's zero-value template from CSS.Hooks. This overwrites the element's actual
                                   root property value (if one is set), but this is acceptable since the primary reason users forcefeed is
                                   to avoid DOM queries, and thus we likewise avoid querying the DOM for the root property's value. */
                                } else {
                                    /* Grab this hook's zero-value template, e.g. "0px 0px 0px black". */
                                    rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
                                }
                            /* Handle non-hooked properties that haven't already been defined via forcefeeding. */
                            } else if (startValue === undefined) {
                                startValue = CSS.getPropertyValue(element, property); /* GET */
                            }
                        }

                        /**************************
                           Value Data Extraction
                        **************************/

                        var separatedValue,
                            endValueUnitType,
                            startValueUnitType,
                            operator = false;

                        /* Separates a property value into its numeric value and its unit type. */
                        function separateValue (property, value) {
                            var unitType,
                                numericValue;

                            numericValue = (value || "0")
                                .toString()
                                .toLowerCase()
                                /* Match the unit type at the end of the value. */
                                .replace(/[%A-z]+$/, function(match) {
                                    /* Grab the unit type. */
                                    unitType = match;

                                    /* Strip the unit type off of value. */
                                    return "";
                                });

                            /* If no unit type was supplied, assign one that is appropriate for this property (e.g. "deg" for rotateZ or "px" for width). */
                            if (!unitType) {
                                unitType = CSS.Values.getUnitType(property);
                            }

                            return [ numericValue, unitType ];
                        }

                        /* Separate startValue. */
                        separatedValue = separateValue(property, startValue);
                        startValue = separatedValue[0];
                        startValueUnitType = separatedValue[1];

                        /* Separate endValue, and extract a value operator (e.g. "+=", "-=") if one exists. */
                        separatedValue = separateValue(property, endValue);
                        endValue = separatedValue[0].replace(/^([+-\/*])=/, function(match, subMatch) {
                            operator = subMatch;

                            /* Strip the operator off of the value. */
                            return "";
                        });
                        endValueUnitType = separatedValue[1];

                        /* Parse float values from endValue and startValue. Default to 0 if NaN is returned. */
                        startValue = parseFloat(startValue) || 0;
                        endValue = parseFloat(endValue) || 0;

                        /***************************************
                           Property-Specific Value Conversion
                        ***************************************/

                        /* Custom support for properties that don't actually accept the % unit type, but where pollyfilling is trivial and relatively foolproof. */
                        if (endValueUnitType === "%") {
                            /* A %-value fontSize/lineHeight is relative to the parent's fontSize (as opposed to the parent's dimensions),
                               which is identical to the em unit's behavior, so we piggyback off of that. */
                            if (/^(fontSize|lineHeight)$/.test(property)) {
                                /* Convert % into an em decimal value. */
                                endValue = endValue / 100;
                                endValueUnitType = "em";
                            /* For scaleX and scaleY, convert the value into its decimal format and strip off the unit type. */
                            } else if (/^scale/.test(property)) {
                                endValue = endValue / 100;
                                endValueUnitType = "";
                            /* For RGB components, take the defined percentage of 255 and strip off the unit type. */
                            } else if (/(Red|Green|Blue)$/i.test(property)) {
                                endValue = (endValue / 100) * 255;
                                endValueUnitType = "";
                            }
                        }

                        /***************************
                           Unit Ratio Calculation
                        ***************************/

                        /* When queried, the browser returns (most) CSS property values in pixels. Therefore, if an endValue with a unit type of
                           %, em, or rem is animated toward, startValue must be converted from pixels into the same unit type as endValue in order
                           for value manipulation logic (increment/decrement) to proceed. Further, if the startValue was forcefed or transferred
                           from a previous call, startValue may also not be in pixels. Unit conversion logic therefore consists of two steps:
                           1) Calculating the ratio of %/em/rem/vh/vw relative to pixels
                           2) Converting startValue into the same unit of measurement as endValue based on these ratios. */
                        /* Unit conversion ratios are calculated by inserting a sibling node next to the target node, copying over its position property,
                           setting values with the target unit type then comparing the returned pixel value. */
                        /* Note: Even if only one of these unit types is being animated, all unit ratios are calculated at once since the overhead
                           of batching the SETs and GETs together upfront outweights the potential overhead
                           of layout thrashing caused by re-querying for uncalculated ratios for subsequently-processed properties. */
                        /* Todo: Shift this logic into the calls' first tick instance so that it's synced with RAF. */
                        function calculateUnitRatios () {

                            /************************
                                Same Ratio Checks
                            ************************/

                            /* The properties below are used to determine whether the element differs sufficiently from this call's
                               previously iterated element to also differ in its unit conversion ratios. If the properties match up with those
                               of the prior element, the prior element's conversion ratios are used. Like most optimizations in Velocity,
                               this is done to minimize DOM querying. */
                            var sameRatioIndicators = {
                                    myParent: element.parentNode || document.body, /* GET */
                                    position: CSS.getPropertyValue(element, "position"), /* GET */
                                    fontSize: CSS.getPropertyValue(element, "fontSize") /* GET */
                                },
                                /* Determine if the same % ratio can be used. % is based on the element's position value and its parent's width and height dimensions. */
                                samePercentRatio = ((sameRatioIndicators.position === callUnitConversionData.lastPosition) && (sameRatioIndicators.myParent === callUnitConversionData.lastParent)),
                                /* Determine if the same em ratio can be used. em is relative to the element's fontSize. */
                                sameEmRatio = (sameRatioIndicators.fontSize === callUnitConversionData.lastFontSize);

                            /* Store these ratio indicators call-wide for the next element to compare against. */
                            callUnitConversionData.lastParent = sameRatioIndicators.myParent;
                            callUnitConversionData.lastPosition = sameRatioIndicators.position;
                            callUnitConversionData.lastFontSize = sameRatioIndicators.fontSize;

                            /***************************
                               Element-Specific Units
                            ***************************/

                            /* Note: IE8 rounds to the nearest pixel when returning CSS values, thus we perform conversions using a measurement
                               of 100 (instead of 1) to give our ratios a precision of at least 2 decimal values. */
                            var measurement = 100,
                                unitRatios = {};

                            if (!sameEmRatio || !samePercentRatio) {
                                var dummy = Data(element).isSVG ? document.createElementNS("http://www.w3.org/2000/svg", "rect") : document.createElement("div");

                                Velocity.init(dummy);
                                sameRatioIndicators.myParent.appendChild(dummy);

                                /* To accurately and consistently calculate conversion ratios, the element's cascaded overflow and box-sizing are stripped.
                                   Similarly, since width/height can be artificially constrained by their min-/max- equivalents, these are controlled for as well. */
                                /* Note: Overflow must be also be controlled for per-axis since the overflow property overwrites its per-axis values. */
                                $.each([ "overflow", "overflowX", "overflowY" ], function(i, property) {
                                    Velocity.CSS.setPropertyValue(dummy, property, "hidden");
                                });
                                Velocity.CSS.setPropertyValue(dummy, "position", sameRatioIndicators.position);
                                Velocity.CSS.setPropertyValue(dummy, "fontSize", sameRatioIndicators.fontSize);
                                Velocity.CSS.setPropertyValue(dummy, "boxSizing", "content-box");

                                /* width and height act as our proxy properties for measuring the horizontal and vertical % ratios. */
                                $.each([ "minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height" ], function(i, property) {
                                    Velocity.CSS.setPropertyValue(dummy, property, measurement + "%");
                                });
                                /* paddingLeft arbitrarily acts as our proxy property for the em ratio. */
                                Velocity.CSS.setPropertyValue(dummy, "paddingLeft", measurement + "em");

                                /* Divide the returned value by the measurement to get the ratio between 1% and 1px. Default to 1 since working with 0 can produce Infinite. */
                                unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth = (parseFloat(CSS.getPropertyValue(dummy, "width", null, true)) || 1) / measurement; /* GET */
                                unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight = (parseFloat(CSS.getPropertyValue(dummy, "height", null, true)) || 1) / measurement; /* GET */
                                unitRatios.emToPx = callUnitConversionData.lastEmToPx = (parseFloat(CSS.getPropertyValue(dummy, "paddingLeft")) || 1) / measurement; /* GET */

                                sameRatioIndicators.myParent.removeChild(dummy);
                            } else {
                                unitRatios.emToPx = callUnitConversionData.lastEmToPx;
                                unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth;
                                unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight;
                            }

                            /***************************
                               Element-Agnostic Units
                            ***************************/

                            /* Whereas % and em ratios are determined on a per-element basis, the rem unit only needs to be checked
                               once per call since it's exclusively dependant upon document.body's fontSize. If this is the first time
                               that calculateUnitRatios() is being run during this call, remToPx will still be set to its default value of null,
                               so we calculate it now. */
                            if (callUnitConversionData.remToPx === null) {
                                /* Default to browsers' default fontSize of 16px in the case of 0. */
                                callUnitConversionData.remToPx = parseFloat(CSS.getPropertyValue(document.body, "fontSize")) || 16; /* GET */
                            }

                            /* Similarly, viewport units are %-relative to the window's inner dimensions. */
                            if (callUnitConversionData.vwToPx === null) {
                                callUnitConversionData.vwToPx = parseFloat(window.innerWidth) / 100; /* GET */
                                callUnitConversionData.vhToPx = parseFloat(window.innerHeight) / 100; /* GET */
                            }

                            unitRatios.remToPx = callUnitConversionData.remToPx;
                            unitRatios.vwToPx = callUnitConversionData.vwToPx;
                            unitRatios.vhToPx = callUnitConversionData.vhToPx;

                            if (Velocity.debug >= 1) console.log("Unit ratios: " + JSON.stringify(unitRatios), element);

                            return unitRatios;
                        }

                        /********************
                           Unit Conversion
                        ********************/

                        /* The * and / operators, which are not passed in with an associated unit, inherently use startValue's unit. Skip value and unit conversion. */
                        if (/[\/*]/.test(operator)) {
                            endValueUnitType = startValueUnitType;
                        /* If startValue and endValue differ in unit type, convert startValue into the same unit type as endValue so that if endValueUnitType
                           is a relative unit (%, em, rem), the values set during tweening will continue to be accurately relative even if the metrics they depend
                           on are dynamically changing during the course of the animation. Conversely, if we always normalized into px and used px for setting values, the px ratio
                           would become stale if the original unit being animated toward was relative and the underlying metrics change during the animation. */
                        /* Since 0 is 0 in any unit type, no conversion is necessary when startValue is 0 -- we just start at 0 with endValueUnitType. */
                        } else if ((startValueUnitType !== endValueUnitType) && startValue !== 0) {
                            /* Unit conversion is also skipped when endValue is 0, but *startValueUnitType* must be used for tween values to remain accurate. */
                            /* Note: Skipping unit conversion here means that if endValueUnitType was originally a relative unit, the animation won't relatively
                               match the underlying metrics if they change, but this is acceptable since we're animating toward invisibility instead of toward visibility,
                               which remains past the point of the animation's completion. */
                            if (endValue === 0) {
                                endValueUnitType = startValueUnitType;
                            } else {
                                /* By this point, we cannot avoid unit conversion (it's undesirable since it causes layout thrashing).
                                   If we haven't already, we trigger calculateUnitRatios(), which runs once per element per call. */
                                elementUnitConversionData = elementUnitConversionData || calculateUnitRatios();

                                /* The following RegEx matches CSS properties that have their % values measured relative to the x-axis. */
                                /* Note: W3C spec mandates that all of margin and padding's properties (even top and bottom) are %-relative to the *width* of the parent element. */
                                var axis = (/margin|padding|left|right|width|text|word|letter/i.test(property) || /X$/.test(property) || property === "x") ? "x" : "y";

                                /* In order to avoid generating n^2 bespoke conversion functions, unit conversion is a two-step process:
                                   1) Convert startValue into pixels. 2) Convert this new pixel value into endValue's unit type. */
                                switch (startValueUnitType) {
                                    case "%":
                                        /* Note: translateX and translateY are the only properties that are %-relative to an element's own dimensions -- not its parent's dimensions.
                                           Velocity does not include a special conversion process to account for this behavior. Therefore, animating translateX/Y from a % value
                                           to a non-% value will produce an incorrect start value. Fortunately, this sort of cross-unit conversion is rarely done by users in practice. */
                                        startValue *= (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
                                        break;

                                    case "px":
                                        /* px acts as our midpoint in the unit conversion process; do nothing. */
                                        break;

                                    default:
                                        startValue *= elementUnitConversionData[startValueUnitType + "ToPx"];
                                }

                                /* Invert the px ratios to convert into to the target unit. */
                                switch (endValueUnitType) {
                                    case "%":
                                        startValue *= 1 / (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
                                        break;

                                    case "px":
                                        /* startValue is already in px, do nothing; we're done. */
                                        break;

                                    default:
                                        startValue *= 1 / elementUnitConversionData[endValueUnitType + "ToPx"];
                                }
                            }
                        }

                        /*********************
                           Relative Values
                        *********************/

                        /* Operator logic must be performed last since it requires unit-normalized start and end values. */
                        /* Note: Relative *percent values* do not behave how most people think; while one would expect "+=50%"
                           to increase the property 1.5x its current value, it in fact increases the percent units in absolute terms:
                           50 points is added on top of the current % value. */
                        switch (operator) {
                            case "+":
                                endValue = startValue + endValue;
                                break;

                            case "-":
                                endValue = startValue - endValue;
                                break;

                            case "*":
                                endValue = startValue * endValue;
                                break;

                            case "/":
                                endValue = startValue / endValue;
                                break;
                        }

                        /**************************
                           tweensContainer Push
                        **************************/

                        /* Construct the per-property tween object, and push it to the element's tweensContainer. */
                        tweensContainer[property] = {
                            rootPropertyValue: rootPropertyValue,
                            startValue: startValue,
                            currentValue: startValue,
                            endValue: endValue,
                            unitType: endValueUnitType,
                            easing: easing
                        };

                        if (Velocity.debug) console.log("tweensContainer (" + property + "): " + JSON.stringify(tweensContainer[property]), element);
                    }

                    /* Along with its property data, store a reference to the element itself onto tweensContainer. */
                    tweensContainer.element = element;
                }

                /*****************
                    Call Push
                *****************/

                /* Note: tweensContainer can be empty if all of the properties in this call's property map were skipped due to not
                   being supported by the browser. The element property is used for checking that the tweensContainer has been appended to. */
                if (tweensContainer.element) {
                    /* Apply the "velocity-animating" indicator class. */
                    CSS.Values.addClass(element, "velocity-animating");

                    /* The call array houses the tweensContainers for each element being animated in the current call. */
                    call.push(tweensContainer);

                    /* Store the tweensContainer and options if we're working on the default effects queue, so that they can be used by the reverse command. */
                    if (opts.queue === "") {
                        Data(element).tweensContainer = tweensContainer;
                        Data(element).opts = opts;
                    }

                    /* Switch on the element's animating flag. */
                    Data(element).isAnimating = true;

                    /* Once the final element in this call's element set has been processed, push the call array onto
                       Velocity.State.calls for the animation tick to immediately begin processing. */
                    if (elementsIndex === elementsLength - 1) {
                        /* Add the current call plus its associated metadata (the element set and the call's options) onto the global call container.
                           Anything on this call container is subjected to tick() processing. */
                        Velocity.State.calls.push([ call, elements, opts, null, promiseData.resolver ]);

                        /* If the animation tick isn't running, start it. (Velocity shuts it off when there are no active calls to process.) */
                        if (Velocity.State.isTicking === false) {
                            Velocity.State.isTicking = true;

                            /* Start the tick loop. */
                            tick();
                        }
                    } else {
                        elementsIndex++;
                    }
                }
            }

            /* When the queue option is set to false, the call skips the element's queue and fires immediately. */
            if (opts.queue === false) {
                /* Since this buildQueue call doesn't respect the element's existing queue (which is where a delay option would have been appended),
                   we manually inject the delay property here with an explicit setTimeout. */
                if (opts.delay) {
                    setTimeout(buildQueue, opts.delay);
                } else {
                    buildQueue();
                }
            /* Otherwise, the call undergoes element queueing as normal. */
            /* Note: To interoperate with jQuery, Velocity uses jQuery's own $.queue() stack for queuing logic. */
            } else {
                $.queue(element, opts.queue, function(next, clearQueue) {
                    /* If the clearQueue flag was passed in by the stop command, resolve this call's promise. (Promises can only be resolved once,
                       so it's fine if this is repeatedly triggered for each element in the associated call.) */
                    if (clearQueue === true) {
                        if (promiseData.promise) {
                            promiseData.resolver(elements);
                        }

                        /* Do not continue with animation queueing. */
                        return true;
                    }

                    /* This flag indicates to the upcoming completeCall() function that this queue entry was initiated by Velocity.
                       See completeCall() for further details. */
                    Velocity.velocityQueueEntryFlag = true;

                    buildQueue(next);
                });
            }

            /*********************
                Auto-Dequeuing
            *********************/

            /* As per jQuery's $.queue() behavior, to fire the first non-custom-queue entry on an element, the element
               must be dequeued if its queue stack consists *solely* of the current call. (This can be determined by checking
               for the "inprogress" item that jQuery prepends to active queue stack arrays.) Regardless, whenever the element's
               queue is further appended with additional items -- including $.delay()'s or even $.animate() calls, the queue's
               first entry is automatically fired. This behavior contrasts that of custom queues, which never auto-fire. */
            /* Note: When an element set is being subjected to a non-parallel Velocity call, the animation will not begin until
               each one of the elements in the set has reached the end of its individually pre-existing queue chain. */
            /* Note: Unfortunately, most people don't fully grasp jQuery's powerful, yet quirky, $.queue() function.
               Lean more here: http://stackoverflow.com/questions/1058158/can-somebody-explain-jquery-queue-to-me */
            if ((opts.queue === "" || opts.queue === "fx") && $.queue(element)[0] !== "inprogress") {
                $.dequeue(element);
            }
        }

        /**************************
           Element Set Iteration
        **************************/

        /* If the "nodeType" property exists on the elements variable, we're animating a single element.
           Place it in an array so that $.each() can iterate over it. */
        $.each(elements, function(i, element) {
            /* Ensure each element in a set has a nodeType (is a real element) to avoid throwing errors. */
            if (Type.isNode(element)) {
                processElement.call(element);
            }
        });

        /******************
           Option: Loop
        ******************/

        /* The loop option accepts an integer indicating how many times the element should loop between the values in the
           current call's properties map and the element's property values prior to this call. */
        /* Note: The loop option's logic is performed here -- after element processing -- because the current call needs
           to undergo its queue insertion prior to the loop option generating its series of constituent "reverse" calls,
           which chain after the current call. Two reverse calls (two "alternations") constitute one loop. */
        var opts = $.extend({}, Velocity.defaults, options),
            reverseCallsCount;

        opts.loop = parseInt(opts.loop);
        reverseCallsCount = (opts.loop * 2) - 1;

        if (opts.loop) {
            /* Double the loop count to convert it into its appropriate number of "reverse" calls.
               Subtract 1 from the resulting value since the current call is included in the total alternation count. */
            for (var x = 0; x < reverseCallsCount; x++) {
                /* Since the logic for the reverse action occurs inside Queueing and therefore this call's options object
                   isn't parsed until then as well, the current call's delay option must be explicitly passed into the reverse
                   call so that the delay logic that occurs inside *Pre-Queueing* can process it. */
                var reverseOptions = {
                    delay: opts.delay,
                    progress: opts.progress
                };

                /* If a complete callback was passed into this call, transfer it to the loop redirect's final "reverse" call
                   so that it's triggered when the entire redirect is complete (and not when the very first animation is complete). */
                if (x === reverseCallsCount - 1) {
                    reverseOptions.display = opts.display;
                    reverseOptions.visibility = opts.visibility;
                    reverseOptions.complete = opts.complete;
                }

                animate(elements, "reverse", reverseOptions);
            }
        }

        /***************
            Chaining
        ***************/

        /* Return the elements back to the call chain, with wrapped elements taking precedence in case Velocity was called via the $.fn. extension. */
        return getChain();
    };

    /* Turn Velocity into the animation function, extended with the pre-existing Velocity object. */
    Velocity = $.extend(animate, Velocity);
    /* For legacy support, also expose the literal animate method. */
    Velocity.animate = animate;

    /**************
        Timing
    **************/

    /* Ticker function. */
    var ticker = window.requestAnimationFrame || rAFShim;

    /* Inactive browser tabs pause rAF, which results in all active animations immediately sprinting to their completion states when the tab refocuses.
       To get around this, we dynamically switch rAF to setTimeout (which the browser *doesn't* pause) when the tab loses focus. We skip this for mobile
       devices to avoid wasting battery power on inactive tabs. */
    /* Note: Tab focus detection doesn't work on older versions of IE, but that's okay since they don't support rAF to begin with. */
    if (!Velocity.State.isMobile && document.hidden !== undefined) {
        document.addEventListener("visibilitychange", function() {
            /* Reassign the rAF function (which the global tick() function uses) based on the tab's focus state. */
            if (document.hidden) {
                ticker = function(callback) {
                    /* The tick function needs a truthy first argument in order to pass its internal timestamp check. */
                    return setTimeout(function() { callback(true) }, 16);
                };

                /* The rAF loop has been paused by the browser, so we manually restart the tick. */
                tick();
            } else {
                ticker = window.requestAnimationFrame || rAFShim;
            }
        });
    }

    /************
        Tick
    ************/

    /* Note: All calls to Velocity are pushed to the Velocity.State.calls array, which is fully iterated through upon each tick. */
    function tick (timestamp) {
        /* An empty timestamp argument indicates that this is the first tick occurence since ticking was turned on.
           We leverage this metadata to fully ignore the first tick pass since RAF's initial pass is fired whenever
           the browser's next tick sync time occurs, which results in the first elements subjected to Velocity
           calls being animated out of sync with any elements animated immediately thereafter. In short, we ignore
           the first RAF tick pass so that elements being immediately consecutively animated -- instead of simultaneously animated
           by the same Velocity call -- are properly batched into the same initial RAF tick and consequently remain in sync thereafter. */
        if (timestamp) {
            /* We ignore RAF's high resolution timestamp since it can be significantly offset when the browser is
               under high stress; we opt for choppiness over allowing the browser to drop huge chunks of frames. */
            var timeCurrent = (new Date).getTime();

            /********************
               Call Iteration
            ********************/

            var callsLength = Velocity.State.calls.length;

            /* To speed up iterating over this array, it is compacted (falsey items -- calls that have completed -- are removed)
               when its length has ballooned to a point that can impact tick performance. This only becomes necessary when animation
               has been continuous with many elements over a long period of time; whenever all active calls are completed, completeCall() clears Velocity.State.calls. */
            if (callsLength > 10000) {
                Velocity.State.calls = compactSparseArray(Velocity.State.calls);
            }

            /* Iterate through each active call. */
            for (var i = 0; i < callsLength; i++) {
                /* When a Velocity call is completed, its Velocity.State.calls entry is set to false. Continue on to the next call. */
                if (!Velocity.State.calls[i]) {
                    continue;
                }

                /************************
                   Call-Wide Variables
                ************************/

                var callContainer = Velocity.State.calls[i],
                    call = callContainer[0],
                    opts = callContainer[2],
                    timeStart = callContainer[3],
                    firstTick = !!timeStart,
                    tweenDummyValue = null;

                /* If timeStart is undefined, then this is the first time that this call has been processed by tick().
                   We assign timeStart now so that its value is as close to the real animation start time as possible.
                   (Conversely, had timeStart been defined when this call was added to Velocity.State.calls, the delay
                   between that time and now would cause the first few frames of the tween to be skipped since
                   percentComplete is calculated relative to timeStart.) */
                /* Further, subtract 16ms (the approximate resolution of RAF) from the current time value so that the
                   first tick iteration isn't wasted by animating at 0% tween completion, which would produce the
                   same style value as the element's current value. */
                if (!timeStart) {
                    timeStart = Velocity.State.calls[i][3] = timeCurrent - 16;
                }

                /* The tween's completion percentage is relative to the tween's start time, not the tween's start value
                   (which would result in unpredictable tween durations since JavaScript's timers are not particularly accurate).
                   Accordingly, we ensure that percentComplete does not exceed 1. */
                var percentComplete = Math.min((timeCurrent - timeStart) / opts.duration, 1);

                /**********************
                   Element Iteration
                **********************/

                /* For every call, iterate through each of the elements in its set. */
                for (var j = 0, callLength = call.length; j < callLength; j++) {
                    var tweensContainer = call[j],
                        element = tweensContainer.element;

                    /* Check to see if this element has been deleted midway through the animation by checking for the
                       continued existence of its data cache. If it's gone, skip animating this element. */
                    if (!Data(element)) {
                        continue;
                    }

                    var transformPropertyExists = false;

                    /**********************************
                       Display & Visibility Toggling
                    **********************************/

                    /* If the display option is set to non-"none", set it upfront so that the element can become visible before tweening begins.
                       (Otherwise, display's "none" value is set in completeCall() once the animation has completed.) */
                    if (opts.display !== undefined && opts.display !== null && opts.display !== "none") {
                        if (opts.display === "flex") {
                            var flexValues = [ "-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex" ];

                            $.each(flexValues, function(i, flexValue) {
                                CSS.setPropertyValue(element, "display", flexValue);
                            });
                        }

                        CSS.setPropertyValue(element, "display", opts.display);
                    }

                    /* Same goes with the visibility option, but its "none" equivalent is "hidden". */
                    if (opts.visibility !== undefined && opts.visibility !== "hidden") {
                        CSS.setPropertyValue(element, "visibility", opts.visibility);
                    }

                    /************************
                       Property Iteration
                    ************************/

                    /* For every element, iterate through each property. */
                    for (var property in tweensContainer) {
                        /* Note: In addition to property tween data, tweensContainer contains a reference to its associated element. */
                        if (property !== "element") {
                            var tween = tweensContainer[property],
                                currentValue,
                                /* Easing can either be a pre-genereated function or a string that references a pre-registered easing
                                   on the Velocity.Easings object. In either case, return the appropriate easing *function*. */
                                easing = Type.isString(tween.easing) ? Velocity.Easings[tween.easing] : tween.easing;

                            /******************************
                               Current Value Calculation
                            ******************************/

                            /* If this is the last tick pass (if we've reached 100% completion for this tween),
                               ensure that currentValue is explicitly set to its target endValue so that it's not subjected to any rounding. */
                            if (percentComplete === 1) {
                                currentValue = tween.endValue;
                            /* Otherwise, calculate currentValue based on the current delta from startValue. */
                            } else {
                                var tweenDelta = tween.endValue - tween.startValue;
                                currentValue = tween.startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));

                                /* If no value change is occurring, don't proceed with DOM updating. */
                                if (!firstTick && (currentValue === tween.currentValue)) {
                                    continue;
                                }
                            }

                            tween.currentValue = currentValue;

                            /* If we're tweening a fake 'tween' property in order to log transition values, update the one-per-call variable so that
                               it can be passed into the progress callback. */
                            if (property === "tween") {
                                tweenDummyValue = currentValue;
                            } else {
                                /******************
                                   Hooks: Part I
                                ******************/

                                /* For hooked properties, the newly-updated rootPropertyValueCache is cached onto the element so that it can be used
                                   for subsequent hooks in this call that are associated with the same root property. If we didn't cache the updated
                                   rootPropertyValue, each subsequent update to the root property in this tick pass would reset the previous hook's
                                   updates to rootPropertyValue prior to injection. A nice performance byproduct of rootPropertyValue caching is that
                                   subsequently chained animations using the same hookRoot but a different hook can use this cached rootPropertyValue. */
                                if (CSS.Hooks.registered[property]) {
                                    var hookRoot = CSS.Hooks.getRoot(property),
                                        rootPropertyValueCache = Data(element).rootPropertyValueCache[hookRoot];

                                    if (rootPropertyValueCache) {
                                        tween.rootPropertyValue = rootPropertyValueCache;
                                    }
                                }

                                /*****************
                                    DOM Update
                                *****************/

                                /* setPropertyValue() returns an array of the property name and property value post any normalization that may have been performed. */
                                /* Note: To solve an IE<=8 positioning bug, the unit type is dropped when setting a property value of 0. */
                                var adjustedSetData = CSS.setPropertyValue(element, /* SET */
                                                                           property,
                                                                           tween.currentValue + (parseFloat(currentValue) === 0 ? "" : tween.unitType),
                                                                           tween.rootPropertyValue,
                                                                           tween.scrollData);

                                /*******************
                                   Hooks: Part II
                                *******************/

                                /* Now that we have the hook's updated rootPropertyValue (the post-processed value provided by adjustedSetData), cache it onto the element. */
                                if (CSS.Hooks.registered[property]) {
                                    /* Since adjustedSetData contains normalized data ready for DOM updating, the rootPropertyValue needs to be re-extracted from its normalized form. ?? */
                                    if (CSS.Normalizations.registered[hookRoot]) {
                                        Data(element).rootPropertyValueCache[hookRoot] = CSS.Normalizations.registered[hookRoot]("extract", null, adjustedSetData[1]);
                                    } else {
                                        Data(element).rootPropertyValueCache[hookRoot] = adjustedSetData[1];
                                    }
                                }

                                /***************
                                   Transforms
                                ***************/

                                /* Flag whether a transform property is being animated so that flushTransformCache() can be triggered once this tick pass is complete. */
                                if (adjustedSetData[0] === "transform") {
                                    transformPropertyExists = true;
                                }

                            }
                        }
                    }

                    /****************
                        mobileHA
                    ****************/

                    /* If mobileHA is enabled, set the translate3d transform to null to force hardware acceleration.
                       It's safe to override this property since Velocity doesn't actually support its animation (hooks are used in its place). */
                    if (opts.mobileHA) {
                        /* Don't set the null transform hack if we've already done so. */
                        if (Data(element).transformCache.translate3d === undefined) {
                            /* All entries on the transformCache object are later concatenated into a single transform string via flushTransformCache(). */
                            Data(element).transformCache.translate3d = "(0px, 0px, 0px)";

                            transformPropertyExists = true;
                        }
                    }

                    if (transformPropertyExists) {
                        CSS.flushTransformCache(element);
                    }
                }

                /* The non-"none" display value is only applied to an element once -- when its associated call is first ticked through.
                   Accordingly, it's set to false so that it isn't re-processed by this call in the next tick. */
                if (opts.display !== undefined && opts.display !== "none") {
                    Velocity.State.calls[i][2].display = false;
                }
                if (opts.visibility !== undefined && opts.visibility !== "hidden") {
                    Velocity.State.calls[i][2].visibility = false;
                }

                /* Pass the elements and the timing data (percentComplete, msRemaining, timeStart, tweenDummyValue) into the progress callback. */
                if (opts.progress) {
                    opts.progress.call(callContainer[1],
                                       callContainer[1],
                                       percentComplete,
                                       Math.max(0, (timeStart + opts.duration) - timeCurrent),
                                       timeStart,
                                       tweenDummyValue);
                }

                /* If this call has finished tweening, pass its index to completeCall() to handle call cleanup. */
                if (percentComplete === 1) {
                    completeCall(i);
                }
            }
        }

        /* Note: completeCall() sets the isTicking flag to false when the last call on Velocity.State.calls has completed. */
        if (Velocity.State.isTicking) {
            ticker(tick);
        }
    }

    /**********************
        Call Completion
    **********************/

    /* Note: Unlike tick(), which processes all active calls at once, call completion is handled on a per-call basis. */
    function completeCall (callIndex, isStopped) {
        /* Ensure the call exists. */
        if (!Velocity.State.calls[callIndex]) {
            return false;
        }

        /* Pull the metadata from the call. */
        var call = Velocity.State.calls[callIndex][0],
            elements = Velocity.State.calls[callIndex][1],
            opts = Velocity.State.calls[callIndex][2],
            resolver = Velocity.State.calls[callIndex][4];

        var remainingCallsExist = false;

        /*************************
           Element Finalization
        *************************/

        for (var i = 0, callLength = call.length; i < callLength; i++) {
            var element = call[i].element;

            /* If the user set display to "none" (intending to hide the element), set it now that the animation has completed. */
            /* Note: display:none isn't set when calls are manually stopped (via Velocity("stop"). */
            /* Note: Display gets ignored with "reverse" calls and infinite loops, since this behavior would be undesirable. */
            if (!isStopped && !opts.loop) {
                if (opts.display === "none") {
                    CSS.setPropertyValue(element, "display", opts.display);
                }

                if (opts.visibility === "hidden") {
                    CSS.setPropertyValue(element, "visibility", opts.visibility);
                }
            }

            /* If the element's queue is empty (if only the "inprogress" item is left at position 0) or if its queue is about to run
               a non-Velocity-initiated entry, turn off the isAnimating flag. A non-Velocity-initiatied queue entry's logic might alter
               an element's CSS values and thereby cause Velocity's cached value data to go stale. To detect if a queue entry was initiated by Velocity,
               we check for the existence of our special Velocity.queueEntryFlag declaration, which minifiers won't rename since the flag
               is assigned to jQuery's global $ object and thus exists out of Velocity's own scope. */
            if (opts.loop !== true && ($.queue(element)[1] === undefined || !/\.velocityQueueEntryFlag/i.test($.queue(element)[1]))) {
                /* The element may have been deleted. Ensure that its data cache still exists before acting on it. */
                if (Data(element)) {
                    Data(element).isAnimating = false;
                    /* Clear the element's rootPropertyValueCache, which will become stale. */
                    Data(element).rootPropertyValueCache = {};

                    var transformHAPropertyExists = false;
                    /* If any 3D transform subproperty is at its default value (regardless of unit type), remove it. */
                    $.each(CSS.Lists.transforms3D, function(i, transformName) {
                        var defaultValue = /^scale/.test(transformName) ? 1 : 0,
                            currentValue = Data(element).transformCache[transformName];

                        if (Data(element).transformCache[transformName] !== undefined && new RegExp("^\\(" + defaultValue + "[^.]").test(currentValue)) {
                            transformHAPropertyExists = true;

                            delete Data(element).transformCache[transformName];
                        }
                    });

                    /* Mobile devices have hardware acceleration removed at the end of the animation in order to avoid hogging the GPU's memory. */
                    if (opts.mobileHA) {
                        transformHAPropertyExists = true;
                        delete Data(element).transformCache.translate3d;
                    }

                    /* Flush the subproperty removals to the DOM. */
                    if (transformHAPropertyExists) {
                        CSS.flushTransformCache(element);
                    }

                    /* Remove the "velocity-animating" indicator class. */
                    CSS.Values.removeClass(element, "velocity-animating");
                }
            }

            /*********************
               Option: Complete
            *********************/

            /* Complete is fired once per call (not once per element) and is passed the full raw DOM element set as both its context and its first argument. */
            /* Note: Callbacks aren't fired when calls are manually stopped (via Velocity("stop"). */
            if (!isStopped && opts.complete && !opts.loop && (i === callLength - 1)) {
                /* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
                try {
                    opts.complete.call(elements, elements);
                } catch (error) {
                    setTimeout(function() { throw error; }, 1);
                }
            }

            /**********************
               Promise Resolving
            **********************/

            /* Note: Infinite loops don't return promises. */
            if (resolver && opts.loop !== true) {
                resolver(elements);
            }

            /****************************
               Option: Loop (Infinite)
            ****************************/

            if (Data(element) && opts.loop === true && !isStopped) {
                /* If a rotateX/Y/Z property is being animated to 360 deg with loop:true, swap tween start/end values to enable
                   continuous iterative rotation looping. (Otherise, the element would just rotate back and forth.) */
                $.each(Data(element).tweensContainer, function(propertyName, tweenContainer) {
                    if (/^rotate/.test(propertyName) && parseFloat(tweenContainer.endValue) === 360) {
                        tweenContainer.endValue = 0;
                        tweenContainer.startValue = 360;
                    }

                    if (/^backgroundPosition/.test(propertyName) && parseFloat(tweenContainer.endValue) === 100 && tweenContainer.unitType === "%") {
                        tweenContainer.endValue = 0;
                        tweenContainer.startValue = 100;
                    }
                });

                Velocity(element, "reverse", { loop: true, delay: opts.delay });
            }

            /***************
               Dequeueing
            ***************/

            /* Fire the next call in the queue so long as this call's queue wasn't set to false (to trigger a parallel animation),
               which would have already caused the next call to fire. Note: Even if the end of the animation queue has been reached,
               $.dequeue() must still be called in order to completely clear jQuery's animation queue. */
            if (opts.queue !== false) {
                $.dequeue(element, opts.queue);
            }
        }

        /************************
           Calls Array Cleanup
        ************************/

        /* Since this call is complete, set it to false so that the rAF tick skips it. This array is later compacted via compactSparseArray().
          (For performance reasons, the call is set to false instead of being deleted from the array: http://www.html5rocks.com/en/tutorials/speed/v8/) */
        Velocity.State.calls[callIndex] = false;

        /* Iterate through the calls array to determine if this was the final in-progress animation.
           If so, set a flag to end ticking and clear the calls array. */
        for (var j = 0, callsLength = Velocity.State.calls.length; j < callsLength; j++) {
            if (Velocity.State.calls[j] !== false) {
                remainingCallsExist = true;

                break;
            }
        }

        if (remainingCallsExist === false) {
            /* tick() will detect this flag upon its next iteration and subsequently turn itself off. */
            Velocity.State.isTicking = false;

            /* Clear the calls array so that its length is reset. */
            delete Velocity.State.calls;
            Velocity.State.calls = [];
        }
    }

    /******************
        Frameworks
    ******************/

    /* Both jQuery and Zepto allow their $.fn object to be extended to allow wrapped elements to be subjected to plugin calls.
       If either framework is loaded, register a "velocity" extension pointing to Velocity's core animate() method.  Velocity
       also registers itself onto a global container (window.jQuery || window.Zepto || window) so that certain features are
       accessible beyond just a per-element scope. This master object contains an .animate() method, which is later assigned to $.fn
       (if jQuery or Zepto are present). Accordingly, Velocity can both act on wrapped DOM elements and stand alone for targeting raw DOM elements. */
    global.Velocity = Velocity;

    if (global !== window) {
        /* Assign the element function to Velocity's core animate() method. */
        global.fn.velocity = animate;
        /* Assign the object function's defaults to Velocity's global defaults object. */
        global.fn.velocity.defaults = Velocity.defaults;
    }

    /***********************
       Packaged Redirects
    ***********************/

    /* slideUp, slideDown */
    $.each([ "Down", "Up" ], function(i, direction) {
        Velocity.Redirects["slide" + direction] = function (element, options, elementsIndex, elementsSize, elements, promiseData) {
            var opts = $.extend({}, options),
                begin = opts.begin,
                complete = opts.complete,
                computedValues = { height: "", marginTop: "", marginBottom: "", paddingTop: "", paddingBottom: "" },
                inlineValues = {};

            if (opts.display === undefined) {
                /* Show the element before slideDown begins and hide the element after slideUp completes. */
                /* Note: Inline elements cannot have dimensions animated, so they're reverted to inline-block. */
                opts.display = (direction === "Down" ? (Velocity.CSS.Values.getDisplayType(element) === "inline" ? "inline-block" : "block") : "none");
            }

            opts.begin = function() {
                /* If the user passed in a begin callback, fire it now. */
                begin && begin.call(elements, elements);

                /* Cache the elements' original vertical dimensional property values so that we can animate back to them. */
                for (var property in computedValues) {
                    inlineValues[property] = element.style[property];

                    /* For slideDown, use forcefeeding to animate all vertical properties from 0. For slideUp,
                       use forcefeeding to start from computed values and animate down to 0. */
                    var propertyValue = Velocity.CSS.getPropertyValue(element, property);
                    computedValues[property] = (direction === "Down") ? [ propertyValue, 0 ] : [ 0, propertyValue ];
                }

                /* Force vertical overflow content to clip so that sliding works as expected. */
                inlineValues.overflow = element.style.overflow;
                element.style.overflow = "hidden";
            }

            opts.complete = function() {
                /* Reset element to its pre-slide inline values once its slide animation is complete. */
                for (var property in inlineValues) {
                    element.style[property] = inlineValues[property];
                }

                /* If the user passed in a complete callback, fire it now. */
                complete && complete.call(elements, elements);
                promiseData && promiseData.resolver(elements);
            };

            Velocity(element, computedValues, opts);
        };
    });

    /* fadeIn, fadeOut */
    $.each([ "In", "Out" ], function(i, direction) {
        Velocity.Redirects["fade" + direction] = function (element, options, elementsIndex, elementsSize, elements, promiseData) {
            var opts = $.extend({}, options),
                propertiesMap = { opacity: (direction === "In") ? 1 : 0 },
                originalComplete = opts.complete;

            /* Since redirects are triggered individually for each element in the animated set, avoid repeatedly triggering
               callbacks by firing them only when the final element has been reached. */
            if (elementsIndex !== elementsSize - 1) {
                opts.complete = opts.begin = null;
            } else {
                opts.complete = function() {
                    if (originalComplete) {
                        originalComplete.call(elements, elements);
                    }

                    promiseData && promiseData.resolver(elements);
                }
            }

            /* If a display was passed in, use it. Otherwise, default to "none" for fadeOut or the element-specific default for fadeIn. */
            /* Note: We allow users to pass in "null" to skip display setting altogether. */
            if (opts.display === undefined) {
                opts.display = (direction === "In" ? "auto" : "none");
            }

            Velocity(this, propertiesMap, opts);
        };
    });

    return Velocity;
}((window.jQuery || window.Zepto || window), window, document);
}));

/******************
   Known Issues
******************/

/* The CSS spec mandates that the translateX/Y/Z transforms are %-relative to the element itself -- not its parent.
Velocity, however, doesn't make this distinction. Thus, converting to or from the % unit with these subproperties
will produce an inaccurate conversion value. The same issue exists with the cx/cy attributes of SVG circles and ellipses. */

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _rcRate=__webpack_require__(689);var _rcRate2=_interopRequireDefault(_rcRate);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Rate=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Rate,_React$Component);function Rate(){(0,_classCallCheck3.default)(this,Rate);return(0,_possibleConstructorReturn3.default)(this,(Rate.__proto__||(0,_getPrototypeOf2.default)(Rate)).apply(this,arguments));}(0,_createClass3.default)(Rate,[{key:'render',value:function render(){return _react2.default.createElement(_rcRate2.default,this.props);}}]);return Rate;}(_react2.default.Component),_class.propTypes={prefixCls:_react.PropTypes.string},_class.defaultProps={prefixCls:'ant-rate'},_temp);exports.default=Rate;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _src=__webpack_require__(690);var _src2=_interopRequireDefault(_src);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_src2.default;// export this package's api

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Rate=__webpack_require__(691);var _Rate2=_interopRequireDefault(_Rate);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Rate2.default;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _util=__webpack_require__(692);var _Star=__webpack_require__(693);var _Star2=_interopRequireDefault(_Star);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function noop(){}var Rate=_react2.default.createClass({displayName:"Rate",propTypes:{disabled:_react.PropTypes.bool,value:_react.PropTypes.number,defaultValue:_react.PropTypes.number,count:_react.PropTypes.number,allowHalf:_react.PropTypes.bool,style:_react.PropTypes.object,prefixCls:_react.PropTypes.string,onChange:_react.PropTypes.func},getDefaultProps:function getDefaultProps(){return{defaultValue:0,count:5,allowHalf:false,style:{},prefixCls:"rc-rate",className:"",onChange:noop};},getInitialState:function getInitialState(){var value=this.props.value;if(value===undefined){value=this.props.defaultValue;}return{value:value};},componentWillReceiveProps:function componentWillReceiveProps(nextProps){if("value"in nextProps){var value=nextProps.value;if(value===undefined){value=nextProps.defaultValue;}this.setState({value:value});}},onHover:function onHover(event,index){var hoverValue=this.getStarValue(index,event.pageX);this.setState({hoverValue:hoverValue});},onMouseLeave:function onMouseLeave(){this.setState({hoverValue:undefined});},onClick:function onClick(event,index){var value=this.getStarValue(index,event.pageX);if(!("value"in this.props)){this.setState({value:value});}this.onMouseLeave();this.props.onChange(value);},getStarDOM:function getStarDOM(index){return _reactDom2.default.findDOMNode(this.refs["star_"+index]);},getStarValue:function getStarValue(index,x){var value=index+1;if(this.props.allowHalf){var leftEdge=(0,_util.getOffsetLeft)(this.getStarDOM(0));var width=(0,_util.getOffsetLeft)(this.getStarDOM(1))-leftEdge;if(x-leftEdge-width*index<width/2){value-=0.5;}}return value;},render:function render(){var _props=this.props,count=_props.count,allowHalf=_props.allowHalf,style=_props.style,prefixCls=_props.prefixCls,disabled=_props.disabled,className=_props.className;var _state=this.state,value=_state.value,hoverValue=_state.hoverValue;var stars=[];var disabledClass=disabled?prefixCls+"-disabled":"";for(var index=0;index<count;index++){stars.push(_react2.default.createElement(_Star2.default,{ref:"star_"+index,index:index,disabled:disabled,prefixCls:prefixCls+"-star",allowHalf:allowHalf,value:hoverValue===undefined?value:hoverValue,onClick:this.onClick,onHover:this.onHover,key:index}));}return _react2.default.createElement("ul",{className:prefixCls+" "+disabledClass+" "+className,style:style,onMouseLeave:disabled?null:this.onMouseLeave},stars);}});exports.default=Rate;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getOffsetLeft=getOffsetLeft;function getScroll(w,top){var ret=top?w.pageYOffset:w.pageXOffset;var method=top?'scrollTop':'scrollLeft';if(typeof ret!=='number'){var d=w.document;// ie6,7,8 standard mode
ret=d.documentElement[method];if(typeof ret!=='number'){// quirks mode
ret=d.body[method];}}return ret;}function getClientPosition(elem){var box=void 0;var x=void 0;var y=void 0;var doc=elem.ownerDocument;var body=doc.body;var docElem=doc&&doc.documentElement;box=elem.getBoundingClientRect();x=box.left;y=box.top;x-=docElem.clientLeft||body.clientLeft||0;y-=docElem.clientTop||body.clientTop||0;return{left:x,top:y};}function getOffsetLeft(el){var pos=getClientPosition(el);var doc=el.ownerDocument;var w=doc.defaultView||doc.parentWindow;pos.left+=getScroll(w);return pos.left;}

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Star=_react2.default.createClass({displayName:'Star',propTypes:{value:_react.PropTypes.number,index:_react.PropTypes.number,prefixCls:_react.PropTypes.string,allowHalf:_react.PropTypes.bool,disabled:_react.PropTypes.bool,onHover:_react.PropTypes.func,onClick:_react.PropTypes.func},onHover:function onHover(e){this.props.onHover(e,this.props.index);},onClick:function onClick(e){this.props.onClick(e,this.props.index);},getClassName:function getClassName(){var _props=this.props,index=_props.index,value=_props.value,prefixCls=_props.prefixCls,allowHalf=_props.allowHalf;var starValue=index+1;if(allowHalf&&value+0.5===starValue){return prefixCls+' '+prefixCls+'-half '+prefixCls+'-active';}return starValue<=value?prefixCls+' '+prefixCls+'-full':prefixCls+' '+prefixCls+'-zero';},render:function render(){var onHover=this.onHover,onClick=this.onClick;var _props2=this.props,disabled=_props2.disabled,prefixCls=_props2.prefixCls;return _react2.default.createElement('li',{className:this.getClassName(),onClick:disabled?null:onClick,onMouseMove:disabled?null:onHover},_react2.default.createElement('div',{className:prefixCls+'-content'}));}});exports.default=Star;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(695);

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(132);

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _RCSelect=__webpack_require__(698);var _RCSelect2=_interopRequireDefault(_RCSelect);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Select=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Select,_React$Component);function Select(){(0,_classCallCheck3.default)(this,Select);return(0,_possibleConstructorReturn3.default)(this,(Select.__proto__||(0,_getPrototypeOf2.default)(Select)).apply(this,arguments));}(0,_createClass3.default)(Select,[{key:"render",value:function render(){var _classNames;var _props=this.props,size=_props.size,className=_props.className,combobox=_props.combobox,notFoundContent=_props.notFoundContent,prefixCls=_props.prefixCls,showSearch=_props.showSearch,optionLabelProp=_props.optionLabelProp;var cls=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls+"-lg",size==="large"),(0,_defineProperty3.default)(_classNames,prefixCls+"-sm",size==="small"),(0,_defineProperty3.default)(_classNames,className,!!className),(0,_defineProperty3.default)(_classNames,prefixCls+"-show-search",showSearch),_classNames));var antLocale=this.context.antLocale;if(antLocale&&antLocale.Select){notFoundContent=notFoundContent||antLocale.Select.notFoundContent;}if(combobox){notFoundContent=null;// children 带 dom 结构时，无法填入输入框
optionLabelProp=optionLabelProp||"value";}return _react2.default.createElement(_RCSelect2.default,(0,_extends3.default)({},this.props,{ecId:this.props.ecId+"_RcSelect@8nckz1",className:cls,optionLabelProp:optionLabelProp||"children",notFoundContent:notFoundContent}));}}]);return Select;}(_react2.default.Component),_class.Option=_RCSelect.Option,_class.OptGroup=_RCSelect.OptGroup,_class.defaultProps={prefixCls:"ant-select",transitionName:"slide-up",choiceTransitionName:"zoom",showSearch:false},_class.contextTypes={antLocale:_react2.default.PropTypes.object},_temp);exports.default=Select;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SelectPropTypes=exports.OptGroup=exports.Option=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _Option=__webpack_require__(699);var _Option2=_interopRequireDefault(_Option);var _PropTypes=__webpack_require__(272);var _OptGroup=__webpack_require__(700);var _OptGroup2=_interopRequireDefault(_OptGroup);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import Select from './Select';
var Select=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 805));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});Select.Option=_Option2.default;Select.OptGroup=_OptGroup2.default;exports.Option=_Option2.default;exports.OptGroup=_OptGroup2.default;exports.SelectPropTypes=_PropTypes.SelectPropTypes;exports.default=Select;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(15);var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Option=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Option,_React$Component);function Option(){(0,_classCallCheck3.default)(this,Option);return(0,_possibleConstructorReturn3.default)(this,(Option.__proto__||(0,_getPrototypeOf2.default)(Option)).apply(this,arguments));}return Option;}(_react2.default.Component),_class.propTypes={value:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number])},_class.isSelectOption=true,_temp);exports.default=Option;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var OptGroup=(_temp=_class=function(_React$Component){(0,_inherits3.default)(OptGroup,_React$Component);function OptGroup(){(0,_classCallCheck3.default)(this,OptGroup);return(0,_possibleConstructorReturn3.default)(this,(OptGroup.__proto__||(0,_getPrototypeOf2.default)(OptGroup)).apply(this,arguments));}return OptGroup;}(_react2.default.Component),_class.isSelectOptGroup=true,_temp);exports.default=OptGroup;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _class,_temp;// import RcSlider from 'rc-slider';
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RcSlider=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 806));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var Slider=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Slider,_React$Component);function Slider(){(0,_classCallCheck3.default)(this,Slider);return(0,_possibleConstructorReturn3.default)(this,(Slider.__proto__||(0,_getPrototypeOf2.default)(Slider)).apply(this,arguments));}(0,_createClass3.default)(Slider,[{key:"render",value:function render(){var _props=this.props,isIncluded=_props.isIncluded,marks=_props.marks,index=_props.index,defaultIndex=_props.defaultIndex,rest=(0,_objectWithoutProperties3.default)(_props,["isIncluded","marks","index","defaultIndex"]);if(isIncluded!==undefined){// 兼容 `isIncluded`
rest.included=isIncluded;}if(Array.isArray(marks)){// 兼容当 marks 为数组的情况
rest.min=0;rest.max=marks.length-1;rest.step=1;if(index!==undefined){rest.value=index;}if(defaultIndex!==undefined){rest.defaultValue=defaultIndex;}rest.marks={};marks.forEach(function(val,idx){rest.marks[idx]=val;});}else{rest.marks=marks;}return _react2.default.createElement(RcSlider,rest);}}]);return Slider;}(_react2.default.Component),_class.defaultProps={prefixCls:"ant-slider",tipTransitionName:"zoom-down"},_temp);exports.default=Slider;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(703);__webpack_require__(232);

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _class,_temp;// import RcSteps from '../../_rc-steps-3.0.1';
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RcSteps=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(3/* limit */).then(__webpack_require__.bind(null, 807));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var Step=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(3/* limit */).then(__webpack_require__.bind(null, 788));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var Steps=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Steps,_React$Component);function Steps(){(0,_classCallCheck3.default)(this,Steps);return(0,_possibleConstructorReturn3.default)(this,(Steps.__proto__||(0,_getPrototypeOf2.default)(Steps)).apply(this,arguments));}(0,_createClass3.default)(Steps,[{key:"render",// static Step = RcSteps.Step;
value:function render(){return _react2.default.createElement(RcSteps,this.props);}}]);return Steps;}(_react2.default.Component),_class.Step=Step,_class.defaultProps={prefixCls:"ant-steps",iconPrefix:"ant",current:0},_temp);exports.default=Steps;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(708);

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _rcSwitch=__webpack_require__(711);var _rcSwitch2=_interopRequireDefault(_rcSwitch);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Switch=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Switch,_React$Component);function Switch(){(0,_classCallCheck3.default)(this,Switch);return(0,_possibleConstructorReturn3.default)(this,(Switch.__proto__||(0,_getPrototypeOf2.default)(Switch)).apply(this,arguments));}(0,_createClass3.default)(Switch,[{key:'render',value:function render(){var _classNames;var _props=this.props,prefixCls=_props.prefixCls,size=_props.size,className=_props.className;var cls=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,className,!!className),(0,_defineProperty3.default)(_classNames,prefixCls+'-small',size==='small'),_classNames));return _react2.default.createElement(_rcSwitch2.default,(0,_extends3.default)({className:cls},this.props));}}]);return Switch;}(_react2.default.Component),_class.defaultProps={prefixCls:'ant-switch'},_temp);exports.default=Switch;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(712);

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(15);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var classNames = __webpack_require__(7);

function noop() {}

var Switch = function (_Component) {
  _inherits(Switch, _Component);

  function Switch(props) {
    _classCallCheck(this, Switch);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    var checked = false;
    if ('checked' in props) {
      checked = !!props.checked;
    } else {
      checked = !!props.defaultChecked;
    }
    _this.state = { checked: checked };
    return _this;
  }

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({
        checked: !!nextProps.checked
      });
    }
  };

  Switch.prototype.setChecked = function setChecked(checked) {
    if (!('checked' in this.props)) {
      this.setState({
        checked: checked
      });
    }
    this.props.onChange(checked);
  };

  Switch.prototype.toggle = function toggle() {
    var checked = !this.state.checked;
    this.setChecked(checked);
  };

  Switch.prototype.handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === 37) {
      this.setChecked(false);
    }
    if (e.keyCode === 39) {
      this.setChecked(true);
    }
  };

  // Handle auto focus when click switch in Chrome


  Switch.prototype.handleMouseUp = function handleMouseUp(e) {
    if (this.refs.node) {
      this.refs.node.blur();
    }
    if (this.props.onMouseUp) {
      this.props.onMouseUp(e);
    }
  };

  Switch.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        className = _props.className,
        prefixCls = _props.prefixCls,
        disabled = _props.disabled,
        checkedChildren = _props.checkedChildren,
        unCheckedChildren = _props.unCheckedChildren,
        restProps = _objectWithoutProperties(_props, ['className', 'prefixCls', 'disabled', 'checkedChildren', 'unCheckedChildren']);

    var checked = this.state.checked;
    var switchClassName = classNames((_classNames = {}, _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, prefixCls + '-checked', checked), _defineProperty(_classNames, prefixCls + '-disabled', disabled), _classNames));
    return _react2["default"].createElement(
      'span',
      _extends({}, restProps, {
        className: switchClassName,
        tabIndex: disabled ? -1 : 0,
        ref: 'node',
        onKeyDown: this.handleKeyDown.bind(this),
        onClick: disabled ? noop : this.toggle.bind(this),
        onMouseUp: this.handleMouseUp.bind(this)
      }),
      _react2["default"].createElement(
        'span',
        { className: prefixCls + '-inner' },
        checked ? checkedChildren : unCheckedChildren
      )
    );
  };

  return Switch;
}(_react.Component);

Switch.propTypes = {
  className: _propTypes2["default"].string,
  prefixCls: _propTypes2["default"].string,
  disabled: _propTypes2["default"].bool,
  checkedChildren: _propTypes2["default"].any,
  unCheckedChildren: _propTypes2["default"].any,
  onChange: _propTypes2["default"].func,
  onMouseUp: _propTypes2["default"].func,
  checked: _propTypes2["default"].bool,
  defaultChecked: _propTypes2["default"].bool
};

Switch.defaultProps = {
  prefixCls: 'rc-switch',
  checkedChildren: null,
  unCheckedChildren: null,
  className: '',
  defaultChecked: false,
  onChange: noop
};

exports["default"] = Switch;
module.exports = exports['default'];

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(714);

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import Table from './Table';
var Table=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 808));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=Table;

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _rcTabs=__webpack_require__(718);var _rcTabs2=_interopRequireDefault(_rcTabs);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);var _isEmpty=__webpack_require__(100);var _isEmpty2=_interopRequireDefault(_isEmpty);var _uniqueId=__webpack_require__(724);var _uniqueId2=_interopRequireDefault(_uniqueId);var _remove=__webpack_require__(725);var _remove2=_interopRequireDefault(_remove);var _middleware=__webpack_require__(27);var _middleware2=_interopRequireDefault(_middleware);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Tabs=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Tabs,_React$Component);function Tabs(props){(0,_classCallCheck3.default)(this,Tabs);var _this=(0,_possibleConstructorReturn3.default)(this,(Tabs.__proto__||(0,_getPrototypeOf2.default)(Tabs)).call(this,props));_this.createNewTab=function(targetKey){_this.props.onEdit(targetKey,"add");};_this.removeTab=function(targetKey,e){e.stopPropagation();if(!targetKey){return;}_this.props.onEdit(targetKey,"remove");};_this.handleChange=function(activeKey){_this.props.onChange(activeKey);};_this.getActiceName=function(){var _this$props=_this.props,_this$props$datas=_this$props.datas,datas=_this$props$datas===undefined?[]:_this$props$datas,activeKey=_this$props.activeKey,keyParam=_this$props.keyParam;var _datas=datas.slice();var name="";Array.isArray(_datas)&&!(0,_isEmpty2.default)(_datas)&&_datas.forEach(function(v){v[keyParam]==activeKey&&(name=v.title);});return name;};_this.index=(0,_uniqueId2.default)("tabKey");return _this;}(0,_createClass3.default)(Tabs,[{key:"componentWillUnmount",value:function componentWillUnmount(){var _this2=this;(0,_remove2.default)(window.tabKeys,function(o){return o.slice(0,o.indexOf("_"))===_this2.index;});}},{key:"render",value:function render(){var _classNames,_this3=this;var _props=this.props,prefixCls=_props.prefixCls,size=_props.size,tabPosition=_props.tabPosition,animation=_props.animation,type=_props.type,children=_props.children,tabBarExtraContent=_props.tabBarExtraContent,hideAdd=_props.hideAdd,activeKey=_props.activeKey;var className=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,this.props.className,!!this.props.className),(0,_defineProperty3.default)(_classNames,prefixCls+"-mini",size==="small"||size==="mini"),(0,_defineProperty3.default)(_classNames,prefixCls+"-vertical",tabPosition==="left"||tabPosition==="right"),(0,_defineProperty3.default)(_classNames,prefixCls+"-card",type.indexOf("card")>=0),(0,_defineProperty3.default)(_classNames,prefixCls+"-"+type,true),_classNames));if(tabPosition==="left"||tabPosition==="right"||type.indexOf("card")>=0){animation=null;}// only card type tabs can be added and closed
var childrenWithCross=void 0;if(type==="editable-card"){childrenWithCross=[];_react2.default.Children.forEach(children,function(child,index){childrenWithCross.push((0,_react.cloneElement)(child,{tab:_react2.default.createElement("div",null,child.props.tab,_react2.default.createElement(_icon2.default,{ecId:_this3.props.ecId+"_Icon@n8wd4n",type:"cross",onClick:function onClick(e){return _this3.removeTab(child.key,e);}})),key:child.key||index}));});// Add new tab handler
if(!hideAdd){tabBarExtraContent=_react2.default.createElement("span",null,_react2.default.createElement(_icon2.default,{ecId:this.props.ecId+"_Icon@w421dh",type:"plus",className:prefixCls+"-new-tab",onClick:this.createNewTab}),tabBarExtraContent);}}tabBarExtraContent=tabBarExtraContent?_react2.default.createElement("div",{className:prefixCls+"-extra-content"},tabBarExtraContent):null;var name=this.getActiceName();var res=this.index+"_key:"+activeKey+"_name:"+name;if(Array.isArray(window.tabKeys)){var index=-1;window.tabKeys.forEach(function(v,l){v.slice(0,v.indexOf("_"))===_this3.index&&(index=l);});index!==-1?window.tabKeys[index]=res:window.tabKeys.push(res);}else{window.tabKeys=[res];}return _react2.default.createElement(_rcTabs2.default,(0,_extends3.default)({},this.props,{ecId:this.props.ecId+"_RcTabs@pnkieg",className:className,tabBarExtraContent:tabBarExtraContent,onChange:this.handleChange,animation:animation}),childrenWithCross||children);}}]);return Tabs;}(_react2.default.Component),_class.TabPane=_rcTabs2.default.TabPane,_class.defaultProps={prefixCls:"ant-tabs",animation:"slide-horizontal",type:"line",// or 'card' 'editable-card'
onChange:function onChange(){},onEdit:function onEdit(){},hideAdd:false},_temp);var Com=(0,_middleware2.default)(Tabs,"Tabs");exports.default=Com;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports=__webpack_require__(719);

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.TabPane=exports.default=undefined;var _Tabs=__webpack_require__(720);var _Tabs2=_interopRequireDefault(_Tabs);var _TabPane2=__webpack_require__(234);var _TabPane3=_interopRequireDefault(_TabPane2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Tabs2.default;exports.TabPane=_TabPane3.default;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _KeyCode=__webpack_require__(721);var _KeyCode2=_interopRequireDefault(_KeyCode);var _TabPane=__webpack_require__(234);var _TabPane2=_interopRequireDefault(_TabPane);var _Nav=__webpack_require__(722);var _Nav2=_interopRequireDefault(_Nav);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _classnames2=__webpack_require__(7);var _classnames3=_interopRequireDefault(_classnames2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function noop(){}function getDefaultActiveKey(props){var activeKey=void 0;_react2.default.Children.forEach(props.children,function(child){if(!child){return;}if(!activeKey&&!child.props.disabled){activeKey=child.key;}});return activeKey;}var Tabs=_react2.default.createClass({displayName:"Tabs",propTypes:{destroyInactiveTabPane:_react.PropTypes.bool,onTabClick:_react.PropTypes.func,onChange:_react.PropTypes.func,children:_react.PropTypes.any,tabBarExtraContent:_react.PropTypes.any,animation:_react.PropTypes.string,prefixCls:_react.PropTypes.string,className:_react.PropTypes.string,tabPosition:_react.PropTypes.string},getDefaultProps:function getDefaultProps(){return{prefixCls:"rc-tabs",destroyInactiveTabPane:false,tabBarExtraContent:null,onChange:noop,tabPosition:"top",style:{},contentStyle:{},navStyle:{},onTabClick:noop};},getInitialState:function getInitialState(){var props=this.props;var activeKey=void 0;if("activeKey"in props){activeKey=props.activeKey;}else if("defaultActiveKey"in props){activeKey=props.defaultActiveKey;}else{activeKey=getDefaultActiveKey(props);}return{activeKey:activeKey};},componentWillReceiveProps:function componentWillReceiveProps(nextProps){var newActiveKey=this.state.activeKey;if("activeKey"in nextProps){newActiveKey=nextProps.activeKey;if(!newActiveKey){this.setState({activeKey:newActiveKey});return;}}var found=void 0;_react2.default.Children.forEach(nextProps.children,function(child){if(!child){return;}if(child.key===newActiveKey){found=true;}});if(found){this.setActiveKey(newActiveKey,nextProps);}else{this.setActiveKey(getDefaultActiveKey(nextProps),nextProps);}},getTabKey:function getTabKey(){var _tabKeys=window.tabKeys;var max=0;_tabKeys.forEach(function(c){if(c===max)max++;});return max;},onTabClick:function onTabClick(key){this.setActiveKey(key);this.props.onTabClick(key);if(this.state.activeKey!==key){this.props.onChange(key);}},onNavKeyDown:function onNavKeyDown(e){var eventKeyCode=e.keyCode;if(eventKeyCode===_KeyCode2.default.RIGHT||eventKeyCode===_KeyCode2.default.DOWN){e.preventDefault();var nextKey=this.getNextActiveKey(true);this.onTabClick(nextKey);}else if(eventKeyCode===_KeyCode2.default.LEFT||eventKeyCode===_KeyCode2.default.UP){e.preventDefault();var previousKey=this.getNextActiveKey(false);this.onTabClick(previousKey);}},getNextActiveKey:function getNextActiveKey(next){var activeKey=this.state.activeKey;var children=[];_react2.default.Children.forEach(this.props.children,function(c){if(!c){return;}if(!c.props.disabled){if(next){children.push(c);}else{children.unshift(c);}}});var length=children.length;var ret=length&&children[0].key;children.forEach(function(child,i){if(!child){return;}if(child.key===activeKey){if(i===length-1){ret=children[0].key;}else{ret=children[i+1].key;}}});return ret;},getTabPanes:function getTabPanes(){var state=this.state;var props=this.props;var activeKey=state.activeKey;var children=props.children;var newChildren=[];_react2.default.Children.forEach(children,function(child){if(!child){return;}var key=child.key;var active=activeKey===key;newChildren.push(_react2.default.cloneElement(child,{active:active,// eventKey: key,
rootPrefixCls:props.prefixCls}));});return newChildren;},getIndexPair:function getIndexPair(props,currentActiveKey,activeKey){var keys=[];_react2.default.Children.forEach(props.children,function(c){if(!c){return;}keys.push(c.key);});var currentIndex=keys.indexOf(currentActiveKey);var nextIndex=keys.indexOf(activeKey);return{currentIndex:currentIndex,nextIndex:nextIndex};},setActiveKey:function setActiveKey(activeKey,ps){var props=ps||this.props;var currentActiveKey=this.state.activeKey;if(currentActiveKey===activeKey||"activeKey"in props&&props===this.props){return;}if(!currentActiveKey){this.setState({activeKey:activeKey});}else{var _getIndexPair=this.getIndexPair(props,currentActiveKey,activeKey),currentIndex=_getIndexPair.currentIndex,nextIndex=_getIndexPair.nextIndex;// removed
if(currentIndex===-1){var newPair=this.getIndexPair(this.props,currentActiveKey,activeKey);currentIndex=newPair.currentIndex;nextIndex=newPair.nextIndex;}var tabMovingDirection=currentIndex>nextIndex?"backward":"forward";this.setState({activeKey:activeKey,tabMovingDirection:tabMovingDirection});}},render:function render(){var _classnames;var props=this.props;var destroyInactiveTabPane=props.destroyInactiveTabPane,prefixCls=props.prefixCls,tabPosition=props.tabPosition,className=props.className,animation=props.animation;var cls=(0,_classnames3.default)((_classnames={},(0,_defineProperty3.default)(_classnames,prefixCls,1),(0,_defineProperty3.default)(_classnames,prefixCls+"-"+tabPosition,1),(0,_defineProperty3.default)(_classnames,className,!!className),_classnames));var tabMovingDirection=this.state.tabMovingDirection;var tabPanes=this.getTabPanes();var transitionName=void 0;transitionName=props.transitionName&&props.transitionName[tabMovingDirection||"backward"];if(!transitionName&&animation){transitionName=prefixCls+"-"+animation+"-"+(tabMovingDirection||"backward");}if(destroyInactiveTabPane){tabPanes=tabPanes.filter(function(panel){return panel.props.active;});}if(transitionName){if(destroyInactiveTabPane){tabPanes=_react2.default.createElement(_rcAnimate2.default,{ecId:this.props.ecId+"_Animate@cyc2tn",exclusive:true,component:"div",transitionName:transitionName},tabPanes);}else{tabPanes=_react2.default.createElement(_rcAnimate2.default,{ecId:this.props.ecId+"_Animate@54z5qk",showProp:"active",exclusive:true,component:"div",transitionName:transitionName},tabPanes);}}var contents=[_react2.default.createElement(_Nav2.default,{ecId:this.props.ecId+"_Nav@z1xp6c",prefixCls:prefixCls,key:"nav",onKeyDown:this.onNavKeyDown,tabBarExtraContent:this.props.tabBarExtraContent,tabPosition:tabPosition,style:props.navStyle,onTabClick:this.onTabClick,tabMovingDirection:tabMovingDirection,panels:this.props.children,activeKey:this.state.activeKey}),_react2.default.createElement("div",{ecId:this.props.ecId+"_div@c8vtwu",className:prefixCls+"-content",style:props.contentStyle,key:"content"},tabPanes)];if(tabPosition==="bottom"){contents.reverse();}return _react2.default.createElement("div",{className:cls,style:props.style},contents);}});Tabs.TabPane=_TabPane2.default;exports.default=Tabs;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={/**
   * LEFT
   */LEFT:37,// also NUM_WEST
/**
   * UP
   */UP:38,// also NUM_NORTH
/**
   * RIGHT
   */RIGHT:39,// also NUM_EAST
/**
   * DOWN
   */DOWN:40// also NUM_SOUTH
};

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames3=__webpack_require__(7);var _classnames4=_interopRequireDefault(_classnames3);var _InkBarMixin=__webpack_require__(723);var _InkBarMixin2=_interopRequireDefault(_InkBarMixin);var _utils=__webpack_require__(235);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var tabBarExtraContentStyle={float:"right"};function noop(){}var Nav=_react2.default.createClass({displayName:"Nav",propTypes:{tabPosition:_react.PropTypes.string,tabBarExtraContent:_react.PropTypes.any,onTabClick:_react.PropTypes.func,onKeyDown:_react.PropTypes.func},mixins:[_InkBarMixin2.default],getInitialState:function getInitialState(){return{next:false,offset:0,prev:false};},componentDidMount:function componentDidMount(){this.componentDidUpdate();},componentDidUpdate:function componentDidUpdate(prevProps){var props=this.props;if(prevProps&&prevProps.tabPosition!==props.tabPosition){this.setOffset(0);return;}var navNode=this.refs.nav;var navNodeWH=this.getOffsetWH(navNode);var navWrapNode=this.refs.navWrap;var navWrapNodeWH=this.getOffsetWH(navWrapNode);var state=this.state;var offset=state.offset;var minOffset=navWrapNodeWH-navNodeWH;var _state=this.state,next=_state.next,prev=_state.prev;if(minOffset>=0){next=false;this.setOffset(0);offset=0;}else if(minOffset<offset){next=true;}else{next=false;this.setOffset(minOffset);offset=minOffset;}if(offset<0){prev=true;}else{prev=false;}this.setNext(next);this.setPrev(prev);var nextPrev={next:next,prev:prev};// wait next,prev show hide
if(this.isNextPrevShown(state)!==this.isNextPrevShown(nextPrev)){this.setNextPrev({},this.scrollToActiveTab);}else{// can not use props.activeKey
if(!prevProps||props.activeKey!==prevProps.activeKey){this.scrollToActiveTab();}}},onTabClick:function onTabClick(key){this.props.onTabClick(key);},// work around eslint warning
setNextPrev:function setNextPrev(nextPrev,callback){this.setState(nextPrev,callback);},getTabs:function getTabs(){var _this=this;var props=this.props;var children=props.panels;var activeKey=props.activeKey;var rst=[];var prefixCls=props.prefixCls;_react2.default.Children.forEach(children,function(child){if(!child){return;}var key=child.key;var cls=child.props.className||"";// zxt - 20171111
cls+=activeKey===key?" "+prefixCls+"-tab-active":"";cls+=" "+prefixCls+"-tab";var events={};if(child.props.disabled){cls+=" "+prefixCls+"-tab-disabled";}else{events={onClick:_this.onTabClick.bind(_this,key)};}var ref={};if(activeKey===key){ref.ref="activeTab";}rst.push(_react2.default.createElement("div",(0,_extends3.default)({ecId:_this.props.ecId+"_div@sygtfb@"+key,role:"tab","aria-disabled":child.props.disabled?"true":"false","aria-selected":activeKey===key?"true":"false"},events,{className:cls,key:key},ref),_react2.default.createElement("div",{className:prefixCls+"-tab-inner",title:child.props.title},child.props.tab)));});return rst;},getOffsetWH:function getOffsetWH(node){var tabPosition=this.props.tabPosition;var prop="offsetWidth";if(tabPosition==="left"||tabPosition==="right"){prop="offsetHeight";}return node[prop];},getOffsetLT:function getOffsetLT(node){var tabPosition=this.props.tabPosition;var prop="left";if(tabPosition==="left"||tabPosition==="right"){prop="top";}return node.getBoundingClientRect()[prop];},setOffset:function setOffset(offset){var target=Math.min(0,offset);if(this.state.offset!==target){this.setState({offset:target});var navOffset={};var tabPosition=this.props.tabPosition;var transformProperty=(0,_utils.getTransformPropertyName)();if(tabPosition==="left"||tabPosition==="right"){if(transformProperty){navOffset={name:transformProperty,value:"translate3d(0,"+target+"px,0)"};}else{navOffset={name:"top",value:target+"px"};}}else{if(transformProperty){navOffset={name:transformProperty,value:"translate3d("+target+"px,0,0)"};}else{navOffset={name:"left",value:target+"px"};}}this.refs.nav.style[navOffset.name]=navOffset.value;}},setPrev:function setPrev(v){if(this.state.prev!==v){this.setState({prev:v});}},setNext:function setNext(v){if(this.state.next!==v){this.setState({next:v});}},isNextPrevShown:function isNextPrevShown(state){return state.next||state.prev;},scrollToActiveTab:function scrollToActiveTab(){var _refs=this.refs,activeTab=_refs.activeTab,navWrap=_refs.navWrap;if(activeTab){var activeTabWH=this.getOffsetWH(activeTab);var navWrapNodeWH=this.getOffsetWH(navWrap);var offset=this.state.offset;var wrapOffset=this.getOffsetLT(navWrap);var activeTabOffset=this.getOffsetLT(activeTab);if(wrapOffset>activeTabOffset){offset+=wrapOffset-activeTabOffset;this.setState({offset:offset});//zxt - 20180702
this.setOffset(offset);}else if(wrapOffset+navWrapNodeWH<activeTabOffset+activeTabWH){offset-=activeTabOffset+activeTabWH-(wrapOffset+navWrapNodeWH);this.setState({offset:offset});//zxt - 20180702
this.setOffset(offset);}}},prev:function prev(){var navWrapNode=this.refs.navWrap;var navWrapNodeWH=this.getOffsetWH(navWrapNode);var state=this.state;var offset=state.offset;this.setOffset(offset+navWrapNodeWH);},next:function next(){var navWrapNode=this.refs.navWrap;var navWrapNodeWH=this.getOffsetWH(navWrapNode);var state=this.state;var offset=state.offset;this.setOffset(offset-navWrapNodeWH);},render:function render(){var props=this.props;var state=this.state;var prefixCls=props.prefixCls;var tabs=this.getTabs();var tabMovingDirection=props.tabMovingDirection;var inkBarClass=prefixCls+"-ink-bar";if(tabMovingDirection){inkBarClass+=" "+prefixCls+"-ink-bar-transition-"+tabMovingDirection;}var nextButton=void 0;var prevButton=void 0;var showNextPrev=state.prev||state.next;if(showNextPrev){var _classnames,_classnames2;prevButton=_react2.default.createElement("span",{ecId:this.props.ecId+"_span@yq6fn1",onClick:state.prev?this.prev:noop,unselectable:"unselectable",className:(0,_classnames4.default)((_classnames={},(0,_defineProperty3.default)(_classnames,prefixCls+"-tab-prev",1),(0,_defineProperty3.default)(_classnames,prefixCls+"-tab-btn-disabled",!state.prev),_classnames))},_react2.default.createElement("span",{className:prefixCls+"-tab-prev-icon"}));nextButton=_react2.default.createElement("span",{ecId:this.props.ecId+"_span@zi23d1",onClick:state.next?this.next:noop,unselectable:"unselectable",className:(0,_classnames4.default)((_classnames2={},(0,_defineProperty3.default)(_classnames2,prefixCls+"-tab-next",1),(0,_defineProperty3.default)(_classnames2,prefixCls+"-tab-btn-disabled",!state.next),_classnames2))},_react2.default.createElement("span",{className:prefixCls+"-tab-next-icon"}));}var tabBarExtraContent=this.props.tabBarExtraContent;return _react2.default.createElement("div",{ecId:this.props.ecId+"_div@apo3uf",role:"tablist",className:prefixCls+"-bar",tabIndex:"0",onKeyDown:this.props.onKeyDown},tabBarExtraContent?_react2.default.createElement("div",{style:tabBarExtraContentStyle},tabBarExtraContent):null,_react2.default.createElement("div",{className:prefixCls+"-nav-container "+(showNextPrev?prefixCls+"-nav-container-scrolling":""),style:props.style,ref:"container"},prevButton,nextButton,_react2.default.createElement("div",{className:prefixCls+"-nav-wrap",ref:"navWrap"},_react2.default.createElement("div",{className:prefixCls+"-nav-scroll"},_react2.default.createElement("div",{className:prefixCls+"-nav",ref:"nav"},_react2.default.createElement("div",{className:inkBarClass,ref:"inkBar"}),tabs)))));}});exports.default=Nav;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _utils=__webpack_require__(235);function _componentDidUpdate(component){var refs=component.refs;var containerNode=refs.nav;var containerOffset=(0,_utils.offset)(containerNode);var inkBarNode=refs.inkBar;var activeTab=refs.activeTab;var tabPosition=component.props.tabPosition;if(activeTab){var tabNode=activeTab;var tabOffset=(0,_utils.offset)(tabNode);var transformPropertyName=(0,_utils.getTransformPropertyName)();if(tabPosition==='top'||tabPosition==='bottom'){var left=tabOffset.left-containerOffset.left;// use 3d gpu to optimize render
if(transformPropertyName){inkBarNode.style[transformPropertyName]='translate3d('+left+'px,0,0)';inkBarNode.style.width=tabNode.offsetWidth+'px';inkBarNode.style.height='';}else{inkBarNode.style.left=left+'px';inkBarNode.style.top='';inkBarNode.style.bottom='';inkBarNode.style.right=containerNode.offsetWidth-left-tabNode.offsetWidth+'px';}}else{var top=tabOffset.top-containerOffset.top;if(transformPropertyName){inkBarNode.style[transformPropertyName]='translate3d(0,'+top+'px,0)';inkBarNode.style.height=tabNode.offsetHeight+'px';inkBarNode.style.width='';}else{inkBarNode.style.left='';inkBarNode.style.right='';inkBarNode.style.top=top+'px';inkBarNode.style.bottom=containerNode.offsetHeight-top-tabNode.offsetHeight+'px';}}}inkBarNode.style.display=activeTab?'block':'none';}exports.default={componentDidUpdate:function componentDidUpdate(){_componentDidUpdate(this);},componentDidMount:function componentDidMount(){_componentDidUpdate(this);}};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(114);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(726),
    basePullAt = __webpack_require__(736);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(727),
    baseMatchesProperty = __webpack_require__(730),
    identity = __webpack_require__(136),
    isArray = __webpack_require__(26),
    property = __webpack_require__(733);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(728),
    getMatchData = __webpack_require__(729),
    matchesStrictComparable = __webpack_require__(237);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(122),
    baseIsEqual = __webpack_require__(121);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(236),
    keys = __webpack_require__(187);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(121),
    get = __webpack_require__(215),
    hasIn = __webpack_require__(731),
    isKey = __webpack_require__(134),
    isStrictComparable = __webpack_require__(236),
    matchesStrictComparable = __webpack_require__(237),
    toKey = __webpack_require__(54);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(732),
    hasPath = __webpack_require__(216);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 732 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(734),
    basePropertyDeep = __webpack_require__(735),
    isKey = __webpack_require__(134),
    toKey = __webpack_require__(54);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 734 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(133);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(737),
    isIndex = __webpack_require__(66);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(93),
    last = __webpack_require__(738),
    parent = __webpack_require__(739),
    toKey = __webpack_require__(54);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 738 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(133),
    baseSlice = __webpack_require__(173);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(741);

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _object=__webpack_require__(44);var _object2=_interopRequireDefault(_object);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Tag=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Tag,_React$Component);function Tag(props){(0,_classCallCheck3.default)(this,Tag);var _this=(0,_possibleConstructorReturn3.default)(this,(Tag.__proto__||(0,_getPrototypeOf2.default)(Tag)).call(this,props));_this.close=function(e){_this.props.onClose(e);if(e.defaultPrevented)return;var dom=_reactDom2.default.findDOMNode(_this);dom.style.width=dom.getBoundingClientRect().width+'px';// It's Magic Code, don't know why
dom.style.width=dom.getBoundingClientRect().width+'px';_this.setState({closing:true});};_this.animationEnd=function(key,existed){if(!existed&&!_this.state.closed){_this.setState({closed:true,closing:false});_this.props.afterClose();}};_this.state={closing:false,closed:false};return _this;}(0,_createClass3.default)(Tag,[{key:'render',value:function render(){var _classNames;var _props=this.props,prefixCls=_props.prefixCls,closable=_props.closable,color=_props.color,className=_props.className,children=_props.children,_props$style=_props.style,style=_props$style===undefined?null:_props$style,otherProps=(0,_objectWithoutProperties3.default)(_props,['prefixCls','closable','color','className','children','style']);var crossStyle=style&&style.color?{color:style.color}:null;var closeIcon=closable?_react2.default.createElement(_icon2.default,{type:'cross',style:crossStyle,onClick:this.close}):'';var classString=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls,true),(0,_defineProperty3.default)(_classNames,prefixCls+'-'+color,!!color),(0,_defineProperty3.default)(_classNames,prefixCls+'-close',this.state.closing),(0,_defineProperty3.default)(_classNames,className,!!className),_classNames));// fix https://fb.me/react-unknown-prop
var divProps=(0,_object2.default)(otherProps,['onClose','afterClose']);return _react2.default.createElement(_rcAnimate2.default,{component:'',showProp:'data-show',transitionName:prefixCls+'-zoom',transitionAppear:true,onEnd:this.animationEnd},this.state.closed?null:_react2.default.createElement('div',(0,_extends3.default)({'data-show':!this.state.closing},divProps,{style:style||{backgroundColor:/blue|red|green|yellow/.test(color)?null:color},className:classString}),_react2.default.createElement('span',{className:prefixCls+'-text'},children),closeIcon));}}]);return Tag;}(_react2.default.Component),_class.defaultProps={prefixCls:'ant-tag',closable:false,onClose:function onClose(){},afterClose:function afterClose(){}},_temp);exports.default=Tag;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(744);

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TimePicker=(0,_reactLoadable2.default)({loader:function loader(){return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 809));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=TimePicker;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Timeline=__webpack_require__(747);var _Timeline2=_interopRequireDefault(_Timeline);var _TimelineItem=__webpack_require__(238);var _TimelineItem2=_interopRequireDefault(_TimelineItem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_Timeline2.default.Item=_TimelineItem2.default;exports.default=_Timeline2.default;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _objectWithoutProperties2=__webpack_require__(11);var _objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _TimelineItem=__webpack_require__(238);var _TimelineItem2=_interopRequireDefault(_TimelineItem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Timeline=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Timeline,_React$Component);function Timeline(){(0,_classCallCheck3.default)(this,Timeline);return(0,_possibleConstructorReturn3.default)(this,(Timeline.__proto__||(0,_getPrototypeOf2.default)(Timeline)).apply(this,arguments));}(0,_createClass3.default)(Timeline,[{key:'render',value:function render(){var _classNames;var _props=this.props,prefixCls=_props.prefixCls,children=_props.children,pending=_props.pending,className=_props.className,restProps=(0,_objectWithoutProperties3.default)(_props,['prefixCls','children','pending','className']);var pendingNode=typeof pending==='boolean'?null:pending;var classString=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls,true),(0,_defineProperty3.default)(_classNames,prefixCls+'-pending',!!pending),(0,_defineProperty3.default)(_classNames,className,className),_classNames));return _react2.default.createElement('ul',(0,_extends3.default)({},restProps,{className:classString}),_react2.default.Children.map(children,function(ele,idx){return _react2.default.cloneElement(ele,{last:idx===children.length-1});}),!!pending?_react2.default.createElement(_TimelineItem2.default,{pending:!!pending},pendingNode):null);}}]);return Timeline;}(_react2.default.Component),_class.defaultProps={prefixCls:'ant-timeline'},_temp);exports.default=Timeline;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(749);

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ListAsync=__webpack_require__(751);var _ListAsync2=_interopRequireDefault(_ListAsync);var _OperationAsync=__webpack_require__(752);var _OperationAsync2=_interopRequireDefault(_OperationAsync);var _SearchAsync=__webpack_require__(753);var _SearchAsync2=_interopRequireDefault(_SearchAsync);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Transfer=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 810));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});Transfer.List=_ListAsync2.default;Transfer.Operation=_OperationAsync2.default;Transfer.Search=_SearchAsync2.default;exports.default=Transfer;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TransferList=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 789));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=TransferList;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TransferOperation=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 791));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=TransferOperation;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Search=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 790));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=Search;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(755);__webpack_require__(53);__webpack_require__(64);__webpack_require__(37);

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _ListAsync=__webpack_require__(757);var _ListAsync2=_interopRequireDefault(_ListAsync);var _OperationAsync=__webpack_require__(758);var _OperationAsync2=_interopRequireDefault(_OperationAsync);var _SearchAsync=__webpack_require__(759);var _SearchAsync2=_interopRequireDefault(_SearchAsync);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Transfer_browser=(0,_reactLoadable2.default)({loader:function loader(){return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 812));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});Transfer_browser.List=_ListAsync2.default;Transfer_browser.Operation=_OperationAsync2.default;Transfer_browser.Search=_SearchAsync2.default;exports.default=Transfer_browser;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TransferList=(0,_reactLoadable2.default)({loader:function loader(){return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, 792));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=TransferList;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TransferOperation=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 794));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=TransferOperation;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Search=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 793));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});exports.default=Search;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(761);__webpack_require__(53);__webpack_require__(64);__webpack_require__(37);

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _class,_temp;// import RcTree from '../../_rc-tree-1.13.2/src';
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _openAnimation=__webpack_require__(137);var _openAnimation2=_interopRequireDefault(_openAnimation);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _TreeNode=__webpack_require__(252);var _TreeNode2=_interopRequireDefault(_TreeNode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RcTree=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 813));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var Tree=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Tree,_React$Component);function Tree(){(0,_classCallCheck3.default)(this,Tree);return(0,_possibleConstructorReturn3.default)(this,(Tree.__proto__||(0,_getPrototypeOf2.default)(Tree)).apply(this,arguments));}(0,_createClass3.default)(Tree,[{key:"render",// static TreeNode = RcTree.TreeNode;
value:function render(){var props=this.props;var checkable=props.checkable;if(checkable){checkable=_react2.default.createElement("span",{className:props.prefixCls+"-checkbox-inner"});}return _react2.default.createElement(RcTree,(0,_extends3.default)({},props,{checkable:checkable}),this.props.children);}}]);return Tree;}(_react2.default.Component),_class.TreeNode=_TreeNode2.default,_class.defaultProps={prefixCls:"ant-tree",checkable:false,showIcon:false// openAnimation: animation,
},_temp);exports.default=Tree;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp;// import RcTreeSelect, { TreeNode, SHOW_ALL, SHOW_PARENT, SHOW_CHILD } from 'rc-tree-select';
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _src=__webpack_require__(764);var _src2=_interopRequireDefault(_src);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TreeSelect=(_temp=_class=function(_React$Component){(0,_inherits3.default)(TreeSelect,_React$Component);function TreeSelect(){(0,_classCallCheck3.default)(this,TreeSelect);return(0,_possibleConstructorReturn3.default)(this,(TreeSelect.__proto__||(0,_getPrototypeOf2.default)(TreeSelect)).apply(this,arguments));}(0,_createClass3.default)(TreeSelect,[{key:"render",value:function render(){var _classNames;var props=this.props;var _props=this.props,size=_props.size,className=_props.className,combobox=_props.combobox,notFoundContent=_props.notFoundContent,prefixCls=_props.prefixCls;var cls=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls+"-lg",size==="large"),(0,_defineProperty3.default)(_classNames,prefixCls+"-sm",size==="small"),(0,_defineProperty3.default)(_classNames,className,!!className),_classNames));var antLocale=this.context.antLocale;if(antLocale&&antLocale.Select){notFoundContent=notFoundContent||antLocale.Select.notFoundContent;}if(combobox){notFoundContent=null;}var checkable=props.treeCheckable;if(checkable){checkable=_react2.default.createElement("span",{className:prefixCls+"-tree-checkbox-inner"});}return _react2.default.createElement(_src2.default,(0,_extends3.default)({},this.props,{treeCheckable:checkable,className:cls,notFoundContent:notFoundContent}));}}]);return TreeSelect;}(_react2.default.Component),_class.TreeNode=_src.TreeNode,_class.SHOW_ALL=_src.SHOW_ALL,_class.SHOW_PARENT=_src.SHOW_PARENT,_class.SHOW_CHILD=_src.SHOW_CHILD,_class.defaultProps={prefixCls:"ant-select",transitionName:"slide-up",choiceTransitionName:"zoom",showSearch:false,dropdownClassName:"ant-select-tree-dropdown"},_class.contextTypes={antLocale:_react2.default.PropTypes.object},_temp);exports.default=TreeSelect;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _TreeNode=__webpack_require__(278);var _TreeNode2=_interopRequireDefault(_TreeNode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// export this package's api
var TreeSelect=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 814));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return React.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});// import TreeSelect from './Select';
var SHOW_ALL="SHOW_ALL";var SHOW_PARENT="SHOW_PARENT";var SHOW_CHILD="SHOW_CHILD";TreeSelect.SHOW_ALL=SHOW_ALL;TreeSelect.SHOW_PARENT=SHOW_PARENT;TreeSelect.SHOW_CHILD=SHOW_CHILD;TreeSelect.TreeNode=_TreeNode2.default;exports.default=TreeSelect;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(766);__webpack_require__(92);__webpack_require__(53);

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(97),
    toInteger = __webpack_require__(768);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseIndexOf(array, value, index);
}

module.exports = indexOf;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(769);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(770);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29),
    isSymbol = __webpack_require__(79);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _class,_temp;//import RcTree from 'rc-tree';
// import RcTree from "../../_rc-tree-1.3.10/src";
// import RcTree from '../../_rc-tree-1.13.2/src';
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _treeZ=__webpack_require__(239);var _treeZ2=_interopRequireDefault(_treeZ);var _openAnimation=__webpack_require__(137);var _openAnimation2=_interopRequireDefault(_openAnimation);var _reactLoadable=__webpack_require__(12);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _TreeNode=__webpack_require__(279);var _TreeNode2=_interopRequireDefault(_TreeNode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RcTree=(0,_reactLoadable2.default)({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 815));},loading:function loading(){return null;},render:function render(obj,props,ref){if(obj){return _react2.default.createElement(obj&&obj.__esModule?obj.default:obj,(0,_extends3.default)({},props,{ref:ref}));}return null;}});var Tree=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Tree,_React$Component);function Tree(){(0,_classCallCheck3.default)(this,Tree);return(0,_possibleConstructorReturn3.default)(this,(Tree.__proto__||(0,_getPrototypeOf2.default)(Tree)).apply(this,arguments));}(0,_createClass3.default)(Tree,[{key:"render",// static TreeNode = RcTree.TreeNode;
value:function render(){var props=this.props;var checkable=props.checkable;if(checkable){checkable=_react2.default.createElement("span",{className:props.prefixCls+"-checkbox-inner"});}var treeInstance=void 0;if(props.ztreeMode){treeInstance=_react2.default.createElement(_treeZ2.default,(0,_extends3.default)({},props,{ecId:props.ecId+"_TreeZ@xhaqqt"}));}else{treeInstance=_react2.default.createElement(RcTree,(0,_extends3.default)({},props,{ecId:props.ecId+"_RcTree@pybwdr",checkable:checkable,ref:"rcTree"}),this.props.children);}return treeInstance;}}]);return Tree;}(_react2.default.Component),_class.TreeNode=_TreeNode2.default,_class.defaultProps={prefixCls:"ant-tree",checkable:false,showIcon:false,openAnimation:_openAnimation2.default},_temp);exports.default=Tree;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(773);__webpack_require__(53);

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _class,_temp;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _index=__webpack_require__(775);var _index2=_interopRequireDefault(_index);var _uploadList=__webpack_require__(780);var _uploadList2=_interopRequireDefault(_uploadList);var _getFileItem=__webpack_require__(781);var _getFileItem2=_interopRequireDefault(_getFileItem);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var prefixCls='ant-upload';function noop(){}function T(){return true;}// Fix IE file.status problem
// via coping a new Object
function fileToObject(file){return{lastModified:file.lastModified,lastModifiedDate:file.lastModifiedDate,name:file.filename||file.name,size:file.size,type:file.type,uid:file.uid,response:file.response,error:file.error,percent:0,originFileObj:file};}/**
 * 生成Progress percent: 0.1 -> 0.98
 *   - for ie
 */function genPercentAdd(){var k=0.1;var i=0.01;var end=0.98;return function(s){var start=s;if(start>=end){return start;}start+=k;k=k-i;if(k<0.001){k=0.001;}return start*100;};}function UploadDragger(props){return _react2.default.createElement(Upload,(0,_extends3.default)({},props,{type:'drag',style:{height:props.height}}));}var Upload=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Upload,_React$Component);function Upload(props){(0,_classCallCheck3.default)(this,Upload);var _this=(0,_possibleConstructorReturn3.default)(this,(Upload.__proto__||(0,_getPrototypeOf2.default)(Upload)).call(this,props));_this.onStart=function(file){var targetItem=void 0;var nextFileList=_this.state.fileList.concat();if(file.length>0){targetItem=file.map(function(f){var fileObject=fileToObject(f);fileObject.status='uploading';return fileObject;});nextFileList=nextFileList.concat(targetItem);}else{targetItem=fileToObject(file);targetItem.status='uploading';nextFileList.push(targetItem);}_this.onChange({file:targetItem,fileList:nextFileList});// fix ie progress
if(!window.FormData){_this.autoUpdateProgress(0,targetItem);}};_this.onSuccess=function(response,file){_this.clearProgressTimer();try{if(typeof response==='string'){response=JSON.parse(response);}}catch(e){/* do nothing */}var fileList=_this.state.fileList;var targetItem=(0,_getFileItem2.default)(file,fileList);// removed
if(!targetItem){return;}targetItem.status='done';targetItem.response=response;_this.onChange({file:targetItem,fileList:fileList});};_this.onProgress=function(e,file){var fileList=_this.state.fileList;var targetItem=(0,_getFileItem2.default)(file,fileList);// removed
if(!targetItem){return;}targetItem.percent=e.percent;_this.onChange({event:e,file:targetItem,fileList:_this.state.fileList});};_this.onError=function(error,response,file){_this.clearProgressTimer();var fileList=_this.state.fileList;var targetItem=(0,_getFileItem2.default)(file,fileList);// removed
if(!targetItem){return;}targetItem.error=error;targetItem.response=response;targetItem.status='error';_this.handleRemove(targetItem);};_this.handleManualRemove=function(file){_this.refs.upload.abort(file);/*eslint-disable */file.status='removed';/*eslint-enable */if('onRemove'in _this.props){_this.props.onRemove(file);}else{_this.handleRemove(file);}};_this.onChange=function(info){if(!('fileList'in _this.props)){_this.setState({fileList:info.fileList});}_this.props.onChange(info);};_this.onFileDrop=function(e){_this.setState({dragState:e.type});};_this.state={fileList:_this.props.fileList||_this.props.defaultFileList||[],dragState:'drop'};return _this;}(0,_createClass3.default)(Upload,[{key:'autoUpdateProgress',value:function autoUpdateProgress(percent,file){var _this2=this;var getPercent=genPercentAdd();var curPercent=0;this.progressTimer=setInterval(function(){curPercent=getPercent(curPercent);_this2.onProgress({percent:curPercent},file);},200);}},{key:'removeFile',value:function removeFile(file){var fileList=this.state.fileList;var targetItem=(0,_getFileItem2.default)(file,fileList);var index=fileList.indexOf(targetItem);if(index!==-1){fileList.splice(index,1);return fileList;}return null;}},{key:'handleRemove',value:function handleRemove(file){var fileList=this.removeFile(file);if(fileList){this.onChange({file:file,fileList:fileList});}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if('fileList'in nextProps){this.setState({fileList:nextProps.fileList||[]});}}},{key:'clearProgressTimer',value:function clearProgressTimer(){clearInterval(this.progressTimer);}},{key:'render',value:function render(){var _classNames2;var type=this.props.type||'select';var props=(0,_extends3.default)({},this.props,{onStart:this.onStart,onError:this.onError,onProgress:this.onProgress,onSuccess:this.onSuccess,beforeUpload:this.props.beforeUpload});var uploadList=void 0;if(this.props.showUploadList){uploadList=_react2.default.createElement(_uploadList2.default,{listType:this.props.listType,items:this.state.fileList,onPreview:props.onPreview,onRemove:this.handleManualRemove});}if(type==='drag'){var _classNames;var dragCls=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls,true),(0,_defineProperty3.default)(_classNames,prefixCls+'-drag',true),(0,_defineProperty3.default)(_classNames,prefixCls+'-drag-uploading',this.state.fileList.some(function(file){return file.status==='uploading';})),(0,_defineProperty3.default)(_classNames,prefixCls+'-drag-hover',this.state.dragState==='dragover'),(0,_defineProperty3.default)(_classNames,prefixCls+'-disabled',this.props.disabled),_classNames));return _react2.default.createElement('span',{className:this.props.className},_react2.default.createElement('div',{className:dragCls,onDrop:this.onFileDrop,onDragOver:this.onFileDrop,onDragLeave:this.onFileDrop},_react2.default.createElement(_index2.default,(0,_extends3.default)({},props,{ref:'upload'}),_react2.default.createElement('div',{className:prefixCls+'-drag-container'},this.props.children))),uploadList);}var uploadButtonCls=(0,_classnames2.default)((_classNames2={},(0,_defineProperty3.default)(_classNames2,prefixCls,true),(0,_defineProperty3.default)(_classNames2,prefixCls+'-select',true),(0,_defineProperty3.default)(_classNames2,prefixCls+'-select-'+this.props.listType,true),(0,_defineProperty3.default)(_classNames2,prefixCls+'-disabled',this.props.disabled),_classNames2));var uploadButton=this.props.children?_react2.default.createElement('div',{className:uploadButtonCls},_react2.default.createElement(_index2.default,(0,_extends3.default)({},props,{ref:'upload'}))):null;//zxt - 20100510 新增其他按钮位置
var otherButtons=this.props.btns||null;//zxt - 20100510 新增其他按钮位置
if(this.props.listType==='picture-card'){return _react2.default.createElement('span',{className:this.props.className},uploadList,uploadButton);}return _react2.default.createElement('span',{className:this.props.className},uploadButton,otherButtons,uploadList);}}]);return Upload;}(_react2.default.Component),_class.Dragger=UploadDragger,_class.defaultProps={type:'select',// do not set
// name: '',
multiple:false,action:'',data:{},accept:'',onChange:noop,beforeUpload:T,showUploadList:true,listType:'text',// or pictrue
className:'',disabled:false},_temp);exports.default=Upload;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// export this package's api
module.exports=__webpack_require__(776);

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _AjaxUploader=__webpack_require__(777);var _AjaxUploader2=_interopRequireDefault(_AjaxUploader);var _IframeUploader=__webpack_require__(779);var _IframeUploader2=_interopRequireDefault(_IframeUploader);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function empty(){}var Upload=_react2.default.createClass({displayName:'Upload',propTypes:{component:_react.PropTypes.string,style:_react.PropTypes.object,prefixCls:_react.PropTypes.string,action:_react.PropTypes.string,name:_react.PropTypes.string,multipart:_react.PropTypes.bool,onError:_react.PropTypes.func,onSuccess:_react.PropTypes.func,onProgress:_react.PropTypes.func,onStart:_react.PropTypes.func,data:_react.PropTypes.oneOfType([_react.PropTypes.object,_react.PropTypes.func]),headers:_react.PropTypes.object,accept:_react.PropTypes.string,multiple:_react.PropTypes.bool,disabled:_react.PropTypes.bool,beforeUpload:_react.PropTypes.func,customRequest:_react.PropTypes.func,onReady:_react.PropTypes.func,withCredentials:_react.PropTypes.bool,supportServerRender:_react.PropTypes.bool},getDefaultProps:function getDefaultProps(){return{component:'span',prefixCls:'rc-upload',data:{},headers:{},name:'file',multipart:false,onProgress:empty,onReady:empty,onStart:empty,onError:empty,onSuccess:empty,supportServerRender:false,multiple:false,beforeUpload:null,customRequest:null,withCredentials:false};},getInitialState:function getInitialState(){return{Component:null};},componentDidMount:function componentDidMount(){if(this.props.supportServerRender){/* eslint react/no-did-mount-set-state:0 */this.setState({Component:this.getComponent()},this.props.onReady);}},getComponent:function getComponent(){return typeof FormData!=='undefined'?_AjaxUploader2.default:_IframeUploader2.default;},abort:function abort(file){this.refs.inner.abort(file);},render:function render(){if(this.props.supportServerRender){var _Component=this.state.Component;if(_Component){return _react2.default.createElement(_Component,(0,_extends3.default)({},this.props,{ref:'inner'}));}return null;}var Component=this.getComponent();return _react2.default.createElement(Component,(0,_extends3.default)({},this.props,{ref:'inner'}));}});exports.default=Upload;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _request=__webpack_require__(778);var _request2=_interopRequireDefault(_request);var _uid=__webpack_require__(240);var _uid2=_interopRequireDefault(_uid);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint react/no-is-mounted:0*/var AjaxUploader=_react2.default.createClass({displayName:'AjaxUploader',propTypes:{component:_react.PropTypes.string,style:_react.PropTypes.object,prefixCls:_react.PropTypes.string,className:_react.PropTypes.string,multiple:_react.PropTypes.bool,disabled:_react.PropTypes.bool,accept:_react.PropTypes.string,children:_react.PropTypes.any,onStart:_react.PropTypes.func,data:_react.PropTypes.oneOfType([_react.PropTypes.object,_react.PropTypes.func]),headers:_react.PropTypes.object,beforeUpload:_react.PropTypes.func,customRequest:_react.PropTypes.func,withCredentials:_react.PropTypes.bool},getInitialState:function getInitialState(){this.reqs={};return{uid:(0,_uid2.default)()};},componentWillUnmount:function componentWillUnmount(){this.abort();},onChange:function onChange(e){var files=e.target.files;this.uploadFiles(files);this.reset();},onClick:function onClick(){var el=this.refs.file;if(!el){return;}el.click();},onKeyDown:function onKeyDown(e){if(e.key==='Enter'){this.onClick();}},onFileDrop:function onFileDrop(e){if(e.type==='dragover'){e.preventDefault();return;}var files=e.dataTransfer.files;this.uploadFiles(files);e.preventDefault();},uploadFiles:function uploadFiles(files){var postFiles=Array.prototype.slice.call(files);var len=postFiles.length;for(var i=0;i<len;i++){var file=postFiles[i];file.uid=(0,_uid2.default)();this.upload(file);}},upload:function upload(file){var _this=this;var props=this.props;if(!props.beforeUpload){// always async in case use react state to keep fileList
return setTimeout(function(){return _this.post(file);},0);}var before=props.beforeUpload(file);if(before&&before.then){before.then(function(processedFile){var processedFileType=Object.prototype.toString.call(processedFile);if(processedFileType==='[object File]'||processedFileType==='[object Blob]'){_this.post(processedFile);}else{_this.post(file);}});}else if(before!==false){setTimeout(function(){return _this.post(file);},0);}},post:function post(file){var _this2=this;if(!this.isMounted()){return;}var props=this.props;var data=props.data;var onStart=props.onStart;if(typeof data==='function'){data=data(file);}var uid=file.uid;var request=props.customRequest||_request2.default;this.reqs[uid]=request({action:props.action,filename:props.name,file:file,data:data,headers:props.headers,withCredentials:props.withCredentials,onProgress:function onProgress(e){props.onProgress(e,file);},onSuccess:function onSuccess(ret){delete _this2.reqs[uid];props.onSuccess(ret,file);},onError:function onError(err,ret){delete _this2.reqs[uid];props.onError(err,ret,file);}});onStart(file);},reset:function reset(){this.setState({uid:(0,_uid2.default)()});},abort:function abort(file){var reqs=this.reqs;if(file){var uid=file;if(file&&file.uid){uid=file.uid;}if(reqs[uid]){reqs[uid].abort();delete reqs[uid];}}else{(0,_keys2.default)(reqs).forEach(function(uid){reqs[uid].abort();delete reqs[uid];});}},render:function render(){var _classNames;var _props=this.props,Tag=_props.component,prefixCls=_props.prefixCls,className=_props.className,disabled=_props.disabled,style=_props.style,multiple=_props.multiple,accept=_props.accept,children=_props.children;var cls=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls,true),(0,_defineProperty3.default)(_classNames,prefixCls+'-disabled',disabled),(0,_defineProperty3.default)(_classNames,className,className),_classNames));var events=disabled?{}:{onClick:this.onClick,onKeyDown:this.onKeyDown,onDrop:this.onFileDrop,onDragOver:this.onFileDrop,tabIndex:'0'};return _react2.default.createElement(Tag,(0,_extends3.default)({},events,{className:cls,role:'button',style:style}),_react2.default.createElement('input',{type:'file',ref:'file',key:this.state.uid,style:{display:'none'},accept:accept,multiple:multiple,onChange:this.onChange}),children);}});exports.default=AjaxUploader;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys=__webpack_require__(22);var _keys2=_interopRequireDefault(_keys);exports.default=upload;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function getError(option,xhr){var msg='cannot post '+option.action+' '+xhr.status+'\'';var err=new Error(msg);err.status=xhr.status;err.method='post';err.url=option.action;return err;}function getBody(xhr){var text=xhr.responseText||xhr.response;if(!text){return text;}try{return JSON.parse(text);}catch(e){return text;}}// option {
//  onProgress: (event: { percent: number }): void,
//  onError: (event: Error, body?: Object): void,
//  onSuccess: (body: Object): void,
//  data: Object,
//  filename: String,
//  file: File,
//  withCredentials: Boolean,
//  action: String,
//  headers: Object,
// }
function upload(option){var xhr=new XMLHttpRequest();if(xhr.upload){xhr.upload.onprogress=function progress(e){if(e.total>0){e.percent=e.loaded/e.total*100;}option.onProgress(e);};}var formData=new FormData();if(option.data){(0,_keys2.default)(option.data).map(function(key){formData.append(key,option.data[key]);});}formData.append(option.filename,option.file);xhr.onerror=function error(e){option.onError(e);};xhr.onload=function onload(){// allow success when 2xx status
// see https://github.com/react-component/upload/issues/34
if(xhr.status<200||xhr.status>=300){return option.onError(getError(option,xhr),getBody(xhr));}option.onSuccess(getBody(xhr));};xhr.open('post',option.action,true);// Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
if(option.withCredentials&&'withCredentials'in xhr){xhr.withCredentials=true;}var headers=option.headers||{};// when set headers['X-Requested-With'] = null , can close default XHR header
// see https://github.com/react-component/upload/issues/33
if(headers['X-Requested-With']!==null){xhr.setRequestHeader('X-Requested-With','XMLHttpRequest');}for(var h in headers){if(headers.hasOwnProperty(h)&&headers[h]!==null){xhr.setRequestHeader(h,headers[h]);}}xhr.send(formData);return{abort:function abort(){xhr.abort();}};}

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(10);var _reactDom2=_interopRequireDefault(_reactDom);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);var _uid=__webpack_require__(240);var _uid2=_interopRequireDefault(_uid);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IFRAME_STYLE={position:'absolute',top:0,opacity:0,filter:'alpha(opacity=0)',left:0,zIndex:9999};// diferent from AjaxUpload, can only upload on at one time, serial seriously
var IframeUploader=_react2.default.createClass({displayName:'IframeUploader',propTypes:{component:_react.PropTypes.string,style:_react.PropTypes.object,disabled:_react.PropTypes.bool,prefixCls:_react.PropTypes.string,className:_react.PropTypes.string,accept:_react.PropTypes.string,onStart:_react.PropTypes.func,multiple:_react.PropTypes.bool,children:_react.PropTypes.any,data:_react.PropTypes.oneOfType([_react.PropTypes.object,_react.PropTypes.func]),action:_react.PropTypes.string,name:_react.PropTypes.string},getInitialState:function getInitialState(){this.file={};return{uploading:false};},componentDidMount:function componentDidMount(){this.updateIframeWH();this.initIframe();},componentDidUpdate:function componentDidUpdate(){this.updateIframeWH();},onLoad:function onLoad(){if(!this.state.uploading){return;}var props=this.props,file=this.file;var response=void 0;try{var doc=this.getIframeDocument();var script=doc.getElementsByTagName('script')[0];if(script&&script.parentNode===doc.body){doc.body.removeChild(script);}response=doc.body.innerHTML;props.onSuccess(response,file);}catch(err){(0,_warning2.default)(false,'cross domain error for Upload. Maybe server should return document.domain script. see Note from https://github.com/react-component/upload');response='cross-domain';props.onError(err,null,file);}this.endUpload();},onChange:function onChange(){var _this=this;var target=this.getFormInputNode();// ie8/9 don't support FileList Object
// http://stackoverflow.com/questions/12830058/ie8-input-type-file-get-files
var file=this.file={uid:(0,_uid2.default)(),name:target.value};this.startUpload();var props=this.props;if(!props.beforeUpload){return this.post(file);}var before=props.beforeUpload(file);if(before&&before.then){before.then(function(){_this.post(file);},function(){_this.endUpload();});}else if(before!==false){this.post(file);}else{this.endUpload();}},getIframeNode:function getIframeNode(){return this.refs.iframe;},getIframeDocument:function getIframeDocument(){return this.getIframeNode().contentDocument;},getFormNode:function getFormNode(){return this.getIframeDocument().getElementById('form');},getFormInputNode:function getFormInputNode(){return this.getIframeDocument().getElementById('input');},getFormDataNode:function getFormDataNode(){return this.getIframeDocument().getElementById('data');},getFileForMultiple:function getFileForMultiple(file){return this.props.multiple?[file]:file;},getIframeHTML:function getIframeHTML(domain){var domainScript='';var domainInput='';if(domain){domainScript='<script>document.domain="'+domain+'";</script>';domainInput='<input name="_documentDomain" value="'+domain+'" />';}return'\n    <!DOCTYPE html>\n    <html>\n    <head>\n    <meta http-equiv="X-UA-Compatible" content="IE=edge" />\n    <style>\n    body,html {padding:0;margin:0;border:0;overflow:hidden;}\n    </style>\n    '+domainScript+'\n    </head>\n    <body>\n    <form method="post"\n    encType="multipart/form-data"\n    action="'+this.props.action+'" id="form"\n    style="display:block;height:9999px;position:relative;overflow:hidden;">\n    <input id="input" type="file"\n     name="'+this.props.name+'"\n     style="position:absolute;top:0;right:0;height:9999px;font-size:9999px;cursor:pointer;"/>\n    '+domainInput+'\n    <span id="data"></span>\n    </form>\n    </body>\n    </html>\n    ';},initIframeSrc:function initIframeSrc(){if(this.domain){this.getIframeNode().src='javascript:void((function(){\n        var d = document;\n        d.open();\n        d.domain=\''+this.domain+'\';\n        d.write(\'\');\n        d.close();\n      })())';}},initIframe:function initIframe(){var iframeNode=this.getIframeNode();var win=iframeNode.contentWindow;var doc=void 0;this.domain=this.domain||'';this.initIframeSrc();try{doc=win.document;}catch(e){this.domain=document.domain;this.initIframeSrc();win=iframeNode.contentWindow;doc=win.document;}doc.open('text/html','replace');doc.write(this.getIframeHTML(this.domain));doc.close();this.getFormInputNode().onchange=this.onChange;},endUpload:function endUpload(){if(this.state.uploading){this.file={};// hack avoid batch
this.state.uploading=false;this.setState({uploading:false});this.initIframe();}},startUpload:function startUpload(){if(!this.state.uploading){this.state.uploading=true;this.setState({uploading:true});}},updateIframeWH:function updateIframeWH(){var rootNode=_reactDom2.default.findDOMNode(this);var iframeNode=this.getIframeNode();iframeNode.style.height=rootNode.offsetHeight+'px';iframeNode.style.width=rootNode.offsetWidth+'px';},abort:function abort(file){if(file){var uid=file;if(file&&file.uid){uid=file.uid;}if(uid===this.file.uid){this.endUpload();}}else{this.endUpload();}},post:function post(file){var formNode=this.getFormNode();var dataSpan=this.getFormDataNode();var data=this.props.data;var onStart=this.props.onStart;if(typeof data==='function'){data=data(file);}var inputs=[];for(var key in data){if(data.hasOwnProperty(key)){inputs.push('<input name=\''+key+'\' value=\''+data[key]+'\'/>');}}dataSpan.innerHTML=inputs.join('');formNode.submit();dataSpan.innerHTML='';onStart(file);},render:function render(){var _classNames;var _props=this.props,Tag=_props.component,disabled=_props.disabled,className=_props.className,prefixCls=_props.prefixCls,children=_props.children,style=_props.style;var iframeStyle=(0,_extends3.default)({},IFRAME_STYLE,{display:this.state.uploading||disabled?'none':''});var cls=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls,true),(0,_defineProperty3.default)(_classNames,prefixCls+'-disabled',disabled),(0,_defineProperty3.default)(_classNames,className,className),_classNames));return _react2.default.createElement(Tag,{className:cls,style:(0,_extends3.default)({position:'relative',zIndex:0},style)},_react2.default.createElement('iframe',{ref:'iframe',onLoad:this.onLoad,style:iframeStyle}),children);}});exports.default=IframeUploader;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _defineProperty2=__webpack_require__(8);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(1);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp2;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _rcAnimate=__webpack_require__(18);var _rcAnimate2=_interopRequireDefault(_rcAnimate);var _icon=__webpack_require__(16);var _icon2=_interopRequireDefault(_icon);var _progress=__webpack_require__(230);var _progress2=_interopRequireDefault(_progress);var _classnames=__webpack_require__(7);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var prefixCls='ant-upload';// https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
var previewFile=function previewFile(file,callback){var reader=new FileReader();reader.onloadend=function(){return callback(reader.result);};reader.readAsDataURL(file);};var UploadList=(_temp2=_class=function(_React$Component){(0,_inherits3.default)(UploadList,_React$Component);function UploadList(){var _ref;var _temp,_this,_ret;(0,_classCallCheck3.default)(this,UploadList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=(0,_possibleConstructorReturn3.default)(this,(_ref=UploadList.__proto__||(0,_getPrototypeOf2.default)(UploadList)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(file){_this.props.onRemove(file);},_this.handlePreview=function(file,e){if(_this.props.onPreview){e.preventDefault();return _this.props.onPreview(file);}},_temp),(0,_possibleConstructorReturn3.default)(_this,_ret);}(0,_createClass3.default)(UploadList,[{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;if(this.props.listType!=='picture'&&this.props.listType!=='picture-card'){return;}this.props.items.forEach(function(file){if(typeof document==='undefined'||typeof window==='undefined'||!window.FileReader||!window.File||!(file.originFileObj instanceof File)||file.thumbUrl!==undefined){return;}/*eslint-disable */file.thumbUrl='';/*eslint-enable */previewFile(file.originFileObj,function(previewDataUrl){/*eslint-disable */file.thumbUrl=previewDataUrl;/*eslint-enable */_this2.forceUpdate();});});}},{key:'render',value:function render(){var _this3=this,_classNames2;var list=this.props.items.map(function(file){var _classNames;var progress=void 0;var icon=_react2.default.createElement(_icon2.default,{type:'paper-clip'});if(_this3.props.listType==='picture'||_this3.props.listType==='picture-card'){if(file.status==='uploading'||!file.thumbUrl&&!file.url){if(_this3.props.listType==='picture-card'){icon=_react2.default.createElement('div',{className:prefixCls+'-list-item-uploading-text'},'\u6587\u4EF6\u4E0A\u4F20\u4E2D');}else{icon=_react2.default.createElement(_icon2.default,{className:prefixCls+'-list-item-thumbnail',type:'picture'});}}else{icon=_react2.default.createElement('a',{className:prefixCls+'-list-item-thumbnail',onClick:function onClick(e){return _this3.handlePreview(file,e);},href:file.url,target:'_blank'},_react2.default.createElement('img',{src:file.thumbUrl||file.url,alt:file.name}));}}if(file.status==='uploading'){progress=_react2.default.createElement('div',{className:prefixCls+'-list-item-progress'},_react2.default.createElement(_progress2.default,(0,_extends3.default)({type:'line'},_this3.props.progressAttr,{percent:file.percent})));}var infoUploadingClass=(0,_classnames2.default)((_classNames={},(0,_defineProperty3.default)(_classNames,prefixCls+'-list-item',true),(0,_defineProperty3.default)(_classNames,prefixCls+'-list-item-'+file.status,true),_classNames));return _react2.default.createElement('div',{className:infoUploadingClass,key:file.uid},_react2.default.createElement('div',{className:prefixCls+'-list-item-info'},icon,file.url?_react2.default.createElement('a',{href:file.url,target:'_blank',className:prefixCls+'-list-item-name',onClick:function onClick(e){return _this3.handlePreview(file,e);}},file.name):_react2.default.createElement('span',{className:prefixCls+'-list-item-name',onClick:function onClick(e){return _this3.handlePreview(file,e);}},file.name),_this3.props.listType==='picture-card'&&file.status!=='uploading'?_react2.default.createElement('span',null,_react2.default.createElement('a',{href:file.url,target:'_blank',style:{pointerEvents:file.url?'':'none'},onClick:function onClick(e){return _this3.handlePreview(file,e);}},_react2.default.createElement(_icon2.default,{type:'eye-o'})),_react2.default.createElement(_icon2.default,{type:'delete',onClick:function onClick(){return _this3.handleClose(file);}})):_react2.default.createElement(_icon2.default,{type:'cross',onClick:function onClick(){return _this3.handleClose(file);}})),progress);});var listClassNames=(0,_classnames2.default)((_classNames2={},(0,_defineProperty3.default)(_classNames2,prefixCls+'-list',true),(0,_defineProperty3.default)(_classNames2,prefixCls+'-list-'+this.props.listType,true),_classNames2));return _react2.default.createElement('div',{className:listClassNames},_react2.default.createElement(_rcAnimate2.default,{transitionName:prefixCls+'-margin-top'},list));}}]);return UploadList;}(_react2.default.Component),_class.defaultProps={listType:'text',// or picture
items:[],progressAttr:{strokeWidth:3,showInfo:false}},_temp2);exports.default=UploadList;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=getFileItem;function getFileItem(file,fileList){var matchWay=!file.uid?'byName':'byUid';var target=fileList.filter(function(item){if(matchWay==='byName'){return item.name===file.name;}return item.uid===file.uid;})[0];return target;}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(9);__webpack_require__(783);__webpack_require__(231);

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _getPrototypeOf=__webpack_require__(5);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(2);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(6);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(3);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(4);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _warning=__webpack_require__(17);var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Validation=function(_React$Component){(0,_inherits3.default)(Validation,_React$Component);function Validation(){(0,_classCallCheck3.default)(this,Validation);return(0,_possibleConstructorReturn3.default)(this,(Validation.__proto__||(0,_getPrototypeOf2.default)(Validation)).apply(this,arguments));}(0,_createClass3.default)(Validation,[{key:'componentDidMount',value:function componentDidMount(){(0,_warning2.default)(false,'`Validation` is removed, please use `Form` which has supported validation after antd@0.12.0,'+' or you can just import Validation from \'rc-form-validation\' for compatibility');}},{key:'render',value:function render(){return null;}}]);return Validation;}(_react2.default.Component);exports.default=Validation;Validation.Validator=function(){};Validation.FieldMixin={setField:function setField(){}};

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_811__;

/***/ }),
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.min.js